import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Upload: any;
};

export type AcceptUserInviteInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  inviteToken: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type ActiveSessionConflict = {
  __typename?: 'ActiveSessionConflict';
  message: Scalars['String'];
};

export type Activity = {
  __typename?: 'Activity';
  body?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  contact: Contact;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUser?: Maybe<User>;
  id: Scalars['ID'];
  job?: Maybe<Job>;
  occurredAt: Scalars['DateTime'];
  opportunity?: Maybe<Opportunity>;
  opportunityId?: Maybe<Scalars['ID']>;
  organization?: Maybe<Organization>;
  proposal?: Maybe<Proposal>;
  summary: Scalars['String'];
  type: ActivityType | `${ActivityType}`;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** A paginated list of Activity items. */
export type ActivityPaginator = {
  __typename?: 'ActivityPaginator';
  /** A list of Activity items. */
  data: Array<Activity>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ActivityType {
  /** Call */
  CALL = 'CALL',
  /** Email */
  EMAIL = 'EMAIL',
  /** Meeting */
  MEETING = 'MEETING',
  /** Note */
  NOTE = 'NOTE',
  /** Text */
  TEXT = 'TEXT'
}

export type AddJobPhaseCostsInput = {
  additionalCosts?: InputMaybe<Array<AddJobPhaseCostsInputAdditionalCosts>>;
  date: Scalars['Date'];
  employees?: InputMaybe<Array<AddJobPhaseCostsInputEmployees>>;
  equipmentPieces?: InputMaybe<Array<AddJobPhaseCostsInputEquipmentPieces>>;
  jobPhaseId: Scalars['ID'];
  materialNeeded?: InputMaybe<Scalars['Float']>;
  materialsNoPlants?: InputMaybe<Array<AddJobPhaseCostsInputMaterialsNoPlants>>;
  plants?: InputMaybe<Array<AddJobPhaseCostsInputPlants>>;
  transferTrucks?: InputMaybe<Array<AddJobPhaseCostsInputTransferTrucks>>;
};

export type AddJobPhaseCostsInputAdditionalCosts = {
  feeAmount: Scalars['Float'];
  id: Scalars['ID'];
  isSubcontractorCost?: InputMaybe<Scalars['Boolean']>;
};

export type AddJobPhaseCostsInputEmployees = {
  id: Scalars['ID'];
  timeOnjob: Scalars['Float'];
  timeTravel: Scalars['Float'];
};

export type AddJobPhaseCostsInputEquipmentPieces = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  timeOnjob: Scalars['Float'];
  timeTravel: Scalars['Float'];
};

export type AddJobPhaseCostsInputMaterialsNoPlants = {
  name: Scalars['String'];
  quantity: Scalars['Float'];
  rate: Scalars['String'];
};

export type AddJobPhaseCostsInputPlants = {
  plantId: Scalars['ID'];
  plantProductId: Scalars['ID'];
  quantity: Scalars['Float'];
  rate: Scalars['String'];
};

export type AddJobPhaseCostsInputTransferTrucks = {
  hours: Scalars['Float'];
  id: Scalars['ID'];
};

export type AddJobPhaseScheduleBlock = {
  blockLength: Scalars['Float'];
  scheduledAt: Scalars['DateTime'];
  showTravelFrom: Scalars['Boolean'];
  showTravelTo: Scalars['Boolean'];
};

export type AddMaterialNoPlantToProposalProductInput = {
  name: Scalars['String'];
  percentage: Scalars['Float'];
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Int'];
  quantityOverride?: InputMaybe<Scalars['Int']>;
  rate: Scalars['Int'];
};

export type AddOrganizationDataUploadInput = {
  path: Scalars['String'];
  type: OrganizationDataUploadType | `${OrganizationDataUploadType}`;
};

export type AddPlantProductToProposalProductInput = {
  applicationRate?: InputMaybe<Scalars['Float']>;
  materialNeededOverride?: InputMaybe<Scalars['Float']>;
  plantId: Scalars['ID'];
  plantProductId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  rateOverride?: InputMaybe<Scalars['Int']>;
};

export type AddProductsToProposalStageInput = {
  products: Array<AddProposalProductInput>;
  proposalStageId: Scalars['ID'];
};

export type AddProposalAddressInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  proposalStageId: Scalars['ID'];
};

export type AddProposalEquipmentPieceInput = {
  id: Scalars['ID'];
  quantity: Scalars['Float'];
};

export type AddProposalProductInput = {
  dailyUnitsComplete?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  jobDuration?: InputMaybe<Scalars['Float']>;
  jobSize: Scalars['Int'];
  mapData?: InputMaybe<Scalars['String']>;
};

export type AddProposalStageChecklistItemsInput = {
  checklistItems: SyncProposalStageChecklistItemHasMany;
  checklistNotes?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type AddTruckToProposalProductInput = {
  costOverride?: InputMaybe<Scalars['Float']>;
  proposalPlantProductId?: InputMaybe<Scalars['ID']>;
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Float'];
  quantityOverride?: InputMaybe<Scalars['Float']>;
  rate?: InputMaybe<Scalars['Float']>;
  totalHaulingHoursOverride?: InputMaybe<Scalars['Float']>;
  transferTruckId: Scalars['ID'];
  truckingProductionRate: Scalars['Float'];
};

export type AdditionalCost = {
  __typename?: 'AdditionalCost';
  cost: Scalars['Int'];
  feeAmount: Scalars['Float'];
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** @deprecated No longer supported */
  pivot?: Maybe<ProductAdditionalCostPivot>;
};

export enum AdditionalCostFeeType {
  /** Flat */
  FLAT = 'FLAT',
  /** Job cost */
  JOB_COST = 'JOB_COST',
  /** Job length */
  JOB_LENGTH = 'JOB_LENGTH',
  /** Job size */
  JOB_SIZE = 'JOB_SIZE',
  /** Materials */
  MATERIALS = 'MATERIALS'
}

export type AdditionalCostItem = {
  __typename?: 'AdditionalCostItem';
  additional_cost_amount?: Maybe<Scalars['Float']>;
  additional_cost_id?: Maybe<Scalars['ID']>;
  additional_cost_name?: Maybe<Scalars['String']>;
  additional_cost_quantity?: Maybe<Scalars['Float']>;
  job_id: Scalars['ID'];
};

/** A paginated list of AdditionalCost items. */
export type AdditionalCostPaginator = {
  __typename?: 'AdditionalCostPaginator';
  /** A list of AdditionalCost items. */
  data: Array<AdditionalCost>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type AiMappingAdditionalCostItemInput = {
  additionalCostId: Scalars['ID'];
  categories?: InputMaybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  kind?: InputMaybe<AiMappingCostItemKind | `${AiMappingCostItemKind}`>;
  proposalProductId: Scalars['ID'];
};

export type AiMappingCategoryCount = {
  __typename?: 'AiMappingCategoryCount';
  category: Scalars['String'];
  count: Scalars['Int'];
};

export type AiMappingCostItemInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<AiMappingCostItemKind | `${AiMappingCostItemKind}`>;
  linearFeetPerUnit?: InputMaybe<Scalars['Float']>;
  productId: Scalars['ID'];
  valueKind?: InputMaybe<AiMappingCostValueKind | `${AiMappingCostValueKind}`>;
};

export enum AiMappingCostItemKind {
  DETECTION_COUNT = 'DETECTION_COUNT',
  MEASURED_AREA = 'MEASURED_AREA'
}

export enum AiMappingCostValueKind {
  COUNT = 'COUNT',
  LINEAR_FEET = 'LINEAR_FEET'
}

export type AiMappingDetectResponse = {
  __typename?: 'AiMappingDetectResponse';
  area: AiMappingRunArea;
  taskId: Scalars['String'];
};

export type AiMappingDetection = {
  __typename?: 'AiMappingDetection';
  bbox: Array<Scalars['Float']>;
  category: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  confidence?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  source?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};

export enum AiMappingInputType {
  BBOX = 'BBOX',
  POLYGON = 'POLYGON'
}

export type AiMappingRun = {
  __typename?: 'AiMappingRun';
  areas: Array<AiMappingRunArea>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  projectMap: ProjectMap;
  updatedAt: Scalars['DateTime'];
};

export type AiMappingRunArea = {
  __typename?: 'AiMappingRunArea';
  /** JSON-encoded array of [latitude, longitude] pairs. */
  coordinates?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentVersion: Scalars['Int'];
  id: Scalars['ID'];
  imageHeight?: Maybe<Scalars['Int']>;
  imageWidth?: Maybe<Scalars['Int']>;
  inputType: AiMappingInputType | `${AiMappingInputType}`;
  minSegAreaSqft?: Maybe<Scalars['Float']>;
  minSegConf?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  segmentationModel?: Maybe<Scalars['String']>;
  /** Processing status reported by the external service */
  status: Scalars['String'];
  taskId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type AiMappingRunAreaResultsResponse = {
  __typename?: 'AiMappingRunAreaResultsResponse';
  area: AiMappingRunArea;
  detections: Array<AiMappingDetection>;
  segmentations: Array<AiMappingSegmentation>;
};

export type AiMappingSegmentation = {
  __typename?: 'AiMappingSegmentation';
  areaSqft?: Maybe<Scalars['Float']>;
  category: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  polygon: Array<Scalars['Float']>;
  version: Scalars['Int'];
};

export enum AiMappingSegmentationModel {
  BOTH = 'BOTH',
  MODEL1 = 'MODEL1',
  MODEL2 = 'MODEL2',
  MODEL3 = 'MODEL3'
}

export type AiMappingTaskStatus = {
  __typename?: 'AiMappingTaskStatus';
  counts?: Maybe<Array<AiMappingCategoryCount>>;
  error?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Int']>;
  progressMessage?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type AppLoginResult = ActiveSessionConflict | LoginAppUser;

export type ApplyAiMappingAdditionalCostsInput = {
  areaId: Scalars['ID'];
  items: Array<AiMappingAdditionalCostItemInput>;
  proposalId: Scalars['ID'];
};

export type ApplyProposalStageMeasurementsInput = {
  proposalStageId: Scalars['ID'];
};

export type ApplyProposalStageMeasurementsPayload = {
  __typename?: 'ApplyProposalStageMeasurementsPayload';
  proposal: Proposal;
  warnings: Array<Scalars['String']>;
};

export type CancelProposalResponse = {
  __typename?: 'CancelProposalResponse';
  newProposal?: Maybe<Proposal>;
  proposal: Proposal;
};

export enum ChangeOrderProposalType {
  CHANGE_EXISTING_PROPOSAL = 'CHANGE_EXISTING_PROPOSAL',
  CREATE_NEW_CHANGE_ORDER_PROPOSAL = 'CREATE_NEW_CHANGE_ORDER_PROPOSAL'
}

export enum ChangeOrderScheduledJobsAction {
  LEAVE_JOBS_SCHEDULED = 'LEAVE_JOBS_SCHEDULED',
  REMOVE_JOBS_FROM_SCHEDULE = 'REMOVE_JOBS_FROM_SCHEDULE'
}

export type ChecklistCompletion = {
  __typename?: 'ChecklistCompletion';
  allCompleted: Scalars['Boolean'];
  ratio: Scalars['String'];
};

export type Company = {
  __typename?: 'Company';
  addCompanyInfo?: Maybe<Scalars['Boolean']>;
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  contacts: Array<Contact>;
  email: Scalars['String'];
  id: Scalars['ID'];
  jobsCount?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  notificationTypes?: Maybe<NotificationTypeOptions>;
  phone?: Maybe<Scalars['String']>;
  primaryContact?: Maybe<Contact>;
  projectFilesFolderId?: Maybe<Scalars['ID']>;
  proposalsCount?: Maybe<Scalars['Int']>;
  status: CompanyStatus | `${CompanyStatus}`;
  website?: Maybe<Scalars['String']>;
};

export type CompanyContactHasMany = {
  create: Array<InputMaybe<CreateCompanyContactInput>>;
};

export type CompanyOrClientDetails = {
  __typename?: 'CompanyOrClientDetails';
  companyId?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  companyStatus?: Maybe<Scalars['String']>;
  orgRevenuePercentage?: Maybe<Scalars['Float']>;
  proposalsCount?: Maybe<Scalars['Int']>;
  proposalsWonAmountTotal?: Maybe<Scalars['Float']>;
  proposalsWonCount?: Maybe<Scalars['Int']>;
  winRate?: Maybe<Scalars['Float']>;
};

/** A paginated list of Company items. */
export type CompanyPaginator = {
  __typename?: 'CompanyPaginator';
  /** A list of Company items. */
  data: Array<Company>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum CompanyStatus {
  /** Customer */
  CUSTOMER = 'CUSTOMER',
  /** Proposal requested */
  PROPOSAL_REQUESTED = 'PROPOSAL_REQUESTED',
  /** Proposal sent */
  PROPOSAL_SENT = 'PROPOSAL_SENT',
  /** Prospect */
  PROSPECT = 'PROSPECT'
}

export type ConnectPlantTransferTruckInput = {
  id: Scalars['ID'];
  rateHourly?: InputMaybe<Scalars['Int']>;
  rateTon?: InputMaybe<Scalars['Int']>;
  tonnage: Scalars['Int'];
};

export type ConnectProposalProductsToGroupHasMany = {
  connect?: InputMaybe<Array<Scalars['ID']>>;
};

export type Contact = {
  __typename?: 'Contact';
  SMSNotifications?: Maybe<Scalars['Boolean']>;
  SMSNotificationsReadOnly?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  role?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_zip?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['ID']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type CreateAdditionalCostInput = {
  cost: Scalars['Int'];
  feeAmount: Scalars['Float'];
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  name: Scalars['String'];
};

export type CreateAiMappingDetectionInput = {
  bbox: Array<Scalars['Float']>;
  category: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
  confidence?: InputMaybe<Scalars['Float']>;
  runAreaId: Scalars['ID'];
};

export type CreateAiMappingRunAreaInput = {
  coordinates: Scalars['String'];
  inputType: AiMappingInputType | `${AiMappingInputType}`;
  minSegAreaSqft?: InputMaybe<Scalars['Float']>;
  minSegConf?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  runId: Scalars['ID'];
  segmentationModel?: InputMaybe<AiMappingSegmentationModel | `${AiMappingSegmentationModel}`>;
};

export type CreateAiMappingSegmentationInput = {
  category?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  polygon: Array<Scalars['Float']>;
  runAreaId: Scalars['ID'];
};

export type CreateCompanyContactInput = {
  SMSNotifications: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  role?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateCompanyInput = {
  addCompanyInfo?: InputMaybe<Scalars['Boolean']>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  contacts: CompanyContactHasMany;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationTypes?: InputMaybe<NotificationTypeInput>;
  phone?: InputMaybe<Scalars['String']>;
  primaryContact: CreateCompanyContactInput;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  status: CompanyStatus | `${CompanyStatus}`;
};

export type CreateCrewInput = {
  color: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<UpsertEmployeeCrewBelongsToMany>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  rate: Scalars['Int'];
};

export type CreateCustomContentTypeInput = {
  contentType: Scalars['String'];
  showOnBranded?: InputMaybe<Scalars['Boolean']>;
  showOnFull?: InputMaybe<Scalars['Boolean']>;
  showOnSimple?: InputMaybe<Scalars['Boolean']>;
  showOnTabular?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCustomEventInput = {
  blocks: Array<CustomEventBlockInput>;
  color?: InputMaybe<Scalars['String']>;
  crewId?: InputMaybe<Scalars['ID']>;
  files?: InputMaybe<Array<CustomEventFileInput>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  userIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CreateDailyFormInspectionInput = {
  dailyFormVehicleId?: InputMaybe<Scalars['ID']>;
  questionAnswers?: InputMaybe<UpsertDailyFormInspectionQuestionAnswerBelongsToMany>;
  vehicleMilleage?: InputMaybe<Scalars['Int']>;
};

export type CreateDailyFormInspectionQuestionInput = {
  question: Scalars['String'];
  type: DailyFormInspectionQuestionType | `${DailyFormInspectionQuestionType}`;
};

export type CreateDailyFormVehicleInput = {
  currentMeterReading?: InputMaybe<Scalars['Float']>;
  dailyFormVehicleTypeId?: InputMaybe<Scalars['ID']>;
  defaultServiceIntervalUnit?: InputMaybe<DailyFormVehicleServiceIntervalUnit | `${DailyFormVehicleServiceIntervalUnit}`>;
  defaultServiceIntervalValue?: InputMaybe<Scalars['Int']>;
  inServiceDate?: InputMaybe<Scalars['Date']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  meterType?: InputMaybe<DailyFormVehicleMeterType | `${DailyFormVehicleMeterType}`>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  registrationExpirationDate?: InputMaybe<Scalars['Date']>;
  registrationState?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type CreateDailyFormVehiclePartInput = {
  dailyFormVehicleId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  vendorName?: InputMaybe<Scalars['String']>;
};

export type CreateDailyFormVehicleServicePlanInput = {
  assignedTo?: InputMaybe<Scalars['ID']>;
  autoCreateTask?: InputMaybe<Scalars['Boolean']>;
  dailyFormVehicleId: Scalars['ID'];
  intervalUnit: DailyFormVehicleServiceIntervalUnit | `${DailyFormVehicleServiceIntervalUnit}`;
  intervalValue: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  issueType?: InputMaybe<Scalars['String']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']>;
  lastCompletedMeterReading?: InputMaybe<Scalars['Float']>;
  leadUnit?: InputMaybe<DailyFormVehicleServiceIntervalUnit | `${DailyFormVehicleServiceIntervalUnit}`>;
  leadValue?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<DailyFormIssuePriority | `${DailyFormIssuePriority}`>;
};

export type CreateDailyFormWorkOrderInput = {
  assignedTo?: InputMaybe<Scalars['ID']>;
  comments?: InputMaybe<Scalars['String']>;
  currentMeterReading?: InputMaybe<Scalars['Float']>;
  estimatedTaskTime?: InputMaybe<Scalars['Float']>;
  files?: InputMaybe<Array<DailyFormWorkOrderFileInput>>;
  issueDescription: Scalars['String'];
  issueName: Scalars['String'];
  issueType: Scalars['String'];
  neededCompletionDate?: InputMaybe<Scalars['Date']>;
  priority: DailyFormIssuePriority | `${DailyFormIssuePriority}`;
  servicePlanId?: InputMaybe<Scalars['ID']>;
  status: DailyFormIssueStatus | `${DailyFormIssueStatus}`;
  vehicleId: Scalars['ID'];
};

export type CreateEmployeeForUserInviteInput = {
  rate: Scalars['Int'];
};

export type CreateEmployeeInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  rate: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreateEquipmentPieceInput = {
  calculateTravelTime: Scalars['Boolean'];
  chargeType: EquipmentPieceChargeType | `${EquipmentPieceChargeType}`;
  fuelSurcharge: Scalars['Int'];
  name: Scalars['String'];
  rate: Scalars['Int'];
  usePercentage: Scalars['Int'];
};

export type CreateNotificationTriggerInput = {
  active: Scalars['Boolean'];
  additionalRecipientTypes?: InputMaybe<Array<NotificationTriggerAdditionalRecipientTypes | `${NotificationTriggerAdditionalRecipientTypes}`>>;
  additionalRecipients?: InputMaybe<SyncNotificationAdditionalRecipientsHasMany>;
  apiHeaders?: InputMaybe<Scalars['String']>;
  apiMethod?: InputMaybe<Scalars['String']>;
  apiPayload?: InputMaybe<Scalars['String']>;
  apiUrl?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  delay: Scalars['Int'];
  emailSubject?: InputMaybe<Scalars['String']>;
  event: NotificationTriggerEvent | `${NotificationTriggerEvent}`;
  isApi?: InputMaybe<Scalars['Boolean']>;
  isEmail?: InputMaybe<Scalars['Boolean']>;
  isSMS?: InputMaybe<Scalars['Boolean']>;
  isTask?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  sendToAllRecipients: Scalars['Boolean'];
  sendToContact: Scalars['Boolean'];
  sendToUser: Scalars['Boolean'];
  smsContent?: InputMaybe<Scalars['String']>;
  taskContent?: InputMaybe<Scalars['String']>;
  type: NotificationTriggerType | `${NotificationTriggerType}`;
};

export type CreateOpportunityInput = {
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  dueAt?: InputMaybe<Scalars['Date']>;
  estimatedOpportunityValue?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<CreateOpportunityProductBelongsToMany>;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<OpportunitySource | `${OpportunitySource}`>;
  userId: Scalars['ID'];
};

export type CreateOpportunityProductBelongsToMany = {
  connect: Array<CreateOpportunityProductInput>;
};

export type CreateOpportunityProductInput = {
  id: Scalars['ID'];
};

export type CreateOrganizationAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  latitude?: InputMaybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type CreateOrganizationApiKey = {
  __typename?: 'CreateOrganizationApiKey';
  success: Scalars['Boolean'];
};

export type CreateOrganizationProductTypeInput = {
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  markupPercentage?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  overheadPercentage?: InputMaybe<Scalars['Int']>;
  type: ProductType | `${ProductType}`;
};

export type CreatePlantInput = {
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  products: CreatePlantProductBelongsToMany;
};

export type CreatePlantProductBelongsToMany = {
  create: Array<CreatePlantProductInput>;
};

export type CreatePlantProductInput = {
  rate: Scalars['Int'];
  type: Scalars['String'];
};

export type CreatePlantTransferTruckBelongsToMany = {
  connect: Array<ConnectPlantTransferTruckInput>;
};

export type CreateProductAdditionalCostBelongsToMany = {
  connect: Array<CreateProductAdditionalCostInput>;
};

export type CreateProductAdditionalCostInput = {
  id: Scalars['ID'];
  type?: InputMaybe<ProductAdditionalCostType | `${ProductAdditionalCostType}`>;
};

export type CreateProductCrewInput = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type CreateProductCrewsBelongsToMany = {
  connect: Array<CreateProductCrewInput>;
};

export type CreateProductEquipmentBelongsToMany = {
  connect: Array<CreateProductEquipmentInput>;
};

export type CreateProductEquipmentInput = {
  id: Scalars['ID'];
  quantity: Scalars['Float'];
};

export type CreateProductGroupInput = {
  name: Scalars['String'];
  products?: InputMaybe<SyncProductGroupProductsHasMany>;
};

export type CreateProductInput = {
  additionalCosts?: InputMaybe<CreateProductAdditionalCostBelongsToMany>;
  areaCoverage?: InputMaybe<Scalars['Float']>;
  /** Json encoded string of attributes */
  attributes?: InputMaybe<ProductAttributesInput>;
  costMaterial?: InputMaybe<Scalars['Int']>;
  costMinimumProduct?: InputMaybe<Scalars['Int']>;
  costMinimumProposal?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  crews?: InputMaybe<CreateProductCrewsBelongsToMany>;
  dailyUnitsComplete?: InputMaybe<Scalars['Int']>;
  equipmentPieces?: InputMaybe<CreateProductEquipmentBelongsToMany>;
  externalProductName?: InputMaybe<Scalars['String']>;
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  labourCostType?: InputMaybe<ProductLabourCostType | `${ProductLabourCostType}`>;
  markupPercentage?: InputMaybe<Scalars['Int']>;
  materialsNoPlant?: InputMaybe<CreateProductMaterialNoPlantHasMany>;
  measurementJob: ProductMeasurementJob | `${ProductMeasurementJob}`;
  measurementMaterial?: InputMaybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  name: Scalars['String'];
  organizationProductTypeId: Scalars['ID'];
  overheadPercentage?: InputMaybe<Scalars['Int']>;
  plantProductId?: InputMaybe<Scalars['ID']>;
  plantProducts?: InputMaybe<CreateProductPlantProductsBelongsToMany>;
  productionRateType?: InputMaybe<ProductProductionRateType | `${ProductProductionRateType}`>;
  statementOfWork?: InputMaybe<Scalars['String']>;
  subcontracted: Scalars['Boolean'];
  unitPrice?: InputMaybe<Scalars['Int']>;
  unitPriceProduct: Scalars['Boolean'];
};

export type CreateProductMaterialNoPlantHasMany = {
  create: Array<CreateProductMaterialNoPlantInput>;
};

export type CreateProductMaterialNoPlantInput = {
  name: Scalars['String'];
  percentage: Scalars['Float'];
  rate: Scalars['Int'];
};

export type CreateProductPlantProductInput = {
  applicationRate?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  plantId: Scalars['ID'];
};

export type CreateProductPlantProductsBelongsToMany = {
  connect?: InputMaybe<Array<CreateProductPlantProductInput>>;
};

export type CreateProjectMapInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mapData?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateTaskInput = {
  assignedUserId: Scalars['ID'];
  content: Scalars['String'];
  dueAt?: InputMaybe<Scalars['DateTime']>;
  /** Optional: link the task to a proposal/job/opportunity */
  related?: InputMaybe<TaskRelatedInput>;
};

export type CreateTimeBucketInput = {
  name: Scalars['String'];
};

export type CreateTimeEntryInput = {
  clockInLatitude?: InputMaybe<Scalars['Float']>;
  clockInLongitude?: InputMaybe<Scalars['Float']>;
  clockOutLatitude?: InputMaybe<Scalars['Float']>;
  clockOutLongitude?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  forDate: Scalars['Date'];
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  timeBucketId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
  uuid: Scalars['String'];
};

export type CreateTransferTruckInput = {
  defaultRateHourly: Scalars['Int'];
  defaultRateTon: Scalars['Int'];
  defaultTonnage: Scalars['Int'];
  name: Scalars['String'];
};

export type Crew = {
  __typename?: 'Crew';
  color: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  employees?: Maybe<Array<Employee>>;
  foremanUser?: Maybe<User>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: Organization;
  rate: Scalars['Int'];
};

/** A paginated list of Crew items. */
export type CrewPaginator = {
  __typename?: 'CrewPaginator';
  /** A list of Crew items. */
  data: Array<Crew>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Custom = {
  __typename?: 'Custom';
  area?: Maybe<Scalars['String']>;
  areaSource: Scalars['String'];
  areaUnit?: Maybe<Scalars['String']>;
  calculationVersion?: Maybe<Scalars['Int']>;
  costTotal?: Maybe<Scalars['String']>;
  fixedPrice: Scalars['String'];
  helpers?: Maybe<CustomHelpers>;
  indirectPercentage?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  margin?: Maybe<Scalars['String']>;
  marginPercentage?: Maybe<Scalars['String']>;
  markup: Scalars['String'];
  name: Scalars['String'];
  overheadPercentage?: Maybe<Scalars['String']>;
  pricing?: Maybe<CustomPricingControl>;
  pricingBaseline?: Maybe<CustomPricingBaseline>;
  pricingMethod: Scalars['String'];
  pricingOverrideField?: Maybe<Scalars['String']>;
  profitAmount?: Maybe<Scalars['String']>;
  quantity: Scalars['String'];
  rate: Scalars['String'];
  rows: Array<CustomRow>;
  scope?: Maybe<Scalars['String']>;
  scopeFormat?: Maybe<Scalars['String']>;
  sellingTotal?: Maybe<Scalars['String']>;
  sourceProductId?: Maybe<Scalars['ID']>;
  sourceProductRevision?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type CustomEvent = {
  __typename?: 'CustomEvent';
  color?: Maybe<Scalars['String']>;
  crew?: Maybe<Crew>;
  customEventBlocks?: Maybe<Array<Maybe<CustomEventBlock>>>;
  customEventsToUsers?: Maybe<Array<Maybe<CustomEventsToUsers>>>;
  endsAt?: Maybe<Scalars['DateTime']>;
  files: Array<CustomEventFile>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
};

export type CustomEventBlock = {
  __typename?: 'CustomEventBlock';
  blockLength?: Maybe<Scalars['Float']>;
  customEvent?: Maybe<CustomEvent>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
};

export type CustomEventBlockInput = {
  blockLength?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomEventFile = {
  __typename?: 'CustomEventFile';
  customEvent: CustomEvent;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: Organization;
  path: Scalars['String'];
};

export type CustomEventFileInput = {
  name: Scalars['String'];
  path: Scalars['String'];
};

export type CustomEventsToUsers = {
  __typename?: 'CustomEventsToUsers';
  user?: Maybe<User>;
};

export type CustomFactor = {
  __typename?: 'CustomFactor';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type CustomHelpers = {
  __typename?: 'CustomHelpers';
  hoursPerDay: Scalars['String'];
  production?: Maybe<ProductionHelper>;
  travel?: Maybe<TravelHelper>;
};

export type CustomHelpersInput = {
  hoursPerDay: Scalars['String'];
  production?: InputMaybe<ProductionHelperInput>;
  travel?: InputMaybe<TravelHelperInput>;
};

export type CustomInput = {
  area?: InputMaybe<Scalars['String']>;
  areaSource: Scalars['String'];
  areaUnit?: InputMaybe<Scalars['String']>;
  calculationVersion?: InputMaybe<Scalars['Int']>;
  fixedPrice: Scalars['String'];
  helpers?: InputMaybe<CustomHelpersInput>;
  indirectPercentage?: InputMaybe<Scalars['String']>;
  internalName?: InputMaybe<Scalars['String']>;
  markup: Scalars['String'];
  name: Scalars['String'];
  overheadPercentage?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<CustomPricingControlInput>;
  pricingBaseline?: InputMaybe<CustomPricingBaselineInput>;
  pricingMethod: Scalars['String'];
  pricingOverrideField?: InputMaybe<Scalars['String']>;
  profitAmount?: InputMaybe<Scalars['String']>;
  quantity: Scalars['String'];
  rate: Scalars['String'];
  rows: Array<CustomRowInput>;
  scope?: InputMaybe<Scalars['String']>;
  scopeFormat?: InputMaybe<Scalars['String']>;
  sourceProductId?: InputMaybe<Scalars['ID']>;
  sourceProductRevision?: InputMaybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type CustomPaginatorInfo = {
  __typename?: 'CustomPaginatorInfo';
  count: Scalars['Int'];
  currentPage: Scalars['Int'];
  firstItem?: Maybe<Scalars['Int']>;
  hasMorePages: Scalars['Boolean'];
  lastItem?: Maybe<Scalars['Int']>;
  lastPage: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
};

export type CustomPricingBaseline = {
  __typename?: 'CustomPricingBaseline';
  fixedPrice: Scalars['String'];
  markup: Scalars['String'];
  pricing?: Maybe<CustomPricingControl>;
  pricingMethod: Scalars['String'];
  profitAmount?: Maybe<Scalars['String']>;
};

export type CustomPricingBaselineInput = {
  fixedPrice: Scalars['String'];
  markup: Scalars['String'];
  pricing?: InputMaybe<CustomPricingControlInput>;
  pricingMethod: Scalars['String'];
  profitAmount?: InputMaybe<Scalars['String']>;
};

export type CustomPricingControl = {
  __typename?: 'CustomPricingControl';
  discount: Scalars['String'];
  mode: Scalars['String'];
  value: Scalars['String'];
  version: Scalars['Int'];
};

export type CustomPricingControlInput = {
  discount: Scalars['String'];
  mode: Scalars['String'];
  value: Scalars['String'];
  version: Scalars['Int'];
};

export type CustomProduct = {
  __typename?: 'CustomProduct';
  definition: Custom;
  id: Scalars['ID'];
  organizationProductType?: Maybe<OrganizationProductType>;
  revision: Scalars['String'];
};

export type CustomProposalFinancials = {
  __typename?: 'CustomProposalFinancials';
  incomplete: Scalars['Boolean'];
  netMargin?: Maybe<Scalars['String']>;
  productsWithoutCosts: Scalars['Int'];
  profit?: Maybe<Scalars['String']>;
  sendErrors: Array<Scalars['String']>;
};

export type CustomRow = {
  __typename?: 'CustomRow';
  calculatedQuantity?: Maybe<Scalars['String']>;
  calculation: Scalars['String'];
  category: Scalars['String'];
  factor?: Maybe<Scalars['String']>;
  factorAreaUnit?: Maybe<Scalars['String']>;
  factorLabel?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  hauling?: Maybe<HaulingHelper>;
  hoursPerTruck?: Maybe<Scalars['String']>;
  jobSize?: Maybe<Scalars['String']>;
  jobSizeUnit?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['String'];
  quantityOverride?: Maybe<Scalars['String']>;
  quantitySource?: Maybe<Scalars['String']>;
  rate: Scalars['String'];
  rowId?: Maybe<Scalars['ID']>;
  sourceId?: Maybe<Scalars['ID']>;
  sourceName?: Maybe<Scalars['String']>;
  sourcePlantId?: Maybe<Scalars['ID']>;
  sourcePlantName?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  thickness?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
  truckCapacity?: Maybe<Scalars['String']>;
  truckRateHours?: Maybe<Scalars['String']>;
  truckRateLoads?: Maybe<Scalars['String']>;
  truckRateTons?: Maybe<Scalars['String']>;
  truckRateYards?: Maybe<Scalars['String']>;
  truckingUnit?: Maybe<Scalars['String']>;
  trucksNeeded?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type CustomRowInput = {
  calculation: Scalars['String'];
  category: Scalars['String'];
  factor?: InputMaybe<Scalars['String']>;
  factorAreaUnit?: InputMaybe<Scalars['String']>;
  factorLabel?: InputMaybe<Scalars['String']>;
  hauling?: InputMaybe<HaulingHelperInput>;
  hoursPerTruck?: InputMaybe<Scalars['String']>;
  jobSize?: InputMaybe<Scalars['String']>;
  jobSizeUnit?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['String'];
  quantityOverride?: InputMaybe<Scalars['String']>;
  quantitySource?: InputMaybe<Scalars['String']>;
  rate: Scalars['String'];
  rowId?: InputMaybe<Scalars['ID']>;
  sourceId?: InputMaybe<Scalars['ID']>;
  sourceName?: InputMaybe<Scalars['String']>;
  sourcePlantId?: InputMaybe<Scalars['ID']>;
  sourcePlantName?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
  thickness?: InputMaybe<Scalars['String']>;
  truckCapacity?: InputMaybe<Scalars['String']>;
  truckRateHours?: InputMaybe<Scalars['String']>;
  truckRateLoads?: InputMaybe<Scalars['String']>;
  truckRateTons?: InputMaybe<Scalars['String']>;
  truckRateYards?: InputMaybe<Scalars['String']>;
  truckingUnit?: InputMaybe<Scalars['String']>;
  trucksNeeded?: InputMaybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type CustomSettings = {
  __typename?: 'CustomSettings';
  canManageProducts: Scalars['Boolean'];
  canManageSettings: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  factors: Array<CustomFactor>;
  markup: Scalars['String'];
  workingHoursPerDay: Scalars['String'];
};

export type DailyFormInspection = {
  __typename?: 'DailyFormInspection';
  createdAt: Scalars['DateTime'];
  dailyFormVehicle?: Maybe<DailyFormVehicle>;
  id: Scalars['ID'];
  lightsWork?: Maybe<Scalars['Boolean']>;
  loadStrapped?: Maybe<Scalars['Boolean']>;
  oilChecked?: Maybe<Scalars['Boolean']>;
  organization: Organization;
  questionAnswers: Array<DailyFormInspectionQuestionAnswer>;
  tiresAiredBrakesWorking?: Maybe<Scalars['Boolean']>;
  toolsLoaded?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  vehicleConditionAcceptable?: Maybe<Scalars['Boolean']>;
  vehicleFueled?: Maybe<Scalars['Boolean']>;
  vehicleMilleage?: Maybe<Scalars['Int']>;
};

export type DailyFormInspectionQuestion = {
  __typename?: 'DailyFormInspectionQuestion';
  id: Scalars['ID'];
  organization: Organization;
  question: Scalars['String'];
  type: DailyFormInspectionQuestionType | `${DailyFormInspectionQuestionType}`;
};

export type DailyFormInspectionQuestionAnswer = {
  __typename?: 'DailyFormInspectionQuestionAnswer';
  answer?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inspection: DailyFormInspection;
  isTrue: Scalars['Boolean'];
  question: DailyFormInspectionQuestion;
};

export type DailyFormInspectionQuestionInput = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isTrue?: InputMaybe<Scalars['Boolean']>;
  questionId: Scalars['ID'];
};

export enum DailyFormInspectionQuestionType {
  /** Boolean */
  BOOLEAN = 'BOOLEAN',
  /** Text */
  TEXT = 'TEXT'
}

export enum DailyFormIssuePriority {
  /** High */
  HIGH = 'HIGH',
  /** Low */
  LOW = 'LOW',
  /** Medium */
  MEDIUM = 'MEDIUM'
}

export enum DailyFormIssueStatus {
  /** Approved */
  APPROVED = 'APPROVED',
  /** Blocked */
  BLOCKED = 'BLOCKED',
  /** Done */
  DONE = 'DONE',
  /** Duplicate */
  DUPLICATE = 'DUPLICATE',
  /** In progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Open */
  OPEN = 'OPEN',
  /** Waiting approval */
  WAITING_APPROVAL = 'WAITING_APPROVAL',
  /** Waiting on parts */
  WAITING_ON_PARTS = 'WAITING_ON_PARTS'
}

export type DailyFormVehicle = {
  __typename?: 'DailyFormVehicle';
  currentMeterReading?: Maybe<Scalars['Float']>;
  dailyFormVehicleType?: Maybe<DailyFormVehicleType>;
  defaultServiceIntervalUnit?: Maybe<DailyFormVehicleServiceIntervalUnit | `${DailyFormVehicleServiceIntervalUnit}`>;
  defaultServiceIntervalValue?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  inServiceDate?: Maybe<Scalars['Date']>;
  inspections: Array<DailyFormInspection>;
  isActive: Scalars['Boolean'];
  licensePlate?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  meterType?: Maybe<DailyFormVehicleMeterType | `${DailyFormVehicleMeterType}`>;
  model?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  parts: Array<DailyFormVehiclePart>;
  registrationExpirationDate?: Maybe<Scalars['Date']>;
  registrationState?: Maybe<Scalars['String']>;
  servicePlans: Array<DailyFormVehicleServicePlan>;
  vin?: Maybe<Scalars['String']>;
  workOrders: Array<DailyFormWorkOrder>;
  year?: Maybe<Scalars['Int']>;
};

export enum DailyFormVehicleMeterType {
  HOURS = 'HOURS',
  MILES = 'MILES'
}

/** A paginated list of DailyFormVehicle items. */
export type DailyFormVehiclePaginator = {
  __typename?: 'DailyFormVehiclePaginator';
  /** A list of DailyFormVehicle items. */
  data: Array<DailyFormVehicle>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DailyFormVehiclePart = {
  __typename?: 'DailyFormVehiclePart';
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Float']>;
  vehicle: DailyFormVehicle;
  vendorName?: Maybe<Scalars['String']>;
};

export enum DailyFormVehicleServiceIntervalUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MILES = 'MILES'
}

export type DailyFormVehicleServicePlan = {
  __typename?: 'DailyFormVehicleServicePlan';
  assignedTo?: Maybe<User>;
  autoCreateTask: Scalars['Boolean'];
  id: Scalars['ID'];
  intervalUnit: DailyFormVehicleServiceIntervalUnit | `${DailyFormVehicleServiceIntervalUnit}`;
  intervalValue: Scalars['Int'];
  isActive: Scalars['Boolean'];
  issueType?: Maybe<Scalars['String']>;
  lastCompletedAt?: Maybe<Scalars['DateTime']>;
  lastCompletedMeterReading?: Maybe<Scalars['Float']>;
  leadUnit?: Maybe<DailyFormVehicleServiceIntervalUnit | `${DailyFormVehicleServiceIntervalUnit}`>;
  leadValue: Scalars['Int'];
  name: Scalars['String'];
  nextDueDate?: Maybe<Scalars['Date']>;
  nextDueMeterReading?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  priority?: Maybe<DailyFormIssuePriority | `${DailyFormIssuePriority}`>;
  vehicle: DailyFormVehicle;
  workOrders: Array<DailyFormWorkOrder>;
};

export type DailyFormVehicleType = {
  __typename?: 'DailyFormVehicleType';
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: Organization;
};

export type DailyFormWorkOrder = {
  __typename?: 'DailyFormWorkOrder';
  assignedTo?: Maybe<User>;
  comments?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  currentMeterReading?: Maybe<Scalars['Float']>;
  estimatedTaskTime?: Maybe<Scalars['Float']>;
  files: Array<DailyFormWorkOrderFile>;
  id: Scalars['ID'];
  issueDescription: Scalars['String'];
  issueName: Scalars['String'];
  issueType: Scalars['String'];
  neededCompletionDate?: Maybe<Scalars['Date']>;
  priority: DailyFormIssuePriority | `${DailyFormIssuePriority}`;
  servicePlan?: Maybe<DailyFormVehicleServicePlan>;
  status: DailyFormIssueStatus | `${DailyFormIssueStatus}`;
  user: User;
  vehicle: DailyFormVehicle;
};

export type DailyFormWorkOrderFile = {
  __typename?: 'DailyFormWorkOrderFile';
  dailyFormWorkOrder: DailyFormWorkOrder;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: Organization;
  path: Scalars['String'];
};

export type DailyFormWorkOrderFileInput = {
  name: Scalars['String'];
  path: Scalars['String'];
};

export type DashboardDataByMonth = {
  __typename?: 'DashboardDataByMonth';
  closedBids: Scalars['Int'];
  closedRate: Scalars['Float'];
  closedRevenue: Scalars['Float'];
  sentBids: Scalars['Int'];
};

export type DashboardExtraKpisYtd = {
  __typename?: 'DashboardExtraKpisYtd';
  averageProposalAmount: Scalars['String'];
  jobsWonCount: Scalars['Int'];
  organizationSalesGoal: Scalars['String'];
  pace: Scalars['Float'];
  percentToGoal: Scalars['Float'];
  totalPipeline: Scalars['String'];
  weightedForecast30Days: Scalars['String'];
  weightedForecast60Days: Scalars['String'];
  weightedPipeline: Scalars['String'];
};

export type DashboardMapData = {
  __typename?: 'DashboardMapData';
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  status: JobStatus | `${JobStatus}`;
};

export type DateWithMaterialAmount = {
  __typename?: 'DateWithMaterialAmount';
  JobPhaseAmountScheduledInDay: Scalars['Float'];
  date: Scalars['String'];
  jobPhaseMaterialNeededInDay: Scalars['Float'];
  material: Scalars['String'];
};

export type DateWithTotals = {
  __typename?: 'DateWithTotals';
  date: Scalars['String'];
  overallTotal: Scalars['String'];
};

export type DefaultDashboardStats = {
  __typename?: 'DefaultDashboardStats';
  currentMonth: DashboardDataByMonth;
  jobScheduleByAmount: Array<DateWithTotals>;
  lastYear: YearlyDashboardData;
  materialNeededByDay?: Maybe<Array<DateWithMaterialAmount>>;
  persons: Array<Maybe<PersonSales>>;
  previousMonth: DashboardDataByMonth;
};

export enum DeleteOpenProposalAction {
  /** Cancel */
  CANCEL = 'CANCEL',
  /** Reassign */
  REASSIGN = 'REASSIGN',
  /** Unassign */
  UNASSIGN = 'UNASSIGN'
}

export type DeleteOrganizationApiKey = {
  __typename?: 'DeleteOrganizationApiKey';
  success: Scalars['Boolean'];
};

export type DnsRecord = {
  __typename?: 'DnsRecord';
  host: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type DuplicateProposalResponse = {
  __typename?: 'DuplicateProposalResponse';
  newProposal?: Maybe<Proposal>;
  proposal: Proposal;
};

export enum EmailIdentityReplyToType {
  custom = 'custom',
  estimator = 'estimator',
  organization = 'organization'
}

export type Employee = {
  __typename?: 'Employee';
  archivedAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  rate: Scalars['Int'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

/** A paginated list of Employee items. */
export type EmployeePaginator = {
  __typename?: 'EmployeePaginator';
  /** A list of Employee items. */
  data: Array<Employee>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type EquipmentPiece = {
  __typename?: 'EquipmentPiece';
  calculateTravelTime: Scalars['Boolean'];
  chargeType: EquipmentPieceChargeType | `${EquipmentPieceChargeType}`;
  fuelSurcharge: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** @deprecated No longer supported */
  pivot?: Maybe<ProductEquipmentPivot>;
  rate: Scalars['Int'];
  usePercentage: Scalars['Int'];
};

export enum EquipmentPieceChargeType {
  /** Full day */
  FULL_DAY = 'FULL_DAY',
  /** Half day */
  HALF_DAY = 'HALF_DAY',
  /** Hourly */
  HOURLY = 'HOURLY',
  /** Mileage */
  MILEAGE = 'MILEAGE'
}

/** A paginated list of EquipmentPiece items. */
export type EquipmentPiecePaginator = {
  __typename?: 'EquipmentPiecePaginator';
  /** A list of EquipmentPiece items. */
  data: Array<EquipmentPiece>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type FinishRegistrationInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type GenerateUploadCompanyLogoUrl = {
  __typename?: 'GenerateUploadCompanyLogoUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadOrganizationDataUploadUrl = {
  __typename?: 'GenerateUploadOrganizationDataUploadUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadOrganizationDocumentUrl = {
  __typename?: 'GenerateUploadOrganizationDocumentUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadOrganizationLogoUrl = {
  __typename?: 'GenerateUploadOrganizationLogoUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadProjectMapImageUrl = {
  __typename?: 'GenerateUploadProjectMapImageUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadProposalFileUrl = {
  __typename?: 'GenerateUploadProposalFileUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadUrl = {
  __typename?: 'GenerateUploadUrl';
  contentDisposition?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GeoJsonMeasurementInput = {
  featureGeojson?: InputMaybe<Scalars['String']>;
  geojsonFeatureId: Scalars['String'];
  isScreenshotTarget?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  measurementJob?: InputMaybe<ProductMeasurementJob | `${ProductMeasurementJob}`>;
  measurementType: ProposalMeasurementType | `${ProposalMeasurementType}`;
  measurementValue?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type GetCompaniesResponse = {
  __typename?: 'GetCompaniesResponse';
  data: Array<Company>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetCompaniesSortKey {
  ADDRESS = 'ADDRESS',
  CONTACT = 'CONTACT',
  ID = 'ID',
  NAME = 'NAME',
  STATUS = 'STATUS'
}

export type GetCompanyProposalActivityResponse = {
  __typename?: 'GetCompanyProposalActivityResponse';
  data: Array<Proposal>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetDailyFormInspectionsResponse = {
  __typename?: 'GetDailyFormInspectionsResponse';
  data: Array<DailyFormInspection>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetDailyFormWorkOrdersResponse = {
  __typename?: 'GetDailyFormWorkOrdersResponse';
  data: Array<DailyFormWorkOrder>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetInvoicesResponse = {
  __typename?: 'GetInvoicesResponse';
  data: Array<Invoice>;
  paginatorInfo: PaginatorInfo;
};

export enum GetInvoicesSortKey {
  ID = 'ID',
  SENT_AT = 'SENT_AT',
  STATUS = 'STATUS'
}

export type GetJobBillingStatusesResponse = {
  __typename?: 'GetJobBillingStatusesResponse';
  statuses?: Maybe<Array<JobBillingStatus | `${JobBillingStatus}`>>;
};

export type GetJobCostingLapsedReportResponse = {
  __typename?: 'GetJobCostingLapsedReportResponse';
  data: Array<JobCostingLapsedReportJob>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetJobCostingLapsedReportSortKey {
  ACTUAL_OVERALL_TOTAL = 'ACTUAL_OVERALL_TOTAL',
  ENDS_AT = 'ENDS_AT',
  PROPOSED_OVERALL_TOTAL = 'PROPOSED_OVERALL_TOTAL',
  VARIANCE_AMOUNT = 'VARIANCE_AMOUNT',
  VARIANCE_PERCENT = 'VARIANCE_PERCENT'
}

export type GetJobPhasesResponse = {
  __typename?: 'GetJobPhasesResponse';
  data: Array<JobPhase>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetJobsResponse = {
  __typename?: 'GetJobsResponse';
  data: Array<Job>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetJobsSortKey {
  CITY = 'CITY',
  COMPANY = 'COMPANY',
  ID = 'ID',
  JOB_TOTAL = 'JOB_TOTAL',
  START = 'START',
  STATUS = 'STATUS',
  WON_DATE = 'WON_DATE'
}

export type GetOpportunitiesResponse = {
  __typename?: 'GetOpportunitiesResponse';
  data: Array<Opportunity>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetOpportunitiesSortKey {
  ADDRESS = 'ADDRESS',
  COMPANY = 'COMPANY',
  CONTACT = 'CONTACT',
  DUEAT = 'DUEAT',
  ID = 'ID',
  NAME = 'NAME',
  STATUS = 'STATUS'
}

export type GetProjectMapsResponse = {
  __typename?: 'GetProjectMapsResponse';
  data: Array<ProjectMap>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetProjectMapsSortKey {
  CREATED = 'CREATED',
  NAME = 'NAME',
  UPDATED = 'UPDATED'
}

export type GetProposalsResponse = {
  __typename?: 'GetProposalsResponse';
  data: Array<Proposal>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetProposalsSortKey {
  COMPANY = 'COMPANY',
  CREATED = 'CREATED',
  ID = 'ID',
  SENT = 'SENT',
  STAGE = 'STAGE',
  STATUS = 'STATUS',
  TOTAL = 'TOTAL'
}

export type GetTimeEntriesGroupedByUserResponse = {
  __typename?: 'GetTimeEntriesGroupedByUserResponse';
  data: Array<TimeEntriesByUserGroup>;
  paginatorInfo: PaginatorInfo;
};

export type GetTimeEntriesResponse = {
  __typename?: 'GetTimeEntriesResponse';
  data: Array<TimeEntry>;
  paginatorInfo: PaginatorInfo;
};

export enum GetTimeEntriesSortKey {
  DATE = 'DATE',
  END = 'END',
  HOURS = 'HOURS',
  JOB_PHASE = 'JOB_PHASE',
  START = 'START',
  USER = 'USER'
}

export type GetYearOverYearRevenueReportResponse = {
  __typename?: 'GetYearOverYearRevenueReportResponse';
  data: Array<YearOverYearRevenueItem>;
};

export type HaulingHelper = {
  __typename?: 'HaulingHelper';
  allocationPercent: Scalars['String'];
  capacity: Scalars['String'];
  capacityUnit: Scalars['String'];
  fullLoads: Scalars['Boolean'];
  haulQuantity?: Maybe<Scalars['String']>;
  haulUnit?: Maybe<Scalars['String']>;
  loadHours: Scalars['String'];
  materialRowId: Scalars['ID'];
  maxTripsPerDay?: Maybe<Scalars['String']>;
  planningEnabled?: Maybe<Scalars['Boolean']>;
  planningHours?: Maybe<Scalars['String']>;
  quantityMode?: Maybe<Scalars['String']>;
  roundTripHours: Scalars['String'];
  unloadHours: Scalars['String'];
};

export type HaulingHelperInput = {
  allocationPercent: Scalars['String'];
  capacity: Scalars['String'];
  capacityUnit: Scalars['String'];
  fullLoads: Scalars['Boolean'];
  haulQuantity?: InputMaybe<Scalars['String']>;
  haulUnit?: InputMaybe<Scalars['String']>;
  loadHours: Scalars['String'];
  materialRowId: Scalars['ID'];
  maxTripsPerDay?: InputMaybe<Scalars['String']>;
  planningEnabled?: InputMaybe<Scalars['Boolean']>;
  planningHours?: InputMaybe<Scalars['String']>;
  quantityMode?: InputMaybe<Scalars['String']>;
  roundTripHours: Scalars['String'];
  unloadHours: Scalars['String'];
};

export type InviteUserInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['Upload']>;
  email: Scalars['String'];
  employee?: InputMaybe<CreateEmployeeForUserInviteInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role: UserRole | `${UserRole}`;
};

export type Invoice = {
  __typename?: 'Invoice';
  data?: Maybe<Scalars['String']>;
  hideLineItemPricing: Scalars['Boolean'];
  id: Scalars['ID'];
  isOverdue: Scalars['Boolean'];
  job: Job;
  link: Scalars['String'];
  paidAt?: Maybe<Scalars['DateTime']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  status: InvoiceStatus | `${InvoiceStatus}`;
  uuid: Scalars['String'];
};

export enum InvoiceStatus {
  /** Pending */
  PENDING = 'PENDING',
  /** Sent */
  SENT = 'SENT',
  /** Unsent */
  UNSENT = 'UNSENT'
}

export type ItemsQuickbooksDetailInput = {
  itemAmount?: InputMaybe<Scalars['Int']>;
  itemsDescription?: InputMaybe<Scalars['String']>;
  itemsName?: InputMaybe<Scalars['String']>;
};

export type Job = {
  __typename?: 'Job';
  actualCostAdditional: Scalars['String'];
  actualCostDirect: Scalars['String'];
  actualCostEquipment: Scalars['String'];
  actualCostIndirect: Scalars['String'];
  actualCostLabour: Scalars['String'];
  actualCostMaterial: Scalars['String'];
  actualCostOverhead: Scalars['String'];
  actualCostTotal: Scalars['String'];
  actualCostTransferTruck: Scalars['String'];
  actualGrossMargin: Scalars['String'];
  actualGrossMarginPercentage: Scalars['Int'];
  actualNetMargin: Scalars['String'];
  actualNetMarginPercentage: Scalars['Int'];
  actualOperatingMargin: Scalars['String'];
  actualOperatingMarginPercentage: Scalars['Int'];
  actualOverallTotal: Scalars['String'];
  actualProfit: Scalars['String'];
  actualProfitPercentage: Scalars['Int'];
  address: ProposalAddress;
  billingStatus?: Maybe<JobBillingStatus | `${JobBillingStatus}`>;
  changeOrders?: Maybe<Array<Proposal>>;
  checklistItems?: Maybe<Array<JobPhaseChecklistItem>>;
  company: Company;
  contact: Contact;
  datePushedToQuickbooks?: Maybe<Scalars['DateTime']>;
  depositCollectedAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  foremanUser?: Maybe<User>;
  id: Scalars['ID'];
  invoiceId?: Maybe<Scalars['ID']>;
  jobPhases?: Maybe<Array<Maybe<JobPhase>>>;
  mayShowTaxNotification?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  projectFilesFolderId?: Maybe<Scalars['ID']>;
  proposal?: Maybe<Proposal>;
  proposalId: Scalars['ID'];
  proposalStage?: Maybe<ProposalStage>;
  proposedCostAdditional: Scalars['String'];
  proposedCostDirect: Scalars['String'];
  proposedCostEquipment: Scalars['String'];
  proposedCostIndirect: Scalars['String'];
  proposedCostLabour: Scalars['String'];
  proposedCostMaterial: Scalars['String'];
  proposedCostOverhead: Scalars['String'];
  proposedCostTotal: Scalars['String'];
  proposedCostTransferTruck: Scalars['String'];
  proposedGrossMargin: Scalars['String'];
  proposedGrossMarginPercentage: Scalars['Int'];
  proposedNetMargin: Scalars['String'];
  proposedNetMarginPercentage: Scalars['Int'];
  proposedOperatingMargin: Scalars['String'];
  proposedOperatingMarginPercentage: Scalars['Int'];
  proposedOverallTotal: Scalars['String'];
  proposedProfit: Scalars['String'];
  proposedProfitPercentage: Scalars['Int'];
  shouldPushTaxesToQuickbooks?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status: JobStatus | `${JobStatus}`;
  user?: Maybe<User>;
  userId: Scalars['ID'];
  uuid?: Maybe<Scalars['String']>;
};

export enum JobBillingStatus {
  /** Billed */
  BILLED = 'BILLED',
  /** Deposit billed */
  DEPOSIT_BILLED = 'DEPOSIT_BILLED',
  /** Paid */
  PAID = 'PAID',
  /** Partial billed */
  PARTIAL_BILLED = 'PARTIAL_BILLED',
  /** Partial paid */
  PARTIAL_PAID = 'PARTIAL_PAID',
  /** Pending billing */
  PENDING_BILLING = 'PENDING_BILLING',
  /** Ready to bill */
  READY_TO_BILL = 'READY_TO_BILL'
}

export enum JobCostingCompletionStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  OUT_OF_THRESHOLD = 'OUT_OF_THRESHOLD',
  WITHIN_THRESHOLD = 'WITHIN_THRESHOLD'
}

export type JobCostingLapsedReportJob = {
  __typename?: 'JobCostingLapsedReportJob';
  actualOverallTotal: Scalars['String'];
  allPhasesMissingCost: Scalars['Boolean'];
  clientName: Scalars['String'];
  endsAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  jobName: Scalars['String'];
  phaseMissingCost: Scalars['Boolean'];
  phases: Array<JobCostingLapsedReportPhase>;
  proposedOverallTotal: Scalars['String'];
  status: JobStatus | `${JobStatus}`;
  varianceAmount: Scalars['String'];
  variancePercent: Scalars['Float'];
};

export type JobCostingLapsedReportPhase = {
  __typename?: 'JobCostingLapsedReportPhase';
  actualOverallTotal: Scalars['String'];
  endsAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  jobId: Scalars['ID'];
  missingCost: Scalars['Boolean'];
  productType: Scalars['String'];
  proposedOverallTotal: Scalars['String'];
  status: JobPhaseStatus | `${JobPhaseStatus}`;
  varianceAmount: Scalars['String'];
  variancePercent: Scalars['Float'];
};

export type JobDetailsMetadata = {
  __typename?: 'JobDetailsMetadata';
  totals: JobDetailsTotals;
};

export type JobDetailsTotals = {
  __typename?: 'JobDetailsTotals';
  actual_cost_additional: Scalars['Float'];
  actual_cost_direct: Scalars['Float'];
  actual_cost_equipment: Scalars['Float'];
  actual_cost_indirect: Scalars['Float'];
  actual_cost_labour: Scalars['Float'];
  actual_cost_material: Scalars['Float'];
  actual_cost_overhead: Scalars['Float'];
  actual_cost_total: Scalars['Float'];
  actual_gross_margin: Scalars['Float'];
  actual_net_margin: Scalars['Float'];
  actual_operating_margin: Scalars['Float'];
  actual_overall_total: Scalars['Float'];
  actual_profit: Scalars['Float'];
  proposed_cost_additional: Scalars['Float'];
  proposed_cost_direct: Scalars['Float'];
  proposed_cost_equipment: Scalars['Float'];
  proposed_cost_indirect: Scalars['Float'];
  proposed_cost_labour: Scalars['Float'];
  proposed_cost_material: Scalars['Float'];
  proposed_cost_overhead: Scalars['Float'];
  proposed_cost_total: Scalars['Float'];
  proposed_gross_margin: Scalars['Float'];
  proposed_net_margin: Scalars['Float'];
  proposed_operating_margin: Scalars['Float'];
  proposed_overall_total: Scalars['Float'];
  proposed_profit: Scalars['Float'];
};

export type JobInvoiceStats = {
  __typename?: 'JobInvoiceStats';
  invoiceStatus: Scalars['String'];
  last30DaysAmount: Scalars['Float'];
  yearToDateAmount: Scalars['Float'];
};

export type JobPhase = {
  __typename?: 'JobPhase';
  actualCostAdditional: Scalars['String'];
  actualCostDirect: Scalars['String'];
  actualCostEquipment: Scalars['String'];
  actualCostIndirect: Scalars['String'];
  actualCostLabour: Scalars['String'];
  actualCostMaterial: Scalars['String'];
  actualCostOverhead: Scalars['String'];
  actualCostTotal: Scalars['String'];
  actualCostTransferTruck: Scalars['String'];
  actualEmployeeHours: Scalars['String'];
  actualGrossMargin: Scalars['String'];
  actualGrossMarginPercentage: Scalars['Int'];
  actualMaterialNeeded: Scalars['String'];
  actualNetMargin: Scalars['String'];
  actualNetMarginPercentage: Scalars['Int'];
  actualOperatingMargin: Scalars['String'];
  actualOperatingMarginPercentage: Scalars['Int'];
  actualOverallTotal: Scalars['String'];
  actualProfit: Scalars['String'];
  actualProfitPercentage: Scalars['Int'];
  actualSubcontractorCost?: Maybe<Scalars['String']>;
  actualSubcontractorName?: Maybe<Scalars['String']>;
  actualSubcontractorReference?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  applicableStatuses?: Maybe<Array<Scalars['String']>>;
  checklistCompletion: ChecklistCompletion;
  checklistItems: Array<JobPhaseChecklistItem>;
  checklistNotes?: Maybe<Scalars['String']>;
  costItems: Array<JobPhaseCostItem>;
  costingMode: JobPhaseCostingMode | `${JobPhaseCostingMode}`;
  crew?: Maybe<Crew>;
  crewId?: Maybe<Scalars['ID']>;
  defaultAdditionalCosts: Array<AdditionalCost>;
  defaultEmployees: Array<Employee>;
  defaultEquipmentPieces: Array<EquipmentPiece>;
  employees: Array<JobPhaseEmployee>;
  endsAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  files?: Maybe<Array<JobPhaseFile>>;
  foremanUser?: Maybe<User>;
  hasJobCostsEntered: Scalars['Boolean'];
  id: Scalars['ID'];
  job: Job;
  jobCostEntryDaysCount: Scalars['Int'];
  jobCostingCompletionStatus: JobCostingCompletionStatus | `${JobCostingCompletionStatus}`;
  jobCostingThresholdPercent: Scalars['Float'];
  jobCostingVariancePercent: Scalars['Float'];
  jobDuration: Scalars['Float'];
  jobPhaseMaterialNoPlants?: Maybe<Array<JobPhaseMaterialNoPlant>>;
  jobPhasePlant?: Maybe<JobPhasePlant>;
  jobPhasePlants?: Maybe<Array<JobPhasePlant>>;
  jobSize: Scalars['Int'];
  lastJobCostEntryDate?: Maybe<Scalars['Date']>;
  missingCostCategories: Array<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  ordering: Scalars['Int'];
  organization: Organization;
  organizationProductType?: Maybe<OrganizationProductType>;
  organizationProductTypeName?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  proposal: Proposal;
  proposalProduct: ProposalProduct;
  proposalProductGroup?: Maybe<ProposalProductGroup>;
  proposalStage: ProposalStage;
  proposedCostAdditional: Scalars['String'];
  proposedCostDirect: Scalars['String'];
  proposedCostEquipment: Scalars['String'];
  proposedCostIndirect: Scalars['String'];
  proposedCostLabour: Scalars['String'];
  proposedCostMaterial: Scalars['String'];
  proposedCostOverhead: Scalars['String'];
  proposedCostTotal: Scalars['String'];
  proposedCostTransferTruck: Scalars['String'];
  proposedEmployeeHours: Scalars['String'];
  proposedGrossMargin: Scalars['String'];
  proposedGrossMarginPercentage: Scalars['Int'];
  proposedMaterialNeeded: Scalars['String'];
  proposedNetMargin: Scalars['String'];
  proposedNetMarginPercentage: Scalars['Int'];
  proposedOperatingMargin: Scalars['String'];
  proposedOperatingMarginPercentage: Scalars['Int'];
  proposedOverallTotal: Scalars['String'];
  proposedProfit: Scalars['String'];
  proposedProfitPercentage: Scalars['Int'];
  scheduleBlocks: Array<JobPhaseScheduleBlock>;
  scheduledBlockForDate?: Maybe<Array<JobPhaseScheduleBlock>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status: JobPhaseStatus | `${JobPhaseStatus}`;
  /** In Hours */
  travelTimeEstimate?: Maybe<Scalars['Float']>;
  users?: Maybe<Array<User>>;
  usersColor?: Maybe<Scalars['String']>;
  workOrderCrews?: Maybe<Array<Maybe<WorkOrderCrew>>>;
  workOrderEquipmentPieces?: Maybe<Array<Maybe<WorkOrderEquipmentPiece>>>;
  workOrderTransferTrucks?: Maybe<Array<Maybe<WorkOrderTransferTruck>>>;
  worksheet?: Maybe<Worksheet>;
};

export type JobPhaseAdditionalCost = {
  __typename?: 'JobPhaseAdditionalCost';
  additionalCostId?: Maybe<Scalars['ID']>;
  cost: Scalars['Int'];
  costTotal: Scalars['Int'];
  feeAmount: Scalars['Float'];
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  id: Scalars['ID'];
  isSubcontractorCost: Scalars['Boolean'];
  jobPhaseCostItem: JobPhaseCostItem;
  name: Scalars['String'];
};

export type JobPhaseChecklistItem = {
  __typename?: 'JobPhaseChecklistItem';
  checklistItem: OrganizationProposalChecklistItem;
  checklistItemId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isCompleted: Scalars['Boolean'];
  jobPhase: JobPhase;
  jobPhaseId?: Maybe<Scalars['ID']>;
};

export type JobPhaseCostItem = {
  __typename?: 'JobPhaseCostItem';
  additionalCosts?: Maybe<Array<JobPhaseAdditionalCost>>;
  costAdditional: Scalars['Float'];
  costEquipment: Scalars['Float'];
  costLabour: Scalars['Float'];
  costMaterial: Scalars['Float'];
  costTransferTruck: Scalars['Float'];
  date: Scalars['DateTime'];
  employees?: Maybe<Array<JobPhaseEmployee>>;
  equipmentPieces?: Maybe<Array<JobPhaseEquipmentPiece>>;
  id: Scalars['ID'];
  jobPhase: JobPhase;
  material?: Maybe<JobPhaseMaterial>;
  materialsNoPlants?: Maybe<Array<JobPhaseCostItemMaterialNoPlant>>;
  plantId?: Maybe<Scalars['ID']>;
  plantProductId?: Maybe<Scalars['ID']>;
  plants?: Maybe<Array<JobPhaseCostItemPlant>>;
  transferTrucks?: Maybe<Array<JobPhaseTransferTruck>>;
  user?: Maybe<User>;
};

export type JobPhaseCostItemMaterialNoPlant = {
  __typename?: 'JobPhaseCostItemMaterialNoPlant';
  costTotal: Scalars['String'];
  id: Scalars['ID'];
  jobPhaseCostItem: JobPhaseCostItem;
  jobPhaseCostItemId: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  rate: Scalars['String'];
};

export type JobPhaseCostItemPlant = {
  __typename?: 'JobPhaseCostItemPlant';
  costTotal: Scalars['String'];
  id: Scalars['ID'];
  jobPhaseCostItem: JobPhaseCostItem;
  plant: Plant;
  plantId: Scalars['ID'];
  plantProduct: PlantProduct;
  plantProductId: Scalars['ID'];
  quantity: Scalars['Float'];
  rate: Scalars['String'];
};

export enum JobPhaseCostingMode {
  STANDARD = 'STANDARD',
  SUBCONTRACTED = 'SUBCONTRACTED'
}

export type JobPhaseEmployee = {
  __typename?: 'JobPhaseEmployee';
  employeeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rate: Scalars['Int'];
  timeOnjob: Scalars['Float'];
  timeTravel: Scalars['Float'];
};

export type JobPhaseEquipmentPiece = {
  __typename?: 'JobPhaseEquipmentPiece';
  equipmentPieceId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  rate: Scalars['Int'];
  timeOnjob: Scalars['Float'];
  timeTravel: Scalars['Float'];
};

export type JobPhaseFile = {
  __typename?: 'JobPhaseFile';
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  thumbnail?: Maybe<Scalars['String']>;
};

export type JobPhaseMaterial = {
  __typename?: 'JobPhaseMaterial';
  costMaterial: Scalars['Int'];
  id: Scalars['ID'];
  jobPhaseCostItem: JobPhaseCostItem;
  materialNeeded: Scalars['Float'];
  name: Scalars['String'];
  organizationProductTypeName?: Maybe<Scalars['String']>;
  type: ProductType | `${ProductType}`;
};

export type JobPhaseMaterialNoPlant = {
  __typename?: 'JobPhaseMaterialNoPlant';
  cost: Scalars['Int'];
  id: Scalars['ID'];
  jobPhase: JobPhase;
  jobPhaseId: Scalars['ID'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
  quantity: Scalars['Float'];
  rate: Scalars['String'];
};

export type JobPhasePlant = {
  __typename?: 'JobPhasePlant';
  id: Scalars['ID'];
  materialNeeded?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  plant?: Maybe<Plant>;
  plantProduct?: Maybe<PlantProduct>;
  rate?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  worksheetMaterial?: Maybe<WorksheetMaterialSnapshot>;
};

export type JobPhaseScheduleBlock = {
  __typename?: 'JobPhaseScheduleBlock';
  /** In Hours */
  blockLength: Scalars['Float'];
  crew?: Maybe<Crew>;
  endsAt: Scalars['DateTime'];
  estimatedMaterial?: Maybe<Scalars['Float']>;
  estimatedMaterialOverride?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  job: Job;
  jobPhase: JobPhase;
  scheduledAt: Scalars['DateTime'];
  showTravelFrom: Scalars['Boolean'];
  showTravelTo: Scalars['Boolean'];
  /** In Hours */
  travelTime: Scalars['Float'];
};

export enum JobPhaseStatus {
  /** Complete */
  COMPLETE = 'COMPLETE',
  /** In progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Job costing */
  JOB_COSTING = 'JOB_COSTING',
  /** Ready to bill */
  READY_TO_BILL = 'READY_TO_BILL',
  /** Scheduled */
  SCHEDULED = 'SCHEDULED',
  /** To be scheduled */
  TO_BE_SCHEDULED = 'TO_BE_SCHEDULED',
  /** Work complete */
  WORK_COMPLETE = 'WORK_COMPLETE'
}

export type JobPhaseTransferTruck = {
  __typename?: 'JobPhaseTransferTruck';
  hours: Scalars['Float'];
  id: Scalars['ID'];
  name: Scalars['String'];
  plantTransferTruckId?: Maybe<Scalars['ID']>;
  rateHourly: Scalars['Int'];
  rateTon: Scalars['Int'];
  tonnage: Scalars['Int'];
  transferTruckId?: Maybe<Scalars['ID']>;
};

export type JobReadinessDailyTotal = {
  __typename?: 'JobReadinessDailyTotal';
  materialRows: Array<JobReadinessMaterialLine>;
  scheduledDate: Scalars['Date'];
  totalQuantity: Scalars['Float'];
  totalTrucks: Scalars['Int'];
};

export type JobReadinessDashboardResponse = {
  __typename?: 'JobReadinessDashboardResponse';
  dailyTotals: Array<JobReadinessDailyTotal>;
  exceptions: JobReadinessExceptions;
  jobs: Array<JobReadinessJobRow>;
  summary: JobReadinessSummary;
};

export type JobReadinessExceptions = {
  __typename?: 'JobReadinessExceptions';
  jobsMissingMaterialQuantity: Scalars['Int'];
  jobsMissingPlantAssignment: Scalars['Int'];
  jobsNotConfirmedWithClient: Scalars['Int'];
  materialLinesWithoutTrucks: Scalars['Int'];
};

export type JobReadinessJobRow = {
  __typename?: 'JobReadinessJobRow';
  checklistOutstanding: Scalars['Int'];
  checklistTotal: Scalars['Int'];
  confirmedWithClient: Scalars['Boolean'];
  jobExternalId?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['ID']>;
  jobName?: Maybe<Scalars['String']>;
  jobPhaseId: Scalars['ID'];
  key: Scalars['String'];
  materialLines: Array<JobReadinessMaterialLine>;
  profitScheduled: Scalars['Float'];
  revenueScheduled: Scalars['Float'];
  scheduledDate: Scalars['Date'];
};

export type JobReadinessMaterialLine = {
  __typename?: 'JobReadinessMaterialLine';
  hasPlant: Scalars['Boolean'];
  materialName: Scalars['String'];
  quantity: Scalars['Float'];
  sourceName: Scalars['String'];
  trucks: Scalars['Int'];
  unitAbbr: Scalars['String'];
};

export type JobReadinessSummary = {
  __typename?: 'JobReadinessSummary';
  jobsConfirmedWithClient: Scalars['Int'];
  jobsScheduled: Scalars['Int'];
  jobsWithOutstandingChecklistItems: Scalars['Int'];
  profitScheduled: Scalars['Float'];
  revenueScheduled: Scalars['Float'];
  totalQuantity: Scalars['Float'];
  totalTrucks: Scalars['Int'];
};

export type JobScheduleStats = {
  __typename?: 'JobScheduleStats';
  amountScheduled: Scalars['Int'];
  profitScheduled: Scalars['Int'];
};

export enum JobStatus {
  /** Complete */
  COMPLETE = 'COMPLETE',
  /** In progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Job costing */
  JOB_COSTING = 'JOB_COSTING',
  /** Ready to bill */
  READY_TO_BILL = 'READY_TO_BILL',
  /** Scheduled */
  SCHEDULED = 'SCHEDULED',
  /** To be scheduled */
  TO_BE_SCHEDULED = 'TO_BE_SCHEDULED',
  /** Work complete */
  WORK_COMPLETE = 'WORK_COMPLETE'
}

export type JobsByContact = {
  __typename?: 'JobsByContact';
  customerName?: Maybe<Scalars['String']>;
  job?: Maybe<Scalars['String']>;
  jobSize?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
};

export type JobsByContactMetadata = {
  __typename?: 'JobsByContactMetadata';
  totals: JobsByContactTotals;
};

export type JobsByContactTotals = {
  __typename?: 'JobsByContactTotals';
  grand_total: Scalars['Float'];
};

export type LogActivityInput = {
  body?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  contactId: Scalars['ID'];
  jobId?: InputMaybe<Scalars['ID']>;
  occurredAt: Scalars['DateTime'];
  opportunityId?: InputMaybe<Scalars['ID']>;
  proposalId?: InputMaybe<Scalars['ID']>;
  summary: Scalars['String'];
  type: ActivityType | `${ActivityType}`;
};

export type LoginAppUser = {
  __typename?: 'LoginAppUser';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginResult = ActiveSessionConflict | User;

export type ModelsPlantProductType = {
  __typename?: 'ModelsPlantProductType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MonthlySummary = {
  __typename?: 'MonthlySummary';
  month: Scalars['Int'];
  total: Scalars['Float'];
  year: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  CreateOrganizationApiKey: CreateOrganizationApiKey;
  DeleteOrganizationApiKey: DeleteOrganizationApiKey;
  acceptUserInvite?: Maybe<User>;
  addJobPhaseCosts: JobPhaseCostItem;
  addJobPhaseFile: JobPhase;
  addMaterialNoPlantToProposalProduct: ProposalMaterialNoPlant;
  addOrganizationDataUpload: OrganizationDataUpload;
  addOrganizationDocument: Organization;
  addPlantProductToProposalProduct: Proposal;
  addProductsToProposalStage: Proposal;
  addProjectFile: ProjectFile;
  addProposalAdditionalCost: Proposal;
  addProposalAdditionalCosts: Proposal;
  addProposalAddress: Proposal;
  addProposalCrew: Proposal;
  addProposalCrews: Proposal;
  addProposalEquipmentPiece: Proposal;
  addProposalEquipmentPieces: Proposal;
  addProposalFile: ProposalProduct;
  addProposalStage?: Maybe<ProposalStage>;
  addProposalStageChecklistItems: ProposalStage;
  addTruckToProposalProduct?: Maybe<Proposal>;
  appLogin?: Maybe<AppLoginResult>;
  appLogout?: Maybe<Scalars['Boolean']>;
  applyAiMappingAdditionalCosts: Proposal;
  applyProposalStageMeasurements: ApplyProposalStageMeasurementsPayload;
  archiveCompany: Scalars['Boolean'];
  archiveCustomProduct: Scalars['Boolean'];
  archiveEmployee: Employee;
  archiveWorksheetProduct: Scalars['Boolean'];
  cancelAiMappingTask: AiMappingRunArea;
  cancelOpportunity: Opportunity;
  cancelProposal: CancelProposalResponse;
  closeProposal: Proposal;
  completeTask?: Maybe<Task>;
  copyProposalProductToStage: Proposal;
  createAdditionalCost: AdditionalCost;
  createAiMappingDetection: AiMappingRunAreaResultsResponse;
  createAiMappingRun: AiMappingRun;
  createAiMappingRunArea: AiMappingRunArea;
  createAiMappingSegmentation: AiMappingRunAreaResultsResponse;
  createCompany: Company;
  createCrew: Crew;
  createCustomEvent?: Maybe<CustomEvent>;
  createDailyFormInspection: DailyFormInspection;
  createDailyFormInspectionQuestion: DailyFormInspectionQuestion;
  createDailyFormVehicle: DailyFormVehicle;
  createDailyFormVehiclePart: DailyFormVehiclePart;
  createDailyFormVehicleServicePlan: DailyFormVehicleServicePlan;
  createDailyFormVehicleType: DailyFormVehicleType;
  createDailyFormWorkOrder: DailyFormWorkOrder;
  createEmployee: Employee;
  createEquipmentPiece: EquipmentPiece;
  createJobInvoiceOnLinkedService?: Maybe<Scalars['Boolean']>;
  createNotificationTrigger?: Maybe<NotificationTrigger>;
  createOpportunity: Opportunity;
  createOpportunityStatus: OrganizationOpportunityStatus;
  createOrganizationAddress?: Maybe<OrganizationAddress>;
  createOrganizationCustomContentType: OrganizationProposalLayoutContentSetting;
  createOrganizationProductType: OrganizationProductType;
  createOrganizationProposalChecklistItem: OrganizationProposalChecklistItem;
  createPlant?: Maybe<Plant>;
  createPlantProductType?: Maybe<ModelsPlantProductType>;
  createProduct: Product;
  createProductGroup: ProductGroup;
  createProjectFileFolder: ProjectFile;
  createProjectMap: ProjectMap;
  createProposal: Proposal;
  createProposalFromOpportunity: Proposal;
  createProposalFromProjectMap: Proposal;
  createTask?: Maybe<Task>;
  createTimeBucket: TimeBucket;
  createTimeEntry: TimeEntry;
  createTransferTruck?: Maybe<TransferTruck>;
  deleteAdditionalCost?: Maybe<Scalars['Boolean']>;
  deleteAiMappingDetection: AiMappingRunAreaResultsResponse;
  deleteAiMappingSegmentation: AiMappingRunAreaResultsResponse;
  deleteCrew?: Maybe<Scalars['Boolean']>;
  deleteCustomEvent: CustomEvent;
  deleteDailyFormInspection: DailyFormInspection;
  deleteDailyFormInspectionQuestion: DailyFormInspectionQuestion;
  deleteDailyFormVehicle: DailyFormVehicle;
  deleteDailyFormVehiclePart: DailyFormVehiclePart;
  deleteDailyFormVehicleServicePlan: DailyFormVehicleServicePlan;
  deleteDailyFormVehicleType: DailyFormVehicleType;
  deleteDailyFormWorkOrder: DailyFormWorkOrder;
  deleteEmployee?: Maybe<Scalars['Boolean']>;
  deleteEquipmentPiece?: Maybe<Scalars['Boolean']>;
  deleteJobPhaseCost: Scalars['Boolean'];
  deleteJobPhaseFile?: Maybe<Scalars['Boolean']>;
  deleteNotificationTrigger?: Maybe<Scalars['Boolean']>;
  deleteOpportunity?: Maybe<Opportunity>;
  deleteOrganizationAddress?: Maybe<Scalars['Boolean']>;
  deleteOrganizationCustomContentType: Scalars['Boolean'];
  deleteOrganizationDocument: Scalars['Boolean'];
  deleteOrganizationEmailIdentity: Scalars['Boolean'];
  deleteOrganizationProductType?: Maybe<Scalars['Boolean']>;
  deleteOrganizationProposalChecklistItem: OrganizationProposalChecklistItem;
  deleteOrganizationUser: Scalars['Boolean'];
  deletePlant?: Maybe<Scalars['Boolean']>;
  deleteProduct?: Maybe<Scalars['Boolean']>;
  deleteProductGroup?: Maybe<Scalars['Boolean']>;
  deleteProjectFile: ProjectFile;
  deleteProjectMap: ProjectMap;
  deleteProposal: Proposal;
  deleteProposalFile: Scalars['Boolean'];
  deleteProposalMapImage: Scalars['Boolean'];
  deleteProposalMaterialNoPlant: Proposal;
  deleteProposalPlantProduct: Proposal;
  deleteProposalProduct: ProposalStage;
  deleteProposalProductProjectFile?: Maybe<Scalars['Boolean']>;
  deleteProposalRecipient: Scalars['Boolean'];
  deleteProposalStage: Proposal;
  deleteTask?: Maybe<Scalars['Boolean']>;
  deleteTimeBucket: TimeBucket;
  deleteTimeEntry?: Maybe<TimeEntry>;
  deleteTransferTruck?: Maybe<Scalars['Boolean']>;
  deleteUserInvite?: Maybe<Scalars['Boolean']>;
  detectAiMappingRunArea: AiMappingDetectResponse;
  downloadProposal: Proposal;
  duplicateProduct: Product;
  duplicateProposal?: Maybe<DuplicateProposalResponse>;
  duplicateProposalStage: Proposal;
  exportAiMappingRunAreaPdf: AiMappingDetectResponse;
  finalizeLinkedServiceAccount?: Maybe<Scalars['Boolean']>;
  finishRegistration?: Maybe<User>;
  generateOrganizationDataUploadUrl: GenerateUploadOrganizationDocumentUrl;
  generateReport: Scalars['String'];
  generateUploadCompanyLogoUrl: GenerateUploadCompanyLogoUrl;
  generateUploadCustomEventFileUrl: GenerateUploadUrl;
  generateUploadDailyFormWorkOrderFileUrl: GenerateUploadUrl;
  generateUploadJobPhaseCostItemFileUrl: GenerateUploadProposalFileUrl;
  generateUploadOrganizationDocumentUrl: GenerateUploadOrganizationDocumentUrl;
  generateUploadOrganizationLogoUrl: GenerateUploadOrganizationLogoUrl;
  generateUploadProjectFileUrl: GenerateUploadUrl;
  generateUploadProjectMapImageUrl: GenerateUploadProjectMapImageUrl;
  generateUploadProposalFileUrl: GenerateUploadProposalFileUrl;
  getLinkedServiceAuthUrl?: Maybe<Scalars['String']>;
  getReportAdditionalCost: GetReportAdditionalCostResponse;
  getReportCompanyOrClientDetails: GetReportCompanyOrClientDetailsResponse;
  getReportContactDetails: GetReportContactDetailsResponse;
  getReportCrewDetails: GetReportCrewDetailsResponse;
  getReportEquipmentCostDetails: GetReportEquipmentCostDetailsResponse;
  getReportJobCostByProductType: GetReportJobCostByProductTypeResponse;
  getReportJobCostDetail: GetReportJobCostDetailResponse;
  getReportJobDetails: GetReportJobDetailsResponse;
  getReportJobsByContact: GetReportJobsByContactResponse;
  getReportOrganizationProfitability: GetReportOrganizationProfitabilityResponse;
  getReportProductDetails: GetReportProductDetailsResponse;
  getReportProposalDetails: GetReportProposalDetailsResponse;
  getReportSalesByContact: GetReportSalesByContactResponse;
  getReportSalesByProductSummary: GetReportSalesByProductSummaryResponse;
  getReportSalesByProposalSource: GetReportSalesByProposalSourceResponse;
  getReportTimeEntries: GetReportTimeEntriesResponse;
  getYearOverYearRevenueReportExport: Scalars['String'];
  hasScheduledJobPhases: Scalars['Boolean'];
  holdProposal: Proposal;
  inviteUser?: Maybe<Scalars['Boolean']>;
  logActivity: Activity;
  login?: Maybe<LoginResult>;
  logout?: Maybe<Scalars['Boolean']>;
  mergeCompany: Company;
  previewInvoice?: Maybe<Scalars['String']>;
  previewProposal?: Maybe<Scalars['String']>;
  reassignTask?: Maybe<Task>;
  redoAiMappingRunArea: AiMappingRunAreaResultsResponse;
  refreshOrganizationEmailIdentityStatus: OrganizationEmailIdentity;
  register?: Maybe<Scalars['Boolean']>;
  removeTruckFromProposalProduct?: Maybe<Proposal>;
  requestPasswordReset?: Maybe<Scalars['Boolean']>;
  resendUserInvite?: Maybe<Scalars['Boolean']>;
  resendVerificationEmail?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  restoreEmployee: Employee;
  restoreOrganizationUser?: Maybe<User>;
  retryProposalPackageSendRecipients: ProposalPackageSendRun;
  retryQuickbooksTimeExportRunFailedItems: QuickbooksTimeExportRun;
  saveCustomItem: Proposal;
  saveCustomProduct: CustomProduct;
  saveOrganizationEmailIdentity: OrganizationEmailIdentity;
  saveProjectMapImage: ProjectMap;
  saveQuickbooksIncomeAccount?: Maybe<Scalars['Boolean']>;
  saveQuickbooksIntegration: Scalars['Boolean'];
  saveWorksheetItem: Proposal;
  saveWorksheetProduct: WorksheetProduct;
  scheduleCustomEventBlock: CustomEvent;
  scheduleJob: Job;
  scheduleJobPhase: Job;
  scheduleJobPhaseBlock: Job;
  segmentAiMappingRunArea: AiMappingDetectResponse;
  sendInvoice: Scalars['Boolean'];
  sendOrganizationEmailIdentityTestEmail: Scalars['Boolean'];
  sendOrganizationEmailTemplatePreview: Scalars['Boolean'];
  sendProposal: Scalars['Boolean'];
  sendProposalPackage: ProposalPackageSendRun;
  sendProposalToSpecificRecipients: Array<ProposalRecipient>;
  setJobDepositCollected: Job;
  setProposalEstimatingMethod: Proposal;
  setProposalToDraft: Proposal;
  setProposalToWon: Proposal;
  signProposal: PublicProposal;
  startQuickbooksTimeExport: QuickbooksTimeExportRun;
  syncAiMappingCostsToMap: ProjectMap;
  syncProjectMapMeasurements: ProjectMap;
  syncProposalStageMeasurements: ProposalStage;
  syncQuickbooksBatch: QuickbooksSyncBatch;
  /** Send a test request to the configured API URL to verify reachability. */
  testNotificationTriggerApi: WebhookTestResult;
  toggleOrganizationEmailIdentity: OrganizationEmailIdentity;
  toggleProposalProductGroupOptionality: ProposalProductGroup;
  toggleProposalProductOptionality: ProposalProduct;
  undoAiMappingRunArea: AiMappingRunAreaResultsResponse;
  unlinkService?: Maybe<Scalars['Boolean']>;
  unscheduleCustomEvent: CustomEvent;
  unscheduleJobPhase: Job;
  updateAdditionalCost: AdditionalCost;
  updateAiMappingDetection: AiMappingRunAreaResultsResponse;
  updateAiMappingSegmentation: AiMappingRunAreaResultsResponse;
  updateCompany?: Maybe<Company>;
  updateCompanyNotes: Company;
  updateCompanyProjectFileFolderId: Company;
  updateCrew: Crew;
  updateCustomEvent?: Maybe<CustomEvent>;
  updateCustomLibraryProduct: CustomProduct;
  updateDailyFormInspection: DailyFormInspection;
  updateDailyFormInspectionQuestion: DailyFormInspectionQuestion;
  updateDailyFormVehicle: DailyFormVehicle;
  updateDailyFormVehiclePart: DailyFormVehiclePart;
  updateDailyFormVehicleServicePlan: DailyFormVehicleServicePlan;
  updateDailyFormVehicleType: DailyFormVehicleType;
  updateDailyFormWorkOrder: DailyFormWorkOrder;
  updateDailyFormWorkOrderStatus: DailyFormWorkOrder;
  updateEmployee: Employee;
  updateEquipmentPiece: EquipmentPiece;
  updateJobBillingStatus: Job;
  updateJobChecklistItems: Job;
  updateJobExternalId: Job;
  updateJobNotes?: Maybe<Job>;
  updateJobPhaseChecklistItems: JobPhase;
  updateJobPhaseCosting: JobPhase;
  updateJobPhaseNotes: JobPhase;
  updateJobPhaseStatus: JobPhase;
  updateJobProjectFileFolderId: Job;
  updateJobProjectManager: Job;
  updateJobStatus: Job;
  updateNotificationTrigger?: Maybe<NotificationTrigger>;
  updateOpportunity: Opportunity;
  updateOpportunityStatus: Opportunity;
  updateOpportunityStatusesOrdering: Array<OrganizationOpportunityStatus>;
  updateOrganization: Organization;
  updateOrganizationAddress?: Maybe<OrganizationAddress>;
  updateOrganizationAddressPrimary?: Maybe<Scalars['Boolean']>;
  updateOrganizationConversionFactorOverride: OrganizationConversionFactorOverride;
  updateOrganizationEmailTemplate?: Maybe<Scalars['Boolean']>;
  updateOrganizationInvoiceEmailText: Organization;
  updateOrganizationInvoicingPaymentTermsNet: Organization;
  updateOrganizationProductType?: Maybe<OrganizationProductType>;
  updateOrganizationProposalChecklistItem: OrganizationProposalChecklistItem;
  updateOrganizationProposalContent: OrganizationProposalContent;
  updateOrganizationProposalDefaults: ProposalDefault;
  updateOrganizationProposalLayoutContentSettings: Array<OrganizationProposalLayoutContentSetting>;
  updateOrganizationProposalSentEmailText: Organization;
  updateOrganizationSalesTaxes: Organization;
  updateOrganizationSettings: Scalars['Boolean'];
  updateOrganizationUser?: Maybe<User>;
  updatePlant?: Maybe<Plant>;
  updateProduct: Product;
  updateProductGroup: ProductGroup;
  updateProjectMap: ProjectMap;
  updateProposal: Proposal;
  updateProposalAddress?: Maybe<ProposalAddress>;
  updateProposalContentSettings: Proposal;
  updateProposalDiscount: Proposal;
  updateProposalInfo: Proposal;
  updateProposalPlantProduct: Proposal;
  updateProposalProduct: Proposal;
  updateProposalProductDiscount: Proposal;
  updateProposalProductOverrides: Proposal;
  updateProposalProductProjectFiles: ProposalProduct;
  updateProposalSalesTaxes: Proposal;
  updateProposalStage: ProposalStage;
  updateProposalStageAddressAndClearProducts: Proposal;
  updateProposalStagesOrdering: Proposal;
  updateRolesWithPermissions?: Maybe<RolesWithPermissions>;
  updateStageProductsOrdering: ProposalStage;
  updateTimeBucket: TimeBucket;
  updateTimeEntry: TimeEntry;
  updateTransferTruck?: Maybe<TransferTruck>;
  updateWorkOrderItems?: Maybe<JobPhase>;
  updateWorksheetSettings: WorksheetSettings;
  validateRegistrationToken?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateOrganizationApiKeyArgs = {
  description: Scalars['String'];
};


export type MutationDeleteOrganizationApiKeyArgs = {
  id: Scalars['ID'];
};


export type MutationAcceptUserInviteArgs = {
  input: AcceptUserInviteInput;
};


export type MutationAddJobPhaseCostsArgs = {
  input: AddJobPhaseCostsInput;
};


export type MutationAddJobPhaseFileArgs = {
  jobPhaseId: Scalars['ID'];
  path: Scalars['String'];
};


export type MutationAddMaterialNoPlantToProposalProductArgs = {
  input: AddMaterialNoPlantToProposalProductInput;
};


export type MutationAddOrganizationDataUploadArgs = {
  input: AddOrganizationDataUploadInput;
};


export type MutationAddOrganizationDocumentArgs = {
  name: Scalars['String'];
  path: Scalars['String'];
};


export type MutationAddPlantProductToProposalProductArgs = {
  input: AddPlantProductToProposalProductInput;
};


export type MutationAddProductsToProposalStageArgs = {
  input: AddProductsToProposalStageInput;
};


export type MutationAddProjectFileArgs = {
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['ID']>;
  path: Scalars['String'];
};


export type MutationAddProposalAdditionalCostArgs = {
  additionalCostId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalAdditionalCostsArgs = {
  additionalCosts: Array<Scalars['ID']>;
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalAddressArgs = {
  input: AddProposalAddressInput;
};


export type MutationAddProposalCrewArgs = {
  crewId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalCrewsArgs = {
  crewIds: Array<Scalars['ID']>;
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalEquipmentPieceArgs = {
  equipmentPieceId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Float'];
};


export type MutationAddProposalEquipmentPiecesArgs = {
  equipmentPieces: Array<AddProposalEquipmentPieceInput>;
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalFileArgs = {
  path: Scalars['String'];
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalStageArgs = {
  proposalId: Scalars['ID'];
};


export type MutationAddProposalStageChecklistItemsArgs = {
  input: AddProposalStageChecklistItemsInput;
};


export type MutationAddTruckToProposalProductArgs = {
  input: AddTruckToProposalProductInput;
};


export type MutationAppLoginArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  input: LoginInput;
};


export type MutationApplyAiMappingAdditionalCostsArgs = {
  input: ApplyAiMappingAdditionalCostsInput;
};


export type MutationApplyProposalStageMeasurementsArgs = {
  input: ApplyProposalStageMeasurementsInput;
};


export type MutationArchiveCompanyArgs = {
  id: Scalars['ID'];
};


export type MutationArchiveCustomProductArgs = {
  id: Scalars['ID'];
};


export type MutationArchiveEmployeeArgs = {
  id: Scalars['ID'];
};


export type MutationArchiveWorksheetProductArgs = {
  id: Scalars['ID'];
};


export type MutationCancelAiMappingTaskArgs = {
  taskId: Scalars['String'];
};


export type MutationCancelOpportunityArgs = {
  id: Scalars['ID'];
};


export type MutationCancelProposalArgs = {
  duplicate: Scalars['Boolean'];
  id: Scalars['ID'];
  maintainCurrentId?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCloseProposalArgs = {
  id: Scalars['ID'];
};


export type MutationCompleteTaskArgs = {
  id: Scalars['ID'];
};


export type MutationCopyProposalProductToStageArgs = {
  proposalProductId: Scalars['ID'];
  targetStageId: Scalars['ID'];
};


export type MutationCreateAdditionalCostArgs = {
  input: CreateAdditionalCostInput;
};


export type MutationCreateAiMappingDetectionArgs = {
  input: CreateAiMappingDetectionInput;
};


export type MutationCreateAiMappingRunArgs = {
  projectMapId: Scalars['ID'];
};


export type MutationCreateAiMappingRunAreaArgs = {
  input: CreateAiMappingRunAreaInput;
};


export type MutationCreateAiMappingSegmentationArgs = {
  input: CreateAiMappingSegmentationInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCrewArgs = {
  input: CreateCrewInput;
};


export type MutationCreateCustomEventArgs = {
  input?: InputMaybe<CreateCustomEventInput>;
};


export type MutationCreateDailyFormInspectionArgs = {
  input: CreateDailyFormInspectionInput;
};


export type MutationCreateDailyFormInspectionQuestionArgs = {
  input: CreateDailyFormInspectionQuestionInput;
};


export type MutationCreateDailyFormVehicleArgs = {
  input: CreateDailyFormVehicleInput;
};


export type MutationCreateDailyFormVehiclePartArgs = {
  input: CreateDailyFormVehiclePartInput;
};


export type MutationCreateDailyFormVehicleServicePlanArgs = {
  input: CreateDailyFormVehicleServicePlanInput;
};


export type MutationCreateDailyFormVehicleTypeArgs = {
  name: Scalars['String'];
};


export type MutationCreateDailyFormWorkOrderArgs = {
  input: CreateDailyFormWorkOrderInput;
};


export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};


export type MutationCreateEquipmentPieceArgs = {
  input: CreateEquipmentPieceInput;
};


export type MutationCreateJobInvoiceOnLinkedServiceArgs = {
  createEstimate?: InputMaybe<Scalars['Boolean']>;
  createInvoice?: InputMaybe<Scalars['Boolean']>;
  createJob?: InputMaybe<Scalars['Boolean']>;
  jobId: Scalars['ID'];
  service: OrganizationLinkedServiceName;
};


export type MutationCreateNotificationTriggerArgs = {
  input: CreateNotificationTriggerInput;
};


export type MutationCreateOpportunityArgs = {
  input: CreateOpportunityInput;
};


export type MutationCreateOpportunityStatusArgs = {
  name: Scalars['String'];
};


export type MutationCreateOrganizationAddressArgs = {
  input: CreateOrganizationAddressInput;
};


export type MutationCreateOrganizationCustomContentTypeArgs = {
  input: CreateCustomContentTypeInput;
};


export type MutationCreateOrganizationProductTypeArgs = {
  input: CreateOrganizationProductTypeInput;
};


export type MutationCreateOrganizationProposalChecklistItemArgs = {
  name: Scalars['String'];
};


export type MutationCreatePlantArgs = {
  input: CreatePlantInput;
};


export type MutationCreatePlantProductTypeArgs = {
  name: Scalars['String'];
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductGroupArgs = {
  input: CreateProductGroupInput;
};


export type MutationCreateProjectFileFolderArgs = {
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateProjectMapArgs = {
  input: CreateProjectMapInput;
};


export type MutationCreateProposalArgs = {
  closeConfidence?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  projectedCloseDate?: InputMaybe<Scalars['Date']>;
  source?: InputMaybe<ProposalSource>;
};


export type MutationCreateProposalFromOpportunityArgs = {
  id: Scalars['ID'];
};


export type MutationCreateProposalFromProjectMapArgs = {
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  projectMapId: Scalars['ID'];
  stageName?: InputMaybe<Scalars['String']>;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTimeBucketArgs = {
  input: CreateTimeBucketInput;
};


export type MutationCreateTimeEntryArgs = {
  input: CreateTimeEntryInput;
};


export type MutationCreateTransferTruckArgs = {
  input: CreateTransferTruckInput;
};


export type MutationDeleteAdditionalCostArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAiMappingDetectionArgs = {
  detectionId: Scalars['ID'];
  runAreaId: Scalars['ID'];
};


export type MutationDeleteAiMappingSegmentationArgs = {
  runAreaId: Scalars['ID'];
  segmentationId: Scalars['ID'];
};


export type MutationDeleteCrewArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCustomEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyFormInspectionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyFormInspectionQuestionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyFormVehicleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyFormVehiclePartArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyFormVehicleServicePlanArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyFormVehicleTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyFormWorkOrderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEmployeeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEquipmentPieceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteJobPhaseCostArgs = {
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
};


export type MutationDeleteJobPhaseFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNotificationTriggerArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOpportunityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationAddressArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationCustomContentTypeArgs = {
  contentType: Scalars['String'];
};


export type MutationDeleteOrganizationDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationProductTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationProposalChecklistItemArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationUserArgs = {
  id: Scalars['ID'];
  openProposalAction: DeleteOpenProposalAction;
  reassignJobPhaseForemanUserId?: InputMaybe<Scalars['ID']>;
  reassignJobUserId?: InputMaybe<Scalars['ID']>;
  reassignUserId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeletePlantArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProjectFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProjectMapArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalMapImageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalMaterialNoPlantArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalPlantProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalProductProjectFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalRecipientArgs = {
  email: Scalars['String'];
  proposalId: Scalars['ID'];
};


export type MutationDeleteProposalStageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTimeBucketArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTimeEntryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTransferTruckArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserInviteArgs = {
  id: Scalars['ID'];
};


export type MutationDetectAiMappingRunAreaArgs = {
  id: Scalars['ID'];
};


export type MutationDownloadProposalArgs = {
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDuplicateProductArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicateProposalArgs = {
  changeOrderJobId?: InputMaybe<Scalars['ID']>;
  changeOrderProposalType?: InputMaybe<ChangeOrderProposalType>;
  changeOrderScheduledJobsAction?: InputMaybe<ChangeOrderScheduledJobsAction>;
  createNewVersion?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isChangeOrder?: InputMaybe<Scalars['Boolean']>;
  startNewProposal?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDuplicateProposalStageArgs = {
  id: Scalars['ID'];
};


export type MutationExportAiMappingRunAreaPdfArgs = {
  id: Scalars['ID'];
  includeAnnotations?: InputMaybe<Scalars['Boolean']>;
  includeCounts?: InputMaybe<Scalars['Boolean']>;
};


export type MutationFinalizeLinkedServiceAccountArgs = {
  code?: InputMaybe<Scalars['String']>;
  realmId?: InputMaybe<Scalars['String']>;
  service: OrganizationLinkedServiceName;
  state?: InputMaybe<Scalars['String']>;
};


export type MutationFinishRegistrationArgs = {
  input: FinishRegistrationInput;
};


export type MutationGenerateOrganizationDataUploadUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateReportArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  estimatorId?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  productTypeId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  type: ReportType;
  wonAt?: InputMaybe<Scalars['Boolean']>;
};


export type MutationGenerateUploadCompanyLogoUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateUploadCustomEventFileUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateUploadDailyFormWorkOrderFileUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateUploadJobPhaseCostItemFileUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
  jobPhaseId: Scalars['ID'];
};


export type MutationGenerateUploadOrganizationDocumentUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateUploadOrganizationLogoUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateUploadProjectFileUrlArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
};


export type MutationGenerateUploadProjectMapImageUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
  projectMapId: Scalars['ID'];
};


export type MutationGenerateUploadProposalFileUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
  proposalProductId: Scalars['ID'];
};


export type MutationGetLinkedServiceAuthUrlArgs = {
  service: OrganizationLinkedServiceName;
};


export type MutationGetReportAdditionalCostArgs = {
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportCompanyOrClientDetailsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportContactDetailsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type MutationGetReportCrewDetailsArgs = {
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportEquipmentCostDetailsArgs = {
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportJobCostByProductTypeArgs = {
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  jobId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportJobCostDetailArgs = {
  jobId: Scalars['String'];
};


export type MutationGetReportJobDetailsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  jobId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportJobsByContactArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportOrganizationProfitabilityArgs = {
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  productTypeId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportProductDetailsArgs = {
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportProposalDetailsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  estimatorId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  productTypeId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status?: InputMaybe<Scalars['String']>;
  wonAt?: InputMaybe<Scalars['Boolean']>;
};


export type MutationGetReportSalesByContactArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportSalesByProductSummaryArgs = {
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportSalesByProposalSourceArgs = {
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationGetReportTimeEntriesArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type MutationHasScheduledJobPhasesArgs = {
  jobId: Scalars['ID'];
};


export type MutationHoldProposalArgs = {
  id: Scalars['ID'];
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationLogActivityArgs = {
  input: LogActivityInput;
};


export type MutationLoginArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  input: LoginInput;
};


export type MutationMergeCompanyArgs = {
  sourceCompany: Scalars['ID'];
  targetCompany: Scalars['ID'];
};


export type MutationPreviewInvoiceArgs = {
  data?: InputMaybe<Scalars['String']>;
  hideLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationPreviewProposalArgs = {
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  contentSettings?: InputMaybe<UpdateProposalContentSettingsHasManyInput>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
};


export type MutationReassignTaskArgs = {
  input: ReassignTaskInput;
};


export type MutationRedoAiMappingRunAreaArgs = {
  id: Scalars['ID'];
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRemoveTruckFromProposalProductArgs = {
  id: Scalars['ID'];
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationResendUserInviteArgs = {
  id: Scalars['ID'];
};


export type MutationResendVerificationEmailArgs = {
  input: ResendVerificationEmailInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRestoreEmployeeArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreOrganizationUserArgs = {
  id: Scalars['ID'];
};


export type MutationRetryProposalPackageSendRecipientsArgs = {
  runId: Scalars['ID'];
};


export type MutationRetryQuickbooksTimeExportRunFailedItemsArgs = {
  runId: Scalars['ID'];
};


export type MutationSaveCustomItemArgs = {
  discount?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  input: CustomInput;
  stageId: Scalars['ID'];
};


export type MutationSaveCustomProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: CustomInput;
  productTypeId: Scalars['ID'];
};


export type MutationSaveOrganizationEmailIdentityArgs = {
  input: SaveOrganizationEmailIdentityInput;
};


export type MutationSaveProjectMapImageArgs = {
  path: Scalars['String'];
  projectMapId: Scalars['ID'];
};


export type MutationSaveQuickbooksIncomeAccountArgs = {
  id: Scalars['ID'];
};


export type MutationSaveQuickbooksIntegrationArgs = {
  input: QuickbooksIntegrationInput;
};


export type MutationSaveWorksheetItemArgs = {
  discount?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  input: WorksheetInput;
  stageId: Scalars['ID'];
};


export type MutationSaveWorksheetProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: WorksheetInput;
  productTypeId: Scalars['ID'];
};


export type MutationScheduleCustomEventBlockArgs = {
  input: ScheduleCustomEventBlockInput;
};


export type MutationScheduleJobArgs = {
  input: ScheduleJobInput;
};


export type MutationScheduleJobPhaseArgs = {
  blocks: Array<InputMaybe<AddJobPhaseScheduleBlock>>;
  crewId?: InputMaybe<Scalars['ID']>;
  jobPhaseId: Scalars['ID'];
  travelTimeEstimate?: InputMaybe<Scalars['Float']>;
  userIDs?: InputMaybe<Array<Scalars['ID']>>;
  usersColor?: InputMaybe<Scalars['String']>;
};


export type MutationScheduleJobPhaseBlockArgs = {
  input: ScheduleJobPhaseBlockInput;
};


export type MutationSegmentAiMappingRunAreaArgs = {
  id: Scalars['ID'];
  minSegAreaSqft?: InputMaybe<Scalars['Float']>;
  minSegConf?: InputMaybe<Scalars['Float']>;
};


export type MutationSendInvoiceArgs = {
  data?: InputMaybe<Scalars['String']>;
  hideLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationSendOrganizationEmailTemplatePreviewArgs = {
  html: Scalars['String'];
};


export type MutationSendProposalArgs = {
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  contentSettings?: InputMaybe<UpdateProposalContentSettingsHasManyInput>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  proposalNotes?: InputMaybe<Scalars['String']>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSendProposalPackageArgs = {
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  contentSettings?: InputMaybe<UpdateProposalContentSettingsHasManyInput>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<ProposalLayout>;
  proposalId: Scalars['ID'];
  proposalNotes?: InputMaybe<Scalars['String']>;
  recipients: Array<ProposalPackageRecipientInput>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSendProposalToSpecificRecipientsArgs = {
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  emails: Array<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetJobDepositCollectedArgs = {
  collected?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationSetProposalEstimatingMethodArgs = {
  id: Scalars['ID'];
  method: Scalars['String'];
};


export type MutationSetProposalToDraftArgs = {
  id: Scalars['ID'];
};


export type MutationSetProposalToWonArgs = {
  forceSend?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationSignProposalArgs = {
  email: Scalars['String'];
  removeProducts?: InputMaybe<Array<Scalars['String']>>;
  signature: Scalars['String'];
  signeeInitials: Scalars['String'];
  signeeName: Scalars['String'];
  signeeTitle: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationStartQuickbooksTimeExportArgs = {
  endDate: Scalars['Date'];
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationSyncAiMappingCostsToMapArgs = {
  input: SyncAiMappingCostsToMapInput;
};


export type MutationSyncProjectMapMeasurementsArgs = {
  input: SyncProjectMapMeasurementsInput;
};


export type MutationSyncProposalStageMeasurementsArgs = {
  input: SyncProposalStageMeasurementsInput;
};


export type MutationSyncQuickbooksBatchArgs = {
  input: SyncQuickbooksBatchInput;
};


export type MutationTestNotificationTriggerApiArgs = {
  triggerId: Scalars['ID'];
};


export type MutationToggleOrganizationEmailIdentityArgs = {
  enabled: Scalars['Boolean'];
};


export type MutationToggleProposalProductGroupOptionalityArgs = {
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
};


export type MutationToggleProposalProductOptionalityArgs = {
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
};


export type MutationUndoAiMappingRunAreaArgs = {
  id: Scalars['ID'];
};


export type MutationUnlinkServiceArgs = {
  service: OrganizationLinkedServiceName;
};


export type MutationUnscheduleCustomEventArgs = {
  id: Scalars['ID'];
};


export type MutationUnscheduleJobPhaseArgs = {
  jobPhaseId: Scalars['ID'];
};


export type MutationUpdateAdditionalCostArgs = {
  input: UpdateAdditionalCostInput;
};


export type MutationUpdateAiMappingDetectionArgs = {
  input: UpdateAiMappingDetectionInput;
};


export type MutationUpdateAiMappingSegmentationArgs = {
  input: UpdateAiMappingSegmentationInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyNotesArgs = {
  input: UpdateCompanyNotesInput;
};


export type MutationUpdateCompanyProjectFileFolderIdArgs = {
  id: Scalars['ID'];
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateCrewArgs = {
  input: UpdateCrewInput;
};


export type MutationUpdateCustomEventArgs = {
  input?: InputMaybe<UpdateCustomEventInput>;
};


export type MutationUpdateCustomLibraryProductArgs = {
  expectedRevision: Scalars['String'];
  id: Scalars['ID'];
  input: CustomInput;
};


export type MutationUpdateDailyFormInspectionArgs = {
  input: UpdateDailyFormInspectionInput;
};


export type MutationUpdateDailyFormInspectionQuestionArgs = {
  input: UpdateDailyFormInspectionQuestionInput;
};


export type MutationUpdateDailyFormVehicleArgs = {
  input: UpdateDailyFormVehicleInput;
};


export type MutationUpdateDailyFormVehiclePartArgs = {
  input: UpdateDailyFormVehiclePartInput;
};


export type MutationUpdateDailyFormVehicleServicePlanArgs = {
  input: UpdateDailyFormVehicleServicePlanInput;
};


export type MutationUpdateDailyFormVehicleTypeArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateDailyFormWorkOrderArgs = {
  input: UpdateDailyFormWorkOrderInput;
};


export type MutationUpdateDailyFormWorkOrderStatusArgs = {
  input: UpdateDailyFormWorkOrderStatusInput;
};


export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput;
};


export type MutationUpdateEquipmentPieceArgs = {
  input: UpdateEquipmentPieceInput;
};


export type MutationUpdateJobBillingStatusArgs = {
  billingStatus: JobBillingStatus;
  id: Scalars['ID'];
};


export type MutationUpdateJobChecklistItemsArgs = {
  input: UpdateJobChecklistItemsInput;
};


export type MutationUpdateJobExternalIdArgs = {
  externalId: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationUpdateJobNotesArgs = {
  id: Scalars['ID'];
  notes: Scalars['String'];
};


export type MutationUpdateJobPhaseChecklistItemsArgs = {
  input: UpdateJobPhaseChecklistItemsInput;
};


export type MutationUpdateJobPhaseCostingArgs = {
  input: UpdateJobPhaseCostingInput;
};


export type MutationUpdateJobPhaseNotesArgs = {
  input: UpdateJobPhaseNotesInput;
};


export type MutationUpdateJobPhaseStatusArgs = {
  id: Scalars['ID'];
  status: JobPhaseStatus;
};


export type MutationUpdateJobProjectFileFolderIdArgs = {
  id: Scalars['ID'];
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateJobProjectManagerArgs = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUpdateJobStatusArgs = {
  id: Scalars['ID'];
  status: JobStatus;
};


export type MutationUpdateNotificationTriggerArgs = {
  input: UpdateNotificationTriggerInput;
};


export type MutationUpdateOpportunityArgs = {
  input: UpdateOpportunityInput;
};


export type MutationUpdateOpportunityStatusArgs = {
  id: Scalars['ID'];
  statusId: Scalars['ID'];
};


export type MutationUpdateOpportunityStatusesOrderingArgs = {
  statuses: Array<OpportunityStatusOrderingInput>;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationAddressArgs = {
  input: UpdateOrganizationAddressInput;
};


export type MutationUpdateOrganizationAddressPrimaryArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateOrganizationConversionFactorOverrideArgs = {
  input: UpdateOrganizationConversionFactorOverrideInput;
};


export type MutationUpdateOrganizationEmailTemplateArgs = {
  html?: InputMaybe<Scalars['String']>;
  type: OrganizationEmailTemplateType;
};


export type MutationUpdateOrganizationInvoiceEmailTextArgs = {
  id: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationUpdateOrganizationInvoicingPaymentTermsNetArgs = {
  id: Scalars['ID'];
  invoicingPaymentTermsNet: Scalars['Int'];
};


export type MutationUpdateOrganizationProductTypeArgs = {
  input: UpdateOrganizationProductTypeInput;
};


export type MutationUpdateOrganizationProposalChecklistItemArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateOrganizationProposalContentArgs = {
  content: Scalars['String'];
  type: Scalars['String'];
};


export type MutationUpdateOrganizationProposalDefaultsArgs = {
  input: UpdateOrganizationProposalDefaultsInput;
};


export type MutationUpdateOrganizationProposalLayoutContentSettingsArgs = {
  items: Array<UpdateProposalLayoutContentSettingItemInput>;
};


export type MutationUpdateOrganizationProposalSentEmailTextArgs = {
  id: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationUpdateOrganizationSalesTaxesArgs = {
  input: UpdateOrganizationSalesTaxesInput;
};


export type MutationUpdateOrganizationSettingsArgs = {
  settings: Array<UpdateOrganizationSettingsInput>;
};


export type MutationUpdateOrganizationUserArgs = {
  input: UpdateOrganizationUserInput;
};


export type MutationUpdatePlantArgs = {
  input: UpdatePlantInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductGroupArgs = {
  input: UpdateProductGroupInput;
};


export type MutationUpdateProjectMapArgs = {
  input: UpdateProjectMapInput;
};


export type MutationUpdateProposalArgs = {
  closeConfidence?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  id: Scalars['ID'];
  projectedCloseDate?: InputMaybe<Scalars['Date']>;
  source?: InputMaybe<ProposalSource>;
};


export type MutationUpdateProposalAddressArgs = {
  input: UpdateProposalAddress;
};


export type MutationUpdateProposalContentSettingsArgs = {
  contentSettings: UpdateProposalContentSettingsHasManyInput;
  id: Scalars['ID'];
};


export type MutationUpdateProposalDiscountArgs = {
  input: UpdateProposalDiscountInput;
};


export type MutationUpdateProposalInfoArgs = {
  input?: InputMaybe<UpdateProposalInfoInput>;
};


export type MutationUpdateProposalPlantProductArgs = {
  applicationRateOverride?: InputMaybe<Scalars['Float']>;
  materialNeededOverride?: InputMaybe<Scalars['Float']>;
  plantProductId: Scalars['ID'];
  proposalPlantProductId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
};


export type MutationUpdateProposalProductArgs = {
  input: UpdateProposalProductInput;
};


export type MutationUpdateProposalProductDiscountArgs = {
  input: UpdateProposalProductDiscountInput;
};


export type MutationUpdateProposalProductOverridesArgs = {
  externalProductName?: InputMaybe<Scalars['String']>;
  jobSize?: InputMaybe<Scalars['Int']>;
  overallTotalOverride?: InputMaybe<Scalars['Int']>;
  profitOverride?: InputMaybe<Scalars['Int']>;
  profitPercentageOverride?: InputMaybe<Scalars['Int']>;
  proposalProductId: Scalars['ID'];
  unitPriceOverride?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateProposalProductProjectFilesArgs = {
  projectFileIds: Array<Scalars['ID']>;
  proposalProductId: Scalars['ID'];
};


export type MutationUpdateProposalSalesTaxesArgs = {
  input?: InputMaybe<UpdateProposalSalesTaxesInput>;
};


export type MutationUpdateProposalStageArgs = {
  addressOverride?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mapData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProposalStageAddressAndClearProductsArgs = {
  input: UpdateProposalStageAddressAndClearProductsInput;
};


export type MutationUpdateProposalStagesOrderingArgs = {
  input: UpdateProposalStagesOrdering;
};


export type MutationUpdateRolesWithPermissionsArgs = {
  input?: InputMaybe<UpdateRolesWithPermissionsInput>;
};


export type MutationUpdateStageProductsOrderingArgs = {
  input: UpdateProposalProductsOrderingInput;
};


export type MutationUpdateTimeBucketArgs = {
  input: UpdateTimeBucketInput;
};


export type MutationUpdateTimeEntryArgs = {
  input: UpdateTimeEntryInput;
};


export type MutationUpdateTransferTruckArgs = {
  input: UpdateTransferTruckInput;
};


export type MutationUpdateWorkOrderItemsArgs = {
  input: UpdateWorkOrderItemsInput;
};


export type MutationUpdateWorksheetSettingsArgs = {
  markup: Scalars['String'];
  method: Scalars['String'];
};


export type MutationValidateRegistrationTokenArgs = {
  input: ValidateRegistrationTokenInput;
};

export type NotificationTrigger = {
  __typename?: 'NotificationTrigger';
  active: Scalars['Boolean'];
  additionalRecipientTypes?: Maybe<Array<NotificationTriggerAdditionalRecipientTypes | `${NotificationTriggerAdditionalRecipientTypes}`>>;
  additionalRecipients: Array<NotificationTriggerRecipient>;
  apiHeaders?: Maybe<Scalars['String']>;
  apiMethod?: Maybe<Scalars['String']>;
  apiPayload?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  apiUrl?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  delay: Scalars['Int'];
  emailSubject?: Maybe<Scalars['String']>;
  event: NotificationTriggerEvent | `${NotificationTriggerEvent}`;
  id: Scalars['ID'];
  isApi?: Maybe<Scalars['Boolean']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  isSMS?: Maybe<Scalars['Boolean']>;
  isTask?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organization: Organization;
  sendToAllRecipients: Scalars['Boolean'];
  sendToContact: Scalars['Boolean'];
  sendToUser: Scalars['Boolean'];
  smsContent?: Maybe<Scalars['String']>;
  taskContent?: Maybe<Scalars['String']>;
  type: NotificationTriggerType | `${NotificationTriggerType}`;
};

export enum NotificationTriggerAdditionalRecipientTypes {
  /** Foreman */
  FOREMAN = 'FOREMAN'
}

export enum NotificationTriggerEvent {
  /** Before job phase starts */
  BEFORE_JOB_PHASE_STARTS = 'BEFORE_JOB_PHASE_STARTS',
  /** Before job starts */
  BEFORE_JOB_STARTS = 'BEFORE_JOB_STARTS',
  /** Contact created */
  CONTACT_CREATED = 'CONTACT_CREATED',
  /** Contact updated */
  CONTACT_UPDATED = 'CONTACT_UPDATED',
  /** Job completed */
  JOB_COMPLETED = 'JOB_COMPLETED',
  /** Job created */
  JOB_CREATED = 'JOB_CREATED',
  /** Job in progress */
  JOB_IN_PROGRESS = 'JOB_IN_PROGRESS',
  /** Job job costing */
  JOB_JOB_COSTING = 'JOB_JOB_COSTING',
  /** Job phase completed */
  JOB_PHASE_COMPLETED = 'JOB_PHASE_COMPLETED',
  /** Job phase done without costs */
  JOB_PHASE_DONE_WITHOUT_COSTS = 'JOB_PHASE_DONE_WITHOUT_COSTS',
  /** Job phase in progress */
  JOB_PHASE_IN_PROGRESS = 'JOB_PHASE_IN_PROGRESS',
  /** Job phase job costing */
  JOB_PHASE_JOB_COSTING = 'JOB_PHASE_JOB_COSTING',
  /** Job phase ready to bill */
  JOB_PHASE_READY_TO_BILL = 'JOB_PHASE_READY_TO_BILL',
  /** Job phase rescheduled */
  JOB_PHASE_RESCHEDULED = 'JOB_PHASE_RESCHEDULED',
  /** Job phase scheduled */
  JOB_PHASE_SCHEDULED = 'JOB_PHASE_SCHEDULED',
  /** Job phase work complete */
  JOB_PHASE_WORK_COMPLETE = 'JOB_PHASE_WORK_COMPLETE',
  /** Job ready to bill */
  JOB_READY_TO_BILL = 'JOB_READY_TO_BILL',
  /** Job rescheduled */
  JOB_RESCHEDULED = 'JOB_RESCHEDULED',
  /** Job scheduled */
  JOB_SCHEDULED = 'JOB_SCHEDULED',
  /** Job started */
  JOB_STARTED = 'JOB_STARTED',
  /** Job work complete */
  JOB_WORK_COMPLETE = 'JOB_WORK_COMPLETE',
  /** Opportunity created */
  OPPORTUNITY_CREATED = 'OPPORTUNITY_CREATED',
  /** Proposal canceled */
  PROPOSAL_CANCELED = 'PROPOSAL_CANCELED',
  /** Proposal draft not sent */
  PROPOSAL_DRAFT_NOT_SENT = 'PROPOSAL_DRAFT_NOT_SENT',
  /** Proposal email clicked */
  PROPOSAL_EMAIL_CLICKED = 'PROPOSAL_EMAIL_CLICKED',
  /** Proposal email opened */
  PROPOSAL_EMAIL_OPENED = 'PROPOSAL_EMAIL_OPENED',
  /** Proposal lost */
  PROPOSAL_LOST = 'PROPOSAL_LOST',
  /** Proposal reassigned */
  PROPOSAL_REASSIGNED = 'PROPOSAL_REASSIGNED',
  /** Proposal sent */
  PROPOSAL_SENT = 'PROPOSAL_SENT',
  /** Proposal sent not viewed */
  PROPOSAL_SENT_NOT_VIEWED = 'PROPOSAL_SENT_NOT_VIEWED',
  /** Proposal started */
  PROPOSAL_STARTED = 'PROPOSAL_STARTED',
  /** Proposal status changed */
  PROPOSAL_STATUS_CHANGED = 'PROPOSAL_STATUS_CHANGED',
  /** Proposal viewed not signed */
  PROPOSAL_VIEWED_NOT_SIGNED = 'PROPOSAL_VIEWED_NOT_SIGNED',
  /** Proposal won */
  PROPOSAL_WON = 'PROPOSAL_WON'
}

export type NotificationTriggerRecipient = {
  __typename?: 'NotificationTriggerRecipient';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  isTask?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  taskContent?: Maybe<Scalars['String']>;
};

export enum NotificationTriggerType {
  /** Contact */
  CONTACT = 'CONTACT',
  /** Job */
  JOB = 'JOB',
  /** Job phase */
  JOB_PHASE = 'JOB_PHASE',
  /** Opportunity */
  OPPORTUNITY = 'OPPORTUNITY',
  /** Proposal */
  PROPOSAL = 'PROPOSAL'
}

export type NotificationTypeInput = {
  CONTACT?: InputMaybe<Scalars['Boolean']>;
  JOB?: InputMaybe<Scalars['Boolean']>;
  JOB_PHASE?: InputMaybe<Scalars['Boolean']>;
  OPPORTUNITY?: InputMaybe<Scalars['Boolean']>;
  PROPOSAL?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationTypeOptions = {
  __typename?: 'NotificationTypeOptions';
  CONTACT?: Maybe<Scalars['Boolean']>;
  JOB?: Maybe<Scalars['Boolean']>;
  JOB_PHASE?: Maybe<Scalars['Boolean']>;
  OPPORTUNITY?: Maybe<Scalars['Boolean']>;
  PROPOSAL?: Maybe<Scalars['Boolean']>;
};

export type Opportunity = {
  __typename?: 'Opportunity';
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  company: Company;
  companyId: Scalars['ID'];
  contact: Contact;
  contactId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  dueAt?: Maybe<Scalars['Date']>;
  estimatedOpportunityValue?: Maybe<Scalars['Float']>;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  products?: Maybe<Array<OrganizationProductType>>;
  projectFilesFolderId?: Maybe<Scalars['ID']>;
  source?: Maybe<OpportunitySource | `${OpportunitySource}`>;
  status: Scalars['String'];
  statusId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export enum OpportunitySource {
  /** Advertisements */
  ADVERTISEMENTS = 'ADVERTISEMENTS',
  /** Channel sales */
  CHANNEL_SALES = 'CHANNEL_SALES',
  /** Existing relationship */
  EXISTING_RELATIONSHIP = 'EXISTING_RELATIONSHIP',
  /** Expo lead */
  EXPO_LEAD = 'EXPO_LEAD',
  /** External sales */
  EXTERNAL_SALES = 'EXTERNAL_SALES',
  /** Internal sales */
  INTERNAL_SALES = 'INTERNAL_SALES',
  /** Online */
  ONLINE = 'ONLINE',
  /** Other */
  OTHER = 'OTHER',
  /** Referral */
  REFERRAL = 'REFERRAL',
  /** Repeat customer */
  REPEAT_CUSTOMER = 'REPEAT_CUSTOMER',
  /** Social media */
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  /** Trade shows */
  TRADE_SHOWS = 'TRADE_SHOWS',
  /** Website lead */
  WEBSITE_LEAD = 'WEBSITE_LEAD',
  /** Website request */
  WEBSITE_REQUEST = 'WEBSITE_REQUEST'
}

export enum OpportunityStatus {
  /** Canceled */
  CANCELED = 'CANCELED',
  /** Closed lost */
  CLOSED_LOST = 'CLOSED_LOST',
  /** Closed won */
  CLOSED_WON = 'CLOSED_WON',
  /** Open */
  OPEN = 'OPEN',
  /** Proposal created */
  PROPOSAL_CREATED = 'PROPOSAL_CREATED',
  /** Unassigned */
  UNASSIGNED = 'UNASSIGNED'
}

export type OpportunityStatusOrderingInput = {
  id: Scalars['ID'];
  ordering: Scalars['Int'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder | `${SortOrder}`;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  COUNT = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  AVG = 'AVG',
  /** Amount of items. */
  COUNT = 'COUNT',
  /** Maximum. */
  MAX = 'MAX',
  /** Minimum. */
  MIN = 'MIN',
  /** Sum. */
  SUM = 'SUM'
}

export type Organization = {
  __typename?: 'Organization';
  /** Whether the organization may use AI mapping (add-on subscription, or trial/subscription while the add-on is not configured). */
  canMapWithAi: Scalars['Boolean'];
  conversionFactorOverride?: Maybe<OrganizationConversionFactorOverride>;
  documents?: Maybe<Array<OrganizationDocument>>;
  email?: Maybe<Scalars['String']>;
  emailTemplate: OrganizationEmailTemplateType | `${OrganizationEmailTemplateType}`;
  failingPayment: Scalars['Boolean'];
  id: Scalars['ID'];
  invoiceEmailText?: Maybe<Scalars['String']>;
  invoicingPaymentTermsNet?: Maybe<Scalars['Int']>;
  linkedServices?: Maybe<Array<OrganizationLinkedService>>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  onTrial?: Maybe<Scalars['Boolean']>;
  organizationSalesGoal?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  proposalDefaults: ProposalDefault;
  proposalSentEmailText?: Maybe<Scalars['String']>;
  salesTaxes?: Maybe<Array<OrganizationSalesTax>>;
  subscribed: Scalars['Boolean'];
  subscription?: Maybe<StripeSubscription>;
  timezone?: Maybe<Scalars['String']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationAddress = {
  __typename?: 'OrganizationAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  latitude: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  longitude: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

/** A paginated list of OrganizationAddress items. */
export type OrganizationAddressPaginator = {
  __typename?: 'OrganizationAddressPaginator';
  /** A list of OrganizationAddress items. */
  data: Array<OrganizationAddress>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OrganizationApiKey = {
  __typename?: 'OrganizationApiKey';
  api_key: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  organizationId: Scalars['String'];
};

export type OrganizationConversionFactorOverride = {
  __typename?: 'OrganizationConversionFactorOverride';
  asphaltTonConversionFactorOverride: Scalars['String'];
  excavateOutTonConversionFactorOverride: Scalars['String'];
  id: Scalars['ID'];
  organization: Organization;
};

export type OrganizationDataUpload = {
  __typename?: 'OrganizationDataUpload';
  createdAt: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organization: Organization;
  path: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: OrganizationDataUploadStatus | `${OrganizationDataUploadStatus}`;
  type: OrganizationDataUploadType | `${OrganizationDataUploadType}`;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
};

/** A paginated list of OrganizationDataUpload items. */
export type OrganizationDataUploadPaginator = {
  __typename?: 'OrganizationDataUploadPaginator';
  /** A list of OrganizationDataUpload items. */
  data: Array<OrganizationDataUpload>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum OrganizationDataUploadStatus {
  /** Errored */
  ERRORED = 'ERRORED',
  /** Finished */
  FINISHED = 'FINISHED',
  /** Processing */
  PROCESSING = 'PROCESSING',
  /** Queued */
  QUEUED = 'QUEUED'
}

export enum OrganizationDataUploadType {
  /** Additional costs */
  ADDITIONAL_COSTS = 'ADDITIONAL_COSTS',
  /** Companies */
  COMPANIES = 'COMPANIES',
  /** Contacts */
  CONTACTS = 'CONTACTS',
  /** Crews */
  CREWS = 'CREWS',
  /** Equipment pieces */
  EQUIPMENT_PIECES = 'EQUIPMENT_PIECES',
  /** Plants */
  PLANTS = 'PLANTS',
  /** Transfer trucks */
  TRANSFER_TRUCKS = 'TRANSFER_TRUCKS'
}

export type OrganizationDocument = {
  __typename?: 'OrganizationDocument';
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: Organization;
  path: Scalars['String'];
  thumbnailPath?: Maybe<Scalars['String']>;
};

export type OrganizationEmailIdentity = {
  __typename?: 'OrganizationEmailIdentity';
  dkimTokens?: Maybe<Array<DnsRecord>>;
  dmarcRecord?: Maybe<DnsRecord>;
  enabled: Scalars['Boolean'];
  fromName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceFromAddress: Scalars['String'];
  invoiceLocalPart: Scalars['String'];
  notificationsFromAddress: Scalars['String'];
  notificationsLocalPart: Scalars['String'];
  organizationId: Scalars['ID'];
  proposalFromAddress: Scalars['String'];
  proposalLocalPart: Scalars['String'];
  replyToCustomEmail?: Maybe<Scalars['String']>;
  replyToType: EmailIdentityReplyToType | `${EmailIdentityReplyToType}`;
  sendingDomain: Scalars['String'];
  spfRecord?: Maybe<DnsRecord>;
  verificationStatus: SesVerificationStatus | `${SesVerificationStatus}`;
  verifiedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationEmailTemplate = {
  __typename?: 'OrganizationEmailTemplate';
  html: Scalars['String'];
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  type: OrganizationEmailTemplateType | `${OrganizationEmailTemplateType}`;
};

export enum OrganizationEmailTemplateType {
  /** Custom */
  CUSTOM = 'CUSTOM',
  /** Default */
  DEFAULT = 'DEFAULT'
}

export type OrganizationLinkedService = {
  __typename?: 'OrganizationLinkedService';
  active: Scalars['Boolean'];
  expired: Scalars['Boolean'];
  id: Scalars['ID'];
  service: OrganizationLinkedServiceName | `${OrganizationLinkedServiceName}`;
  type: OrganizationLinkedServiceType | `${OrganizationLinkedServiceType}`;
};

export enum OrganizationLinkedServiceName {
  /** Quickbooks */
  QUICKBOOKS = 'QUICKBOOKS',
  /** Quickbooks desktop */
  QUICKBOOKS_DESKTOP = 'QUICKBOOKS_DESKTOP'
}

export enum OrganizationLinkedServiceType {
  /** Accounting */
  ACCOUNTING = 'ACCOUNTING'
}

export type OrganizationOpportunityStatus = {
  __typename?: 'OrganizationOpportunityStatus';
  id: Scalars['ID'];
  name: Scalars['String'];
  ordering: Scalars['Int'];
};

export type OrganizationProductType = {
  __typename?: 'OrganizationProductType';
  id: Scalars['ID'];
  indirectPercentage?: Maybe<Scalars['Int']>;
  markupPercentage?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  overheadPercentage?: Maybe<Scalars['Int']>;
  type: ProductType | `${ProductType}`;
};

export type OrganizationProfitabilityMetadata = {
  __typename?: 'OrganizationProfitabilityMetadata';
  totals: ReportOrganizationProfitabilityItem;
};

export type OrganizationProposalChecklistItem = {
  __typename?: 'OrganizationProposalChecklistItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
};

export type OrganizationProposalContent = {
  __typename?: 'OrganizationProposalContent';
  content: Scalars['String'];
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type OrganizationProposalLayoutContentSetting = {
  __typename?: 'OrganizationProposalLayoutContentSetting';
  contentType: Scalars['String'];
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  showOnBranded: Scalars['Boolean'];
  showOnFull: Scalars['Boolean'];
  showOnSimple: Scalars['Boolean'];
  showOnTabular: Scalars['Boolean'];
};

export type OrganizationSalesTax = {
  __typename?: 'OrganizationSalesTax';
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
  quickbooksDesktopTaxCodeId?: Maybe<Scalars['ID']>;
  quickbooksTaxCodeId?: Maybe<Scalars['ID']>;
};

export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type OutstandingWorkReportJob = {
  __typename?: 'OutstandingWorkReportJob';
  customerName: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['ID'];
  jobName: Scalars['String'];
  jobRevenue: Scalars['String'];
};

export enum OutstandingWorkReportMode {
  JOB_COMPLETE_STATUS = 'JOB_COMPLETE_STATUS',
  JOB_SCHEDULE = 'JOB_SCHEDULE'
}

export type OutstandingWorkReportResponse = {
  __typename?: 'OutstandingWorkReportResponse';
  countJobsOutstanding: Scalars['Int'];
  countJobsWon: Scalars['Int'];
  jobs: Array<OutstandingWorkReportJob>;
  mode: OutstandingWorkReportMode | `${OutstandingWorkReportMode}`;
  totalOutstandingRevenue: Scalars['String'];
  totalWonRevenue: Scalars['String'];
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

export type PersonPerformanceYtdRow = {
  __typename?: 'PersonPerformanceYtdRow';
  averageProposedNetMargin: Scalars['Float'];
  forecastedSalesThisYear: Scalars['String'];
  name: Scalars['String'];
  percentToGoal: Scalars['Float'];
  personId: Scalars['ID'];
  proposalsSent: Scalars['Int'];
  proposalsWon: Scalars['Int'];
  proposalsWonAmount: Scalars['String'];
  salesGoal: Scalars['String'];
  winRate: Scalars['Float'];
};

export type PersonSales = {
  __typename?: 'PersonSales';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  proposalsWonCount: Scalars['Int'];
  proposalsWonPercentage: Scalars['Float'];
  proposalsWonSum?: Maybe<Scalars['String']>;
  sentProposalsCount: Scalars['Int'];
  winRate?: Maybe<Scalars['Float']>;
};

export type Plant = {
  __typename?: 'Plant';
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  products: Array<PlantProduct>;
};

/** A paginated list of Plant items. */
export type PlantPaginator = {
  __typename?: 'PlantPaginator';
  /** A list of Plant items. */
  data: Array<Plant>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PlantProduct = {
  __typename?: 'PlantProduct';
  id: Scalars['ID'];
  pivot?: Maybe<ProductPlantProductPivot>;
  plantId: Scalars['ID'];
  rate: Scalars['Int'];
  type: Scalars['String'];
};

export enum PlantProductType {
  /** Asphalt */
  ASPHALT = 'ASPHALT',
  /** Asphalt 1 2 apwa spec */
  ASPHALT_1_2_APWA_SPEC = 'ASPHALT_1_2_APWA_SPEC',
  /** Asphalt 3 4 apwa spec */
  ASPHALT_3_4_APWA_SPEC = 'ASPHALT_3_4_APWA_SPEC',
  /** Asphalt commercial mix 1 2 */
  ASPHALT_COMMERCIAL_MIX_1_2 = 'ASPHALT_COMMERCIAL_MIX_1_2',
  /** Asphalt commercial mix 3 4 */
  ASPHALT_COMMERCIAL_MIX_3_4 = 'ASPHALT_COMMERCIAL_MIX_3_4',
  /** Base course */
  BASE_COURSE = 'BASE_COURSE',
  /** Binder course */
  BINDER_COURSE = 'BINDER_COURSE',
  /** Chip washed standard 3 8 */
  CHIP_WASHED_STANDARD_3_8 = 'CHIP_WASHED_STANDARD_3_8',
  /** Concrete flatwork */
  CONCRETE_FLATWORK = 'CONCRETE_FLATWORK',
  /** Concrete walls */
  CONCRETE_WALLS = 'CONCRETE_WALLS',
  /** Crushed concrete 1 apwa */
  CRUSHED_CONCRETE_1_APWA = 'CRUSHED_CONCRETE_1_APWA',
  /** Debris */
  DEBRIS = 'DEBRIS',
  /** Fine course */
  FINE_COURSE = 'FINE_COURSE',
  /** Fine gravel */
  FINE_GRAVEL = 'FINE_GRAVEL',
  /** Rip rap 12 max */
  RIP_RAP_12_MAX = 'RIP_RAP_12_MAX',
  /** Road base */
  ROAD_BASE = 'ROAD_BASE',
  /** Road base 1 */
  ROAD_BASE_1 = 'ROAD_BASE_1',
  /** Road base 1 2 */
  ROAD_BASE_1_2 = 'ROAD_BASE_1_2',
  /** Road base 1 2 apwa spec */
  ROAD_BASE_1_2_APWA_SPEC = 'ROAD_BASE_1_2_APWA_SPEC',
  /** Road base 1 apwa spec */
  ROAD_BASE_1_APWA_SPEC = 'ROAD_BASE_1_APWA_SPEC',
  /** Road base 3 4 */
  ROAD_BASE_3_4 = 'ROAD_BASE_3_4',
  /** Road base 3 4 apwa spec */
  ROAD_BASE_3_4_APWA_SPEC = 'ROAD_BASE_3_4_APWA_SPEC',
  /** Rock unwashed 1 1 2 maximum */
  ROCK_UNWASHED_1_1_2_MAXIMUM = 'ROCK_UNWASHED_1_1_2_MAXIMUM',
  /** Rock unwashed 3 4 or 1 maximum */
  ROCK_UNWASHED_3_4_OR_1_MAXIMUM = 'ROCK_UNWASHED_3_4_OR_1_MAXIMUM',
  /** Slurry sand type 1 */
  SLURRY_SAND_TYPE_1 = 'SLURRY_SAND_TYPE_1',
  /** Slurry sand type 2 */
  SLURRY_SAND_TYPE_2 = 'SLURRY_SAND_TYPE_2',
  /** Slurry sand type 3 */
  SLURRY_SAND_TYPE_3 = 'SLURRY_SAND_TYPE_3',
  /** Top course */
  TOP_COURSE = 'TOP_COURSE'
}

export type PlantTransferTruck = {
  __typename?: 'PlantTransferTruck';
  id: Scalars['ID'];
  rateHourly?: Maybe<Scalars['Int']>;
  rateTon?: Maybe<Scalars['Int']>;
  tonnage?: Maybe<Scalars['Int']>;
  transferTruck: TransferTruck;
};

export type PreviewSubscriptionChangeResponse = {
  __typename?: 'PreviewSubscriptionChangeResponse';
  totalOnRenewal: Scalars['Int'];
  totalToday: Scalars['Int'];
};

export type Product = {
  __typename?: 'Product';
  /** @deprecated Use productEquipmentPieces instead with Apollo Caching */
  additionalCosts: Array<AdditionalCost>;
  /** Area Coverage */
  areaCoverage?: Maybe<Scalars['Float']>;
  attributes?: Maybe<ProductAttributes>;
  costMaterial?: Maybe<Scalars['Int']>;
  costMinimumProduct?: Maybe<Scalars['Int']>;
  costMinimumProposal?: Maybe<Scalars['Int']>;
  crew?: Maybe<Crew>;
  dailyUnitsComplete?: Maybe<Scalars['Int']>;
  /** @deprecated Use productEquipmentPieces instead with Apollo Caching */
  equipmentPieces: Array<EquipmentPiece>;
  externalProductName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  indirectPercentage?: Maybe<Scalars['Int']>;
  labourCostType?: Maybe<ProductLabourCostType | `${ProductLabourCostType}`>;
  markupPercentage?: Maybe<Scalars['Int']>;
  materialsNoPlant?: Maybe<Array<ProductMaterialNoPlant>>;
  measurementJob?: Maybe<ProductMeasurementJob | `${ProductMeasurementJob}`>;
  measurementMaterial?: Maybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  name: Scalars['String'];
  organizationProductType: OrganizationProductType;
  overheadPercentage?: Maybe<Scalars['Int']>;
  plant?: Maybe<Plant>;
  plantProductId?: Maybe<Scalars['String']>;
  plantProducts?: Maybe<Array<PlantProduct>>;
  plants?: Maybe<Array<Plant>>;
  productAdditionalCosts?: Maybe<Array<ProductAdditionalCost>>;
  productCrews?: Maybe<Array<ProductCrew>>;
  productEquipmentPieces?: Maybe<Array<ProductEquipmentPiece>>;
  productionRateType?: Maybe<ProductProductionRateType | `${ProductProductionRateType}`>;
  statementOfWork?: Maybe<Scalars['String']>;
  subcontracted: Scalars['Boolean'];
  type: ProductType | `${ProductType}`;
  unitPrice?: Maybe<Scalars['Int']>;
  unitPriceProduct: Scalars['Boolean'];
};

export type ProductAdditionalCost = {
  __typename?: 'ProductAdditionalCost';
  additionalCost: AdditionalCost;
  id: Scalars['ID'];
  type?: Maybe<ProductAdditionalCostType | `${ProductAdditionalCostType}`>;
};

export type ProductAdditionalCostPivot = {
  __typename?: 'ProductAdditionalCostPivot';
  type?: Maybe<ProductAdditionalCostType | `${ProductAdditionalCostType}`>;
};

export enum ProductAdditionalCostType {
  /** Additive */
  ADDITIVE = 'ADDITIVE',
  /** Cement */
  CEMENT = 'CEMENT',
  /** Emulsion oil */
  EMULSION_OIL = 'EMULSION_OIL',
  /** Water */
  WATER = 'WATER'
}

export type ProductAttributeAsphalt = {
  __typename?: 'ProductAttributeAsphalt';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeAsphaltCurbing = {
  __typename?: 'ProductAttributeAsphaltCurbing';
  curbHeight?: Maybe<Scalars['Float']>;
  curbWidth?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteColumn = {
  __typename?: 'ProductAttributeConcreteColumn';
  diameter?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteCurbOrGutter = {
  __typename?: 'ProductAttributeConcreteCurbOrGutter';
  curbHeight?: Maybe<Scalars['Float']>;
  curbWidth?: Maybe<Scalars['Float']>;
  gutterHeight?: Maybe<Scalars['Float']>;
  gutterWidth?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteFlatwork = {
  __typename?: 'ProductAttributeConcreteFlatwork';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteFooting = {
  __typename?: 'ProductAttributeConcreteFooting';
  depth?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteWall = {
  __typename?: 'ProductAttributeConcreteWall';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteWaterway = {
  __typename?: 'ProductAttributeConcreteWaterway';
  curbHeight?: Maybe<Scalars['Float']>;
  curbWidth?: Maybe<Scalars['Float']>;
  gutterHeight?: Maybe<Scalars['Float']>;
  gutterWidth?: Maybe<Scalars['Float']>;
};

export type ProductAttributeCrackSeal = {
  __typename?: 'ProductAttributeCrackSeal';
  crackDepth?: Maybe<Scalars['Float']>;
  crackWidth?: Maybe<Scalars['Float']>;
  overbandThickness?: Maybe<Scalars['Float']>;
  overbandWidth?: Maybe<Scalars['Float']>;
  poundsPerBlock?: Maybe<Scalars['Float']>;
  poundsPerGallon?: Maybe<Scalars['Float']>;
};

export type ProductAttributeCurbWall = {
  __typename?: 'ProductAttributeCurbWall';
  curbHeight?: Maybe<Scalars['Float']>;
  curbWidth?: Maybe<Scalars['Float']>;
  gutterHeight?: Maybe<Scalars['Float']>;
  gutterWidth?: Maybe<Scalars['Float']>;
};

export type ProductAttributeExcavateOut = {
  __typename?: 'ProductAttributeExcavateOut';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeGrading = {
  __typename?: 'ProductAttributeGrading';
  applicationRate?: Maybe<Scalars['Float']>;
  poundsPerCubicYard?: Maybe<Scalars['Float']>;
};

export type ProductAttributeMastic = {
  __typename?: 'ProductAttributeMastic';
  crackDepth?: Maybe<Scalars['Float']>;
  crackWidth?: Maybe<Scalars['Float']>;
  overbandThickness?: Maybe<Scalars['Float']>;
  overbandWidth?: Maybe<Scalars['Float']>;
  poundsPerBlock?: Maybe<Scalars['Float']>;
  poundsPerGallon?: Maybe<Scalars['Float']>;
};

export type ProductAttributeMicrosurfacing = {
  __typename?: 'ProductAttributeMicrosurfacing';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeSealCoat = {
  __typename?: 'ProductAttributeSealCoat';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeSlurrySeal = {
  __typename?: 'ProductAttributeSlurrySeal';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeStriping = {
  __typename?: 'ProductAttributeStriping';
  applicationRate?: Maybe<Scalars['Float']>;
  lineWidth?: Maybe<Scalars['Float']>;
};

export type ProductAttributes = ProductAttributeAsphalt | ProductAttributeAsphaltCurbing | ProductAttributeConcreteColumn | ProductAttributeConcreteCurbOrGutter | ProductAttributeConcreteFlatwork | ProductAttributeConcreteFooting | ProductAttributeConcreteWall | ProductAttributeConcreteWaterway | ProductAttributeCrackSeal | ProductAttributeCurbWall | ProductAttributeExcavateOut | ProductAttributeGrading | ProductAttributeMastic | ProductAttributeMicrosurfacing | ProductAttributeSealCoat | ProductAttributeSlurrySeal | ProductAttributeStriping;

export type ProductAttributesInput = {
  applicationRate?: InputMaybe<Scalars['Float']>;
  crackDepth?: InputMaybe<Scalars['Float']>;
  crackWidth?: InputMaybe<Scalars['Float']>;
  curbHeight?: InputMaybe<Scalars['Float']>;
  curbWidth?: InputMaybe<Scalars['Float']>;
  depth?: InputMaybe<Scalars['Float']>;
  diameter?: InputMaybe<Scalars['Float']>;
  gutterHeight?: InputMaybe<Scalars['Float']>;
  gutterWidth?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  lineWidth?: InputMaybe<Scalars['Float']>;
  overbandThickness?: InputMaybe<Scalars['Float']>;
  overbandWidth?: InputMaybe<Scalars['Float']>;
  poundsPerBlock?: InputMaybe<Scalars['Float']>;
  poundsPerCubicYard?: InputMaybe<Scalars['Float']>;
  poundsPerGallon?: InputMaybe<Scalars['Float']>;
  transferTruckLoadTime?: InputMaybe<Scalars['Float']>;
  transferTruckUnloadTime?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type ProductCrew = {
  __typename?: 'ProductCrew';
  crew: Crew;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ProductDetails = {
  __typename?: 'ProductDetails';
  costBasis?: Maybe<Scalars['String']>;
  itemsWithoutCosts?: Maybe<Scalars['Int']>;
  materialCostType?: Maybe<Scalars['String']>;
  materialNeededSum?: Maybe<Scalars['Float']>;
  measurementMaterial?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['ID']>;
  productName?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  proposalsCount?: Maybe<Scalars['Int']>;
  sumCostTotal?: Maybe<Scalars['Float']>;
  sumOverallTotal?: Maybe<Scalars['Float']>;
  sumProfit?: Maybe<Scalars['Float']>;
};

export type ProductDetailsMetadata = {
  __typename?: 'ProductDetailsMetadata';
  totals: ProductDetailsTotals;
};

export type ProductDetailsTotals = {
  __typename?: 'ProductDetailsTotals';
  cost_total_sum: Scalars['Float'];
  items_without_costs?: Maybe<Scalars['Int']>;
  overall_total_sum: Scalars['Float'];
  profit_sum: Scalars['Float'];
};

export type ProductEquipmentPiece = {
  __typename?: 'ProductEquipmentPiece';
  equipmentPiece: EquipmentPiece;
  id: Scalars['ID'];
  quantity: Scalars['Float'];
};

export type ProductEquipmentPivot = {
  __typename?: 'ProductEquipmentPivot';
  quantity: Scalars['Int'];
};

export type ProductGroup = {
  __typename?: 'ProductGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  products: Array<Product>;
};

/** A paginated list of ProductGroup items. */
export type ProductGroupPaginator = {
  __typename?: 'ProductGroupPaginator';
  /** A list of ProductGroup items. */
  data: Array<ProductGroup>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ProductLabourCostType {
  /** Full day */
  FULL_DAY = 'FULL_DAY',
  /** Half day */
  HALF_DAY = 'HALF_DAY',
  /** Job */
  JOB = 'JOB',
  /** Per man hour */
  PER_MAN_HOUR = 'PER_MAN_HOUR',
  /** Per unit complete */
  PER_UNIT_COMPLETE = 'PER_UNIT_COMPLETE'
}

export type ProductMaterialNoPlant = {
  __typename?: 'ProductMaterialNoPlant';
  id: Scalars['ID'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
  productId: Scalars['ID'];
  rate: Scalars['Int'];
};

export type ProductMaterialUsed = {
  __typename?: 'ProductMaterialUsed';
  jobSizeComplete?: Maybe<Scalars['String']>;
  productMaterialUsed: Scalars['String'];
  productType: Scalars['String'];
  proposalJobSize: Scalars['String'];
  proposalMaterialNeeded?: Maybe<Scalars['String']>;
};

export enum ProductMeasurementJob {
  /** Linear foot */
  LINEAR_FOOT = 'LINEAR_FOOT',
  /** Square foot */
  SQUARE_FOOT = 'SQUARE_FOOT',
  /** Square yard */
  SQUARE_YARD = 'SQUARE_YARD',
  /** Unit */
  UNIT = 'UNIT'
}

export enum ProductMeasurementMaterial {
  /** Block */
  BLOCK = 'BLOCK',
  /** Gallon */
  GALLON = 'GALLON',
  /** Pound */
  POUND = 'POUND',
  /** Ton */
  TON = 'TON',
  /** Unit */
  UNIT = 'UNIT',
  /** Yard */
  YARD = 'YARD'
}

/** A paginated list of Product items. */
export type ProductPaginator = {
  __typename?: 'ProductPaginator';
  /** A list of Product items. */
  data: Array<Product>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProductPlantProductPivot = {
  __typename?: 'ProductPlantProductPivot';
  applicationRate?: Maybe<Scalars['Float']>;
};

export enum ProductProductionRateType {
  /** Sq ft sq yd per hour */
  SQ_FT_SQ_YD_PER_HOUR = 'SQ_FT_SQ_YD_PER_HOUR',
  /** Tons per hour */
  TONS_PER_HOUR = 'TONS_PER_HOUR'
}

export type ProductSales = {
  __typename?: 'ProductSales';
  actualProfitPercentage: Scalars['Float'];
  name: Scalars['String'];
  proposedProfitPercentage: Scalars['Float'];
  sumOverallTotal: Scalars['Float'];
};

export type ProductStats = {
  __typename?: 'ProductStats';
  materialUsed?: Maybe<Array<ProductMaterialUsed>>;
  productTypeUsedPercentages?: Maybe<Array<ProductTypeUsed>>;
  products: Array<Maybe<ProductSales>>;
};

export enum ProductType {
  /** Asphalt */
  ASPHALT = 'ASPHALT',
  /** Asphalt curbing */
  ASPHALT_CURBING = 'ASPHALT_CURBING',
  /** Concrete column */
  CONCRETE_COLUMN = 'CONCRETE_COLUMN',
  /** Concrete curb or gutter */
  CONCRETE_CURB_OR_GUTTER = 'CONCRETE_CURB_OR_GUTTER',
  /** Concrete flatwork */
  CONCRETE_FLATWORK = 'CONCRETE_FLATWORK',
  /** Concrete footing */
  CONCRETE_FOOTING = 'CONCRETE_FOOTING',
  /** Concrete wall */
  CONCRETE_WALL = 'CONCRETE_WALL',
  /** Concrete waterway */
  CONCRETE_WATERWAY = 'CONCRETE_WATERWAY',
  /** Crack seal */
  CRACK_SEAL = 'CRACK_SEAL',
  /** Curb wall */
  CURB_WALL = 'CURB_WALL',
  /** Excavate out */
  EXCAVATE_OUT = 'EXCAVATE_OUT',
  /** Generic */
  GENERIC = 'GENERIC',
  /** Grading */
  GRADING = 'GRADING',
  /** Mastic */
  MASTIC = 'MASTIC',
  /** Microsurfacing */
  MICROSURFACING = 'MICROSURFACING',
  /** Sealcoat */
  SEALCOAT = 'SEALCOAT',
  /** Slurry seal */
  SLURRY_SEAL = 'SLURRY_SEAL',
  /** Striping */
  STRIPING = 'STRIPING'
}

export type ProductTypeUsed = {
  __typename?: 'ProductTypeUsed';
  equipmentUsedPercentage?: Maybe<Scalars['Float']>;
  labourUsedPercentage?: Maybe<Scalars['Float']>;
  materialUsedPercentage?: Maybe<Scalars['Float']>;
  productType: Scalars['String'];
};

export type ProductionHelper = {
  __typename?: 'ProductionHelper';
  enabled: Scalars['Boolean'];
  materialRowId?: Maybe<Scalars['ID']>;
  period: Scalars['String'];
  quantity?: Maybe<Scalars['String']>;
  rate: Scalars['String'];
  source: Scalars['String'];
  unit: Scalars['String'];
};

export type ProductionHelperInput = {
  enabled: Scalars['Boolean'];
  materialRowId?: InputMaybe<Scalars['ID']>;
  period: Scalars['String'];
  quantity?: InputMaybe<Scalars['String']>;
  rate: Scalars['String'];
  source: Scalars['String'];
  unit: Scalars['String'];
};

export type ProjectFile = {
  __typename?: 'ProjectFile';
  children?: Maybe<Array<ProjectFile>>;
  createdAt?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parentFolderId?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  pivot?: Maybe<ProposalProductProjectFile>;
  type: ProjectFileType | `${ProjectFileType}`;
};

export enum ProjectFileType {
  /** File */
  FILE = 'FILE',
  /** Folder */
  FOLDER = 'FOLDER'
}

export type ProjectMap = {
  __typename?: 'ProjectMap';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  mapData?: Maybe<Scalars['String']>;
  mapImage?: Maybe<Scalars['String']>;
  mapImageDirty: Scalars['Boolean'];
  measurements: Array<ProjectMapMeasurement>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ProjectMapMeasurement = {
  __typename?: 'ProjectMapMeasurement';
  featureGeojson?: Maybe<Scalars['String']>;
  geojsonFeatureId: Scalars['String'];
  id: Scalars['ID'];
  isScreenshotTarget: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  measurementJob?: Maybe<ProductMeasurementJob | `${ProductMeasurementJob}`>;
  measurementType: ProposalMeasurementType | `${ProposalMeasurementType}`;
  measurementValue?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type Proposal = {
  __typename?: 'Proposal';
  acceptanceOverride?: Maybe<Scalars['String']>;
  activeVersion: Scalars['Boolean'];
  addresses: Array<Maybe<ProposalAddress>>;
  attachments?: Maybe<Array<OrganizationDocument>>;
  changeOrderJobId?: Maybe<Scalars['String']>;
  changeOrders?: Maybe<Array<Proposal>>;
  clientEmailOverride?: Maybe<Scalars['String']>;
  closeConfidence?: Maybe<Scalars['Int']>;
  company: Company;
  contact: Contact;
  contactId: Scalars['ID'];
  contentSettings: Array<ProposalContentSetting>;
  costAdditional: Scalars['String'];
  costDirect: Scalars['String'];
  costEquipment: Scalars['String'];
  costIndirect: Scalars['String'];
  costLabour: Scalars['String'];
  costMaterial: Scalars['String'];
  costOverhead: Scalars['String'];
  costTaxes: Scalars['String'];
  costTotal: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customFinancials: CustomProposalFinancials;
  discount: Scalars['String'];
  emailBodyOverride?: Maybe<Scalars['String']>;
  emailBodyOverrideParsed?: Maybe<Scalars['String']>;
  emailSubjectOverride?: Maybe<Scalars['String']>;
  estimatingMethod: Scalars['String'];
  events: Array<ProposalEvent>;
  externalId: Scalars['String'];
  externalIdWithPrefix: Scalars['String'];
  grossMargin: Scalars['String'];
  grossMarginPercentage: Scalars['Int'];
  id: Scalars['ID'];
  isChangeOrder: Scalars['Boolean'];
  isPackageChild: Scalars['Boolean'];
  isPackageParent: Scalars['Boolean'];
  isSendable: Scalars['Boolean'];
  lastEvent?: Maybe<ProposalEvent>;
  lastStatusChange?: Maybe<ProposalStatusChange>;
  latestPackageSendRun?: Maybe<ProposalPackageSendRun>;
  layout?: Maybe<ProposalLayout | `${ProposalLayout}`>;
  netMargin: Scalars['String'];
  netMarginPercentage: Scalars['Int'];
  operatingMargin: Scalars['String'];
  operatingMarginPercentage: Scalars['Int'];
  organization: Organization;
  overallTotal: Scalars['String'];
  overallTotalAfterDiscount: Scalars['String'];
  overallTotalAfterTaxes: Scalars['String'];
  packageChildren: Array<Proposal>;
  packageParent?: Maybe<Proposal>;
  packageWinnerProposal?: Maybe<Proposal>;
  pdfGeneratedAt?: Maybe<Scalars['DateTime']>;
  profit: Scalars['String'];
  profitAfterDiscount: Scalars['String'];
  profitPercentage: Scalars['Int'];
  projectFilesFolderId?: Maybe<Scalars['ID']>;
  projectedCloseDate?: Maybe<Scalars['Date']>;
  proposalNotes?: Maybe<Scalars['String']>;
  proposalPackageParentId?: Maybe<Scalars['ID']>;
  proposalPackageWinnerProposalId?: Maybe<Scalars['ID']>;
  proposalPdf?: Maybe<Scalars['String']>;
  proposalRole: Scalars['String'];
  recipients: Array<ProposalRecipient>;
  removeIndividualLineItemPricing?: Maybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: Maybe<Scalars['Boolean']>;
  salesTaxes?: Maybe<Array<ProposalSalesTax>>;
  sentAt?: Maybe<Scalars['DateTime']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  signedInitials?: Maybe<Scalars['String']>;
  signedName?: Maybe<Scalars['String']>;
  source?: Maybe<ProposalSource | `${ProposalSource}`>;
  stages: Array<ProposalStage>;
  status: ProposalStatus | `${ProposalStatus}`;
  statusChanges: Array<ProposalStatusChange>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  uuid: Scalars['String'];
  version: Scalars['String'];
  versionWithPrefix: Scalars['String'];
  versions?: Maybe<Array<Proposal>>;
  wonAt?: Maybe<Scalars['DateTime']>;
};

export type ProposalAdditionalCost = {
  __typename?: 'ProposalAdditionalCost';
  additionalCostId?: Maybe<Scalars['ID']>;
  cost: Scalars['Int'];
  costOverride?: Maybe<Scalars['Int']>;
  costTotal?: Maybe<Scalars['String']>;
  feeAmount: Scalars['Float'];
  feeAmountOverride?: Maybe<Scalars['Float']>;
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  quantityOverride?: Maybe<Scalars['Float']>;
  showOnProposal: Scalars['Boolean'];
};

export type ProposalAddress = {
  __typename?: 'ProposalAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  longitude: Scalars['String'];
  mapImage?: Maybe<Scalars['String']>;
  organizationAddressId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ProposalContent = {
  __typename?: 'ProposalContent';
  content: Scalars['String'];
  contentOverride: Scalars['String'];
  type: Scalars['String'];
};

export type ProposalContentSetting = {
  __typename?: 'ProposalContentSetting';
  contentType: Scalars['String'];
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  proposalId: Scalars['ID'];
};

export enum ProposalContentType {
  /** Acceptance */
  ACCEPTANCE = 'ACCEPTANCE',
  /** Invoice details */
  INVOICE_DETAILS = 'INVOICE_DETAILS',
  /** Project summary */
  PROJECT_SUMMARY = 'PROJECT_SUMMARY',
  /** Statement of work */
  STATEMENT_OF_WORK = 'STATEMENT_OF_WORK',
  /** Terms */
  TERMS = 'TERMS',
  /** Title page */
  TITLE_PAGE = 'TITLE_PAGE'
}

export type ProposalCrew = {
  __typename?: 'ProposalCrew';
  cost: Scalars['String'];
  crewId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  quantityOverride?: Maybe<Scalars['Int']>;
  rate: Scalars['Int'];
  rateOverride?: Maybe<Scalars['Int']>;
  timeOnjob: Scalars['Int'];
  timeOnjobOverride?: Maybe<Scalars['Int']>;
  timeTravel: Scalars['Int'];
  timeTravelOverride?: Maybe<Scalars['Int']>;
};

export type ProposalDefault = {
  __typename?: 'ProposalDefault';
  autoSave?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  defaultLoadingTimeMins?: Maybe<Scalars['Int']>;
  defaultTransferTruckId?: Maybe<Scalars['ID']>;
  defaultUnloadTimeMins?: Maybe<Scalars['Int']>;
  estimateTruckingByFullDay: Scalars['Boolean'];
  id: Scalars['ID'];
  idPrefix?: Maybe<Scalars['String']>;
  layout: ProposalLayout | `${ProposalLayout}`;
  maxTripNumberPerTruck?: Maybe<Scalars['Int']>;
  minimumProfitPerDay?: Maybe<Scalars['Int']>;
  multiplyTravelTimeByDay: Scalars['Boolean'];
  multiplyTravelTimeForEquipmentLabour: Scalars['Boolean'];
  optionalCheckboxDefaultChecked: Scalars['Boolean'];
  removeIndividualLineItemPricing: Scalars['Boolean'];
  removeUnitPriceAndQuantity: Scalars['Boolean'];
  roundUpToNearestDollarAmount: Scalars['Boolean'];
  startingNumber?: Maybe<Scalars['Int']>;
};

export type ProposalDetailsItem = {
  __typename?: 'ProposalDetailsItem';
  address_line_1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['ID']>;
  company_name?: Maybe<Scalars['String']>;
  cost_additional?: Maybe<Scalars['Float']>;
  cost_basis?: Maybe<Scalars['String']>;
  cost_direct?: Maybe<Scalars['Float']>;
  cost_equipment?: Maybe<Scalars['Float']>;
  cost_indirect?: Maybe<Scalars['Float']>;
  cost_labour?: Maybe<Scalars['Float']>;
  cost_material?: Maybe<Scalars['Float']>;
  cost_overhead?: Maybe<Scalars['Float']>;
  cost_total?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  estimator_name?: Maybe<Scalars['String']>;
  external_id_with_prefix?: Maybe<Scalars['String']>;
  gross_margin?: Maybe<Scalars['Float']>;
  gross_margin_percentage?: Maybe<Scalars['Float']>;
  job_name?: Maybe<Scalars['String']>;
  job_size?: Maybe<Scalars['String']>;
  material_material_needed_override?: Maybe<Scalars['Float']>;
  material_measurement_material?: Maybe<Scalars['String']>;
  material_name?: Maybe<Scalars['String']>;
  material_type?: Maybe<Scalars['String']>;
  net_margin?: Maybe<Scalars['Float']>;
  net_margin_percentage?: Maybe<Scalars['Float']>;
  operating_margin?: Maybe<Scalars['Float']>;
  operating_margin_percentage?: Maybe<Scalars['Float']>;
  overall_total?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  profit_percentage_override?: Maybe<Scalars['Float']>;
  proposal_notes?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['String']>;
  signed_at?: Maybe<Scalars['String']>;
  signee_initials?: Maybe<Scalars['String']>;
  signee_name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  stage_id?: Maybe<Scalars['ID']>;
  stage_name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['ID']>;
  viewed_at?: Maybe<Scalars['String']>;
  won_at?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ProposalDetailsMetadata = {
  __typename?: 'ProposalDetailsMetadata';
  totals: ProposalDetailsTotals;
};

export type ProposalDetailsTotals = {
  __typename?: 'ProposalDetailsTotals';
  cost_additional: Scalars['Float'];
  cost_direct: Scalars['Float'];
  cost_equipment: Scalars['Float'];
  cost_indirect: Scalars['Float'];
  cost_labour: Scalars['Float'];
  cost_material: Scalars['Float'];
  cost_overhead: Scalars['Float'];
  cost_total: Scalars['Float'];
  gross_margin: Scalars['Float'];
  items_without_costs?: Maybe<Scalars['Int']>;
  net_margin: Scalars['Float'];
  operating_margin: Scalars['Float'];
  overall_total: Scalars['Float'];
  profit: Scalars['Float'];
};

export type ProposalEquipmentPiece = {
  __typename?: 'ProposalEquipmentPiece';
  calculateTravelTime: Scalars['Boolean'];
  chargeType: EquipmentPieceChargeType | `${EquipmentPieceChargeType}`;
  cost: Scalars['String'];
  equipmentPieceId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  quantityOverride?: Maybe<Scalars['Float']>;
  rate: Scalars['Int'];
  rateOverride?: Maybe<Scalars['Int']>;
  timeOnjob: Scalars['Int'];
  timeOnjobOverride?: Maybe<Scalars['Int']>;
  timeTravel: Scalars['Int'];
  timeTravelOverride?: Maybe<Scalars['Int']>;
  usePercentage: Scalars['Int'];
};

export type ProposalEvent = {
  __typename?: 'ProposalEvent';
  action: ProposalEventAction | `${ProposalEventAction}`;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
};

export enum ProposalEventAction {
  /** Email clicked */
  EMAIL_CLICKED = 'EMAIL_CLICKED',
  /** Email opened */
  EMAIL_OPENED = 'EMAIL_OPENED',
  /** Resent */
  RESENT = 'RESENT',
  /** Sent */
  SENT = 'SENT',
  /** Viewed */
  VIEWED = 'VIEWED'
}

export type ProposalFile = {
  __typename?: 'ProposalFile';
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  thumbnail?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum ProposalLayout {
  /** Branded */
  BRANDED = 'BRANDED',
  /** Full */
  FULL = 'FULL',
  /** Simple */
  SIMPLE = 'SIMPLE',
  /** Tabular */
  TABULAR = 'TABULAR'
}

export type ProposalMaterial = {
  __typename?: 'ProposalMaterial';
  areaCoverage?: Maybe<Scalars['Float']>;
  attributes?: Maybe<ProductAttributes>;
  attributesOverride?: Maybe<ProductAttributes>;
  costMaterial?: Maybe<Scalars['String']>;
  costMaterialOverride?: Maybe<Scalars['String']>;
  costMinimumProduct?: Maybe<Scalars['Int']>;
  costMinimumProposal?: Maybe<Scalars['Int']>;
  dailyUnitsComplete?: Maybe<Scalars['String']>;
  dailyUnitsCompleteOverride?: Maybe<Scalars['String']>;
  externalProductName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  indirectPercentage?: Maybe<Scalars['Int']>;
  indirectPercentageOverride?: Maybe<Scalars['Int']>;
  labourCostType?: Maybe<ProductLabourCostType | `${ProductLabourCostType}`>;
  markupPercentage?: Maybe<Scalars['Int']>;
  markupPercentageOverride?: Maybe<Scalars['Int']>;
  materialNeeded?: Maybe<Scalars['Float']>;
  materialNeededOverride?: Maybe<Scalars['Float']>;
  measurementJob?: Maybe<ProductMeasurementJob | `${ProductMeasurementJob}`>;
  measurementMaterial?: Maybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  name: Scalars['String'];
  organizationProductTypeName?: Maybe<Scalars['String']>;
  overheadPercentage?: Maybe<Scalars['Int']>;
  overheadPercentageOverride?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['ID']>;
  productionRateType?: Maybe<ProductProductionRateType | `${ProductProductionRateType}`>;
  proposalId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  proposalStageId: Scalars['ID'];
  statementOfWork?: Maybe<Scalars['String']>;
  statementOfWorkOverride?: Maybe<Scalars['String']>;
  subcontracted: Scalars['Boolean'];
  tonConversionFactor?: Maybe<Scalars['Float']>;
  tonConversionFactorOverride?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  unitPrice?: Maybe<Scalars['Int']>;
  unitPriceOverride?: Maybe<Scalars['Int']>;
  unitPriceProduct: Scalars['Boolean'];
};

export type ProposalMaterialNoPlant = {
  __typename?: 'ProposalMaterialNoPlant';
  cost: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Int'];
  quantityOverride?: Maybe<Scalars['Int']>;
  rate: Scalars['Int'];
};

export enum ProposalMeasurementType {
  /** Area */
  AREA = 'AREA',
  /** Perimeter */
  PERIMETER = 'PERIMETER'
}

export type ProposalPackageRecipientInput = {
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
};

export type ProposalPackageSendRecipient = {
  __typename?: 'ProposalPackageSendRecipient';
  attemptCount: Scalars['Int'];
  company: Company;
  companyId: Scalars['ID'];
  contact: Contact;
  contactId: Scalars['ID'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  proposal?: Maybe<Proposal>;
  proposalId?: Maybe<Scalars['ID']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: ProposalPackageSendRecipientStatus | `${ProposalPackageSendRecipientStatus}`;
};

export enum ProposalPackageSendRecipientStatus {
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SENT = 'SENT'
}

export type ProposalPackageSendRun = {
  __typename?: 'ProposalPackageSendRun';
  failedRecipients: Scalars['Int'];
  id: Scalars['ID'];
  processedRecipients: Scalars['Int'];
  proposalId: Scalars['ID'];
  recipients: Array<ProposalPackageSendRecipient>;
  status: ProposalPackageSendRunStatus | `${ProposalPackageSendRunStatus}`;
  succeededRecipients: Scalars['Int'];
  totalRecipients: Scalars['Int'];
};

export enum ProposalPackageSendRunStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
  PROCESSING = 'PROCESSING',
  QUEUED = 'QUEUED'
}

export type ProposalPlant = {
  __typename?: 'ProposalPlant';
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  distanceMeters?: Maybe<Scalars['Int']>;
  distanceSeconds?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  plantId: Scalars['ID'];
  rateOnWeight: Scalars['Boolean'];
  roundTripSeconds?: Maybe<Scalars['Int']>;
};

export type ProposalPlantProduct = {
  __typename?: 'ProposalPlantProduct';
  applicationRate?: Maybe<Scalars['Float']>;
  applicationRateOverride?: Maybe<Scalars['Float']>;
  areaCoverage?: Maybe<Scalars['Float']>;
  costMaterial?: Maybe<Scalars['Int']>;
  costTransferTruck?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  materialNeeded?: Maybe<Scalars['Float']>;
  materialNeededOverride?: Maybe<Scalars['Float']>;
  plant: ProposalPlant;
  plantProductId: Scalars['ID'];
  rate: Scalars['Int'];
  rateOnWeight?: Maybe<Scalars['Boolean']>;
  rateOverride?: Maybe<Scalars['Int']>;
  /** In Hours */
  transferTruckLoadTimeBuffer?: Maybe<Scalars['Float']>;
  transferTruckRoundTripTimeHrs?: Maybe<Scalars['Float']>;
  transferTruckRoundTripTimeHrsOverride?: Maybe<Scalars['Float']>;
  /** In Hours */
  transferTruckUnloadTimeBuffer?: Maybe<Scalars['Float']>;
  transferTrucks?: Maybe<Array<ProposalTransferTruck>>;
  type: Scalars['String'];
};

export type ProposalProduct = {
  __typename?: 'ProposalProduct';
  additionalCosts?: Maybe<Array<Maybe<ProposalAdditionalCost>>>;
  costAdditional: Scalars['String'];
  costDirect: Scalars['String'];
  costEquipment: Scalars['String'];
  costIndirect: Scalars['String'];
  costLabour: Scalars['String'];
  costMaterial: Scalars['String'];
  costOverhead: Scalars['String'];
  costTotal: Scalars['String'];
  costTransferTruck: Scalars['String'];
  crews?: Maybe<Array<ProposalCrew>>;
  custom?: Maybe<Custom>;
  discount: Scalars['String'];
  equipmentPieces?: Maybe<Array<ProposalEquipmentPiece>>;
  externalProductName?: Maybe<Scalars['String']>;
  files?: Maybe<Array<ProposalFile>>;
  grossMargin: Scalars['String'];
  grossMarginPercentage: Scalars['Int'];
  id: Scalars['ID'];
  isCustom: Scalars['Boolean'];
  isOptional: Scalars['Boolean'];
  /** In Hours */
  jobDuration: Scalars['Float'];
  jobDurationDaysOverride?: Maybe<Scalars['Float']>;
  jobDurationOverride?: Maybe<Scalars['Float']>;
  jobSize: Scalars['Int'];
  mapData?: Maybe<Scalars['String']>;
  mapImage?: Maybe<Scalars['String']>;
  mapImageDirty: Scalars['Boolean'];
  material: ProposalMaterial;
  measurementJob?: Maybe<ProductMeasurementJob | `${ProductMeasurementJob}`>;
  measurementMaterial?: Maybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  netMargin: Scalars['String'];
  netMarginPercentage: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  operatingMargin: Scalars['String'];
  operatingMarginPercentage: Scalars['Int'];
  ordering: Scalars['Int'];
  overallTotal: Scalars['String'];
  overallTotalAfterDiscount: Scalars['String'];
  overallTotalOverride?: Maybe<Scalars['String']>;
  plantProduct?: Maybe<ProposalPlantProduct>;
  productName?: Maybe<Scalars['String']>;
  profit: Scalars['String'];
  profitAfterDiscount: Scalars['String'];
  profitOverride?: Maybe<Scalars['String']>;
  profitPercentage: Scalars['Int'];
  profitPercentageOverride?: Maybe<Scalars['Int']>;
  projectFiles?: Maybe<Array<ProjectFile>>;
  proposalMaterialNoPlants?: Maybe<Array<Maybe<ProposalMaterialNoPlant>>>;
  proposalPlantProducts?: Maybe<Array<Maybe<ProposalPlantProduct>>>;
  proposalProductGroup?: Maybe<ProposalProductGroup>;
  proposalProductGroupId?: Maybe<Scalars['ID']>;
  roundTripTravelTimeHours?: Maybe<Scalars['Float']>;
  statementOfWork?: Maybe<Scalars['String']>;
  subcontractorCost?: Maybe<Scalars['String']>;
  subcontractorName?: Maybe<Scalars['String']>;
  subcontractorProposalId?: Maybe<Scalars['String']>;
  /** In Hours */
  transferTruckLoadTimeBuffer?: Maybe<Scalars['Float']>;
  /** In Hours */
  transferTruckRoundTripTime?: Maybe<Scalars['Float']>;
  /** In Hours */
  transferTruckRoundTripTimeOverride?: Maybe<Scalars['Float']>;
  /** In Hours */
  transferTruckUnloadTimeBuffer?: Maybe<Scalars['Float']>;
  transferTrucks?: Maybe<Array<Maybe<ProposalTransferTruck>>>;
  unitPriceOverride?: Maybe<Scalars['String']>;
  worksheet?: Maybe<Worksheet>;
};

export type ProposalProductGroup = {
  __typename?: 'ProposalProductGroup';
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
  name: Scalars['String'];
  ordering: Scalars['Int'];
  proposalProducts: Array<ProposalProduct>;
  showIndividualProducts: Scalars['Boolean'];
};

export type ProposalProductProjectFile = {
  __typename?: 'ProposalProductProjectFile';
  id: Scalars['ID'];
};

export type ProposalRecipient = {
  __typename?: 'ProposalRecipient';
  contactId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type ProposalSalesTax = {
  __typename?: 'ProposalSalesTax';
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationSalesTaxId: Scalars['ID'];
  percentage: Scalars['Float'];
};

export enum ProposalSource {
  /** Advertisements */
  ADVERTISEMENTS = 'ADVERTISEMENTS',
  /** Channel sales */
  CHANNEL_SALES = 'CHANNEL_SALES',
  /** Existing relationship */
  EXISTING_RELATIONSHIP = 'EXISTING_RELATIONSHIP',
  /** Expo lead */
  EXPO_LEAD = 'EXPO_LEAD',
  /** External sales */
  EXTERNAL_SALES = 'EXTERNAL_SALES',
  /** Internal sales */
  INTERNAL_SALES = 'INTERNAL_SALES',
  /** Online */
  ONLINE = 'ONLINE',
  /** Other */
  OTHER = 'OTHER',
  /** Referral */
  REFERRAL = 'REFERRAL',
  /** Repeat customer */
  REPEAT_CUSTOMER = 'REPEAT_CUSTOMER',
  /** Social media */
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  /** Trade shows */
  TRADE_SHOWS = 'TRADE_SHOWS',
  /** Website lead */
  WEBSITE_LEAD = 'WEBSITE_LEAD',
  /** Website request */
  WEBSITE_REQUEST = 'WEBSITE_REQUEST'
}

export type ProposalStage = {
  __typename?: 'ProposalStage';
  address?: Maybe<ProposalAddress>;
  addressOverride?: Maybe<Scalars['String']>;
  checklistItems?: Maybe<Array<OrganizationProposalChecklistItem>>;
  checklistNotes?: Maybe<Scalars['String']>;
  costAdditional: Scalars['String'];
  costDirect: Scalars['String'];
  costEquipment: Scalars['String'];
  costIndirect: Scalars['String'];
  costLabour: Scalars['String'];
  costMaterial: Scalars['String'];
  costOverhead: Scalars['String'];
  costTotal: Scalars['String'];
  discount: Scalars['String'];
  distanceMeters?: Maybe<Scalars['Int']>;
  distanceSeconds?: Maybe<Scalars['Int']>;
  grossMargin: Scalars['String'];
  grossMarginPercentage: Scalars['Int'];
  id: Scalars['ID'];
  mapData?: Maybe<Scalars['String']>;
  mapImage?: Maybe<Scalars['String']>;
  mapImageDirty: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  netMargin: Scalars['String'];
  netMarginPercentage: Scalars['Int'];
  operatingMargin: Scalars['String'];
  operatingMarginPercentage: Scalars['Int'];
  ordering: Scalars['Int'];
  overallTotal?: Maybe<Scalars['String']>;
  overallTotalAfterDiscount: Scalars['String'];
  profit: Scalars['String'];
  profitAfterDiscount: Scalars['String'];
  profitPercentage: Scalars['Int'];
  proposalProductGroups: Array<ProposalProductGroup>;
  proposalProducts?: Maybe<Array<ProposalProduct>>;
  roundTripTravelTimeHours?: Maybe<Scalars['Float']>;
  stageMeasurements: Array<ProposalStageMeasurement>;
};

export type ProposalStageChecklistItem = {
  __typename?: 'ProposalStageChecklistItem';
  checklistItem: OrganizationProposalChecklistItem;
  id: Scalars['ID'];
  proposalStage: ProposalStage;
};

export type ProposalStageMeasurement = {
  __typename?: 'ProposalStageMeasurement';
  featureGeojson?: Maybe<Scalars['String']>;
  geojsonFeatureId: Scalars['String'];
  id: Scalars['ID'];
  isScreenshotTarget: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  measurementJob?: Maybe<ProductMeasurementJob | `${ProductMeasurementJob}`>;
  measurementType: ProposalMeasurementType | `${ProposalMeasurementType}`;
  measurementValue?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type ProposalStageOrderingInput = {
  id: Scalars['ID'];
  ordering: Scalars['Int'];
};

export enum ProposalStatus {
  /** Canceled */
  CANCELED = 'CANCELED',
  /** Change order */
  CHANGE_ORDER = 'CHANGE_ORDER',
  /** Closed lost */
  CLOSED_LOST = 'CLOSED_LOST',
  /** Closed won */
  CLOSED_WON = 'CLOSED_WON',
  /** Draft */
  DRAFT = 'DRAFT',
  /** New version */
  NEW_VERSION = 'NEW_VERSION',
  /** On hold */
  ON_HOLD = 'ON_HOLD',
  /** Open */
  OPEN = 'OPEN',
  /** Sent */
  SENT = 'SENT'
}

export type ProposalStatusChange = {
  __typename?: 'ProposalStatusChange';
  changeAt: Scalars['DateTime'];
  changedBy?: Maybe<User>;
  status: ProposalStatus | `${ProposalStatus}`;
};

export type ProposalTransferTruck = {
  __typename?: 'ProposalTransferTruck';
  cost: Scalars['Int'];
  costOverride?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  plantTransferTruckId?: Maybe<Scalars['ID']>;
  proposalPlantProductId?: Maybe<Scalars['ID']>;
  quantity: Scalars['Float'];
  quantityOverride?: Maybe<Scalars['Float']>;
  rateHourly: Scalars['Int'];
  rateHourlyOverride?: Maybe<Scalars['Int']>;
  rateTon: Scalars['Int'];
  rateTonOverride?: Maybe<Scalars['Int']>;
  tonnage: Scalars['Int'];
  totalHaulingHours: Scalars['Int'];
  totalHaulingHoursOverride?: Maybe<Scalars['Int']>;
  transferTruckId: Scalars['ID'];
  truckingProductionRate?: Maybe<Scalars['Float']>;
  trucksNeeded?: Maybe<Scalars['Float']>;
};

export type ProposalUserMetrics = {
  __typename?: 'ProposalUserMetrics';
  avgNetMargin: Scalars['Float'];
  closeRate: Scalars['Float'];
  salesGoal: Scalars['String'];
  sentCount: Scalars['Int'];
  totalProposed: Scalars['String'];
  totalWon: Scalars['String'];
  userId: Scalars['ID'];
  wonCount: Scalars['Int'];
};

export type PublicCompany = {
  __typename?: 'PublicCompany';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type PublicCompanyOrg = {
  __typename?: 'PublicCompanyOrg';
  company: PublicCompany;
  organization: PublicOrganization;
};

export type PublicContact = {
  __typename?: 'PublicContact';
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PublicCustom = {
  __typename?: 'PublicCustom';
  name: Scalars['String'];
  quantity: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type PublicInvoice = {
  __typename?: 'PublicInvoice';
  company: PublicInvoiceCompany;
  data: Scalars['String'];
  hideLineItemPricing: Scalars['Boolean'];
  job: PublicInvoiceJob;
  organization: PublicInvoiceOrganization;
  pageTextParsed: Scalars['String'];
  uuid: Scalars['String'];
};

export type PublicInvoiceAddress = {
  __typename?: 'PublicInvoiceAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type PublicInvoiceCompany = {
  __typename?: 'PublicInvoiceCompany';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type PublicInvoiceJob = {
  __typename?: 'PublicInvoiceJob';
  address?: Maybe<PublicInvoiceAddress>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  proposalStage: PublicInvoiceProposalStage;
};

export type PublicInvoiceOrganization = {
  __typename?: 'PublicInvoiceOrganization';
  address?: Maybe<PublicInvoiceAddress>;
  email: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type PublicInvoiceProposalStage = {
  __typename?: 'PublicInvoiceProposalStage';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PublicInvoiceResponse = PublicInvoice | PublicInvoiceOrganization;

export type PublicOrganization = {
  __typename?: 'PublicOrganization';
  address?: Maybe<OrganizationAddress>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  proposalDefaults: ProposalDefault;
};

export type PublicProposal = {
  __typename?: 'PublicProposal';
  acceptanceOverride?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<OrganizationDocument>>;
  company: PublicCompany;
  contact: PublicContact;
  content: Array<Maybe<ProposalContent>>;
  costTaxes: Scalars['String'];
  discount: Scalars['String'];
  externalId: Scalars['String'];
  externalIdWithPrefix: Scalars['String'];
  id: Scalars['ID'];
  layout: ProposalLayout | `${ProposalLayout}`;
  organization: PublicOrganization;
  overallTotal: Scalars['String'];
  overallTotalAfterDiscount: Scalars['String'];
  overallTotalAfterTaxes: Scalars['String'];
  profitAfterDiscount: Scalars['String'];
  proposalPDF?: Maybe<Scalars['String']>;
  removeIndividualLineItemPricing?: Maybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: Maybe<Scalars['Boolean']>;
  salesTaxes?: Maybe<Array<ProposalSalesTax>>;
  sentAt?: Maybe<Scalars['DateTime']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  signeeInitials?: Maybe<Scalars['String']>;
  signeeName?: Maybe<Scalars['String']>;
  signeeTitle?: Maybe<Scalars['String']>;
  stages: Array<PublicProposalStage>;
  status: ProposalStatus | `${ProposalStatus}`;
  user: PublicUser;
};

export type PublicProposalAddress = {
  __typename?: 'PublicProposalAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  longitude: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type PublicProposalOrganization = {
  __typename?: 'PublicProposalOrganization';
  estimatorEmail: Scalars['String'];
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
};

export type PublicProposalProduct = {
  __typename?: 'PublicProposalProduct';
  additionalCosts?: Maybe<Array<Maybe<ProposalAdditionalCost>>>;
  discount: Scalars['String'];
  files?: Maybe<Array<ProposalFile>>;
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
  jobDuration: Scalars['Float'];
  jobSize: Scalars['Int'];
  mapImage?: Maybe<Scalars['String']>;
  material: ProposalMaterial;
  ordering: Scalars['Int'];
  overallTotal: Scalars['String'];
  overallTotalAfterDiscount: Scalars['String'];
  overallTotalOverride?: Maybe<Scalars['String']>;
  profitAfterDiscount: Scalars['String'];
  projectFiles?: Maybe<Array<ProjectFile>>;
  proposalProductGroupId?: Maybe<Scalars['ID']>;
  statementOfWork?: Maybe<Scalars['String']>;
  worksheet?: Maybe<PublicWorksheet>;
};

export type PublicProposalProductGroup = {
  __typename?: 'PublicProposalProductGroup';
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
  name: Scalars['String'];
  ordering: Scalars['Int'];
  proposalProducts: Array<PublicProposalProduct>;
  showIndividualProducts: Scalars['Boolean'];
};

export type PublicProposalResponse = PublicProposal | PublicProposalOrganization;

export type PublicProposalStage = {
  __typename?: 'PublicProposalStage';
  address?: Maybe<PublicProposalAddress>;
  addressOverride?: Maybe<Scalars['String']>;
  content: Array<Maybe<ProposalContent>>;
  discount: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  ordering: Scalars['Int'];
  overallTotal: Scalars['String'];
  overallTotalAfterDiscount: Scalars['String'];
  profitAfterDiscount: Scalars['String'];
  proposalProductGroups: Array<PublicProposalProductGroup>;
  proposalProducts?: Maybe<Array<PublicProposalProduct>>;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type PublicWorksheet = {
  __typename?: 'PublicWorksheet';
  name: Scalars['String'];
  quantity: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  GetOrganizationApiKeys: Array<OrganizationApiKey>;
  customProducts: Array<CustomProduct>;
  customProposal: Proposal;
  customSettings: CustomSettings;
  getAdditionalCost?: Maybe<AdditionalCost>;
  getAdditionalCosts?: Maybe<AdditionalCostPaginator>;
  getAiMappingRun?: Maybe<AiMappingRun>;
  getAiMappingRunArea: AiMappingRunArea;
  getAiMappingRunAreaResults: AiMappingRunAreaResultsResponse;
  getAiMappingTaskStatus: AiMappingTaskStatus;
  getAllCrews: Array<Crew>;
  getAllDailyFormVehicles: Array<DailyFormVehicle>;
  getArchivedCompanies?: Maybe<CompanyPaginator>;
  getCheckoutUrl: Scalars['String'];
  getCompanies: GetCompaniesResponse;
  getCompany?: Maybe<Company>;
  getCompanyContacts?: Maybe<Array<Contact>>;
  getCompanyProposalActivity: GetCompanyProposalActivityResponse;
  getContactActivities?: Maybe<ActivityPaginator>;
  getCrew?: Maybe<Crew>;
  getCrews?: Maybe<CrewPaginator>;
  getCurrentMonthStats: DashboardDataByMonth;
  getCustomEvent?: Maybe<CustomEvent>;
  getCustomEventBlocks: Array<CustomEventBlock>;
  getDailyFormInspection: DailyFormInspection;
  getDailyFormInspectionQuestion: DailyFormInspectionQuestion;
  getDailyFormInspectionQuestions: Array<DailyFormInspectionQuestion>;
  getDailyFormInspections: GetDailyFormInspectionsResponse;
  getDailyFormVehicle: DailyFormVehicle;
  getDailyFormVehiclePart: DailyFormVehiclePart;
  getDailyFormVehicleParts: Array<DailyFormVehiclePart>;
  getDailyFormVehicleServicePlan: DailyFormVehicleServicePlan;
  getDailyFormVehicleServicePlans: Array<DailyFormVehicleServicePlan>;
  getDailyFormVehicleType: DailyFormVehicleType;
  getDailyFormVehicleTypes: Array<DailyFormVehicleType>;
  getDailyFormVehicles?: Maybe<DailyFormVehiclePaginator>;
  getDailyFormWorkOrder: DailyFormWorkOrder;
  getDailyFormWorkOrders: GetDailyFormWorkOrdersResponse;
  getDashboardExtraKpisYtd: DashboardExtraKpisYtd;
  getDashboardMapData: Array<Maybe<Job>>;
  getEmployee?: Maybe<Employee>;
  getEmployees?: Maybe<EmployeePaginator>;
  getEnabledContentTypesForLayout: Array<OrganizationProposalLayoutContentSetting>;
  getEquipmentPiece?: Maybe<EquipmentPiece>;
  getEquipmentPieces?: Maybe<EquipmentPiecePaginator>;
  getInvoice: Invoice;
  getInvoices: GetInvoicesResponse;
  getJob: Job;
  getJobBillingStatuses: GetJobBillingStatusesResponse;
  getJobCities: Array<Scalars['String']>;
  getJobCostingLapsedReport: GetJobCostingLapsedReportResponse;
  getJobInvoiceStats: Array<JobInvoiceStats>;
  getJobPhase: JobPhase;
  getJobPhaseCostItem?: Maybe<JobPhaseCostItem>;
  getJobPhaseCosts?: Maybe<JobPhaseCostItem>;
  getJobPhases: GetJobPhasesResponse;
  getJobReadinessDashboard: JobReadinessDashboardResponse;
  getJobScheduleByAmountStats: Array<DateWithTotals>;
  getJobScheduleStats: JobScheduleStats;
  getJobSchedules: Array<JobPhaseScheduleBlock>;
  getJobs: GetJobsResponse;
  getJobsSimple: GetJobsResponse;
  getLastYearStats: YearlyDashboardData;
  getManageSubscriptionUrl: Scalars['String'];
  getMaterialNeededByDayStats?: Maybe<Array<DateWithMaterialAmount>>;
  getMyTasks?: Maybe<TaskPaginator>;
  getNotificationTrigger: NotificationTrigger;
  getNotificationTriggers?: Maybe<Array<NotificationTrigger>>;
  getOpportunities: GetOpportunitiesResponse;
  getOpportunity?: Maybe<Opportunity>;
  getOpportunityStatuses: Array<OrganizationOpportunityStatus>;
  getOrganizationAddress?: Maybe<OrganizationAddress>;
  getOrganizationAddresses?: Maybe<OrganizationAddressPaginator>;
  getOrganizationDataUploads?: Maybe<OrganizationDataUploadPaginator>;
  getOrganizationEmailIdentity?: Maybe<OrganizationEmailIdentity>;
  getOrganizationEmailTemplate?: Maybe<OrganizationEmailTemplate>;
  getOrganizationEmailTemplates?: Maybe<Array<OrganizationEmailTemplate>>;
  getOrganizationProductType: OrganizationProductType;
  getOrganizationProductTypes: Array<OrganizationProductType>;
  getOrganizationProposalContent?: Maybe<Array<OrganizationProposalContent>>;
  getOrganizationProposalLayoutContentSettings: Array<OrganizationProposalLayoutContentSetting>;
  getOrganizationSettings: Array<OrganizationSetting>;
  getOrganizationUser?: Maybe<User>;
  getOrganizationUsers?: Maybe<UserPaginator>;
  getOutstandingWorkReport: OutstandingWorkReportResponse;
  getPersonPerformanceYtd: Array<PersonPerformanceYtdRow>;
  getPlant: Plant;
  getPlantProductTypes?: Maybe<Array<ModelsPlantProductType>>;
  getPlantTransferTrucks: Array<PlantTransferTruck>;
  getPlants?: Maybe<PlantPaginator>;
  getPreviousMonthStats: DashboardDataByMonth;
  getProduct?: Maybe<Product>;
  getProductGroup?: Maybe<ProductGroup>;
  getProductGroups?: Maybe<ProductGroupPaginator>;
  getProductStats: ProductStats;
  getProducts?: Maybe<ProductPaginator>;
  getProjectFile: ProjectFile;
  getProjectFiles: Array<ProjectFile>;
  getProjectMap: ProjectMap;
  getProjectMaps: GetProjectMapsResponse;
  getProposal: Proposal;
  getProposalProductMapData?: Maybe<Scalars['String']>;
  getProposalUserMetrics: ProposalUserMetrics;
  getProposals: GetProposalsResponse;
  getPublicInvoice: PublicInvoiceResponse;
  getPublicProposal: PublicProposalResponse;
  getPublicProposalCompanyOrg?: Maybe<PublicCompanyOrg>;
  getQuickbooksIncomeAccounts?: Maybe<Array<QuickbooksIncomeAccount>>;
  getQuickbooksTaxCodes?: Maybe<Array<QuickbooksTaxCode>>;
  getQuickbooksTaxRates?: Maybe<Array<QuickbooksTaxRate>>;
  getQuickbooksTimeExportRun?: Maybe<QuickbooksTimeExportRun>;
  getQuickbooksTimeExportRunItems: QuickbooksTimeExportRunItemsResponse;
  getQuickbooksTimeExportRuns: QuickbooksTimeExportRunsResponse;
  getRolesWithPermissions?: Maybe<RolesWithPermissions>;
  getTimeBucket?: Maybe<TimeBucket>;
  getTimeBuckets: Array<TimeBucket>;
  getTimeEntries: GetTimeEntriesResponse;
  getTimeEntriesGroupedByUser: GetTimeEntriesGroupedByUserResponse;
  getTransferTruck?: Maybe<TransferTruck>;
  getTransferTrucks: Array<TransferTruck>;
  getUserOrganization: Organization;
  getYearOverYearRevenueReport: GetYearOverYearRevenueReportResponse;
  getYearToDateStats: YearToDateStats;
  isCompanySearchable?: Maybe<Scalars['Boolean']>;
  isJobSearchable?: Maybe<Scalars['Boolean']>;
  isOpportunitySearchable?: Maybe<Scalars['Boolean']>;
  isProposalSearchable?: Maybe<Scalars['Boolean']>;
  me?: Maybe<User>;
  notificationTriggerDeliveries: Array<WebhookDelivery>;
  organizationProposalChecklistItems: Array<OrganizationProposalChecklistItem>;
  previewSubscriptionChange?: Maybe<PreviewSubscriptionChangeResponse>;
  /** Search a related record (Proposal/Job/Opportunity) for linking a Task. */
  taskRelatedSearch: Array<TaskRelatedResult>;
  timeEntry?: Maybe<TimeEntry>;
  validateLogin?: Maybe<Scalars['Boolean']>;
  validateUserInviteToken: Scalars['Boolean'];
  worksheetProducts: Array<WorksheetProduct>;
  worksheetProposal: Proposal;
  worksheetSettings: WorksheetSettings;
};


export type QueryCustomProposalArgs = {
  id: Scalars['ID'];
};


export type QueryGetAdditionalCostArgs = {
  id: Scalars['ID'];
};


export type QueryGetAdditionalCostsArgs = {
  feeType?: InputMaybe<AdditionalCostFeeType>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
};


export type QueryGetAiMappingRunArgs = {
  projectMapId: Scalars['ID'];
};


export type QueryGetAiMappingRunAreaArgs = {
  id: Scalars['ID'];
};


export type QueryGetAiMappingRunAreaResultsArgs = {
  id: Scalars['ID'];
};


export type QueryGetAiMappingTaskStatusArgs = {
  taskId: Scalars['String'];
};


export type QueryGetArchivedCompaniesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCompaniesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
};


export type QueryGetCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyContactsArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyProposalActivityArgs = {
  companyId: Scalars['ID'];
  contactId?: InputMaybe<Scalars['ID']>;
  first?: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetContactActivitiesArgs = {
  contactId: Scalars['ID'];
  first: Scalars['Int'];
  opportunityId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCrewArgs = {
  id: Scalars['ID'];
};


export type QueryGetCrewsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
};


export type QueryGetCustomEventArgs = {
  id: Scalars['ID'];
};


export type QueryGetCustomEventBlocksArgs = {
  crewId?: InputMaybe<Scalars['ID']>;
  customEventIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetDailyFormInspectionArgs = {
  id: Scalars['ID'];
};


export type QueryGetDailyFormInspectionQuestionArgs = {
  id: Scalars['ID'];
};


export type QueryGetDailyFormInspectionsArgs = {
  dailyFormVehicleId?: InputMaybe<Scalars['ID']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<QueryDailyFormInspectionsSortKey>;
};


export type QueryGetDailyFormVehicleArgs = {
  id: Scalars['ID'];
};


export type QueryGetDailyFormVehiclePartArgs = {
  id: Scalars['ID'];
};


export type QueryGetDailyFormVehicleServicePlanArgs = {
  id: Scalars['ID'];
};


export type QueryGetDailyFormVehicleTypeArgs = {
  id: Scalars['ID'];
};


export type QueryGetDailyFormVehiclesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDailyFormWorkOrderArgs = {
  id: Scalars['ID'];
};


export type QueryGetDailyFormWorkOrdersArgs = {
  assignedTo?: InputMaybe<Scalars['ID']>;
  completedDate?: InputMaybe<Scalars['Date']>;
  first: Scalars['Int'];
  multipleAssignedTo?: InputMaybe<Array<Scalars['ID']>>;
  multiplePriorities?: InputMaybe<Array<DailyFormIssuePriority>>;
  multipleStatuses?: InputMaybe<Array<DailyFormIssueStatus>>;
  neededCompletionDate?: InputMaybe<Scalars['Date']>;
  page?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<DailyFormIssuePriority>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<QueryDailyFormWorkOrdersSortKey>;
  status?: InputMaybe<DailyFormIssueStatus>;
  vehicleId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetEmployeeArgs = {
  id: Scalars['ID'];
};


export type QueryGetEmployeesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
};


export type QueryGetEnabledContentTypesForLayoutArgs = {
  layout: ProposalLayout;
};


export type QueryGetEquipmentPieceArgs = {
  id: Scalars['ID'];
};


export type QueryGetEquipmentPiecesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
};


export type QueryGetInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryGetInvoicesArgs = {
  billingStatuses?: InputMaybe<Array<JobBillingStatus>>;
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  isOverdue?: InputMaybe<Scalars['Boolean']>;
  jobStatuses?: InputMaybe<Array<JobStatus>>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetInvoicesSortKey>;
  status?: InputMaybe<InvoiceStatus>;
};


export type QueryGetJobArgs = {
  id: Scalars['ID'];
};


export type QueryGetJobCostingLapsedReportArgs = {
  first: Scalars['Int'];
  jobsInPast?: InputMaybe<Scalars['Boolean']>;
  jobsWithoutCosts?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobCostingLapsedReportSortKey>;
  statuses?: InputMaybe<Array<JobStatus>>;
};


export type QueryGetJobPhaseArgs = {
  id: Scalars['ID'];
};


export type QueryGetJobPhaseCostItemArgs = {
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
};


export type QueryGetJobPhaseCostsArgs = {
  id: Scalars['ID'];
};


export type QueryGetJobPhasesArgs = {
  billingStatuses?: InputMaybe<Array<JobBillingStatus>>;
  companyId?: InputMaybe<Scalars['ID']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  first: Scalars['Int'];
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetJobReadinessDashboardArgs = {
  crewId?: InputMaybe<Scalars['ID']>;
  endDate: Scalars['Date'];
  jobIds?: InputMaybe<Array<Scalars['ID']>>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
};


export type QueryGetJobScheduleStatsArgs = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueryGetJobSchedulesArgs = {
  crewId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
  jobIds?: InputMaybe<Array<Scalars['ID']>>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetJobsArgs = {
  billingStatuses?: InputMaybe<Array<JobBillingStatus>>;
  cities?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']>>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']>>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']>>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  statuses?: InputMaybe<Array<JobStatus>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetJobsSimpleArgs = {
  billingStatuses?: InputMaybe<Array<JobBillingStatus>>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']>>;
  jobName?: InputMaybe<Scalars['String']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  statuses?: InputMaybe<Array<JobStatus>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetMyTasksArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetNotificationTriggerArgs = {
  id: Scalars['ID'];
};


export type QueryGetOpportunitiesArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  contactName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['Date']>;
  first: Scalars['Int'];
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']>>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetOpportunitiesSortKey>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetOpportunityArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationAddressArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationAddressesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrganizationDataUploadsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrganizationEmailTemplateArgs = {
  type: OrganizationEmailTemplateType;
};


export type QueryGetOrganizationProductTypeArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationUserArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationUsersArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  roles?: InputMaybe<Array<InputMaybe<UserRole>>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
};


export type QueryGetOutstandingWorkReportArgs = {
  endDate: Scalars['DateTime'];
  mode?: InputMaybe<OutstandingWorkReportMode>;
  startDate: Scalars['DateTime'];
};


export type QueryGetPlantArgs = {
  id: Scalars['ID'];
};


export type QueryGetPlantTransferTrucksArgs = {
  plantId: Scalars['ID'];
};


export type QueryGetPlantsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetProductGroupArgs = {
  id: Scalars['ID'];
};


export type QueryGetProductGroupsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QueryGetProductsOrderByOrderByClause>>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProductType>;
};


export type QueryGetProjectFileArgs = {
  id: Scalars['ID'];
};


export type QueryGetProjectMapArgs = {
  id: Scalars['ID'];
};


export type QueryGetProjectMapsArgs = {
  first?: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetProjectMapsSortKey>;
};


export type QueryGetProposalArgs = {
  id: Scalars['ID'];
};


export type QueryGetProposalProductMapDataArgs = {
  proposalProductId: Scalars['ID'];
  token: Scalars['String'];
};


export type QueryGetProposalUserMetricsArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetProposalsArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']>>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']>>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetProposalsSortKey>;
  statuses?: InputMaybe<Array<ProposalStatus>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetPublicInvoiceArgs = {
  email?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};


export type QueryGetPublicProposalArgs = {
  email?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};


export type QueryGetPublicProposalCompanyOrgArgs = {
  uuid: Scalars['String'];
};


export type QueryGetQuickbooksTimeExportRunArgs = {
  id: Scalars['ID'];
};


export type QueryGetQuickbooksTimeExportRunItemsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  runId: Scalars['ID'];
  status?: InputMaybe<QuickbooksTimeExportItemStatus>;
};


export type QueryGetQuickbooksTimeExportRunsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<QuickbooksTimeExportRunStatus>;
};


export type QueryGetTimeBucketArgs = {
  id: Scalars['ID'];
};


export type QueryGetTimeEntriesArgs = {
  first: Scalars['Int'];
  forDate?: InputMaybe<Scalars['Date']>;
  forDateEnd?: InputMaybe<Scalars['Date']>;
  forDateStart?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetTimeEntriesSortKey>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetTimeEntriesGroupedByUserArgs = {
  first: Scalars['Int'];
  forDate?: InputMaybe<Scalars['Date']>;
  forDateEnd?: InputMaybe<Scalars['Date']>;
  forDateStart?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetTransferTruckArgs = {
  id: Scalars['ID'];
};


export type QueryIsCompanySearchableArgs = {
  id: Scalars['ID'];
};


export type QueryIsJobSearchableArgs = {
  id: Scalars['ID'];
};


export type QueryIsOpportunitySearchableArgs = {
  id: Scalars['ID'];
};


export type QueryIsProposalSearchableArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationTriggerDeliveriesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  triggerId: Scalars['ID'];
};


export type QueryPreviewSubscriptionChangeArgs = {
  email?: InputMaybe<Scalars['String']>;
  quantityChange: Scalars['Int'];
};


export type QueryTaskRelatedSearchArgs = {
  first?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  type: Scalars['String'];
};


export type QueryTimeEntryArgs = {
  id: Scalars['ID'];
};


export type QueryValidateLoginArgs = {
  input: ValidateLoginInput;
};


export type QueryValidateUserInviteTokenArgs = {
  email: Scalars['String'];
  inviteToken: Scalars['String'];
};


export type QueryWorksheetProposalArgs = {
  id: Scalars['ID'];
};

export enum QueryDailyFormInspectionsSortKey {
  CREATED_AT = 'CREATED_AT',
  DAILY_FORM_VEHICLE_NAME = 'DAILY_FORM_VEHICLE_NAME',
  ID = 'ID'
}

export enum QueryDailyFormWorkOrdersSortKey {
  ASSIGNED_TO = 'ASSIGNED_TO',
  COMPLETED_AT = 'COMPLETED_AT',
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  ISSUE_NAME = 'ISSUE_NAME',
  NEEDED_COMPLETION_DATE = 'NEEDED_COMPLETION_DATE',
  PRIORITY = 'PRIORITY',
  STATUS = 'STATUS',
  SUBMITTED_BY = 'SUBMITTED_BY',
  UPDATED_AT = 'UPDATED_AT',
  VEHICLE = 'VEHICLE'
}

/** Allowed column names for Query.getProducts.orderBy. */
export enum QueryGetProductsOrderByColumn {
  NAME = 'NAME'
}

/** Order by clause for Query.getProducts.orderBy. */
export type QueryGetProductsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryGetProductsOrderByColumn | `${QueryGetProductsOrderByColumn}`;
  /** The direction that is used for ordering. */
  order: SortOrder | `${SortOrder}`;
};

export type QuickbooksIncomeAccount = {
  __typename?: 'QuickbooksIncomeAccount';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type QuickbooksIntegrationInput = {
  data: Scalars['String'];
  jobId: Scalars['ID'];
};

export type QuickbooksSyncBatch = {
  __typename?: 'QuickbooksSyncBatch';
  billedTotalAmount: Scalars['Int'];
  billingMode: QuickbooksSyncBatchBillingMode | `${QuickbooksSyncBatchBillingMode}`;
  company: Company;
  createEstimate: Scalars['Boolean'];
  createInvoice: Scalars['Boolean'];
  createJob: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isDeposit: Scalars['Boolean'];
  jobs: Array<QuickbooksSyncBatchJob>;
  lines: Array<QuickbooksSyncBatchLine>;
  partialAmountCents?: Maybe<Scalars['Int']>;
  partialPercentage?: Maybe<Scalars['Float']>;
  quickbooksDesktopError?: Maybe<Scalars['String']>;
  quickbooksDesktopQueuedAt?: Maybe<Scalars['DateTime']>;
  quickbooksDesktopStatus: QuickbooksSyncBatchStatus | `${QuickbooksSyncBatchStatus}`;
  quickbooksOnlineDocumentId?: Maybe<Scalars['String']>;
  quickbooksOnlineDocumentType?: Maybe<Scalars['String']>;
  quickbooksOnlineError?: Maybe<Scalars['String']>;
  quickbooksOnlineStatus: QuickbooksSyncBatchStatus | `${QuickbooksSyncBatchStatus}`;
  selectedTotalAmount: Scalars['Int'];
  syncedDesktopAt?: Maybe<Scalars['DateTime']>;
  syncedOnlineAt?: Maybe<Scalars['DateTime']>;
};

export enum QuickbooksSyncBatchBillingMode {
  /** Fixed amount */
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  /** Full */
  FULL = 'FULL',
  /** Percentage */
  PERCENTAGE = 'PERCENTAGE'
}

export type QuickbooksSyncBatchJob = {
  __typename?: 'QuickbooksSyncBatchJob';
  billedAmount: Scalars['Int'];
  id: Scalars['ID'];
  job: Job;
  selectedAmount: Scalars['Int'];
};

export type QuickbooksSyncBatchLine = {
  __typename?: 'QuickbooksSyncBatchLine';
  billedAmount: Scalars['Int'];
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemDescription?: Maybe<Scalars['String']>;
  itemName: Scalars['String'];
  job?: Maybe<Job>;
  jobPhase?: Maybe<JobPhase>;
  originalAmount: Scalars['Int'];
  proposalProductGroup?: Maybe<ProposalProductGroup>;
  sortOrder: Scalars['Int'];
  sourceType: QuickbooksSyncBatchLineSourceType | `${QuickbooksSyncBatchLineSourceType}`;
};

export type QuickbooksSyncBatchLineInput = {
  amount: Scalars['Int'];
  billedAmount?: InputMaybe<Scalars['Int']>;
  groupName?: InputMaybe<Scalars['String']>;
  itemDescription?: InputMaybe<Scalars['String']>;
  itemName: Scalars['String'];
  jobId: Scalars['ID'];
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  proposalProductGroupId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export enum QuickbooksSyncBatchLineSourceType {
  /** Job phase */
  JOB_PHASE = 'JOB_PHASE',
  /** Manual */
  MANUAL = 'MANUAL'
}

export type QuickbooksSyncBatchManualLineInput = {
  amount: Scalars['Int'];
  billedAmount?: InputMaybe<Scalars['Int']>;
  itemDescription?: InputMaybe<Scalars['String']>;
  itemName: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export enum QuickbooksSyncBatchStatus {
  /** Failed */
  FAILED = 'FAILED',
  /** Not requested */
  NOT_REQUESTED = 'NOT_REQUESTED',
  /** Queued */
  QUEUED = 'QUEUED',
  /** Success */
  SUCCESS = 'SUCCESS'
}

export type QuickbooksTaxCode = {
  __typename?: 'QuickbooksTaxCode';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type QuickbooksTaxRate = {
  __typename?: 'QuickbooksTaxRate';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rateValue?: Maybe<Scalars['Float']>;
};

export type QuickbooksTimeExportItem = {
  __typename?: 'QuickbooksTimeExportItem';
  attemptCount: Scalars['Int'];
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorPayload?: Maybe<Scalars['String']>;
  exportedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lastAttemptAt?: Maybe<Scalars['DateTime']>;
  organizationId: Scalars['ID'];
  qboCustomerId?: Maybe<Scalars['String']>;
  qboEmployeeId?: Maybe<Scalars['String']>;
  qboJobId?: Maybe<Scalars['String']>;
  qboTimeActivityId?: Maybe<Scalars['String']>;
  recommendedAction?: Maybe<Scalars['String']>;
  retryable: Scalars['Boolean'];
  runId: Scalars['ID'];
  status: QuickbooksTimeExportItemStatus | `${QuickbooksTimeExportItemStatus}`;
  timeEntry?: Maybe<TimeEntry>;
  timeEntryId: Scalars['ID'];
};

export enum QuickbooksTimeExportItemStatus {
  EXPORTED = 'EXPORTED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  QUEUED = 'QUEUED',
  SKIPPED = 'SKIPPED'
}

export type QuickbooksTimeExportRun = {
  __typename?: 'QuickbooksTimeExportRun';
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['ID']>;
  dateEnd: Scalars['Date'];
  dateStart: Scalars['Date'];
  failedItems: Scalars['Int'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  itemsCount: Scalars['Int'];
  lastErrorCode?: Maybe<Scalars['String']>;
  lastErrorMessage?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  organizationLinkedServiceId?: Maybe<Scalars['ID']>;
  processedItems: Scalars['Int'];
  skippedItems: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: QuickbooksTimeExportRunStatus | `${QuickbooksTimeExportRunStatus}`;
  succeededItems: Scalars['Int'];
  totalItems: Scalars['Int'];
};

export type QuickbooksTimeExportRunItemsResponse = {
  __typename?: 'QuickbooksTimeExportRunItemsResponse';
  data: Array<QuickbooksTimeExportItem>;
  paginatorInfo: PaginatorInfo;
};

export enum QuickbooksTimeExportRunStatus {
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING'
}

export type QuickbooksTimeExportRunsResponse = {
  __typename?: 'QuickbooksTimeExportRunsResponse';
  data: Array<QuickbooksTimeExportRun>;
  paginatorInfo: PaginatorInfo;
};

export type ReassignTaskInput = {
  assignedUserId: Scalars['ID'];
  id: Scalars['ID'];
};

export type RegisterInput = {
  companyName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  token: Scalars['String'];
};

export type ReportCrewDetailsItem = {
  __typename?: 'ReportCrewDetailsItem';
  actual_labour_hours: Scalars['Float'];
  crew_name?: Maybe<Scalars['String']>;
  estimated_labour_hours: Scalars['Float'];
  job_id: Scalars['ID'];
  job_size: Scalars['String'];
  material_cost_type?: Maybe<Scalars['String']>;
  proposal_total_amount: Scalars['Float'];
  total_material_used: Scalars['Float'];
};

export type ReportEquipmentCostDetailsItem = {
  __typename?: 'ReportEquipmentCostDetailsItem';
  equipmentCost: Scalars['Float'];
  equipmentHours: Scalars['Float'];
  equipmentId?: Maybe<Scalars['ID']>;
  equipmentName: Scalars['String'];
  jobId: Scalars['ID'];
};

export type ReportJobCostByProductTypeItem = {
  __typename?: 'ReportJobCostByProductTypeItem';
  actual_cost_equipment: Scalars['Float'];
  actual_cost_labour: Scalars['Float'];
  actual_cost_material: Scalars['Float'];
  actual_cost_transfer_truck: Scalars['Float'];
  actual_employee_hours: Scalars['Float'];
  job_id: Scalars['ID'];
  job_size: Scalars['String'];
  organization_product_type_name: Scalars['String'];
  proposed_cost_equipment: Scalars['Float'];
  proposed_cost_labour: Scalars['Float'];
  proposed_cost_material: Scalars['Float'];
  proposed_cost_transfer_truck: Scalars['Float'];
  proposed_employee_hours: Scalars['Float'];
};

export type ReportJobCostDetailAdditionalCostItem = {
  __typename?: 'ReportJobCostDetailAdditionalCostItem';
  cost: Scalars['Float'];
  date: Scalars['String'];
  expense: Scalars['String'];
  qty: Scalars['Float'];
  rate: Scalars['Float'];
};

export type ReportJobCostDetailEmployeeItem = {
  __typename?: 'ReportJobCostDetailEmployeeItem';
  cost: Scalars['Float'];
  date: Scalars['String'];
  employee: Scalars['String'];
  hours: Scalars['Float'];
  rate: Scalars['Float'];
};

export type ReportJobCostDetailEquipmentItem = {
  __typename?: 'ReportJobCostDetailEquipmentItem';
  cost: Scalars['Float'];
  date: Scalars['String'];
  equipment: Scalars['String'];
  hours: Scalars['Float'];
  rate: Scalars['Float'];
};

export type ReportJobCostDetailHeader = {
  __typename?: 'ReportJobCostDetailHeader';
  company_name: Scalars['String'];
  job_external_id: Scalars['String'];
  job_id: Scalars['ID'];
  job_name: Scalars['String'];
  status: Scalars['String'];
  total_proposed_amount: Scalars['Float'];
};

export type ReportJobCostDetailMaterialItem = {
  __typename?: 'ReportJobCostDetailMaterialItem';
  cost: Scalars['Float'];
  date: Scalars['String'];
  material: Scalars['String'];
  qty: Scalars['Float'];
  rate: Scalars['Float'];
};

export type ReportJobCostDetailSummary = {
  __typename?: 'ReportJobCostDetailSummary';
  actual_profit: Scalars['Float'];
  additional_costs_difference_percent: Scalars['Float'];
  additional_costs_total: Scalars['Float'];
  employees_difference_percent: Scalars['Float'];
  employees_total: Scalars['Float'];
  equipment_difference_percent: Scalars['Float'];
  equipment_total: Scalars['Float'];
  material_difference_percent: Scalars['Float'];
  material_total: Scalars['Float'];
  profit_difference_percent: Scalars['Float'];
  proposed_additional_costs_total: Scalars['Float'];
  proposed_employees_total: Scalars['Float'];
  proposed_equipment_total: Scalars['Float'];
  proposed_material_total: Scalars['Float'];
  proposed_profit: Scalars['Float'];
  proposed_total_job_cost: Scalars['Float'];
  proposed_trucking_total: Scalars['Float'];
  total_job_cost: Scalars['Float'];
  total_job_cost_difference_percent: Scalars['Float'];
  trucking_difference_percent: Scalars['Float'];
  trucking_total: Scalars['Float'];
};

export type ReportJobCostDetailTruckingItem = {
  __typename?: 'ReportJobCostDetailTruckingItem';
  cost: Scalars['Float'];
  date: Scalars['String'];
  qty: Scalars['Float'];
  rate: Scalars['Float'];
  truck: Scalars['String'];
};

export type ReportJobDetailsItem = {
  __typename?: 'ReportJobDetailsItem';
  actual_cost_additional?: Maybe<Scalars['Float']>;
  actual_cost_direct?: Maybe<Scalars['Float']>;
  actual_cost_equipment?: Maybe<Scalars['Float']>;
  actual_cost_indirect?: Maybe<Scalars['Float']>;
  actual_cost_labour?: Maybe<Scalars['Float']>;
  actual_cost_material?: Maybe<Scalars['Float']>;
  actual_cost_overhead?: Maybe<Scalars['Float']>;
  actual_cost_total?: Maybe<Scalars['Float']>;
  actual_gross_margin?: Maybe<Scalars['Float']>;
  actual_gross_margin_percentage?: Maybe<Scalars['Float']>;
  actual_net_margin?: Maybe<Scalars['Float']>;
  actual_net_margin_percentage?: Maybe<Scalars['Float']>;
  actual_operating_margin?: Maybe<Scalars['Float']>;
  actual_operating_margin_percentage?: Maybe<Scalars['Float']>;
  actual_overall_total?: Maybe<Scalars['Float']>;
  actual_profit?: Maybe<Scalars['Float']>;
  actual_profit_percentage?: Maybe<Scalars['Float']>;
  company_name?: Maybe<Scalars['String']>;
  crew_display_name?: Maybe<Scalars['String']>;
  crew_name?: Maybe<Scalars['String']>;
  ends_at?: Maybe<Scalars['String']>;
  job_address_city?: Maybe<Scalars['String']>;
  job_address_line_1?: Maybe<Scalars['String']>;
  job_address_state?: Maybe<Scalars['String']>;
  job_address_zip?: Maybe<Scalars['String']>;
  job_external_id: Scalars['String'];
  job_id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  organization_product_type_name?: Maybe<Scalars['String']>;
  proposal_external_id: Scalars['String'];
  proposal_product_job_duration?: Maybe<Scalars['String']>;
  proposal_product_job_size?: Maybe<Scalars['String']>;
  proposal_product_material_type?: Maybe<Scalars['String']>;
  proposal_product_material_used?: Maybe<Scalars['String']>;
  proposal_product_name?: Maybe<Scalars['String']>;
  proposal_stage_id: Scalars['String'];
  proposal_stage_name?: Maybe<Scalars['String']>;
  proposed_cost_additional?: Maybe<Scalars['Float']>;
  proposed_cost_direct?: Maybe<Scalars['Float']>;
  proposed_cost_equipment?: Maybe<Scalars['Float']>;
  proposed_cost_indirect?: Maybe<Scalars['Float']>;
  proposed_cost_labour?: Maybe<Scalars['Float']>;
  proposed_cost_material?: Maybe<Scalars['Float']>;
  proposed_cost_overhead?: Maybe<Scalars['Float']>;
  proposed_cost_total?: Maybe<Scalars['Float']>;
  proposed_gross_margin?: Maybe<Scalars['Float']>;
  proposed_gross_margin_percentage?: Maybe<Scalars['Float']>;
  proposed_net_margin?: Maybe<Scalars['Float']>;
  proposed_net_margin_percentage?: Maybe<Scalars['Float']>;
  proposed_operating_margin?: Maybe<Scalars['Float']>;
  proposed_operating_margin_percentage?: Maybe<Scalars['Float']>;
  proposed_overall_total?: Maybe<Scalars['Float']>;
  proposed_profit?: Maybe<Scalars['Float']>;
  proposed_profit_percentage?: Maybe<Scalars['Float']>;
  starts_at?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ReportOrganizationProfitabilityItem = {
  __typename?: 'ReportOrganizationProfitabilityItem';
  actual_cost_additional: Scalars['Float'];
  actual_cost_equipment: Scalars['Float'];
  actual_cost_labour: Scalars['Float'];
  actual_cost_material: Scalars['Float'];
  actual_cost_transfer_truck: Scalars['Float'];
  actual_profit: Scalars['Float'];
  additional_variance_percentage?: Maybe<Scalars['Float']>;
  cost_basis?: Maybe<Scalars['String']>;
  equipment_variance_percentage?: Maybe<Scalars['Float']>;
  items_without_costs?: Maybe<Scalars['Int']>;
  labour_variance_percentage?: Maybe<Scalars['Float']>;
  material_variance_percentage?: Maybe<Scalars['Float']>;
  organization_product_type_name: Scalars['String'];
  profit_variance_dollars?: Maybe<Scalars['Float']>;
  profit_variance_percentage?: Maybe<Scalars['Float']>;
  proposed_cost_additional: Scalars['Float'];
  proposed_cost_equipment: Scalars['Float'];
  proposed_cost_labour: Scalars['Float'];
  proposed_cost_material: Scalars['Float'];
  proposed_cost_transfer_truck: Scalars['Float'];
  proposed_profit?: Maybe<Scalars['Float']>;
  trucking_variance_percentage?: Maybe<Scalars['Float']>;
};

export enum ReportType {
  /** Additional cost details */
  ADDITIONAL_COST_DETAILS = 'ADDITIONAL_COST_DETAILS',
  /** Company or client details */
  COMPANY_OR_CLIENT_DETAILS = 'COMPANY_OR_CLIENT_DETAILS',
  /** Contact details */
  CONTACT_DETAILS = 'CONTACT_DETAILS',
  /** Crew details */
  CREW_DETAILS = 'CREW_DETAILS',
  /** Equipment cost details */
  EQUIPMENT_COST_DETAILS = 'EQUIPMENT_COST_DETAILS',
  /** Jobs by contact */
  JOBS_BY_CONTACT = 'JOBS_BY_CONTACT',
  /** Job cost by product type */
  JOB_COST_BY_PRODUCT_TYPE = 'JOB_COST_BY_PRODUCT_TYPE',
  /** Job cost detail */
  JOB_COST_DETAIL = 'JOB_COST_DETAIL',
  /** Job details */
  JOB_DETAILS = 'JOB_DETAILS',
  /** Organization profitability */
  ORGANIZATION_PROFITABILITY = 'ORGANIZATION_PROFITABILITY',
  /** Product details */
  PRODUCT_DETAILS = 'PRODUCT_DETAILS',
  /** Proposal details */
  PROPOSAL_DETAILS = 'PROPOSAL_DETAILS',
  /** Sales by contact */
  SALES_BY_CONTACT = 'SALES_BY_CONTACT',
  /** Sales by product summary */
  SALES_BY_PRODUCT_SUMMARY = 'SALES_BY_PRODUCT_SUMMARY',
  /** Sales by proposal source */
  SALES_BY_PROPOSAL_SOURCE = 'SALES_BY_PROPOSAL_SOURCE',
  /** Time entries */
  TIME_ENTRIES = 'TIME_ENTRIES'
}

export type RequestPasswordResetInput = {
  email: Scalars['String'];
};

export type ResendVerificationEmailInput = {
  email: Scalars['String'];
};

export type ResetPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type RolesWithPermissions = {
  __typename?: 'RolesWithPermissions';
  admin?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  employee?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  foreman?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  officeManager?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  salesperson?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  subcontractor?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
};

export type SalesByContact = {
  __typename?: 'SalesByContact';
  customerName?: Maybe<Scalars['String']>;
  jobSize?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
};

export type SalesByProductSummaryItem = {
  __typename?: 'SalesByProductSummaryItem';
  amount?: Maybe<Scalars['String']>;
  avgUnitPrice?: Maybe<Scalars['String']>;
  perOfSales?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  totalJobSize?: Maybe<Scalars['String']>;
  totalMaterialQuantity?: Maybe<Scalars['String']>;
};

export type SalesByProposalSource = {
  __typename?: 'SalesByProposalSource';
  orgRevenuePercentage?: Maybe<Scalars['Float']>;
  pTotal?: Maybe<Scalars['Int']>;
  proposalsWonAmountTotal?: Maybe<Scalars['Float']>;
  proposalsWonCount?: Maybe<Scalars['Int']>;
  s1?: Maybe<Scalars['String']>;
  winRate?: Maybe<Scalars['Float']>;
};

export type SaveOrganizationEmailIdentityInput = {
  fromName?: InputMaybe<Scalars['String']>;
  invoiceLocalPart: Scalars['String'];
  notificationsLocalPart: Scalars['String'];
  proposalLocalPart: Scalars['String'];
  replyToCustomEmail?: InputMaybe<Scalars['String']>;
  replyToType: EmailIdentityReplyToType | `${EmailIdentityReplyToType}`;
  sendingDomain: Scalars['String'];
};

export type SaveQuickbooksIntegrationInput = {
  customerBillingAddressCity?: InputMaybe<Scalars['String']>;
  customerBillingAddressCountry?: InputMaybe<Scalars['String']>;
  customerBillingAddressLine1?: InputMaybe<Scalars['String']>;
  customerBillingAddressLine2?: InputMaybe<Scalars['String']>;
  customerBillingAddressState?: InputMaybe<Scalars['String']>;
  customerBillingAddressZip?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<ItemsQuickbooksDetailInput>>>;
  jobName?: InputMaybe<Scalars['String']>;
  shipAddressAddressCity?: InputMaybe<Scalars['String']>;
  shipAddressAddressLine1?: InputMaybe<Scalars['String']>;
  shipAddressAddressLine2?: InputMaybe<Scalars['String']>;
  shipAddressAddressState?: InputMaybe<Scalars['String']>;
  shipAddressAddressZip?: InputMaybe<Scalars['String']>;
  taxReference?: InputMaybe<Scalars['String']>;
  totalAmountItems?: InputMaybe<Scalars['Int']>;
};

export type ScheduleCustomEventBlockInput = {
  blockId: Scalars['ID'];
  blockLength: Scalars['Float'];
  scheduledAt: Scalars['DateTime'];
};

export type ScheduleJobInput = {
  blocks: Array<AddJobPhaseScheduleBlock>;
  crewId?: InputMaybe<Scalars['ID']>;
  jobId: Scalars['ID'];
  /** Travel time estimate in hours */
  travelTimeEstimate?: InputMaybe<Scalars['Float']>;
  userIDs?: InputMaybe<Array<Scalars['ID']>>;
  usersColor?: InputMaybe<Scalars['String']>;
};

export type ScheduleJobPhaseBlockInput = {
  blockId: Scalars['ID'];
  blockLength: Scalars['Float'];
  scheduledAt: Scalars['DateTime'];
  showTravelFrom: Scalars['Boolean'];
  showTravelTo: Scalars['Boolean'];
  travelTimeEstimate?: InputMaybe<Scalars['Float']>;
};

export enum SesVerificationStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  TEMPORARY_FAILURE = 'TEMPORARY_FAILURE',
  VERIFIED = 'VERIFIED'
}

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Number of items per page. */
  perPage: Scalars['Int'];
};

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  ASC = 'ASC',
  /** Sort records in descending order. */
  DESC = 'DESC'
}

export type StageProposalProductOrderingInput = {
  id: Scalars['ID'];
  ordering: Scalars['Int'];
  proposalProductGroupId?: InputMaybe<Scalars['ID']>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  endsAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
  renewsAt?: Maybe<Scalars['DateTime']>;
  stripeId: Scalars['String'];
  stripePrice?: Maybe<Scalars['String']>;
  stripeStatus: Scalars['String'];
  trialEndsAt?: Maybe<Scalars['DateTime']>;
};

export type SyncAiMappingCostsToMapInput = {
  areaId: Scalars['ID'];
  items: Array<AiMappingCostItemInput>;
};

export type SyncNotificationAdditionalRecipientsHasMany = {
  sync: Array<Scalars['ID']>;
};

export type SyncProductGroupProductsHasMany = {
  sync: Array<Scalars['ID']>;
};

export type SyncProjectMapMeasurementsInput = {
  mapData: Scalars['String'];
  measurements: Array<GeoJsonMeasurementInput>;
  projectMapId: Scalars['ID'];
};

export type SyncProposalStageChecklistItemHasMany = {
  sync: Array<Scalars['ID']>;
};

export type SyncProposalStageMeasurementsInput = {
  mapData: Scalars['String'];
  measurements: Array<GeoJsonMeasurementInput>;
  proposalStageId: Scalars['ID'];
};

export type SyncQuickbooksBatchInput = {
  billingMode?: QuickbooksSyncBatchBillingMode | `${QuickbooksSyncBatchBillingMode}`;
  billingStatus?: InputMaybe<JobBillingStatus | `${JobBillingStatus}`>;
  createEstimate?: InputMaybe<Scalars['Boolean']>;
  createInvoice?: InputMaybe<Scalars['Boolean']>;
  createJob?: InputMaybe<Scalars['Boolean']>;
  customerBillingAddressCity?: InputMaybe<Scalars['String']>;
  customerBillingAddressCountry?: InputMaybe<Scalars['String']>;
  customerBillingAddressLine1?: InputMaybe<Scalars['String']>;
  customerBillingAddressLine2?: InputMaybe<Scalars['String']>;
  customerBillingAddressState?: InputMaybe<Scalars['String']>;
  customerBillingAddressZip?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  jobIds: Array<Scalars['ID']>;
  jobName?: InputMaybe<Scalars['String']>;
  lines: Array<QuickbooksSyncBatchLineInput>;
  manualLines?: InputMaybe<Array<QuickbooksSyncBatchManualLineInput>>;
  partialAmountCents?: InputMaybe<Scalars['Int']>;
  partialPercentage?: InputMaybe<Scalars['Float']>;
  pushDesktop?: InputMaybe<Scalars['Boolean']>;
  pushOnline?: InputMaybe<Scalars['Boolean']>;
  shipAddressAddressCity?: InputMaybe<Scalars['String']>;
  shipAddressAddressLine1?: InputMaybe<Scalars['String']>;
  shipAddressAddressLine2?: InputMaybe<Scalars['String']>;
  shipAddressAddressState?: InputMaybe<Scalars['String']>;
  shipAddressAddressZip?: InputMaybe<Scalars['String']>;
  taxReference?: InputMaybe<Scalars['String']>;
};

export type Task = {
  __typename?: 'Task';
  assignedUser: User;
  company?: Maybe<Company>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contact?: Maybe<Contact>;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dueAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  notifiableExternalId?: Maybe<Scalars['String']>;
  notifiableId?: Maybe<Scalars['ID']>;
  notifiableType?: Maybe<Scalars['String']>;
  notificationTrigger?: Maybe<NotificationTrigger>;
  status: Scalars['String'];
  triggerEvent?: Maybe<Scalars['String']>;
  triggerType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

/** A paginated list of Task items. */
export type TaskPaginator = {
  __typename?: 'TaskPaginator';
  /** A list of Task items. */
  data: Array<Task>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Optional relationship to another record (proposal/job/opportunity). */
export type TaskRelatedInput = {
  id: Scalars['ID'];
  type: Scalars['String'];
};

/** A lightweight search result used when linking a Task to another record. */
export type TaskRelatedResult = {
  __typename?: 'TaskRelatedResult';
  companyId?: Maybe<Scalars['ID']>;
  contactId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  secondary?: Maybe<Scalars['String']>;
};

export type TimeBucket = {
  __typename?: 'TimeBucket';
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type TimeEntries = {
  __typename?: 'TimeEntries';
  endTime?: Maybe<Scalars['String']>;
  forDate?: Maybe<Scalars['String']>;
  jobPhaseAddress?: Maybe<Scalars['String']>;
  jobPhaseExternalId?: Maybe<Scalars['String']>;
  proposalStageName?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  timeTrackedHours?: Maybe<Scalars['Float']>;
  timeTrackedHuman?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type TimeEntriesByDateGroup = {
  __typename?: 'TimeEntriesByDateGroup';
  entries: Array<TimeEntry>;
  forDate: Scalars['Date'];
  totalEntries: Scalars['Int'];
  totalTimeTrackedSeconds: Scalars['Int'];
};

export type TimeEntriesByUserGroup = {
  __typename?: 'TimeEntriesByUserGroup';
  dates: Array<TimeEntriesByDateGroup>;
  totalEntries: Scalars['Int'];
  totalTimeTrackedSeconds: Scalars['Int'];
  user: User;
};

export type TimeEntry = {
  __typename?: 'TimeEntry';
  clockInLatitude?: Maybe<Scalars['Float']>;
  clockInLongitude?: Maybe<Scalars['Float']>;
  clockOutLatitude?: Maybe<Scalars['Float']>;
  clockOutLongitude?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['DateTime']>;
  forDate: Scalars['Date'];
  id: Scalars['ID'];
  jobPhase?: Maybe<JobPhase>;
  notes?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  startTime: Scalars['DateTime'];
  timeBucket?: Maybe<TimeBucket>;
  timeTrackedSeconds?: Maybe<Scalars['Int']>;
  timeTrackedSecondsOverride?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  uuid: Scalars['String'];
};

export type TransferTruck = {
  __typename?: 'TransferTruck';
  defaultRateHourly: Scalars['Int'];
  defaultRateTon: Scalars['Int'];
  defaultTonnage: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  ONLY = 'ONLY',
  /** Return both trashed and non-trashed results. */
  WITH = 'WITH',
  /** Only return non-trashed results. */
  WITHOUT = 'WITHOUT'
}

export type TravelHelper = {
  __typename?: 'TravelHelper';
  enabled: Scalars['Boolean'];
  roundTripHours: Scalars['String'];
  visits?: Maybe<Scalars['String']>;
};

export type TravelHelperInput = {
  enabled: Scalars['Boolean'];
  roundTripHours: Scalars['String'];
  visits?: InputMaybe<Scalars['String']>;
};

export type UpdateAdditionalCostInput = {
  cost: Scalars['Int'];
  feeAmount: Scalars['Float'];
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateAiMappingDetectionInput = {
  bbox?: InputMaybe<Array<Scalars['Float']>>;
  category?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  confidence?: InputMaybe<Scalars['Float']>;
  detectionId: Scalars['ID'];
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  runAreaId: Scalars['ID'];
};

export type UpdateAiMappingSegmentationInput = {
  category?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  polygon?: InputMaybe<Array<Scalars['Float']>>;
  runAreaId: Scalars['ID'];
  segmentationId: Scalars['ID'];
};

export type UpdateCompanyInput = {
  addCompanyInfo?: InputMaybe<Scalars['Boolean']>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  contacts: UpsertCompanyContactHasMany;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationTypes?: InputMaybe<NotificationTypeInput>;
  phone?: InputMaybe<Scalars['String']>;
  primaryContact: UpsertCompanyContactInput;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  status: CompanyStatus | `${CompanyStatus}`;
};

export type UpdateCompanyNotesInput = {
  id: Scalars['ID'];
  notes: Scalars['String'];
};

export type UpdateCrewInput = {
  color: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<UpsertEmployeeCrewBelongsToMany>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rate: Scalars['Int'];
};

export type UpdateCustomEventInput = {
  blocks: Array<CustomEventBlockInput>;
  color?: InputMaybe<Scalars['String']>;
  crewId?: InputMaybe<Scalars['ID']>;
  files?: InputMaybe<Array<CustomEventFileInput>>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  removeFiles?: InputMaybe<Array<Scalars['ID']>>;
  userIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UpdateDailyFormInspectionInput = {
  dailyFormVehicleId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  questionAnswers?: InputMaybe<UpsertDailyFormInspectionQuestionAnswerBelongsToMany>;
  vehicleMilleage?: InputMaybe<Scalars['Int']>;
};

export type UpdateDailyFormInspectionQuestionInput = {
  id: Scalars['ID'];
  question?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DailyFormInspectionQuestionType | `${DailyFormInspectionQuestionType}`>;
};

export type UpdateDailyFormVehicleInput = {
  currentMeterReading?: InputMaybe<Scalars['Float']>;
  dailyFormVehicleTypeId?: InputMaybe<Scalars['ID']>;
  defaultServiceIntervalUnit?: InputMaybe<DailyFormVehicleServiceIntervalUnit | `${DailyFormVehicleServiceIntervalUnit}`>;
  defaultServiceIntervalValue?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  inServiceDate?: InputMaybe<Scalars['Date']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  meterType?: InputMaybe<DailyFormVehicleMeterType | `${DailyFormVehicleMeterType}`>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  registrationExpirationDate?: InputMaybe<Scalars['Date']>;
  registrationState?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type UpdateDailyFormVehiclePartInput = {
  dailyFormVehicleId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  vendorName?: InputMaybe<Scalars['String']>;
};

export type UpdateDailyFormVehicleServicePlanInput = {
  assignedTo?: InputMaybe<Scalars['ID']>;
  autoCreateTask?: InputMaybe<Scalars['Boolean']>;
  dailyFormVehicleId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  intervalUnit?: InputMaybe<DailyFormVehicleServiceIntervalUnit | `${DailyFormVehicleServiceIntervalUnit}`>;
  intervalValue?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  issueType?: InputMaybe<Scalars['String']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']>;
  lastCompletedMeterReading?: InputMaybe<Scalars['Float']>;
  leadUnit?: InputMaybe<DailyFormVehicleServiceIntervalUnit | `${DailyFormVehicleServiceIntervalUnit}`>;
  leadValue?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<DailyFormIssuePriority | `${DailyFormIssuePriority}`>;
};

export type UpdateDailyFormWorkOrderInput = {
  assignedTo?: InputMaybe<Scalars['ID']>;
  comments?: InputMaybe<Scalars['String']>;
  currentMeterReading?: InputMaybe<Scalars['Float']>;
  estimatedTaskTime?: InputMaybe<Scalars['Float']>;
  files?: InputMaybe<Array<DailyFormWorkOrderFileInput>>;
  id: Scalars['ID'];
  issueDescription?: InputMaybe<Scalars['String']>;
  issueName?: InputMaybe<Scalars['String']>;
  issueType?: InputMaybe<Scalars['String']>;
  neededCompletionDate?: InputMaybe<Scalars['Date']>;
  priority?: InputMaybe<DailyFormIssuePriority | `${DailyFormIssuePriority}`>;
  removeFiles?: InputMaybe<Array<Scalars['ID']>>;
  servicePlanId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<DailyFormIssueStatus | `${DailyFormIssueStatus}`>;
  vehicleId?: InputMaybe<Scalars['ID']>;
};

export type UpdateDailyFormWorkOrderStatusInput = {
  id: Scalars['ID'];
  status: DailyFormIssueStatus | `${DailyFormIssueStatus}`;
};

export type UpdateEmployeeInput = {
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  rate: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type UpdateEquipmentPieceInput = {
  calculateTravelTime: Scalars['Boolean'];
  chargeType: EquipmentPieceChargeType | `${EquipmentPieceChargeType}`;
  fuelSurcharge: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  rate: Scalars['Int'];
  usePercentage: Scalars['Int'];
};

export type UpdateJobChecklistItemsInput = {
  checklistItems: UpsertJobChecklistItemsHasMany;
  id: Scalars['ID'];
};

export type UpdateJobPhaseChecklistItemsInput = {
  checklistItems: UpsertJobPhaseChecklistItemHasMany;
  checklistNotes?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateJobPhaseCostingInput = {
  actualSubcontractorCost?: InputMaybe<Scalars['Int']>;
  actualSubcontractorName?: InputMaybe<Scalars['String']>;
  actualSubcontractorReference?: InputMaybe<Scalars['String']>;
  costingMode: JobPhaseCostingMode | `${JobPhaseCostingMode}`;
  id: Scalars['ID'];
};

export type UpdateJobPhaseNotesInput = {
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdateNotificationTriggerInput = {
  active: Scalars['Boolean'];
  additionalRecipientTypes?: InputMaybe<Array<NotificationTriggerAdditionalRecipientTypes | `${NotificationTriggerAdditionalRecipientTypes}`>>;
  additionalRecipients?: InputMaybe<SyncNotificationAdditionalRecipientsHasMany>;
  apiHeaders?: InputMaybe<Scalars['String']>;
  apiMethod?: InputMaybe<Scalars['String']>;
  apiPayload?: InputMaybe<Scalars['String']>;
  apiUrl?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  delay: Scalars['Int'];
  emailSubject?: InputMaybe<Scalars['String']>;
  event: NotificationTriggerEvent | `${NotificationTriggerEvent}`;
  id: Scalars['ID'];
  isApi?: InputMaybe<Scalars['Boolean']>;
  isEmail?: InputMaybe<Scalars['Boolean']>;
  isSMS?: InputMaybe<Scalars['Boolean']>;
  isTask?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  sendToAllRecipients: Scalars['Boolean'];
  sendToContact: Scalars['Boolean'];
  sendToUser: Scalars['Boolean'];
  smsContent?: InputMaybe<Scalars['String']>;
  taskContent?: InputMaybe<Scalars['String']>;
  type: NotificationTriggerType | `${NotificationTriggerType}`;
};

export type UpdateOpportunityInput = {
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  dueAt?: InputMaybe<Scalars['Date']>;
  estimatedOpportunityValue?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<UpsertOpportunityProductBelongsToMany>;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<OpportunitySource | `${OpportunitySource}`>;
  statusId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type UpdateOrganizationAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  latitude?: InputMaybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type UpdateOrganizationConversionFactorOverrideInput = {
  asphaltTonConversionFactorOverride: Scalars['String'];
  excavateOutTonConversionFactorOverride: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateOrganizationInput = {
  email: Scalars['String'];
  id: Scalars['ID'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationSalesGoal?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  timezone: Scalars['String'];
};

export type UpdateOrganizationProductTypeInput = {
  id: Scalars['ID'];
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  markupPercentage?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  overheadPercentage?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrganizationProposalDefaultsInput = {
  autoSave?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  defaultLoadingTimeMins?: InputMaybe<Scalars['Int']>;
  defaultTransferTruckId?: InputMaybe<Scalars['ID']>;
  defaultUnloadTimeMins?: InputMaybe<Scalars['Int']>;
  estimateTruckingByFullDay?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idPrefix?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<ProposalLayout | `${ProposalLayout}`>;
  maxTripNumberPerTruck?: InputMaybe<Scalars['Int']>;
  minimumProfitPerDay?: InputMaybe<Scalars['Int']>;
  multiplyTravelTimeByDay?: InputMaybe<Scalars['Boolean']>;
  optionalCheckboxDefaultChecked?: InputMaybe<Scalars['Boolean']>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
  roundUpToNearestDollarAmount?: InputMaybe<Scalars['Boolean']>;
  startingNumber?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrganizationSalesTaxesInput = {
  /** organization id */
  id: Scalars['ID'];
  salesTaxes: UpsertOrganizationSalesTaxHasMany;
};

export type UpdateOrganizationSettingsInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type UpdateOrganizationUserInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  autoAssign: Scalars['Boolean'];
  avatar?: InputMaybe<Scalars['Upload']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRole | `${UserRole}`>;
  salesGoal?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type UpdatePlantInput = {
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  id: Scalars['ID'];
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  products: UpsertPlantProductBelongsToMany;
};

export type UpdateProductGroupInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  products?: InputMaybe<SyncProductGroupProductsHasMany>;
};

export type UpdateProductInput = {
  additionalCosts?: InputMaybe<UpsertProductAdditionalCostBelongsToMany>;
  areaCoverage?: InputMaybe<Scalars['Float']>;
  /** Json encoded string of attributes */
  attributes?: InputMaybe<ProductAttributesInput>;
  costMaterial?: InputMaybe<Scalars['Int']>;
  costMinimumProduct?: InputMaybe<Scalars['Int']>;
  costMinimumProposal?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  crews?: InputMaybe<UpsertProductCrewsBelongsToMany>;
  dailyUnitsComplete?: InputMaybe<Scalars['Int']>;
  equipmentPieces?: InputMaybe<UpsertProductEquipmentBelongsToMany>;
  externalProductName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  labourCostType?: InputMaybe<ProductLabourCostType | `${ProductLabourCostType}`>;
  markupPercentage?: InputMaybe<Scalars['Int']>;
  materialsNoPlant?: InputMaybe<UpsertProductMaterialNoPlantHasMany>;
  measurementJob: ProductMeasurementJob | `${ProductMeasurementJob}`;
  measurementMaterial?: InputMaybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  name: Scalars['String'];
  overheadPercentage?: InputMaybe<Scalars['Int']>;
  plantProductId?: InputMaybe<Scalars['ID']>;
  plantProducts?: InputMaybe<UpsertProductPlantProductsBelongsToMany>;
  productionRateType?: InputMaybe<ProductProductionRateType | `${ProductProductionRateType}`>;
  statementOfWork?: InputMaybe<Scalars['String']>;
  subcontracted: Scalars['Boolean'];
  unitPrice?: InputMaybe<Scalars['Float']>;
  unitPriceProduct: Scalars['Boolean'];
};

export type UpdateProjectMapInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateProposalAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Int']>;
  feeAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Float']>;
  showOnProposal?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProposalAddress = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type UpdateProposalContentSettingUpsertInput = {
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
};

export type UpdateProposalContentSettingsHasManyInput = {
  upsert: Array<UpdateProposalContentSettingUpsertInput>;
};

export type UpdateProposalCrewInput = {
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['Int']>;
  timeOnjob?: InputMaybe<Scalars['Int']>;
  timeTravel?: InputMaybe<Scalars['Int']>;
};

export type UpdateProposalDiscountInput = {
  discount: Scalars['Int'];
  id: Scalars['ID'];
};

export type UpdateProposalEquipmentPieceInput = {
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Float']>;
  rate?: InputMaybe<Scalars['Int']>;
  timeOnJob?: InputMaybe<Scalars['Int']>;
  timeTravel?: InputMaybe<Scalars['Int']>;
};

export type UpdateProposalInfoInput = {
  closeConfidence?: InputMaybe<Scalars['Int']>;
  contactId: Scalars['ID'];
  id: Scalars['ID'];
  layout: ProposalLayout | `${ProposalLayout}`;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  projectedCloseDate?: InputMaybe<Scalars['Date']>;
  proposalNotes?: InputMaybe<Scalars['String']>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<ProposalSource | `${ProposalSource}`>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UpdateProposalLayoutContentSettingItemInput = {
  contentType: Scalars['String'];
  showOnBranded?: InputMaybe<Scalars['Boolean']>;
  showOnFull?: InputMaybe<Scalars['Boolean']>;
  showOnSimple?: InputMaybe<Scalars['Boolean']>;
  showOnTabular?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProposalMaterialInput = {
  attributes?: InputMaybe<ProductAttributesInput>;
  costMaterial?: InputMaybe<Scalars['Int']>;
  dailyUnitsComplete?: InputMaybe<Scalars['String']>;
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  markup?: InputMaybe<Scalars['Int']>;
  materialNeeded?: InputMaybe<Scalars['Float']>;
  overheadPercentage?: InputMaybe<Scalars['Int']>;
  statementOfWork?: InputMaybe<Scalars['String']>;
  tonConversionFactor?: InputMaybe<Scalars['Float']>;
  unitPrice?: InputMaybe<Scalars['Int']>;
};

export type UpdateProposalMaterialNoPlantInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
  quantityOverride?: InputMaybe<Scalars['Int']>;
  rate: Scalars['Int'];
};

export type UpdateProposalPlantInput = {
  rateOnWeight: Scalars['Boolean'];
};

export type UpdateProposalPlantProductInput = {
  applicationRateOverride?: InputMaybe<Scalars['Float']>;
  areaCoverage?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  materialNeededOverride?: InputMaybe<Scalars['Float']>;
  plantProductId?: InputMaybe<Scalars['ID']>;
  rateOnWeight?: InputMaybe<Scalars['Boolean']>;
  rateOverride?: InputMaybe<Scalars['Int']>;
  /** In Hours */
  transferTruckLoadTimeBuffer?: InputMaybe<Scalars['Float']>;
  transferTruckRoundTripTimeHrsOverride?: InputMaybe<Scalars['Float']>;
  /** In Hours */
  transferTruckUnloadTimeBuffer?: InputMaybe<Scalars['Float']>;
};

export type UpdateProposalProductDiscountInput = {
  discount: Scalars['Int'];
  id: Scalars['ID'];
};

export type UpdateProposalProductGroupsHasMany = {
  upsert?: InputMaybe<Array<UpsertProposalProductGroupInput>>;
};

export type UpdateProposalProductInput = {
  additionalCosts: Array<UpdateProposalAdditionalCostInput>;
  crews: Array<UpdateProposalCrewInput>;
  equipmentPieces: Array<UpdateProposalEquipmentPieceInput>;
  id: Scalars['ID'];
  jobDurationDaysOverride?: InputMaybe<Scalars['Float']>;
  jobDurationOverride?: InputMaybe<Scalars['Float']>;
  jobSize: Scalars['Int'];
  mapData?: InputMaybe<Scalars['String']>;
  material: UpdateProposalMaterialInput;
  materialNoPlants: Array<UpdateProposalMaterialNoPlantInput>;
  notes?: InputMaybe<Scalars['String']>;
  overallTotalOverride?: InputMaybe<Scalars['Int']>;
  plant?: InputMaybe<UpdateProposalPlantInput>;
  plantProducts?: InputMaybe<Array<UpdateProposalPlantProductInput>>;
  profitPercentageOverride?: InputMaybe<Scalars['Int']>;
  roundTripTravelTimeHours?: InputMaybe<Scalars['Float']>;
  subcontractorCost?: InputMaybe<Scalars['Int']>;
  subcontractorName?: InputMaybe<Scalars['String']>;
  subcontractorProposalId?: InputMaybe<Scalars['String']>;
  transferTrucks: Array<UpsertProposalTransferTrucksInput>;
};

export type UpdateProposalProductsHasMany = {
  update: Array<StageProposalProductOrderingInput>;
};

export type UpdateProposalProductsOrderingInput = {
  id: Scalars['ID'];
  proposalProductGroups?: InputMaybe<UpdateProposalProductGroupsHasMany>;
  proposalProducts: UpdateProposalProductsHasMany;
};

export type UpdateProposalSalesTaxesInput = {
  id: Scalars['ID'];
  salesTaxes: Array<Scalars['ID']>;
};

export type UpdateProposalStageAddressAndClearProductsInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressOverride?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  mapData?: InputMaybe<Scalars['String']>;
  proposalStageId: Scalars['ID'];
};

export type UpdateProposalStagesHasMany = {
  update: Array<ProposalStageOrderingInput>;
};

export type UpdateProposalStagesOrdering = {
  id: Scalars['ID'];
  stages: UpdateProposalStagesHasMany;
};

export type UpdateRolesWithPermissionsInput = {
  employee?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
  foreman?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
  officeManager?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
  salesperson?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
  subcontractor?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
};

export type UpdateTimeBucketInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateTimeEntryInput = {
  clockOutLatitude?: InputMaybe<Scalars['Float']>;
  clockOutLongitude?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  forDate?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  timeBucketId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  uuid: Scalars['String'];
};

export type UpdateTransferTruckInput = {
  defaultRateHourly: Scalars['Int'];
  defaultRateTon: Scalars['Int'];
  defaultTonnage: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateWorkOrderItemsInput = {
  additionalCosts?: InputMaybe<Array<UpdateWorkOrderItemsInputAdditionalCosts>>;
  crews?: InputMaybe<Array<UpdateWorkOrderItemsInputCrews>>;
  equipmentPieces?: InputMaybe<Array<UpdateWorkOrderItemsInputEquipmentPieces>>;
  jobPhaseId: Scalars['ID'];
  plantId?: InputMaybe<Scalars['ID']>;
  plantProductId?: InputMaybe<Scalars['ID']>;
  schedules?: InputMaybe<Array<InputMaybe<UpdateWorkOrderItemsSchedules>>>;
  transferTrucks?: InputMaybe<Array<UpdateWorkOrderItemsInputTransferTruck>>;
};

export type UpdateWorkOrderItemsInputAdditionalCosts = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkOrderItemsInputCrews = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkOrderItemsInputEquipmentPieces = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkOrderItemsInputTransferTruck = {
  id: Scalars['ID'];
  proposalPlantProductId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Float']>;
  workOrderTruckId?: InputMaybe<Scalars['ID']>;
};

export type UpdateWorkOrderItemsSchedules = {
  estimatedMaterialOverride: Scalars['Float'];
  id: Scalars['ID'];
};

export type UpsertCompanyContactHasMany = {
  upsert: Array<UpsertCompanyContactInput>;
};

export type UpsertCompanyContactInput = {
  SMSNotifications: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  role?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpsertDailyFormInspectionQuestionAnswerBelongsToMany = {
  upsert: Array<DailyFormInspectionQuestionInput>;
};

export type UpsertEmployeeCrewBelongsToMany = {
  sync: Array<UpsertEmployeeCrewInput>;
};

export type UpsertEmployeeCrewInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type UpsertJobChecklistItemInput = {
  checklistItemId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  isCompleted: Scalars['Boolean'];
  jobPhaseId: Scalars['ID'];
};

export type UpsertJobChecklistItemsHasMany = {
  upsert: Array<UpsertJobChecklistItemInput>;
};

export type UpsertJobPhaseChecklistItemHasMany = {
  upsert: Array<UpsertJobPhaseChecklistItemInput>;
};

export type UpsertJobPhaseChecklistItemInput = {
  checklistItemId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  isCompleted: Scalars['Boolean'];
  jobId: Scalars['ID'];
};

export type UpsertOpportunityProductBelongsToMany = {
  sync: Array<UpsertOpportunityProductInput>;
};

export type UpsertOpportunityProductInput = {
  id: Scalars['ID'];
};

export type UpsertOrganizationSalesTaxHasMany = {
  upsert: Array<InputMaybe<UpsertOrganizationSalesTaxInput>>;
};

export type UpsertOrganizationSalesTaxInput = {
  id?: InputMaybe<Scalars['ID']>;
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
  quickbooksDesktopTaxCodeId?: InputMaybe<Scalars['ID']>;
  quickbooksTaxCodeId?: InputMaybe<Scalars['ID']>;
};

export type UpsertPlantProductBelongsToMany = {
  upsert: Array<UpsertPlantProductInput>;
};

export type UpsertPlantProductInput = {
  id?: InputMaybe<Scalars['ID']>;
  rate: Scalars['Float'];
  type: Scalars['String'];
};

export type UpsertPlantTransferTruckHasMany = {
  upsert: Array<UpsertPlantTransferTruckInput>;
};

export type UpsertPlantTransferTruckInput = {
  id?: InputMaybe<Scalars['ID']>;
  rateHourly?: InputMaybe<Scalars['Int']>;
  rateTon?: InputMaybe<Scalars['Int']>;
  tonnage: Scalars['Int'];
  transferTruckId: Scalars['ID'];
};

export type UpsertProductAdditionalCostBelongsToMany = {
  sync: Array<UpsertProductAdditionalCostInput>;
};

export type UpsertProductAdditionalCostInput = {
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ProductAdditionalCostType | `${ProductAdditionalCostType}`>;
};

export type UpsertProductCrewInput = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type UpsertProductCrewsBelongsToMany = {
  sync: Array<UpsertProductCrewInput>;
};

export type UpsertProductEquipmentBelongsToMany = {
  sync: Array<UpsertProductEquipmentInput>;
};

export type UpsertProductEquipmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Float'];
};

export type UpsertProductMaterialNoPlantHasMany = {
  upsert: Array<UpsertProductMaterialNoPlantInput>;
};

export type UpsertProductMaterialNoPlantInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  percentage: Scalars['Float'];
  rate: Scalars['Int'];
};

export type UpsertProductPlantProductInput = {
  applicationRate?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  plantId: Scalars['ID'];
};

export type UpsertProductPlantProductsBelongsToMany = {
  sync?: InputMaybe<Array<UpsertProductPlantProductInput>>;
};

export type UpsertProposalProductGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  isOptional: Scalars['Boolean'];
  name: Scalars['String'];
  ordering: Scalars['Int'];
  proposalProducts?: InputMaybe<ConnectProposalProductsToGroupHasMany>;
  showIndividualProducts: Scalars['Boolean'];
};

export type UpsertProposalTransferTrucksInput = {
  plantTransferTruckId: Scalars['ID'];
  proposalPlantProductId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  quantityOverride?: InputMaybe<Scalars['Float']>;
  rate?: InputMaybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  autoAssign: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  crewsCount: Scalars['Int'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hasEmployee: Scalars['Boolean'];
  id: Scalars['ID'];
  inviteToken?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<User>;
  jobPhasesCount: Scalars['Int'];
  jobsCount: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization: Organization;
  permissions: Array<UserPermissions | `${UserPermissions}`>;
  phone?: Maybe<Scalars['String']>;
  proposalCount: Scalars['Int'];
  roles: Array<UserRole | `${UserRole}`>;
  salesGoal?: Maybe<Scalars['String']>;
  status: UserStatus | `${UserStatus}`;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum UserPermissions {
  /** Add items to schedule */
  ADD_ITEMS_TO_SCHEDULE = 'ADD_ITEMS_TO_SCHEDULE',
  /** Add manual time */
  ADD_MANUAL_TIME = 'ADD_MANUAL_TIME',
  /** Do data imports */
  DO_DATA_IMPORTS = 'DO_DATA_IMPORTS',
  /** Generate reports */
  GENERATE_REPORTS = 'GENERATE_REPORTS',
  /** Input job info costs */
  INPUT_JOB_INFO_COSTS = 'INPUT_JOB_INFO_COSTS',
  /** Manage companies */
  MANAGE_COMPANIES = 'MANAGE_COMPANIES',
  /** Manage email settings */
  MANAGE_EMAIL_SETTINGS = 'MANAGE_EMAIL_SETTINGS',
  /** Manage employees */
  MANAGE_EMPLOYEES = 'MANAGE_EMPLOYEES',
  /** Manage knowledge base */
  MANAGE_KNOWLEDGE_BASE = 'MANAGE_KNOWLEDGE_BASE',
  /** Manage linked services */
  MANAGE_LINKED_SERVICES = 'MANAGE_LINKED_SERVICES',
  /** Manage notification triggers */
  MANAGE_NOTIFICATION_TRIGGERS = 'MANAGE_NOTIFICATION_TRIGGERS',
  /** Manage opportunities */
  MANAGE_OPPORTUNITIES = 'MANAGE_OPPORTUNITIES',
  /** Manage organization info */
  MANAGE_ORGANIZATION_INFO = 'MANAGE_ORGANIZATION_INFO',
  /** Manage product settings */
  MANAGE_PRODUCT_SETTINGS = 'MANAGE_PRODUCT_SETTINGS',
  /** Manage proposals */
  MANAGE_PROPOSALS = 'MANAGE_PROPOSALS',
  /** Manage proposal settings */
  MANAGE_PROPOSAL_SETTINGS = 'MANAGE_PROPOSAL_SETTINGS',
  /** Manage schedule */
  MANAGE_SCHEDULE = 'MANAGE_SCHEDULE',
  /** Manage subscription */
  MANAGE_SUBSCRIPTION = 'MANAGE_SUBSCRIPTION',
  /** Manage time tracking */
  MANAGE_TIME_TRACKING = 'MANAGE_TIME_TRACKING',
  /** Manage users */
  MANAGE_USERS = 'MANAGE_USERS',
  /** Push job to quickbooks */
  PUSH_JOB_TO_QUICKBOOKS = 'PUSH_JOB_TO_QUICKBOOKS',
  /** View all jobs */
  VIEW_ALL_JOBS = 'VIEW_ALL_JOBS',
  /** View all proposals */
  VIEW_ALL_PROPOSALS = 'VIEW_ALL_PROPOSALS',
  /** View assigned jobs */
  VIEW_ASSIGNED_JOBS = 'VIEW_ASSIGNED_JOBS',
  /** View companies */
  VIEW_COMPANIES = 'VIEW_COMPANIES',
  /** View crew jobs */
  VIEW_CREW_JOBS = 'VIEW_CREW_JOBS',
  /** View dashboard */
  VIEW_DASHBOARD = 'VIEW_DASHBOARD',
  /** View job financial summaries */
  VIEW_JOB_FINANCIAL_SUMMARIES = 'VIEW_JOB_FINANCIAL_SUMMARIES',
  /** View job info */
  VIEW_JOB_INFO = 'VIEW_JOB_INFO',
  /** View maps */
  VIEW_MAPS = 'VIEW_MAPS',
  /** View only assigned opportunities */
  VIEW_ONLY_ASSIGNED_OPPORTUNITIES = 'VIEW_ONLY_ASSIGNED_OPPORTUNITIES',
  /** View only assigned proposals */
  VIEW_ONLY_ASSIGNED_PROPOSALS = 'VIEW_ONLY_ASSIGNED_PROPOSALS',
  /** View opportunities */
  VIEW_OPPORTUNITIES = 'VIEW_OPPORTUNITIES',
  /** View schedule */
  VIEW_SCHEDULE = 'VIEW_SCHEDULE',
  /** View time tracking */
  VIEW_TIME_TRACKING = 'VIEW_TIME_TRACKING',
  /** View work order */
  VIEW_WORK_ORDER = 'VIEW_WORK_ORDER'
}

export enum UserRole {
  /** Admin */
  ADMIN = 'ADMIN',
  /** Employee */
  EMPLOYEE = 'EMPLOYEE',
  /** Foreman */
  FOREMAN = 'FOREMAN',
  /** Office manager */
  OFFICE_MANAGER = 'OFFICE_MANAGER',
  /** Sales person */
  SALES_PERSON = 'SALES_PERSON',
  /** Subcontractor */
  SUBCONTRACTOR = 'SUBCONTRACTOR'
}

export enum UserStatus {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Disabled */
  DISABLED = 'DISABLED',
  /** Invited */
  INVITED = 'INVITED'
}

export type ValidateLoginInput = {
  email: Scalars['String'];
};

export type ValidateRegistrationTokenInput = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type WebhookDelivery = {
  __typename?: 'WebhookDelivery';
  attempts: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deliveredAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  eventType: Scalars['String'];
  httpStatusCode?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  nextRetryAt?: Maybe<Scalars['DateTime']>;
  notificationTriggerId?: Maybe<Scalars['ID']>;
  responseBody?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type WebhookTestResult = {
  __typename?: 'WebhookTestResult';
  errorMessage?: Maybe<Scalars['String']>;
  httpStatusCode?: Maybe<Scalars['Int']>;
  responseTimeMs: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type WorkOrderCrew = {
  __typename?: 'WorkOrderCrew';
  crewId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type WorkOrderEquipmentPiece = {
  __typename?: 'WorkOrderEquipmentPiece';
  equipmentPieceId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type WorkOrderTransferTruck = {
  __typename?: 'WorkOrderTransferTruck';
  id: Scalars['ID'];
  name: Scalars['String'];
  proposalPlantProduct?: Maybe<ProposalPlantProduct>;
  proposalPlantProductId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Float']>;
  rateHourly: Scalars['Int'];
  rateTon: Scalars['Int'];
  tonnage: Scalars['Int'];
  transferTruck?: Maybe<TransferTruck>;
  transferTruckId?: Maybe<Scalars['ID']>;
  worksheetBilling?: Maybe<WorksheetTruckBilling>;
};

export type Worksheet = {
  __typename?: 'Worksheet';
  area?: Maybe<Scalars['String']>;
  areaSource: Scalars['String'];
  areaUnit?: Maybe<Scalars['String']>;
  costTotal?: Maybe<Scalars['String']>;
  fixedPrice: Scalars['String'];
  indirectPercentage?: Maybe<Scalars['String']>;
  margin?: Maybe<Scalars['String']>;
  marginPercentage?: Maybe<Scalars['String']>;
  markup: Scalars['String'];
  name: Scalars['String'];
  overheadPercentage?: Maybe<Scalars['String']>;
  pricingBaseline?: Maybe<WorksheetPricingBaseline>;
  pricingMethod: Scalars['String'];
  pricingOverrideField?: Maybe<Scalars['String']>;
  profitAmount?: Maybe<Scalars['String']>;
  quantity: Scalars['String'];
  rate: Scalars['String'];
  rows: Array<WorksheetRow>;
  scope?: Maybe<Scalars['String']>;
  scopeFormat?: Maybe<Scalars['String']>;
  sellingTotal?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type WorksheetFactor = {
  __typename?: 'WorksheetFactor';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type WorksheetInput = {
  area?: InputMaybe<Scalars['String']>;
  areaSource: Scalars['String'];
  areaUnit?: InputMaybe<Scalars['String']>;
  fixedPrice: Scalars['String'];
  indirectPercentage?: InputMaybe<Scalars['String']>;
  markup: Scalars['String'];
  name: Scalars['String'];
  overheadPercentage?: InputMaybe<Scalars['String']>;
  pricingBaseline?: InputMaybe<WorksheetPricingBaselineInput>;
  pricingMethod: Scalars['String'];
  pricingOverrideField?: InputMaybe<Scalars['String']>;
  profitAmount?: InputMaybe<Scalars['String']>;
  quantity: Scalars['String'];
  rate: Scalars['String'];
  rows: Array<WorksheetRowInput>;
  scope?: InputMaybe<Scalars['String']>;
  scopeFormat?: InputMaybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type WorksheetMaterialSnapshot = {
  __typename?: 'WorksheetMaterialSnapshot';
  quantity: Scalars['String'];
  rate: Scalars['String'];
  unit: Scalars['String'];
};

export type WorksheetPricingBaseline = {
  __typename?: 'WorksheetPricingBaseline';
  fixedPrice: Scalars['String'];
  markup: Scalars['String'];
  pricingMethod: Scalars['String'];
  profitAmount?: Maybe<Scalars['String']>;
};

export type WorksheetPricingBaselineInput = {
  fixedPrice: Scalars['String'];
  markup: Scalars['String'];
  pricingMethod: Scalars['String'];
  profitAmount?: InputMaybe<Scalars['String']>;
};

export type WorksheetProduct = {
  __typename?: 'WorksheetProduct';
  definition: Worksheet;
  id: Scalars['ID'];
  organizationProductType?: Maybe<OrganizationProductType>;
};

export type WorksheetRow = {
  __typename?: 'WorksheetRow';
  calculatedQuantity?: Maybe<Scalars['String']>;
  calculation: Scalars['String'];
  category: Scalars['String'];
  factor?: Maybe<Scalars['String']>;
  factorAreaUnit?: Maybe<Scalars['String']>;
  factorLabel?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  hoursPerTruck?: Maybe<Scalars['String']>;
  jobSize?: Maybe<Scalars['String']>;
  jobSizeUnit?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['String'];
  quantityOverride?: Maybe<Scalars['String']>;
  rate: Scalars['String'];
  sourceId?: Maybe<Scalars['ID']>;
  sourceName?: Maybe<Scalars['String']>;
  sourcePlantId?: Maybe<Scalars['ID']>;
  sourcePlantName?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  thickness?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
  truckCapacity?: Maybe<Scalars['String']>;
  truckRateHours?: Maybe<Scalars['String']>;
  truckRateLoads?: Maybe<Scalars['String']>;
  truckRateTons?: Maybe<Scalars['String']>;
  truckRateYards?: Maybe<Scalars['String']>;
  truckingUnit?: Maybe<Scalars['String']>;
  trucksNeeded?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type WorksheetRowInput = {
  calculation: Scalars['String'];
  category: Scalars['String'];
  factor?: InputMaybe<Scalars['String']>;
  factorAreaUnit?: InputMaybe<Scalars['String']>;
  factorLabel?: InputMaybe<Scalars['String']>;
  hoursPerTruck?: InputMaybe<Scalars['String']>;
  jobSize?: InputMaybe<Scalars['String']>;
  jobSizeUnit?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['String'];
  quantityOverride?: InputMaybe<Scalars['String']>;
  rate: Scalars['String'];
  sourceId?: InputMaybe<Scalars['ID']>;
  sourceName?: InputMaybe<Scalars['String']>;
  sourcePlantId?: InputMaybe<Scalars['ID']>;
  sourcePlantName?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
  thickness?: InputMaybe<Scalars['String']>;
  truckCapacity?: InputMaybe<Scalars['String']>;
  truckRateHours?: InputMaybe<Scalars['String']>;
  truckRateLoads?: InputMaybe<Scalars['String']>;
  truckRateTons?: InputMaybe<Scalars['String']>;
  truckRateYards?: InputMaybe<Scalars['String']>;
  truckingUnit?: InputMaybe<Scalars['String']>;
  trucksNeeded?: InputMaybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type WorksheetSettings = {
  __typename?: 'WorksheetSettings';
  canManageProducts: Scalars['Boolean'];
  canManageSettings: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  factors: Array<WorksheetFactor>;
  markup: Scalars['String'];
  method: Scalars['String'];
};

export type WorksheetTruckBilling = {
  __typename?: 'WorksheetTruckBilling';
  quantity: Scalars['String'];
  rate: Scalars['String'];
  unit: Scalars['String'];
};

export type YearOverYearRevenueItem = {
  __typename?: 'YearOverYearRevenueItem';
  lastYearRevenue: Scalars['String'];
  month: Scalars['String'];
  percentDifference: Scalars['Float'];
  thisYearRevenue: Scalars['String'];
};

export type YearToDateStats = {
  __typename?: 'YearToDateStats';
  yearToDateCloseRate: Scalars['Float'];
  yearToDateJobAmountCompleted?: Maybe<Scalars['String']>;
  yearToDateNetMarginCalculated?: Maybe<Scalars['Float']>;
  yearToDateTotalAmountProposed?: Maybe<Scalars['String']>;
  yearToDateTotalSalesWon?: Maybe<Scalars['String']>;
};

export type YearlyDashboardData = {
  __typename?: 'YearlyDashboardData';
  closedBids?: Maybe<Array<Maybe<MonthlySummary>>>;
  closedRate?: Maybe<Array<Maybe<MonthlySummary>>>;
  closedRevenue?: Maybe<Array<Maybe<MonthlySummary>>>;
  sentBids?: Maybe<Array<Maybe<MonthlySummary>>>;
};

export type GetReportAdditionalCostResponse = {
  __typename?: 'getReportAdditionalCostResponse';
  data: Array<AdditionalCostItem>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportCompanyOrClientDetailsResponse = {
  __typename?: 'getReportCompanyOrClientDetailsResponse';
  data: Array<CompanyOrClientDetails>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportContactDetailsResponse = {
  __typename?: 'getReportContactDetailsResponse';
  data: Array<ContactDetails>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportCrewDetailsResponse = {
  __typename?: 'getReportCrewDetailsResponse';
  data: Array<ReportCrewDetailsItem>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportEquipmentCostDetailsResponse = {
  __typename?: 'getReportEquipmentCostDetailsResponse';
  data: Array<ReportEquipmentCostDetailsItem>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportJobCostByProductTypeResponse = {
  __typename?: 'getReportJobCostByProductTypeResponse';
  data: Array<ReportJobCostByProductTypeItem>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportJobCostDetailResponse = {
  __typename?: 'getReportJobCostDetailResponse';
  additional_costs: Array<ReportJobCostDetailAdditionalCostItem>;
  employees: Array<ReportJobCostDetailEmployeeItem>;
  equipment: Array<ReportJobCostDetailEquipmentItem>;
  header: ReportJobCostDetailHeader;
  materials: Array<ReportJobCostDetailMaterialItem>;
  summary: ReportJobCostDetailSummary;
  trucking: Array<ReportJobCostDetailTruckingItem>;
};

export type GetReportJobDetailsResponse = {
  __typename?: 'getReportJobDetailsResponse';
  data: Array<ReportJobDetailsItem>;
  metadata: JobDetailsMetadata;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportJobsByContactResponse = {
  __typename?: 'getReportJobsByContactResponse';
  data: Array<JobsByContact>;
  metadata: JobsByContactMetadata;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportOrganizationProfitabilityResponse = {
  __typename?: 'getReportOrganizationProfitabilityResponse';
  data: Array<ReportOrganizationProfitabilityItem>;
  metadata: OrganizationProfitabilityMetadata;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportProductDetailsResponse = {
  __typename?: 'getReportProductDetailsResponse';
  data: Array<ProductDetails>;
  metadata: ProductDetailsMetadata;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportProposalDetailsResponse = {
  __typename?: 'getReportProposalDetailsResponse';
  data: Array<ProposalDetailsItem>;
  metadata: ProposalDetailsMetadata;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportSalesByContactResponse = {
  __typename?: 'getReportSalesByContactResponse';
  data: Array<SalesByContact>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportSalesByProductSummaryResponse = {
  __typename?: 'getReportSalesByProductSummaryResponse';
  data: Array<SalesByProductSummaryItem>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportSalesByProposalSourceResponse = {
  __typename?: 'getReportSalesByProposalSourceResponse';
  data: Array<SalesByProposalSource>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetReportTimeEntriesResponse = {
  __typename?: 'getReportTimeEntriesResponse';
  data: Array<TimeEntries>;
  paginatorInfo: CustomPaginatorInfo;
};

export type CreateOrganizationApiKeyMutationVariables = Exact<{
  description: Scalars['String'];
}>;


export type CreateOrganizationApiKeyMutation = { __typename?: 'Mutation', CreateOrganizationApiKey: { __typename?: 'CreateOrganizationApiKey', success: boolean } };

export type DeleteOrganizationApiKeyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationApiKeyMutation = { __typename?: 'Mutation', DeleteOrganizationApiKey: { __typename?: 'DeleteOrganizationApiKey', success: boolean } };

export type AcceptUserInviteMutationVariables = Exact<{
  input: AcceptUserInviteInput;
}>;


export type AcceptUserInviteMutation = { __typename?: 'Mutation', acceptUserInvite?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type AddJobPhaseCostsMutationVariables = Exact<{
  input: AddJobPhaseCostsInput;
}>;


export type AddJobPhaseCostsMutation = { __typename?: 'Mutation', addJobPhaseCosts: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }, plant: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string }, plantProduct: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type AddJobPhaseFileMutationVariables = Exact<{
  jobPhaseId: Scalars['ID'];
  path: Scalars['String'];
}>;


export type AddJobPhaseFileMutation = { __typename?: 'Mutation', addJobPhaseFile: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } };

export type AddMaterialNoPlantToProposalProductMutationVariables = Exact<{
  input: AddMaterialNoPlantToProposalProductInput;
}>;


export type AddMaterialNoPlantToProposalProductMutation = { __typename?: 'Mutation', addMaterialNoPlantToProposalProduct: { __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } };

export type AddOrganizationDataUploadMutationVariables = Exact<{
  input: AddOrganizationDataUploadInput;
}>;


export type AddOrganizationDataUploadMutation = { __typename?: 'Mutation', addOrganizationDataUpload: { __typename?: 'OrganizationDataUpload', createdAt: any, error?: string | null, id: string, path: string, startedAt?: any | null, status: OrganizationDataUploadStatus, type: OrganizationDataUploadType, updatedAt: any, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } };

export type AddOrganizationDocumentMutationVariables = Exact<{
  name: Scalars['String'];
  path: Scalars['String'];
}>;


export type AddOrganizationDocumentMutation = { __typename?: 'Mutation', addOrganizationDocument: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type AddPlantProductToProposalProductMutationVariables = Exact<{
  input: AddPlantProductToProposalProductInput;
}>;


export type AddPlantProductToProposalProductMutation = { __typename?: 'Mutation', addPlantProductToProposalProduct: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type AddProductsToProposalStageMutationVariables = Exact<{
  input: AddProductsToProposalStageInput;
}>;


export type AddProductsToProposalStageMutation = { __typename?: 'Mutation', addProductsToProposalStage: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type AddProjectFileMutationVariables = Exact<{
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['ID']>;
  path: Scalars['String'];
}>;


export type AddProjectFileMutation = { __typename?: 'Mutation', addProjectFile: { __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null } };

export type AddProposalAdditionalCostMutationVariables = Exact<{
  additionalCostId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalAdditionalCostMutation = { __typename?: 'Mutation', addProposalAdditionalCost: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type AddProposalAdditionalCostsMutationVariables = Exact<{
  additionalCosts: Array<Scalars['ID']> | Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalAdditionalCostsMutation = { __typename?: 'Mutation', addProposalAdditionalCosts: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type AddProposalAddressMutationVariables = Exact<{
  input: AddProposalAddressInput;
}>;


export type AddProposalAddressMutation = { __typename?: 'Mutation', addProposalAddress: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type AddProposalCrewMutationVariables = Exact<{
  crewId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalCrewMutation = { __typename?: 'Mutation', addProposalCrew: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type AddProposalCrewsMutationVariables = Exact<{
  crewIds: Array<Scalars['ID']> | Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalCrewsMutation = { __typename?: 'Mutation', addProposalCrews: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type AddProposalEquipmentPieceMutationVariables = Exact<{
  equipmentPieceId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Float'];
}>;


export type AddProposalEquipmentPieceMutation = { __typename?: 'Mutation', addProposalEquipmentPiece: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type AddProposalEquipmentPiecesMutationVariables = Exact<{
  equipmentPieces: Array<AddProposalEquipmentPieceInput> | AddProposalEquipmentPieceInput;
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalEquipmentPiecesMutation = { __typename?: 'Mutation', addProposalEquipmentPieces: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type AddProposalFileMutationVariables = Exact<{
  path: Scalars['String'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalFileMutation = { __typename?: 'Mutation', addProposalFile: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string, production?: { __typename?: 'ProductionHelper', enabled: boolean, materialRowId?: string | null, period: string, quantity?: string | null, rate: string, source: string, unit: string } | null, travel?: { __typename?: 'TravelHelper', enabled: boolean, roundTripHours: string, visits?: string | null } | null } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string, hauling?: { __typename?: 'HaulingHelper', allocationPercent: string, capacity: string, capacityUnit: string, fullLoads: boolean, haulQuantity?: string | null, haulUnit?: string | null, loadHours: string, materialRowId: string, maxTripsPerDay?: string | null, planningEnabled?: boolean | null, planningHours?: string | null, quantityMode?: string | null, roundTripHours: string, unloadHours: string } | null }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } };

export type AddProposalStageMutationVariables = Exact<{
  proposalId: Scalars['ID'];
}>;


export type AddProposalStageMutation = { __typename?: 'Mutation', addProposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } | null };

export type AddProposalStageChecklistItemsMutationVariables = Exact<{
  input: AddProposalStageChecklistItemsInput;
}>;


export type AddProposalStageChecklistItemsMutation = { __typename?: 'Mutation', addProposalStageChecklistItems: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type AddTruckToProposalProductMutationVariables = Exact<{
  input: AddTruckToProposalProductInput;
}>;


export type AddTruckToProposalProductMutation = { __typename?: 'Mutation', addTruckToProposalProduct?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null };

export type AppLoginMutationVariables = Exact<{
  force?: InputMaybe<Scalars['Boolean']>;
  input: LoginInput;
}>;


export type AppLoginMutation = { __typename?: 'Mutation', appLogin?: { __typename: 'ActiveSessionConflict', message: string } | { __typename: 'LoginAppUser', token?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type AppLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type AppLogoutMutation = { __typename?: 'Mutation', appLogout?: boolean | null };

export type ApplyAiMappingAdditionalCostsMutationVariables = Exact<{
  input: ApplyAiMappingAdditionalCostsInput;
}>;


export type ApplyAiMappingAdditionalCostsMutation = { __typename?: 'Mutation', applyAiMappingAdditionalCosts: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type ApplyProposalStageMeasurementsMutationVariables = Exact<{
  input: ApplyProposalStageMeasurementsInput;
}>;


export type ApplyProposalStageMeasurementsMutation = { __typename?: 'Mutation', applyProposalStageMeasurements: { __typename?: 'ApplyProposalStageMeasurementsPayload', warnings: Array<string>, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null } | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null } } };

export type ArchiveCompanyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveCompanyMutation = { __typename?: 'Mutation', archiveCompany: boolean };

export type ArchiveCustomProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveCustomProductMutation = { __typename?: 'Mutation', archiveCustomProduct: boolean };

export type ArchiveEmployeeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveEmployeeMutation = { __typename?: 'Mutation', archiveEmployee: { __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type ArchiveWorksheetProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveWorksheetProductMutation = { __typename?: 'Mutation', archiveWorksheetProduct: boolean };

export type CancelAiMappingTaskMutationVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type CancelAiMappingTaskMutation = { __typename?: 'Mutation', cancelAiMappingTask: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any } };

export type CancelOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelOpportunityMutation = { __typename?: 'Mutation', cancelOpportunity: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type CancelProposalMutationVariables = Exact<{
  duplicate: Scalars['Boolean'];
  id: Scalars['ID'];
  maintainCurrentId?: InputMaybe<Scalars['Boolean']>;
}>;


export type CancelProposalMutation = { __typename?: 'Mutation', cancelProposal: { __typename?: 'CancelProposalResponse', newProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null } | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } } };

export type CloseProposalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CloseProposalMutation = { __typename?: 'Mutation', closeProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type CompleteTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompleteTaskMutation = { __typename?: 'Mutation', completeTask?: { __typename?: 'Task', completedAt?: any | null, content: string, createdAt: any, dueAt?: any | null, id: string, notifiableExternalId?: string | null, notifiableId?: string | null, notifiableType?: string | null, status: string, triggerEvent?: string | null, triggerType?: string | null, updatedAt: any, assignedUser: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }, company?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null, contact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTrigger?: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, apiHeaders?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiSecret?: string | null, apiUrl?: string | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isApi?: boolean | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, taskContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, isTask?: boolean | null, lastName: string, taskContent?: string | null }>, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null };

export type CopyProposalProductToStageMutationVariables = Exact<{
  proposalProductId: Scalars['ID'];
  targetStageId: Scalars['ID'];
}>;


export type CopyProposalProductToStageMutation = { __typename?: 'Mutation', copyProposalProductToStage: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type CreateAdditionalCostMutationVariables = Exact<{
  input: CreateAdditionalCostInput;
}>;


export type CreateAdditionalCostMutation = { __typename?: 'Mutation', createAdditionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } };

export type CreateAiMappingDetectionMutationVariables = Exact<{
  input: CreateAiMappingDetectionInput;
}>;


export type CreateAiMappingDetectionMutation = { __typename?: 'Mutation', createAiMappingDetection: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', bbox: Array<number>, category: string, color?: string | null, confidence?: number | null, id: string, isDeleted: boolean, source?: string | null, version: number }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', areaSqft?: number | null, category: string, color?: string | null, id: string, isDeleted: boolean, polygon: Array<number>, version: number }> } };

export type CreateAiMappingRunMutationVariables = Exact<{
  projectMapId: Scalars['ID'];
}>;


export type CreateAiMappingRunMutation = { __typename?: 'Mutation', createAiMappingRun: { __typename?: 'AiMappingRun', createdAt: any, description?: string | null, id: string, name: string, updatedAt: any, areas: Array<{ __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }>, projectMap: { __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number }> | null } | null }> } } };

export type CreateAiMappingRunAreaMutationVariables = Exact<{
  input: CreateAiMappingRunAreaInput;
}>;


export type CreateAiMappingRunAreaMutation = { __typename?: 'Mutation', createAiMappingRunArea: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any } };

export type CreateAiMappingSegmentationMutationVariables = Exact<{
  input: CreateAiMappingSegmentationInput;
}>;


export type CreateAiMappingSegmentationMutation = { __typename?: 'Mutation', createAiMappingSegmentation: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', bbox: Array<number>, category: string, color?: string | null, confidence?: number | null, id: string, isDeleted: boolean, source?: string | null, version: number }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', areaSqft?: number | null, category: string, color?: string | null, id: string, isDeleted: boolean, polygon: Array<number>, version: number }> } };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } };

export type CreateCrewMutationVariables = Exact<{
  input: CreateCrewInput;
}>;


export type CreateCrewMutation = { __typename?: 'Mutation', createCrew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } };

export type CreateCustomEventMutationVariables = Exact<{
  input?: InputMaybe<CreateCustomEventInput>;
}>;


export type CreateCustomEventMutation = { __typename?: 'Mutation', createCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string, customEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }> } | null };

export type CreateDailyFormInspectionMutationVariables = Exact<{
  input: CreateDailyFormInspectionInput;
}>;


export type CreateDailyFormInspectionMutation = { __typename?: 'Mutation', createDailyFormInspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type CreateDailyFormInspectionQuestionMutationVariables = Exact<{
  input: CreateDailyFormInspectionQuestionInput;
}>;


export type CreateDailyFormInspectionQuestionMutation = { __typename?: 'Mutation', createDailyFormInspectionQuestion: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type CreateDailyFormVehicleMutationVariables = Exact<{
  input: CreateDailyFormVehicleInput;
}>;


export type CreateDailyFormVehicleMutation = { __typename?: 'Mutation', createDailyFormVehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } };

export type CreateDailyFormVehiclePartMutationVariables = Exact<{
  input: CreateDailyFormVehiclePartInput;
}>;


export type CreateDailyFormVehiclePartMutation = { __typename?: 'Mutation', createDailyFormVehiclePart: { __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> } } };

export type CreateDailyFormVehicleServicePlanMutationVariables = Exact<{
  input: CreateDailyFormVehicleServicePlanInput;
}>;


export type CreateDailyFormVehicleServicePlanMutation = { __typename?: 'Mutation', createDailyFormVehicleServicePlan: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }> } };

export type CreateDailyFormVehicleTypeMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateDailyFormVehicleTypeMutation = { __typename?: 'Mutation', createDailyFormVehicleType: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type CreateDailyFormWorkOrderMutationVariables = Exact<{
  input: CreateDailyFormWorkOrderInput;
}>;


export type CreateDailyFormWorkOrderMutation = { __typename?: 'Mutation', createDailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } } };

export type CreateEmployeeMutationVariables = Exact<{
  input: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type CreateEquipmentPieceMutationVariables = Exact<{
  input: CreateEquipmentPieceInput;
}>;


export type CreateEquipmentPieceMutation = { __typename?: 'Mutation', createEquipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } };

export type CreateJobInvoiceOnLinkedServiceMutationVariables = Exact<{
  createEstimate?: InputMaybe<Scalars['Boolean']>;
  createInvoice?: InputMaybe<Scalars['Boolean']>;
  createJob?: InputMaybe<Scalars['Boolean']>;
  jobId: Scalars['ID'];
  service: OrganizationLinkedServiceName;
}>;


export type CreateJobInvoiceOnLinkedServiceMutation = { __typename?: 'Mutation', createJobInvoiceOnLinkedService?: boolean | null };

export type CreateNotificationTriggerMutationVariables = Exact<{
  input: CreateNotificationTriggerInput;
}>;


export type CreateNotificationTriggerMutation = { __typename?: 'Mutation', createNotificationTrigger?: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, apiHeaders?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiSecret?: string | null, apiUrl?: string | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isApi?: boolean | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, taskContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, isTask?: boolean | null, lastName: string, taskContent?: string | null }>, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } | null };

export type CreateOpportunityMutationVariables = Exact<{
  input: CreateOpportunityInput;
}>;


export type CreateOpportunityMutation = { __typename?: 'Mutation', createOpportunity: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type CreateOpportunityStatusMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateOpportunityStatusMutation = { __typename?: 'Mutation', createOpportunityStatus: { __typename?: 'OrganizationOpportunityStatus', id: string, name: string, ordering: number } };

export type CreateOrganizationAddressMutationVariables = Exact<{
  input: CreateOrganizationAddressInput;
}>;


export type CreateOrganizationAddressMutation = { __typename?: 'Mutation', createOrganizationAddress?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null };

export type CreateOrganizationCustomContentTypeMutationVariables = Exact<{
  input: CreateCustomContentTypeInput;
}>;


export type CreateOrganizationCustomContentTypeMutation = { __typename?: 'Mutation', createOrganizationCustomContentType: { __typename?: 'OrganizationProposalLayoutContentSetting', contentType: string, id: string, organizationId: string, showOnBranded: boolean, showOnFull: boolean, showOnSimple: boolean, showOnTabular: boolean } };

export type CreateOrganizationProductTypeMutationVariables = Exact<{
  input: CreateOrganizationProductTypeInput;
}>;


export type CreateOrganizationProductTypeMutation = { __typename?: 'Mutation', createOrganizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } };

export type CreateOrganizationProposalChecklistItemMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateOrganizationProposalChecklistItemMutation = { __typename?: 'Mutation', createOrganizationProposalChecklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null } };

export type CreatePlantMutationVariables = Exact<{
  input: CreatePlantInput;
}>;


export type CreatePlantMutation = { __typename?: 'Mutation', createPlant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null };

export type CreatePlantProductTypeMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreatePlantProductTypeMutation = { __typename?: 'Mutation', createPlantProductType?: { __typename?: 'ModelsPlantProductType', id: string, name: string } | null };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } };

export type CreateProductGroupMutationVariables = Exact<{
  input: CreateProductGroupInput;
}>;


export type CreateProductGroupMutation = { __typename?: 'Mutation', createProductGroup: { __typename?: 'ProductGroup', id: string, name: string, organizationId: string, products: Array<{ __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null }> } };

export type CreateProjectFileFolderMutationVariables = Exact<{
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateProjectFileFolderMutation = { __typename?: 'Mutation', createProjectFileFolder: { __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null } };

export type CreateProjectMapMutationVariables = Exact<{
  input: CreateProjectMapInput;
}>;


export type CreateProjectMapMutation = { __typename?: 'Mutation', createProjectMap: { __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type CreateProposalMutationVariables = Exact<{
  closeConfidence?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  projectedCloseDate?: InputMaybe<Scalars['Date']>;
  source?: InputMaybe<ProposalSource>;
}>;


export type CreateProposalMutation = { __typename?: 'Mutation', createProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type CreateProposalFromOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreateProposalFromOpportunityMutation = { __typename?: 'Mutation', createProposalFromOpportunity: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type CreateProposalFromProjectMapMutationVariables = Exact<{
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  projectMapId: Scalars['ID'];
  stageName?: InputMaybe<Scalars['String']>;
}>;


export type CreateProposalFromProjectMapMutation = { __typename?: 'Mutation', createProposalFromProjectMap: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask?: { __typename?: 'Task', completedAt?: any | null, content: string, createdAt: any, dueAt?: any | null, id: string, notifiableExternalId?: string | null, notifiableId?: string | null, notifiableType?: string | null, status: string, triggerEvent?: string | null, triggerType?: string | null, updatedAt: any, assignedUser: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }, company?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null, contact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTrigger?: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, apiHeaders?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiSecret?: string | null, apiUrl?: string | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isApi?: boolean | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, taskContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, isTask?: boolean | null, lastName: string, taskContent?: string | null }>, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null };

export type CreateTimeBucketMutationVariables = Exact<{
  input: CreateTimeBucketInput;
}>;


export type CreateTimeBucketMutation = { __typename?: 'Mutation', createTimeBucket: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } };

export type CreateTimeEntryMutationVariables = Exact<{
  input: CreateTimeEntryInput;
}>;


export type CreateTimeEntryMutation = { __typename?: 'Mutation', createTimeEntry: { __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }> } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type CreateTransferTruckMutationVariables = Exact<{
  input: CreateTransferTruckInput;
}>;


export type CreateTransferTruckMutation = { __typename?: 'Mutation', createTransferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null };

export type DeleteAdditionalCostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAdditionalCostMutation = { __typename?: 'Mutation', deleteAdditionalCost?: boolean | null };

export type DeleteAiMappingDetectionMutationVariables = Exact<{
  detectionId: Scalars['ID'];
  runAreaId: Scalars['ID'];
}>;


export type DeleteAiMappingDetectionMutation = { __typename?: 'Mutation', deleteAiMappingDetection: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', bbox: Array<number>, category: string, color?: string | null, confidence?: number | null, id: string, isDeleted: boolean, source?: string | null, version: number }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', areaSqft?: number | null, category: string, color?: string | null, id: string, isDeleted: boolean, polygon: Array<number>, version: number }> } };

export type DeleteAiMappingSegmentationMutationVariables = Exact<{
  runAreaId: Scalars['ID'];
  segmentationId: Scalars['ID'];
}>;


export type DeleteAiMappingSegmentationMutation = { __typename?: 'Mutation', deleteAiMappingSegmentation: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', bbox: Array<number>, category: string, color?: string | null, confidence?: number | null, id: string, isDeleted: boolean, source?: string | null, version: number }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', areaSqft?: number | null, category: string, color?: string | null, id: string, isDeleted: boolean, polygon: Array<number>, version: number }> } };

export type DeleteCrewMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCrewMutation = { __typename?: 'Mutation', deleteCrew?: boolean | null };

export type DeleteCustomEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCustomEventMutation = { __typename?: 'Mutation', deleteCustomEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string, customEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }> } };

export type DeleteDailyFormInspectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDailyFormInspectionMutation = { __typename?: 'Mutation', deleteDailyFormInspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type DeleteDailyFormInspectionQuestionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDailyFormInspectionQuestionMutation = { __typename?: 'Mutation', deleteDailyFormInspectionQuestion: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type DeleteDailyFormVehicleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDailyFormVehicleMutation = { __typename?: 'Mutation', deleteDailyFormVehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } };

export type DeleteDailyFormVehiclePartMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDailyFormVehiclePartMutation = { __typename?: 'Mutation', deleteDailyFormVehiclePart: { __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> } } };

export type DeleteDailyFormVehicleServicePlanMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDailyFormVehicleServicePlanMutation = { __typename?: 'Mutation', deleteDailyFormVehicleServicePlan: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }> } };

export type DeleteDailyFormVehicleTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDailyFormVehicleTypeMutation = { __typename?: 'Mutation', deleteDailyFormVehicleType: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type DeleteDailyFormWorkOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDailyFormWorkOrderMutation = { __typename?: 'Mutation', deleteDailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } } };

export type DeleteEmployeeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', deleteEmployee?: boolean | null };

export type DeleteEquipmentPieceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEquipmentPieceMutation = { __typename?: 'Mutation', deleteEquipmentPiece?: boolean | null };

export type DeleteJobPhaseCostMutationVariables = Exact<{
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
}>;


export type DeleteJobPhaseCostMutation = { __typename?: 'Mutation', deleteJobPhaseCost: boolean };

export type DeleteJobPhaseFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteJobPhaseFileMutation = { __typename?: 'Mutation', deleteJobPhaseFile?: boolean | null };

export type DeleteNotificationTriggerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNotificationTriggerMutation = { __typename?: 'Mutation', deleteNotificationTrigger?: boolean | null };

export type DeleteOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOpportunityMutation = { __typename?: 'Mutation', deleteOpportunity?: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type DeleteOrganizationAddressMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationAddressMutation = { __typename?: 'Mutation', deleteOrganizationAddress?: boolean | null };

export type DeleteOrganizationCustomContentTypeMutationVariables = Exact<{
  contentType: Scalars['String'];
}>;


export type DeleteOrganizationCustomContentTypeMutation = { __typename?: 'Mutation', deleteOrganizationCustomContentType: boolean };

export type DeleteOrganizationDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationDocumentMutation = { __typename?: 'Mutation', deleteOrganizationDocument: boolean };

export type DeleteOrganizationEmailIdentityMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteOrganizationEmailIdentityMutation = { __typename?: 'Mutation', deleteOrganizationEmailIdentity: boolean };

export type DeleteOrganizationProductTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationProductTypeMutation = { __typename?: 'Mutation', deleteOrganizationProductType?: boolean | null };

export type DeleteOrganizationProposalChecklistItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationProposalChecklistItemMutation = { __typename?: 'Mutation', deleteOrganizationProposalChecklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null } };

export type DeleteOrganizationUserMutationVariables = Exact<{
  id: Scalars['ID'];
  openProposalAction: DeleteOpenProposalAction;
  reassignJobPhaseForemanUserId?: InputMaybe<Scalars['ID']>;
  reassignJobUserId?: InputMaybe<Scalars['ID']>;
  reassignUserId?: InputMaybe<Scalars['ID']>;
}>;


export type DeleteOrganizationUserMutation = { __typename?: 'Mutation', deleteOrganizationUser: boolean };

export type DeletePlantMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePlantMutation = { __typename?: 'Mutation', deletePlant?: boolean | null };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct?: boolean | null };

export type DeleteProductGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProductGroupMutation = { __typename?: 'Mutation', deleteProductGroup?: boolean | null };

export type DeleteProjectFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProjectFileMutation = { __typename?: 'Mutation', deleteProjectFile: { __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null } };

export type DeleteProjectMapMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProjectMapMutation = { __typename?: 'Mutation', deleteProjectMap: { __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type DeleteProposalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalMutation = { __typename?: 'Mutation', deleteProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type DeleteProposalFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalFileMutation = { __typename?: 'Mutation', deleteProposalFile: boolean };

export type DeleteProposalMapImageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalMapImageMutation = { __typename?: 'Mutation', deleteProposalMapImage: boolean };

export type DeleteProposalMaterialNoPlantMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalMaterialNoPlantMutation = { __typename?: 'Mutation', deleteProposalMaterialNoPlant: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type DeleteProposalPlantProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalPlantProductMutation = { __typename?: 'Mutation', deleteProposalPlantProduct: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type DeleteProposalProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalProductMutation = { __typename?: 'Mutation', deleteProposalProduct: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type DeleteProposalProductProjectFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalProductProjectFileMutation = { __typename?: 'Mutation', deleteProposalProductProjectFile?: boolean | null };

export type DeleteProposalRecipientMutationVariables = Exact<{
  email: Scalars['String'];
  proposalId: Scalars['ID'];
}>;


export type DeleteProposalRecipientMutation = { __typename?: 'Mutation', deleteProposalRecipient: boolean };

export type DeleteProposalStageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalStageMutation = { __typename?: 'Mutation', deleteProposalStage: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask?: boolean | null };

export type DeleteTimeBucketMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTimeBucketMutation = { __typename?: 'Mutation', deleteTimeBucket: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } };

export type DeleteTimeEntryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTimeEntryMutation = { __typename?: 'Mutation', deleteTimeEntry?: { __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }> } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type DeleteTransferTruckMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTransferTruckMutation = { __typename?: 'Mutation', deleteTransferTruck?: boolean | null };

export type DeleteUserInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserInviteMutation = { __typename?: 'Mutation', deleteUserInvite?: boolean | null };

export type DetectAiMappingRunAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DetectAiMappingRunAreaMutation = { __typename?: 'Mutation', detectAiMappingRunArea: { __typename?: 'AiMappingDetectResponse', taskId: string, area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any } } };

export type DownloadProposalMutationVariables = Exact<{
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
}>;


export type DownloadProposalMutation = { __typename?: 'Mutation', downloadProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type DuplicateProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DuplicateProductMutation = { __typename?: 'Mutation', duplicateProduct: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } };

export type DuplicateProposalMutationVariables = Exact<{
  changeOrderJobId?: InputMaybe<Scalars['ID']>;
  changeOrderProposalType?: InputMaybe<ChangeOrderProposalType>;
  changeOrderScheduledJobsAction?: InputMaybe<ChangeOrderScheduledJobsAction>;
  createNewVersion?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isChangeOrder?: InputMaybe<Scalars['Boolean']>;
  startNewProposal?: InputMaybe<Scalars['Boolean']>;
}>;


export type DuplicateProposalMutation = { __typename?: 'Mutation', duplicateProposal?: { __typename?: 'DuplicateProposalResponse', newProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null } | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } } | null };

export type DuplicateProposalStageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DuplicateProposalStageMutation = { __typename?: 'Mutation', duplicateProposalStage: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type ExportAiMappingRunAreaPdfMutationVariables = Exact<{
  id: Scalars['ID'];
  includeAnnotations?: InputMaybe<Scalars['Boolean']>;
  includeCounts?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExportAiMappingRunAreaPdfMutation = { __typename?: 'Mutation', exportAiMappingRunAreaPdf: { __typename?: 'AiMappingDetectResponse', taskId: string, area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any } } };

export type FinalizeLinkedServiceAccountMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
  realmId?: InputMaybe<Scalars['String']>;
  service: OrganizationLinkedServiceName;
  state?: InputMaybe<Scalars['String']>;
}>;


export type FinalizeLinkedServiceAccountMutation = { __typename?: 'Mutation', finalizeLinkedServiceAccount?: boolean | null };

export type FinishRegistrationMutationVariables = Exact<{
  input: FinishRegistrationInput;
}>;


export type FinishRegistrationMutation = { __typename?: 'Mutation', finishRegistration?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type GenerateOrganizationDataUploadUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateOrganizationDataUploadUrlMutation = { __typename?: 'Mutation', generateOrganizationDataUploadUrl: { __typename?: 'GenerateUploadOrganizationDocumentUrl', method: string, path: string, url: string } };

export type GenerateReportMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  estimatorId?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  productTypeId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  type: ReportType;
  wonAt?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenerateReportMutation = { __typename?: 'Mutation', generateReport: string };

export type GenerateUploadCompanyLogoUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateUploadCompanyLogoUrlMutation = { __typename?: 'Mutation', generateUploadCompanyLogoUrl: { __typename?: 'GenerateUploadCompanyLogoUrl', method: string, path: string, url: string } };

export type GenerateUploadCustomEventFileUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateUploadCustomEventFileUrlMutation = { __typename?: 'Mutation', generateUploadCustomEventFileUrl: { __typename?: 'GenerateUploadUrl', contentDisposition?: string | null, contentType: string, method: string, path: string, url: string } };

export type GenerateUploadDailyFormWorkOrderFileUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateUploadDailyFormWorkOrderFileUrlMutation = { __typename?: 'Mutation', generateUploadDailyFormWorkOrderFileUrl: { __typename?: 'GenerateUploadUrl', contentDisposition?: string | null, contentType: string, method: string, path: string, url: string } };

export type GenerateUploadJobPhaseCostItemFileUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
  jobPhaseId: Scalars['ID'];
}>;


export type GenerateUploadJobPhaseCostItemFileUrlMutation = { __typename?: 'Mutation', generateUploadJobPhaseCostItemFileUrl: { __typename?: 'GenerateUploadProposalFileUrl', method: string, path: string, url: string } };

export type GenerateUploadOrganizationDocumentUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateUploadOrganizationDocumentUrlMutation = { __typename?: 'Mutation', generateUploadOrganizationDocumentUrl: { __typename?: 'GenerateUploadOrganizationDocumentUrl', method: string, path: string, url: string } };

export type GenerateUploadOrganizationLogoUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateUploadOrganizationLogoUrlMutation = { __typename?: 'Mutation', generateUploadOrganizationLogoUrl: { __typename?: 'GenerateUploadOrganizationLogoUrl', method: string, path: string, url: string } };

export type GenerateUploadProjectFileUrlMutationVariables = Exact<{
  contentType?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
}>;


export type GenerateUploadProjectFileUrlMutation = { __typename?: 'Mutation', generateUploadProjectFileUrl: { __typename?: 'GenerateUploadUrl', contentDisposition?: string | null, contentType: string, method: string, path: string, url: string } };

export type GenerateUploadProjectMapImageUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
  projectMapId: Scalars['ID'];
}>;


export type GenerateUploadProjectMapImageUrlMutation = { __typename?: 'Mutation', generateUploadProjectMapImageUrl: { __typename?: 'GenerateUploadProjectMapImageUrl', method: string, path: string, url: string } };

export type GenerateUploadProposalFileUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
  proposalProductId: Scalars['ID'];
}>;


export type GenerateUploadProposalFileUrlMutation = { __typename?: 'Mutation', generateUploadProposalFileUrl: { __typename?: 'GenerateUploadProposalFileUrl', method: string, path: string, url: string } };

export type GetLinkedServiceAuthUrlMutationVariables = Exact<{
  service: OrganizationLinkedServiceName;
}>;


export type GetLinkedServiceAuthUrlMutation = { __typename?: 'Mutation', getLinkedServiceAuthUrl?: string | null };

export type GetReportAdditionalCostMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportAdditionalCostMutation = { __typename?: 'Mutation', getReportAdditionalCost: { __typename?: 'getReportAdditionalCostResponse', data: Array<{ __typename?: 'AdditionalCostItem', additional_cost_amount?: number | null, additional_cost_id?: string | null, additional_cost_name?: string | null, additional_cost_quantity?: number | null, job_id: string }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportCompanyOrClientDetailsMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportCompanyOrClientDetailsMutation = { __typename?: 'Mutation', getReportCompanyOrClientDetails: { __typename?: 'getReportCompanyOrClientDetailsResponse', data: Array<{ __typename?: 'CompanyOrClientDetails', companyId?: string | null, companyName?: string | null, companyStatus?: string | null, orgRevenuePercentage?: number | null, proposalsCount?: number | null, proposalsWonAmountTotal?: number | null, proposalsWonCount?: number | null, winRate?: number | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportContactDetailsMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetReportContactDetailsMutation = { __typename?: 'Mutation', getReportContactDetails: { __typename?: 'getReportContactDetailsResponse', data: Array<{ __typename?: 'ContactDetails', address_city?: string | null, address_country?: string | null, address_line_1?: string | null, address_line_2?: string | null, address_state?: string | null, address_zip?: string | null, company_id?: string | null, contact_email?: string | null, contact_phone?: string | null, email?: string | null, first_name?: string | null, id?: string | null, last_name?: string | null, name?: string | null, notes?: string | null, phone?: string | null, role?: string | null, status?: string | null, title?: string | null, website?: string | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportCrewDetailsMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportCrewDetailsMutation = { __typename?: 'Mutation', getReportCrewDetails: { __typename?: 'getReportCrewDetailsResponse', data: Array<{ __typename?: 'ReportCrewDetailsItem', actual_labour_hours: number, crew_name?: string | null, estimated_labour_hours: number, job_id: string, job_size: string, material_cost_type?: string | null, proposal_total_amount: number, total_material_used: number }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportEquipmentCostDetailsMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportEquipmentCostDetailsMutation = { __typename?: 'Mutation', getReportEquipmentCostDetails: { __typename?: 'getReportEquipmentCostDetailsResponse', data: Array<{ __typename?: 'ReportEquipmentCostDetailsItem', equipmentCost: number, equipmentHours: number, equipmentId?: string | null, equipmentName: string, jobId: string }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportJobCostByProductTypeMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  jobId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportJobCostByProductTypeMutation = { __typename?: 'Mutation', getReportJobCostByProductType: { __typename?: 'getReportJobCostByProductTypeResponse', data: Array<{ __typename?: 'ReportJobCostByProductTypeItem', actual_cost_equipment: number, actual_cost_labour: number, actual_cost_material: number, actual_cost_transfer_truck: number, actual_employee_hours: number, job_id: string, job_size: string, organization_product_type_name: string, proposed_cost_equipment: number, proposed_cost_labour: number, proposed_cost_material: number, proposed_cost_transfer_truck: number, proposed_employee_hours: number }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportJobCostDetailMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type GetReportJobCostDetailMutation = { __typename?: 'Mutation', getReportJobCostDetail: { __typename?: 'getReportJobCostDetailResponse', additional_costs: Array<{ __typename?: 'ReportJobCostDetailAdditionalCostItem', cost: number, date: string, expense: string, qty: number, rate: number }>, employees: Array<{ __typename?: 'ReportJobCostDetailEmployeeItem', cost: number, date: string, employee: string, hours: number, rate: number }>, equipment: Array<{ __typename?: 'ReportJobCostDetailEquipmentItem', cost: number, date: string, equipment: string, hours: number, rate: number }>, header: { __typename?: 'ReportJobCostDetailHeader', company_name: string, job_external_id: string, job_id: string, job_name: string, status: string, total_proposed_amount: number }, materials: Array<{ __typename?: 'ReportJobCostDetailMaterialItem', cost: number, date: string, material: string, qty: number, rate: number }>, summary: { __typename?: 'ReportJobCostDetailSummary', actual_profit: number, additional_costs_difference_percent: number, additional_costs_total: number, employees_difference_percent: number, employees_total: number, equipment_difference_percent: number, equipment_total: number, material_difference_percent: number, material_total: number, profit_difference_percent: number, proposed_additional_costs_total: number, proposed_employees_total: number, proposed_equipment_total: number, proposed_material_total: number, proposed_profit: number, proposed_total_job_cost: number, proposed_trucking_total: number, total_job_cost: number, total_job_cost_difference_percent: number, trucking_difference_percent: number, trucking_total: number }, trucking: Array<{ __typename?: 'ReportJobCostDetailTruckingItem', cost: number, date: string, qty: number, rate: number, truck: string }> } };

export type GetReportJobDetailsMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  jobId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportJobDetailsMutation = { __typename?: 'Mutation', getReportJobDetails: { __typename?: 'getReportJobDetailsResponse', data: Array<{ __typename?: 'ReportJobDetailsItem', actual_cost_additional?: number | null, actual_cost_direct?: number | null, actual_cost_equipment?: number | null, actual_cost_indirect?: number | null, actual_cost_labour?: number | null, actual_cost_material?: number | null, actual_cost_overhead?: number | null, actual_cost_total?: number | null, actual_gross_margin?: number | null, actual_gross_margin_percentage?: number | null, actual_net_margin?: number | null, actual_net_margin_percentage?: number | null, actual_operating_margin?: number | null, actual_operating_margin_percentage?: number | null, actual_overall_total?: number | null, actual_profit?: number | null, actual_profit_percentage?: number | null, company_name?: string | null, crew_display_name?: string | null, crew_name?: string | null, ends_at?: string | null, job_address_city?: string | null, job_address_line_1?: string | null, job_address_state?: string | null, job_address_zip?: string | null, job_external_id: string, job_id: string, notes?: string | null, organization_product_type_name?: string | null, proposal_external_id: string, proposal_product_job_duration?: string | null, proposal_product_job_size?: string | null, proposal_product_material_type?: string | null, proposal_product_material_used?: string | null, proposal_product_name?: string | null, proposal_stage_id: string, proposal_stage_name?: string | null, proposed_cost_additional?: number | null, proposed_cost_direct?: number | null, proposed_cost_equipment?: number | null, proposed_cost_indirect?: number | null, proposed_cost_labour?: number | null, proposed_cost_material?: number | null, proposed_cost_overhead?: number | null, proposed_cost_total?: number | null, proposed_gross_margin?: number | null, proposed_gross_margin_percentage?: number | null, proposed_net_margin?: number | null, proposed_net_margin_percentage?: number | null, proposed_operating_margin?: number | null, proposed_operating_margin_percentage?: number | null, proposed_overall_total?: number | null, proposed_profit?: number | null, proposed_profit_percentage?: number | null, starts_at?: string | null, status: string }>, metadata: { __typename?: 'JobDetailsMetadata', totals: { __typename?: 'JobDetailsTotals', actual_cost_additional: number, actual_cost_direct: number, actual_cost_equipment: number, actual_cost_indirect: number, actual_cost_labour: number, actual_cost_material: number, actual_cost_overhead: number, actual_cost_total: number, actual_gross_margin: number, actual_net_margin: number, actual_operating_margin: number, actual_overall_total: number, actual_profit: number, proposed_cost_additional: number, proposed_cost_direct: number, proposed_cost_equipment: number, proposed_cost_indirect: number, proposed_cost_labour: number, proposed_cost_material: number, proposed_cost_overhead: number, proposed_cost_total: number, proposed_gross_margin: number, proposed_net_margin: number, proposed_operating_margin: number, proposed_overall_total: number, proposed_profit: number } }, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportJobsByContactMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportJobsByContactMutation = { __typename?: 'Mutation', getReportJobsByContact: { __typename?: 'getReportJobsByContactResponse', data: Array<{ __typename?: 'JobsByContact', customerName?: string | null, job?: string | null, jobSize?: string | null, total?: string | null }>, metadata: { __typename?: 'JobsByContactMetadata', totals: { __typename?: 'JobsByContactTotals', grand_total: number } }, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportOrganizationProfitabilityMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  productTypeId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportOrganizationProfitabilityMutation = { __typename?: 'Mutation', getReportOrganizationProfitability: { __typename?: 'getReportOrganizationProfitabilityResponse', data: Array<{ __typename?: 'ReportOrganizationProfitabilityItem', actual_cost_additional: number, actual_cost_equipment: number, actual_cost_labour: number, actual_cost_material: number, actual_cost_transfer_truck: number, actual_profit: number, additional_variance_percentage?: number | null, cost_basis?: string | null, equipment_variance_percentage?: number | null, items_without_costs?: number | null, labour_variance_percentage?: number | null, material_variance_percentage?: number | null, organization_product_type_name: string, profit_variance_dollars?: number | null, profit_variance_percentage?: number | null, proposed_cost_additional: number, proposed_cost_equipment: number, proposed_cost_labour: number, proposed_cost_material: number, proposed_cost_transfer_truck: number, proposed_profit?: number | null, trucking_variance_percentage?: number | null }>, metadata: { __typename?: 'OrganizationProfitabilityMetadata', totals: { __typename?: 'ReportOrganizationProfitabilityItem', actual_cost_additional: number, actual_cost_equipment: number, actual_cost_labour: number, actual_cost_material: number, actual_cost_transfer_truck: number, actual_profit: number, additional_variance_percentage?: number | null, cost_basis?: string | null, equipment_variance_percentage?: number | null, items_without_costs?: number | null, labour_variance_percentage?: number | null, material_variance_percentage?: number | null, organization_product_type_name: string, profit_variance_dollars?: number | null, profit_variance_percentage?: number | null, proposed_cost_additional: number, proposed_cost_equipment: number, proposed_cost_labour: number, proposed_cost_material: number, proposed_cost_transfer_truck: number, proposed_profit?: number | null, trucking_variance_percentage?: number | null } }, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportProductDetailsMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportProductDetailsMutation = { __typename?: 'Mutation', getReportProductDetails: { __typename?: 'getReportProductDetailsResponse', data: Array<{ __typename?: 'ProductDetails', costBasis?: string | null, itemsWithoutCosts?: number | null, materialCostType?: string | null, materialNeededSum?: number | null, measurementMaterial?: string | null, productId?: string | null, productName?: string | null, productType?: string | null, proposalsCount?: number | null, sumCostTotal?: number | null, sumOverallTotal?: number | null, sumProfit?: number | null }>, metadata: { __typename?: 'ProductDetailsMetadata', totals: { __typename?: 'ProductDetailsTotals', cost_total_sum: number, items_without_costs?: number | null, overall_total_sum: number, profit_sum: number } }, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportProposalDetailsMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  estimatorId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  productTypeId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status?: InputMaybe<Scalars['String']>;
  wonAt?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetReportProposalDetailsMutation = { __typename?: 'Mutation', getReportProposalDetails: { __typename?: 'getReportProposalDetailsResponse', data: Array<{ __typename?: 'ProposalDetailsItem', address_line_1?: string | null, city?: string | null, company_id?: string | null, company_name?: string | null, cost_additional?: number | null, cost_basis?: string | null, cost_direct?: number | null, cost_equipment?: number | null, cost_indirect?: number | null, cost_labour?: number | null, cost_material?: number | null, cost_overhead?: number | null, cost_total?: number | null, created_at?: string | null, created_by?: string | null, estimator_name?: string | null, external_id_with_prefix?: string | null, gross_margin?: number | null, gross_margin_percentage?: number | null, job_name?: string | null, job_size?: string | null, material_material_needed_override?: number | null, material_measurement_material?: string | null, material_name?: string | null, material_type?: string | null, net_margin?: number | null, net_margin_percentage?: number | null, operating_margin?: number | null, operating_margin_percentage?: number | null, overall_total?: number | null, profit?: number | null, profit_percentage_override?: number | null, proposal_notes?: string | null, sent_at?: string | null, signed_at?: string | null, signee_initials?: string | null, signee_name?: string | null, source?: string | null, stage_id?: string | null, stage_name?: string | null, state?: string | null, status?: string | null, user_id?: string | null, viewed_at?: string | null, won_at?: string | null, zip?: string | null }>, metadata: { __typename?: 'ProposalDetailsMetadata', totals: { __typename?: 'ProposalDetailsTotals', cost_additional: number, cost_direct: number, cost_equipment: number, cost_indirect: number, cost_labour: number, cost_material: number, cost_overhead: number, cost_total: number, gross_margin: number, items_without_costs?: number | null, net_margin: number, operating_margin: number, overall_total: number, profit: number } }, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportSalesByContactMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportSalesByContactMutation = { __typename?: 'Mutation', getReportSalesByContact: { __typename?: 'getReportSalesByContactResponse', data: Array<{ __typename?: 'SalesByContact', customerName?: string | null, jobSize?: string | null, product?: string | null, total?: string | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportSalesByProductSummaryMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportSalesByProductSummaryMutation = { __typename?: 'Mutation', getReportSalesByProductSummary: { __typename?: 'getReportSalesByProductSummaryResponse', data: Array<{ __typename?: 'SalesByProductSummaryItem', amount?: string | null, avgUnitPrice?: string | null, perOfSales?: string | null, product?: string | null, totalJobSize?: string | null, totalMaterialQuantity?: string | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportSalesByProposalSourceMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
}>;


export type GetReportSalesByProposalSourceMutation = { __typename?: 'Mutation', getReportSalesByProposalSource: { __typename?: 'getReportSalesByProposalSourceResponse', data: Array<{ __typename?: 'SalesByProposalSource', orgRevenuePercentage?: number | null, pTotal?: number | null, proposalsWonAmountTotal?: number | null, proposalsWonCount?: number | null, s1?: string | null, winRate?: number | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetReportTimeEntriesMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
}>;


export type GetReportTimeEntriesMutation = { __typename?: 'Mutation', getReportTimeEntries: { __typename?: 'getReportTimeEntriesResponse', data: Array<{ __typename?: 'TimeEntries', endTime?: string | null, forDate?: string | null, jobPhaseAddress?: string | null, jobPhaseExternalId?: string | null, proposalStageName?: string | null, startTime?: string | null, timeTrackedHours?: number | null, timeTrackedHuman?: string | null, userName?: string | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetYearOverYearRevenueReportExportMutationVariables = Exact<{ [key: string]: never; }>;


export type GetYearOverYearRevenueReportExportMutation = { __typename?: 'Mutation', getYearOverYearRevenueReportExport: string };

export type HasScheduledJobPhasesMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type HasScheduledJobPhasesMutation = { __typename?: 'Mutation', hasScheduledJobPhases: boolean };

export type HoldProposalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HoldProposalMutation = { __typename?: 'Mutation', holdProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser?: boolean | null };

export type LogActivityMutationVariables = Exact<{
  input: LogActivityInput;
}>;


export type LogActivityMutation = { __typename?: 'Mutation', logActivity: { __typename?: 'Activity', body?: string | null, createdAt?: any | null, id: string, occurredAt: any, opportunityId?: string | null, summary: string, type: ActivityType, updatedAt?: any | null, company?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, createdByUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, job?: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } | null> | null } | null, opportunity?: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null } };

export type LoginMutationVariables = Exact<{
  force?: InputMaybe<Scalars['Boolean']>;
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename: 'ActiveSessionConflict', message: string } | { __typename: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: boolean | null };

export type MergeCompanyMutationVariables = Exact<{
  sourceCompany: Scalars['ID'];
  targetCompany: Scalars['ID'];
}>;


export type MergeCompanyMutation = { __typename?: 'Mutation', mergeCompany: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } };

export type PreviewInvoiceMutationVariables = Exact<{
  data?: InputMaybe<Scalars['String']>;
  hideLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
}>;


export type PreviewInvoiceMutation = { __typename?: 'Mutation', previewInvoice?: string | null };

export type PreviewProposalMutationVariables = Exact<{
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  contentSettings?: InputMaybe<UpdateProposalContentSettingsHasManyInput>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
}>;


export type PreviewProposalMutation = { __typename?: 'Mutation', previewProposal?: string | null };

export type ReassignTaskMutationVariables = Exact<{
  input: ReassignTaskInput;
}>;


export type ReassignTaskMutation = { __typename?: 'Mutation', reassignTask?: { __typename?: 'Task', completedAt?: any | null, content: string, createdAt: any, dueAt?: any | null, id: string, notifiableExternalId?: string | null, notifiableId?: string | null, notifiableType?: string | null, status: string, triggerEvent?: string | null, triggerType?: string | null, updatedAt: any, assignedUser: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }, company?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null, contact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTrigger?: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, apiHeaders?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiSecret?: string | null, apiUrl?: string | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isApi?: boolean | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, taskContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, isTask?: boolean | null, lastName: string, taskContent?: string | null }>, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null };

export type RedoAiMappingRunAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RedoAiMappingRunAreaMutation = { __typename?: 'Mutation', redoAiMappingRunArea: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', bbox: Array<number>, category: string, color?: string | null, confidence?: number | null, id: string, isDeleted: boolean, source?: string | null, version: number }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', areaSqft?: number | null, category: string, color?: string | null, id: string, isDeleted: boolean, polygon: Array<number>, version: number }> } };

export type RefreshOrganizationEmailIdentityStatusMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshOrganizationEmailIdentityStatusMutation = { __typename?: 'Mutation', refreshOrganizationEmailIdentityStatus: { __typename?: 'OrganizationEmailIdentity', enabled: boolean, fromName?: string | null, id: string, invoiceFromAddress: string, invoiceLocalPart: string, notificationsFromAddress: string, notificationsLocalPart: string, organizationId: string, proposalFromAddress: string, proposalLocalPart: string, replyToCustomEmail?: string | null, replyToType: EmailIdentityReplyToType, sendingDomain: string, verificationStatus: SesVerificationStatus, verifiedAt?: any | null, dkimTokens?: Array<{ __typename?: 'DnsRecord', host: string, type: string, value: string }> | null, dmarcRecord?: { __typename?: 'DnsRecord', host: string, type: string, value: string } | null, spfRecord?: { __typename?: 'DnsRecord', host: string, type: string, value: string } | null } };

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: boolean | null };

export type RemoveTruckFromProposalProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveTruckFromProposalProductMutation = { __typename?: 'Mutation', removeTruckFromProposalProduct?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: boolean | null };

export type ResendUserInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendUserInviteMutation = { __typename?: 'Mutation', resendUserInvite?: boolean | null };

export type ResendVerificationEmailMutationVariables = Exact<{
  input: ResendVerificationEmailInput;
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type RestoreEmployeeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreEmployeeMutation = { __typename?: 'Mutation', restoreEmployee: { __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type RestoreOrganizationUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreOrganizationUserMutation = { __typename?: 'Mutation', restoreOrganizationUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type RetryProposalPackageSendRecipientsMutationVariables = Exact<{
  runId: Scalars['ID'];
}>;


export type RetryProposalPackageSendRecipientsMutation = { __typename?: 'Mutation', retryProposalPackageSendRecipients: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null } | null }> } };

export type RetryQuickbooksTimeExportRunFailedItemsMutationVariables = Exact<{
  runId: Scalars['ID'];
}>;


export type RetryQuickbooksTimeExportRunFailedItemsMutation = { __typename?: 'Mutation', retryQuickbooksTimeExportRunFailedItems: { __typename?: 'QuickbooksTimeExportRun', createdByUserId?: string | null, dateEnd: any, dateStart: any, failedItems: number, finishedAt?: any | null, id: string, itemsCount: number, lastErrorCode?: string | null, lastErrorMessage?: string | null, organizationId: string, organizationLinkedServiceId?: string | null, processedItems: number, skippedItems: number, startedAt?: any | null, status: QuickbooksTimeExportRunStatus, succeededItems: number, totalItems: number, createdByUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type SaveCustomItemMutationVariables = Exact<{
  discount?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  input: CustomInput;
  stageId: Scalars['ID'];
}>;


export type SaveCustomItemMutation = { __typename?: 'Mutation', saveCustomItem: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type SaveCustomProductMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  input: CustomInput;
  productTypeId: Scalars['ID'];
}>;


export type SaveCustomProductMutation = { __typename?: 'Mutation', saveCustomProduct: { __typename?: 'CustomProduct', id: string, revision: string, definition: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string, production?: { __typename?: 'ProductionHelper', enabled: boolean, materialRowId?: string | null, period: string, quantity?: string | null, rate: string, source: string, unit: string } | null, travel?: { __typename?: 'TravelHelper', enabled: boolean, roundTripHours: string, visits?: string | null } | null } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string, hauling?: { __typename?: 'HaulingHelper', allocationPercent: string, capacity: string, capacityUnit: string, fullLoads: boolean, haulQuantity?: string | null, haulUnit?: string | null, loadHours: string, materialRowId: string, maxTripsPerDay?: string | null, planningEnabled?: boolean | null, planningHours?: string | null, quantityMode?: string | null, roundTripHours: string, unloadHours: string } | null }> }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null } };

export type SaveOrganizationEmailIdentityMutationVariables = Exact<{
  input: SaveOrganizationEmailIdentityInput;
}>;


export type SaveOrganizationEmailIdentityMutation = { __typename?: 'Mutation', saveOrganizationEmailIdentity: { __typename?: 'OrganizationEmailIdentity', enabled: boolean, fromName?: string | null, id: string, invoiceFromAddress: string, invoiceLocalPart: string, notificationsFromAddress: string, notificationsLocalPart: string, organizationId: string, proposalFromAddress: string, proposalLocalPart: string, replyToCustomEmail?: string | null, replyToType: EmailIdentityReplyToType, sendingDomain: string, verificationStatus: SesVerificationStatus, verifiedAt?: any | null, dkimTokens?: Array<{ __typename?: 'DnsRecord', host: string, type: string, value: string }> | null, dmarcRecord?: { __typename?: 'DnsRecord', host: string, type: string, value: string } | null, spfRecord?: { __typename?: 'DnsRecord', host: string, type: string, value: string } | null } };

export type SaveProjectMapImageMutationVariables = Exact<{
  path: Scalars['String'];
  projectMapId: Scalars['ID'];
}>;


export type SaveProjectMapImageMutation = { __typename?: 'Mutation', saveProjectMapImage: { __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type SaveQuickbooksIncomeAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SaveQuickbooksIncomeAccountMutation = { __typename?: 'Mutation', saveQuickbooksIncomeAccount?: boolean | null };

export type SaveQuickbooksIntegrationMutationVariables = Exact<{
  input: QuickbooksIntegrationInput;
}>;


export type SaveQuickbooksIntegrationMutation = { __typename?: 'Mutation', saveQuickbooksIntegration: boolean };

export type SaveWorksheetItemMutationVariables = Exact<{
  discount?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  input: WorksheetInput;
  stageId: Scalars['ID'];
}>;


export type SaveWorksheetItemMutation = { __typename?: 'Mutation', saveWorksheetItem: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type SaveWorksheetProductMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  input: WorksheetInput;
  productTypeId: Scalars['ID'];
}>;


export type SaveWorksheetProductMutation = { __typename?: 'Mutation', saveWorksheetProduct: { __typename?: 'WorksheetProduct', id: string, definition: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null } };

export type ScheduleCustomEventBlockMutationVariables = Exact<{
  input: ScheduleCustomEventBlockInput;
}>;


export type ScheduleCustomEventBlockMutation = { __typename?: 'Mutation', scheduleCustomEventBlock: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string, customEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }> } };

export type ScheduleJobMutationVariables = Exact<{
  input: ScheduleJobInput;
}>;


export type ScheduleJobMutation = { __typename?: 'Mutation', scheduleJob: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type ScheduleJobPhaseMutationVariables = Exact<{
  blocks: Array<InputMaybe<AddJobPhaseScheduleBlock>> | InputMaybe<AddJobPhaseScheduleBlock>;
  crewId?: InputMaybe<Scalars['ID']>;
  jobPhaseId: Scalars['ID'];
  travelTimeEstimate?: InputMaybe<Scalars['Float']>;
  userIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  usersColor?: InputMaybe<Scalars['String']>;
}>;


export type ScheduleJobPhaseMutation = { __typename?: 'Mutation', scheduleJobPhase: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type ScheduleJobPhaseBlockMutationVariables = Exact<{
  input: ScheduleJobPhaseBlockInput;
}>;


export type ScheduleJobPhaseBlockMutation = { __typename?: 'Mutation', scheduleJobPhaseBlock: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type SegmentAiMappingRunAreaMutationVariables = Exact<{
  id: Scalars['ID'];
  minSegAreaSqft?: InputMaybe<Scalars['Float']>;
  minSegConf?: InputMaybe<Scalars['Float']>;
}>;


export type SegmentAiMappingRunAreaMutation = { __typename?: 'Mutation', segmentAiMappingRunArea: { __typename?: 'AiMappingDetectResponse', taskId: string, area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any } } };

export type SendInvoiceMutationVariables = Exact<{
  data?: InputMaybe<Scalars['String']>;
  hideLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
}>;


export type SendInvoiceMutation = { __typename?: 'Mutation', sendInvoice: boolean };

export type SendOrganizationEmailIdentityTestEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendOrganizationEmailIdentityTestEmailMutation = { __typename?: 'Mutation', sendOrganizationEmailIdentityTestEmail: boolean };

export type SendOrganizationEmailTemplatePreviewMutationVariables = Exact<{
  html: Scalars['String'];
}>;


export type SendOrganizationEmailTemplatePreviewMutation = { __typename?: 'Mutation', sendOrganizationEmailTemplatePreview: boolean };

export type SendProposalMutationVariables = Exact<{
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  contentSettings?: InputMaybe<UpdateProposalContentSettingsHasManyInput>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  proposalNotes?: InputMaybe<Scalars['String']>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendProposalMutation = { __typename?: 'Mutation', sendProposal: boolean };

export type SendProposalPackageMutationVariables = Exact<{
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  contentSettings?: InputMaybe<UpdateProposalContentSettingsHasManyInput>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<ProposalLayout>;
  proposalId: Scalars['ID'];
  proposalNotes?: InputMaybe<Scalars['String']>;
  recipients: Array<ProposalPackageRecipientInput> | ProposalPackageRecipientInput;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendProposalPackageMutation = { __typename?: 'Mutation', sendProposalPackage: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null } | null }> } };

export type SendProposalToSpecificRecipientsMutationVariables = Exact<{
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  emails: Array<Scalars['String']> | Scalars['String'];
  forceSend?: InputMaybe<Scalars['Boolean']>;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendProposalToSpecificRecipientsMutation = { __typename?: 'Mutation', sendProposalToSpecificRecipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }> };

export type SetJobDepositCollectedMutationVariables = Exact<{
  collected?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
}>;


export type SetJobDepositCollectedMutation = { __typename?: 'Mutation', setJobDepositCollected: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type SetProposalEstimatingMethodMutationVariables = Exact<{
  id: Scalars['ID'];
  method: Scalars['String'];
}>;


export type SetProposalEstimatingMethodMutation = { __typename?: 'Mutation', setProposalEstimatingMethod: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type SetProposalToDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SetProposalToDraftMutation = { __typename?: 'Mutation', setProposalToDraft: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type SetProposalToWonMutationVariables = Exact<{
  forceSend?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
}>;


export type SetProposalToWonMutation = { __typename?: 'Mutation', setProposalToWon: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type SignProposalMutationVariables = Exact<{
  email: Scalars['String'];
  removeProducts?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  signature: Scalars['String'];
  signeeInitials: Scalars['String'];
  signeeName: Scalars['String'];
  signeeTitle: Scalars['String'];
  uuid: Scalars['String'];
}>;


export type SignProposalMutation = { __typename?: 'Mutation', signProposal: { __typename?: 'PublicProposal', acceptanceOverride?: string | null, costTaxes: string, discount: string, externalId: string, externalIdWithPrefix: string, id: string, layout: ProposalLayout, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, profitAfterDiscount: string, proposalPDF?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signeeInitials?: string | null, signeeName?: string | null, signeeTitle?: string | null, status: ProposalStatus, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, company: { __typename?: 'PublicCompany', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, name: string, phone?: string | null, website?: string | null }, contact: { __typename?: 'PublicContact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null }, content: Array<{ __typename?: 'ProposalContent', content: string, contentOverride: string, type: string } | null>, organization: { __typename?: 'PublicOrganization', email?: string | null, id: string, logo?: string | null, name: string, phone?: string | null, address?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null }, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'PublicProposalStage', addressOverride?: string | null, discount: string, id: string, name?: string | null, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, profitAfterDiscount: string, address?: { __typename?: 'PublicProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, state?: string | null, zip?: string | null } | null, content: Array<{ __typename?: 'ProposalContent', content: string, contentOverride: string, type: string } | null>, proposalProductGroups: Array<{ __typename?: 'PublicProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'PublicProposalProduct', discount: string, id: string, isOptional: boolean, jobDuration: number, jobSize: number, mapImage?: string | null, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, profitAfterDiscount: string, proposalProductGroupId?: string | null, statementOfWork?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, worksheet?: { __typename?: 'PublicWorksheet', name: string, quantity: string, scope?: string | null, unit: string } | null }> }>, proposalProducts?: Array<{ __typename?: 'PublicProposalProduct', discount: string, id: string, isOptional: boolean, jobDuration: number, jobSize: number, mapImage?: string | null, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, profitAfterDiscount: string, proposalProductGroupId?: string | null, statementOfWork?: string | null }> | null }>, user: { __typename?: 'PublicUser', email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null } } };

export type StartQuickbooksTimeExportMutationVariables = Exact<{
  endDate: Scalars['Date'];
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type StartQuickbooksTimeExportMutation = { __typename?: 'Mutation', startQuickbooksTimeExport: { __typename?: 'QuickbooksTimeExportRun', createdByUserId?: string | null, dateEnd: any, dateStart: any, failedItems: number, finishedAt?: any | null, id: string, itemsCount: number, lastErrorCode?: string | null, lastErrorMessage?: string | null, organizationId: string, organizationLinkedServiceId?: string | null, processedItems: number, skippedItems: number, startedAt?: any | null, status: QuickbooksTimeExportRunStatus, succeededItems: number, totalItems: number, createdByUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type SyncAiMappingCostsToMapMutationVariables = Exact<{
  input: SyncAiMappingCostsToMapInput;
}>;


export type SyncAiMappingCostsToMapMutation = { __typename?: 'Mutation', syncAiMappingCostsToMap: { __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type SyncProjectMapMeasurementsMutationVariables = Exact<{
  input: SyncProjectMapMeasurementsInput;
}>;


export type SyncProjectMapMeasurementsMutation = { __typename?: 'Mutation', syncProjectMapMeasurements: { __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type SyncProposalStageMeasurementsMutationVariables = Exact<{
  input: SyncProposalStageMeasurementsInput;
}>;


export type SyncProposalStageMeasurementsMutation = { __typename?: 'Mutation', syncProposalStageMeasurements: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type SyncQuickbooksBatchMutationVariables = Exact<{
  input: SyncQuickbooksBatchInput;
}>;


export type SyncQuickbooksBatchMutation = { __typename?: 'Mutation', syncQuickbooksBatch: { __typename?: 'QuickbooksSyncBatch', billedTotalAmount: number, billingMode: QuickbooksSyncBatchBillingMode, createEstimate: boolean, createInvoice: boolean, createJob: boolean, createdAt: any, id: string, isDeposit: boolean, partialAmountCents?: number | null, partialPercentage?: number | null, quickbooksDesktopError?: string | null, quickbooksDesktopQueuedAt?: any | null, quickbooksDesktopStatus: QuickbooksSyncBatchStatus, quickbooksOnlineDocumentId?: string | null, quickbooksOnlineDocumentType?: string | null, quickbooksOnlineError?: string | null, quickbooksOnlineStatus: QuickbooksSyncBatchStatus, selectedTotalAmount: number, syncedDesktopAt?: any | null, syncedOnlineAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, jobs: Array<{ __typename?: 'QuickbooksSyncBatchJob', billedAmount: number, id: string, selectedAmount: number, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } }>, lines: Array<{ __typename?: 'QuickbooksSyncBatchLine', billedAmount: number, groupName?: string | null, id: string, itemDescription?: string | null, itemName: string, originalAmount: number, sortOrder: number, sourceType: QuickbooksSyncBatchLineSourceType, job?: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null } | null, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null }> } };

export type TestNotificationTriggerApiMutationVariables = Exact<{
  triggerId: Scalars['ID'];
}>;


export type TestNotificationTriggerApiMutation = { __typename?: 'Mutation', testNotificationTriggerApi: { __typename?: 'WebhookTestResult', errorMessage?: string | null, httpStatusCode?: number | null, responseTimeMs: number, success: boolean } };

export type ToggleOrganizationEmailIdentityMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
}>;


export type ToggleOrganizationEmailIdentityMutation = { __typename?: 'Mutation', toggleOrganizationEmailIdentity: { __typename?: 'OrganizationEmailIdentity', enabled: boolean, fromName?: string | null, id: string, invoiceFromAddress: string, invoiceLocalPart: string, notificationsFromAddress: string, notificationsLocalPart: string, organizationId: string, proposalFromAddress: string, proposalLocalPart: string, replyToCustomEmail?: string | null, replyToType: EmailIdentityReplyToType, sendingDomain: string, verificationStatus: SesVerificationStatus, verifiedAt?: any | null, dkimTokens?: Array<{ __typename?: 'DnsRecord', host: string, type: string, value: string }> | null, dmarcRecord?: { __typename?: 'DnsRecord', host: string, type: string, value: string } | null, spfRecord?: { __typename?: 'DnsRecord', host: string, type: string, value: string } | null } };

export type ToggleProposalProductGroupOptionalityMutationVariables = Exact<{
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
}>;


export type ToggleProposalProductGroupOptionalityMutation = { __typename?: 'Mutation', toggleProposalProductGroupOptionality: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string, production?: { __typename?: 'ProductionHelper', enabled: boolean, materialRowId?: string | null, period: string, quantity?: string | null, rate: string, source: string, unit: string } | null, travel?: { __typename?: 'TravelHelper', enabled: boolean, roundTripHours: string, visits?: string | null } | null } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string, hauling?: { __typename?: 'HaulingHelper', allocationPercent: string, capacity: string, capacityUnit: string, fullLoads: boolean, haulQuantity?: string | null, haulUnit?: string | null, loadHours: string, materialRowId: string, maxTripsPerDay?: string | null, planningEnabled?: boolean | null, planningHours?: string | null, quantityMode?: string | null, roundTripHours: string, unloadHours: string } | null }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }> } | null }> } };

export type ToggleProposalProductOptionalityMutationVariables = Exact<{
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
}>;


export type ToggleProposalProductOptionalityMutation = { __typename?: 'Mutation', toggleProposalProductOptionality: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string, production?: { __typename?: 'ProductionHelper', enabled: boolean, materialRowId?: string | null, period: string, quantity?: string | null, rate: string, source: string, unit: string } | null, travel?: { __typename?: 'TravelHelper', enabled: boolean, roundTripHours: string, visits?: string | null } | null } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string, hauling?: { __typename?: 'HaulingHelper', allocationPercent: string, capacity: string, capacityUnit: string, fullLoads: boolean, haulQuantity?: string | null, haulUnit?: string | null, loadHours: string, materialRowId: string, maxTripsPerDay?: string | null, planningEnabled?: boolean | null, planningHours?: string | null, quantityMode?: string | null, roundTripHours: string, unloadHours: string } | null }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } };

export type UndoAiMappingRunAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UndoAiMappingRunAreaMutation = { __typename?: 'Mutation', undoAiMappingRunArea: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', bbox: Array<number>, category: string, color?: string | null, confidence?: number | null, id: string, isDeleted: boolean, source?: string | null, version: number }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', areaSqft?: number | null, category: string, color?: string | null, id: string, isDeleted: boolean, polygon: Array<number>, version: number }> } };

export type UnlinkServiceMutationVariables = Exact<{
  service: OrganizationLinkedServiceName;
}>;


export type UnlinkServiceMutation = { __typename?: 'Mutation', unlinkService?: boolean | null };

export type UnscheduleCustomEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnscheduleCustomEventMutation = { __typename?: 'Mutation', unscheduleCustomEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string, customEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }> } };

export type UnscheduleJobPhaseMutationVariables = Exact<{
  jobPhaseId: Scalars['ID'];
}>;


export type UnscheduleJobPhaseMutation = { __typename?: 'Mutation', unscheduleJobPhase: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type UpdateAdditionalCostMutationVariables = Exact<{
  input: UpdateAdditionalCostInput;
}>;


export type UpdateAdditionalCostMutation = { __typename?: 'Mutation', updateAdditionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } };

export type UpdateAiMappingDetectionMutationVariables = Exact<{
  input: UpdateAiMappingDetectionInput;
}>;


export type UpdateAiMappingDetectionMutation = { __typename?: 'Mutation', updateAiMappingDetection: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', bbox: Array<number>, category: string, color?: string | null, confidence?: number | null, id: string, isDeleted: boolean, source?: string | null, version: number }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', areaSqft?: number | null, category: string, color?: string | null, id: string, isDeleted: boolean, polygon: Array<number>, version: number }> } };

export type UpdateAiMappingSegmentationMutationVariables = Exact<{
  input: UpdateAiMappingSegmentationInput;
}>;


export type UpdateAiMappingSegmentationMutation = { __typename?: 'Mutation', updateAiMappingSegmentation: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', bbox: Array<number>, category: string, color?: string | null, confidence?: number | null, id: string, isDeleted: boolean, source?: string | null, version: number }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', areaSqft?: number | null, category: string, color?: string | null, id: string, isDeleted: boolean, polygon: Array<number>, version: number }> } };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null };

export type UpdateCompanyNotesMutationVariables = Exact<{
  input: UpdateCompanyNotesInput;
}>;


export type UpdateCompanyNotesMutation = { __typename?: 'Mutation', updateCompanyNotes: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } };

export type UpdateCompanyProjectFileFolderIdMutationVariables = Exact<{
  id: Scalars['ID'];
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateCompanyProjectFileFolderIdMutation = { __typename?: 'Mutation', updateCompanyProjectFileFolderId: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } };

export type UpdateCrewMutationVariables = Exact<{
  input: UpdateCrewInput;
}>;


export type UpdateCrewMutation = { __typename?: 'Mutation', updateCrew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } };

export type UpdateCustomEventMutationVariables = Exact<{
  input?: InputMaybe<UpdateCustomEventInput>;
}>;


export type UpdateCustomEventMutation = { __typename?: 'Mutation', updateCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string, customEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }> } | null };

export type UpdateCustomLibraryProductMutationVariables = Exact<{
  expectedRevision: Scalars['String'];
  id: Scalars['ID'];
  input: CustomInput;
}>;


export type UpdateCustomLibraryProductMutation = { __typename?: 'Mutation', updateCustomLibraryProduct: { __typename?: 'CustomProduct', id: string, revision: string, definition: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string, production?: { __typename?: 'ProductionHelper', enabled: boolean, materialRowId?: string | null, period: string, quantity?: string | null, rate: string, source: string, unit: string } | null, travel?: { __typename?: 'TravelHelper', enabled: boolean, roundTripHours: string, visits?: string | null } | null } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string, hauling?: { __typename?: 'HaulingHelper', allocationPercent: string, capacity: string, capacityUnit: string, fullLoads: boolean, haulQuantity?: string | null, haulUnit?: string | null, loadHours: string, materialRowId: string, maxTripsPerDay?: string | null, planningEnabled?: boolean | null, planningHours?: string | null, quantityMode?: string | null, roundTripHours: string, unloadHours: string } | null }> }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null } };

export type UpdateDailyFormInspectionMutationVariables = Exact<{
  input: UpdateDailyFormInspectionInput;
}>;


export type UpdateDailyFormInspectionMutation = { __typename?: 'Mutation', updateDailyFormInspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type UpdateDailyFormInspectionQuestionMutationVariables = Exact<{
  input: UpdateDailyFormInspectionQuestionInput;
}>;


export type UpdateDailyFormInspectionQuestionMutation = { __typename?: 'Mutation', updateDailyFormInspectionQuestion: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type UpdateDailyFormVehicleMutationVariables = Exact<{
  input: UpdateDailyFormVehicleInput;
}>;


export type UpdateDailyFormVehicleMutation = { __typename?: 'Mutation', updateDailyFormVehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } };

export type UpdateDailyFormVehiclePartMutationVariables = Exact<{
  input: UpdateDailyFormVehiclePartInput;
}>;


export type UpdateDailyFormVehiclePartMutation = { __typename?: 'Mutation', updateDailyFormVehiclePart: { __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> } } };

export type UpdateDailyFormVehicleServicePlanMutationVariables = Exact<{
  input: UpdateDailyFormVehicleServicePlanInput;
}>;


export type UpdateDailyFormVehicleServicePlanMutation = { __typename?: 'Mutation', updateDailyFormVehicleServicePlan: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }> } };

export type UpdateDailyFormVehicleTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type UpdateDailyFormVehicleTypeMutation = { __typename?: 'Mutation', updateDailyFormVehicleType: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type UpdateDailyFormWorkOrderMutationVariables = Exact<{
  input: UpdateDailyFormWorkOrderInput;
}>;


export type UpdateDailyFormWorkOrderMutation = { __typename?: 'Mutation', updateDailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } } };

export type UpdateDailyFormWorkOrderStatusMutationVariables = Exact<{
  input: UpdateDailyFormWorkOrderStatusInput;
}>;


export type UpdateDailyFormWorkOrderStatusMutation = { __typename?: 'Mutation', updateDailyFormWorkOrderStatus: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } } };

export type UpdateEmployeeMutationVariables = Exact<{
  input: UpdateEmployeeInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type UpdateEquipmentPieceMutationVariables = Exact<{
  input: UpdateEquipmentPieceInput;
}>;


export type UpdateEquipmentPieceMutation = { __typename?: 'Mutation', updateEquipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } };

export type UpdateJobBillingStatusMutationVariables = Exact<{
  billingStatus: JobBillingStatus;
  id: Scalars['ID'];
}>;


export type UpdateJobBillingStatusMutation = { __typename?: 'Mutation', updateJobBillingStatus: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type UpdateJobChecklistItemsMutationVariables = Exact<{
  input: UpdateJobChecklistItemsInput;
}>;


export type UpdateJobChecklistItemsMutation = { __typename?: 'Mutation', updateJobChecklistItems: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type UpdateJobExternalIdMutationVariables = Exact<{
  externalId: Scalars['String'];
  id: Scalars['ID'];
}>;


export type UpdateJobExternalIdMutation = { __typename?: 'Mutation', updateJobExternalId: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type UpdateJobNotesMutationVariables = Exact<{
  id: Scalars['ID'];
  notes: Scalars['String'];
}>;


export type UpdateJobNotesMutation = { __typename?: 'Mutation', updateJobNotes?: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null };

export type UpdateJobPhaseChecklistItemsMutationVariables = Exact<{
  input: UpdateJobPhaseChecklistItemsInput;
}>;


export type UpdateJobPhaseChecklistItemsMutation = { __typename?: 'Mutation', updateJobPhaseChecklistItems: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } };

export type UpdateJobPhaseCostingMutationVariables = Exact<{
  input: UpdateJobPhaseCostingInput;
}>;


export type UpdateJobPhaseCostingMutation = { __typename?: 'Mutation', updateJobPhaseCosting: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } };

export type UpdateJobPhaseNotesMutationVariables = Exact<{
  input: UpdateJobPhaseNotesInput;
}>;


export type UpdateJobPhaseNotesMutation = { __typename?: 'Mutation', updateJobPhaseNotes: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } };

export type UpdateJobPhaseStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: JobPhaseStatus;
}>;


export type UpdateJobPhaseStatusMutation = { __typename?: 'Mutation', updateJobPhaseStatus: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } };

export type UpdateJobProjectFileFolderIdMutationVariables = Exact<{
  id: Scalars['ID'];
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateJobProjectFileFolderIdMutation = { __typename?: 'Mutation', updateJobProjectFileFolderId: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type UpdateJobProjectManagerMutationVariables = Exact<{
  id: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type UpdateJobProjectManagerMutation = { __typename?: 'Mutation', updateJobProjectManager: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type UpdateJobStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: JobStatus;
}>;


export type UpdateJobStatusMutation = { __typename?: 'Mutation', updateJobStatus: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type UpdateNotificationTriggerMutationVariables = Exact<{
  input: UpdateNotificationTriggerInput;
}>;


export type UpdateNotificationTriggerMutation = { __typename?: 'Mutation', updateNotificationTrigger?: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, apiHeaders?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiSecret?: string | null, apiUrl?: string | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isApi?: boolean | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, taskContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, isTask?: boolean | null, lastName: string, taskContent?: string | null }>, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } | null };

export type UpdateOpportunityMutationVariables = Exact<{
  input: UpdateOpportunityInput;
}>;


export type UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type UpdateOpportunityStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  statusId: Scalars['ID'];
}>;


export type UpdateOpportunityStatusMutation = { __typename?: 'Mutation', updateOpportunityStatus: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type UpdateOpportunityStatusesOrderingMutationVariables = Exact<{
  statuses: Array<OpportunityStatusOrderingInput> | OpportunityStatusOrderingInput;
}>;


export type UpdateOpportunityStatusesOrderingMutation = { __typename?: 'Mutation', updateOpportunityStatusesOrdering: Array<{ __typename?: 'OrganizationOpportunityStatus', id: string, name: string, ordering: number }> };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type UpdateOrganizationAddressMutationVariables = Exact<{
  input: UpdateOrganizationAddressInput;
}>;


export type UpdateOrganizationAddressMutation = { __typename?: 'Mutation', updateOrganizationAddress?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null };

export type UpdateOrganizationAddressPrimaryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateOrganizationAddressPrimaryMutation = { __typename?: 'Mutation', updateOrganizationAddressPrimary?: boolean | null };

export type UpdateOrganizationConversionFactorOverrideMutationVariables = Exact<{
  input: UpdateOrganizationConversionFactorOverrideInput;
}>;


export type UpdateOrganizationConversionFactorOverrideMutation = { __typename?: 'Mutation', updateOrganizationConversionFactorOverride: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type UpdateOrganizationEmailTemplateMutationVariables = Exact<{
  html?: InputMaybe<Scalars['String']>;
  type: OrganizationEmailTemplateType;
}>;


export type UpdateOrganizationEmailTemplateMutation = { __typename?: 'Mutation', updateOrganizationEmailTemplate?: boolean | null };

export type UpdateOrganizationInvoiceEmailTextMutationVariables = Exact<{
  id: Scalars['ID'];
  text: Scalars['String'];
}>;


export type UpdateOrganizationInvoiceEmailTextMutation = { __typename?: 'Mutation', updateOrganizationInvoiceEmailText: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type UpdateOrganizationInvoicingPaymentTermsNetMutationVariables = Exact<{
  id: Scalars['ID'];
  invoicingPaymentTermsNet: Scalars['Int'];
}>;


export type UpdateOrganizationInvoicingPaymentTermsNetMutation = { __typename?: 'Mutation', updateOrganizationInvoicingPaymentTermsNet: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type UpdateOrganizationProductTypeMutationVariables = Exact<{
  input: UpdateOrganizationProductTypeInput;
}>;


export type UpdateOrganizationProductTypeMutation = { __typename?: 'Mutation', updateOrganizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null };

export type UpdateOrganizationProposalChecklistItemMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type UpdateOrganizationProposalChecklistItemMutation = { __typename?: 'Mutation', updateOrganizationProposalChecklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null } };

export type UpdateOrganizationProposalContentMutationVariables = Exact<{
  content: Scalars['String'];
  type: Scalars['String'];
}>;


export type UpdateOrganizationProposalContentMutation = { __typename?: 'Mutation', updateOrganizationProposalContent: { __typename?: 'OrganizationProposalContent', content: string, id: string, type: string } };

export type UpdateOrganizationProposalDefaultsMutationVariables = Exact<{
  input: UpdateOrganizationProposalDefaultsInput;
}>;


export type UpdateOrganizationProposalDefaultsMutation = { __typename?: 'Mutation', updateOrganizationProposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null } };

export type UpdateOrganizationProposalLayoutContentSettingsMutationVariables = Exact<{
  items: Array<UpdateProposalLayoutContentSettingItemInput> | UpdateProposalLayoutContentSettingItemInput;
}>;


export type UpdateOrganizationProposalLayoutContentSettingsMutation = { __typename?: 'Mutation', updateOrganizationProposalLayoutContentSettings: Array<{ __typename?: 'OrganizationProposalLayoutContentSetting', contentType: string, id: string, organizationId: string, showOnBranded: boolean, showOnFull: boolean, showOnSimple: boolean, showOnTabular: boolean }> };

export type UpdateOrganizationProposalSentEmailTextMutationVariables = Exact<{
  id: Scalars['ID'];
  text: Scalars['String'];
}>;


export type UpdateOrganizationProposalSentEmailTextMutation = { __typename?: 'Mutation', updateOrganizationProposalSentEmailText: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type UpdateOrganizationSalesTaxesMutationVariables = Exact<{
  input: UpdateOrganizationSalesTaxesInput;
}>;


export type UpdateOrganizationSalesTaxesMutation = { __typename?: 'Mutation', updateOrganizationSalesTaxes: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type UpdateOrganizationSettingsMutationVariables = Exact<{
  settings: Array<UpdateOrganizationSettingsInput> | UpdateOrganizationSettingsInput;
}>;


export type UpdateOrganizationSettingsMutation = { __typename?: 'Mutation', updateOrganizationSettings: boolean };

export type UpdateOrganizationUserMutationVariables = Exact<{
  input: UpdateOrganizationUserInput;
}>;


export type UpdateOrganizationUserMutation = { __typename?: 'Mutation', updateOrganizationUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type UpdatePlantMutationVariables = Exact<{
  input: UpdatePlantInput;
}>;


export type UpdatePlantMutation = { __typename?: 'Mutation', updatePlant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } };

export type UpdateProductGroupMutationVariables = Exact<{
  input: UpdateProductGroupInput;
}>;


export type UpdateProductGroupMutation = { __typename?: 'Mutation', updateProductGroup: { __typename?: 'ProductGroup', id: string, name: string, organizationId: string, products: Array<{ __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null }> } };

export type UpdateProjectMapMutationVariables = Exact<{
  input: UpdateProjectMapInput;
}>;


export type UpdateProjectMapMutation = { __typename?: 'Mutation', updateProjectMap: { __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type UpdateProposalMutationVariables = Exact<{
  closeConfidence?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  id: Scalars['ID'];
  projectedCloseDate?: InputMaybe<Scalars['Date']>;
  source?: InputMaybe<ProposalSource>;
}>;


export type UpdateProposalMutation = { __typename?: 'Mutation', updateProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalAddressMutationVariables = Exact<{
  input: UpdateProposalAddress;
}>;


export type UpdateProposalAddressMutation = { __typename?: 'Mutation', updateProposalAddress?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null };

export type UpdateProposalContentSettingsMutationVariables = Exact<{
  contentSettings: UpdateProposalContentSettingsHasManyInput;
  id: Scalars['ID'];
}>;


export type UpdateProposalContentSettingsMutation = { __typename?: 'Mutation', updateProposalContentSettings: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalDiscountMutationVariables = Exact<{
  input: UpdateProposalDiscountInput;
}>;


export type UpdateProposalDiscountMutation = { __typename?: 'Mutation', updateProposalDiscount: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalInfoMutationVariables = Exact<{
  input?: InputMaybe<UpdateProposalInfoInput>;
}>;


export type UpdateProposalInfoMutation = { __typename?: 'Mutation', updateProposalInfo: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalPlantProductMutationVariables = Exact<{
  applicationRateOverride?: InputMaybe<Scalars['Float']>;
  materialNeededOverride?: InputMaybe<Scalars['Float']>;
  plantProductId: Scalars['ID'];
  proposalPlantProductId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type UpdateProposalPlantProductMutation = { __typename?: 'Mutation', updateProposalPlantProduct: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalProductMutationVariables = Exact<{
  input: UpdateProposalProductInput;
}>;


export type UpdateProposalProductMutation = { __typename?: 'Mutation', updateProposalProduct: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalProductDiscountMutationVariables = Exact<{
  input: UpdateProposalProductDiscountInput;
}>;


export type UpdateProposalProductDiscountMutation = { __typename?: 'Mutation', updateProposalProductDiscount: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalProductOverridesMutationVariables = Exact<{
  externalProductName?: InputMaybe<Scalars['String']>;
  jobSize?: InputMaybe<Scalars['Int']>;
  overallTotalOverride?: InputMaybe<Scalars['Int']>;
  profitOverride?: InputMaybe<Scalars['Int']>;
  profitPercentageOverride?: InputMaybe<Scalars['Int']>;
  proposalProductId: Scalars['ID'];
  unitPriceOverride?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateProposalProductOverridesMutation = { __typename?: 'Mutation', updateProposalProductOverrides: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalProductProjectFilesMutationVariables = Exact<{
  projectFileIds: Array<Scalars['ID']> | Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type UpdateProposalProductProjectFilesMutation = { __typename?: 'Mutation', updateProposalProductProjectFiles: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string, production?: { __typename?: 'ProductionHelper', enabled: boolean, materialRowId?: string | null, period: string, quantity?: string | null, rate: string, source: string, unit: string } | null, travel?: { __typename?: 'TravelHelper', enabled: boolean, roundTripHours: string, visits?: string | null } | null } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string, hauling?: { __typename?: 'HaulingHelper', allocationPercent: string, capacity: string, capacityUnit: string, fullLoads: boolean, haulQuantity?: string | null, haulUnit?: string | null, loadHours: string, materialRowId: string, maxTripsPerDay?: string | null, planningEnabled?: boolean | null, planningHours?: string | null, quantityMode?: string | null, roundTripHours: string, unloadHours: string } | null }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } };

export type UpdateProposalSalesTaxesMutationVariables = Exact<{
  input?: InputMaybe<UpdateProposalSalesTaxesInput>;
}>;


export type UpdateProposalSalesTaxesMutation = { __typename?: 'Mutation', updateProposalSalesTaxes: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalStageMutationVariables = Exact<{
  addressOverride?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mapData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProposalStageMutation = { __typename?: 'Mutation', updateProposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type UpdateProposalStageAddressAndClearProductsMutationVariables = Exact<{
  input: UpdateProposalStageAddressAndClearProductsInput;
}>;


export type UpdateProposalStageAddressAndClearProductsMutation = { __typename?: 'Mutation', updateProposalStageAddressAndClearProducts: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateProposalStagesOrderingMutationVariables = Exact<{
  input: UpdateProposalStagesOrdering;
}>;


export type UpdateProposalStagesOrderingMutation = { __typename?: 'Mutation', updateProposalStagesOrdering: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type UpdateRolesWithPermissionsMutationVariables = Exact<{
  input?: InputMaybe<UpdateRolesWithPermissionsInput>;
}>;


export type UpdateRolesWithPermissionsMutation = { __typename?: 'Mutation', updateRolesWithPermissions?: { __typename?: 'RolesWithPermissions', admin?: Array<UserPermissions | null> | null, employee?: Array<UserPermissions | null> | null, foreman?: Array<UserPermissions | null> | null, officeManager?: Array<UserPermissions | null> | null, salesperson?: Array<UserPermissions | null> | null, subcontractor?: Array<UserPermissions | null> | null } | null };

export type UpdateStageProductsOrderingMutationVariables = Exact<{
  input: UpdateProposalProductsOrderingInput;
}>;


export type UpdateStageProductsOrderingMutation = { __typename?: 'Mutation', updateStageProductsOrdering: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type UpdateTimeBucketMutationVariables = Exact<{
  input: UpdateTimeBucketInput;
}>;


export type UpdateTimeBucketMutation = { __typename?: 'Mutation', updateTimeBucket: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } };

export type UpdateTimeEntryMutationVariables = Exact<{
  input: UpdateTimeEntryInput;
}>;


export type UpdateTimeEntryMutation = { __typename?: 'Mutation', updateTimeEntry: { __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }> } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type UpdateTransferTruckMutationVariables = Exact<{
  input: UpdateTransferTruckInput;
}>;


export type UpdateTransferTruckMutation = { __typename?: 'Mutation', updateTransferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null };

export type UpdateWorkOrderItemsMutationVariables = Exact<{
  input: UpdateWorkOrderItemsInput;
}>;


export type UpdateWorkOrderItemsMutation = { __typename?: 'Mutation', updateWorkOrderItems?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null };

export type UpdateWorksheetSettingsMutationVariables = Exact<{
  markup: Scalars['String'];
  method: Scalars['String'];
}>;


export type UpdateWorksheetSettingsMutation = { __typename?: 'Mutation', updateWorksheetSettings: { __typename?: 'WorksheetSettings', canManageProducts: boolean, canManageSettings: boolean, enabled: boolean, markup: string, method: string, factors: Array<{ __typename?: 'WorksheetFactor', label: string, value: string }> } };

export type ValidateRegistrationTokenMutationVariables = Exact<{
  input: ValidateRegistrationTokenInput;
}>;


export type ValidateRegistrationTokenMutation = { __typename?: 'Mutation', validateRegistrationToken?: boolean | null };

export type GetOrganizationApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationApiKeysQuery = { __typename?: 'Query', GetOrganizationApiKeys: Array<{ __typename?: 'OrganizationApiKey', api_key: string, description: string, id: string, is_active: boolean, organizationId: string }> };

export type CustomProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomProductsQuery = { __typename?: 'Query', customProducts: Array<{ __typename?: 'CustomProduct', id: string, revision: string, definition: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string, production?: { __typename?: 'ProductionHelper', enabled: boolean, materialRowId?: string | null, period: string, quantity?: string | null, rate: string, source: string, unit: string } | null, travel?: { __typename?: 'TravelHelper', enabled: boolean, roundTripHours: string, visits?: string | null } | null } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string, hauling?: { __typename?: 'HaulingHelper', allocationPercent: string, capacity: string, capacityUnit: string, fullLoads: boolean, haulQuantity?: string | null, haulUnit?: string | null, loadHours: string, materialRowId: string, maxTripsPerDay?: string | null, planningEnabled?: boolean | null, planningHours?: string | null, quantityMode?: string | null, roundTripHours: string, unloadHours: string } | null }> }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null }> };

export type CustomProposalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomProposalQuery = { __typename?: 'Query', customProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type CustomSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomSettingsQuery = { __typename?: 'Query', customSettings: { __typename?: 'CustomSettings', canManageProducts: boolean, canManageSettings: boolean, enabled: boolean, markup: string, workingHoursPerDay: string, factors: Array<{ __typename?: 'CustomFactor', label: string, value: string }> } };

export type GetAdditionalCostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdditionalCostQuery = { __typename?: 'Query', getAdditionalCost?: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } | null };

export type GetAdditionalCostsQueryVariables = Exact<{
  feeType?: InputMaybe<AdditionalCostFeeType>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
}>;


export type GetAdditionalCostsQuery = { __typename?: 'Query', getAdditionalCosts?: { __typename?: 'AdditionalCostPaginator', data: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetAiMappingRunQueryVariables = Exact<{
  projectMapId: Scalars['ID'];
}>;


export type GetAiMappingRunQuery = { __typename?: 'Query', getAiMappingRun?: { __typename?: 'AiMappingRun', createdAt: any, description?: string | null, id: string, name: string, updatedAt: any, areas: Array<{ __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }>, projectMap: { __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number }> | null } | null }> } } | null };

export type GetAiMappingRunAreaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAiMappingRunAreaQuery = { __typename?: 'Query', getAiMappingRunArea: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any } };

export type GetAiMappingRunAreaResultsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAiMappingRunAreaResultsQuery = { __typename?: 'Query', getAiMappingRunAreaResults: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', coordinates?: string | null, createdAt: any, currentVersion: number, id: string, imageHeight?: number | null, imageWidth?: number | null, inputType: AiMappingInputType, minSegAreaSqft?: number | null, minSegConf?: number | null, name?: string | null, segmentationModel?: string | null, status: string, taskId?: string | null, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', bbox: Array<number>, category: string, color?: string | null, confidence?: number | null, id: string, isDeleted: boolean, source?: string | null, version: number }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', areaSqft?: number | null, category: string, color?: string | null, id: string, isDeleted: boolean, polygon: Array<number>, version: number }> } };

export type GetAiMappingTaskStatusQueryVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type GetAiMappingTaskStatusQuery = { __typename?: 'Query', getAiMappingTaskStatus: { __typename?: 'AiMappingTaskStatus', error?: string | null, pdfUrl?: string | null, progress?: number | null, progressMessage?: string | null, status: string, counts?: Array<{ __typename?: 'AiMappingCategoryCount', category: string, count: number }> | null } };

export type GetAllCrewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCrewsQuery = { __typename?: 'Query', getAllCrews: Array<{ __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> };

export type GetAllDailyFormVehiclesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDailyFormVehiclesQuery = { __typename?: 'Query', getAllDailyFormVehicles: Array<{ __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> }> };

export type GetArchivedCompaniesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetArchivedCompaniesQuery = { __typename?: 'Query', getArchivedCompanies?: { __typename?: 'CompanyPaginator', data: Array<{ __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetCheckoutUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheckoutUrlQuery = { __typename?: 'Query', getCheckoutUrl: string };

export type GetCompaniesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
}>;


export type GetCompaniesQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompaniesResponse', data: Array<{ __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null };

export type GetCompanyContactsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyContactsQuery = { __typename?: 'Query', getCompanyContacts?: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> | null };

export type GetCompanyProposalActivityQueryVariables = Exact<{
  companyId: Scalars['ID'];
  contactId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanyProposalActivityQuery = { __typename?: 'Query', getCompanyProposalActivity: { __typename?: 'GetCompanyProposalActivityResponse', data: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null } | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetContactActivitiesQueryVariables = Exact<{
  contactId: Scalars['ID'];
  first: Scalars['Int'];
  opportunityId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetContactActivitiesQuery = { __typename?: 'Query', getContactActivities?: { __typename?: 'ActivityPaginator', data: Array<{ __typename?: 'Activity', body?: string | null, createdAt?: any | null, id: string, occurredAt: any, opportunityId?: string | null, summary: string, type: ActivityType, updatedAt?: any | null, company?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, createdByUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, job?: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, opportunity?: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetCrewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCrewQuery = { __typename?: 'Query', getCrew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type GetCrewsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
}>;


export type GetCrewsQuery = { __typename?: 'Query', getCrews?: { __typename?: 'CrewPaginator', data: Array<{ __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetCurrentMonthStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentMonthStatsQuery = { __typename?: 'Query', getCurrentMonthStats: { __typename?: 'DashboardDataByMonth', closedBids: number, closedRate: number, closedRevenue: number, sentBids: number } };

export type GetCustomEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCustomEventQuery = { __typename?: 'Query', getCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string, customEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> } | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }> } | null };

export type GetCustomEventBlocksQueryVariables = Exact<{
  crewId?: InputMaybe<Scalars['ID']>;
  customEventIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetCustomEventBlocksQuery = { __typename?: 'Query', getCustomEventBlocks: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }> } | null } | null> | null } | null }> };

export type GetDailyFormInspectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDailyFormInspectionQuery = { __typename?: 'Query', getDailyFormInspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type GetDailyFormInspectionQuestionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDailyFormInspectionQuestionQuery = { __typename?: 'Query', getDailyFormInspectionQuestion: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type GetDailyFormInspectionQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDailyFormInspectionQuestionsQuery = { __typename?: 'Query', getDailyFormInspectionQuestions: Array<{ __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } }> };

export type GetDailyFormInspectionsQueryVariables = Exact<{
  dailyFormVehicleId?: InputMaybe<Scalars['ID']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<QueryDailyFormInspectionsSortKey>;
}>;


export type GetDailyFormInspectionsQuery = { __typename?: 'Query', getDailyFormInspections: { __typename?: 'GetDailyFormInspectionsResponse', data: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetDailyFormVehicleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDailyFormVehicleQuery = { __typename?: 'Query', getDailyFormVehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } };

export type GetDailyFormVehiclePartQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDailyFormVehiclePartQuery = { __typename?: 'Query', getDailyFormVehiclePart: { __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> } } };

export type GetDailyFormVehiclePartsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDailyFormVehiclePartsQuery = { __typename?: 'Query', getDailyFormVehicleParts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> } }> };

export type GetDailyFormVehicleServicePlanQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDailyFormVehicleServicePlanQuery = { __typename?: 'Query', getDailyFormVehicleServicePlan: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }> } };

export type GetDailyFormVehicleServicePlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDailyFormVehicleServicePlansQuery = { __typename?: 'Query', getDailyFormVehicleServicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }> }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null }> }> };

export type GetDailyFormVehicleTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDailyFormVehicleTypeQuery = { __typename?: 'Query', getDailyFormVehicleType: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type GetDailyFormVehicleTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDailyFormVehicleTypesQuery = { __typename?: 'Query', getDailyFormVehicleTypes: Array<{ __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } }> };

export type GetDailyFormVehiclesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetDailyFormVehiclesQuery = { __typename?: 'Query', getDailyFormVehicles?: { __typename?: 'DailyFormVehiclePaginator', data: Array<{ __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', answer?: string | null, id: string, isTrue: boolean, inspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetDailyFormWorkOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDailyFormWorkOrderQuery = { __typename?: 'Query', getDailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> } } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } } };

export type GetDailyFormWorkOrdersQueryVariables = Exact<{
  assignedTo?: InputMaybe<Scalars['ID']>;
  completedDate?: InputMaybe<Scalars['Date']>;
  first: Scalars['Int'];
  multipleAssignedTo?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multiplePriorities?: InputMaybe<Array<DailyFormIssuePriority> | DailyFormIssuePriority>;
  multipleStatuses?: InputMaybe<Array<DailyFormIssueStatus> | DailyFormIssueStatus>;
  neededCompletionDate?: InputMaybe<Scalars['Date']>;
  page?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<DailyFormIssuePriority>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<QueryDailyFormWorkOrdersSortKey>;
  status?: InputMaybe<DailyFormIssueStatus>;
  vehicleId?: InputMaybe<Scalars['ID']>;
}>;


export type GetDailyFormWorkOrdersQuery = { __typename?: 'Query', getDailyFormWorkOrders: { __typename?: 'GetDailyFormWorkOrdersResponse', data: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string, dailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, inspections: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null }>, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, notes?: string | null, partNumber?: string | null, quantity?: number | null, unitPrice?: number | null, vendorName?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null }>, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus }> }, workOrders: Array<{ __typename?: 'DailyFormWorkOrder', comments?: string | null, completedAt?: any | null, createdAt: any, currentMeterReading?: number | null, estimatedTaskTime?: number | null, id: string, issueDescription: string, issueName: string, issueType: string, neededCompletionDate?: any | null, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, assignedTo?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }>, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', autoCreateTask: boolean, id: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, intervalValue: number, isActive: boolean, issueType?: string | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, leadValue: number, name: string, nextDueDate?: any | null, nextDueMeterReading?: number | null, notes?: string | null, priority?: DailyFormIssuePriority | null } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }> } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }, vehicle: { __typename?: 'DailyFormVehicle', currentMeterReading?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, defaultServiceIntervalValue?: number | null, id: string, inServiceDate?: any | null, isActive: boolean, licensePlate?: string | null, make?: string | null, meterType?: DailyFormVehicleMeterType | null, model?: string | null, name: string, notes?: string | null, registrationExpirationDate?: any | null, registrationState?: string | null, vin?: string | null, year?: number | null } }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetDashboardExtraKpisYtdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardExtraKpisYtdQuery = { __typename?: 'Query', getDashboardExtraKpisYtd: { __typename?: 'DashboardExtraKpisYtd', averageProposalAmount: string, jobsWonCount: number, organizationSalesGoal: string, pace: number, percentToGoal: number, totalPipeline: string, weightedForecast30Days: string, weightedForecast60Days: string, weightedPipeline: string } };

export type GetDashboardMapDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardMapDataQuery = { __typename?: 'Query', getDashboardMapData: Array<{ __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null> };

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', getEmployee?: { __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type GetEmployeesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
}>;


export type GetEmployeesQuery = { __typename?: 'Query', getEmployees?: { __typename?: 'EmployeePaginator', data: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetEnabledContentTypesForLayoutQueryVariables = Exact<{
  layout: ProposalLayout;
}>;


export type GetEnabledContentTypesForLayoutQuery = { __typename?: 'Query', getEnabledContentTypesForLayout: Array<{ __typename?: 'OrganizationProposalLayoutContentSetting', contentType: string, id: string, organizationId: string, showOnBranded: boolean, showOnFull: boolean, showOnSimple: boolean, showOnTabular: boolean }> };

export type GetEquipmentPieceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEquipmentPieceQuery = { __typename?: 'Query', getEquipmentPiece?: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } | null };

export type GetEquipmentPiecesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
}>;


export type GetEquipmentPiecesQuery = { __typename?: 'Query', getEquipmentPieces?: { __typename?: 'EquipmentPiecePaginator', data: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', getInvoice: { __typename?: 'Invoice', data?: string | null, hideLineItemPricing: boolean, id: string, isOverdue: boolean, link: string, paidAt?: any | null, sentAt?: any | null, status: InvoiceStatus, uuid: string, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } | null> | null } } };

export type GetInvoicesQueryVariables = Exact<{
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  isOverdue?: InputMaybe<Scalars['Boolean']>;
  jobStatuses?: InputMaybe<Array<JobStatus> | JobStatus>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetInvoicesSortKey>;
  status?: InputMaybe<InvoiceStatus>;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', getInvoices: { __typename?: 'GetInvoicesResponse', data: Array<{ __typename?: 'Invoice', data?: string | null, hideLineItemPricing: boolean, id: string, isOverdue: boolean, link: string, paidAt?: any | null, sentAt?: any | null, status: InvoiceStatus, uuid: string, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetJobQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetJobQuery = { __typename?: 'Query', getJob: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } };

export type GetJobBillingStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobBillingStatusesQuery = { __typename?: 'Query', getJobBillingStatuses: { __typename?: 'GetJobBillingStatusesResponse', statuses?: Array<JobBillingStatus> | null } };

export type GetJobCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobCitiesQuery = { __typename?: 'Query', getJobCities: Array<string> };

export type GetJobCostingLapsedReportQueryVariables = Exact<{
  first: Scalars['Int'];
  jobsInPast?: InputMaybe<Scalars['Boolean']>;
  jobsWithoutCosts?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobCostingLapsedReportSortKey>;
  statuses?: InputMaybe<Array<JobStatus> | JobStatus>;
}>;


export type GetJobCostingLapsedReportQuery = { __typename?: 'Query', getJobCostingLapsedReport: { __typename?: 'GetJobCostingLapsedReportResponse', data: Array<{ __typename?: 'JobCostingLapsedReportJob', actualOverallTotal: string, allPhasesMissingCost: boolean, clientName: string, endsAt?: any | null, externalId: string, id: string, jobName: string, phaseMissingCost: boolean, proposedOverallTotal: string, status: JobStatus, varianceAmount: string, variancePercent: number, phases: Array<{ __typename?: 'JobCostingLapsedReportPhase', actualOverallTotal: string, endsAt?: any | null, externalId: string, id: string, jobId: string, missingCost: boolean, productType: string, proposedOverallTotal: string, status: JobPhaseStatus, varianceAmount: string, variancePercent: number }> }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetJobInvoiceStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobInvoiceStatsQuery = { __typename?: 'Query', getJobInvoiceStats: Array<{ __typename?: 'JobInvoiceStats', invoiceStatus: string, last30DaysAmount: number, yearToDateAmount: number }> };

export type GetJobPhaseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetJobPhaseQuery = { __typename?: 'Query', getJobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } };

export type GetJobPhaseCostItemQueryVariables = Exact<{
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
}>;


export type GetJobPhaseCostItemQuery = { __typename?: 'Query', getJobPhaseCostItem?: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }, plant: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string }, plantProduct: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null };

export type GetJobPhaseCostsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetJobPhaseCostsQuery = { __typename?: 'Query', getJobPhaseCosts?: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }, plant: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string }, plantProduct: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null };

export type GetJobPhasesQueryVariables = Exact<{
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
  companyId?: InputMaybe<Scalars['ID']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  first: Scalars['Int'];
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetJobPhasesQuery = { __typename?: 'Query', getJobPhases: { __typename?: 'GetJobPhasesResponse', data: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }, plant: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string }, plantProduct: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string, helpers?: { __typename?: 'CustomHelpers', hoursPerDay: string } | null, pricing?: { __typename?: 'CustomPricingControl', discount: string, mode: string, value: string, version: number } | null, pricingBaseline?: { __typename?: 'CustomPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'CustomRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, quantitySource?: string | null, rate: string, rowId?: string | null, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null }> | null } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetJobReadinessDashboardQueryVariables = Exact<{
  crewId?: InputMaybe<Scalars['ID']>;
  endDate: Scalars['Date'];
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
}>;


export type GetJobReadinessDashboardQuery = { __typename?: 'Query', getJobReadinessDashboard: { __typename?: 'JobReadinessDashboardResponse', dailyTotals: Array<{ __typename?: 'JobReadinessDailyTotal', scheduledDate: any, totalQuantity: number, totalTrucks: number, materialRows: Array<{ __typename?: 'JobReadinessMaterialLine', hasPlant: boolean, materialName: string, quantity: number, sourceName: string, trucks: number, unitAbbr: string }> }>, exceptions: { __typename?: 'JobReadinessExceptions', jobsMissingMaterialQuantity: number, jobsMissingPlantAssignment: number, jobsNotConfirmedWithClient: number, materialLinesWithoutTrucks: number }, jobs: Array<{ __typename?: 'JobReadinessJobRow', checklistOutstanding: number, checklistTotal: number, confirmedWithClient: boolean, jobExternalId?: string | null, jobId?: string | null, jobName?: string | null, jobPhaseId: string, key: string, profitScheduled: number, revenueScheduled: number, scheduledDate: any, materialLines: Array<{ __typename?: 'JobReadinessMaterialLine', hasPlant: boolean, materialName: string, quantity: number, sourceName: string, trucks: number, unitAbbr: string }> }>, summary: { __typename?: 'JobReadinessSummary', jobsConfirmedWithClient: number, jobsScheduled: number, jobsWithOutstandingChecklistItems: number, profitScheduled: number, revenueScheduled: number, totalQuantity: number, totalTrucks: number } } };

export type GetJobScheduleByAmountStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobScheduleByAmountStatsQuery = { __typename?: 'Query', getJobScheduleByAmountStats: Array<{ __typename?: 'DateWithTotals', date: string, overallTotal: string }> };

export type GetJobScheduleStatsQueryVariables = Exact<{
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
}>;


export type GetJobScheduleStatsQuery = { __typename?: 'Query', getJobScheduleStats: { __typename?: 'JobScheduleStats', amountScheduled: number, profitScheduled: number } };

export type GetJobSchedulesQueryVariables = Exact<{
  crewId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
}>;


export type GetJobSchedulesQuery = { __typename?: 'Query', getJobSchedules: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } | null> | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> };

export type GetJobsQueryVariables = Exact<{
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
  cities?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  statuses?: InputMaybe<Array<JobStatus> | JobStatus>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetJobsQuery = { __typename?: 'Query', getJobs: { __typename?: 'GetJobsResponse', data: Array<{ __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetJobsSimpleQueryVariables = Exact<{
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  jobName?: InputMaybe<Scalars['String']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  statuses?: InputMaybe<Array<JobStatus> | JobStatus>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetJobsSimpleQuery = { __typename?: 'Query', getJobsSimple: { __typename?: 'GetJobsResponse', data: Array<{ __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetLastYearStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastYearStatsQuery = { __typename?: 'Query', getLastYearStats: { __typename?: 'YearlyDashboardData', closedBids?: Array<{ __typename?: 'MonthlySummary', month: number, total: number, year: number } | null> | null, closedRate?: Array<{ __typename?: 'MonthlySummary', month: number, total: number, year: number } | null> | null, closedRevenue?: Array<{ __typename?: 'MonthlySummary', month: number, total: number, year: number } | null> | null, sentBids?: Array<{ __typename?: 'MonthlySummary', month: number, total: number, year: number } | null> | null } };

export type GetManageSubscriptionUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManageSubscriptionUrlQuery = { __typename?: 'Query', getManageSubscriptionUrl: string };

export type GetMaterialNeededByDayStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaterialNeededByDayStatsQuery = { __typename?: 'Query', getMaterialNeededByDayStats?: Array<{ __typename?: 'DateWithMaterialAmount', JobPhaseAmountScheduledInDay: number, date: string, jobPhaseMaterialNeededInDay: number, material: string }> | null };

export type GetMyTasksQueryVariables = Exact<{
  all?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetMyTasksQuery = { __typename?: 'Query', getMyTasks?: { __typename?: 'TaskPaginator', data: Array<{ __typename?: 'Task', completedAt?: any | null, content: string, createdAt: any, dueAt?: any | null, id: string, notifiableExternalId?: string | null, notifiableId?: string | null, notifiableType?: string | null, status: string, triggerEvent?: string | null, triggerType?: string | null, updatedAt: any, assignedUser: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }, company?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null, contact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTrigger?: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, apiHeaders?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiSecret?: string | null, apiUrl?: string | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isApi?: boolean | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, taskContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, isTask?: boolean | null, lastName: string, taskContent?: string | null }>, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetNotificationTriggerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetNotificationTriggerQuery = { __typename?: 'Query', getNotificationTrigger: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, apiHeaders?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiSecret?: string | null, apiUrl?: string | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isApi?: boolean | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, taskContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, isTask?: boolean | null, lastName: string, taskContent?: string | null }>, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type GetNotificationTriggersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationTriggersQuery = { __typename?: 'Query', getNotificationTriggers?: Array<{ __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, apiHeaders?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiSecret?: string | null, apiUrl?: string | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isApi?: boolean | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, taskContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, isTask?: boolean | null, lastName: string, taskContent?: string | null }>, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } }> | null };

export type GetOpportunitiesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contactName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['Date']>;
  first: Scalars['Int'];
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetOpportunitiesSortKey>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetOpportunitiesQuery = { __typename?: 'Query', getOpportunities: { __typename?: 'GetOpportunitiesResponse', data: Array<{ __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetOpportunityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type GetOpportunityStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpportunityStatusesQuery = { __typename?: 'Query', getOpportunityStatuses: Array<{ __typename?: 'OrganizationOpportunityStatus', id: string, name: string, ordering: number }> };

export type GetOrganizationAddressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationAddressQuery = { __typename?: 'Query', getOrganizationAddress?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null };

export type GetOrganizationAddressesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetOrganizationAddressesQuery = { __typename?: 'Query', getOrganizationAddresses?: { __typename?: 'OrganizationAddressPaginator', data: Array<{ __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetOrganizationDataUploadsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetOrganizationDataUploadsQuery = { __typename?: 'Query', getOrganizationDataUploads?: { __typename?: 'OrganizationDataUploadPaginator', data: Array<{ __typename?: 'OrganizationDataUpload', createdAt: any, error?: string | null, id: string, path: string, startedAt?: any | null, status: OrganizationDataUploadStatus, type: OrganizationDataUploadType, updatedAt: any, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetOrganizationEmailIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationEmailIdentityQuery = { __typename?: 'Query', getOrganizationEmailIdentity?: { __typename?: 'OrganizationEmailIdentity', enabled: boolean, fromName?: string | null, id: string, invoiceFromAddress: string, invoiceLocalPart: string, notificationsFromAddress: string, notificationsLocalPart: string, organizationId: string, proposalFromAddress: string, proposalLocalPart: string, replyToCustomEmail?: string | null, replyToType: EmailIdentityReplyToType, sendingDomain: string, verificationStatus: SesVerificationStatus, verifiedAt?: any | null, dkimTokens?: Array<{ __typename?: 'DnsRecord', host: string, type: string, value: string }> | null, dmarcRecord?: { __typename?: 'DnsRecord', host: string, type: string, value: string } | null, spfRecord?: { __typename?: 'DnsRecord', host: string, type: string, value: string } | null } | null };

export type GetOrganizationEmailTemplateQueryVariables = Exact<{
  type: OrganizationEmailTemplateType;
}>;


export type GetOrganizationEmailTemplateQuery = { __typename?: 'Query', getOrganizationEmailTemplate?: { __typename?: 'OrganizationEmailTemplate', html: string, id: string, type: OrganizationEmailTemplateType, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null } | null };

export type GetOrganizationEmailTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationEmailTemplatesQuery = { __typename?: 'Query', getOrganizationEmailTemplates?: Array<{ __typename?: 'OrganizationEmailTemplate', html: string, id: string, type: OrganizationEmailTemplateType, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null }> | null };

export type GetOrganizationProductTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationProductTypeQuery = { __typename?: 'Query', getOrganizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } };

export type GetOrganizationProductTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationProductTypesQuery = { __typename?: 'Query', getOrganizationProductTypes: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> };

export type GetOrganizationProposalContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationProposalContentQuery = { __typename?: 'Query', getOrganizationProposalContent?: Array<{ __typename?: 'OrganizationProposalContent', content: string, id: string, type: string }> | null };

export type GetOrganizationProposalLayoutContentSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationProposalLayoutContentSettingsQuery = { __typename?: 'Query', getOrganizationProposalLayoutContentSettings: Array<{ __typename?: 'OrganizationProposalLayoutContentSetting', contentType: string, id: string, organizationId: string, showOnBranded: boolean, showOnFull: boolean, showOnSimple: boolean, showOnTabular: boolean }> };

export type GetOrganizationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationSettingsQuery = { __typename?: 'Query', getOrganizationSettings: Array<{ __typename?: 'OrganizationSetting', key: string, value: string }> };

export type GetOrganizationUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationUserQuery = { __typename?: 'Query', getOrganizationUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type GetOrganizationUsersQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  roles?: InputMaybe<Array<InputMaybe<UserRole>> | InputMaybe<UserRole>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
}>;


export type GetOrganizationUsersQuery = { __typename?: 'Query', getOrganizationUsers?: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetOutstandingWorkReportQueryVariables = Exact<{
  endDate: Scalars['DateTime'];
  mode?: InputMaybe<OutstandingWorkReportMode>;
  startDate: Scalars['DateTime'];
}>;


export type GetOutstandingWorkReportQuery = { __typename?: 'Query', getOutstandingWorkReport: { __typename?: 'OutstandingWorkReportResponse', countJobsOutstanding: number, countJobsWon: number, mode: OutstandingWorkReportMode, totalOutstandingRevenue: string, totalWonRevenue: string, jobs: Array<{ __typename?: 'OutstandingWorkReportJob', customerName: string, externalId: string, id: string, jobName: string, jobRevenue: string }> } };

export type GetPersonPerformanceYtdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonPerformanceYtdQuery = { __typename?: 'Query', getPersonPerformanceYtd: Array<{ __typename?: 'PersonPerformanceYtdRow', averageProposedNetMargin: number, forecastedSalesThisYear: string, name: string, percentToGoal: number, personId: string, proposalsSent: number, proposalsWon: number, proposalsWonAmount: string, salesGoal: string, winRate: number }> };

export type GetPlantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPlantQuery = { __typename?: 'Query', getPlant: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } };

export type GetPlantProductTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlantProductTypesQuery = { __typename?: 'Query', getPlantProductTypes?: Array<{ __typename?: 'ModelsPlantProductType', id: string, name: string }> | null };

export type GetPlantTransferTrucksQueryVariables = Exact<{
  plantId: Scalars['ID'];
}>;


export type GetPlantTransferTrucksQuery = { __typename?: 'Query', getPlantTransferTrucks: Array<{ __typename?: 'PlantTransferTruck', id: string, rateHourly?: number | null, rateTon?: number | null, tonnage?: number | null, transferTruck: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } }> };

export type GetPlantsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPlantsQuery = { __typename?: 'Query', getPlants?: { __typename?: 'PlantPaginator', data: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetPreviousMonthStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreviousMonthStatsQuery = { __typename?: 'Query', getPreviousMonthStats: { __typename?: 'DashboardDataByMonth', closedBids: number, closedRate: number, closedRevenue: number, sentBids: number } };

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null };

export type GetProductGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProductGroupQuery = { __typename?: 'Query', getProductGroup?: { __typename?: 'ProductGroup', id: string, name: string, organizationId: string, products: Array<{ __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null }> } | null };

export type GetProductGroupsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetProductGroupsQuery = { __typename?: 'Query', getProductGroups?: { __typename?: 'ProductGroupPaginator', data: Array<{ __typename?: 'ProductGroup', id: string, name: string, organizationId: string, products: Array<{ __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetProductStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductStatsQuery = { __typename?: 'Query', getProductStats: { __typename?: 'ProductStats', materialUsed?: Array<{ __typename?: 'ProductMaterialUsed', jobSizeComplete?: string | null, productMaterialUsed: string, productType: string, proposalJobSize: string, proposalMaterialNeeded?: string | null }> | null, productTypeUsedPercentages?: Array<{ __typename?: 'ProductTypeUsed', equipmentUsedPercentage?: number | null, labourUsedPercentage?: number | null, materialUsedPercentage?: number | null, productType: string }> | null, products: Array<{ __typename?: 'ProductSales', actualProfitPercentage: number, name: string, proposedProfitPercentage: number, sumOverallTotal: number } | null> } };

export type GetProductsQueryVariables = Exact<{
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QueryGetProductsOrderByOrderByClause> | QueryGetProductsOrderByOrderByClause>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProductType>;
}>;


export type GetProductsQuery = { __typename?: 'Query', getProducts?: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetProjectFileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProjectFileQuery = { __typename?: 'Query', getProjectFile: { __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null } };

export type GetProjectFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectFilesQuery = { __typename?: 'Query', getProjectFiles: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> };

export type GetProjectMapQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProjectMapQuery = { __typename?: 'Query', getProjectMap: { __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string, pivot?: { __typename?: 'ProductPlantProductPivot', applicationRate?: number | null } | null }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number, crew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null }> } };

export type GetProjectMapsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetProjectMapsSortKey>;
}>;


export type GetProjectMapsQuery = { __typename?: 'Query', getProjectMaps: { __typename?: 'GetProjectMapsResponse', data: Array<{ __typename?: 'ProjectMap', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, createdAt: any, description?: string | null, id: string, latitude?: number | null, longitude?: number | null, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name: string, updatedAt: any, createdBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, materialsNoPlant?: Array<{ __typename?: 'ProductMaterialNoPlant', id: string, name: string, percentage: number, productId: string, rate: number }> | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProducts?: Array<{ __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string }> | null, plants?: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string }> | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null }> | null, productCrews?: Array<{ __typename?: 'ProductCrew', id: string, quantity: number }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number }> | null } | null }> }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetProposalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProposalQuery = { __typename?: 'Query', getProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type GetProposalProductMapDataQueryVariables = Exact<{
  proposalProductId: Scalars['ID'];
  token: Scalars['String'];
}>;


export type GetProposalProductMapDataQuery = { __typename?: 'Query', getProposalProductMapData?: string | null };

export type GetProposalUserMetricsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProposalUserMetricsQuery = { __typename?: 'Query', getProposalUserMetrics: { __typename?: 'ProposalUserMetrics', avgNetMargin: number, closeRate: number, salesGoal: string, sentCount: number, totalProposed: string, totalWon: string, userId: string, wonCount: number } };

export type GetProposalsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetProposalsSortKey>;
  statuses?: InputMaybe<Array<ProposalStatus> | ProposalStatus>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProposalsQuery = { __typename?: 'Query', getProposals: { __typename?: 'GetProposalsResponse', data: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null, product?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null } | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetPublicInvoiceQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
}>;


export type GetPublicInvoiceQuery = { __typename?: 'Query', getPublicInvoice: { __typename: 'PublicInvoice', data: string, hideLineItemPricing: boolean, pageTextParsed: string, uuid: string, company: { __typename?: 'PublicInvoiceCompany', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, logo?: string | null, name: string, phone?: string | null }, job: { __typename?: 'PublicInvoiceJob', externalId?: string | null, id: string, address?: { __typename?: 'PublicInvoiceAddress', city: string, country: string, line1: string, line2?: string | null, state: string, zip: string } | null, proposalStage: { __typename?: 'PublicInvoiceProposalStage', id: string, name: string } }, organization: { __typename?: 'PublicInvoiceOrganization', email: string, logo?: string | null, name: string, phone?: string | null, address?: { __typename?: 'PublicInvoiceAddress', city: string, country: string, line1: string, line2?: string | null, state: string, zip: string } | null } } | { __typename: 'PublicInvoiceOrganization', email: string, logo?: string | null, name: string, phone?: string | null, address?: { __typename?: 'PublicInvoiceAddress', city: string, country: string, line1: string, line2?: string | null, state: string, zip: string } | null } };

export type GetPublicProposalQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
}>;


export type GetPublicProposalQuery = { __typename?: 'Query', getPublicProposal: { __typename: 'PublicProposal', acceptanceOverride?: string | null, costTaxes: string, discount: string, externalId: string, externalIdWithPrefix: string, id: string, layout: ProposalLayout, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, profitAfterDiscount: string, proposalPDF?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signeeInitials?: string | null, signeeName?: string | null, signeeTitle?: string | null, status: ProposalStatus, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, company: { __typename?: 'PublicCompany', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, name: string, phone?: string | null, website?: string | null }, contact: { __typename?: 'PublicContact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null }, content: Array<{ __typename?: 'ProposalContent', content: string, contentOverride: string, type: string } | null>, organization: { __typename?: 'PublicOrganization', email?: string | null, id: string, logo?: string | null, name: string, phone?: string | null, address?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null } }, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'PublicProposalStage', addressOverride?: string | null, discount: string, id: string, name?: string | null, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, profitAfterDiscount: string, address?: { __typename?: 'PublicProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, state?: string | null, zip?: string | null } | null, content: Array<{ __typename?: 'ProposalContent', content: string, contentOverride: string, type: string } | null>, proposalProductGroups: Array<{ __typename?: 'PublicProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'PublicProposalProduct', discount: string, id: string, isOptional: boolean, jobDuration: number, jobSize: number, mapImage?: string | null, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, profitAfterDiscount: string, proposalProductGroupId?: string | null, statementOfWork?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, worksheet?: { __typename?: 'PublicWorksheet', name: string, quantity: string, scope?: string | null, unit: string } | null }> }>, proposalProducts?: Array<{ __typename?: 'PublicProposalProduct', discount: string, id: string, isOptional: boolean, jobDuration: number, jobSize: number, mapImage?: string | null, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, profitAfterDiscount: string, proposalProductGroupId?: string | null, statementOfWork?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, worksheet?: { __typename?: 'PublicWorksheet', name: string, quantity: string, scope?: string | null, unit: string } | null }> | null }>, user: { __typename?: 'PublicUser', email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null } } | { __typename: 'PublicProposalOrganization', estimatorEmail: string, id: string, logo?: string | null } };

export type GetPublicProposalCompanyOrgQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type GetPublicProposalCompanyOrgQuery = { __typename?: 'Query', getPublicProposalCompanyOrg?: { __typename?: 'PublicCompanyOrg', company: { __typename?: 'PublicCompany', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, name: string, phone?: string | null, website?: string | null }, organization: { __typename?: 'PublicOrganization', email?: string | null, id: string, logo?: string | null, name: string, phone?: string | null, address?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null } } } | null };

export type GetQuickbooksIncomeAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickbooksIncomeAccountsQuery = { __typename?: 'Query', getQuickbooksIncomeAccounts?: Array<{ __typename?: 'QuickbooksIncomeAccount', id: string, name: string }> | null };

export type GetQuickbooksTaxCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickbooksTaxCodesQuery = { __typename?: 'Query', getQuickbooksTaxCodes?: Array<{ __typename?: 'QuickbooksTaxCode', description?: string | null, id: string, name: string }> | null };

export type GetQuickbooksTaxRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickbooksTaxRatesQuery = { __typename?: 'Query', getQuickbooksTaxRates?: Array<{ __typename?: 'QuickbooksTaxRate', description?: string | null, id: string, name: string, rateValue?: number | null }> | null };

export type GetQuickbooksTimeExportRunQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetQuickbooksTimeExportRunQuery = { __typename?: 'Query', getQuickbooksTimeExportRun?: { __typename?: 'QuickbooksTimeExportRun', createdByUserId?: string | null, dateEnd: any, dateStart: any, failedItems: number, finishedAt?: any | null, id: string, itemsCount: number, lastErrorCode?: string | null, lastErrorMessage?: string | null, organizationId: string, organizationLinkedServiceId?: string | null, processedItems: number, skippedItems: number, startedAt?: any | null, status: QuickbooksTimeExportRunStatus, succeededItems: number, totalItems: number, createdByUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type GetQuickbooksTimeExportRunItemsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  runId: Scalars['ID'];
  status?: InputMaybe<QuickbooksTimeExportItemStatus>;
}>;


export type GetQuickbooksTimeExportRunItemsQuery = { __typename?: 'Query', getQuickbooksTimeExportRunItems: { __typename?: 'QuickbooksTimeExportRunItemsResponse', data: Array<{ __typename?: 'QuickbooksTimeExportItem', attemptCount: number, errorCode?: string | null, errorMessage?: string | null, errorPayload?: string | null, exportedAt?: any | null, id: string, lastAttemptAt?: any | null, organizationId: string, qboCustomerId?: string | null, qboEmployeeId?: string | null, qboJobId?: string | null, qboTimeActivityId?: string | null, recommendedAction?: string | null, retryable: boolean, runId: string, status: QuickbooksTimeExportItemStatus, timeEntryId: string, timeEntry?: { __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetQuickbooksTimeExportRunsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<QuickbooksTimeExportRunStatus>;
}>;


export type GetQuickbooksTimeExportRunsQuery = { __typename?: 'Query', getQuickbooksTimeExportRuns: { __typename?: 'QuickbooksTimeExportRunsResponse', data: Array<{ __typename?: 'QuickbooksTimeExportRun', createdByUserId?: string | null, dateEnd: any, dateStart: any, failedItems: number, finishedAt?: any | null, id: string, itemsCount: number, lastErrorCode?: string | null, lastErrorMessage?: string | null, organizationId: string, organizationLinkedServiceId?: string | null, processedItems: number, skippedItems: number, startedAt?: any | null, status: QuickbooksTimeExportRunStatus, succeededItems: number, totalItems: number, createdByUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetRolesWithPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesWithPermissionsQuery = { __typename?: 'Query', getRolesWithPermissions?: { __typename?: 'RolesWithPermissions', admin?: Array<UserPermissions | null> | null, employee?: Array<UserPermissions | null> | null, foreman?: Array<UserPermissions | null> | null, officeManager?: Array<UserPermissions | null> | null, salesperson?: Array<UserPermissions | null> | null, subcontractor?: Array<UserPermissions | null> | null } | null };

export type GetTimeBucketQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTimeBucketQuery = { __typename?: 'Query', getTimeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null };

export type GetTimeBucketsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeBucketsQuery = { __typename?: 'Query', getTimeBuckets: Array<{ __typename?: 'TimeBucket', id: string, name: string, organizationId: string }> };

export type GetTimeEntriesQueryVariables = Exact<{
  first: Scalars['Int'];
  forDate?: InputMaybe<Scalars['Date']>;
  forDateEnd?: InputMaybe<Scalars['Date']>;
  forDateStart?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetTimeEntriesSortKey>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetTimeEntriesQuery = { __typename?: 'Query', getTimeEntries: { __typename?: 'GetTimeEntriesResponse', data: Array<{ __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', costTotal: string, id: string, jobPhaseCostItemId: string, name: string, quantity: number, rate: string }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', costTotal: string, id: string, plantId: string, plantProductId: string, quantity: number, rate: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, plantId: string, rate: number, type: string } | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', quantity: string, rate: string, unit: string } | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, custom?: { __typename?: 'Custom', area?: string | null, areaSource: string, areaUnit?: string | null, calculationVersion?: number | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, internalName?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, sourceProductId?: string | null, sourceProductRevision?: string | null, unit: string } | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, projectFiles?: Array<{ __typename?: 'ProjectFile', createdAt?: string | null, fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', cost: number, id: string, name: string, percentage: number, proposalProductId: string, quantity: number, quantityOverride?: number | null, rate: number } | null> | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null> | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, id: string, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, type: string } | null, transferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', quantity: string, rate: string, unit: string } | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> } | null } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetTimeEntriesGroupedByUserQueryVariables = Exact<{
  first: Scalars['Int'];
  forDate?: InputMaybe<Scalars['Date']>;
  forDateEnd?: InputMaybe<Scalars['Date']>;
  forDateStart?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetTimeEntriesGroupedByUserQuery = { __typename?: 'Query', getTimeEntriesGroupedByUser: { __typename?: 'GetTimeEntriesGroupedByUserResponse', data: Array<{ __typename?: 'TimeEntriesByUserGroup', totalEntries: number, totalTimeTrackedSeconds: number, dates: Array<{ __typename?: 'TimeEntriesByDateGroup', forDate: any, totalEntries: number, totalTimeTrackedSeconds: number, entries: Array<{ __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }> }>, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetTransferTruckQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTransferTruckQuery = { __typename?: 'Query', getTransferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null };

export type GetTransferTrucksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransferTrucksQuery = { __typename?: 'Query', getTransferTrucks: Array<{ __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string }> };

export type GetUserOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserOrganizationQuery = { __typename?: 'Query', getUserOrganization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type GetYearOverYearRevenueReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetYearOverYearRevenueReportQuery = { __typename?: 'Query', getYearOverYearRevenueReport: { __typename?: 'GetYearOverYearRevenueReportResponse', data: Array<{ __typename?: 'YearOverYearRevenueItem', lastYearRevenue: string, month: string, percentDifference: number, thisYearRevenue: string }> } };

export type GetYearToDateStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetYearToDateStatsQuery = { __typename?: 'Query', getYearToDateStats: { __typename?: 'YearToDateStats', yearToDateCloseRate: number, yearToDateJobAmountCompleted?: string | null, yearToDateNetMarginCalculated?: number | null, yearToDateTotalAmountProposed?: string | null, yearToDateTotalSalesWon?: string | null } };

export type IsCompanySearchableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IsCompanySearchableQuery = { __typename?: 'Query', isCompanySearchable?: boolean | null };

export type IsJobSearchableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IsJobSearchableQuery = { __typename?: 'Query', isJobSearchable?: boolean | null };

export type IsOpportunitySearchableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IsOpportunitySearchableQuery = { __typename?: 'Query', isOpportunitySearchable?: boolean | null };

export type IsProposalSearchableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IsProposalSearchableQuery = { __typename?: 'Query', isProposalSearchable?: boolean | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type NotificationTriggerDeliveriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  triggerId: Scalars['ID'];
}>;


export type NotificationTriggerDeliveriesQuery = { __typename?: 'Query', notificationTriggerDeliveries: Array<{ __typename?: 'WebhookDelivery', attempts: number, createdAt: any, deliveredAt?: any | null, errorMessage?: string | null, eventType: string, httpStatusCode?: number | null, id: string, nextRetryAt?: any | null, notificationTriggerId?: string | null, responseBody?: string | null, status: string, url?: string | null, uuid: string }> };

export type OrganizationProposalChecklistItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationProposalChecklistItemsQuery = { __typename?: 'Query', organizationProposalChecklistItems: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null }> };

export type PreviewSubscriptionChangeQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  quantityChange: Scalars['Int'];
}>;


export type PreviewSubscriptionChangeQuery = { __typename?: 'Query', previewSubscriptionChange?: { __typename?: 'PreviewSubscriptionChangeResponse', totalOnRenewal: number, totalToday: number } | null };

export type TaskRelatedSearchQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  type: Scalars['String'];
}>;


export type TaskRelatedSearchQuery = { __typename?: 'Query', taskRelatedSearch: Array<{ __typename?: 'TaskRelatedResult', companyId?: string | null, contactId?: string | null, id: string, label: string, secondary?: string | null }> };

export type TimeEntryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TimeEntryQuery = { __typename?: 'Query', timeEntry?: { __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', allCompleted: boolean, ratio: string }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', checklistItemId?: string | null, id: string, isCompleted: boolean, jobPhaseId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string, organization?: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, address: string, applicableStatuses?: Array<string> | null, checklistNotes?: string | null, costingMode: JobPhaseCostingMode, crewId?: string | null, endsAt?: any | null, externalId: string, hasJobCostsEntered: boolean, id: string, jobCostEntryDaysCount: number, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingThresholdPercent: number, jobCostingVariancePercent: number, jobDuration: number, jobSize: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, notes?: string | null, ordering: number, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', archivedAt?: any | null, firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, depositCollectedAt?: any | null, endsAt?: any | null, externalId: string, id: string, invoiceId?: string | null, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, uuid?: string | null }, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', cost: number, id: string, jobPhaseId: string, name: string, percentage: number, quantity: number, rate: string }> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, materialNeeded?: number | null, name?: string | null, rate?: string | null, type?: string | null }> | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean } | null, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, proposalPlantProductId?: string | null, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null, worksheet?: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string } | null } }> } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type ValidateLoginQueryVariables = Exact<{
  input: ValidateLoginInput;
}>;


export type ValidateLoginQuery = { __typename?: 'Query', validateLogin?: boolean | null };

export type ValidateUserInviteTokenQueryVariables = Exact<{
  email: Scalars['String'];
  inviteToken: Scalars['String'];
}>;


export type ValidateUserInviteTokenQuery = { __typename?: 'Query', validateUserInviteToken: boolean };

export type WorksheetProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorksheetProductsQuery = { __typename?: 'Query', worksheetProducts: Array<{ __typename?: 'WorksheetProduct', id: string, definition: { __typename?: 'Worksheet', area?: string | null, areaSource: string, areaUnit?: string | null, costTotal?: string | null, fixedPrice: string, indirectPercentage?: string | null, margin?: string | null, marginPercentage?: string | null, markup: string, name: string, overheadPercentage?: string | null, pricingMethod: string, pricingOverrideField?: string | null, profitAmount?: string | null, quantity: string, rate: string, scope?: string | null, scopeFormat?: string | null, sellingTotal?: string | null, unit: string, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', fixedPrice: string, markup: string, pricingMethod: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', calculatedQuantity?: string | null, calculation: string, category: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, formula?: string | null, hoursPerTruck?: string | null, jobSize?: string | null, jobSizeUnit?: string | null, name: string, quantity: string, quantityOverride?: string | null, rate: string, sourceId?: string | null, sourceName?: string | null, sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, thickness?: string | null, total?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateLoads?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, unit: string }> }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null }> };

export type WorksheetProposalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WorksheetProposalQuery = { __typename?: 'Query', worksheetProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, defaultLoadingTimeMins?: number | null, defaultTransferTruckId?: string | null, defaultUnloadTimeMins?: number | null, estimateTruckingByFullDay: boolean, id: string, idPrefix?: string | null, layout: ProposalLayout, maxTripNumberPerTruck?: number | null, minimumProfitPerDay?: number | null, multiplyTravelTimeByDay: boolean, multiplyTravelTimeForEquipmentLabour: boolean, optionalCheckboxDefaultChecked: boolean, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean, roundUpToNearestDollarAmount: boolean, startingNumber?: number | null }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', attemptCount: number, companyId: string, contactId: string, errorMessage?: string | null, id: string, proposalId?: string | null, sentAt?: any | null, startedAt?: any | null, status: ProposalPackageSendRecipientStatus }> } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, isOptional: boolean, name: string, ordering: number, showIndividualProducts: boolean }>, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isCustom: boolean, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, proposalProductGroupId?: string | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null }> | null, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', featureGeojson?: string | null, geojsonFeatureId: string, id: string, isScreenshotTarget: boolean, label?: string | null, measurementJob?: ProductMeasurementJob | null, measurementType: ProposalMeasurementType, measurementValue?: number | null, productId?: string | null, sortOrder?: number | null }> }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', contentType: string, id: string, isEnabled: boolean, proposalId: string }>, customFinancials: { __typename?: 'CustomProposalFinancials', incomplete: boolean, netMargin?: string | null, productsWithoutCosts: number, profit?: string | null, sendErrors: Array<string> }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', failedRecipients: number, id: string, processedRecipients: number, proposalId: string, status: ProposalPackageSendRunStatus, succeededRecipients: number, totalRecipients: number } | null, organization: { __typename?: 'Organization', canMapWithAi: boolean, email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, invoiceEmailText?: string | null, invoicingPaymentTermsNet?: number | null, logo?: string | null, name: string, onTrial?: boolean | null, organizationSalesGoal?: string | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, packageChildren: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }>, packageParent?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, packageWinnerProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null } | null, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, checklistNotes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, discount: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, overallTotalAfterDiscount: string, profit: string, profitAfterDiscount: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, archivedAt?: any | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, salesGoal?: string | null, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, closeConfidence?: number | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, discount: string, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, estimatingMethod: string, externalId: string, externalIdWithPrefix: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isPackageChild: boolean, isPackageParent: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalAfterTaxes: string, pdfGeneratedAt?: any | null, profit: string, profitAfterDiscount: string, profitPercentage: number, projectFilesFolderId?: string | null, projectedCloseDate?: any | null, proposalNotes?: string | null, proposalPackageParentId?: string | null, proposalPackageWinnerProposalId?: string | null, proposalPdf?: string | null, proposalRole: string, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, updatedAt: any, userId?: string | null, uuid: string, version: string, versionWithPrefix: string, wonAt?: any | null }> | null } };

export type WorksheetSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorksheetSettingsQuery = { __typename?: 'Query', worksheetSettings: { __typename?: 'WorksheetSettings', canManageProducts: boolean, canManageSettings: boolean, enabled: boolean, markup: string, method: string, factors: Array<{ __typename?: 'WorksheetFactor', label: string, value: string }> } };

export type AiMappingResultsBundleFragmentFragment = { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> };

export type AiMappingRunAreaFragmentFragment = { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any };

export type CompanyFragmentFragment = { __typename?: 'Company', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, addCompanyInfo?: boolean | null, projectFilesFolderId?: string | null, email: string, id: string, jobsCount?: number | null, name: string, notes?: string | null, phone?: string | null, proposalsCount?: number | null, website?: string | null, logo?: string | null, status: CompanyStatus, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null };

export type CustomEventFragmentFragment = { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }>, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null };

export type JobPhaseFragmentFragment = { __typename?: 'JobPhase', id: string, externalId: string, ordering: number, actualCostAdditional: string, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualCostTransferTruck: string, hasJobCostsEntered: boolean, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingVariancePercent: number, jobCostingThresholdPercent: number, jobCostEntryDaysCount: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, address: string, applicableStatuses?: Array<string> | null, productName: string, endsAt?: any | null, jobDuration: number, jobSize: number, notes?: string | null, checklistNotes?: string | null, organizationProductTypeName?: string | null, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, proposedCostTransferTruck: string, startsAt?: any | null, status: JobPhaseStatus, costingMode: JobPhaseCostingMode, travelTimeEstimate?: number | null, usersColor?: string | null, worksheet?: { __typename?: 'Worksheet', name: string, scope?: string | null, scopeFormat?: string | null, quantity: string, unit: string, rate: string, pricingMethod: string, pricingOverrideField?: string | null, markup: string, overheadPercentage?: string | null, indirectPercentage?: string | null, fixedPrice: string, profitAmount?: string | null, areaSource: string, area?: string | null, areaUnit?: string | null, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', pricingMethod: string, markup: string, fixedPrice: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, sourceId?: string | null, sourceName?: string | null, name: string, category: string, jobSize?: string | null, jobSizeUnit?: string | null, hoursPerTruck?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckRateLoads?: string | null, quantity: string, unit: string, rate: string, calculation: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, thickness?: string | null, quantityOverride?: string | null }> } | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, showIndividualProducts: boolean } | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, transferTruckId?: string | null, quantity?: number | null, name: string, tonnage: number, rateTon: number, rateHourly: number, proposalPlantProductId?: string | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', unit: string, quantity: string, rate: string } | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, type: string, plant: { __typename?: 'ProposalPlant', id: string, name: string, plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null } | null> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, rate?: string | null, name?: string | null, type?: string | null, materialNeeded?: number | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', unit: string, quantity: string, rate: string } | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, type: string } | null }> | null, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', id: string, jobPhaseId: string, name: string, cost: number, percentage: number, quantity: number, rate: string }> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', id: string, quantity: number, rate: string, costTotal: string, plantId: string, plantProductId: string }> | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', id: string, jobPhaseCostItemId: string, name: string, costTotal: string, quantity: number, rate: string }> | null }>, checklistCompletion: { __typename?: 'ChecklistCompletion', ratio: string, allCompleted: boolean }, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, cost: number, id: string, feeAmount: number, feeType: AdditionalCostFeeType }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, foremanUser?: { __typename?: 'User', id: string, name: string, phone?: string | null } | null, job: { __typename?: 'Job', externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, userId: string, company: { __typename?: 'Company', id: string, name: string, phone?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, name: string, email: string, phone?: string | null, avatar?: string | null, status: UserStatus } | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, measurementJob?: ProductMeasurementJob | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, type: string, externalProductName?: string | null, materialNeeded?: number | null, materialNeededOverride?: number | null, productId?: string | null, statementOfWork?: string | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', id: string, equipmentPieceId?: string | null, name: string, quantity: number, quantityOverride?: number | null, rate: number, timeTravel: number, timeTravelOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null }> | null, crews?: Array<{ __typename?: 'ProposalCrew', id: string, crewId?: string | null, name: string, rate: number, timeOnjob: number, timeOnjobOverride?: number | null }> | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', id: string, additionalCostId?: string | null, name: string, cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, quantity?: number | null, quantityOverride?: number | null } | null> | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, transferTruckId: string, name: string, tonnage: number, quantity: number, trucksNeeded?: number | null, proposalPlantProductId?: string | null } | null> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean }>, organization: { __typename?: 'Organization', id: string, name: string, logo?: string | null }, crew?: { __typename?: 'Crew', id: string, color: string, displayName?: string | null } | null, users?: Array<{ __typename?: 'User', id: string }> | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', id: string, isCompleted: boolean, checklistItemId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string } }> };

export type NotificationTriggerFragmentFragment = { __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, smsContent?: string | null, taskContent?: string | null, emailSubject?: string | null, isApi?: boolean | null, apiUrl?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiHeaders?: string | null, apiSecret?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> };

export type BitumioOrganizationEmailTemplateFragment = { __typename?: 'OrganizationEmailTemplate', type: OrganizationEmailTemplateType, html: string };

export type UpdatedProductFragment = { __typename?: 'Product', id: string };

export type BitumioProposalFragment = { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } };

export type BitumioProposalStageFragment = { __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null };

export type CustomAddPlantProductToProposalProductMutationVariables = Exact<{
  input: AddPlantProductToProposalProductInput;
}>;


export type CustomAddPlantProductToProposalProductMutation = { __typename?: 'Mutation', addPlantProductToProposalProduct: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomAddProductsToProposalStageMutationVariables = Exact<{
  input: AddProductsToProposalStageInput;
}>;


export type CustomAddProductsToProposalStageMutation = { __typename?: 'Mutation', addProductsToProposalStage: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomAddProposalAddressMutationVariables = Exact<{
  input: AddProposalAddressInput;
}>;


export type CustomAddProposalAddressMutation = { __typename?: 'Mutation', addProposalAddress: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomAddProposalEquipmentPieceMutationVariables = Exact<{
  equipmentPieceId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Float'];
}>;


export type CustomAddProposalEquipmentPieceMutation = { __typename?: 'Mutation', addProposalEquipmentPiece: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomAddProposalStageMutationVariables = Exact<{
  proposalId: Scalars['ID'];
}>;


export type CustomAddProposalStageMutation = { __typename?: 'Mutation', addProposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null } | null };

export type CustomApplyAiMappingAdditionalCostsMutationVariables = Exact<{
  input: ApplyAiMappingAdditionalCostsInput;
}>;


export type CustomApplyAiMappingAdditionalCostsMutation = { __typename?: 'Mutation', applyAiMappingAdditionalCosts: { __typename?: 'Proposal', id: string } };

export type CustomApplyProposalStageMeasurementsMutationVariables = Exact<{
  input: ApplyProposalStageMeasurementsInput;
}>;


export type CustomApplyProposalStageMeasurementsMutation = { __typename?: 'Mutation', applyProposalStageMeasurements: { __typename?: 'ApplyProposalStageMeasurementsPayload', warnings: Array<string>, proposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } } };

export type CustomCancelAiMappingTaskMutationVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type CustomCancelAiMappingTaskMutation = { __typename?: 'Mutation', cancelAiMappingTask: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any } };

export type CustomCancelOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomCancelOpportunityMutation = { __typename?: 'Mutation', cancelOpportunity: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, id: string, name: string, notes?: string | null, source?: OpportunitySource | null, status: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', name: string }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, name: string }> | null, user?: { __typename?: 'User', firstName?: string | null, id: string, lastName?: string | null } | null } };

export type CustomCancelProposalMutationVariables = Exact<{
  duplicate: Scalars['Boolean'];
  id: Scalars['ID'];
  maintainCurrentId?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomCancelProposalMutation = { __typename?: 'Mutation', cancelProposal: { __typename?: 'CancelProposalResponse', newProposal?: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } | null, proposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } } };

export type CustomCloseProposalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomCloseProposalMutation = { __typename?: 'Mutation', closeProposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomCopyProposalProductToStageMutationVariables = Exact<{
  proposalProductId: Scalars['ID'];
  targetStageId: Scalars['ID'];
}>;


export type CustomCopyProposalProductToStageMutation = { __typename?: 'Mutation', copyProposalProductToStage: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomCreateAiMappingDetectionMutationVariables = Exact<{
  input: CreateAiMappingDetectionInput;
}>;


export type CustomCreateAiMappingDetectionMutation = { __typename?: 'Mutation', createAiMappingDetection: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> } };

export type CustomCreateAiMappingRunMutationVariables = Exact<{
  projectMapId: Scalars['ID'];
}>;


export type CustomCreateAiMappingRunMutation = { __typename?: 'Mutation', createAiMappingRun: { __typename?: 'AiMappingRun', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, projectMap: { __typename?: 'ProjectMap', id: string }, areas: Array<{ __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }> } };

export type CustomCreateAiMappingRunAreaMutationVariables = Exact<{
  input: CreateAiMappingRunAreaInput;
}>;


export type CustomCreateAiMappingRunAreaMutation = { __typename?: 'Mutation', createAiMappingRunArea: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any } };

export type CustomCreateAiMappingSegmentationMutationVariables = Exact<{
  input: CreateAiMappingSegmentationInput;
}>;


export type CustomCreateAiMappingSegmentationMutation = { __typename?: 'Mutation', createAiMappingSegmentation: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> } };

export type CustomCreateCustomEventMutationVariables = Exact<{
  input?: InputMaybe<CreateCustomEventInput>;
}>;


export type CustomCreateCustomEventMutation = { __typename?: 'Mutation', createCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }>, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } | null };

export type CustomCreateDailyFormVehiclePartMutationVariables = Exact<{
  input: CreateDailyFormVehiclePartInput;
}>;


export type CustomCreateDailyFormVehiclePartMutation = { __typename?: 'Mutation', createDailyFormVehiclePart: { __typename?: 'DailyFormVehiclePart', id: string } };

export type CustomCreateDailyFormVehicleServicePlanMutationVariables = Exact<{
  input: CreateDailyFormVehicleServicePlanInput;
}>;


export type CustomCreateDailyFormVehicleServicePlanMutation = { __typename?: 'Mutation', createDailyFormVehicleServicePlan: { __typename?: 'DailyFormVehicleServicePlan', id: string } };

export type CustomCreateNotificationTriggerMutationVariables = Exact<{
  input: CreateNotificationTriggerInput;
}>;


export type CustomCreateNotificationTriggerMutation = { __typename?: 'Mutation', createNotificationTrigger?: { __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, smsContent?: string | null, taskContent?: string | null, emailSubject?: string | null, isApi?: boolean | null, apiUrl?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiHeaders?: string | null, apiSecret?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> } | null };

export type CustomCreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CustomCreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string } };

export type CustomCreateProposalMutationVariables = Exact<{
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  source?: InputMaybe<ProposalSource>;
  projectedCloseDate?: InputMaybe<Scalars['Date']>;
  closeConfidence?: InputMaybe<Scalars['Int']>;
}>;


export type CustomCreateProposalMutation = { __typename?: 'Mutation', createProposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomCreateProposalFromOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomCreateProposalFromOpportunityMutation = { __typename?: 'Mutation', createProposalFromOpportunity: { __typename?: 'Proposal', id: string } };

export type CustomDeleteAiMappingDetectionMutationVariables = Exact<{
  runAreaId: Scalars['ID'];
  detectionId: Scalars['ID'];
}>;


export type CustomDeleteAiMappingDetectionMutation = { __typename?: 'Mutation', deleteAiMappingDetection: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> } };

export type CustomDeleteAiMappingSegmentationMutationVariables = Exact<{
  runAreaId: Scalars['ID'];
  segmentationId: Scalars['ID'];
}>;


export type CustomDeleteAiMappingSegmentationMutation = { __typename?: 'Mutation', deleteAiMappingSegmentation: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> } };

export type CustomDeleteCustomEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteCustomEventMutation = { __typename?: 'Mutation', deleteCustomEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }>, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } };

export type CustomDeleteDailyFormVehiclePartMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteDailyFormVehiclePartMutation = { __typename?: 'Mutation', deleteDailyFormVehiclePart: { __typename?: 'DailyFormVehiclePart', id: string } };

export type CustomDeleteDailyFormVehicleServicePlanMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteDailyFormVehicleServicePlanMutation = { __typename?: 'Mutation', deleteDailyFormVehicleServicePlan: { __typename?: 'DailyFormVehicleServicePlan', id: string } };

export type CustomDeleteProposalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteProposalMutation = { __typename?: 'Mutation', deleteProposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomDeleteProposalProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteProposalProductMutation = { __typename?: 'Mutation', deleteProposalProduct: { __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null } };

export type CustomDeleteProposalStageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteProposalStageMutation = { __typename?: 'Mutation', deleteProposalStage: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomDetectAiMappingRunAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDetectAiMappingRunAreaMutation = { __typename?: 'Mutation', detectAiMappingRunArea: { __typename?: 'AiMappingDetectResponse', taskId: string, area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any } } };

export type CustomDuplicateProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDuplicateProductMutation = { __typename?: 'Mutation', duplicateProduct: { __typename?: 'Product', id: string } };

export type CustomDuplicateProposalMutationVariables = Exact<{
  id: Scalars['ID'];
  isChangeOrder?: InputMaybe<Scalars['Boolean']>;
  startNewProposal?: InputMaybe<Scalars['Boolean']>;
  createNewVersion?: InputMaybe<Scalars['Boolean']>;
  changeOrderJobId?: InputMaybe<Scalars['ID']>;
  changeOrderProposalType?: InputMaybe<ChangeOrderProposalType>;
  changeOrderScheduledJobsAction?: InputMaybe<ChangeOrderScheduledJobsAction>;
}>;


export type CustomDuplicateProposalMutation = { __typename?: 'Mutation', duplicateProposal?: { __typename?: 'DuplicateProposalResponse', newProposal?: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } | null, proposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } } | null };

export type CustomDuplicateProposalStageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDuplicateProposalStageMutation = { __typename?: 'Mutation', duplicateProposalStage: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomExportAiMappingRunAreaPdfMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomExportAiMappingRunAreaPdfMutation = { __typename?: 'Mutation', exportAiMappingRunAreaPdf: { __typename?: 'AiMappingDetectResponse', taskId: string, area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any } } };

export type CustomRedoAiMappingRunAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomRedoAiMappingRunAreaMutation = { __typename?: 'Mutation', redoAiMappingRunArea: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> } };

export type CustomRetryProposalPackageSendRecipientsMutationVariables = Exact<{
  runId: Scalars['ID'];
}>;


export type CustomRetryProposalPackageSendRecipientsMutation = { __typename?: 'Mutation', retryProposalPackageSendRecipients: { __typename?: 'ProposalPackageSendRun', id: string, status: ProposalPackageSendRunStatus, totalRecipients: number, processedRecipients: number, succeededRecipients: number, failedRecipients: number } };

export type CustomScheduleCustomEventBlockMutationVariables = Exact<{
  input: ScheduleCustomEventBlockInput;
}>;


export type CustomScheduleCustomEventBlockMutation = { __typename?: 'Mutation', scheduleCustomEventBlock: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }>, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } };

export type CustomScheduleJobPhaseMutationVariables = Exact<{
  blocks: Array<InputMaybe<AddJobPhaseScheduleBlock>> | InputMaybe<AddJobPhaseScheduleBlock>;
  crewId?: InputMaybe<Scalars['ID']>;
  jobPhaseId: Scalars['ID'];
  travelTimeEstimate?: InputMaybe<Scalars['Float']>;
  userIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  usersColor?: InputMaybe<Scalars['String']>;
}>;


export type CustomScheduleJobPhaseMutation = { __typename?: 'Mutation', scheduleJobPhase: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, userId: string, foremanUser?: { __typename?: 'User', id: string, organization: { __typename?: 'Organization', id: string } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null } | null> | null } };

export type CustomScheduleJobPhaseBlockMutationVariables = Exact<{
  input: ScheduleJobPhaseBlockInput;
}>;


export type CustomScheduleJobPhaseBlockMutation = { __typename?: 'Mutation', scheduleJobPhaseBlock: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, userId: string, foremanUser?: { __typename?: 'User', id: string, organization: { __typename?: 'Organization', id: string } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null } | null> | null } };

export type CustomSegmentAiMappingRunAreaMutationVariables = Exact<{
  id: Scalars['ID'];
  minSegAreaSqft?: InputMaybe<Scalars['Float']>;
  minSegConf?: InputMaybe<Scalars['Float']>;
}>;


export type CustomSegmentAiMappingRunAreaMutation = { __typename?: 'Mutation', segmentAiMappingRunArea: { __typename?: 'AiMappingDetectResponse', taskId: string, area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any } } };

export type CustomSendProposalPackageMutationVariables = Exact<{
  proposalId: Scalars['ID'];
  recipients: Array<ProposalPackageRecipientInput> | ProposalPackageRecipientInput;
  layout?: InputMaybe<ProposalLayout>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  proposalNotes?: InputMaybe<Scalars['String']>;
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  contentSettings?: InputMaybe<UpdateProposalContentSettingsHasManyInput>;
}>;


export type CustomSendProposalPackageMutation = { __typename?: 'Mutation', sendProposalPackage: { __typename?: 'ProposalPackageSendRun', id: string, status: ProposalPackageSendRunStatus, totalRecipients: number, processedRecipients: number, succeededRecipients: number, failedRecipients: number } };

export type CustomSendProposalToSpecificRecipientsMutationVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String'];
  proposalId: Scalars['ID'];
  forceSend?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomSendProposalToSpecificRecipientsMutation = { __typename?: 'Mutation', sendProposalToSpecificRecipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }> };

export type CustomSetJobDepositCollectedMutationVariables = Exact<{
  collected: Scalars['Boolean'];
  id: Scalars['ID'];
}>;


export type CustomSetJobDepositCollectedMutation = { __typename?: 'Mutation', setJobDepositCollected: { __typename?: 'Job', id: string, billingStatus?: JobBillingStatus | null, depositCollectedAt?: any | null } };

export type CustomSetProposalToDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomSetProposalToDraftMutation = { __typename?: 'Mutation', setProposalToDraft: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomSetProposalToWonMutationVariables = Exact<{
  id: Scalars['ID'];
  forceSend?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomSetProposalToWonMutation = { __typename?: 'Mutation', setProposalToWon: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomSyncAiMappingCostsToMapMutationVariables = Exact<{
  input: SyncAiMappingCostsToMapInput;
}>;


export type CustomSyncAiMappingCostsToMapMutation = { __typename?: 'Mutation', syncAiMappingCostsToMap: { __typename?: 'ProjectMap', id: string, measurements: Array<{ __typename?: 'ProjectMapMeasurement', id: string, geojsonFeatureId: string }> } };

export type CustomSyncProposalStageMeasurementsMutationVariables = Exact<{
  input: SyncProposalStageMeasurementsInput;
}>;


export type CustomSyncProposalStageMeasurementsMutation = { __typename?: 'Mutation', syncProposalStageMeasurements: { __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null } };

export type CustomSyncQuickbooksBatchMutationVariables = Exact<{
  input: SyncQuickbooksBatchInput;
}>;


export type CustomSyncQuickbooksBatchMutation = { __typename?: 'Mutation', syncQuickbooksBatch: { __typename?: 'QuickbooksSyncBatch', id: string, billedTotalAmount: number, selectedTotalAmount: number, quickbooksOnlineStatus: QuickbooksSyncBatchStatus, quickbooksDesktopStatus: QuickbooksSyncBatchStatus, quickbooksOnlineError?: string | null, quickbooksDesktopError?: string | null } };

export type CustomUndoAiMappingRunAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomUndoAiMappingRunAreaMutation = { __typename?: 'Mutation', undoAiMappingRunArea: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> } };

export type CustomUnscheduleCustomEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomUnscheduleCustomEventMutation = { __typename?: 'Mutation', unscheduleCustomEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }>, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } };

export type CustomUnscheduleJobPhaseMutationVariables = Exact<{
  jobPhaseId: Scalars['ID'];
}>;


export type CustomUnscheduleJobPhaseMutation = { __typename?: 'Mutation', unscheduleJobPhase: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, userId: string, foremanUser?: { __typename?: 'User', id: string, organization: { __typename?: 'Organization', id: string } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null } | null> | null } };

export type CustomUpdateAiMappingDetectionMutationVariables = Exact<{
  input: UpdateAiMappingDetectionInput;
}>;


export type CustomUpdateAiMappingDetectionMutation = { __typename?: 'Mutation', updateAiMappingDetection: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> } };

export type CustomUpdateAiMappingSegmentationMutationVariables = Exact<{
  input: UpdateAiMappingSegmentationInput;
}>;


export type CustomUpdateAiMappingSegmentationMutation = { __typename?: 'Mutation', updateAiMappingSegmentation: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> } };

export type CustomUpdateCustomEventMutationVariables = Exact<{
  input?: InputMaybe<UpdateCustomEventInput>;
}>;


export type CustomUpdateCustomEventMutation = { __typename?: 'Mutation', updateCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }>, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } | null };

export type CustomUpdateDailyFormVehiclePartMutationVariables = Exact<{
  input: UpdateDailyFormVehiclePartInput;
}>;


export type CustomUpdateDailyFormVehiclePartMutation = { __typename?: 'Mutation', updateDailyFormVehiclePart: { __typename?: 'DailyFormVehiclePart', id: string } };

export type CustomUpdateDailyFormVehicleServicePlanMutationVariables = Exact<{
  input: UpdateDailyFormVehicleServicePlanInput;
}>;


export type CustomUpdateDailyFormVehicleServicePlanMutation = { __typename?: 'Mutation', updateDailyFormVehicleServicePlan: { __typename?: 'DailyFormVehicleServicePlan', id: string } };

export type CustomUpdateJobNotesMutationVariables = Exact<{
  id: Scalars['ID'];
  notes: Scalars['String'];
}>;


export type CustomUpdateJobNotesMutation = { __typename?: 'Mutation', updateJobNotes?: { __typename?: 'Job', id: string, notes?: string | null } | null };

export type CustomUpdateJobPhaseCostingMutationVariables = Exact<{
  input: UpdateJobPhaseCostingInput;
}>;


export type CustomUpdateJobPhaseCostingMutation = { __typename?: 'Mutation', updateJobPhaseCosting: { __typename?: 'JobPhase', id: string, externalId: string, ordering: number, actualCostAdditional: string, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualCostTransferTruck: string, hasJobCostsEntered: boolean, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingVariancePercent: number, jobCostingThresholdPercent: number, jobCostEntryDaysCount: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, address: string, applicableStatuses?: Array<string> | null, productName: string, endsAt?: any | null, jobDuration: number, jobSize: number, notes?: string | null, checklistNotes?: string | null, organizationProductTypeName?: string | null, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, proposedCostTransferTruck: string, startsAt?: any | null, status: JobPhaseStatus, costingMode: JobPhaseCostingMode, travelTimeEstimate?: number | null, usersColor?: string | null, worksheet?: { __typename?: 'Worksheet', name: string, scope?: string | null, scopeFormat?: string | null, quantity: string, unit: string, rate: string, pricingMethod: string, pricingOverrideField?: string | null, markup: string, overheadPercentage?: string | null, indirectPercentage?: string | null, fixedPrice: string, profitAmount?: string | null, areaSource: string, area?: string | null, areaUnit?: string | null, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', pricingMethod: string, markup: string, fixedPrice: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, sourceId?: string | null, sourceName?: string | null, name: string, category: string, jobSize?: string | null, jobSizeUnit?: string | null, hoursPerTruck?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckRateLoads?: string | null, quantity: string, unit: string, rate: string, calculation: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, thickness?: string | null, quantityOverride?: string | null }> } | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, showIndividualProducts: boolean } | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, transferTruckId?: string | null, quantity?: number | null, name: string, tonnage: number, rateTon: number, rateHourly: number, proposalPlantProductId?: string | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', unit: string, quantity: string, rate: string } | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, type: string, plant: { __typename?: 'ProposalPlant', id: string, name: string, plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null } | null> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, rate?: string | null, name?: string | null, type?: string | null, materialNeeded?: number | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', unit: string, quantity: string, rate: string } | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, type: string } | null }> | null, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', id: string, jobPhaseId: string, name: string, cost: number, percentage: number, quantity: number, rate: string }> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', id: string, quantity: number, rate: string, costTotal: string, plantId: string, plantProductId: string }> | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', id: string, jobPhaseCostItemId: string, name: string, costTotal: string, quantity: number, rate: string }> | null }>, checklistCompletion: { __typename?: 'ChecklistCompletion', ratio: string, allCompleted: boolean }, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, cost: number, id: string, feeAmount: number, feeType: AdditionalCostFeeType }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, foremanUser?: { __typename?: 'User', id: string, name: string, phone?: string | null } | null, job: { __typename?: 'Job', externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, userId: string, company: { __typename?: 'Company', id: string, name: string, phone?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, name: string, email: string, phone?: string | null, avatar?: string | null, status: UserStatus } | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, measurementJob?: ProductMeasurementJob | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, type: string, externalProductName?: string | null, materialNeeded?: number | null, materialNeededOverride?: number | null, productId?: string | null, statementOfWork?: string | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', id: string, equipmentPieceId?: string | null, name: string, quantity: number, quantityOverride?: number | null, rate: number, timeTravel: number, timeTravelOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null }> | null, crews?: Array<{ __typename?: 'ProposalCrew', id: string, crewId?: string | null, name: string, rate: number, timeOnjob: number, timeOnjobOverride?: number | null }> | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', id: string, additionalCostId?: string | null, name: string, cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, quantity?: number | null, quantityOverride?: number | null } | null> | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, transferTruckId: string, name: string, tonnage: number, quantity: number, trucksNeeded?: number | null, proposalPlantProductId?: string | null } | null> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean }>, organization: { __typename?: 'Organization', id: string, name: string, logo?: string | null }, crew?: { __typename?: 'Crew', id: string, color: string, displayName?: string | null } | null, users?: Array<{ __typename?: 'User', id: string }> | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', id: string, isCompleted: boolean, checklistItemId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string } }> } };

export type CustomUpdateJobPhaseNotesMutationVariables = Exact<{
  input: UpdateJobPhaseNotesInput;
}>;


export type CustomUpdateJobPhaseNotesMutation = { __typename?: 'Mutation', updateJobPhaseNotes: { __typename?: 'JobPhase', id: string, externalId: string, ordering: number, actualCostAdditional: string, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualCostTransferTruck: string, hasJobCostsEntered: boolean, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingVariancePercent: number, jobCostingThresholdPercent: number, jobCostEntryDaysCount: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, address: string, applicableStatuses?: Array<string> | null, productName: string, endsAt?: any | null, jobDuration: number, jobSize: number, notes?: string | null, checklistNotes?: string | null, organizationProductTypeName?: string | null, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, proposedCostTransferTruck: string, startsAt?: any | null, status: JobPhaseStatus, costingMode: JobPhaseCostingMode, travelTimeEstimate?: number | null, usersColor?: string | null, worksheet?: { __typename?: 'Worksheet', name: string, scope?: string | null, scopeFormat?: string | null, quantity: string, unit: string, rate: string, pricingMethod: string, pricingOverrideField?: string | null, markup: string, overheadPercentage?: string | null, indirectPercentage?: string | null, fixedPrice: string, profitAmount?: string | null, areaSource: string, area?: string | null, areaUnit?: string | null, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', pricingMethod: string, markup: string, fixedPrice: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, sourceId?: string | null, sourceName?: string | null, name: string, category: string, jobSize?: string | null, jobSizeUnit?: string | null, hoursPerTruck?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckRateLoads?: string | null, quantity: string, unit: string, rate: string, calculation: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, thickness?: string | null, quantityOverride?: string | null }> } | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, showIndividualProducts: boolean } | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, transferTruckId?: string | null, quantity?: number | null, name: string, tonnage: number, rateTon: number, rateHourly: number, proposalPlantProductId?: string | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', unit: string, quantity: string, rate: string } | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, type: string, plant: { __typename?: 'ProposalPlant', id: string, name: string, plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null } | null> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, rate?: string | null, name?: string | null, type?: string | null, materialNeeded?: number | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', unit: string, quantity: string, rate: string } | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, type: string } | null }> | null, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', id: string, jobPhaseId: string, name: string, cost: number, percentage: number, quantity: number, rate: string }> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', id: string, quantity: number, rate: string, costTotal: string, plantId: string, plantProductId: string }> | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', id: string, jobPhaseCostItemId: string, name: string, costTotal: string, quantity: number, rate: string }> | null }>, checklistCompletion: { __typename?: 'ChecklistCompletion', ratio: string, allCompleted: boolean }, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, cost: number, id: string, feeAmount: number, feeType: AdditionalCostFeeType }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, foremanUser?: { __typename?: 'User', id: string, name: string, phone?: string | null } | null, job: { __typename?: 'Job', externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, userId: string, company: { __typename?: 'Company', id: string, name: string, phone?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, name: string, email: string, phone?: string | null, avatar?: string | null, status: UserStatus } | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, measurementJob?: ProductMeasurementJob | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, type: string, externalProductName?: string | null, materialNeeded?: number | null, materialNeededOverride?: number | null, productId?: string | null, statementOfWork?: string | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', id: string, equipmentPieceId?: string | null, name: string, quantity: number, quantityOverride?: number | null, rate: number, timeTravel: number, timeTravelOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null }> | null, crews?: Array<{ __typename?: 'ProposalCrew', id: string, crewId?: string | null, name: string, rate: number, timeOnjob: number, timeOnjobOverride?: number | null }> | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', id: string, additionalCostId?: string | null, name: string, cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, quantity?: number | null, quantityOverride?: number | null } | null> | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, transferTruckId: string, name: string, tonnage: number, quantity: number, trucksNeeded?: number | null, proposalPlantProductId?: string | null } | null> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean }>, organization: { __typename?: 'Organization', id: string, name: string, logo?: string | null }, crew?: { __typename?: 'Crew', id: string, color: string, displayName?: string | null } | null, users?: Array<{ __typename?: 'User', id: string }> | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', id: string, isCompleted: boolean, checklistItemId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string } }> } };

export type CustomUpdateJobProjectManagerMutationVariables = Exact<{
  id: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type CustomUpdateJobProjectManagerMutation = { __typename?: 'Mutation', updateJobProjectManager: { __typename?: 'Job', id: string, userId: string } };

export type CustomUpdateNotificationTriggerMutationVariables = Exact<{
  input: UpdateNotificationTriggerInput;
}>;


export type CustomUpdateNotificationTriggerMutation = { __typename?: 'Mutation', updateNotificationTrigger?: { __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, smsContent?: string | null, taskContent?: string | null, emailSubject?: string | null, isApi?: boolean | null, apiUrl?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiHeaders?: string | null, apiSecret?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> } | null };

export type CustomUpdateProjectMapMutationVariables = Exact<{
  input: UpdateProjectMapInput;
}>;


export type CustomUpdateProjectMapMutation = { __typename?: 'Mutation', updateProjectMap: { __typename?: 'ProjectMap', id: string, addressLine1?: string | null, addressLine2?: string | null, addressCity?: string | null, addressState?: string | null, addressZip?: string | null, addressCountry?: string | null, latitude?: number | null, longitude?: number | null } };

export type CustomUpdateProposalMutationVariables = Exact<{
  id: Scalars['ID'];
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  source?: InputMaybe<ProposalSource>;
  projectedCloseDate?: InputMaybe<Scalars['Date']>;
  closeConfidence?: InputMaybe<Scalars['Int']>;
}>;


export type CustomUpdateProposalMutation = { __typename?: 'Mutation', updateProposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomUpdateProposalInfoMutationVariables = Exact<{
  input?: InputMaybe<UpdateProposalInfoInput>;
}>;


export type CustomUpdateProposalInfoMutation = { __typename?: 'Mutation', updateProposalInfo: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomUpdateProposalPlantProductMutationVariables = Exact<{
  plantProductId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  proposalPlantProductId: Scalars['ID'];
}>;


export type CustomUpdateProposalPlantProductMutation = { __typename?: 'Mutation', updateProposalPlantProduct: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomUpdateProposalProductMutationVariables = Exact<{
  input: UpdateProposalProductInput;
}>;


export type CustomUpdateProposalProductMutation = { __typename?: 'Mutation', updateProposalProduct: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomUpdateProposalStageMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  mapData?: InputMaybe<Scalars['String']>;
  addressOverride?: InputMaybe<Scalars['String']>;
}>;


export type CustomUpdateProposalStageMutation = { __typename?: 'Mutation', updateProposalStage: { __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null } };

export type CustomUpdateProposalStageAddressAndClearProductsMutationVariables = Exact<{
  input: UpdateProposalStageAddressAndClearProductsInput;
}>;


export type CustomUpdateProposalStageAddressAndClearProductsMutation = { __typename?: 'Mutation', updateProposalStageAddressAndClearProducts: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomGetAiMappingProposalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetAiMappingProposalQuery = { __typename?: 'Query', getProposal: { __typename?: 'Proposal', id: string, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', id: string, productName?: string | null, measurementJob?: ProductMeasurementJob | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, unitPrice?: number | null, measurementJob?: ProductMeasurementJob | null, productId?: string | null } }> | null }> } };

export type CustomGetAiMappingRunQueryVariables = Exact<{
  projectMapId: Scalars['ID'];
}>;


export type CustomGetAiMappingRunQuery = { __typename?: 'Query', getAiMappingRun?: { __typename?: 'AiMappingRun', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, projectMap: { __typename?: 'ProjectMap', id: string }, areas: Array<{ __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }> } | null };

export type CustomGetAiMappingRunAreaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetAiMappingRunAreaQuery = { __typename?: 'Query', getAiMappingRunArea: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any } };

export type CustomGetAiMappingRunAreaResultsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetAiMappingRunAreaResultsQuery = { __typename?: 'Query', getAiMappingRunAreaResults: { __typename?: 'AiMappingRunAreaResultsResponse', area: { __typename?: 'AiMappingRunArea', id: string, name?: string | null, inputType: AiMappingInputType, coordinates?: string | null, status: string, taskId?: string | null, currentVersion: number, imageWidth?: number | null, imageHeight?: number | null, segmentationModel?: string | null, minSegAreaSqft?: number | null, minSegConf?: number | null, createdAt: any, updatedAt: any }, detections: Array<{ __typename?: 'AiMappingDetection', id: string, version: number, category: string, bbox: Array<number>, confidence?: number | null, color?: string | null, source?: string | null, isDeleted: boolean }>, segmentations: Array<{ __typename?: 'AiMappingSegmentation', id: string, version: number, category: string, polygon: Array<number>, areaSqft?: number | null, color?: string | null, isDeleted: boolean }> } };

export type CustomGetAiMappingTaskStatusQueryVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type CustomGetAiMappingTaskStatusQuery = { __typename?: 'Query', getAiMappingTaskStatus: { __typename?: 'AiMappingTaskStatus', status: string, progress?: number | null, progressMessage?: string | null, error?: string | null, pdfUrl?: string | null, counts?: Array<{ __typename?: 'AiMappingCategoryCount', category: string, count: number }> | null } };

export type CustomGetAllCrewsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomGetAllCrewsQuery = { __typename?: 'Query', getAllCrews: Array<{ __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', id: string }> | null, foremanUser?: { __typename?: 'User', id: string, name: string } | null, organization: { __typename?: 'Organization', id: string } }> };

export type CustomGetCompaniesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
}>;


export type CustomGetCompaniesQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompaniesResponse', data: Array<{ __typename?: 'Company', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, addCompanyInfo?: boolean | null, projectFilesFolderId?: string | null, email: string, id: string, jobsCount?: number | null, name: string, notes?: string | null, phone?: string | null, proposalsCount?: number | null, website?: string | null, logo?: string | null, status: CompanyStatus, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetCompaniesForDropdownQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
}>;


export type CustomGetCompaniesForDropdownQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompaniesResponse', data: Array<{ __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, id: string, firstName: string, lastName: string }> }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetCompaniesForFilterQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
}>;


export type CustomGetCompaniesForFilterQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompaniesResponse', data: Array<{ __typename?: 'Company', id: string, name: string }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetCompaniesForMergeQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
}>;


export type CustomGetCompaniesForMergeQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompaniesResponse', data: Array<{ __typename?: 'Company', id: string, name: string, proposalsCount?: number | null, jobsCount?: number | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', currentPage: number, hasMorePages: boolean } } };

export type CustomGetCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'Company', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, addCompanyInfo?: boolean | null, projectFilesFolderId?: string | null, email: string, id: string, jobsCount?: number | null, name: string, notes?: string | null, phone?: string | null, proposalsCount?: number | null, website?: string | null, logo?: string | null, status: CompanyStatus, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null } | null };

export type CustomGetCrewsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
}>;


export type CustomGetCrewsQuery = { __typename?: 'Query', getCrews?: { __typename?: 'CrewPaginator', data: Array<{ __typename?: 'Crew', id: string, name: string, displayName?: string | null, rate: number, color: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type CustomGetCustomEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetCustomEventQuery = { __typename?: 'Query', getCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, files: Array<{ __typename?: 'CustomEventFile', id: string, name: string, path: string }>, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } | null };

export type CustomGetCustomEventBlocksQueryVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
  crewId?: InputMaybe<Scalars['ID']>;
  customEventIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CustomGetCustomEventBlocksQuery = { __typename?: 'Query', getCustomEventBlocks: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, id: string, name: string } | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } | null }> };

export type CustomGetDailyFormVehicleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetDailyFormVehicleQuery = { __typename?: 'Query', getDailyFormVehicle: { __typename?: 'DailyFormVehicle', id: string, name: string, year?: number | null, make?: string | null, model?: string | null, vin?: string | null, licensePlate?: string | null, registrationState?: string | null, registrationExpirationDate?: any | null, inServiceDate?: any | null, meterType?: DailyFormVehicleMeterType | null, currentMeterReading?: number | null, defaultServiceIntervalValue?: number | null, defaultServiceIntervalUnit?: DailyFormVehicleServiceIntervalUnit | null, notes?: string | null, isActive: boolean, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, parts: Array<{ __typename?: 'DailyFormVehiclePart', id: string, name: string, vendorName?: string | null, partNumber?: string | null, unitPrice?: number | null, quantity?: number | null, notes?: string | null }>, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', id: string, name: string, intervalValue: number, intervalUnit: DailyFormVehicleServiceIntervalUnit, leadValue: number, leadUnit?: DailyFormVehicleServiceIntervalUnit | null, lastCompletedAt?: any | null, lastCompletedMeterReading?: number | null, nextDueDate?: any | null, nextDueMeterReading?: number | null, autoCreateTask: boolean, issueType?: string | null, priority?: DailyFormIssuePriority | null, notes?: string | null, isActive: boolean, assignedTo?: { __typename?: 'User', id: string, name: string } | null }> } };

export type CustomGetDailyFormVehiclesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type CustomGetDailyFormVehiclesQuery = { __typename?: 'Query', getDailyFormVehicles?: { __typename?: 'DailyFormVehiclePaginator', data: Array<{ __typename?: 'DailyFormVehicle', id: string, name: string, year?: number | null, make?: string | null, model?: string | null, licensePlate?: string | null, registrationExpirationDate?: any | null, currentMeterReading?: number | null, meterType?: DailyFormVehicleMeterType | null, isActive: boolean, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null, servicePlans: Array<{ __typename?: 'DailyFormVehicleServicePlan', id: string, name: string, intervalUnit: DailyFormVehicleServiceIntervalUnit, nextDueDate?: any | null, nextDueMeterReading?: number | null, isActive: boolean }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type CustomGetDailyFormWorkOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetDailyFormWorkOrderQuery = { __typename?: 'Query', getDailyFormWorkOrder: { __typename?: 'DailyFormWorkOrder', id: string, issueName: string, issueDescription: string, issueType: string, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, comments?: string | null, neededCompletionDate?: any | null, completedAt?: any | null, currentMeterReading?: number | null, estimatedTaskTime?: number | null, vehicle: { __typename?: 'DailyFormVehicle', id: string, name: string }, assignedTo?: { __typename?: 'User', id: string, name: string } | null, servicePlan?: { __typename?: 'DailyFormVehicleServicePlan', id: string, name: string } | null, files: Array<{ __typename?: 'DailyFormWorkOrderFile', id: string, name: string, path: string }> } };

export type CustomGetDailyFormWorkOrdersQueryVariables = Exact<{
  assignedTo?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  multipleAssignedTo?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multiplePriorities?: InputMaybe<Array<DailyFormIssuePriority> | DailyFormIssuePriority>;
  multipleStatuses?: InputMaybe<Array<DailyFormIssueStatus> | DailyFormIssueStatus>;
  completedDate?: InputMaybe<Scalars['Date']>;
  neededCompletionDate?: InputMaybe<Scalars['Date']>;
  page?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<DailyFormIssuePriority>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<QueryDailyFormWorkOrdersSortKey>;
  status?: InputMaybe<DailyFormIssueStatus>;
  vehicleId?: InputMaybe<Scalars['ID']>;
}>;


export type CustomGetDailyFormWorkOrdersQuery = { __typename?: 'Query', getDailyFormWorkOrders: { __typename?: 'GetDailyFormWorkOrdersResponse', data: Array<{ __typename?: 'DailyFormWorkOrder', id: string, issueName: string, priority: DailyFormIssuePriority, status: DailyFormIssueStatus, neededCompletionDate?: any | null, completedAt?: any | null, currentMeterReading?: number | null, createdAt: any, vehicle: { __typename?: 'DailyFormVehicle', id: string, name: string }, user: { __typename?: 'User', id: string, name: string }, assignedTo?: { __typename?: 'User', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetDailyFormInspectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetDailyFormInspectionQuery = { __typename?: 'Query', getDailyFormInspection: { __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', id: string, name: string, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null } | null, questionAnswers: Array<{ __typename?: 'DailyFormInspectionQuestionAnswer', isTrue: boolean, answer?: string | null, question: { __typename?: 'DailyFormInspectionQuestion', id: string, question: string, type: DailyFormInspectionQuestionType } }> } };

export type CustomGetDailyFormInspectionsQueryVariables = Exact<{
  dailyFormVehicleId?: InputMaybe<Scalars['ID']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<QueryDailyFormInspectionsSortKey>;
}>;


export type CustomGetDailyFormInspectionsQuery = { __typename?: 'Query', getDailyFormInspections: { __typename?: 'GetDailyFormInspectionsResponse', data: Array<{ __typename?: 'DailyFormInspection', createdAt: any, id: string, lightsWork?: boolean | null, loadStrapped?: boolean | null, oilChecked?: boolean | null, tiresAiredBrakesWorking?: boolean | null, toolsLoaded?: boolean | null, vehicleConditionAcceptable?: boolean | null, vehicleFueled?: boolean | null, vehicleMilleage?: number | null, dailyFormVehicle?: { __typename?: 'DailyFormVehicle', id: string, name: string, dailyFormVehicleType?: { __typename?: 'DailyFormVehicleType', id: string, name: string } | null } | null, user?: { __typename?: 'User', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetDashboardMapDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomGetDashboardMapDataQuery = { __typename?: 'Query', getDashboardMapData: Array<{ __typename?: 'Job', id: string, status: JobStatus, jobPhases?: Array<{ __typename?: 'JobPhase', id: string, status: JobPhaseStatus, startsAt?: any | null, productName: string } | null> | null, proposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null } | null, address: { __typename?: 'ProposalAddress', latitude: string, longitude: string } } | null> };

export type CustomGetInvoicesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  status?: InputMaybe<InvoiceStatus>;
  jobStatuses?: InputMaybe<Array<JobStatus> | JobStatus>;
  isOverdue?: InputMaybe<Scalars['Boolean']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetInvoicesSortKey>;
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
}>;


export type CustomGetInvoicesQuery = { __typename?: 'Query', getInvoices: { __typename?: 'GetInvoicesResponse', data: Array<{ __typename?: 'Invoice', id: string, status: InvoiceStatus, isOverdue: boolean, sentAt?: any | null, job: { __typename?: 'Job', id: string, status: JobStatus, billingStatus?: JobBillingStatus | null, proposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null } | null, company: { __typename?: 'Company', id: string, name: string } } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, lastPage: number, perPage: number, total: number, hasMorePages: boolean } } };

export type CustomGetJobQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetJobQuery = { __typename?: 'Query', getJob: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualCostTransferTruck: string, actualProfitPercentage: number, datePushedToQuickbooks?: any | null, billingStatus?: JobBillingStatus | null, projectFilesFolderId?: string | null, proposalId: string, userId: string, invoiceId?: string | null, endsAt?: any | null, id: string, externalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedCostTransferTruck: string, proposedProfitPercentage: number, startsAt?: any | null, shouldPushTaxesToQuickbooks?: boolean | null, mayShowTaxNotification?: boolean | null, status: JobStatus, notes?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null, mapImage?: string | null }, company: { __typename?: 'Company', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, name: string, notes?: string | null, phone?: string | null, website?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, jobPhases?: Array<{ __typename?: 'JobPhase', id: string, externalId: string, ordering: number, actualCostAdditional: string, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualCostTransferTruck: string, hasJobCostsEntered: boolean, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingVariancePercent: number, jobCostingThresholdPercent: number, jobCostEntryDaysCount: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, address: string, applicableStatuses?: Array<string> | null, productName: string, endsAt?: any | null, jobDuration: number, jobSize: number, notes?: string | null, checklistNotes?: string | null, organizationProductTypeName?: string | null, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, proposedCostTransferTruck: string, startsAt?: any | null, status: JobPhaseStatus, costingMode: JobPhaseCostingMode, travelTimeEstimate?: number | null, usersColor?: string | null, worksheet?: { __typename?: 'Worksheet', name: string, scope?: string | null, scopeFormat?: string | null, quantity: string, unit: string, rate: string, pricingMethod: string, pricingOverrideField?: string | null, markup: string, overheadPercentage?: string | null, indirectPercentage?: string | null, fixedPrice: string, profitAmount?: string | null, areaSource: string, area?: string | null, areaUnit?: string | null, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', pricingMethod: string, markup: string, fixedPrice: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, sourceId?: string | null, sourceName?: string | null, name: string, category: string, jobSize?: string | null, jobSizeUnit?: string | null, hoursPerTruck?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckRateLoads?: string | null, quantity: string, unit: string, rate: string, calculation: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, thickness?: string | null, quantityOverride?: string | null }> } | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, showIndividualProducts: boolean } | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, transferTruckId?: string | null, quantity?: number | null, name: string, tonnage: number, rateTon: number, rateHourly: number, proposalPlantProductId?: string | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', unit: string, quantity: string, rate: string } | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, type: string, plant: { __typename?: 'ProposalPlant', id: string, name: string, plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null } | null> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, rate?: string | null, name?: string | null, type?: string | null, materialNeeded?: number | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', unit: string, quantity: string, rate: string } | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, type: string } | null }> | null, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', id: string, jobPhaseId: string, name: string, cost: number, percentage: number, quantity: number, rate: string }> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', id: string, quantity: number, rate: string, costTotal: string, plantId: string, plantProductId: string }> | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', id: string, jobPhaseCostItemId: string, name: string, costTotal: string, quantity: number, rate: string }> | null }>, checklistCompletion: { __typename?: 'ChecklistCompletion', ratio: string, allCompleted: boolean }, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, cost: number, id: string, feeAmount: number, feeType: AdditionalCostFeeType }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, foremanUser?: { __typename?: 'User', id: string, name: string, phone?: string | null } | null, job: { __typename?: 'Job', externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, userId: string, company: { __typename?: 'Company', id: string, name: string, phone?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, name: string, email: string, phone?: string | null, avatar?: string | null, status: UserStatus } | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, measurementJob?: ProductMeasurementJob | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, type: string, externalProductName?: string | null, materialNeeded?: number | null, materialNeededOverride?: number | null, productId?: string | null, statementOfWork?: string | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', id: string, equipmentPieceId?: string | null, name: string, quantity: number, quantityOverride?: number | null, rate: number, timeTravel: number, timeTravelOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null }> | null, crews?: Array<{ __typename?: 'ProposalCrew', id: string, crewId?: string | null, name: string, rate: number, timeOnjob: number, timeOnjobOverride?: number | null }> | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', id: string, additionalCostId?: string | null, name: string, cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, quantity?: number | null, quantityOverride?: number | null } | null> | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, transferTruckId: string, name: string, tonnage: number, quantity: number, trucksNeeded?: number | null, proposalPlantProductId?: string | null } | null> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean }>, organization: { __typename?: 'Organization', id: string, name: string, logo?: string | null }, crew?: { __typename?: 'Crew', id: string, color: string, displayName?: string | null } | null, users?: Array<{ __typename?: 'User', id: string }> | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', id: string, isCompleted: boolean, checklistItemId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string } }> } | null> | null, checklistItems?: Array<{ __typename?: 'JobPhaseChecklistItem', id: string, jobPhaseId?: string | null, isCompleted: boolean, checklistItemId?: string | null }> | null, proposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null } | null, proposal?: { __typename?: 'Proposal', id: string, isChangeOrder: boolean, status: ProposalStatus, costTaxes: string, overallTotalAfterTaxes: string, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, percentage: number }> | null } | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, changeOrderJobId?: string | null, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string }> | null } };

export type CustomGetJobCostingLapsedReportQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<JobStatus> | JobStatus>;
  jobsWithoutCosts?: InputMaybe<Scalars['Boolean']>;
  jobsInPast?: InputMaybe<Scalars['Boolean']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobCostingLapsedReportSortKey>;
}>;


export type CustomGetJobCostingLapsedReportQuery = { __typename?: 'Query', getJobCostingLapsedReport: { __typename?: 'GetJobCostingLapsedReportResponse', data: Array<{ __typename?: 'JobCostingLapsedReportJob', id: string, externalId: string, jobName: string, clientName: string, status: JobStatus, endsAt?: any | null, phaseMissingCost: boolean, allPhasesMissingCost: boolean, proposedOverallTotal: string, actualOverallTotal: string, varianceAmount: string, variancePercent: number, phases: Array<{ __typename?: 'JobCostingLapsedReportPhase', id: string, externalId: string, jobId: string, productType: string, status: JobPhaseStatus, endsAt?: any | null, missingCost: boolean, proposedOverallTotal: string, actualOverallTotal: string, varianceAmount: string, variancePercent: number }> }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', currentPage: number, perPage: number, total: number } } };

export type CustomGetJobDepositStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetJobDepositStatusQuery = { __typename?: 'Query', getJob: { __typename?: 'Job', id: string, billingStatus?: JobBillingStatus | null, depositCollectedAt?: any | null } };

export type CustomGetJobPhaseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetJobPhaseQuery = { __typename?: 'Query', getJobPhase: { __typename?: 'JobPhase', id: string, externalId: string, ordering: number, actualCostAdditional: string, actualSubcontractorCost?: string | null, actualSubcontractorName?: string | null, actualSubcontractorReference?: string | null, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualCostTransferTruck: string, hasJobCostsEntered: boolean, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingVariancePercent: number, jobCostingThresholdPercent: number, jobCostEntryDaysCount: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, address: string, applicableStatuses?: Array<string> | null, productName: string, endsAt?: any | null, jobDuration: number, jobSize: number, notes?: string | null, checklistNotes?: string | null, organizationProductTypeName?: string | null, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, proposedCostTransferTruck: string, startsAt?: any | null, status: JobPhaseStatus, costingMode: JobPhaseCostingMode, travelTimeEstimate?: number | null, usersColor?: string | null, worksheet?: { __typename?: 'Worksheet', name: string, scope?: string | null, scopeFormat?: string | null, quantity: string, unit: string, rate: string, pricingMethod: string, pricingOverrideField?: string | null, markup: string, overheadPercentage?: string | null, indirectPercentage?: string | null, fixedPrice: string, profitAmount?: string | null, areaSource: string, area?: string | null, areaUnit?: string | null, pricingBaseline?: { __typename?: 'WorksheetPricingBaseline', pricingMethod: string, markup: string, fixedPrice: string, profitAmount?: string | null } | null, rows: Array<{ __typename?: 'WorksheetRow', sourcePlantId?: string | null, sourcePlantName?: string | null, sourceType?: string | null, sourceId?: string | null, sourceName?: string | null, name: string, category: string, jobSize?: string | null, jobSizeUnit?: string | null, hoursPerTruck?: string | null, truckingUnit?: string | null, trucksNeeded?: string | null, truckCapacity?: string | null, truckRateHours?: string | null, truckRateTons?: string | null, truckRateYards?: string | null, truckRateLoads?: string | null, quantity: string, unit: string, rate: string, calculation: string, factor?: string | null, factorAreaUnit?: string | null, factorLabel?: string | null, thickness?: string | null, quantityOverride?: string | null }> } | null, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, showIndividualProducts: boolean } | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, transferTruckId?: string | null, quantity?: number | null, name: string, tonnage: number, rateTon: number, rateHourly: number, proposalPlantProductId?: string | null, worksheetBilling?: { __typename?: 'WorksheetTruckBilling', unit: string, quantity: string, rate: string } | null, proposalPlantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, type: string, plant: { __typename?: 'ProposalPlant', id: string, name: string, plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null } | null> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string } | null } | null, jobPhasePlants?: Array<{ __typename?: 'JobPhasePlant', id: string, rate?: string | null, name?: string | null, type?: string | null, materialNeeded?: number | null, worksheetMaterial?: { __typename?: 'WorksheetMaterialSnapshot', unit: string, quantity: string, rate: string } | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, type: string } | null }> | null, jobPhaseMaterialNoPlants?: Array<{ __typename?: 'JobPhaseMaterialNoPlant', id: string, jobPhaseId: string, name: string, cost: number, percentage: number, quantity: number, rate: string }> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', id: string, quantity: number, rate: string, costTotal: string, plantId: string, plantProductId: string }> | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', id: string, jobPhaseCostItemId: string, name: string, costTotal: string, quantity: number, rate: string }> | null }>, checklistCompletion: { __typename?: 'ChecklistCompletion', ratio: string, allCompleted: boolean }, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, cost: number, id: string, feeAmount: number, feeType: AdditionalCostFeeType }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, foremanUser?: { __typename?: 'User', id: string, name: string, phone?: string | null } | null, job: { __typename?: 'Job', externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, userId: string, company: { __typename?: 'Company', id: string, name: string, phone?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, name: string, email: string, phone?: string | null, avatar?: string | null, status: UserStatus } | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, measurementJob?: ProductMeasurementJob | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, type: string, externalProductName?: string | null, materialNeeded?: number | null, materialNeededOverride?: number | null, productId?: string | null, statementOfWork?: string | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', id: string, equipmentPieceId?: string | null, name: string, quantity: number, quantityOverride?: number | null, rate: number, timeTravel: number, timeTravelOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null }> | null, crews?: Array<{ __typename?: 'ProposalCrew', id: string, crewId?: string | null, name: string, rate: number, timeOnjob: number, timeOnjobOverride?: number | null }> | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', id: string, additionalCostId?: string | null, name: string, cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, quantity?: number | null, quantityOverride?: number | null } | null> | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, transferTruckId: string, name: string, tonnage: number, quantity: number, trucksNeeded?: number | null, proposalPlantProductId?: string | null } | null> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean }>, organization: { __typename?: 'Organization', id: string, name: string, logo?: string | null }, crew?: { __typename?: 'Crew', id: string, color: string, displayName?: string | null } | null, users?: Array<{ __typename?: 'User', id: string }> | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null }, checklistItems: Array<{ __typename?: 'JobPhaseChecklistItem', id: string, isCompleted: boolean, checklistItemId?: string | null, checklistItem: { __typename?: 'OrganizationProposalChecklistItem', id: string, name: string } }> } };

export type CustomGetJobPhaseCostItemQueryVariables = Exact<{
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
}>;


export type CustomGetJobPhaseCostItemQuery = { __typename?: 'Query', getJobPhaseCostItem?: { __typename?: 'JobPhaseCostItem', id: string, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, costTotal: number, cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, isSubcontractorCost: boolean, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, userId: string }, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, subscribed: boolean, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string }> | null }, proposalStage: { __typename?: 'ProposalStage', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal?: string | null, profit: string, profitPercentage: number }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number }> | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, proposalProduct: { __typename?: 'ProposalProduct', costEquipment: string, costMaterial: string, costTransferTruck: string, costLabour: string, costAdditional: string, costTotal: string, crews?: Array<{ __typename?: 'ProposalCrew', cost: string }> | null } }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, plants?: Array<{ __typename?: 'JobPhaseCostItemPlant', id: string, quantity: number, rate: string, costTotal: string, plantId: string, plantProductId: string }> | null, materialsNoPlants?: Array<{ __typename?: 'JobPhaseCostItemMaterialNoPlant', id: string, name: string, quantity: number, rate: string, costTotal: string, jobPhaseCostItemId: string }> | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, transferTruckId?: string | null, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number }> | null } | null };

export type CustomGetJobPhaseForDropdownLazyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetJobPhaseForDropdownLazyQuery = { __typename?: 'Query', getJobPhase: { __typename?: 'JobPhase', id: string, organizationProductTypeName?: string | null, address: string, startsAt?: any | null, endsAt?: any | null, proposalStage: { __typename?: 'ProposalStage', id: string, name?: string | null } } };

export type CustomGetJobPhasesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
}>;


export type CustomGetJobPhasesQuery = { __typename?: 'Query', getJobPhases: { __typename?: 'GetJobPhasesResponse', data: Array<{ __typename?: 'JobPhase', id: string, externalId: string, address: string, hasJobCostsEntered: boolean, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingVariancePercent: number, jobCostingThresholdPercent: number, jobCostEntryDaysCount: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, proposedCostTotal: string, actualCostTotal: string, productName: string, jobSize: number, travelTimeEstimate?: number | null, proposedMaterialNeeded: string, organizationProductTypeName?: string | null, startsAt?: any | null, jobDuration: number, proposalStage: { __typename?: 'ProposalStage', name?: string | null, distanceSeconds?: number | null }, foremanUser?: { __typename?: 'User', name: string } | null, organization: { __typename?: 'Organization', name: string }, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, id: string }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', name: string, id: string }>, crew?: { __typename?: 'Crew', name: string, displayName?: string | null } | null, job: { __typename?: 'Job', id: string, externalId: string, billingStatus?: JobBillingStatus | null, company: { __typename?: 'Company', name: string }, contact: { __typename?: 'Contact', firstName: string, lastName: string, phone?: string | null }, address: { __typename?: 'ProposalAddress', line1: string } } }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetJobPhasesForDropdownQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
}>;


export type CustomGetJobPhasesForDropdownQuery = { __typename?: 'Query', getJobPhases: { __typename?: 'GetJobPhasesResponse', data: Array<{ __typename?: 'JobPhase', id: string, externalId: string, address: string, productName: string, organizationProductTypeName?: string | null, proposalStage: { __typename?: 'ProposalStage', id: string, name?: string | null, distanceSeconds?: number | null }, job: { __typename?: 'Job', id: string, company: { __typename?: 'Company', id: string, name: string } } }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetJobPhasesScheduleBlocksQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date: Scalars['DateTime'];
}>;


export type CustomGetJobPhasesScheduleBlocksQuery = { __typename?: 'Query', getJobPhases: { __typename?: 'GetJobPhasesResponse', data: Array<{ __typename?: 'JobPhase', id: string, externalId: string, hasJobCostsEntered: boolean, jobCostingCompletionStatus: JobCostingCompletionStatus, jobCostingVariancePercent: number, jobCostingThresholdPercent: number, jobCostEntryDaysCount: number, lastJobCostEntryDate?: any | null, missingCostCategories: Array<string>, proposedCostTotal: string, actualCostTotal: string, productName: string, jobSize: number, travelTimeEstimate?: number | null, proposedMaterialNeeded: string, organizationProductTypeName?: string | null, startsAt?: any | null, jobDuration: number, proposalStage: { __typename?: 'ProposalStage', name?: string | null, distanceSeconds?: number | null }, foremanUser?: { __typename?: 'User', name: string } | null, organization: { __typename?: 'Organization', name: string }, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', name: string, id: string }>, crew?: { __typename?: 'Crew', name: string, displayName?: string | null } | null, job: { __typename?: 'Job', id: string, externalId: string, billingStatus?: JobBillingStatus | null, company: { __typename?: 'Company', name: string }, contact: { __typename?: 'Contact', firstName: string, lastName: string, phone?: string | null }, address: { __typename?: 'ProposalAddress', line1: string } }, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', scheduledAt: any, blockLength: number }> | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetJobSchedulesQueryVariables = Exact<{
  crewId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
}>;


export type CustomGetJobSchedulesQuery = { __typename?: 'Query', getJobSchedules: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', id: string, datePushedToQuickbooks?: any | null, status: JobStatus, userId: string, company: { __typename?: 'Company', name: string } }, jobPhase: { __typename?: 'JobPhase', id: string, productName: string, status: JobPhaseStatus, usersColor?: string | null, checklistCompletion: { __typename?: 'ChecklistCompletion', ratio: string, allCompleted: boolean }, proposalProduct: { __typename?: 'ProposalProduct', material: { __typename?: 'ProposalMaterial', id: string, name: string, productId?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', name: string } | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null }, foremanUser?: { __typename?: 'User', name: string } | null } }> };

export type CustomGetJobsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  statuses?: InputMaybe<Array<JobStatus> | JobStatus>;
  userId?: InputMaybe<Scalars['ID']>;
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
  cities?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CustomGetJobsQuery = { __typename?: 'Query', getJobs: { __typename?: 'GetJobsResponse', data: Array<{ __typename?: 'Job', actualOverallTotal: string, endsAt?: any | null, id: string, externalId: string, proposedOverallTotal: string, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, jobPhases?: Array<{ __typename?: 'JobPhase', id: string, externalId: string, applicableStatuses?: Array<string> | null, endsAt?: any | null, ordering: number, productName: string, startsAt?: any | null, status: JobPhaseStatus, organizationProductTypeName?: string | null, jobDuration: number, proposedOverallTotal: string, actualOverallTotal: string, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number } | null, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, name: string } | null, foremanUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null } | null, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', id: string, scheduledAt: any, endsAt: any, blockLength: number, showTravelTo: boolean, showTravelFrom: boolean, travelTime: number }> } | null> | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, name: string } | null, foremanUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'ProposalAddress', id: string, line1: string, city?: string | null, state?: string | null, latitude: string, longitude: string }, company: { __typename?: 'Company', id: string, name: string }, contact: { __typename?: 'Contact', firstName: string, id: string, lastName: string, phone?: string | null }, proposal?: { __typename?: 'Proposal', wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetJobsForDropdownQueryVariables = Exact<{
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  jobName?: InputMaybe<Scalars['String']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  statuses?: InputMaybe<Array<JobStatus> | JobStatus>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type CustomGetJobsForDropdownQuery = { __typename?: 'Query', getJobsSimple: { __typename?: 'GetJobsResponse', data: Array<{ __typename?: 'Job', id: string, externalId: string, company: { __typename?: 'Company', id: string, name: string }, proposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetMyTasksQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  all?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomGetMyTasksQuery = { __typename?: 'Query', getMyTasks?: { __typename?: 'TaskPaginator', data: Array<{ __typename?: 'Task', id: string, content: string, status: string, dueAt?: any | null, createdAt: any, updatedAt: any, completedAt?: any | null, triggerType?: string | null, triggerEvent?: string | null, notifiableType?: string | null, notifiableId?: string | null, notifiableExternalId?: string | null, assignedUser: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, email: string, permissions: Array<UserPermissions> }, company?: { __typename?: 'Company', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type CustomGetNotificationTriggerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetNotificationTriggerQuery = { __typename?: 'Query', getNotificationTrigger: { __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, smsContent?: string | null, taskContent?: string | null, emailSubject?: string | null, isApi?: boolean | null, apiUrl?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiHeaders?: string | null, apiSecret?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> } };

export type CustomGetNotificationTriggersQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomGetNotificationTriggersQuery = { __typename?: 'Query', getNotificationTriggers?: Array<{ __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, isTask?: boolean | null, smsContent?: string | null, taskContent?: string | null, emailSubject?: string | null, isApi?: boolean | null, apiUrl?: string | null, apiMethod?: string | null, apiPayload?: string | null, apiHeaders?: string | null, apiSecret?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> }> | null };

export type CustomGetOpportunitiesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contactName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['Date']>;
  first: Scalars['Int'];
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetOpportunitiesSortKey>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type CustomGetOpportunitiesQuery = { __typename?: 'Query', getOpportunities: { __typename?: 'GetOpportunitiesResponse', data: Array<{ __typename?: 'Opportunity', addressCity: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', id: string, name: string }, contact: { __typename?: 'Contact', firstName: string, id: string, lastName: string, phone?: string | null }, user?: { __typename?: 'User', firstName?: string | null, id: string, lastName?: string | null, name: string } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetOpportunityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, estimatedOpportunityValue?: number | null, projectFilesFolderId?: string | null, contactId: string, dueAt?: any | null, id: string, externalId: string, name: string, notes?: string | null, source?: OpportunitySource | null, status: string, statusId: string, userId?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', firstName: string, id: string, lastName: string }> }, products?: Array<{ __typename?: 'OrganizationProductType', id: string }> | null } | null };

export type CustomGetOrganizationEmailTemplateQueryVariables = Exact<{
  type: OrganizationEmailTemplateType;
}>;


export type CustomGetOrganizationEmailTemplateQuery = { __typename?: 'Query', getOrganizationEmailTemplate?: { __typename?: 'OrganizationEmailTemplate', type: OrganizationEmailTemplateType, html: string } | null };

export type CustomGetOrganizationEmailTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomGetOrganizationEmailTemplatesQuery = { __typename?: 'Query', getOrganizationEmailTemplates?: Array<{ __typename?: 'OrganizationEmailTemplate', type: OrganizationEmailTemplateType, html: string }> | null };

export type CustomGetOrganizationUsersQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  roles?: InputMaybe<Array<InputMaybe<UserRole>> | InputMaybe<UserRole>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
}>;


export type CustomGetOrganizationUsersQuery = { __typename?: 'Query', getOrganizationUsers?: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, name: string, email: string, roles: Array<UserRole>, status: UserStatus, hasEmployee: boolean, archivedAt?: any | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type CustomGetProductsQueryVariables = Exact<{
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QueryGetProductsOrderByOrderByClause> | QueryGetProductsOrderByOrderByClause>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProductType>;
}>;


export type CustomGetProductsQuery = { __typename?: 'Query', getProducts?: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', dailyUnitsComplete?: number | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, statementOfWork?: string | null, type: ProductType, subcontracted: boolean, unitPriceProduct: boolean, organizationProductType: { __typename?: 'OrganizationProductType', name: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type CustomGetProjectMapQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetProjectMapQuery = { __typename?: 'Query', getProjectMap: { __typename?: 'ProjectMap', id: string, name: string, mapData?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressCity?: string | null, addressState?: string | null, addressZip?: string | null, addressCountry?: string | null, latitude?: number | null, longitude?: number | null, measurements: Array<{ __typename?: 'ProjectMapMeasurement', id: string, geojsonFeatureId: string, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, productId?: string | null, isScreenshotTarget: boolean, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }> } };

export type CustomGetProjectMapsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetProjectMapsSortKey>;
}>;


export type CustomGetProjectMapsQuery = { __typename?: 'Query', getProjectMaps: { __typename?: 'GetProjectMapsResponse', data: Array<{ __typename?: 'ProjectMap', id: string, name: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetProposalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetProposalQuery = { __typename?: 'Query', getProposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, projectedCloseDate?: any | null, closeConfidence?: number | null, discount: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, externalIdWithPrefix: string, versionWithPrefix: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, updatedAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, proposalPdf?: string | null, pdfGeneratedAt?: any | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null, id: string }, contentSettings: Array<{ __typename?: 'ProposalContentSetting', id: string, proposalId: string, contentType: string, isEnabled: boolean }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, overallTotalAfterDiscount: string, distanceSeconds?: number | null, discount: string, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, checklistNotes?: string | null, ordering: number, stageMeasurements: Array<{ __typename?: 'ProposalStageMeasurement', id: string, geojsonFeatureId: string, measurementType: ProposalMeasurementType, measurementJob?: ProductMeasurementJob | null, measurementValue?: number | null, featureGeojson?: string | null, label?: string | null, sortOrder?: number | null, isScreenshotTarget: boolean, productId?: string | null, product?: { __typename?: 'Product', id: string, name: string, measurementJob?: ProductMeasurementJob | null, dailyUnitsComplete?: number | null } | null }>, checklistItems?: Array<{ __typename?: 'OrganizationProposalChecklistItem', id: string, name: string }> | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, discount: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterDiscount: string, overallTotalOverride?: string | null, ordering: number, proposalProductGroupId?: string | null, profit: string, profitAfterDiscount: string, profitOverride?: string | null, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, unitPriceOverride?: string | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', calculateTravelTime: boolean, chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, projectFiles?: Array<{ __typename?: 'ProjectFile', id: string, name: string, path?: string | null, pivot?: { __typename?: 'ProposalProductProjectFile', id: string } | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: string | null, costMaterialOverride?: string | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId?: string | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeAsphaltCurbing', curbHeight?: number | null, curbWidth?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, proposalPlantProducts?: Array<{ __typename?: 'ProposalPlantProduct', id: string, applicationRate?: number | null, applicationRateOverride?: number | null, areaCoverage?: number | null, costMaterial?: number | null, costTransferTruck?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, plantProductId: string, rate: number, rateOnWeight?: boolean | null, rateOverride?: number | null, transferTruckRoundTripTimeHrs?: number | null, transferTruckRoundTripTimeHrsOverride?: number | null, type: string, transferTruckLoadTimeBuffer?: number | null, transferTruckUnloadTimeBuffer?: number | null, plant: { __typename?: 'ProposalPlant', distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null }, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, proposalPlantProductId?: string | null, quantity: number, quantityOverride?: number | null, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null }> | null } | null> | null, proposalMaterialNoPlants?: Array<{ __typename?: 'ProposalMaterialNoPlant', id: string, name: string, percentage: number, cost: number, rate: number, quantity: number, quantityOverride?: number | null } | null> | null }> | null, proposalProductGroups: Array<{ __typename?: 'ProposalProductGroup', id: string, name: string, ordering: number, isOptional: boolean, proposalProducts: Array<{ __typename?: 'ProposalProduct', isCustom: boolean, id: string, ordering: number }> }>, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null, organization: { __typename?: 'Organization', id: string, proposalDefaults: { __typename?: 'ProposalDefault', id: string, estimateTruckingByFullDay: boolean, defaultTransferTruckId?: string | null, defaultLoadingTimeMins?: number | null, defaultUnloadTimeMins?: number | null, maxTripNumberPerTruck?: number | null, roundUpToNearestDollarAmount: boolean, color?: string | null, layout: ProposalLayout, autoSave?: boolean | null, startingNumber?: number | null, idPrefix?: string | null, removeUnitPriceAndQuantity: boolean, removeIndividualLineItemPricing: boolean } } } };

export type CustomGetProposalPackageSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetProposalPackageSummaryQuery = { __typename?: 'Query', getProposal: { __typename?: 'Proposal', id: string, isPackageParent: boolean, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', id: string, status: ProposalPackageSendRunStatus, totalRecipients: number, processedRecipients: number, succeededRecipients: number, failedRecipients: number, recipients: Array<{ __typename?: 'ProposalPackageSendRecipient', id: string, status: ProposalPackageSendRecipientStatus, proposalId?: string | null, errorMessage?: string | null, proposal?: { __typename?: 'Proposal', id: string, externalIdWithPrefix: string, status: ProposalStatus } | null, company: { __typename?: 'Company', id: string, name: string }, contact: { __typename?: 'Contact', id: string, firstName: string, lastName: string } }> } | null, packageChildren: Array<{ __typename?: 'Proposal', id: string, externalIdWithPrefix: string, status: ProposalStatus, sentAt?: any | null, signedAt?: any | null, company: { __typename?: 'Company', id: string, name: string }, contact: { __typename?: 'Contact', id: string, firstName: string, lastName: string } }> } };

export type CustomGetProposalsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  first: Scalars['Int'];
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetProposalsSortKey>;
  statuses?: InputMaybe<Array<ProposalStatus> | ProposalStatus>;
  userId?: InputMaybe<Scalars['ID']>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CustomGetProposalsQuery = { __typename?: 'Query', getProposals: { __typename?: 'GetProposalsResponse', data: Array<{ __typename?: 'Proposal', proposalRole: string, id: string, externalId: string, externalIdWithPrefix: string, status: ProposalStatus, overallTotal: string, userId?: string | null, uuid: string, createdAt: any, sentAt?: any | null, latestPackageSendRun?: { __typename?: 'ProposalPackageSendRun', status: ProposalPackageSendRunStatus, totalRecipients: number, processedRecipients: number } | null, company: { __typename?: 'Company', email: string, id: string, name: string }, contact: { __typename?: 'Contact', firstName: string, id: string, lastName: string, phone?: string | null }, user?: { __typename?: 'User', firstName?: string | null, id: string, lastName?: string | null, name: string } | null, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, overallTotal?: string | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', id: string, productName?: string | null }> | null }>, lastEvent?: { __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any, id: string } | null, lastStatusChange?: { __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetQuickbooksSyncJobsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type CustomGetQuickbooksSyncJobsQuery = { __typename?: 'Query', getJobs: { __typename?: 'GetJobsResponse', data: Array<{ __typename?: 'Job', id: string, externalId: string, proposedOverallTotal: string, proposalStage?: { __typename?: 'ProposalStage', name?: string | null } | null, jobPhases?: Array<{ __typename?: 'JobPhase', id: string, productName: string, proposedOverallTotal: string, proposalProductGroup?: { __typename?: 'ProposalProductGroup', id: string, name: string } | null, proposalProduct: { __typename?: 'ProposalProduct', productName?: string | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', name: string, externalProductName?: string | null, statementOfWork?: string | null } } } | null> | null }> } };

export type CustomGetTimeEntriesQueryVariables = Exact<{
  first: Scalars['Int'];
  forDate?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetTimeEntriesSortKey>;
  userId?: InputMaybe<Scalars['ID']>;
  forDateStart?: InputMaybe<Scalars['Date']>;
  forDateEnd?: InputMaybe<Scalars['Date']>;
}>;


export type CustomGetTimeEntriesQuery = { __typename?: 'Query', getTimeEntries: { __typename?: 'GetTimeEntriesResponse', data: Array<{ __typename?: 'TimeEntry', endTime?: any | null, forDate: any, id: string, clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', id: string, externalId: string, address: string, proposalStage: { __typename?: 'ProposalStage', id: string, name?: string | null }, job: { __typename?: 'Job', id: string, externalId: string } } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user?: { __typename?: 'User', firstName?: string | null, id: string, lastName?: string | null, name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetVehicleDailyFormWorkOrdersQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  vehicleId?: InputMaybe<Scalars['ID']>;
}>;


export type CustomGetVehicleDailyFormWorkOrdersQuery = { __typename?: 'Query', getDailyFormWorkOrders: { __typename?: 'GetDailyFormWorkOrdersResponse', data: Array<{ __typename?: 'DailyFormWorkOrder', id: string, issueName: string, status: DailyFormIssueStatus, neededCompletionDate?: any | null, completedAt?: any | null, currentMeterReading?: number | null, createdAt: any, assignedTo?: { __typename?: 'User', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomMeQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, permissions: Array<UserPermissions>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, subscribed: boolean, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, invoiceEmailText?: string | null, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, subscribed: boolean, trialEndsAt?: any | null, timezone?: string | null, subscription?: { __typename?: 'StripeSubscription', id: string } | null } } | null };

export const AiMappingRunAreaFragmentFragmentDoc = gql`
    fragment AiMappingRunAreaFragment on AiMappingRunArea {
  id
  name
  inputType
  coordinates
  status
  taskId
  currentVersion
  imageWidth
  imageHeight
  segmentationModel
  minSegAreaSqft
  minSegConf
  createdAt
  updatedAt
}
    `;
export const AiMappingResultsBundleFragmentFragmentDoc = gql`
    fragment AiMappingResultsBundleFragment on AiMappingRunAreaResultsResponse {
  area {
    ...AiMappingRunAreaFragment
  }
  detections {
    id
    version
    category
    bbox
    confidence
    color
    source
    isDeleted
  }
  segmentations {
    id
    version
    category
    polygon
    areaSqft
    color
    isDeleted
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;
export const CompanyFragmentFragmentDoc = gql`
    fragment CompanyFragment on Company {
  addressCity
  addressCountry
  addressLine1
  addressLine2
  addressState
  addressZip
  addCompanyInfo
  projectFilesFolderId
  contacts {
    SMSNotifications
    SMSNotificationsReadOnly
    email
    firstName
    id
    lastName
    phone
    primary
    role
    title
  }
  email
  id
  jobsCount
  name
  notes
  phone
  primaryContact {
    SMSNotifications
    SMSNotificationsReadOnly
    email
    firstName
    id
    lastName
    phone
    primary
    role
    title
  }
  proposalsCount
  website
  notificationTypes {
    CONTACT
    JOB
    JOB_PHASE
    OPPORTUNITY
    PROPOSAL
  }
  logo
  status
}
    `;
export const CustomEventFragmentFragmentDoc = gql`
    fragment CustomEventFragment on CustomEvent {
  color
  crew {
    color
    displayName
    id
    name
  }
  customEventBlocks {
    blockLength
    endsAt
    id
    scheduledAt
  }
  endsAt
  files {
    id
    name
    path
  }
  id
  name
  notes
  startsAt
  customEventsToUsers {
    user {
      id
    }
  }
}
    `;
export const JobPhaseFragmentFragmentDoc = gql`
    fragment JobPhaseFragment on JobPhase {
  id
  worksheet {
    name
    scope
    scopeFormat
    quantity
    unit
    rate
    pricingMethod
    pricingOverrideField
    markup
    overheadPercentage
    indirectPercentage
    fixedPrice
    profitAmount
    pricingBaseline {
      pricingMethod
      markup
      fixedPrice
      profitAmount
    }
    areaSource
    area
    areaUnit
    rows {
      sourcePlantId
      sourcePlantName
      sourceType
      sourceId
      sourceName
      name
      category
      jobSize
      jobSizeUnit
      hoursPerTruck
      truckingUnit
      trucksNeeded
      truckCapacity
      truckRateHours
      truckRateTons
      truckRateYards
      truckRateLoads
      quantity
      unit
      rate
      calculation
      factor
      factorAreaUnit
      factorLabel
      thickness
      quantityOverride
    }
  }
  externalId
  ordering
  proposalProductGroup {
    id
    name
    ordering
    isOptional
    showIndividualProducts
  }
  actualCostAdditional
  actualSubcontractorCost
  actualSubcontractorName
  actualSubcontractorReference
  actualCostDirect
  actualCostEquipment
  actualCostIndirect
  actualCostLabour
  actualCostMaterial
  actualCostOverhead
  actualCostTotal
  actualEmployeeHours
  actualGrossMargin
  actualGrossMarginPercentage
  actualMaterialNeeded
  actualNetMargin
  actualNetMarginPercentage
  actualOperatingMargin
  actualOperatingMarginPercentage
  actualOverallTotal
  actualProfit
  actualProfitPercentage
  actualCostTransferTruck
  hasJobCostsEntered
  jobCostingCompletionStatus
  jobCostingVariancePercent
  jobCostingThresholdPercent
  jobCostEntryDaysCount
  lastJobCostEntryDate
  missingCostCategories
  address
  applicableStatuses
  productName
  workOrderCrews {
    crewId
    id
    name
  }
  workOrderTransferTrucks {
    worksheetBilling {
      unit
      quantity
      rate
    }
    id
    transferTruckId
    quantity
    name
    tonnage
    rateTon
    rateHourly
    proposalPlantProductId
    proposalPlantProduct {
      id
      plantProductId
      type
      plant {
        id
        name
        plantId
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        addressCountry
      }
    }
  }
  jobPhasePlant {
    id
    plant {
      id
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      addressCountry
    }
    plantProduct {
      id
    }
    name
    type
  }
  jobPhasePlants {
    worksheetMaterial {
      unit
      quantity
      rate
    }
    id
    rate
    plant {
      id
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      addressCountry
    }
    plantProduct {
      id
      type
    }
    name
    type
    materialNeeded
  }
  jobPhaseMaterialNoPlants {
    id
    jobPhaseId
    name
    cost
    percentage
    quantity
    rate
  }
  workOrderEquipmentPieces {
    equipmentPieceId
    id
    name
  }
  costItems {
    date
    costMaterial
    costEquipment
    costLabour
    costAdditional
    costTransferTruck
    user {
      name
    }
    material {
      costMaterial
      id
      jobPhaseCostItem {
        id
        plantId
        plantProductId
      }
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    additionalCosts {
      additionalCostId
      cost
      costTotal
      feeAmount
      feeType
      id
      name
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    plants {
      id
      quantity
      rate
      costTotal
      plantId
      plantProductId
    }
    materialsNoPlants {
      id
      jobPhaseCostItemId
      name
      costTotal
      quantity
      rate
    }
    id
    plantId
    plantProductId
  }
  endsAt
  jobDuration
  jobSize
  notes
  checklistNotes
  organizationProductTypeName
  proposedCostAdditional
  proposedCostDirect
  proposedCostEquipment
  proposedCostIndirect
  proposedCostLabour
  proposedCostMaterial
  proposedCostOverhead
  proposedCostTotal
  proposedEmployeeHours
  proposedGrossMargin
  proposedGrossMarginPercentage
  proposedMaterialNeeded
  proposedNetMargin
  proposedNetMarginPercentage
  proposedOperatingMargin
  proposedOperatingMarginPercentage
  proposedOverallTotal
  proposedProfit
  proposedProfitPercentage
  proposedCostTransferTruck
  startsAt
  status
  costingMode
  travelTimeEstimate
  usersColor
  checklistCompletion {
    ratio
    allCompleted
  }
  files {
    createdAt
    filename
    id
    thumbnail
  }
  defaultEmployees {
    firstName
    id
    lastName
    name
    rate
  }
  defaultAdditionalCosts {
    name
    cost
    id
    feeAmount
    feeType
  }
  defaultEquipmentPieces {
    chargeType
    fuelSurcharge
    id
    name
    rate
    usePercentage
  }
  foremanUser {
    id
    name
    phone
  }
  job {
    externalId
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    endsAt
    id
    notes
    proposalId
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    startsAt
    status
    billingStatus
    userId
    company {
      id
      name
      phone
    }
    contact {
      email
      firstName
      id
      lastName
      phone
      title
    }
  }
  organizationProductType {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
  proposal {
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    grossMargin
    grossMarginPercentage
    id
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    profit
    profitPercentage
    signedAt
    signedInitials
    signedName
    source
    status
    userId
    uuid
    user {
      id
      firstName
      lastName
      name
      email
      phone
      avatar
      status
    }
  }
  proposalProduct {
    material {
      id
      name
      type
      externalProductName
      materialNeeded
      materialNeededOverride
      productId
      statementOfWork
    }
    plantProduct {
      type
      plantProductId
      plant {
        plantId
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        addressCountry
      }
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    grossMargin
    grossMarginPercentage
    id
    jobDuration
    jobSize
    mapData
    mapImage
    mapImageDirty
    measurementMaterial
    measurementJob
    netMargin
    netMarginPercentage
    notes
    operatingMargin
    operatingMarginPercentage
    overallTotal
    productName
    profit
    profitPercentage
    transferTruckLoadTimeBuffer
    transferTruckRoundTripTime
    transferTruckRoundTripTimeOverride
    transferTruckUnloadTimeBuffer
    statementOfWork
    files {
      createdAt
      filename
      id
      thumbnail
      type
    }
    equipmentPieces {
      id
      equipmentPieceId
      name
      quantity
      quantityOverride
      rate
      timeTravel
      timeTravelOverride
      timeOnjob
      timeOnjobOverride
    }
    crews {
      id
      crewId
      name
      rate
      timeOnjob
      timeOnjobOverride
    }
    additionalCosts {
      id
      additionalCostId
      name
      cost
      costOverride
      feeAmount
      feeAmountOverride
      quantity
      quantityOverride
    }
    transferTrucks {
      id
      transferTruckId
      name
      tonnage
      quantity
      trucksNeeded
      proposalPlantProductId
    }
  }
  scheduleBlocks {
    estimatedMaterialOverride
    estimatedMaterial
    blockLength
    endsAt
    id
    scheduledAt
    showTravelFrom
    showTravelTo
  }
  organization {
    id
    name
    logo
  }
  crew {
    id
    color
    displayName
  }
  users {
    id
  }
  proposalStage {
    name
  }
  checklistItems {
    id
    isCompleted
    checklistItemId
    checklistItem {
      id
      name
    }
  }
}
    `;
export const NotificationTriggerFragmentFragmentDoc = gql`
    fragment NotificationTriggerFragment on NotificationTrigger {
  id
  name
  active
  delay
  event
  type
  content
  sendToUser
  sendToAllRecipients
  sendToContact
  additionalRecipientTypes
  isEmail
  isSMS
  isTask
  smsContent
  taskContent
  emailSubject
  isApi
  apiUrl
  apiMethod
  apiPayload
  apiHeaders
  apiSecret
  additionalRecipients {
    id
    firstName
    lastName
  }
}
    `;
export const BitumioOrganizationEmailTemplateFragmentDoc = gql`
    fragment BitumioOrganizationEmailTemplate on OrganizationEmailTemplate {
  type
  html
}
    `;
export const UpdatedProductFragmentDoc = gql`
    fragment UpdatedProduct on Product {
  id
}
    `;
export const BitumioProposalStageFragmentDoc = gql`
    fragment BitumioProposalStage on ProposalStage {
  id
  name
  mapData
  mapImage
  overallTotal
  overallTotalAfterDiscount
  distanceSeconds
  discount
  roundTripTravelTimeHours
  addressOverride
  checklistNotes
  stageMeasurements {
    id
    geojsonFeatureId
    measurementType
    measurementJob
    measurementValue
    featureGeojson
    label
    sortOrder
    isScreenshotTarget
    productId
    product {
      id
      name
      measurementJob
      dailyUnitsComplete
    }
  }
  checklistItems {
    id
    name
  }
  proposalProducts {
    isCustom
    notes
    additionalCosts {
      cost
      costOverride
      feeAmount
      feeAmountOverride
      feeType
      id
      name
      costTotal
      quantity
      quantityOverride
      showOnProposal
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    costTransferTruck
    discount
    jobDurationOverride
    jobDurationDaysOverride
    roundTripTravelTimeHours
    crews {
      cost
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
    }
    equipmentPieces {
      calculateTravelTime
      chargeType
      cost
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
      usePercentage
    }
    files {
      createdAt
      filename
      id
      thumbnail
    }
    projectFiles {
      id
      name
      path
      pivot {
        id
      }
    }
    grossMargin
    grossMarginPercentage
    id
    jobDuration
    jobSize
    mapData
    mapImage
    mapImageDirty
    material {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
        ... on ProductAttributeConcreteFooting {
          width
          depth
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteColumn {
          height
          diameter
        }
      }
      attributesOverride {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
        ... on ProductAttributeConcreteFooting {
          width
          depth
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteColumn {
          height
          diameter
        }
      }
      costMaterial
      costMaterialOverride
      costMinimumProduct
      costMinimumProposal
      dailyUnitsComplete
      dailyUnitsCompleteOverride
      externalProductName
      id
      indirectPercentage
      indirectPercentageOverride
      labourCostType
      markupPercentage
      markupPercentageOverride
      materialNeeded
      materialNeededOverride
      measurementJob
      measurementMaterial
      organizationProductTypeName
      overheadPercentage
      overheadPercentageOverride
      productId
      proposalId
      proposalProductId
      proposalStageId
      statementOfWork
      statementOfWorkOverride
      tonConversionFactor
      tonConversionFactorOverride
      name
      type
      productionRateType
      subcontracted
      unitPriceProduct
      unitPrice
      unitPriceOverride
    }
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterDiscount
    overallTotalOverride
    ordering
    plantProduct {
      id
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOverride
      type
    }
    proposalPlantProducts {
      id
      applicationRate
      applicationRateOverride
      areaCoverage
      costMaterial
      costTransferTruck
      materialNeeded
      materialNeededOverride
      plant {
        distanceMeters
        distanceSeconds
        id
        name
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOnWeight
      rateOverride
      transferTruckRoundTripTimeHrs
      transferTruckRoundTripTimeHrsOverride
      type
      transferTrucks {
        id
        name
        plantTransferTruckId
        proposalPlantProductId
        quantity
        quantityOverride
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        transferTruckId
        trucksNeeded
        truckingProductionRate
        totalHaulingHours
        totalHaulingHoursOverride
        cost
        costOverride
      }
      transferTruckLoadTimeBuffer
      transferTruckUnloadTimeBuffer
      type
    }
    proposalMaterialNoPlants {
      id
      name
      percentage
      cost
      rate
      quantity
      quantityOverride
    }
    proposalProductGroupId
    profit
    profitAfterDiscount
    profitOverride
    profitPercentage
    profitPercentageOverride
    subcontractorCost
    subcontractorName
    subcontractorProposalId
    transferTruckRoundTripTime
    transferTruckRoundTripTimeOverride
    transferTruckUnloadTimeBuffer
    unitPriceOverride
    isOptional
  }
  proposalProductGroups {
    id
    name
    ordering
    isOptional
    proposalProducts {
      isCustom
      id
      ordering
    }
  }
  address {
    city
    country
    id
    latitude
    line1
    line2
    longitude
    organizationAddressId
    state
    zip
  }
  ordering
}
    `;
export const BitumioProposalFragmentDoc = gql`
    fragment BitumioProposal on Proposal {
  id
  uuid
  activeVersion
  company {
    id
    name
    contacts {
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
  }
  contact {
    firstName
    lastName
    email
    id
  }
  contentSettings {
    id
    proposalId
    contentType
    isEnabled
  }
  recipients {
    contactId
    email
    id
  }
  contactId
  status
  source
  projectedCloseDate
  closeConfidence
  discount
  stages {
    ...BitumioProposalStage
  }
  costAdditional
  costDirect
  costEquipment
  costIndirect
  costLabour
  costMaterial
  costOverhead
  costTotal
  grossMargin
  grossMarginPercentage
  id
  externalId
  externalIdWithPrefix
  versionWithPrefix
  isSendable
  layout
  netMargin
  netMarginPercentage
  operatingMargin
  operatingMarginPercentage
  overallTotal
  profit
  profitPercentage
  proposalNotes
  createdAt
  updatedAt
  removeUnitPriceAndQuantity
  removeIndividualLineItemPricing
  isChangeOrder
  user {
    id
    firstName
    lastName
    email
  }
  userId
  events {
    action
    createdAt
  }
  statusChanges {
    changeAt
    status
  }
  lastStatusChange {
    changeAt
    status
  }
  salesTaxes {
    id
    name
    percentage
    organizationSalesTaxId
  }
  costTaxes
  overallTotalAfterTaxes
  acceptanceOverride
  attachments {
    id
    name
    path
  }
  changeOrders {
    id
    externalId
    status
    overallTotalAfterTaxes
    changeOrderJobId
  }
  version
  changeOrderJobId
  projectFilesFolderId
  versions {
    id
    version
    externalId
    status
    overallTotalAfterTaxes
    activeVersion
  }
  clientEmailOverride
  emailSubjectOverride
  emailBodyOverride
  emailBodyOverrideParsed
  proposalPdf
  pdfGeneratedAt
  organization {
    id
    proposalDefaults {
      id
      estimateTruckingByFullDay
      defaultTransferTruckId
      defaultLoadingTimeMins
      defaultUnloadTimeMins
      maxTripNumberPerTruck
      roundUpToNearestDollarAmount
      color
      layout
      autoSave
      startingNumber
      idPrefix
      removeUnitPriceAndQuantity
      removeIndividualLineItemPricing
    }
  }
}
    ${BitumioProposalStageFragmentDoc}`;
export const CreateOrganizationApiKeyDocument = gql`
    mutation CreateOrganizationApiKey($description: String!) {
  CreateOrganizationApiKey(description: $description) {
    success
  }
}
    `;
export type CreateOrganizationApiKeyMutationFn = Apollo.MutationFunction<CreateOrganizationApiKeyMutation, CreateOrganizationApiKeyMutationVariables>;

/**
 * __useCreateOrganizationApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationApiKeyMutation, { data, loading, error }] = useCreateOrganizationApiKeyMutation({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateOrganizationApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationApiKeyMutation, CreateOrganizationApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationApiKeyMutation, CreateOrganizationApiKeyMutationVariables>(CreateOrganizationApiKeyDocument, options);
      }
export type CreateOrganizationApiKeyMutationHookResult = ReturnType<typeof useCreateOrganizationApiKeyMutation>;
export type CreateOrganizationApiKeyMutationResult = Apollo.MutationResult<CreateOrganizationApiKeyMutation>;
export type CreateOrganizationApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationApiKeyMutation, CreateOrganizationApiKeyMutationVariables>;
export const DeleteOrganizationApiKeyDocument = gql`
    mutation DeleteOrganizationApiKey($id: ID!) {
  DeleteOrganizationApiKey(id: $id) {
    success
  }
}
    `;
export type DeleteOrganizationApiKeyMutationFn = Apollo.MutationFunction<DeleteOrganizationApiKeyMutation, DeleteOrganizationApiKeyMutationVariables>;

/**
 * __useDeleteOrganizationApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationApiKeyMutation, { data, loading, error }] = useDeleteOrganizationApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationApiKeyMutation, DeleteOrganizationApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationApiKeyMutation, DeleteOrganizationApiKeyMutationVariables>(DeleteOrganizationApiKeyDocument, options);
      }
export type DeleteOrganizationApiKeyMutationHookResult = ReturnType<typeof useDeleteOrganizationApiKeyMutation>;
export type DeleteOrganizationApiKeyMutationResult = Apollo.MutationResult<DeleteOrganizationApiKeyMutation>;
export type DeleteOrganizationApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationApiKeyMutation, DeleteOrganizationApiKeyMutationVariables>;
export const AcceptUserInviteDocument = gql`
    mutation acceptUserInvite($input: AcceptUserInviteInput!) {
  acceptUserInvite(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    archivedAt
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    salesGoal
    status
  }
}
    `;
export type AcceptUserInviteMutationFn = Apollo.MutationFunction<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>;

/**
 * __useAcceptUserInviteMutation__
 *
 * To run a mutation, you first call `useAcceptUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUserInviteMutation, { data, loading, error }] = useAcceptUserInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>(AcceptUserInviteDocument, options);
      }
export type AcceptUserInviteMutationHookResult = ReturnType<typeof useAcceptUserInviteMutation>;
export type AcceptUserInviteMutationResult = Apollo.MutationResult<AcceptUserInviteMutation>;
export type AcceptUserInviteMutationOptions = Apollo.BaseMutationOptions<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>;
export const AddJobPhaseCostsDocument = gql`
    mutation addJobPhaseCosts($input: AddJobPhaseCostsInput!) {
  addJobPhaseCosts(input: $input) {
    additionalCosts {
      additionalCostId
      cost
      costTotal
      feeAmount
      feeType
      id
      isSubcontractorCost
      jobPhaseCostItem {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          isSubcontractorCost
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        materialsNoPlants {
          costTotal
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          jobPhaseCostItemId
          name
          quantity
          rate
        }
        plantId
        plantProductId
        plants {
          costTotal
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantId
          plantProduct {
            id
            plantId
            rate
            type
          }
          plantProductId
          quantity
          rate
        }
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
      }
      name
    }
    costAdditional
    costEquipment
    costLabour
    costMaterial
    costTransferTruck
    date
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistNotes
      costingMode
      crewId
      endsAt
      externalId
      hasJobCostsEntered
      id
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    material {
      costMaterial
      id
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    materialsNoPlants {
      costTotal
      id
      jobPhaseCostItemId
      name
      quantity
      rate
    }
    plantId
    plantProductId
    plants {
      costTotal
      id
      plantId
      plantProductId
      quantity
      rate
    }
    transferTrucks {
      hours
      id
      name
      plantTransferTruckId
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
  }
}
    `;
export type AddJobPhaseCostsMutationFn = Apollo.MutationFunction<AddJobPhaseCostsMutation, AddJobPhaseCostsMutationVariables>;

/**
 * __useAddJobPhaseCostsMutation__
 *
 * To run a mutation, you first call `useAddJobPhaseCostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJobPhaseCostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJobPhaseCostsMutation, { data, loading, error }] = useAddJobPhaseCostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddJobPhaseCostsMutation(baseOptions?: Apollo.MutationHookOptions<AddJobPhaseCostsMutation, AddJobPhaseCostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJobPhaseCostsMutation, AddJobPhaseCostsMutationVariables>(AddJobPhaseCostsDocument, options);
      }
export type AddJobPhaseCostsMutationHookResult = ReturnType<typeof useAddJobPhaseCostsMutation>;
export type AddJobPhaseCostsMutationResult = Apollo.MutationResult<AddJobPhaseCostsMutation>;
export type AddJobPhaseCostsMutationOptions = Apollo.BaseMutationOptions<AddJobPhaseCostsMutation, AddJobPhaseCostsMutationVariables>;
export const AddJobPhaseFileDocument = gql`
    mutation addJobPhaseFile($jobPhaseId: ID!, $path: String!) {
  addJobPhaseFile(jobPhaseId: $jobPhaseId, path: $path) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    actualSubcontractorCost
    actualSubcontractorName
    actualSubcontractorReference
    address
    applicableStatuses
    checklistCompletion {
      allCompleted
      ratio
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    checklistNotes
    costItems {
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      id
      plantId
      plantProductId
    }
    costingMode
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      calculateTravelTime
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    hasJobCostsEntered
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      id
      invoiceId
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    jobCostEntryDaysCount
    jobCostingCompletionStatus
    jobCostingThresholdPercent
    jobCostingVariancePercent
    jobDuration
    jobPhaseMaterialNoPlants {
      cost
      id
      jobPhaseId
      name
      percentage
      quantity
      rate
    }
    jobPhasePlant {
      id
      materialNeeded
      name
      rate
      type
    }
    jobPhasePlants {
      id
      materialNeeded
      name
      rate
      type
    }
    jobSize
    lastJobCostEntryDate
    missingCostCategories
    notes
    ordering
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      showIndividualProducts
    }
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      proposalPlantProductId
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;
export type AddJobPhaseFileMutationFn = Apollo.MutationFunction<AddJobPhaseFileMutation, AddJobPhaseFileMutationVariables>;

/**
 * __useAddJobPhaseFileMutation__
 *
 * To run a mutation, you first call `useAddJobPhaseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJobPhaseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJobPhaseFileMutation, { data, loading, error }] = useAddJobPhaseFileMutation({
 *   variables: {
 *      jobPhaseId: // value for 'jobPhaseId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAddJobPhaseFileMutation(baseOptions?: Apollo.MutationHookOptions<AddJobPhaseFileMutation, AddJobPhaseFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJobPhaseFileMutation, AddJobPhaseFileMutationVariables>(AddJobPhaseFileDocument, options);
      }
export type AddJobPhaseFileMutationHookResult = ReturnType<typeof useAddJobPhaseFileMutation>;
export type AddJobPhaseFileMutationResult = Apollo.MutationResult<AddJobPhaseFileMutation>;
export type AddJobPhaseFileMutationOptions = Apollo.BaseMutationOptions<AddJobPhaseFileMutation, AddJobPhaseFileMutationVariables>;
export const AddMaterialNoPlantToProposalProductDocument = gql`
    mutation addMaterialNoPlantToProposalProduct($input: AddMaterialNoPlantToProposalProductInput!) {
  addMaterialNoPlantToProposalProduct(input: $input) {
    cost
    id
    name
    percentage
    proposalProductId
    quantity
    quantityOverride
    rate
  }
}
    `;
export type AddMaterialNoPlantToProposalProductMutationFn = Apollo.MutationFunction<AddMaterialNoPlantToProposalProductMutation, AddMaterialNoPlantToProposalProductMutationVariables>;

/**
 * __useAddMaterialNoPlantToProposalProductMutation__
 *
 * To run a mutation, you first call `useAddMaterialNoPlantToProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMaterialNoPlantToProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMaterialNoPlantToProposalProductMutation, { data, loading, error }] = useAddMaterialNoPlantToProposalProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMaterialNoPlantToProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<AddMaterialNoPlantToProposalProductMutation, AddMaterialNoPlantToProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMaterialNoPlantToProposalProductMutation, AddMaterialNoPlantToProposalProductMutationVariables>(AddMaterialNoPlantToProposalProductDocument, options);
      }
export type AddMaterialNoPlantToProposalProductMutationHookResult = ReturnType<typeof useAddMaterialNoPlantToProposalProductMutation>;
export type AddMaterialNoPlantToProposalProductMutationResult = Apollo.MutationResult<AddMaterialNoPlantToProposalProductMutation>;
export type AddMaterialNoPlantToProposalProductMutationOptions = Apollo.BaseMutationOptions<AddMaterialNoPlantToProposalProductMutation, AddMaterialNoPlantToProposalProductMutationVariables>;
export const AddOrganizationDataUploadDocument = gql`
    mutation addOrganizationDataUpload($input: AddOrganizationDataUploadInput!) {
  addOrganizationDataUpload(input: $input) {
    createdAt
    error
    id
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    path
    startedAt
    status
    type
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
  }
}
    `;
export type AddOrganizationDataUploadMutationFn = Apollo.MutationFunction<AddOrganizationDataUploadMutation, AddOrganizationDataUploadMutationVariables>;

/**
 * __useAddOrganizationDataUploadMutation__
 *
 * To run a mutation, you first call `useAddOrganizationDataUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationDataUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationDataUploadMutation, { data, loading, error }] = useAddOrganizationDataUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationDataUploadMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationDataUploadMutation, AddOrganizationDataUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationDataUploadMutation, AddOrganizationDataUploadMutationVariables>(AddOrganizationDataUploadDocument, options);
      }
export type AddOrganizationDataUploadMutationHookResult = ReturnType<typeof useAddOrganizationDataUploadMutation>;
export type AddOrganizationDataUploadMutationResult = Apollo.MutationResult<AddOrganizationDataUploadMutation>;
export type AddOrganizationDataUploadMutationOptions = Apollo.BaseMutationOptions<AddOrganizationDataUploadMutation, AddOrganizationDataUploadMutationVariables>;
export const AddOrganizationDocumentDocument = gql`
    mutation addOrganizationDocument($name: String!, $path: String!) {
  addOrganizationDocument(name: $name, path: $path) {
    canMapWithAi
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    invoiceEmailText
    invoicingPaymentTermsNet
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    organizationSalesGoal
    phone
    proposalDefaults {
      autoSave
      color
      defaultLoadingTimeMins
      defaultTransferTruckId
      defaultUnloadTimeMins
      estimateTruckingByFullDay
      id
      idPrefix
      layout
      maxTripNumberPerTruck
      minimumProfitPerDay
      multiplyTravelTimeByDay
      multiplyTravelTimeForEquipmentLabour
      optionalCheckboxDefaultChecked
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      roundUpToNearestDollarAmount
      startingNumber
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type AddOrganizationDocumentMutationFn = Apollo.MutationFunction<AddOrganizationDocumentMutation, AddOrganizationDocumentMutationVariables>;

/**
 * __useAddOrganizationDocumentMutation__
 *
 * To run a mutation, you first call `useAddOrganizationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationDocumentMutation, { data, loading, error }] = useAddOrganizationDocumentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAddOrganizationDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationDocumentMutation, AddOrganizationDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationDocumentMutation, AddOrganizationDocumentMutationVariables>(AddOrganizationDocumentDocument, options);
      }
export type AddOrganizationDocumentMutationHookResult = ReturnType<typeof useAddOrganizationDocumentMutation>;
export type AddOrganizationDocumentMutationResult = Apollo.MutationResult<AddOrganizationDocumentMutation>;
export type AddOrganizationDocumentMutationOptions = Apollo.BaseMutationOptions<AddOrganizationDocumentMutation, AddOrganizationDocumentMutationVariables>;
export const AddPlantProductToProposalProductDocument = gql`
    mutation addPlantProductToProposalProduct($input: AddPlantProductToProposalProductInput!) {
  addPlantProductToProposalProduct(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddPlantProductToProposalProductMutationFn = Apollo.MutationFunction<AddPlantProductToProposalProductMutation, AddPlantProductToProposalProductMutationVariables>;

/**
 * __useAddPlantProductToProposalProductMutation__
 *
 * To run a mutation, you first call `useAddPlantProductToProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlantProductToProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlantProductToProposalProductMutation, { data, loading, error }] = useAddPlantProductToProposalProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlantProductToProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<AddPlantProductToProposalProductMutation, AddPlantProductToProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlantProductToProposalProductMutation, AddPlantProductToProposalProductMutationVariables>(AddPlantProductToProposalProductDocument, options);
      }
export type AddPlantProductToProposalProductMutationHookResult = ReturnType<typeof useAddPlantProductToProposalProductMutation>;
export type AddPlantProductToProposalProductMutationResult = Apollo.MutationResult<AddPlantProductToProposalProductMutation>;
export type AddPlantProductToProposalProductMutationOptions = Apollo.BaseMutationOptions<AddPlantProductToProposalProductMutation, AddPlantProductToProposalProductMutationVariables>;
export const AddProductsToProposalStageDocument = gql`
    mutation addProductsToProposalStage($input: AddProductsToProposalStageInput!) {
  addProductsToProposalStage(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProductsToProposalStageMutationFn = Apollo.MutationFunction<AddProductsToProposalStageMutation, AddProductsToProposalStageMutationVariables>;

/**
 * __useAddProductsToProposalStageMutation__
 *
 * To run a mutation, you first call `useAddProductsToProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToProposalStageMutation, { data, loading, error }] = useAddProductsToProposalStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductsToProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<AddProductsToProposalStageMutation, AddProductsToProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductsToProposalStageMutation, AddProductsToProposalStageMutationVariables>(AddProductsToProposalStageDocument, options);
      }
export type AddProductsToProposalStageMutationHookResult = ReturnType<typeof useAddProductsToProposalStageMutation>;
export type AddProductsToProposalStageMutationResult = Apollo.MutationResult<AddProductsToProposalStageMutation>;
export type AddProductsToProposalStageMutationOptions = Apollo.BaseMutationOptions<AddProductsToProposalStageMutation, AddProductsToProposalStageMutationVariables>;
export const AddProjectFileDocument = gql`
    mutation addProjectFile($name: String!, $parentFolderId: ID, $path: String!) {
  addProjectFile(name: $name, parentFolderId: $parentFolderId, path: $path) {
    children {
      children {
        createdAt
        fileSizeBytes
        id
        name
        parentFolderId
        path
        pivot {
          id
        }
        type
      }
      createdAt
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    createdAt
    fileSizeBytes
    id
    name
    parentFolderId
    path
    pivot {
      id
    }
    type
  }
}
    `;
export type AddProjectFileMutationFn = Apollo.MutationFunction<AddProjectFileMutation, AddProjectFileMutationVariables>;

/**
 * __useAddProjectFileMutation__
 *
 * To run a mutation, you first call `useAddProjectFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectFileMutation, { data, loading, error }] = useAddProjectFileMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parentFolderId: // value for 'parentFolderId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAddProjectFileMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectFileMutation, AddProjectFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectFileMutation, AddProjectFileMutationVariables>(AddProjectFileDocument, options);
      }
export type AddProjectFileMutationHookResult = ReturnType<typeof useAddProjectFileMutation>;
export type AddProjectFileMutationResult = Apollo.MutationResult<AddProjectFileMutation>;
export type AddProjectFileMutationOptions = Apollo.BaseMutationOptions<AddProjectFileMutation, AddProjectFileMutationVariables>;
export const AddProposalAdditionalCostDocument = gql`
    mutation addProposalAdditionalCost($additionalCostId: ID!, $proposalProductId: ID!) {
  addProposalAdditionalCost(
    additionalCostId: $additionalCostId
    proposalProductId: $proposalProductId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalAdditionalCostMutationFn = Apollo.MutationFunction<AddProposalAdditionalCostMutation, AddProposalAdditionalCostMutationVariables>;

/**
 * __useAddProposalAdditionalCostMutation__
 *
 * To run a mutation, you first call `useAddProposalAdditionalCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalAdditionalCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalAdditionalCostMutation, { data, loading, error }] = useAddProposalAdditionalCostMutation({
 *   variables: {
 *      additionalCostId: // value for 'additionalCostId'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalAdditionalCostMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalAdditionalCostMutation, AddProposalAdditionalCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalAdditionalCostMutation, AddProposalAdditionalCostMutationVariables>(AddProposalAdditionalCostDocument, options);
      }
export type AddProposalAdditionalCostMutationHookResult = ReturnType<typeof useAddProposalAdditionalCostMutation>;
export type AddProposalAdditionalCostMutationResult = Apollo.MutationResult<AddProposalAdditionalCostMutation>;
export type AddProposalAdditionalCostMutationOptions = Apollo.BaseMutationOptions<AddProposalAdditionalCostMutation, AddProposalAdditionalCostMutationVariables>;
export const AddProposalAdditionalCostsDocument = gql`
    mutation addProposalAdditionalCosts($additionalCosts: [ID!]!, $proposalProductId: ID!) {
  addProposalAdditionalCosts(
    additionalCosts: $additionalCosts
    proposalProductId: $proposalProductId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalAdditionalCostsMutationFn = Apollo.MutationFunction<AddProposalAdditionalCostsMutation, AddProposalAdditionalCostsMutationVariables>;

/**
 * __useAddProposalAdditionalCostsMutation__
 *
 * To run a mutation, you first call `useAddProposalAdditionalCostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalAdditionalCostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalAdditionalCostsMutation, { data, loading, error }] = useAddProposalAdditionalCostsMutation({
 *   variables: {
 *      additionalCosts: // value for 'additionalCosts'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalAdditionalCostsMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalAdditionalCostsMutation, AddProposalAdditionalCostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalAdditionalCostsMutation, AddProposalAdditionalCostsMutationVariables>(AddProposalAdditionalCostsDocument, options);
      }
export type AddProposalAdditionalCostsMutationHookResult = ReturnType<typeof useAddProposalAdditionalCostsMutation>;
export type AddProposalAdditionalCostsMutationResult = Apollo.MutationResult<AddProposalAdditionalCostsMutation>;
export type AddProposalAdditionalCostsMutationOptions = Apollo.BaseMutationOptions<AddProposalAdditionalCostsMutation, AddProposalAdditionalCostsMutationVariables>;
export const AddProposalAddressDocument = gql`
    mutation addProposalAddress($input: AddProposalAddressInput!) {
  addProposalAddress(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalAddressMutationFn = Apollo.MutationFunction<AddProposalAddressMutation, AddProposalAddressMutationVariables>;

/**
 * __useAddProposalAddressMutation__
 *
 * To run a mutation, you first call `useAddProposalAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalAddressMutation, { data, loading, error }] = useAddProposalAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProposalAddressMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalAddressMutation, AddProposalAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalAddressMutation, AddProposalAddressMutationVariables>(AddProposalAddressDocument, options);
      }
export type AddProposalAddressMutationHookResult = ReturnType<typeof useAddProposalAddressMutation>;
export type AddProposalAddressMutationResult = Apollo.MutationResult<AddProposalAddressMutation>;
export type AddProposalAddressMutationOptions = Apollo.BaseMutationOptions<AddProposalAddressMutation, AddProposalAddressMutationVariables>;
export const AddProposalCrewDocument = gql`
    mutation addProposalCrew($crewId: ID!, $proposalProductId: ID!) {
  addProposalCrew(crewId: $crewId, proposalProductId: $proposalProductId) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalCrewMutationFn = Apollo.MutationFunction<AddProposalCrewMutation, AddProposalCrewMutationVariables>;

/**
 * __useAddProposalCrewMutation__
 *
 * To run a mutation, you first call `useAddProposalCrewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalCrewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalCrewMutation, { data, loading, error }] = useAddProposalCrewMutation({
 *   variables: {
 *      crewId: // value for 'crewId'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalCrewMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalCrewMutation, AddProposalCrewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalCrewMutation, AddProposalCrewMutationVariables>(AddProposalCrewDocument, options);
      }
export type AddProposalCrewMutationHookResult = ReturnType<typeof useAddProposalCrewMutation>;
export type AddProposalCrewMutationResult = Apollo.MutationResult<AddProposalCrewMutation>;
export type AddProposalCrewMutationOptions = Apollo.BaseMutationOptions<AddProposalCrewMutation, AddProposalCrewMutationVariables>;
export const AddProposalCrewsDocument = gql`
    mutation addProposalCrews($crewIds: [ID!]!, $proposalProductId: ID!) {
  addProposalCrews(crewIds: $crewIds, proposalProductId: $proposalProductId) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalCrewsMutationFn = Apollo.MutationFunction<AddProposalCrewsMutation, AddProposalCrewsMutationVariables>;

/**
 * __useAddProposalCrewsMutation__
 *
 * To run a mutation, you first call `useAddProposalCrewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalCrewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalCrewsMutation, { data, loading, error }] = useAddProposalCrewsMutation({
 *   variables: {
 *      crewIds: // value for 'crewIds'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalCrewsMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalCrewsMutation, AddProposalCrewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalCrewsMutation, AddProposalCrewsMutationVariables>(AddProposalCrewsDocument, options);
      }
export type AddProposalCrewsMutationHookResult = ReturnType<typeof useAddProposalCrewsMutation>;
export type AddProposalCrewsMutationResult = Apollo.MutationResult<AddProposalCrewsMutation>;
export type AddProposalCrewsMutationOptions = Apollo.BaseMutationOptions<AddProposalCrewsMutation, AddProposalCrewsMutationVariables>;
export const AddProposalEquipmentPieceDocument = gql`
    mutation addProposalEquipmentPiece($equipmentPieceId: ID!, $proposalProductId: ID!, $quantity: Float!) {
  addProposalEquipmentPiece(
    equipmentPieceId: $equipmentPieceId
    proposalProductId: $proposalProductId
    quantity: $quantity
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalEquipmentPieceMutationFn = Apollo.MutationFunction<AddProposalEquipmentPieceMutation, AddProposalEquipmentPieceMutationVariables>;

/**
 * __useAddProposalEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useAddProposalEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalEquipmentPieceMutation, { data, loading, error }] = useAddProposalEquipmentPieceMutation({
 *   variables: {
 *      equipmentPieceId: // value for 'equipmentPieceId'
 *      proposalProductId: // value for 'proposalProductId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useAddProposalEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalEquipmentPieceMutation, AddProposalEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalEquipmentPieceMutation, AddProposalEquipmentPieceMutationVariables>(AddProposalEquipmentPieceDocument, options);
      }
export type AddProposalEquipmentPieceMutationHookResult = ReturnType<typeof useAddProposalEquipmentPieceMutation>;
export type AddProposalEquipmentPieceMutationResult = Apollo.MutationResult<AddProposalEquipmentPieceMutation>;
export type AddProposalEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<AddProposalEquipmentPieceMutation, AddProposalEquipmentPieceMutationVariables>;
export const AddProposalEquipmentPiecesDocument = gql`
    mutation addProposalEquipmentPieces($equipmentPieces: [AddProposalEquipmentPieceInput!]!, $proposalProductId: ID!) {
  addProposalEquipmentPieces(
    equipmentPieces: $equipmentPieces
    proposalProductId: $proposalProductId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalEquipmentPiecesMutationFn = Apollo.MutationFunction<AddProposalEquipmentPiecesMutation, AddProposalEquipmentPiecesMutationVariables>;

/**
 * __useAddProposalEquipmentPiecesMutation__
 *
 * To run a mutation, you first call `useAddProposalEquipmentPiecesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalEquipmentPiecesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalEquipmentPiecesMutation, { data, loading, error }] = useAddProposalEquipmentPiecesMutation({
 *   variables: {
 *      equipmentPieces: // value for 'equipmentPieces'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalEquipmentPiecesMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalEquipmentPiecesMutation, AddProposalEquipmentPiecesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalEquipmentPiecesMutation, AddProposalEquipmentPiecesMutationVariables>(AddProposalEquipmentPiecesDocument, options);
      }
export type AddProposalEquipmentPiecesMutationHookResult = ReturnType<typeof useAddProposalEquipmentPiecesMutation>;
export type AddProposalEquipmentPiecesMutationResult = Apollo.MutationResult<AddProposalEquipmentPiecesMutation>;
export type AddProposalEquipmentPiecesMutationOptions = Apollo.BaseMutationOptions<AddProposalEquipmentPiecesMutation, AddProposalEquipmentPiecesMutationVariables>;
export const AddProposalFileDocument = gql`
    mutation addProposalFile($path: String!, $proposalProductId: ID!) {
  addProposalFile(path: $path, proposalProductId: $proposalProductId) {
    additionalCosts {
      additionalCostId
      cost
      costOverride
      costTotal
      feeAmount
      feeAmountOverride
      feeType
      id
      name
      quantity
      quantityOverride
      showOnProposal
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    costTransferTruck
    crews {
      cost
      crewId
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
    }
    custom {
      area
      areaSource
      areaUnit
      calculationVersion
      costTotal
      fixedPrice
      helpers {
        hoursPerDay
        production {
          enabled
          materialRowId
          period
          quantity
          rate
          source
          unit
        }
        travel {
          enabled
          roundTripHours
          visits
        }
      }
      indirectPercentage
      internalName
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricing {
        discount
        mode
        value
        version
      }
      pricingBaseline {
        fixedPrice
        markup
        pricing {
          discount
          mode
          value
          version
        }
        pricingMethod
        profitAmount
      }
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      rows {
        calculatedQuantity
        calculation
        category
        factor
        factorAreaUnit
        factorLabel
        formula
        hauling {
          allocationPercent
          capacity
          capacityUnit
          fullLoads
          haulQuantity
          haulUnit
          loadHours
          materialRowId
          maxTripsPerDay
          planningEnabled
          planningHours
          quantityMode
          roundTripHours
          unloadHours
        }
        hoursPerTruck
        jobSize
        jobSizeUnit
        name
        quantity
        quantityOverride
        quantitySource
        rate
        rowId
        sourceId
        sourceName
        sourcePlantId
        sourcePlantName
        sourceType
        thickness
        total
        truckCapacity
        truckRateHours
        truckRateLoads
        truckRateTons
        truckRateYards
        truckingUnit
        trucksNeeded
        unit
      }
      scope
      scopeFormat
      sellingTotal
      sourceProductId
      sourceProductRevision
      unit
    }
    discount
    equipmentPieces {
      calculateTravelTime
      chargeType
      cost
      equipmentPieceId
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
      usePercentage
    }
    externalProductName
    files {
      createdAt
      filename
      id
      thumbnail
      type
    }
    grossMargin
    grossMarginPercentage
    id
    isCustom
    isOptional
    jobDuration
    jobDurationDaysOverride
    jobDurationOverride
    jobSize
    mapData
    mapImage
    mapImageDirty
    material {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      attributesOverride {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMaterialOverride
      costMinimumProduct
      costMinimumProposal
      dailyUnitsComplete
      dailyUnitsCompleteOverride
      externalProductName
      id
      indirectPercentage
      indirectPercentageOverride
      labourCostType
      markupPercentage
      markupPercentageOverride
      materialNeeded
      materialNeededOverride
      measurementJob
      measurementMaterial
      name
      organizationProductTypeName
      overheadPercentage
      overheadPercentageOverride
      productId
      productionRateType
      proposalId
      proposalProductId
      proposalStageId
      statementOfWork
      statementOfWorkOverride
      subcontracted
      tonConversionFactor
      tonConversionFactorOverride
      type
      unitPrice
      unitPriceOverride
      unitPriceProduct
    }
    measurementJob
    measurementMaterial
    netMargin
    netMarginPercentage
    notes
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalAfterDiscount
    overallTotalOverride
    plantProduct {
      applicationRate
      applicationRateOverride
      areaCoverage
      costMaterial
      costTransferTruck
      id
      materialNeeded
      materialNeededOverride
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOnWeight
      rateOverride
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTimeHrs
      transferTruckRoundTripTimeHrsOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        proposalPlantProductId
        quantity
        quantityOverride
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
      type
    }
    productName
    profit
    profitAfterDiscount
    profitOverride
    profitPercentage
    profitPercentageOverride
    projectFiles {
      children {
        children {
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        createdAt
        fileSizeBytes
        id
        name
        parentFolderId
        path
        type
      }
      createdAt
      fileSizeBytes
      id
      name
      parentFolderId
      path
      pivot {
        id
      }
      type
    }
    proposalMaterialNoPlants {
      cost
      id
      name
      percentage
      proposalProductId
      quantity
      quantityOverride
      rate
    }
    proposalPlantProducts {
      applicationRate
      applicationRateOverride
      areaCoverage
      costMaterial
      costTransferTruck
      id
      materialNeeded
      materialNeededOverride
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOnWeight
      rateOverride
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTimeHrs
      transferTruckRoundTripTimeHrsOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        proposalPlantProductId
        quantity
        quantityOverride
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
      type
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      showIndividualProducts
    }
    proposalProductGroupId
    roundTripTravelTimeHours
    statementOfWork
    subcontractorCost
    subcontractorName
    subcontractorProposalId
    transferTruckLoadTimeBuffer
    transferTruckRoundTripTime
    transferTruckRoundTripTimeOverride
    transferTruckUnloadTimeBuffer
    transferTrucks {
      cost
      costOverride
      id
      name
      plantTransferTruckId
      proposalPlantProductId
      quantity
      quantityOverride
      rateHourly
      rateHourlyOverride
      rateTon
      rateTonOverride
      tonnage
      totalHaulingHours
      totalHaulingHoursOverride
      transferTruckId
      truckingProductionRate
      trucksNeeded
    }
    unitPriceOverride
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;
export type AddProposalFileMutationFn = Apollo.MutationFunction<AddProposalFileMutation, AddProposalFileMutationVariables>;

/**
 * __useAddProposalFileMutation__
 *
 * To run a mutation, you first call `useAddProposalFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalFileMutation, { data, loading, error }] = useAddProposalFileMutation({
 *   variables: {
 *      path: // value for 'path'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalFileMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalFileMutation, AddProposalFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalFileMutation, AddProposalFileMutationVariables>(AddProposalFileDocument, options);
      }
export type AddProposalFileMutationHookResult = ReturnType<typeof useAddProposalFileMutation>;
export type AddProposalFileMutationResult = Apollo.MutationResult<AddProposalFileMutation>;
export type AddProposalFileMutationOptions = Apollo.BaseMutationOptions<AddProposalFileMutation, AddProposalFileMutationVariables>;
export const AddProposalStageDocument = gql`
    mutation addProposalStage($proposalId: ID!) {
  addProposalStage(proposalId: $proposalId) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    checklistItems {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    checklistNotes
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    discount
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalAfterDiscount
    profit
    profitAfterDiscount
    profitPercentage
    proposalProductGroups {
      id
      isOptional
      name
      ordering
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          helpers {
            hoursPerDay
          }
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricing {
            discount
            mode
            value
            version
          }
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            quantitySource
            rate
            rowId
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          children {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      showIndividualProducts
    }
    proposalProducts {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    roundTripTravelTimeHours
    stageMeasurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
  }
}
    `;
export type AddProposalStageMutationFn = Apollo.MutationFunction<AddProposalStageMutation, AddProposalStageMutationVariables>;

/**
 * __useAddProposalStageMutation__
 *
 * To run a mutation, you first call `useAddProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalStageMutation, { data, loading, error }] = useAddProposalStageMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useAddProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalStageMutation, AddProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalStageMutation, AddProposalStageMutationVariables>(AddProposalStageDocument, options);
      }
export type AddProposalStageMutationHookResult = ReturnType<typeof useAddProposalStageMutation>;
export type AddProposalStageMutationResult = Apollo.MutationResult<AddProposalStageMutation>;
export type AddProposalStageMutationOptions = Apollo.BaseMutationOptions<AddProposalStageMutation, AddProposalStageMutationVariables>;
export const AddProposalStageChecklistItemsDocument = gql`
    mutation addProposalStageChecklistItems($input: AddProposalStageChecklistItemsInput!) {
  addProposalStageChecklistItems(input: $input) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    checklistItems {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    checklistNotes
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    discount
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalAfterDiscount
    profit
    profitAfterDiscount
    profitPercentage
    proposalProductGroups {
      id
      isOptional
      name
      ordering
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          helpers {
            hoursPerDay
          }
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricing {
            discount
            mode
            value
            version
          }
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            quantitySource
            rate
            rowId
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          children {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      showIndividualProducts
    }
    proposalProducts {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    roundTripTravelTimeHours
    stageMeasurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
  }
}
    `;
export type AddProposalStageChecklistItemsMutationFn = Apollo.MutationFunction<AddProposalStageChecklistItemsMutation, AddProposalStageChecklistItemsMutationVariables>;

/**
 * __useAddProposalStageChecklistItemsMutation__
 *
 * To run a mutation, you first call `useAddProposalStageChecklistItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalStageChecklistItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalStageChecklistItemsMutation, { data, loading, error }] = useAddProposalStageChecklistItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProposalStageChecklistItemsMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalStageChecklistItemsMutation, AddProposalStageChecklistItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalStageChecklistItemsMutation, AddProposalStageChecklistItemsMutationVariables>(AddProposalStageChecklistItemsDocument, options);
      }
export type AddProposalStageChecklistItemsMutationHookResult = ReturnType<typeof useAddProposalStageChecklistItemsMutation>;
export type AddProposalStageChecklistItemsMutationResult = Apollo.MutationResult<AddProposalStageChecklistItemsMutation>;
export type AddProposalStageChecklistItemsMutationOptions = Apollo.BaseMutationOptions<AddProposalStageChecklistItemsMutation, AddProposalStageChecklistItemsMutationVariables>;
export const AddTruckToProposalProductDocument = gql`
    mutation addTruckToProposalProduct($input: AddTruckToProposalProductInput!) {
  addTruckToProposalProduct(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type AddTruckToProposalProductMutationFn = Apollo.MutationFunction<AddTruckToProposalProductMutation, AddTruckToProposalProductMutationVariables>;

/**
 * __useAddTruckToProposalProductMutation__
 *
 * To run a mutation, you first call `useAddTruckToProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTruckToProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTruckToProposalProductMutation, { data, loading, error }] = useAddTruckToProposalProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTruckToProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<AddTruckToProposalProductMutation, AddTruckToProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTruckToProposalProductMutation, AddTruckToProposalProductMutationVariables>(AddTruckToProposalProductDocument, options);
      }
export type AddTruckToProposalProductMutationHookResult = ReturnType<typeof useAddTruckToProposalProductMutation>;
export type AddTruckToProposalProductMutationResult = Apollo.MutationResult<AddTruckToProposalProductMutation>;
export type AddTruckToProposalProductMutationOptions = Apollo.BaseMutationOptions<AddTruckToProposalProductMutation, AddTruckToProposalProductMutationVariables>;
export const AppLoginDocument = gql`
    mutation appLogin($force: Boolean, $input: LoginInput!) {
  appLogin(force: $force, input: $input) {
    __typename
    ... on ActiveSessionConflict {
      message
    }
    ... on LoginAppUser {
      token
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            invitedBy {
              addressCity
              addressCountry
              addressLine1
              addressLine2
              addressState
              addressZip
              archivedAt
              autoAssign
              avatar
              crewsCount
              email
              firstName
              hasEmployee
              id
              inviteToken
              invitedAt
              invitedBy {
                addressCity
                addressCountry
                addressLine1
                addressLine2
                addressState
                addressZip
                archivedAt
                autoAssign
                avatar
                crewsCount
                email
                firstName
                hasEmployee
                id
                inviteToken
                invitedAt
                jobPhasesCount
                jobsCount
                lastName
                name
                permissions
                phone
                proposalCount
                roles
                salesGoal
                status
              }
              jobPhasesCount
              jobsCount
              lastName
              name
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
              permissions
              phone
              proposalCount
              roles
              salesGoal
              status
            }
            jobPhasesCount
            jobsCount
            lastName
            name
            organization {
              canMapWithAi
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              invoiceEmailText
              invoicingPaymentTermsNet
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              organizationSalesGoal
              phone
              proposalDefaults {
                autoSave
                color
                defaultLoadingTimeMins
                defaultTransferTruckId
                defaultUnloadTimeMins
                estimateTruckingByFullDay
                id
                idPrefix
                layout
                maxTripNumberPerTruck
                minimumProfitPerDay
                multiplyTravelTimeByDay
                multiplyTravelTimeForEquipmentLabour
                optionalCheckboxDefaultChecked
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
                roundUpToNearestDollarAmount
                startingNumber
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            conversionFactorOverride {
              asphaltTonConversionFactorOverride
              excavateOutTonConversionFactorOverride
              id
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
            }
            documents {
              id
              name
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
              path
              thumbnailPath
            }
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            linkedServices {
              active
              expired
              id
              service
              type
            }
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalDefaults {
              autoSave
              color
              defaultLoadingTimeMins
              defaultTransferTruckId
              defaultUnloadTimeMins
              estimateTruckingByFullDay
              id
              idPrefix
              layout
              maxTripNumberPerTruck
              minimumProfitPerDay
              multiplyTravelTimeByDay
              multiplyTravelTimeForEquipmentLabour
              optionalCheckboxDefaultChecked
              removeIndividualLineItemPricing
              removeUnitPriceAndQuantity
              roundUpToNearestDollarAmount
              startingNumber
            }
            proposalSentEmailText
            salesTaxes {
              id
              isDefault
              name
              percentage
              quickbooksDesktopTaxCodeId
              quickbooksTaxCodeId
            }
            subscribed
            subscription {
              endsAt
              id
              name
              quantity
              renewsAt
              stripeId
              stripePrice
              stripeStatus
              trialEndsAt
            }
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
            organization {
              canMapWithAi
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              invoiceEmailText
              invoicingPaymentTermsNet
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              organizationSalesGoal
              phone
              proposalDefaults {
                autoSave
                color
                defaultLoadingTimeMins
                defaultTransferTruckId
                defaultUnloadTimeMins
                estimateTruckingByFullDay
                id
                idPrefix
                layout
                maxTripNumberPerTruck
                minimumProfitPerDay
                multiplyTravelTimeByDay
                multiplyTravelTimeForEquipmentLabour
                optionalCheckboxDefaultChecked
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
                roundUpToNearestDollarAmount
                startingNumber
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
          }
          documents {
            id
            name
            organization {
              canMapWithAi
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              invoiceEmailText
              invoicingPaymentTermsNet
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              organizationSalesGoal
              phone
              proposalDefaults {
                autoSave
                color
                defaultLoadingTimeMins
                defaultTransferTruckId
                defaultUnloadTimeMins
                estimateTruckingByFullDay
                id
                idPrefix
                layout
                maxTripNumberPerTruck
                minimumProfitPerDay
                multiplyTravelTimeByDay
                multiplyTravelTimeForEquipmentLabour
                optionalCheckboxDefaultChecked
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
                roundUpToNearestDollarAmount
                startingNumber
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
    }
  }
}
    `;
export type AppLoginMutationFn = Apollo.MutationFunction<AppLoginMutation, AppLoginMutationVariables>;

/**
 * __useAppLoginMutation__
 *
 * To run a mutation, you first call `useAppLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appLoginMutation, { data, loading, error }] = useAppLoginMutation({
 *   variables: {
 *      force: // value for 'force'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppLoginMutation(baseOptions?: Apollo.MutationHookOptions<AppLoginMutation, AppLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppLoginMutation, AppLoginMutationVariables>(AppLoginDocument, options);
      }
export type AppLoginMutationHookResult = ReturnType<typeof useAppLoginMutation>;
export type AppLoginMutationResult = Apollo.MutationResult<AppLoginMutation>;
export type AppLoginMutationOptions = Apollo.BaseMutationOptions<AppLoginMutation, AppLoginMutationVariables>;
export const AppLogoutDocument = gql`
    mutation appLogout {
  appLogout
}
    `;
export type AppLogoutMutationFn = Apollo.MutationFunction<AppLogoutMutation, AppLogoutMutationVariables>;

/**
 * __useAppLogoutMutation__
 *
 * To run a mutation, you first call `useAppLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appLogoutMutation, { data, loading, error }] = useAppLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useAppLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AppLogoutMutation, AppLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppLogoutMutation, AppLogoutMutationVariables>(AppLogoutDocument, options);
      }
export type AppLogoutMutationHookResult = ReturnType<typeof useAppLogoutMutation>;
export type AppLogoutMutationResult = Apollo.MutationResult<AppLogoutMutation>;
export type AppLogoutMutationOptions = Apollo.BaseMutationOptions<AppLogoutMutation, AppLogoutMutationVariables>;
export const ApplyAiMappingAdditionalCostsDocument = gql`
    mutation applyAiMappingAdditionalCosts($input: ApplyAiMappingAdditionalCostsInput!) {
  applyAiMappingAdditionalCosts(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type ApplyAiMappingAdditionalCostsMutationFn = Apollo.MutationFunction<ApplyAiMappingAdditionalCostsMutation, ApplyAiMappingAdditionalCostsMutationVariables>;

/**
 * __useApplyAiMappingAdditionalCostsMutation__
 *
 * To run a mutation, you first call `useApplyAiMappingAdditionalCostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyAiMappingAdditionalCostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyAiMappingAdditionalCostsMutation, { data, loading, error }] = useApplyAiMappingAdditionalCostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyAiMappingAdditionalCostsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyAiMappingAdditionalCostsMutation, ApplyAiMappingAdditionalCostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyAiMappingAdditionalCostsMutation, ApplyAiMappingAdditionalCostsMutationVariables>(ApplyAiMappingAdditionalCostsDocument, options);
      }
export type ApplyAiMappingAdditionalCostsMutationHookResult = ReturnType<typeof useApplyAiMappingAdditionalCostsMutation>;
export type ApplyAiMappingAdditionalCostsMutationResult = Apollo.MutationResult<ApplyAiMappingAdditionalCostsMutation>;
export type ApplyAiMappingAdditionalCostsMutationOptions = Apollo.BaseMutationOptions<ApplyAiMappingAdditionalCostsMutation, ApplyAiMappingAdditionalCostsMutationVariables>;
export const ApplyProposalStageMeasurementsDocument = gql`
    mutation applyProposalStageMeasurements($input: ApplyProposalStageMeasurementsInput!) {
  applyProposalStageMeasurements(input: $input) {
    proposal {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      clientEmailOverride
      closeConfidence
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      contentSettings {
        contentType
        id
        isEnabled
        proposalId
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      customFinancials {
        incomplete
        netMargin
        productsWithoutCosts
        profit
        sendErrors
      }
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      events {
        action
        createdAt
        id
      }
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      lastEvent {
        action
        createdAt
        id
      }
      lastStatusChange {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      latestPackageSendRun {
        failedRecipients
        id
        processedRecipients
        proposalId
        recipients {
          attemptCount
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          companyId
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          errorMessage
          id
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          sentAt
          startedAt
          status
        }
        status
        succeededRecipients
        totalRecipients
      }
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      packageChildren {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageParent {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageWinnerProposal {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        addressOverride
        checklistItems {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        proposalProductGroups {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        roundTripTravelTimeHours
        stageMeasurements {
          featureGeojson
          geojsonFeatureId
          id
          isScreenshotTarget
          label
          measurementJob
          measurementType
          measurementValue
          product {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            externalProductName
            id
            indirectPercentage
            labourCostType
            markupPercentage
            measurementJob
            measurementMaterial
            name
            overheadPercentage
            plantProductId
            productionRateType
            statementOfWork
            subcontracted
            type
            unitPrice
            unitPriceProduct
          }
          productId
          sortOrder
        }
      }
      status
      statusChanges {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
      uuid
      version
      versionWithPrefix
      versions {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          addressOverride
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        wonAt
      }
      wonAt
    }
    warnings
  }
}
    `;
export type ApplyProposalStageMeasurementsMutationFn = Apollo.MutationFunction<ApplyProposalStageMeasurementsMutation, ApplyProposalStageMeasurementsMutationVariables>;

/**
 * __useApplyProposalStageMeasurementsMutation__
 *
 * To run a mutation, you first call `useApplyProposalStageMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyProposalStageMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyProposalStageMeasurementsMutation, { data, loading, error }] = useApplyProposalStageMeasurementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyProposalStageMeasurementsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyProposalStageMeasurementsMutation, ApplyProposalStageMeasurementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyProposalStageMeasurementsMutation, ApplyProposalStageMeasurementsMutationVariables>(ApplyProposalStageMeasurementsDocument, options);
      }
export type ApplyProposalStageMeasurementsMutationHookResult = ReturnType<typeof useApplyProposalStageMeasurementsMutation>;
export type ApplyProposalStageMeasurementsMutationResult = Apollo.MutationResult<ApplyProposalStageMeasurementsMutation>;
export type ApplyProposalStageMeasurementsMutationOptions = Apollo.BaseMutationOptions<ApplyProposalStageMeasurementsMutation, ApplyProposalStageMeasurementsMutationVariables>;
export const ArchiveCompanyDocument = gql`
    mutation archiveCompany($id: ID!) {
  archiveCompany(id: $id)
}
    `;
export type ArchiveCompanyMutationFn = Apollo.MutationFunction<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>;

/**
 * __useArchiveCompanyMutation__
 *
 * To run a mutation, you first call `useArchiveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCompanyMutation, { data, loading, error }] = useArchiveCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>(ArchiveCompanyDocument, options);
      }
export type ArchiveCompanyMutationHookResult = ReturnType<typeof useArchiveCompanyMutation>;
export type ArchiveCompanyMutationResult = Apollo.MutationResult<ArchiveCompanyMutation>;
export type ArchiveCompanyMutationOptions = Apollo.BaseMutationOptions<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>;
export const ArchiveCustomProductDocument = gql`
    mutation archiveCustomProduct($id: ID!) {
  archiveCustomProduct(id: $id)
}
    `;
export type ArchiveCustomProductMutationFn = Apollo.MutationFunction<ArchiveCustomProductMutation, ArchiveCustomProductMutationVariables>;

/**
 * __useArchiveCustomProductMutation__
 *
 * To run a mutation, you first call `useArchiveCustomProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCustomProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCustomProductMutation, { data, loading, error }] = useArchiveCustomProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveCustomProductMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCustomProductMutation, ArchiveCustomProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCustomProductMutation, ArchiveCustomProductMutationVariables>(ArchiveCustomProductDocument, options);
      }
export type ArchiveCustomProductMutationHookResult = ReturnType<typeof useArchiveCustomProductMutation>;
export type ArchiveCustomProductMutationResult = Apollo.MutationResult<ArchiveCustomProductMutation>;
export type ArchiveCustomProductMutationOptions = Apollo.BaseMutationOptions<ArchiveCustomProductMutation, ArchiveCustomProductMutationVariables>;
export const ArchiveEmployeeDocument = gql`
    mutation archiveEmployee($id: ID!) {
  archiveEmployee(id: $id) {
    archivedAt
    firstName
    id
    lastName
    name
    organizationId
    rate
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;
export type ArchiveEmployeeMutationFn = Apollo.MutationFunction<ArchiveEmployeeMutation, ArchiveEmployeeMutationVariables>;

/**
 * __useArchiveEmployeeMutation__
 *
 * To run a mutation, you first call `useArchiveEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEmployeeMutation, { data, loading, error }] = useArchiveEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEmployeeMutation, ArchiveEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEmployeeMutation, ArchiveEmployeeMutationVariables>(ArchiveEmployeeDocument, options);
      }
export type ArchiveEmployeeMutationHookResult = ReturnType<typeof useArchiveEmployeeMutation>;
export type ArchiveEmployeeMutationResult = Apollo.MutationResult<ArchiveEmployeeMutation>;
export type ArchiveEmployeeMutationOptions = Apollo.BaseMutationOptions<ArchiveEmployeeMutation, ArchiveEmployeeMutationVariables>;
export const ArchiveWorksheetProductDocument = gql`
    mutation archiveWorksheetProduct($id: ID!) {
  archiveWorksheetProduct(id: $id)
}
    `;
export type ArchiveWorksheetProductMutationFn = Apollo.MutationFunction<ArchiveWorksheetProductMutation, ArchiveWorksheetProductMutationVariables>;

/**
 * __useArchiveWorksheetProductMutation__
 *
 * To run a mutation, you first call `useArchiveWorksheetProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWorksheetProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWorksheetProductMutation, { data, loading, error }] = useArchiveWorksheetProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveWorksheetProductMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveWorksheetProductMutation, ArchiveWorksheetProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveWorksheetProductMutation, ArchiveWorksheetProductMutationVariables>(ArchiveWorksheetProductDocument, options);
      }
export type ArchiveWorksheetProductMutationHookResult = ReturnType<typeof useArchiveWorksheetProductMutation>;
export type ArchiveWorksheetProductMutationResult = Apollo.MutationResult<ArchiveWorksheetProductMutation>;
export type ArchiveWorksheetProductMutationOptions = Apollo.BaseMutationOptions<ArchiveWorksheetProductMutation, ArchiveWorksheetProductMutationVariables>;
export const CancelAiMappingTaskDocument = gql`
    mutation cancelAiMappingTask($taskId: String!) {
  cancelAiMappingTask(taskId: $taskId) {
    coordinates
    createdAt
    currentVersion
    id
    imageHeight
    imageWidth
    inputType
    minSegAreaSqft
    minSegConf
    name
    segmentationModel
    status
    taskId
    updatedAt
  }
}
    `;
export type CancelAiMappingTaskMutationFn = Apollo.MutationFunction<CancelAiMappingTaskMutation, CancelAiMappingTaskMutationVariables>;

/**
 * __useCancelAiMappingTaskMutation__
 *
 * To run a mutation, you first call `useCancelAiMappingTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAiMappingTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAiMappingTaskMutation, { data, loading, error }] = useCancelAiMappingTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCancelAiMappingTaskMutation(baseOptions?: Apollo.MutationHookOptions<CancelAiMappingTaskMutation, CancelAiMappingTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAiMappingTaskMutation, CancelAiMappingTaskMutationVariables>(CancelAiMappingTaskDocument, options);
      }
export type CancelAiMappingTaskMutationHookResult = ReturnType<typeof useCancelAiMappingTaskMutation>;
export type CancelAiMappingTaskMutationResult = Apollo.MutationResult<CancelAiMappingTaskMutation>;
export type CancelAiMappingTaskMutationOptions = Apollo.BaseMutationOptions<CancelAiMappingTaskMutation, CancelAiMappingTaskMutationVariables>;
export const CancelOpportunityDocument = gql`
    mutation cancelOpportunity($id: ID!) {
  cancelOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;
export type CancelOpportunityMutationFn = Apollo.MutationFunction<CancelOpportunityMutation, CancelOpportunityMutationVariables>;

/**
 * __useCancelOpportunityMutation__
 *
 * To run a mutation, you first call `useCancelOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOpportunityMutation, { data, loading, error }] = useCancelOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CancelOpportunityMutation, CancelOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOpportunityMutation, CancelOpportunityMutationVariables>(CancelOpportunityDocument, options);
      }
export type CancelOpportunityMutationHookResult = ReturnType<typeof useCancelOpportunityMutation>;
export type CancelOpportunityMutationResult = Apollo.MutationResult<CancelOpportunityMutation>;
export type CancelOpportunityMutationOptions = Apollo.BaseMutationOptions<CancelOpportunityMutation, CancelOpportunityMutationVariables>;
export const CancelProposalDocument = gql`
    mutation cancelProposal($duplicate: Boolean!, $id: ID!, $maintainCurrentId: Boolean) {
  cancelProposal(
    duplicate: $duplicate
    id: $id
    maintainCurrentId: $maintainCurrentId
  ) {
    newProposal {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      clientEmailOverride
      closeConfidence
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      contentSettings {
        contentType
        id
        isEnabled
        proposalId
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      customFinancials {
        incomplete
        netMargin
        productsWithoutCosts
        profit
        sendErrors
      }
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      events {
        action
        createdAt
        id
      }
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      lastEvent {
        action
        createdAt
        id
      }
      lastStatusChange {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      latestPackageSendRun {
        failedRecipients
        id
        processedRecipients
        proposalId
        recipients {
          attemptCount
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          companyId
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          errorMessage
          id
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          sentAt
          startedAt
          status
        }
        status
        succeededRecipients
        totalRecipients
      }
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      packageChildren {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageParent {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageWinnerProposal {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        addressOverride
        checklistItems {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        proposalProductGroups {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        roundTripTravelTimeHours
        stageMeasurements {
          featureGeojson
          geojsonFeatureId
          id
          isScreenshotTarget
          label
          measurementJob
          measurementType
          measurementValue
          product {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            externalProductName
            id
            indirectPercentage
            labourCostType
            markupPercentage
            measurementJob
            measurementMaterial
            name
            overheadPercentage
            plantProductId
            productionRateType
            statementOfWork
            subcontracted
            type
            unitPrice
            unitPriceProduct
          }
          productId
          sortOrder
        }
      }
      status
      statusChanges {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
      uuid
      version
      versionWithPrefix
      versions {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          addressOverride
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        wonAt
      }
      wonAt
    }
    proposal {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      clientEmailOverride
      closeConfidence
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        email
        id
        jobsCount
        logo
        name
        notes
        phone
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      contentSettings {
        contentType
        id
        isEnabled
        proposalId
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      customFinancials {
        incomplete
        netMargin
        productsWithoutCosts
        profit
        sendErrors
      }
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      events {
        action
        createdAt
        id
      }
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      lastEvent {
        action
        createdAt
        id
      }
      lastStatusChange {
        changeAt
        status
      }
      latestPackageSendRun {
        failedRecipients
        id
        processedRecipients
        proposalId
        status
        succeededRecipients
        totalRecipients
      }
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      packageChildren {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageParent {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageWinnerProposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      status
      statusChanges {
        changeAt
        status
      }
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
      uuid
      version
      versionWithPrefix
      versions {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      wonAt
    }
  }
}
    `;
export type CancelProposalMutationFn = Apollo.MutationFunction<CancelProposalMutation, CancelProposalMutationVariables>;

/**
 * __useCancelProposalMutation__
 *
 * To run a mutation, you first call `useCancelProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelProposalMutation, { data, loading, error }] = useCancelProposalMutation({
 *   variables: {
 *      duplicate: // value for 'duplicate'
 *      id: // value for 'id'
 *      maintainCurrentId: // value for 'maintainCurrentId'
 *   },
 * });
 */
export function useCancelProposalMutation(baseOptions?: Apollo.MutationHookOptions<CancelProposalMutation, CancelProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelProposalMutation, CancelProposalMutationVariables>(CancelProposalDocument, options);
      }
export type CancelProposalMutationHookResult = ReturnType<typeof useCancelProposalMutation>;
export type CancelProposalMutationResult = Apollo.MutationResult<CancelProposalMutation>;
export type CancelProposalMutationOptions = Apollo.BaseMutationOptions<CancelProposalMutation, CancelProposalMutationVariables>;
export const CloseProposalDocument = gql`
    mutation closeProposal($id: ID!) {
  closeProposal(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type CloseProposalMutationFn = Apollo.MutationFunction<CloseProposalMutation, CloseProposalMutationVariables>;

/**
 * __useCloseProposalMutation__
 *
 * To run a mutation, you first call `useCloseProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeProposalMutation, { data, loading, error }] = useCloseProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseProposalMutation(baseOptions?: Apollo.MutationHookOptions<CloseProposalMutation, CloseProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseProposalMutation, CloseProposalMutationVariables>(CloseProposalDocument, options);
      }
export type CloseProposalMutationHookResult = ReturnType<typeof useCloseProposalMutation>;
export type CloseProposalMutationResult = Apollo.MutationResult<CloseProposalMutation>;
export type CloseProposalMutationOptions = Apollo.BaseMutationOptions<CloseProposalMutation, CloseProposalMutationVariables>;
export const CompleteTaskDocument = gql`
    mutation completeTask($id: ID!) {
  completeTask(id: $id) {
    assignedUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    completedAt
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    content
    createdAt
    dueAt
    id
    notifiableExternalId
    notifiableId
    notifiableType
    notificationTrigger {
      active
      additionalRecipientTypes
      additionalRecipients {
        email
        firstName
        id
        isTask
        lastName
        taskContent
      }
      apiHeaders
      apiMethod
      apiPayload
      apiSecret
      apiUrl
      content
      delay
      emailSubject
      event
      id
      isApi
      isEmail
      isSMS
      isTask
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      sendToAllRecipients
      sendToContact
      sendToUser
      smsContent
      taskContent
      type
    }
    status
    triggerEvent
    triggerType
    updatedAt
  }
}
    `;
export type CompleteTaskMutationFn = Apollo.MutationFunction<CompleteTaskMutation, CompleteTaskMutationVariables>;

/**
 * __useCompleteTaskMutation__
 *
 * To run a mutation, you first call `useCompleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTaskMutation, { data, loading, error }] = useCompleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<CompleteTaskMutation, CompleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteTaskMutation, CompleteTaskMutationVariables>(CompleteTaskDocument, options);
      }
export type CompleteTaskMutationHookResult = ReturnType<typeof useCompleteTaskMutation>;
export type CompleteTaskMutationResult = Apollo.MutationResult<CompleteTaskMutation>;
export type CompleteTaskMutationOptions = Apollo.BaseMutationOptions<CompleteTaskMutation, CompleteTaskMutationVariables>;
export const CopyProposalProductToStageDocument = gql`
    mutation copyProposalProductToStage($proposalProductId: ID!, $targetStageId: ID!) {
  copyProposalProductToStage(
    proposalProductId: $proposalProductId
    targetStageId: $targetStageId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type CopyProposalProductToStageMutationFn = Apollo.MutationFunction<CopyProposalProductToStageMutation, CopyProposalProductToStageMutationVariables>;

/**
 * __useCopyProposalProductToStageMutation__
 *
 * To run a mutation, you first call `useCopyProposalProductToStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyProposalProductToStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyProposalProductToStageMutation, { data, loading, error }] = useCopyProposalProductToStageMutation({
 *   variables: {
 *      proposalProductId: // value for 'proposalProductId'
 *      targetStageId: // value for 'targetStageId'
 *   },
 * });
 */
export function useCopyProposalProductToStageMutation(baseOptions?: Apollo.MutationHookOptions<CopyProposalProductToStageMutation, CopyProposalProductToStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyProposalProductToStageMutation, CopyProposalProductToStageMutationVariables>(CopyProposalProductToStageDocument, options);
      }
export type CopyProposalProductToStageMutationHookResult = ReturnType<typeof useCopyProposalProductToStageMutation>;
export type CopyProposalProductToStageMutationResult = Apollo.MutationResult<CopyProposalProductToStageMutation>;
export type CopyProposalProductToStageMutationOptions = Apollo.BaseMutationOptions<CopyProposalProductToStageMutation, CopyProposalProductToStageMutationVariables>;
export const CreateAdditionalCostDocument = gql`
    mutation createAdditionalCost($input: CreateAdditionalCostInput!) {
  createAdditionalCost(input: $input) {
    cost
    feeAmount
    feeType
    id
    name
  }
}
    `;
export type CreateAdditionalCostMutationFn = Apollo.MutationFunction<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>;

/**
 * __useCreateAdditionalCostMutation__
 *
 * To run a mutation, you first call `useCreateAdditionalCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdditionalCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdditionalCostMutation, { data, loading, error }] = useCreateAdditionalCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdditionalCostMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>(CreateAdditionalCostDocument, options);
      }
export type CreateAdditionalCostMutationHookResult = ReturnType<typeof useCreateAdditionalCostMutation>;
export type CreateAdditionalCostMutationResult = Apollo.MutationResult<CreateAdditionalCostMutation>;
export type CreateAdditionalCostMutationOptions = Apollo.BaseMutationOptions<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>;
export const CreateAiMappingDetectionDocument = gql`
    mutation createAiMappingDetection($input: CreateAiMappingDetectionInput!) {
  createAiMappingDetection(input: $input) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    detections {
      bbox
      category
      color
      confidence
      id
      isDeleted
      source
      version
    }
    segmentations {
      areaSqft
      category
      color
      id
      isDeleted
      polygon
      version
    }
  }
}
    `;
export type CreateAiMappingDetectionMutationFn = Apollo.MutationFunction<CreateAiMappingDetectionMutation, CreateAiMappingDetectionMutationVariables>;

/**
 * __useCreateAiMappingDetectionMutation__
 *
 * To run a mutation, you first call `useCreateAiMappingDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiMappingDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiMappingDetectionMutation, { data, loading, error }] = useCreateAiMappingDetectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiMappingDetectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiMappingDetectionMutation, CreateAiMappingDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiMappingDetectionMutation, CreateAiMappingDetectionMutationVariables>(CreateAiMappingDetectionDocument, options);
      }
export type CreateAiMappingDetectionMutationHookResult = ReturnType<typeof useCreateAiMappingDetectionMutation>;
export type CreateAiMappingDetectionMutationResult = Apollo.MutationResult<CreateAiMappingDetectionMutation>;
export type CreateAiMappingDetectionMutationOptions = Apollo.BaseMutationOptions<CreateAiMappingDetectionMutation, CreateAiMappingDetectionMutationVariables>;
export const CreateAiMappingRunDocument = gql`
    mutation createAiMappingRun($projectMapId: ID!) {
  createAiMappingRun(projectMapId: $projectMapId) {
    areas {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    createdAt
    description
    id
    name
    projectMap {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      createdAt
      createdBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      description
      id
      latitude
      longitude
      mapData
      mapImage
      mapImageDirty
      measurements {
        featureGeojson
        geojsonFeatureId
        id
        isScreenshotTarget
        label
        measurementJob
        measurementType
        measurementValue
        product {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMinimumProduct
          costMinimumProposal
          crew {
            color
            displayName
            id
            name
            rate
          }
          dailyUnitsComplete
          externalProductName
          id
          indirectPercentage
          labourCostType
          markupPercentage
          materialsNoPlant {
            id
            name
            percentage
            productId
            rate
          }
          measurementJob
          measurementMaterial
          name
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          overheadPercentage
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProductId
          plantProducts {
            id
            plantId
            rate
            type
          }
          plants {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          productAdditionalCosts {
            id
            type
          }
          productCrews {
            id
            quantity
          }
          productEquipmentPieces {
            id
            quantity
          }
          productionRateType
          statementOfWork
          subcontracted
          type
          unitPrice
          unitPriceProduct
        }
        productId
        sortOrder
      }
      name
      updatedAt
    }
    updatedAt
  }
}
    `;
export type CreateAiMappingRunMutationFn = Apollo.MutationFunction<CreateAiMappingRunMutation, CreateAiMappingRunMutationVariables>;

/**
 * __useCreateAiMappingRunMutation__
 *
 * To run a mutation, you first call `useCreateAiMappingRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiMappingRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiMappingRunMutation, { data, loading, error }] = useCreateAiMappingRunMutation({
 *   variables: {
 *      projectMapId: // value for 'projectMapId'
 *   },
 * });
 */
export function useCreateAiMappingRunMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiMappingRunMutation, CreateAiMappingRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiMappingRunMutation, CreateAiMappingRunMutationVariables>(CreateAiMappingRunDocument, options);
      }
export type CreateAiMappingRunMutationHookResult = ReturnType<typeof useCreateAiMappingRunMutation>;
export type CreateAiMappingRunMutationResult = Apollo.MutationResult<CreateAiMappingRunMutation>;
export type CreateAiMappingRunMutationOptions = Apollo.BaseMutationOptions<CreateAiMappingRunMutation, CreateAiMappingRunMutationVariables>;
export const CreateAiMappingRunAreaDocument = gql`
    mutation createAiMappingRunArea($input: CreateAiMappingRunAreaInput!) {
  createAiMappingRunArea(input: $input) {
    coordinates
    createdAt
    currentVersion
    id
    imageHeight
    imageWidth
    inputType
    minSegAreaSqft
    minSegConf
    name
    segmentationModel
    status
    taskId
    updatedAt
  }
}
    `;
export type CreateAiMappingRunAreaMutationFn = Apollo.MutationFunction<CreateAiMappingRunAreaMutation, CreateAiMappingRunAreaMutationVariables>;

/**
 * __useCreateAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useCreateAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiMappingRunAreaMutation, { data, loading, error }] = useCreateAiMappingRunAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiMappingRunAreaMutation, CreateAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiMappingRunAreaMutation, CreateAiMappingRunAreaMutationVariables>(CreateAiMappingRunAreaDocument, options);
      }
export type CreateAiMappingRunAreaMutationHookResult = ReturnType<typeof useCreateAiMappingRunAreaMutation>;
export type CreateAiMappingRunAreaMutationResult = Apollo.MutationResult<CreateAiMappingRunAreaMutation>;
export type CreateAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<CreateAiMappingRunAreaMutation, CreateAiMappingRunAreaMutationVariables>;
export const CreateAiMappingSegmentationDocument = gql`
    mutation createAiMappingSegmentation($input: CreateAiMappingSegmentationInput!) {
  createAiMappingSegmentation(input: $input) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    detections {
      bbox
      category
      color
      confidence
      id
      isDeleted
      source
      version
    }
    segmentations {
      areaSqft
      category
      color
      id
      isDeleted
      polygon
      version
    }
  }
}
    `;
export type CreateAiMappingSegmentationMutationFn = Apollo.MutationFunction<CreateAiMappingSegmentationMutation, CreateAiMappingSegmentationMutationVariables>;

/**
 * __useCreateAiMappingSegmentationMutation__
 *
 * To run a mutation, you first call `useCreateAiMappingSegmentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiMappingSegmentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiMappingSegmentationMutation, { data, loading, error }] = useCreateAiMappingSegmentationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiMappingSegmentationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiMappingSegmentationMutation, CreateAiMappingSegmentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiMappingSegmentationMutation, CreateAiMappingSegmentationMutationVariables>(CreateAiMappingSegmentationDocument, options);
      }
export type CreateAiMappingSegmentationMutationHookResult = ReturnType<typeof useCreateAiMappingSegmentationMutation>;
export type CreateAiMappingSegmentationMutationResult = Apollo.MutationResult<CreateAiMappingSegmentationMutation>;
export type CreateAiMappingSegmentationMutationOptions = Apollo.BaseMutationOptions<CreateAiMappingSegmentationMutation, CreateAiMappingSegmentationMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation createCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const CreateCrewDocument = gql`
    mutation createCrew($input: CreateCrewInput!) {
  createCrew(input: $input) {
    color
    displayName
    employees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    rate
  }
}
    `;
export type CreateCrewMutationFn = Apollo.MutationFunction<CreateCrewMutation, CreateCrewMutationVariables>;

/**
 * __useCreateCrewMutation__
 *
 * To run a mutation, you first call `useCreateCrewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCrewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCrewMutation, { data, loading, error }] = useCreateCrewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCrewMutation(baseOptions?: Apollo.MutationHookOptions<CreateCrewMutation, CreateCrewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCrewMutation, CreateCrewMutationVariables>(CreateCrewDocument, options);
      }
export type CreateCrewMutationHookResult = ReturnType<typeof useCreateCrewMutation>;
export type CreateCrewMutationResult = Apollo.MutationResult<CreateCrewMutation>;
export type CreateCrewMutationOptions = Apollo.BaseMutationOptions<CreateCrewMutation, CreateCrewMutationVariables>;
export const CreateCustomEventDocument = gql`
    mutation createCustomEvent($input: CreateCustomEventInput) {
  createCustomEvent(input: $input) {
    color
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        endsAt
        files {
          customEvent {
            color
            endsAt
            id
            name
            notes
            startsAt
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    files {
      id
      name
      path
    }
    id
    name
    notes
    startsAt
  }
}
    `;
export type CreateCustomEventMutationFn = Apollo.MutationFunction<CreateCustomEventMutation, CreateCustomEventMutationVariables>;

/**
 * __useCreateCustomEventMutation__
 *
 * To run a mutation, you first call `useCreateCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomEventMutation, { data, loading, error }] = useCreateCustomEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomEventMutation, CreateCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomEventMutation, CreateCustomEventMutationVariables>(CreateCustomEventDocument, options);
      }
export type CreateCustomEventMutationHookResult = ReturnType<typeof useCreateCustomEventMutation>;
export type CreateCustomEventMutationResult = Apollo.MutationResult<CreateCustomEventMutation>;
export type CreateCustomEventMutationOptions = Apollo.BaseMutationOptions<CreateCustomEventMutation, CreateCustomEventMutationVariables>;
export const CreateDailyFormInspectionDocument = gql`
    mutation createDailyFormInspection($input: CreateDailyFormInspectionInput!) {
  createDailyFormInspection(input: $input) {
    createdAt
    dailyFormVehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      registrationExpirationDate
      registrationState
      vin
      year
    }
    id
    lightsWork
    loadStrapped
    oilChecked
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    questionAnswers {
      answer
      id
      isTrue
    }
    tiresAiredBrakesWorking
    toolsLoaded
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    vehicleConditionAcceptable
    vehicleFueled
    vehicleMilleage
  }
}
    `;
export type CreateDailyFormInspectionMutationFn = Apollo.MutationFunction<CreateDailyFormInspectionMutation, CreateDailyFormInspectionMutationVariables>;

/**
 * __useCreateDailyFormInspectionMutation__
 *
 * To run a mutation, you first call `useCreateDailyFormInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyFormInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyFormInspectionMutation, { data, loading, error }] = useCreateDailyFormInspectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDailyFormInspectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyFormInspectionMutation, CreateDailyFormInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyFormInspectionMutation, CreateDailyFormInspectionMutationVariables>(CreateDailyFormInspectionDocument, options);
      }
export type CreateDailyFormInspectionMutationHookResult = ReturnType<typeof useCreateDailyFormInspectionMutation>;
export type CreateDailyFormInspectionMutationResult = Apollo.MutationResult<CreateDailyFormInspectionMutation>;
export type CreateDailyFormInspectionMutationOptions = Apollo.BaseMutationOptions<CreateDailyFormInspectionMutation, CreateDailyFormInspectionMutationVariables>;
export const CreateDailyFormInspectionQuestionDocument = gql`
    mutation createDailyFormInspectionQuestion($input: CreateDailyFormInspectionQuestionInput!) {
  createDailyFormInspectionQuestion(input: $input) {
    id
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    question
    type
  }
}
    `;
export type CreateDailyFormInspectionQuestionMutationFn = Apollo.MutationFunction<CreateDailyFormInspectionQuestionMutation, CreateDailyFormInspectionQuestionMutationVariables>;

/**
 * __useCreateDailyFormInspectionQuestionMutation__
 *
 * To run a mutation, you first call `useCreateDailyFormInspectionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyFormInspectionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyFormInspectionQuestionMutation, { data, loading, error }] = useCreateDailyFormInspectionQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDailyFormInspectionQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyFormInspectionQuestionMutation, CreateDailyFormInspectionQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyFormInspectionQuestionMutation, CreateDailyFormInspectionQuestionMutationVariables>(CreateDailyFormInspectionQuestionDocument, options);
      }
export type CreateDailyFormInspectionQuestionMutationHookResult = ReturnType<typeof useCreateDailyFormInspectionQuestionMutation>;
export type CreateDailyFormInspectionQuestionMutationResult = Apollo.MutationResult<CreateDailyFormInspectionQuestionMutation>;
export type CreateDailyFormInspectionQuestionMutationOptions = Apollo.BaseMutationOptions<CreateDailyFormInspectionQuestionMutation, CreateDailyFormInspectionQuestionMutationVariables>;
export const CreateDailyFormVehicleDocument = gql`
    mutation createDailyFormVehicle($input: CreateDailyFormVehicleInput!) {
  createDailyFormVehicle(input: $input) {
    currentMeterReading
    dailyFormVehicleType {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    defaultServiceIntervalUnit
    defaultServiceIntervalValue
    id
    inServiceDate
    inspections {
      createdAt
      dailyFormVehicle {
        currentMeterReading
        dailyFormVehicleType {
          id
          name
        }
        defaultServiceIntervalUnit
        defaultServiceIntervalValue
        id
        inServiceDate
        inspections {
          createdAt
          id
          lightsWork
          loadStrapped
          oilChecked
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          questionAnswers {
            answer
            id
            isTrue
          }
          tiresAiredBrakesWorking
          toolsLoaded
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicleConditionAcceptable
          vehicleFueled
          vehicleMilleage
        }
        isActive
        licensePlate
        make
        meterType
        model
        name
        notes
        parts {
          id
          name
          notes
          partNumber
          quantity
          unitPrice
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          vendorName
        }
        registrationExpirationDate
        registrationState
        servicePlans {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        vin
        workOrders {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        year
      }
      id
      lightsWork
      loadStrapped
      oilChecked
      tiresAiredBrakesWorking
      toolsLoaded
      vehicleConditionAcceptable
      vehicleFueled
      vehicleMilleage
    }
    isActive
    licensePlate
    make
    meterType
    model
    name
    notes
    parts {
      id
      name
      notes
      partNumber
      quantity
      unitPrice
      vendorName
    }
    registrationExpirationDate
    registrationState
    servicePlans {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    vin
    workOrders {
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      status
    }
    year
  }
}
    `;
export type CreateDailyFormVehicleMutationFn = Apollo.MutationFunction<CreateDailyFormVehicleMutation, CreateDailyFormVehicleMutationVariables>;

/**
 * __useCreateDailyFormVehicleMutation__
 *
 * To run a mutation, you first call `useCreateDailyFormVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyFormVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyFormVehicleMutation, { data, loading, error }] = useCreateDailyFormVehicleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDailyFormVehicleMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyFormVehicleMutation, CreateDailyFormVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyFormVehicleMutation, CreateDailyFormVehicleMutationVariables>(CreateDailyFormVehicleDocument, options);
      }
export type CreateDailyFormVehicleMutationHookResult = ReturnType<typeof useCreateDailyFormVehicleMutation>;
export type CreateDailyFormVehicleMutationResult = Apollo.MutationResult<CreateDailyFormVehicleMutation>;
export type CreateDailyFormVehicleMutationOptions = Apollo.BaseMutationOptions<CreateDailyFormVehicleMutation, CreateDailyFormVehicleMutationVariables>;
export const CreateDailyFormVehiclePartDocument = gql`
    mutation createDailyFormVehiclePart($input: CreateDailyFormVehiclePartInput!) {
  createDailyFormVehiclePart(input: $input) {
    id
    name
    notes
    partNumber
    quantity
    unitPrice
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    vendorName
  }
}
    `;
export type CreateDailyFormVehiclePartMutationFn = Apollo.MutationFunction<CreateDailyFormVehiclePartMutation, CreateDailyFormVehiclePartMutationVariables>;

/**
 * __useCreateDailyFormVehiclePartMutation__
 *
 * To run a mutation, you first call `useCreateDailyFormVehiclePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyFormVehiclePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyFormVehiclePartMutation, { data, loading, error }] = useCreateDailyFormVehiclePartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDailyFormVehiclePartMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyFormVehiclePartMutation, CreateDailyFormVehiclePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyFormVehiclePartMutation, CreateDailyFormVehiclePartMutationVariables>(CreateDailyFormVehiclePartDocument, options);
      }
export type CreateDailyFormVehiclePartMutationHookResult = ReturnType<typeof useCreateDailyFormVehiclePartMutation>;
export type CreateDailyFormVehiclePartMutationResult = Apollo.MutationResult<CreateDailyFormVehiclePartMutation>;
export type CreateDailyFormVehiclePartMutationOptions = Apollo.BaseMutationOptions<CreateDailyFormVehiclePartMutation, CreateDailyFormVehiclePartMutationVariables>;
export const CreateDailyFormVehicleServicePlanDocument = gql`
    mutation createDailyFormVehicleServicePlan($input: CreateDailyFormVehicleServicePlanInput!) {
  createDailyFormVehicleServicePlan(input: $input) {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    autoCreateTask
    id
    intervalUnit
    intervalValue
    isActive
    issueType
    lastCompletedAt
    lastCompletedMeterReading
    leadUnit
    leadValue
    name
    nextDueDate
    nextDueMeterReading
    notes
    priority
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    workOrders {
      assignedTo {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      files {
        dailyFormWorkOrder {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        path
      }
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      servicePlan {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        autoCreateTask
        id
        intervalUnit
        intervalValue
        isActive
        issueType
        lastCompletedAt
        lastCompletedMeterReading
        leadUnit
        leadValue
        name
        nextDueDate
        nextDueMeterReading
        notes
        priority
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          vin
          year
        }
        workOrders {
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
      }
      status
    }
  }
}
    `;
export type CreateDailyFormVehicleServicePlanMutationFn = Apollo.MutationFunction<CreateDailyFormVehicleServicePlanMutation, CreateDailyFormVehicleServicePlanMutationVariables>;

/**
 * __useCreateDailyFormVehicleServicePlanMutation__
 *
 * To run a mutation, you first call `useCreateDailyFormVehicleServicePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyFormVehicleServicePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyFormVehicleServicePlanMutation, { data, loading, error }] = useCreateDailyFormVehicleServicePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDailyFormVehicleServicePlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyFormVehicleServicePlanMutation, CreateDailyFormVehicleServicePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyFormVehicleServicePlanMutation, CreateDailyFormVehicleServicePlanMutationVariables>(CreateDailyFormVehicleServicePlanDocument, options);
      }
export type CreateDailyFormVehicleServicePlanMutationHookResult = ReturnType<typeof useCreateDailyFormVehicleServicePlanMutation>;
export type CreateDailyFormVehicleServicePlanMutationResult = Apollo.MutationResult<CreateDailyFormVehicleServicePlanMutation>;
export type CreateDailyFormVehicleServicePlanMutationOptions = Apollo.BaseMutationOptions<CreateDailyFormVehicleServicePlanMutation, CreateDailyFormVehicleServicePlanMutationVariables>;
export const CreateDailyFormVehicleTypeDocument = gql`
    mutation createDailyFormVehicleType($name: String!) {
  createDailyFormVehicleType(name: $name) {
    id
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;
export type CreateDailyFormVehicleTypeMutationFn = Apollo.MutationFunction<CreateDailyFormVehicleTypeMutation, CreateDailyFormVehicleTypeMutationVariables>;

/**
 * __useCreateDailyFormVehicleTypeMutation__
 *
 * To run a mutation, you first call `useCreateDailyFormVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyFormVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyFormVehicleTypeMutation, { data, loading, error }] = useCreateDailyFormVehicleTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateDailyFormVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyFormVehicleTypeMutation, CreateDailyFormVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyFormVehicleTypeMutation, CreateDailyFormVehicleTypeMutationVariables>(CreateDailyFormVehicleTypeDocument, options);
      }
export type CreateDailyFormVehicleTypeMutationHookResult = ReturnType<typeof useCreateDailyFormVehicleTypeMutation>;
export type CreateDailyFormVehicleTypeMutationResult = Apollo.MutationResult<CreateDailyFormVehicleTypeMutation>;
export type CreateDailyFormVehicleTypeMutationOptions = Apollo.BaseMutationOptions<CreateDailyFormVehicleTypeMutation, CreateDailyFormVehicleTypeMutationVariables>;
export const CreateDailyFormWorkOrderDocument = gql`
    mutation createDailyFormWorkOrder($input: CreateDailyFormWorkOrderInput!) {
  createDailyFormWorkOrder(input: $input) {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    comments
    completedAt
    createdAt
    currentMeterReading
    estimatedTaskTime
    files {
      dailyFormWorkOrder {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        comments
        completedAt
        createdAt
        currentMeterReading
        estimatedTaskTime
        files {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        issueDescription
        issueName
        issueType
        neededCompletionDate
        priority
        servicePlan {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
      }
      id
      name
      path
    }
    id
    issueDescription
    issueName
    issueType
    neededCompletionDate
    priority
    servicePlan {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    vehicle {
      currentMeterReading
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      registrationExpirationDate
      registrationState
      vin
      year
    }
  }
}
    `;
export type CreateDailyFormWorkOrderMutationFn = Apollo.MutationFunction<CreateDailyFormWorkOrderMutation, CreateDailyFormWorkOrderMutationVariables>;

/**
 * __useCreateDailyFormWorkOrderMutation__
 *
 * To run a mutation, you first call `useCreateDailyFormWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyFormWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyFormWorkOrderMutation, { data, loading, error }] = useCreateDailyFormWorkOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDailyFormWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyFormWorkOrderMutation, CreateDailyFormWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyFormWorkOrderMutation, CreateDailyFormWorkOrderMutationVariables>(CreateDailyFormWorkOrderDocument, options);
      }
export type CreateDailyFormWorkOrderMutationHookResult = ReturnType<typeof useCreateDailyFormWorkOrderMutation>;
export type CreateDailyFormWorkOrderMutationResult = Apollo.MutationResult<CreateDailyFormWorkOrderMutation>;
export type CreateDailyFormWorkOrderMutationOptions = Apollo.BaseMutationOptions<CreateDailyFormWorkOrderMutation, CreateDailyFormWorkOrderMutationVariables>;
export const CreateEmployeeDocument = gql`
    mutation createEmployee($input: CreateEmployeeInput!) {
  createEmployee(input: $input) {
    archivedAt
    firstName
    id
    lastName
    name
    organizationId
    rate
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const CreateEquipmentPieceDocument = gql`
    mutation createEquipmentPiece($input: CreateEquipmentPieceInput!) {
  createEquipmentPiece(input: $input) {
    calculateTravelTime
    chargeType
    fuelSurcharge
    id
    name
    rate
    usePercentage
  }
}
    `;
export type CreateEquipmentPieceMutationFn = Apollo.MutationFunction<CreateEquipmentPieceMutation, CreateEquipmentPieceMutationVariables>;

/**
 * __useCreateEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useCreateEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEquipmentPieceMutation, { data, loading, error }] = useCreateEquipmentPieceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<CreateEquipmentPieceMutation, CreateEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEquipmentPieceMutation, CreateEquipmentPieceMutationVariables>(CreateEquipmentPieceDocument, options);
      }
export type CreateEquipmentPieceMutationHookResult = ReturnType<typeof useCreateEquipmentPieceMutation>;
export type CreateEquipmentPieceMutationResult = Apollo.MutationResult<CreateEquipmentPieceMutation>;
export type CreateEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<CreateEquipmentPieceMutation, CreateEquipmentPieceMutationVariables>;
export const CreateJobInvoiceOnLinkedServiceDocument = gql`
    mutation createJobInvoiceOnLinkedService($createEstimate: Boolean, $createInvoice: Boolean, $createJob: Boolean, $jobId: ID!, $service: OrganizationLinkedServiceName!) {
  createJobInvoiceOnLinkedService(
    createEstimate: $createEstimate
    createInvoice: $createInvoice
    createJob: $createJob
    jobId: $jobId
    service: $service
  )
}
    `;
export type CreateJobInvoiceOnLinkedServiceMutationFn = Apollo.MutationFunction<CreateJobInvoiceOnLinkedServiceMutation, CreateJobInvoiceOnLinkedServiceMutationVariables>;

/**
 * __useCreateJobInvoiceOnLinkedServiceMutation__
 *
 * To run a mutation, you first call `useCreateJobInvoiceOnLinkedServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobInvoiceOnLinkedServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobInvoiceOnLinkedServiceMutation, { data, loading, error }] = useCreateJobInvoiceOnLinkedServiceMutation({
 *   variables: {
 *      createEstimate: // value for 'createEstimate'
 *      createInvoice: // value for 'createInvoice'
 *      createJob: // value for 'createJob'
 *      jobId: // value for 'jobId'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useCreateJobInvoiceOnLinkedServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobInvoiceOnLinkedServiceMutation, CreateJobInvoiceOnLinkedServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobInvoiceOnLinkedServiceMutation, CreateJobInvoiceOnLinkedServiceMutationVariables>(CreateJobInvoiceOnLinkedServiceDocument, options);
      }
export type CreateJobInvoiceOnLinkedServiceMutationHookResult = ReturnType<typeof useCreateJobInvoiceOnLinkedServiceMutation>;
export type CreateJobInvoiceOnLinkedServiceMutationResult = Apollo.MutationResult<CreateJobInvoiceOnLinkedServiceMutation>;
export type CreateJobInvoiceOnLinkedServiceMutationOptions = Apollo.BaseMutationOptions<CreateJobInvoiceOnLinkedServiceMutation, CreateJobInvoiceOnLinkedServiceMutationVariables>;
export const CreateNotificationTriggerDocument = gql`
    mutation createNotificationTrigger($input: CreateNotificationTriggerInput!) {
  createNotificationTrigger(input: $input) {
    active
    additionalRecipientTypes
    additionalRecipients {
      email
      firstName
      id
      isTask
      lastName
      taskContent
    }
    apiHeaders
    apiMethod
    apiPayload
    apiSecret
    apiUrl
    content
    delay
    emailSubject
    event
    id
    isApi
    isEmail
    isSMS
    isTask
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    sendToAllRecipients
    sendToContact
    sendToUser
    smsContent
    taskContent
    type
  }
}
    `;
export type CreateNotificationTriggerMutationFn = Apollo.MutationFunction<CreateNotificationTriggerMutation, CreateNotificationTriggerMutationVariables>;

/**
 * __useCreateNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useCreateNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationTriggerMutation, { data, loading, error }] = useCreateNotificationTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationTriggerMutation, CreateNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationTriggerMutation, CreateNotificationTriggerMutationVariables>(CreateNotificationTriggerDocument, options);
      }
export type CreateNotificationTriggerMutationHookResult = ReturnType<typeof useCreateNotificationTriggerMutation>;
export type CreateNotificationTriggerMutationResult = Apollo.MutationResult<CreateNotificationTriggerMutation>;
export type CreateNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<CreateNotificationTriggerMutation, CreateNotificationTriggerMutationVariables>;
export const CreateOpportunityDocument = gql`
    mutation createOpportunity($input: CreateOpportunityInput!) {
  createOpportunity(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;
export type CreateOpportunityMutationFn = Apollo.MutationFunction<CreateOpportunityMutation, CreateOpportunityMutationVariables>;

/**
 * __useCreateOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpportunityMutation, { data, loading, error }] = useCreateOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpportunityMutation, CreateOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpportunityMutation, CreateOpportunityMutationVariables>(CreateOpportunityDocument, options);
      }
export type CreateOpportunityMutationHookResult = ReturnType<typeof useCreateOpportunityMutation>;
export type CreateOpportunityMutationResult = Apollo.MutationResult<CreateOpportunityMutation>;
export type CreateOpportunityMutationOptions = Apollo.BaseMutationOptions<CreateOpportunityMutation, CreateOpportunityMutationVariables>;
export const CreateOpportunityStatusDocument = gql`
    mutation createOpportunityStatus($name: String!) {
  createOpportunityStatus(name: $name) {
    id
    name
    ordering
  }
}
    `;
export type CreateOpportunityStatusMutationFn = Apollo.MutationFunction<CreateOpportunityStatusMutation, CreateOpportunityStatusMutationVariables>;

/**
 * __useCreateOpportunityStatusMutation__
 *
 * To run a mutation, you first call `useCreateOpportunityStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpportunityStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpportunityStatusMutation, { data, loading, error }] = useCreateOpportunityStatusMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOpportunityStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpportunityStatusMutation, CreateOpportunityStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpportunityStatusMutation, CreateOpportunityStatusMutationVariables>(CreateOpportunityStatusDocument, options);
      }
export type CreateOpportunityStatusMutationHookResult = ReturnType<typeof useCreateOpportunityStatusMutation>;
export type CreateOpportunityStatusMutationResult = Apollo.MutationResult<CreateOpportunityStatusMutation>;
export type CreateOpportunityStatusMutationOptions = Apollo.BaseMutationOptions<CreateOpportunityStatusMutation, CreateOpportunityStatusMutationVariables>;
export const CreateOrganizationAddressDocument = gql`
    mutation createOrganizationAddress($input: CreateOrganizationAddressInput!) {
  createOrganizationAddress(input: $input) {
    city
    country
    id
    isPrimary
    latitude
    line1
    line2
    longitude
    state
    zip
  }
}
    `;
export type CreateOrganizationAddressMutationFn = Apollo.MutationFunction<CreateOrganizationAddressMutation, CreateOrganizationAddressMutationVariables>;

/**
 * __useCreateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationAddressMutation, { data, loading, error }] = useCreateOrganizationAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationAddressMutation, CreateOrganizationAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationAddressMutation, CreateOrganizationAddressMutationVariables>(CreateOrganizationAddressDocument, options);
      }
export type CreateOrganizationAddressMutationHookResult = ReturnType<typeof useCreateOrganizationAddressMutation>;
export type CreateOrganizationAddressMutationResult = Apollo.MutationResult<CreateOrganizationAddressMutation>;
export type CreateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationAddressMutation, CreateOrganizationAddressMutationVariables>;
export const CreateOrganizationCustomContentTypeDocument = gql`
    mutation createOrganizationCustomContentType($input: CreateCustomContentTypeInput!) {
  createOrganizationCustomContentType(input: $input) {
    contentType
    id
    organizationId
    showOnBranded
    showOnFull
    showOnSimple
    showOnTabular
  }
}
    `;
export type CreateOrganizationCustomContentTypeMutationFn = Apollo.MutationFunction<CreateOrganizationCustomContentTypeMutation, CreateOrganizationCustomContentTypeMutationVariables>;

/**
 * __useCreateOrganizationCustomContentTypeMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationCustomContentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationCustomContentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationCustomContentTypeMutation, { data, loading, error }] = useCreateOrganizationCustomContentTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationCustomContentTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationCustomContentTypeMutation, CreateOrganizationCustomContentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationCustomContentTypeMutation, CreateOrganizationCustomContentTypeMutationVariables>(CreateOrganizationCustomContentTypeDocument, options);
      }
export type CreateOrganizationCustomContentTypeMutationHookResult = ReturnType<typeof useCreateOrganizationCustomContentTypeMutation>;
export type CreateOrganizationCustomContentTypeMutationResult = Apollo.MutationResult<CreateOrganizationCustomContentTypeMutation>;
export type CreateOrganizationCustomContentTypeMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationCustomContentTypeMutation, CreateOrganizationCustomContentTypeMutationVariables>;
export const CreateOrganizationProductTypeDocument = gql`
    mutation createOrganizationProductType($input: CreateOrganizationProductTypeInput!) {
  createOrganizationProductType(input: $input) {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
}
    `;
export type CreateOrganizationProductTypeMutationFn = Apollo.MutationFunction<CreateOrganizationProductTypeMutation, CreateOrganizationProductTypeMutationVariables>;

/**
 * __useCreateOrganizationProductTypeMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationProductTypeMutation, { data, loading, error }] = useCreateOrganizationProductTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationProductTypeMutation, CreateOrganizationProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationProductTypeMutation, CreateOrganizationProductTypeMutationVariables>(CreateOrganizationProductTypeDocument, options);
      }
export type CreateOrganizationProductTypeMutationHookResult = ReturnType<typeof useCreateOrganizationProductTypeMutation>;
export type CreateOrganizationProductTypeMutationResult = Apollo.MutationResult<CreateOrganizationProductTypeMutation>;
export type CreateOrganizationProductTypeMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationProductTypeMutation, CreateOrganizationProductTypeMutationVariables>;
export const CreateOrganizationProposalChecklistItemDocument = gql`
    mutation createOrganizationProposalChecklistItem($name: String!) {
  createOrganizationProposalChecklistItem(name: $name) {
    id
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;
export type CreateOrganizationProposalChecklistItemMutationFn = Apollo.MutationFunction<CreateOrganizationProposalChecklistItemMutation, CreateOrganizationProposalChecklistItemMutationVariables>;

/**
 * __useCreateOrganizationProposalChecklistItemMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationProposalChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationProposalChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationProposalChecklistItemMutation, { data, loading, error }] = useCreateOrganizationProposalChecklistItemMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOrganizationProposalChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationProposalChecklistItemMutation, CreateOrganizationProposalChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationProposalChecklistItemMutation, CreateOrganizationProposalChecklistItemMutationVariables>(CreateOrganizationProposalChecklistItemDocument, options);
      }
export type CreateOrganizationProposalChecklistItemMutationHookResult = ReturnType<typeof useCreateOrganizationProposalChecklistItemMutation>;
export type CreateOrganizationProposalChecklistItemMutationResult = Apollo.MutationResult<CreateOrganizationProposalChecklistItemMutation>;
export type CreateOrganizationProposalChecklistItemMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationProposalChecklistItemMutation, CreateOrganizationProposalChecklistItemMutationVariables>;
export const CreatePlantDocument = gql`
    mutation createPlant($input: CreatePlantInput!) {
  createPlant(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    id
    name
    phone
    products {
      id
      pivot {
        applicationRate
      }
      plantId
      rate
      type
    }
  }
}
    `;
export type CreatePlantMutationFn = Apollo.MutationFunction<CreatePlantMutation, CreatePlantMutationVariables>;

/**
 * __useCreatePlantMutation__
 *
 * To run a mutation, you first call `useCreatePlantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlantMutation, { data, loading, error }] = useCreatePlantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlantMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlantMutation, CreatePlantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlantMutation, CreatePlantMutationVariables>(CreatePlantDocument, options);
      }
export type CreatePlantMutationHookResult = ReturnType<typeof useCreatePlantMutation>;
export type CreatePlantMutationResult = Apollo.MutationResult<CreatePlantMutation>;
export type CreatePlantMutationOptions = Apollo.BaseMutationOptions<CreatePlantMutation, CreatePlantMutationVariables>;
export const CreatePlantProductTypeDocument = gql`
    mutation createPlantProductType($name: String!) {
  createPlantProductType(name: $name) {
    id
    name
  }
}
    `;
export type CreatePlantProductTypeMutationFn = Apollo.MutationFunction<CreatePlantProductTypeMutation, CreatePlantProductTypeMutationVariables>;

/**
 * __useCreatePlantProductTypeMutation__
 *
 * To run a mutation, you first call `useCreatePlantProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlantProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlantProductTypeMutation, { data, loading, error }] = useCreatePlantProductTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreatePlantProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlantProductTypeMutation, CreatePlantProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlantProductTypeMutation, CreatePlantProductTypeMutationVariables>(CreatePlantProductTypeDocument, options);
      }
export type CreatePlantProductTypeMutationHookResult = ReturnType<typeof useCreatePlantProductTypeMutation>;
export type CreatePlantProductTypeMutationResult = Apollo.MutationResult<CreatePlantProductTypeMutation>;
export type CreatePlantProductTypeMutationOptions = Apollo.BaseMutationOptions<CreatePlantProductTypeMutation, CreatePlantProductTypeMutationVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    areaCoverage
    attributes {
      __typename
      ... on ProductAttributeAsphalt {
        applicationRate
      }
      ... on ProductAttributeAsphaltCurbing {
        curbHeight
        curbWidth
      }
      ... on ProductAttributeConcreteColumn {
        diameter
        height
      }
      ... on ProductAttributeConcreteCurbOrGutter {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeConcreteFlatwork {
        applicationRate
      }
      ... on ProductAttributeConcreteFooting {
        depth
        width
      }
      ... on ProductAttributeConcreteWall {
        height
        width
      }
      ... on ProductAttributeConcreteWaterway {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeCrackSeal {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeCurbWall {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeExcavateOut {
        applicationRate
      }
      ... on ProductAttributeGrading {
        applicationRate
        poundsPerCubicYard
      }
      ... on ProductAttributeMastic {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeMicrosurfacing {
        applicationRate
      }
      ... on ProductAttributeSealCoat {
        applicationRate
      }
      ... on ProductAttributeSlurrySeal {
        applicationRate
      }
      ... on ProductAttributeStriping {
        applicationRate
        lineWidth
      }
    }
    costMaterial
    costMinimumProduct
    costMinimumProposal
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    dailyUnitsComplete
    externalProductName
    id
    indirectPercentage
    labourCostType
    markupPercentage
    materialsNoPlant {
      id
      name
      percentage
      productId
      rate
    }
    measurementJob
    measurementMaterial
    name
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    overheadPercentage
    plant {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        pivot {
          applicationRate
        }
        plantId
        rate
        type
      }
    }
    plantProductId
    plantProducts {
      id
      pivot {
        applicationRate
      }
      plantId
      rate
      type
    }
    plants {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        plantId
        rate
        type
      }
    }
    productAdditionalCosts {
      additionalCost {
        cost
        feeAmount
        feeType
        id
        name
      }
      id
      type
    }
    productCrews {
      crew {
        color
        displayName
        id
        name
        rate
      }
      id
      quantity
    }
    productEquipmentPieces {
      equipmentPiece {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      id
      quantity
    }
    productionRateType
    statementOfWork
    subcontracted
    type
    unitPrice
    unitPriceProduct
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const CreateProductGroupDocument = gql`
    mutation createProductGroup($input: CreateProductGroupInput!) {
  createProductGroup(input: $input) {
    id
    name
    organizationId
    products {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMinimumProduct
      costMinimumProposal
      crew {
        color
        displayName
        employees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        rate
      }
      dailyUnitsComplete
      externalProductName
      id
      indirectPercentage
      labourCostType
      markupPercentage
      materialsNoPlant {
        id
        name
        percentage
        productId
        rate
      }
      measurementJob
      measurementMaterial
      name
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      overheadPercentage
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        id
        name
        phone
        products {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
      }
      plantProductId
      plantProducts {
        id
        pivot {
          applicationRate
        }
        plantId
        rate
        type
      }
      plants {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        id
        name
        phone
        products {
          id
          plantId
          rate
          type
        }
      }
      productAdditionalCosts {
        additionalCost {
          cost
          feeAmount
          feeType
          id
          name
        }
        id
        type
      }
      productCrews {
        crew {
          color
          displayName
          id
          name
          rate
        }
        id
        quantity
      }
      productEquipmentPieces {
        equipmentPiece {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        id
        quantity
      }
      productionRateType
      statementOfWork
      subcontracted
      type
      unitPrice
      unitPriceProduct
    }
  }
}
    `;
export type CreateProductGroupMutationFn = Apollo.MutationFunction<CreateProductGroupMutation, CreateProductGroupMutationVariables>;

/**
 * __useCreateProductGroupMutation__
 *
 * To run a mutation, you first call `useCreateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductGroupMutation, { data, loading, error }] = useCreateProductGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductGroupMutation, CreateProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductGroupMutation, CreateProductGroupMutationVariables>(CreateProductGroupDocument, options);
      }
export type CreateProductGroupMutationHookResult = ReturnType<typeof useCreateProductGroupMutation>;
export type CreateProductGroupMutationResult = Apollo.MutationResult<CreateProductGroupMutation>;
export type CreateProductGroupMutationOptions = Apollo.BaseMutationOptions<CreateProductGroupMutation, CreateProductGroupMutationVariables>;
export const CreateProjectFileFolderDocument = gql`
    mutation createProjectFileFolder($name: String!, $parentFolderId: ID) {
  createProjectFileFolder(name: $name, parentFolderId: $parentFolderId) {
    children {
      children {
        createdAt
        fileSizeBytes
        id
        name
        parentFolderId
        path
        pivot {
          id
        }
        type
      }
      createdAt
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    createdAt
    fileSizeBytes
    id
    name
    parentFolderId
    path
    pivot {
      id
    }
    type
  }
}
    `;
export type CreateProjectFileFolderMutationFn = Apollo.MutationFunction<CreateProjectFileFolderMutation, CreateProjectFileFolderMutationVariables>;

/**
 * __useCreateProjectFileFolderMutation__
 *
 * To run a mutation, you first call `useCreateProjectFileFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFileFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFileFolderMutation, { data, loading, error }] = useCreateProjectFileFolderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parentFolderId: // value for 'parentFolderId'
 *   },
 * });
 */
export function useCreateProjectFileFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectFileFolderMutation, CreateProjectFileFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectFileFolderMutation, CreateProjectFileFolderMutationVariables>(CreateProjectFileFolderDocument, options);
      }
export type CreateProjectFileFolderMutationHookResult = ReturnType<typeof useCreateProjectFileFolderMutation>;
export type CreateProjectFileFolderMutationResult = Apollo.MutationResult<CreateProjectFileFolderMutation>;
export type CreateProjectFileFolderMutationOptions = Apollo.BaseMutationOptions<CreateProjectFileFolderMutation, CreateProjectFileFolderMutationVariables>;
export const CreateProjectMapDocument = gql`
    mutation createProjectMap($input: CreateProjectMapInput!) {
  createProjectMap(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    createdAt
    createdBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    description
    id
    latitude
    longitude
    mapData
    mapImage
    mapImageDirty
    measurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
    name
    updatedAt
  }
}
    `;
export type CreateProjectMapMutationFn = Apollo.MutationFunction<CreateProjectMapMutation, CreateProjectMapMutationVariables>;

/**
 * __useCreateProjectMapMutation__
 *
 * To run a mutation, you first call `useCreateProjectMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMapMutation, { data, loading, error }] = useCreateProjectMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMapMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMapMutation, CreateProjectMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMapMutation, CreateProjectMapMutationVariables>(CreateProjectMapDocument, options);
      }
export type CreateProjectMapMutationHookResult = ReturnType<typeof useCreateProjectMapMutation>;
export type CreateProjectMapMutationResult = Apollo.MutationResult<CreateProjectMapMutation>;
export type CreateProjectMapMutationOptions = Apollo.BaseMutationOptions<CreateProjectMapMutation, CreateProjectMapMutationVariables>;
export const CreateProposalDocument = gql`
    mutation createProposal($closeConfidence: Int, $companyId: ID!, $contactId: ID!, $projectedCloseDate: Date, $source: ProposalSource) {
  createProposal(
    closeConfidence: $closeConfidence
    companyId: $companyId
    contactId: $contactId
    projectedCloseDate: $projectedCloseDate
    source: $source
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type CreateProposalMutationFn = Apollo.MutationFunction<CreateProposalMutation, CreateProposalMutationVariables>;

/**
 * __useCreateProposalMutation__
 *
 * To run a mutation, you first call `useCreateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProposalMutation, { data, loading, error }] = useCreateProposalMutation({
 *   variables: {
 *      closeConfidence: // value for 'closeConfidence'
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      projectedCloseDate: // value for 'projectedCloseDate'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCreateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateProposalMutation, CreateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProposalMutation, CreateProposalMutationVariables>(CreateProposalDocument, options);
      }
export type CreateProposalMutationHookResult = ReturnType<typeof useCreateProposalMutation>;
export type CreateProposalMutationResult = Apollo.MutationResult<CreateProposalMutation>;
export type CreateProposalMutationOptions = Apollo.BaseMutationOptions<CreateProposalMutation, CreateProposalMutationVariables>;
export const CreateProposalFromOpportunityDocument = gql`
    mutation createProposalFromOpportunity($id: ID!) {
  createProposalFromOpportunity(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type CreateProposalFromOpportunityMutationFn = Apollo.MutationFunction<CreateProposalFromOpportunityMutation, CreateProposalFromOpportunityMutationVariables>;

/**
 * __useCreateProposalFromOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateProposalFromOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProposalFromOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProposalFromOpportunityMutation, { data, loading, error }] = useCreateProposalFromOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateProposalFromOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateProposalFromOpportunityMutation, CreateProposalFromOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProposalFromOpportunityMutation, CreateProposalFromOpportunityMutationVariables>(CreateProposalFromOpportunityDocument, options);
      }
export type CreateProposalFromOpportunityMutationHookResult = ReturnType<typeof useCreateProposalFromOpportunityMutation>;
export type CreateProposalFromOpportunityMutationResult = Apollo.MutationResult<CreateProposalFromOpportunityMutation>;
export type CreateProposalFromOpportunityMutationOptions = Apollo.BaseMutationOptions<CreateProposalFromOpportunityMutation, CreateProposalFromOpportunityMutationVariables>;
export const CreateProposalFromProjectMapDocument = gql`
    mutation createProposalFromProjectMap($companyId: ID!, $contactId: ID!, $projectMapId: ID!, $stageName: String) {
  createProposalFromProjectMap(
    companyId: $companyId
    contactId: $contactId
    projectMapId: $projectMapId
    stageName: $stageName
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type CreateProposalFromProjectMapMutationFn = Apollo.MutationFunction<CreateProposalFromProjectMapMutation, CreateProposalFromProjectMapMutationVariables>;

/**
 * __useCreateProposalFromProjectMapMutation__
 *
 * To run a mutation, you first call `useCreateProposalFromProjectMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProposalFromProjectMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProposalFromProjectMapMutation, { data, loading, error }] = useCreateProposalFromProjectMapMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      projectMapId: // value for 'projectMapId'
 *      stageName: // value for 'stageName'
 *   },
 * });
 */
export function useCreateProposalFromProjectMapMutation(baseOptions?: Apollo.MutationHookOptions<CreateProposalFromProjectMapMutation, CreateProposalFromProjectMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProposalFromProjectMapMutation, CreateProposalFromProjectMapMutationVariables>(CreateProposalFromProjectMapDocument, options);
      }
export type CreateProposalFromProjectMapMutationHookResult = ReturnType<typeof useCreateProposalFromProjectMapMutation>;
export type CreateProposalFromProjectMapMutationResult = Apollo.MutationResult<CreateProposalFromProjectMapMutation>;
export type CreateProposalFromProjectMapMutationOptions = Apollo.BaseMutationOptions<CreateProposalFromProjectMapMutation, CreateProposalFromProjectMapMutationVariables>;
export const CreateTaskDocument = gql`
    mutation createTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    assignedUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    completedAt
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    content
    createdAt
    dueAt
    id
    notifiableExternalId
    notifiableId
    notifiableType
    notificationTrigger {
      active
      additionalRecipientTypes
      additionalRecipients {
        email
        firstName
        id
        isTask
        lastName
        taskContent
      }
      apiHeaders
      apiMethod
      apiPayload
      apiSecret
      apiUrl
      content
      delay
      emailSubject
      event
      id
      isApi
      isEmail
      isSMS
      isTask
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      sendToAllRecipients
      sendToContact
      sendToUser
      smsContent
      taskContent
      type
    }
    status
    triggerEvent
    triggerType
    updatedAt
  }
}
    `;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const CreateTimeBucketDocument = gql`
    mutation createTimeBucket($input: CreateTimeBucketInput!) {
  createTimeBucket(input: $input) {
    id
    name
    organizationId
  }
}
    `;
export type CreateTimeBucketMutationFn = Apollo.MutationFunction<CreateTimeBucketMutation, CreateTimeBucketMutationVariables>;

/**
 * __useCreateTimeBucketMutation__
 *
 * To run a mutation, you first call `useCreateTimeBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeBucketMutation, { data, loading, error }] = useCreateTimeBucketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimeBucketMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeBucketMutation, CreateTimeBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeBucketMutation, CreateTimeBucketMutationVariables>(CreateTimeBucketDocument, options);
      }
export type CreateTimeBucketMutationHookResult = ReturnType<typeof useCreateTimeBucketMutation>;
export type CreateTimeBucketMutationResult = Apollo.MutationResult<CreateTimeBucketMutation>;
export type CreateTimeBucketMutationOptions = Apollo.BaseMutationOptions<CreateTimeBucketMutation, CreateTimeBucketMutationVariables>;
export const CreateTimeEntryDocument = gql`
    mutation createTimeEntry($input: CreateTimeEntryInput!) {
  createTimeEntry(input: $input) {
    clockInLatitude
    clockInLongitude
    clockOutLatitude
    clockOutLongitude
    endTime
    forDate
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      checklistNotes
      costingMode
      crewId
      endsAt
      externalId
      hasJobCostsEntered
      id
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    notes
    organizationId
    startTime
    timeBucket {
      id
      name
      organizationId
    }
    timeTrackedSeconds
    timeTrackedSecondsOverride
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    uuid
  }
}
    `;
export type CreateTimeEntryMutationFn = Apollo.MutationFunction<CreateTimeEntryMutation, CreateTimeEntryMutationVariables>;

/**
 * __useCreateTimeEntryMutation__
 *
 * To run a mutation, you first call `useCreateTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeEntryMutation, { data, loading, error }] = useCreateTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeEntryMutation, CreateTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeEntryMutation, CreateTimeEntryMutationVariables>(CreateTimeEntryDocument, options);
      }
export type CreateTimeEntryMutationHookResult = ReturnType<typeof useCreateTimeEntryMutation>;
export type CreateTimeEntryMutationResult = Apollo.MutationResult<CreateTimeEntryMutation>;
export type CreateTimeEntryMutationOptions = Apollo.BaseMutationOptions<CreateTimeEntryMutation, CreateTimeEntryMutationVariables>;
export const CreateTransferTruckDocument = gql`
    mutation createTransferTruck($input: CreateTransferTruckInput!) {
  createTransferTruck(input: $input) {
    defaultRateHourly
    defaultRateTon
    defaultTonnage
    id
    name
  }
}
    `;
export type CreateTransferTruckMutationFn = Apollo.MutationFunction<CreateTransferTruckMutation, CreateTransferTruckMutationVariables>;

/**
 * __useCreateTransferTruckMutation__
 *
 * To run a mutation, you first call `useCreateTransferTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransferTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransferTruckMutation, { data, loading, error }] = useCreateTransferTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransferTruckMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransferTruckMutation, CreateTransferTruckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransferTruckMutation, CreateTransferTruckMutationVariables>(CreateTransferTruckDocument, options);
      }
export type CreateTransferTruckMutationHookResult = ReturnType<typeof useCreateTransferTruckMutation>;
export type CreateTransferTruckMutationResult = Apollo.MutationResult<CreateTransferTruckMutation>;
export type CreateTransferTruckMutationOptions = Apollo.BaseMutationOptions<CreateTransferTruckMutation, CreateTransferTruckMutationVariables>;
export const DeleteAdditionalCostDocument = gql`
    mutation deleteAdditionalCost($id: ID!) {
  deleteAdditionalCost(id: $id)
}
    `;
export type DeleteAdditionalCostMutationFn = Apollo.MutationFunction<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>;

/**
 * __useDeleteAdditionalCostMutation__
 *
 * To run a mutation, you first call `useDeleteAdditionalCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdditionalCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdditionalCostMutation, { data, loading, error }] = useDeleteAdditionalCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdditionalCostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>(DeleteAdditionalCostDocument, options);
      }
export type DeleteAdditionalCostMutationHookResult = ReturnType<typeof useDeleteAdditionalCostMutation>;
export type DeleteAdditionalCostMutationResult = Apollo.MutationResult<DeleteAdditionalCostMutation>;
export type DeleteAdditionalCostMutationOptions = Apollo.BaseMutationOptions<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>;
export const DeleteAiMappingDetectionDocument = gql`
    mutation deleteAiMappingDetection($detectionId: ID!, $runAreaId: ID!) {
  deleteAiMappingDetection(detectionId: $detectionId, runAreaId: $runAreaId) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    detections {
      bbox
      category
      color
      confidence
      id
      isDeleted
      source
      version
    }
    segmentations {
      areaSqft
      category
      color
      id
      isDeleted
      polygon
      version
    }
  }
}
    `;
export type DeleteAiMappingDetectionMutationFn = Apollo.MutationFunction<DeleteAiMappingDetectionMutation, DeleteAiMappingDetectionMutationVariables>;

/**
 * __useDeleteAiMappingDetectionMutation__
 *
 * To run a mutation, you first call `useDeleteAiMappingDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiMappingDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiMappingDetectionMutation, { data, loading, error }] = useDeleteAiMappingDetectionMutation({
 *   variables: {
 *      detectionId: // value for 'detectionId'
 *      runAreaId: // value for 'runAreaId'
 *   },
 * });
 */
export function useDeleteAiMappingDetectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAiMappingDetectionMutation, DeleteAiMappingDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAiMappingDetectionMutation, DeleteAiMappingDetectionMutationVariables>(DeleteAiMappingDetectionDocument, options);
      }
export type DeleteAiMappingDetectionMutationHookResult = ReturnType<typeof useDeleteAiMappingDetectionMutation>;
export type DeleteAiMappingDetectionMutationResult = Apollo.MutationResult<DeleteAiMappingDetectionMutation>;
export type DeleteAiMappingDetectionMutationOptions = Apollo.BaseMutationOptions<DeleteAiMappingDetectionMutation, DeleteAiMappingDetectionMutationVariables>;
export const DeleteAiMappingSegmentationDocument = gql`
    mutation deleteAiMappingSegmentation($runAreaId: ID!, $segmentationId: ID!) {
  deleteAiMappingSegmentation(
    runAreaId: $runAreaId
    segmentationId: $segmentationId
  ) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    detections {
      bbox
      category
      color
      confidence
      id
      isDeleted
      source
      version
    }
    segmentations {
      areaSqft
      category
      color
      id
      isDeleted
      polygon
      version
    }
  }
}
    `;
export type DeleteAiMappingSegmentationMutationFn = Apollo.MutationFunction<DeleteAiMappingSegmentationMutation, DeleteAiMappingSegmentationMutationVariables>;

/**
 * __useDeleteAiMappingSegmentationMutation__
 *
 * To run a mutation, you first call `useDeleteAiMappingSegmentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiMappingSegmentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiMappingSegmentationMutation, { data, loading, error }] = useDeleteAiMappingSegmentationMutation({
 *   variables: {
 *      runAreaId: // value for 'runAreaId'
 *      segmentationId: // value for 'segmentationId'
 *   },
 * });
 */
export function useDeleteAiMappingSegmentationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAiMappingSegmentationMutation, DeleteAiMappingSegmentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAiMappingSegmentationMutation, DeleteAiMappingSegmentationMutationVariables>(DeleteAiMappingSegmentationDocument, options);
      }
export type DeleteAiMappingSegmentationMutationHookResult = ReturnType<typeof useDeleteAiMappingSegmentationMutation>;
export type DeleteAiMappingSegmentationMutationResult = Apollo.MutationResult<DeleteAiMappingSegmentationMutation>;
export type DeleteAiMappingSegmentationMutationOptions = Apollo.BaseMutationOptions<DeleteAiMappingSegmentationMutation, DeleteAiMappingSegmentationMutationVariables>;
export const DeleteCrewDocument = gql`
    mutation deleteCrew($id: ID!) {
  deleteCrew(id: $id)
}
    `;
export type DeleteCrewMutationFn = Apollo.MutationFunction<DeleteCrewMutation, DeleteCrewMutationVariables>;

/**
 * __useDeleteCrewMutation__
 *
 * To run a mutation, you first call `useDeleteCrewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCrewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCrewMutation, { data, loading, error }] = useDeleteCrewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCrewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCrewMutation, DeleteCrewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCrewMutation, DeleteCrewMutationVariables>(DeleteCrewDocument, options);
      }
export type DeleteCrewMutationHookResult = ReturnType<typeof useDeleteCrewMutation>;
export type DeleteCrewMutationResult = Apollo.MutationResult<DeleteCrewMutation>;
export type DeleteCrewMutationOptions = Apollo.BaseMutationOptions<DeleteCrewMutation, DeleteCrewMutationVariables>;
export const DeleteCustomEventDocument = gql`
    mutation deleteCustomEvent($id: ID!) {
  deleteCustomEvent(id: $id) {
    color
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        endsAt
        files {
          customEvent {
            color
            endsAt
            id
            name
            notes
            startsAt
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    files {
      id
      name
      path
    }
    id
    name
    notes
    startsAt
  }
}
    `;
export type DeleteCustomEventMutationFn = Apollo.MutationFunction<DeleteCustomEventMutation, DeleteCustomEventMutationVariables>;

/**
 * __useDeleteCustomEventMutation__
 *
 * To run a mutation, you first call `useDeleteCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomEventMutation, { data, loading, error }] = useDeleteCustomEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomEventMutation, DeleteCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomEventMutation, DeleteCustomEventMutationVariables>(DeleteCustomEventDocument, options);
      }
export type DeleteCustomEventMutationHookResult = ReturnType<typeof useDeleteCustomEventMutation>;
export type DeleteCustomEventMutationResult = Apollo.MutationResult<DeleteCustomEventMutation>;
export type DeleteCustomEventMutationOptions = Apollo.BaseMutationOptions<DeleteCustomEventMutation, DeleteCustomEventMutationVariables>;
export const DeleteDailyFormInspectionDocument = gql`
    mutation deleteDailyFormInspection($id: ID!) {
  deleteDailyFormInspection(id: $id) {
    createdAt
    dailyFormVehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      registrationExpirationDate
      registrationState
      vin
      year
    }
    id
    lightsWork
    loadStrapped
    oilChecked
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    questionAnswers {
      answer
      id
      isTrue
    }
    tiresAiredBrakesWorking
    toolsLoaded
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    vehicleConditionAcceptable
    vehicleFueled
    vehicleMilleage
  }
}
    `;
export type DeleteDailyFormInspectionMutationFn = Apollo.MutationFunction<DeleteDailyFormInspectionMutation, DeleteDailyFormInspectionMutationVariables>;

/**
 * __useDeleteDailyFormInspectionMutation__
 *
 * To run a mutation, you first call `useDeleteDailyFormInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyFormInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyFormInspectionMutation, { data, loading, error }] = useDeleteDailyFormInspectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDailyFormInspectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDailyFormInspectionMutation, DeleteDailyFormInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDailyFormInspectionMutation, DeleteDailyFormInspectionMutationVariables>(DeleteDailyFormInspectionDocument, options);
      }
export type DeleteDailyFormInspectionMutationHookResult = ReturnType<typeof useDeleteDailyFormInspectionMutation>;
export type DeleteDailyFormInspectionMutationResult = Apollo.MutationResult<DeleteDailyFormInspectionMutation>;
export type DeleteDailyFormInspectionMutationOptions = Apollo.BaseMutationOptions<DeleteDailyFormInspectionMutation, DeleteDailyFormInspectionMutationVariables>;
export const DeleteDailyFormInspectionQuestionDocument = gql`
    mutation deleteDailyFormInspectionQuestion($id: ID!) {
  deleteDailyFormInspectionQuestion(id: $id) {
    id
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    question
    type
  }
}
    `;
export type DeleteDailyFormInspectionQuestionMutationFn = Apollo.MutationFunction<DeleteDailyFormInspectionQuestionMutation, DeleteDailyFormInspectionQuestionMutationVariables>;

/**
 * __useDeleteDailyFormInspectionQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteDailyFormInspectionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyFormInspectionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyFormInspectionQuestionMutation, { data, loading, error }] = useDeleteDailyFormInspectionQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDailyFormInspectionQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDailyFormInspectionQuestionMutation, DeleteDailyFormInspectionQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDailyFormInspectionQuestionMutation, DeleteDailyFormInspectionQuestionMutationVariables>(DeleteDailyFormInspectionQuestionDocument, options);
      }
export type DeleteDailyFormInspectionQuestionMutationHookResult = ReturnType<typeof useDeleteDailyFormInspectionQuestionMutation>;
export type DeleteDailyFormInspectionQuestionMutationResult = Apollo.MutationResult<DeleteDailyFormInspectionQuestionMutation>;
export type DeleteDailyFormInspectionQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteDailyFormInspectionQuestionMutation, DeleteDailyFormInspectionQuestionMutationVariables>;
export const DeleteDailyFormVehicleDocument = gql`
    mutation deleteDailyFormVehicle($id: ID!) {
  deleteDailyFormVehicle(id: $id) {
    currentMeterReading
    dailyFormVehicleType {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    defaultServiceIntervalUnit
    defaultServiceIntervalValue
    id
    inServiceDate
    inspections {
      createdAt
      dailyFormVehicle {
        currentMeterReading
        dailyFormVehicleType {
          id
          name
        }
        defaultServiceIntervalUnit
        defaultServiceIntervalValue
        id
        inServiceDate
        inspections {
          createdAt
          id
          lightsWork
          loadStrapped
          oilChecked
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          questionAnswers {
            answer
            id
            isTrue
          }
          tiresAiredBrakesWorking
          toolsLoaded
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicleConditionAcceptable
          vehicleFueled
          vehicleMilleage
        }
        isActive
        licensePlate
        make
        meterType
        model
        name
        notes
        parts {
          id
          name
          notes
          partNumber
          quantity
          unitPrice
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          vendorName
        }
        registrationExpirationDate
        registrationState
        servicePlans {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        vin
        workOrders {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        year
      }
      id
      lightsWork
      loadStrapped
      oilChecked
      tiresAiredBrakesWorking
      toolsLoaded
      vehicleConditionAcceptable
      vehicleFueled
      vehicleMilleage
    }
    isActive
    licensePlate
    make
    meterType
    model
    name
    notes
    parts {
      id
      name
      notes
      partNumber
      quantity
      unitPrice
      vendorName
    }
    registrationExpirationDate
    registrationState
    servicePlans {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    vin
    workOrders {
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      status
    }
    year
  }
}
    `;
export type DeleteDailyFormVehicleMutationFn = Apollo.MutationFunction<DeleteDailyFormVehicleMutation, DeleteDailyFormVehicleMutationVariables>;

/**
 * __useDeleteDailyFormVehicleMutation__
 *
 * To run a mutation, you first call `useDeleteDailyFormVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyFormVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyFormVehicleMutation, { data, loading, error }] = useDeleteDailyFormVehicleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDailyFormVehicleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDailyFormVehicleMutation, DeleteDailyFormVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDailyFormVehicleMutation, DeleteDailyFormVehicleMutationVariables>(DeleteDailyFormVehicleDocument, options);
      }
export type DeleteDailyFormVehicleMutationHookResult = ReturnType<typeof useDeleteDailyFormVehicleMutation>;
export type DeleteDailyFormVehicleMutationResult = Apollo.MutationResult<DeleteDailyFormVehicleMutation>;
export type DeleteDailyFormVehicleMutationOptions = Apollo.BaseMutationOptions<DeleteDailyFormVehicleMutation, DeleteDailyFormVehicleMutationVariables>;
export const DeleteDailyFormVehiclePartDocument = gql`
    mutation deleteDailyFormVehiclePart($id: ID!) {
  deleteDailyFormVehiclePart(id: $id) {
    id
    name
    notes
    partNumber
    quantity
    unitPrice
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    vendorName
  }
}
    `;
export type DeleteDailyFormVehiclePartMutationFn = Apollo.MutationFunction<DeleteDailyFormVehiclePartMutation, DeleteDailyFormVehiclePartMutationVariables>;

/**
 * __useDeleteDailyFormVehiclePartMutation__
 *
 * To run a mutation, you first call `useDeleteDailyFormVehiclePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyFormVehiclePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyFormVehiclePartMutation, { data, loading, error }] = useDeleteDailyFormVehiclePartMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDailyFormVehiclePartMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDailyFormVehiclePartMutation, DeleteDailyFormVehiclePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDailyFormVehiclePartMutation, DeleteDailyFormVehiclePartMutationVariables>(DeleteDailyFormVehiclePartDocument, options);
      }
export type DeleteDailyFormVehiclePartMutationHookResult = ReturnType<typeof useDeleteDailyFormVehiclePartMutation>;
export type DeleteDailyFormVehiclePartMutationResult = Apollo.MutationResult<DeleteDailyFormVehiclePartMutation>;
export type DeleteDailyFormVehiclePartMutationOptions = Apollo.BaseMutationOptions<DeleteDailyFormVehiclePartMutation, DeleteDailyFormVehiclePartMutationVariables>;
export const DeleteDailyFormVehicleServicePlanDocument = gql`
    mutation deleteDailyFormVehicleServicePlan($id: ID!) {
  deleteDailyFormVehicleServicePlan(id: $id) {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    autoCreateTask
    id
    intervalUnit
    intervalValue
    isActive
    issueType
    lastCompletedAt
    lastCompletedMeterReading
    leadUnit
    leadValue
    name
    nextDueDate
    nextDueMeterReading
    notes
    priority
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    workOrders {
      assignedTo {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      files {
        dailyFormWorkOrder {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        path
      }
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      servicePlan {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        autoCreateTask
        id
        intervalUnit
        intervalValue
        isActive
        issueType
        lastCompletedAt
        lastCompletedMeterReading
        leadUnit
        leadValue
        name
        nextDueDate
        nextDueMeterReading
        notes
        priority
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          vin
          year
        }
        workOrders {
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
      }
      status
    }
  }
}
    `;
export type DeleteDailyFormVehicleServicePlanMutationFn = Apollo.MutationFunction<DeleteDailyFormVehicleServicePlanMutation, DeleteDailyFormVehicleServicePlanMutationVariables>;

/**
 * __useDeleteDailyFormVehicleServicePlanMutation__
 *
 * To run a mutation, you first call `useDeleteDailyFormVehicleServicePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyFormVehicleServicePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyFormVehicleServicePlanMutation, { data, loading, error }] = useDeleteDailyFormVehicleServicePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDailyFormVehicleServicePlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDailyFormVehicleServicePlanMutation, DeleteDailyFormVehicleServicePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDailyFormVehicleServicePlanMutation, DeleteDailyFormVehicleServicePlanMutationVariables>(DeleteDailyFormVehicleServicePlanDocument, options);
      }
export type DeleteDailyFormVehicleServicePlanMutationHookResult = ReturnType<typeof useDeleteDailyFormVehicleServicePlanMutation>;
export type DeleteDailyFormVehicleServicePlanMutationResult = Apollo.MutationResult<DeleteDailyFormVehicleServicePlanMutation>;
export type DeleteDailyFormVehicleServicePlanMutationOptions = Apollo.BaseMutationOptions<DeleteDailyFormVehicleServicePlanMutation, DeleteDailyFormVehicleServicePlanMutationVariables>;
export const DeleteDailyFormVehicleTypeDocument = gql`
    mutation deleteDailyFormVehicleType($id: ID!) {
  deleteDailyFormVehicleType(id: $id) {
    id
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;
export type DeleteDailyFormVehicleTypeMutationFn = Apollo.MutationFunction<DeleteDailyFormVehicleTypeMutation, DeleteDailyFormVehicleTypeMutationVariables>;

/**
 * __useDeleteDailyFormVehicleTypeMutation__
 *
 * To run a mutation, you first call `useDeleteDailyFormVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyFormVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyFormVehicleTypeMutation, { data, loading, error }] = useDeleteDailyFormVehicleTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDailyFormVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDailyFormVehicleTypeMutation, DeleteDailyFormVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDailyFormVehicleTypeMutation, DeleteDailyFormVehicleTypeMutationVariables>(DeleteDailyFormVehicleTypeDocument, options);
      }
export type DeleteDailyFormVehicleTypeMutationHookResult = ReturnType<typeof useDeleteDailyFormVehicleTypeMutation>;
export type DeleteDailyFormVehicleTypeMutationResult = Apollo.MutationResult<DeleteDailyFormVehicleTypeMutation>;
export type DeleteDailyFormVehicleTypeMutationOptions = Apollo.BaseMutationOptions<DeleteDailyFormVehicleTypeMutation, DeleteDailyFormVehicleTypeMutationVariables>;
export const DeleteDailyFormWorkOrderDocument = gql`
    mutation deleteDailyFormWorkOrder($id: ID!) {
  deleteDailyFormWorkOrder(id: $id) {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    comments
    completedAt
    createdAt
    currentMeterReading
    estimatedTaskTime
    files {
      dailyFormWorkOrder {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        comments
        completedAt
        createdAt
        currentMeterReading
        estimatedTaskTime
        files {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        issueDescription
        issueName
        issueType
        neededCompletionDate
        priority
        servicePlan {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
      }
      id
      name
      path
    }
    id
    issueDescription
    issueName
    issueType
    neededCompletionDate
    priority
    servicePlan {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    vehicle {
      currentMeterReading
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      registrationExpirationDate
      registrationState
      vin
      year
    }
  }
}
    `;
export type DeleteDailyFormWorkOrderMutationFn = Apollo.MutationFunction<DeleteDailyFormWorkOrderMutation, DeleteDailyFormWorkOrderMutationVariables>;

/**
 * __useDeleteDailyFormWorkOrderMutation__
 *
 * To run a mutation, you first call `useDeleteDailyFormWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyFormWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyFormWorkOrderMutation, { data, loading, error }] = useDeleteDailyFormWorkOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDailyFormWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDailyFormWorkOrderMutation, DeleteDailyFormWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDailyFormWorkOrderMutation, DeleteDailyFormWorkOrderMutationVariables>(DeleteDailyFormWorkOrderDocument, options);
      }
export type DeleteDailyFormWorkOrderMutationHookResult = ReturnType<typeof useDeleteDailyFormWorkOrderMutation>;
export type DeleteDailyFormWorkOrderMutationResult = Apollo.MutationResult<DeleteDailyFormWorkOrderMutation>;
export type DeleteDailyFormWorkOrderMutationOptions = Apollo.BaseMutationOptions<DeleteDailyFormWorkOrderMutation, DeleteDailyFormWorkOrderMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation deleteEmployee($id: ID!) {
  deleteEmployee(id: $id)
}
    `;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const DeleteEquipmentPieceDocument = gql`
    mutation deleteEquipmentPiece($id: ID!) {
  deleteEquipmentPiece(id: $id)
}
    `;
export type DeleteEquipmentPieceMutationFn = Apollo.MutationFunction<DeleteEquipmentPieceMutation, DeleteEquipmentPieceMutationVariables>;

/**
 * __useDeleteEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentPieceMutation, { data, loading, error }] = useDeleteEquipmentPieceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEquipmentPieceMutation, DeleteEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEquipmentPieceMutation, DeleteEquipmentPieceMutationVariables>(DeleteEquipmentPieceDocument, options);
      }
export type DeleteEquipmentPieceMutationHookResult = ReturnType<typeof useDeleteEquipmentPieceMutation>;
export type DeleteEquipmentPieceMutationResult = Apollo.MutationResult<DeleteEquipmentPieceMutation>;
export type DeleteEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<DeleteEquipmentPieceMutation, DeleteEquipmentPieceMutationVariables>;
export const DeleteJobPhaseCostDocument = gql`
    mutation deleteJobPhaseCost($date: Date!, $jobPhaseId: ID!) {
  deleteJobPhaseCost(date: $date, jobPhaseId: $jobPhaseId)
}
    `;
export type DeleteJobPhaseCostMutationFn = Apollo.MutationFunction<DeleteJobPhaseCostMutation, DeleteJobPhaseCostMutationVariables>;

/**
 * __useDeleteJobPhaseCostMutation__
 *
 * To run a mutation, you first call `useDeleteJobPhaseCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobPhaseCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobPhaseCostMutation, { data, loading, error }] = useDeleteJobPhaseCostMutation({
 *   variables: {
 *      date: // value for 'date'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useDeleteJobPhaseCostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobPhaseCostMutation, DeleteJobPhaseCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobPhaseCostMutation, DeleteJobPhaseCostMutationVariables>(DeleteJobPhaseCostDocument, options);
      }
export type DeleteJobPhaseCostMutationHookResult = ReturnType<typeof useDeleteJobPhaseCostMutation>;
export type DeleteJobPhaseCostMutationResult = Apollo.MutationResult<DeleteJobPhaseCostMutation>;
export type DeleteJobPhaseCostMutationOptions = Apollo.BaseMutationOptions<DeleteJobPhaseCostMutation, DeleteJobPhaseCostMutationVariables>;
export const DeleteJobPhaseFileDocument = gql`
    mutation deleteJobPhaseFile($id: ID!) {
  deleteJobPhaseFile(id: $id)
}
    `;
export type DeleteJobPhaseFileMutationFn = Apollo.MutationFunction<DeleteJobPhaseFileMutation, DeleteJobPhaseFileMutationVariables>;

/**
 * __useDeleteJobPhaseFileMutation__
 *
 * To run a mutation, you first call `useDeleteJobPhaseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobPhaseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobPhaseFileMutation, { data, loading, error }] = useDeleteJobPhaseFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobPhaseFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobPhaseFileMutation, DeleteJobPhaseFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobPhaseFileMutation, DeleteJobPhaseFileMutationVariables>(DeleteJobPhaseFileDocument, options);
      }
export type DeleteJobPhaseFileMutationHookResult = ReturnType<typeof useDeleteJobPhaseFileMutation>;
export type DeleteJobPhaseFileMutationResult = Apollo.MutationResult<DeleteJobPhaseFileMutation>;
export type DeleteJobPhaseFileMutationOptions = Apollo.BaseMutationOptions<DeleteJobPhaseFileMutation, DeleteJobPhaseFileMutationVariables>;
export const DeleteNotificationTriggerDocument = gql`
    mutation deleteNotificationTrigger($id: ID!) {
  deleteNotificationTrigger(id: $id)
}
    `;
export type DeleteNotificationTriggerMutationFn = Apollo.MutationFunction<DeleteNotificationTriggerMutation, DeleteNotificationTriggerMutationVariables>;

/**
 * __useDeleteNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationTriggerMutation, { data, loading, error }] = useDeleteNotificationTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationTriggerMutation, DeleteNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationTriggerMutation, DeleteNotificationTriggerMutationVariables>(DeleteNotificationTriggerDocument, options);
      }
export type DeleteNotificationTriggerMutationHookResult = ReturnType<typeof useDeleteNotificationTriggerMutation>;
export type DeleteNotificationTriggerMutationResult = Apollo.MutationResult<DeleteNotificationTriggerMutation>;
export type DeleteNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationTriggerMutation, DeleteNotificationTriggerMutationVariables>;
export const DeleteOpportunityDocument = gql`
    mutation deleteOpportunity($id: ID!) {
  deleteOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;
export type DeleteOpportunityMutationFn = Apollo.MutationFunction<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>;

/**
 * __useDeleteOpportunityMutation__
 *
 * To run a mutation, you first call `useDeleteOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpportunityMutation, { data, loading, error }] = useDeleteOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>(DeleteOpportunityDocument, options);
      }
export type DeleteOpportunityMutationHookResult = ReturnType<typeof useDeleteOpportunityMutation>;
export type DeleteOpportunityMutationResult = Apollo.MutationResult<DeleteOpportunityMutation>;
export type DeleteOpportunityMutationOptions = Apollo.BaseMutationOptions<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>;
export const DeleteOrganizationAddressDocument = gql`
    mutation deleteOrganizationAddress($id: ID!) {
  deleteOrganizationAddress(id: $id)
}
    `;
export type DeleteOrganizationAddressMutationFn = Apollo.MutationFunction<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>;

/**
 * __useDeleteOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationAddressMutation, { data, loading, error }] = useDeleteOrganizationAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>(DeleteOrganizationAddressDocument, options);
      }
export type DeleteOrganizationAddressMutationHookResult = ReturnType<typeof useDeleteOrganizationAddressMutation>;
export type DeleteOrganizationAddressMutationResult = Apollo.MutationResult<DeleteOrganizationAddressMutation>;
export type DeleteOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>;
export const DeleteOrganizationCustomContentTypeDocument = gql`
    mutation deleteOrganizationCustomContentType($contentType: String!) {
  deleteOrganizationCustomContentType(contentType: $contentType)
}
    `;
export type DeleteOrganizationCustomContentTypeMutationFn = Apollo.MutationFunction<DeleteOrganizationCustomContentTypeMutation, DeleteOrganizationCustomContentTypeMutationVariables>;

/**
 * __useDeleteOrganizationCustomContentTypeMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationCustomContentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationCustomContentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationCustomContentTypeMutation, { data, loading, error }] = useDeleteOrganizationCustomContentTypeMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useDeleteOrganizationCustomContentTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationCustomContentTypeMutation, DeleteOrganizationCustomContentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationCustomContentTypeMutation, DeleteOrganizationCustomContentTypeMutationVariables>(DeleteOrganizationCustomContentTypeDocument, options);
      }
export type DeleteOrganizationCustomContentTypeMutationHookResult = ReturnType<typeof useDeleteOrganizationCustomContentTypeMutation>;
export type DeleteOrganizationCustomContentTypeMutationResult = Apollo.MutationResult<DeleteOrganizationCustomContentTypeMutation>;
export type DeleteOrganizationCustomContentTypeMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationCustomContentTypeMutation, DeleteOrganizationCustomContentTypeMutationVariables>;
export const DeleteOrganizationDocumentDocument = gql`
    mutation deleteOrganizationDocument($id: ID!) {
  deleteOrganizationDocument(id: $id)
}
    `;
export type DeleteOrganizationDocumentMutationFn = Apollo.MutationFunction<DeleteOrganizationDocumentMutation, DeleteOrganizationDocumentMutationVariables>;

/**
 * __useDeleteOrganizationDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationDocumentMutation, { data, loading, error }] = useDeleteOrganizationDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationDocumentMutation, DeleteOrganizationDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationDocumentMutation, DeleteOrganizationDocumentMutationVariables>(DeleteOrganizationDocumentDocument, options);
      }
export type DeleteOrganizationDocumentMutationHookResult = ReturnType<typeof useDeleteOrganizationDocumentMutation>;
export type DeleteOrganizationDocumentMutationResult = Apollo.MutationResult<DeleteOrganizationDocumentMutation>;
export type DeleteOrganizationDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationDocumentMutation, DeleteOrganizationDocumentMutationVariables>;
export const DeleteOrganizationEmailIdentityDocument = gql`
    mutation deleteOrganizationEmailIdentity {
  deleteOrganizationEmailIdentity
}
    `;
export type DeleteOrganizationEmailIdentityMutationFn = Apollo.MutationFunction<DeleteOrganizationEmailIdentityMutation, DeleteOrganizationEmailIdentityMutationVariables>;

/**
 * __useDeleteOrganizationEmailIdentityMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationEmailIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationEmailIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationEmailIdentityMutation, { data, loading, error }] = useDeleteOrganizationEmailIdentityMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteOrganizationEmailIdentityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationEmailIdentityMutation, DeleteOrganizationEmailIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationEmailIdentityMutation, DeleteOrganizationEmailIdentityMutationVariables>(DeleteOrganizationEmailIdentityDocument, options);
      }
export type DeleteOrganizationEmailIdentityMutationHookResult = ReturnType<typeof useDeleteOrganizationEmailIdentityMutation>;
export type DeleteOrganizationEmailIdentityMutationResult = Apollo.MutationResult<DeleteOrganizationEmailIdentityMutation>;
export type DeleteOrganizationEmailIdentityMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationEmailIdentityMutation, DeleteOrganizationEmailIdentityMutationVariables>;
export const DeleteOrganizationProductTypeDocument = gql`
    mutation deleteOrganizationProductType($id: ID!) {
  deleteOrganizationProductType(id: $id)
}
    `;
export type DeleteOrganizationProductTypeMutationFn = Apollo.MutationFunction<DeleteOrganizationProductTypeMutation, DeleteOrganizationProductTypeMutationVariables>;

/**
 * __useDeleteOrganizationProductTypeMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationProductTypeMutation, { data, loading, error }] = useDeleteOrganizationProductTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationProductTypeMutation, DeleteOrganizationProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationProductTypeMutation, DeleteOrganizationProductTypeMutationVariables>(DeleteOrganizationProductTypeDocument, options);
      }
export type DeleteOrganizationProductTypeMutationHookResult = ReturnType<typeof useDeleteOrganizationProductTypeMutation>;
export type DeleteOrganizationProductTypeMutationResult = Apollo.MutationResult<DeleteOrganizationProductTypeMutation>;
export type DeleteOrganizationProductTypeMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationProductTypeMutation, DeleteOrganizationProductTypeMutationVariables>;
export const DeleteOrganizationProposalChecklistItemDocument = gql`
    mutation deleteOrganizationProposalChecklistItem($id: ID!) {
  deleteOrganizationProposalChecklistItem(id: $id) {
    id
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;
export type DeleteOrganizationProposalChecklistItemMutationFn = Apollo.MutationFunction<DeleteOrganizationProposalChecklistItemMutation, DeleteOrganizationProposalChecklistItemMutationVariables>;

/**
 * __useDeleteOrganizationProposalChecklistItemMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationProposalChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationProposalChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationProposalChecklistItemMutation, { data, loading, error }] = useDeleteOrganizationProposalChecklistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationProposalChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationProposalChecklistItemMutation, DeleteOrganizationProposalChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationProposalChecklistItemMutation, DeleteOrganizationProposalChecklistItemMutationVariables>(DeleteOrganizationProposalChecklistItemDocument, options);
      }
export type DeleteOrganizationProposalChecklistItemMutationHookResult = ReturnType<typeof useDeleteOrganizationProposalChecklistItemMutation>;
export type DeleteOrganizationProposalChecklistItemMutationResult = Apollo.MutationResult<DeleteOrganizationProposalChecklistItemMutation>;
export type DeleteOrganizationProposalChecklistItemMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationProposalChecklistItemMutation, DeleteOrganizationProposalChecklistItemMutationVariables>;
export const DeleteOrganizationUserDocument = gql`
    mutation deleteOrganizationUser($id: ID!, $openProposalAction: DeleteOpenProposalAction!, $reassignJobPhaseForemanUserId: ID, $reassignJobUserId: ID, $reassignUserId: ID) {
  deleteOrganizationUser(
    id: $id
    openProposalAction: $openProposalAction
    reassignJobPhaseForemanUserId: $reassignJobPhaseForemanUserId
    reassignJobUserId: $reassignJobUserId
    reassignUserId: $reassignUserId
  )
}
    `;
export type DeleteOrganizationUserMutationFn = Apollo.MutationFunction<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>;

/**
 * __useDeleteOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationUserMutation, { data, loading, error }] = useDeleteOrganizationUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      openProposalAction: // value for 'openProposalAction'
 *      reassignJobPhaseForemanUserId: // value for 'reassignJobPhaseForemanUserId'
 *      reassignJobUserId: // value for 'reassignJobUserId'
 *      reassignUserId: // value for 'reassignUserId'
 *   },
 * });
 */
export function useDeleteOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>(DeleteOrganizationUserDocument, options);
      }
export type DeleteOrganizationUserMutationHookResult = ReturnType<typeof useDeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationResult = Apollo.MutationResult<DeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>;
export const DeletePlantDocument = gql`
    mutation deletePlant($id: ID!) {
  deletePlant(id: $id)
}
    `;
export type DeletePlantMutationFn = Apollo.MutationFunction<DeletePlantMutation, DeletePlantMutationVariables>;

/**
 * __useDeletePlantMutation__
 *
 * To run a mutation, you first call `useDeletePlantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlantMutation, { data, loading, error }] = useDeletePlantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlantMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlantMutation, DeletePlantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlantMutation, DeletePlantMutationVariables>(DeletePlantDocument, options);
      }
export type DeletePlantMutationHookResult = ReturnType<typeof useDeletePlantMutation>;
export type DeletePlantMutationResult = Apollo.MutationResult<DeletePlantMutation>;
export type DeletePlantMutationOptions = Apollo.BaseMutationOptions<DeletePlantMutation, DeletePlantMutationVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($id: ID!) {
  deleteProduct(id: $id)
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const DeleteProductGroupDocument = gql`
    mutation deleteProductGroup($id: ID!) {
  deleteProductGroup(id: $id)
}
    `;
export type DeleteProductGroupMutationFn = Apollo.MutationFunction<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>;

/**
 * __useDeleteProductGroupMutation__
 *
 * To run a mutation, you first call `useDeleteProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductGroupMutation, { data, loading, error }] = useDeleteProductGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>(DeleteProductGroupDocument, options);
      }
export type DeleteProductGroupMutationHookResult = ReturnType<typeof useDeleteProductGroupMutation>;
export type DeleteProductGroupMutationResult = Apollo.MutationResult<DeleteProductGroupMutation>;
export type DeleteProductGroupMutationOptions = Apollo.BaseMutationOptions<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>;
export const DeleteProjectFileDocument = gql`
    mutation deleteProjectFile($id: ID!) {
  deleteProjectFile(id: $id) {
    children {
      children {
        createdAt
        fileSizeBytes
        id
        name
        parentFolderId
        path
        pivot {
          id
        }
        type
      }
      createdAt
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    createdAt
    fileSizeBytes
    id
    name
    parentFolderId
    path
    pivot {
      id
    }
    type
  }
}
    `;
export type DeleteProjectFileMutationFn = Apollo.MutationFunction<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>;

/**
 * __useDeleteProjectFileMutation__
 *
 * To run a mutation, you first call `useDeleteProjectFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectFileMutation, { data, loading, error }] = useDeleteProjectFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>(DeleteProjectFileDocument, options);
      }
export type DeleteProjectFileMutationHookResult = ReturnType<typeof useDeleteProjectFileMutation>;
export type DeleteProjectFileMutationResult = Apollo.MutationResult<DeleteProjectFileMutation>;
export type DeleteProjectFileMutationOptions = Apollo.BaseMutationOptions<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>;
export const DeleteProjectMapDocument = gql`
    mutation deleteProjectMap($id: ID!) {
  deleteProjectMap(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    createdAt
    createdBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    description
    id
    latitude
    longitude
    mapData
    mapImage
    mapImageDirty
    measurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
    name
    updatedAt
  }
}
    `;
export type DeleteProjectMapMutationFn = Apollo.MutationFunction<DeleteProjectMapMutation, DeleteProjectMapMutationVariables>;

/**
 * __useDeleteProjectMapMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMapMutation, { data, loading, error }] = useDeleteProjectMapMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMapMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMapMutation, DeleteProjectMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMapMutation, DeleteProjectMapMutationVariables>(DeleteProjectMapDocument, options);
      }
export type DeleteProjectMapMutationHookResult = ReturnType<typeof useDeleteProjectMapMutation>;
export type DeleteProjectMapMutationResult = Apollo.MutationResult<DeleteProjectMapMutation>;
export type DeleteProjectMapMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMapMutation, DeleteProjectMapMutationVariables>;
export const DeleteProposalDocument = gql`
    mutation deleteProposal($id: ID!) {
  deleteProposal(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type DeleteProposalMutationFn = Apollo.MutationFunction<DeleteProposalMutation, DeleteProposalMutationVariables>;

/**
 * __useDeleteProposalMutation__
 *
 * To run a mutation, you first call `useDeleteProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalMutation, { data, loading, error }] = useDeleteProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalMutation, DeleteProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalMutation, DeleteProposalMutationVariables>(DeleteProposalDocument, options);
      }
export type DeleteProposalMutationHookResult = ReturnType<typeof useDeleteProposalMutation>;
export type DeleteProposalMutationResult = Apollo.MutationResult<DeleteProposalMutation>;
export type DeleteProposalMutationOptions = Apollo.BaseMutationOptions<DeleteProposalMutation, DeleteProposalMutationVariables>;
export const DeleteProposalFileDocument = gql`
    mutation deleteProposalFile($id: ID!) {
  deleteProposalFile(id: $id)
}
    `;
export type DeleteProposalFileMutationFn = Apollo.MutationFunction<DeleteProposalFileMutation, DeleteProposalFileMutationVariables>;

/**
 * __useDeleteProposalFileMutation__
 *
 * To run a mutation, you first call `useDeleteProposalFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalFileMutation, { data, loading, error }] = useDeleteProposalFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalFileMutation, DeleteProposalFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalFileMutation, DeleteProposalFileMutationVariables>(DeleteProposalFileDocument, options);
      }
export type DeleteProposalFileMutationHookResult = ReturnType<typeof useDeleteProposalFileMutation>;
export type DeleteProposalFileMutationResult = Apollo.MutationResult<DeleteProposalFileMutation>;
export type DeleteProposalFileMutationOptions = Apollo.BaseMutationOptions<DeleteProposalFileMutation, DeleteProposalFileMutationVariables>;
export const DeleteProposalMapImageDocument = gql`
    mutation deleteProposalMapImage($id: ID!) {
  deleteProposalMapImage(id: $id)
}
    `;
export type DeleteProposalMapImageMutationFn = Apollo.MutationFunction<DeleteProposalMapImageMutation, DeleteProposalMapImageMutationVariables>;

/**
 * __useDeleteProposalMapImageMutation__
 *
 * To run a mutation, you first call `useDeleteProposalMapImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalMapImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalMapImageMutation, { data, loading, error }] = useDeleteProposalMapImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalMapImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalMapImageMutation, DeleteProposalMapImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalMapImageMutation, DeleteProposalMapImageMutationVariables>(DeleteProposalMapImageDocument, options);
      }
export type DeleteProposalMapImageMutationHookResult = ReturnType<typeof useDeleteProposalMapImageMutation>;
export type DeleteProposalMapImageMutationResult = Apollo.MutationResult<DeleteProposalMapImageMutation>;
export type DeleteProposalMapImageMutationOptions = Apollo.BaseMutationOptions<DeleteProposalMapImageMutation, DeleteProposalMapImageMutationVariables>;
export const DeleteProposalMaterialNoPlantDocument = gql`
    mutation deleteProposalMaterialNoPlant($id: ID!) {
  deleteProposalMaterialNoPlant(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type DeleteProposalMaterialNoPlantMutationFn = Apollo.MutationFunction<DeleteProposalMaterialNoPlantMutation, DeleteProposalMaterialNoPlantMutationVariables>;

/**
 * __useDeleteProposalMaterialNoPlantMutation__
 *
 * To run a mutation, you first call `useDeleteProposalMaterialNoPlantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalMaterialNoPlantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalMaterialNoPlantMutation, { data, loading, error }] = useDeleteProposalMaterialNoPlantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalMaterialNoPlantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalMaterialNoPlantMutation, DeleteProposalMaterialNoPlantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalMaterialNoPlantMutation, DeleteProposalMaterialNoPlantMutationVariables>(DeleteProposalMaterialNoPlantDocument, options);
      }
export type DeleteProposalMaterialNoPlantMutationHookResult = ReturnType<typeof useDeleteProposalMaterialNoPlantMutation>;
export type DeleteProposalMaterialNoPlantMutationResult = Apollo.MutationResult<DeleteProposalMaterialNoPlantMutation>;
export type DeleteProposalMaterialNoPlantMutationOptions = Apollo.BaseMutationOptions<DeleteProposalMaterialNoPlantMutation, DeleteProposalMaterialNoPlantMutationVariables>;
export const DeleteProposalPlantProductDocument = gql`
    mutation deleteProposalPlantProduct($id: ID!) {
  deleteProposalPlantProduct(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type DeleteProposalPlantProductMutationFn = Apollo.MutationFunction<DeleteProposalPlantProductMutation, DeleteProposalPlantProductMutationVariables>;

/**
 * __useDeleteProposalPlantProductMutation__
 *
 * To run a mutation, you first call `useDeleteProposalPlantProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalPlantProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalPlantProductMutation, { data, loading, error }] = useDeleteProposalPlantProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalPlantProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalPlantProductMutation, DeleteProposalPlantProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalPlantProductMutation, DeleteProposalPlantProductMutationVariables>(DeleteProposalPlantProductDocument, options);
      }
export type DeleteProposalPlantProductMutationHookResult = ReturnType<typeof useDeleteProposalPlantProductMutation>;
export type DeleteProposalPlantProductMutationResult = Apollo.MutationResult<DeleteProposalPlantProductMutation>;
export type DeleteProposalPlantProductMutationOptions = Apollo.BaseMutationOptions<DeleteProposalPlantProductMutation, DeleteProposalPlantProductMutationVariables>;
export const DeleteProposalProductDocument = gql`
    mutation deleteProposalProduct($id: ID!) {
  deleteProposalProduct(id: $id) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    checklistItems {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    checklistNotes
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    discount
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalAfterDiscount
    profit
    profitAfterDiscount
    profitPercentage
    proposalProductGroups {
      id
      isOptional
      name
      ordering
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          helpers {
            hoursPerDay
          }
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricing {
            discount
            mode
            value
            version
          }
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            quantitySource
            rate
            rowId
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          children {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      showIndividualProducts
    }
    proposalProducts {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    roundTripTravelTimeHours
    stageMeasurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
  }
}
    `;
export type DeleteProposalProductMutationFn = Apollo.MutationFunction<DeleteProposalProductMutation, DeleteProposalProductMutationVariables>;

/**
 * __useDeleteProposalProductMutation__
 *
 * To run a mutation, you first call `useDeleteProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalProductMutation, { data, loading, error }] = useDeleteProposalProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalProductMutation, DeleteProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalProductMutation, DeleteProposalProductMutationVariables>(DeleteProposalProductDocument, options);
      }
export type DeleteProposalProductMutationHookResult = ReturnType<typeof useDeleteProposalProductMutation>;
export type DeleteProposalProductMutationResult = Apollo.MutationResult<DeleteProposalProductMutation>;
export type DeleteProposalProductMutationOptions = Apollo.BaseMutationOptions<DeleteProposalProductMutation, DeleteProposalProductMutationVariables>;
export const DeleteProposalProductProjectFileDocument = gql`
    mutation deleteProposalProductProjectFile($id: ID!) {
  deleteProposalProductProjectFile(id: $id)
}
    `;
export type DeleteProposalProductProjectFileMutationFn = Apollo.MutationFunction<DeleteProposalProductProjectFileMutation, DeleteProposalProductProjectFileMutationVariables>;

/**
 * __useDeleteProposalProductProjectFileMutation__
 *
 * To run a mutation, you first call `useDeleteProposalProductProjectFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalProductProjectFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalProductProjectFileMutation, { data, loading, error }] = useDeleteProposalProductProjectFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalProductProjectFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalProductProjectFileMutation, DeleteProposalProductProjectFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalProductProjectFileMutation, DeleteProposalProductProjectFileMutationVariables>(DeleteProposalProductProjectFileDocument, options);
      }
export type DeleteProposalProductProjectFileMutationHookResult = ReturnType<typeof useDeleteProposalProductProjectFileMutation>;
export type DeleteProposalProductProjectFileMutationResult = Apollo.MutationResult<DeleteProposalProductProjectFileMutation>;
export type DeleteProposalProductProjectFileMutationOptions = Apollo.BaseMutationOptions<DeleteProposalProductProjectFileMutation, DeleteProposalProductProjectFileMutationVariables>;
export const DeleteProposalRecipientDocument = gql`
    mutation deleteProposalRecipient($email: String!, $proposalId: ID!) {
  deleteProposalRecipient(email: $email, proposalId: $proposalId)
}
    `;
export type DeleteProposalRecipientMutationFn = Apollo.MutationFunction<DeleteProposalRecipientMutation, DeleteProposalRecipientMutationVariables>;

/**
 * __useDeleteProposalRecipientMutation__
 *
 * To run a mutation, you first call `useDeleteProposalRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalRecipientMutation, { data, loading, error }] = useDeleteProposalRecipientMutation({
 *   variables: {
 *      email: // value for 'email'
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useDeleteProposalRecipientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalRecipientMutation, DeleteProposalRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalRecipientMutation, DeleteProposalRecipientMutationVariables>(DeleteProposalRecipientDocument, options);
      }
export type DeleteProposalRecipientMutationHookResult = ReturnType<typeof useDeleteProposalRecipientMutation>;
export type DeleteProposalRecipientMutationResult = Apollo.MutationResult<DeleteProposalRecipientMutation>;
export type DeleteProposalRecipientMutationOptions = Apollo.BaseMutationOptions<DeleteProposalRecipientMutation, DeleteProposalRecipientMutationVariables>;
export const DeleteProposalStageDocument = gql`
    mutation deleteProposalStage($id: ID!) {
  deleteProposalStage(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type DeleteProposalStageMutationFn = Apollo.MutationFunction<DeleteProposalStageMutation, DeleteProposalStageMutationVariables>;

/**
 * __useDeleteProposalStageMutation__
 *
 * To run a mutation, you first call `useDeleteProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalStageMutation, { data, loading, error }] = useDeleteProposalStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalStageMutation, DeleteProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalStageMutation, DeleteProposalStageMutationVariables>(DeleteProposalStageDocument, options);
      }
export type DeleteProposalStageMutationHookResult = ReturnType<typeof useDeleteProposalStageMutation>;
export type DeleteProposalStageMutationResult = Apollo.MutationResult<DeleteProposalStageMutation>;
export type DeleteProposalStageMutationOptions = Apollo.BaseMutationOptions<DeleteProposalStageMutation, DeleteProposalStageMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation deleteTask($id: ID!) {
  deleteTask(id: $id)
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const DeleteTimeBucketDocument = gql`
    mutation deleteTimeBucket($id: ID!) {
  deleteTimeBucket(id: $id) {
    id
    name
    organizationId
  }
}
    `;
export type DeleteTimeBucketMutationFn = Apollo.MutationFunction<DeleteTimeBucketMutation, DeleteTimeBucketMutationVariables>;

/**
 * __useDeleteTimeBucketMutation__
 *
 * To run a mutation, you first call `useDeleteTimeBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeBucketMutation, { data, loading, error }] = useDeleteTimeBucketMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeBucketMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeBucketMutation, DeleteTimeBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeBucketMutation, DeleteTimeBucketMutationVariables>(DeleteTimeBucketDocument, options);
      }
export type DeleteTimeBucketMutationHookResult = ReturnType<typeof useDeleteTimeBucketMutation>;
export type DeleteTimeBucketMutationResult = Apollo.MutationResult<DeleteTimeBucketMutation>;
export type DeleteTimeBucketMutationOptions = Apollo.BaseMutationOptions<DeleteTimeBucketMutation, DeleteTimeBucketMutationVariables>;
export const DeleteTimeEntryDocument = gql`
    mutation deleteTimeEntry($id: ID!) {
  deleteTimeEntry(id: $id) {
    clockInLatitude
    clockInLongitude
    clockOutLatitude
    clockOutLongitude
    endTime
    forDate
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      checklistNotes
      costingMode
      crewId
      endsAt
      externalId
      hasJobCostsEntered
      id
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    notes
    organizationId
    startTime
    timeBucket {
      id
      name
      organizationId
    }
    timeTrackedSeconds
    timeTrackedSecondsOverride
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    uuid
  }
}
    `;
export type DeleteTimeEntryMutationFn = Apollo.MutationFunction<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>;

/**
 * __useDeleteTimeEntryMutation__
 *
 * To run a mutation, you first call `useDeleteTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeEntryMutation, { data, loading, error }] = useDeleteTimeEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>(DeleteTimeEntryDocument, options);
      }
export type DeleteTimeEntryMutationHookResult = ReturnType<typeof useDeleteTimeEntryMutation>;
export type DeleteTimeEntryMutationResult = Apollo.MutationResult<DeleteTimeEntryMutation>;
export type DeleteTimeEntryMutationOptions = Apollo.BaseMutationOptions<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>;
export const DeleteTransferTruckDocument = gql`
    mutation deleteTransferTruck($id: ID!) {
  deleteTransferTruck(id: $id)
}
    `;
export type DeleteTransferTruckMutationFn = Apollo.MutationFunction<DeleteTransferTruckMutation, DeleteTransferTruckMutationVariables>;

/**
 * __useDeleteTransferTruckMutation__
 *
 * To run a mutation, you first call `useDeleteTransferTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransferTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransferTruckMutation, { data, loading, error }] = useDeleteTransferTruckMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransferTruckMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransferTruckMutation, DeleteTransferTruckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransferTruckMutation, DeleteTransferTruckMutationVariables>(DeleteTransferTruckDocument, options);
      }
export type DeleteTransferTruckMutationHookResult = ReturnType<typeof useDeleteTransferTruckMutation>;
export type DeleteTransferTruckMutationResult = Apollo.MutationResult<DeleteTransferTruckMutation>;
export type DeleteTransferTruckMutationOptions = Apollo.BaseMutationOptions<DeleteTransferTruckMutation, DeleteTransferTruckMutationVariables>;
export const DeleteUserInviteDocument = gql`
    mutation deleteUserInvite($id: ID!) {
  deleteUserInvite(id: $id)
}
    `;
export type DeleteUserInviteMutationFn = Apollo.MutationFunction<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>;

/**
 * __useDeleteUserInviteMutation__
 *
 * To run a mutation, you first call `useDeleteUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserInviteMutation, { data, loading, error }] = useDeleteUserInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>(DeleteUserInviteDocument, options);
      }
export type DeleteUserInviteMutationHookResult = ReturnType<typeof useDeleteUserInviteMutation>;
export type DeleteUserInviteMutationResult = Apollo.MutationResult<DeleteUserInviteMutation>;
export type DeleteUserInviteMutationOptions = Apollo.BaseMutationOptions<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>;
export const DetectAiMappingRunAreaDocument = gql`
    mutation detectAiMappingRunArea($id: ID!) {
  detectAiMappingRunArea(id: $id) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    taskId
  }
}
    `;
export type DetectAiMappingRunAreaMutationFn = Apollo.MutationFunction<DetectAiMappingRunAreaMutation, DetectAiMappingRunAreaMutationVariables>;

/**
 * __useDetectAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useDetectAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetectAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detectAiMappingRunAreaMutation, { data, loading, error }] = useDetectAiMappingRunAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<DetectAiMappingRunAreaMutation, DetectAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetectAiMappingRunAreaMutation, DetectAiMappingRunAreaMutationVariables>(DetectAiMappingRunAreaDocument, options);
      }
export type DetectAiMappingRunAreaMutationHookResult = ReturnType<typeof useDetectAiMappingRunAreaMutation>;
export type DetectAiMappingRunAreaMutationResult = Apollo.MutationResult<DetectAiMappingRunAreaMutation>;
export type DetectAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<DetectAiMappingRunAreaMutation, DetectAiMappingRunAreaMutationVariables>;
export const DownloadProposalDocument = gql`
    mutation downloadProposal($acceptanceOverride: String, $attachments: [ID!], $clientEmailOverride: String, $emailBodyOverride: String, $emailSubjectOverride: String, $forceSend: Boolean, $layout: ProposalLayout!, $proposalId: ID!, $removeIndividualLineItemPricing: Boolean, $removeUnitPriceAndQuantity: Boolean) {
  downloadProposal(
    acceptanceOverride: $acceptanceOverride
    attachments: $attachments
    clientEmailOverride: $clientEmailOverride
    emailBodyOverride: $emailBodyOverride
    emailSubjectOverride: $emailSubjectOverride
    forceSend: $forceSend
    layout: $layout
    proposalId: $proposalId
    removeIndividualLineItemPricing: $removeIndividualLineItemPricing
    removeUnitPriceAndQuantity: $removeUnitPriceAndQuantity
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type DownloadProposalMutationFn = Apollo.MutationFunction<DownloadProposalMutation, DownloadProposalMutationVariables>;

/**
 * __useDownloadProposalMutation__
 *
 * To run a mutation, you first call `useDownloadProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadProposalMutation, { data, loading, error }] = useDownloadProposalMutation({
 *   variables: {
 *      acceptanceOverride: // value for 'acceptanceOverride'
 *      attachments: // value for 'attachments'
 *      clientEmailOverride: // value for 'clientEmailOverride'
 *      emailBodyOverride: // value for 'emailBodyOverride'
 *      emailSubjectOverride: // value for 'emailSubjectOverride'
 *      forceSend: // value for 'forceSend'
 *      layout: // value for 'layout'
 *      proposalId: // value for 'proposalId'
 *      removeIndividualLineItemPricing: // value for 'removeIndividualLineItemPricing'
 *      removeUnitPriceAndQuantity: // value for 'removeUnitPriceAndQuantity'
 *   },
 * });
 */
export function useDownloadProposalMutation(baseOptions?: Apollo.MutationHookOptions<DownloadProposalMutation, DownloadProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadProposalMutation, DownloadProposalMutationVariables>(DownloadProposalDocument, options);
      }
export type DownloadProposalMutationHookResult = ReturnType<typeof useDownloadProposalMutation>;
export type DownloadProposalMutationResult = Apollo.MutationResult<DownloadProposalMutation>;
export type DownloadProposalMutationOptions = Apollo.BaseMutationOptions<DownloadProposalMutation, DownloadProposalMutationVariables>;
export const DuplicateProductDocument = gql`
    mutation duplicateProduct($id: ID!) {
  duplicateProduct(id: $id) {
    areaCoverage
    attributes {
      __typename
      ... on ProductAttributeAsphalt {
        applicationRate
      }
      ... on ProductAttributeAsphaltCurbing {
        curbHeight
        curbWidth
      }
      ... on ProductAttributeConcreteColumn {
        diameter
        height
      }
      ... on ProductAttributeConcreteCurbOrGutter {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeConcreteFlatwork {
        applicationRate
      }
      ... on ProductAttributeConcreteFooting {
        depth
        width
      }
      ... on ProductAttributeConcreteWall {
        height
        width
      }
      ... on ProductAttributeConcreteWaterway {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeCrackSeal {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeCurbWall {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeExcavateOut {
        applicationRate
      }
      ... on ProductAttributeGrading {
        applicationRate
        poundsPerCubicYard
      }
      ... on ProductAttributeMastic {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeMicrosurfacing {
        applicationRate
      }
      ... on ProductAttributeSealCoat {
        applicationRate
      }
      ... on ProductAttributeSlurrySeal {
        applicationRate
      }
      ... on ProductAttributeStriping {
        applicationRate
        lineWidth
      }
    }
    costMaterial
    costMinimumProduct
    costMinimumProposal
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    dailyUnitsComplete
    externalProductName
    id
    indirectPercentage
    labourCostType
    markupPercentage
    materialsNoPlant {
      id
      name
      percentage
      productId
      rate
    }
    measurementJob
    measurementMaterial
    name
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    overheadPercentage
    plant {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        pivot {
          applicationRate
        }
        plantId
        rate
        type
      }
    }
    plantProductId
    plantProducts {
      id
      pivot {
        applicationRate
      }
      plantId
      rate
      type
    }
    plants {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        plantId
        rate
        type
      }
    }
    productAdditionalCosts {
      additionalCost {
        cost
        feeAmount
        feeType
        id
        name
      }
      id
      type
    }
    productCrews {
      crew {
        color
        displayName
        id
        name
        rate
      }
      id
      quantity
    }
    productEquipmentPieces {
      equipmentPiece {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      id
      quantity
    }
    productionRateType
    statementOfWork
    subcontracted
    type
    unitPrice
    unitPriceProduct
  }
}
    `;
export type DuplicateProductMutationFn = Apollo.MutationFunction<DuplicateProductMutation, DuplicateProductMutationVariables>;

/**
 * __useDuplicateProductMutation__
 *
 * To run a mutation, you first call `useDuplicateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProductMutation, { data, loading, error }] = useDuplicateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateProductMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProductMutation, DuplicateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProductMutation, DuplicateProductMutationVariables>(DuplicateProductDocument, options);
      }
export type DuplicateProductMutationHookResult = ReturnType<typeof useDuplicateProductMutation>;
export type DuplicateProductMutationResult = Apollo.MutationResult<DuplicateProductMutation>;
export type DuplicateProductMutationOptions = Apollo.BaseMutationOptions<DuplicateProductMutation, DuplicateProductMutationVariables>;
export const DuplicateProposalDocument = gql`
    mutation duplicateProposal($changeOrderJobId: ID, $changeOrderProposalType: ChangeOrderProposalType, $changeOrderScheduledJobsAction: ChangeOrderScheduledJobsAction, $createNewVersion: Boolean, $id: ID!, $isChangeOrder: Boolean, $startNewProposal: Boolean) {
  duplicateProposal(
    changeOrderJobId: $changeOrderJobId
    changeOrderProposalType: $changeOrderProposalType
    changeOrderScheduledJobsAction: $changeOrderScheduledJobsAction
    createNewVersion: $createNewVersion
    id: $id
    isChangeOrder: $isChangeOrder
    startNewProposal: $startNewProposal
  ) {
    newProposal {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      clientEmailOverride
      closeConfidence
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      contentSettings {
        contentType
        id
        isEnabled
        proposalId
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      customFinancials {
        incomplete
        netMargin
        productsWithoutCosts
        profit
        sendErrors
      }
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      events {
        action
        createdAt
        id
      }
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      lastEvent {
        action
        createdAt
        id
      }
      lastStatusChange {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      latestPackageSendRun {
        failedRecipients
        id
        processedRecipients
        proposalId
        recipients {
          attemptCount
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          companyId
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          errorMessage
          id
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          sentAt
          startedAt
          status
        }
        status
        succeededRecipients
        totalRecipients
      }
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      packageChildren {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageParent {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageWinnerProposal {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        addressOverride
        checklistItems {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        proposalProductGroups {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        roundTripTravelTimeHours
        stageMeasurements {
          featureGeojson
          geojsonFeatureId
          id
          isScreenshotTarget
          label
          measurementJob
          measurementType
          measurementValue
          product {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            externalProductName
            id
            indirectPercentage
            labourCostType
            markupPercentage
            measurementJob
            measurementMaterial
            name
            overheadPercentage
            plantProductId
            productionRateType
            statementOfWork
            subcontracted
            type
            unitPrice
            unitPriceProduct
          }
          productId
          sortOrder
        }
      }
      status
      statusChanges {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
      uuid
      version
      versionWithPrefix
      versions {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          addressOverride
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        wonAt
      }
      wonAt
    }
    proposal {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      clientEmailOverride
      closeConfidence
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        email
        id
        jobsCount
        logo
        name
        notes
        phone
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      contentSettings {
        contentType
        id
        isEnabled
        proposalId
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      customFinancials {
        incomplete
        netMargin
        productsWithoutCosts
        profit
        sendErrors
      }
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      events {
        action
        createdAt
        id
      }
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      lastEvent {
        action
        createdAt
        id
      }
      lastStatusChange {
        changeAt
        status
      }
      latestPackageSendRun {
        failedRecipients
        id
        processedRecipients
        proposalId
        status
        succeededRecipients
        totalRecipients
      }
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      packageChildren {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageParent {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageWinnerProposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      status
      statusChanges {
        changeAt
        status
      }
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
      uuid
      version
      versionWithPrefix
      versions {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      wonAt
    }
  }
}
    `;
export type DuplicateProposalMutationFn = Apollo.MutationFunction<DuplicateProposalMutation, DuplicateProposalMutationVariables>;

/**
 * __useDuplicateProposalMutation__
 *
 * To run a mutation, you first call `useDuplicateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProposalMutation, { data, loading, error }] = useDuplicateProposalMutation({
 *   variables: {
 *      changeOrderJobId: // value for 'changeOrderJobId'
 *      changeOrderProposalType: // value for 'changeOrderProposalType'
 *      changeOrderScheduledJobsAction: // value for 'changeOrderScheduledJobsAction'
 *      createNewVersion: // value for 'createNewVersion'
 *      id: // value for 'id'
 *      isChangeOrder: // value for 'isChangeOrder'
 *      startNewProposal: // value for 'startNewProposal'
 *   },
 * });
 */
export function useDuplicateProposalMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProposalMutation, DuplicateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProposalMutation, DuplicateProposalMutationVariables>(DuplicateProposalDocument, options);
      }
export type DuplicateProposalMutationHookResult = ReturnType<typeof useDuplicateProposalMutation>;
export type DuplicateProposalMutationResult = Apollo.MutationResult<DuplicateProposalMutation>;
export type DuplicateProposalMutationOptions = Apollo.BaseMutationOptions<DuplicateProposalMutation, DuplicateProposalMutationVariables>;
export const DuplicateProposalStageDocument = gql`
    mutation duplicateProposalStage($id: ID!) {
  duplicateProposalStage(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type DuplicateProposalStageMutationFn = Apollo.MutationFunction<DuplicateProposalStageMutation, DuplicateProposalStageMutationVariables>;

/**
 * __useDuplicateProposalStageMutation__
 *
 * To run a mutation, you first call `useDuplicateProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProposalStageMutation, { data, loading, error }] = useDuplicateProposalStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProposalStageMutation, DuplicateProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProposalStageMutation, DuplicateProposalStageMutationVariables>(DuplicateProposalStageDocument, options);
      }
export type DuplicateProposalStageMutationHookResult = ReturnType<typeof useDuplicateProposalStageMutation>;
export type DuplicateProposalStageMutationResult = Apollo.MutationResult<DuplicateProposalStageMutation>;
export type DuplicateProposalStageMutationOptions = Apollo.BaseMutationOptions<DuplicateProposalStageMutation, DuplicateProposalStageMutationVariables>;
export const ExportAiMappingRunAreaPdfDocument = gql`
    mutation exportAiMappingRunAreaPdf($id: ID!, $includeAnnotations: Boolean, $includeCounts: Boolean) {
  exportAiMappingRunAreaPdf(
    id: $id
    includeAnnotations: $includeAnnotations
    includeCounts: $includeCounts
  ) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    taskId
  }
}
    `;
export type ExportAiMappingRunAreaPdfMutationFn = Apollo.MutationFunction<ExportAiMappingRunAreaPdfMutation, ExportAiMappingRunAreaPdfMutationVariables>;

/**
 * __useExportAiMappingRunAreaPdfMutation__
 *
 * To run a mutation, you first call `useExportAiMappingRunAreaPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAiMappingRunAreaPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAiMappingRunAreaPdfMutation, { data, loading, error }] = useExportAiMappingRunAreaPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *      includeAnnotations: // value for 'includeAnnotations'
 *      includeCounts: // value for 'includeCounts'
 *   },
 * });
 */
export function useExportAiMappingRunAreaPdfMutation(baseOptions?: Apollo.MutationHookOptions<ExportAiMappingRunAreaPdfMutation, ExportAiMappingRunAreaPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAiMappingRunAreaPdfMutation, ExportAiMappingRunAreaPdfMutationVariables>(ExportAiMappingRunAreaPdfDocument, options);
      }
export type ExportAiMappingRunAreaPdfMutationHookResult = ReturnType<typeof useExportAiMappingRunAreaPdfMutation>;
export type ExportAiMappingRunAreaPdfMutationResult = Apollo.MutationResult<ExportAiMappingRunAreaPdfMutation>;
export type ExportAiMappingRunAreaPdfMutationOptions = Apollo.BaseMutationOptions<ExportAiMappingRunAreaPdfMutation, ExportAiMappingRunAreaPdfMutationVariables>;
export const FinalizeLinkedServiceAccountDocument = gql`
    mutation finalizeLinkedServiceAccount($code: String, $realmId: String, $service: OrganizationLinkedServiceName!, $state: String) {
  finalizeLinkedServiceAccount(
    code: $code
    realmId: $realmId
    service: $service
    state: $state
  )
}
    `;
export type FinalizeLinkedServiceAccountMutationFn = Apollo.MutationFunction<FinalizeLinkedServiceAccountMutation, FinalizeLinkedServiceAccountMutationVariables>;

/**
 * __useFinalizeLinkedServiceAccountMutation__
 *
 * To run a mutation, you first call `useFinalizeLinkedServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeLinkedServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeLinkedServiceAccountMutation, { data, loading, error }] = useFinalizeLinkedServiceAccountMutation({
 *   variables: {
 *      code: // value for 'code'
 *      realmId: // value for 'realmId'
 *      service: // value for 'service'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useFinalizeLinkedServiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeLinkedServiceAccountMutation, FinalizeLinkedServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeLinkedServiceAccountMutation, FinalizeLinkedServiceAccountMutationVariables>(FinalizeLinkedServiceAccountDocument, options);
      }
export type FinalizeLinkedServiceAccountMutationHookResult = ReturnType<typeof useFinalizeLinkedServiceAccountMutation>;
export type FinalizeLinkedServiceAccountMutationResult = Apollo.MutationResult<FinalizeLinkedServiceAccountMutation>;
export type FinalizeLinkedServiceAccountMutationOptions = Apollo.BaseMutationOptions<FinalizeLinkedServiceAccountMutation, FinalizeLinkedServiceAccountMutationVariables>;
export const FinishRegistrationDocument = gql`
    mutation finishRegistration($input: FinishRegistrationInput!) {
  finishRegistration(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    archivedAt
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    salesGoal
    status
  }
}
    `;
export type FinishRegistrationMutationFn = Apollo.MutationFunction<FinishRegistrationMutation, FinishRegistrationMutationVariables>;

/**
 * __useFinishRegistrationMutation__
 *
 * To run a mutation, you first call `useFinishRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishRegistrationMutation, { data, loading, error }] = useFinishRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinishRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<FinishRegistrationMutation, FinishRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishRegistrationMutation, FinishRegistrationMutationVariables>(FinishRegistrationDocument, options);
      }
export type FinishRegistrationMutationHookResult = ReturnType<typeof useFinishRegistrationMutation>;
export type FinishRegistrationMutationResult = Apollo.MutationResult<FinishRegistrationMutation>;
export type FinishRegistrationMutationOptions = Apollo.BaseMutationOptions<FinishRegistrationMutation, FinishRegistrationMutationVariables>;
export const GenerateOrganizationDataUploadUrlDocument = gql`
    mutation generateOrganizationDataUploadUrl($contentType: String!, $filename: String!) {
  generateOrganizationDataUploadUrl(
    contentType: $contentType
    filename: $filename
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateOrganizationDataUploadUrlMutationFn = Apollo.MutationFunction<GenerateOrganizationDataUploadUrlMutation, GenerateOrganizationDataUploadUrlMutationVariables>;

/**
 * __useGenerateOrganizationDataUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateOrganizationDataUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrganizationDataUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrganizationDataUploadUrlMutation, { data, loading, error }] = useGenerateOrganizationDataUploadUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateOrganizationDataUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOrganizationDataUploadUrlMutation, GenerateOrganizationDataUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOrganizationDataUploadUrlMutation, GenerateOrganizationDataUploadUrlMutationVariables>(GenerateOrganizationDataUploadUrlDocument, options);
      }
export type GenerateOrganizationDataUploadUrlMutationHookResult = ReturnType<typeof useGenerateOrganizationDataUploadUrlMutation>;
export type GenerateOrganizationDataUploadUrlMutationResult = Apollo.MutationResult<GenerateOrganizationDataUploadUrlMutation>;
export type GenerateOrganizationDataUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateOrganizationDataUploadUrlMutation, GenerateOrganizationDataUploadUrlMutationVariables>;
export const GenerateReportDocument = gql`
    mutation generateReport($companyId: String, $customerId: String, $endDate: DateTime, $estimatorId: String, $jobId: String, $productId: String, $productTypeId: String, $startDate: DateTime, $status: String, $type: ReportType!, $wonAt: Boolean) {
  generateReport(
    companyId: $companyId
    customerId: $customerId
    endDate: $endDate
    estimatorId: $estimatorId
    jobId: $jobId
    productId: $productId
    productTypeId: $productTypeId
    startDate: $startDate
    status: $status
    type: $type
    wonAt: $wonAt
  )
}
    `;
export type GenerateReportMutationFn = Apollo.MutationFunction<GenerateReportMutation, GenerateReportMutationVariables>;

/**
 * __useGenerateReportMutation__
 *
 * To run a mutation, you first call `useGenerateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportMutation, { data, loading, error }] = useGenerateReportMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      customerId: // value for 'customerId'
 *      endDate: // value for 'endDate'
 *      estimatorId: // value for 'estimatorId'
 *      jobId: // value for 'jobId'
 *      productId: // value for 'productId'
 *      productTypeId: // value for 'productTypeId'
 *      startDate: // value for 'startDate'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *      wonAt: // value for 'wonAt'
 *   },
 * });
 */
export function useGenerateReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportMutation, GenerateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportMutation, GenerateReportMutationVariables>(GenerateReportDocument, options);
      }
export type GenerateReportMutationHookResult = ReturnType<typeof useGenerateReportMutation>;
export type GenerateReportMutationResult = Apollo.MutationResult<GenerateReportMutation>;
export type GenerateReportMutationOptions = Apollo.BaseMutationOptions<GenerateReportMutation, GenerateReportMutationVariables>;
export const GenerateUploadCompanyLogoUrlDocument = gql`
    mutation generateUploadCompanyLogoUrl($contentType: String!, $filename: String!) {
  generateUploadCompanyLogoUrl(contentType: $contentType, filename: $filename) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadCompanyLogoUrlMutationFn = Apollo.MutationFunction<GenerateUploadCompanyLogoUrlMutation, GenerateUploadCompanyLogoUrlMutationVariables>;

/**
 * __useGenerateUploadCompanyLogoUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadCompanyLogoUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadCompanyLogoUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadCompanyLogoUrlMutation, { data, loading, error }] = useGenerateUploadCompanyLogoUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadCompanyLogoUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadCompanyLogoUrlMutation, GenerateUploadCompanyLogoUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadCompanyLogoUrlMutation, GenerateUploadCompanyLogoUrlMutationVariables>(GenerateUploadCompanyLogoUrlDocument, options);
      }
export type GenerateUploadCompanyLogoUrlMutationHookResult = ReturnType<typeof useGenerateUploadCompanyLogoUrlMutation>;
export type GenerateUploadCompanyLogoUrlMutationResult = Apollo.MutationResult<GenerateUploadCompanyLogoUrlMutation>;
export type GenerateUploadCompanyLogoUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadCompanyLogoUrlMutation, GenerateUploadCompanyLogoUrlMutationVariables>;
export const GenerateUploadCustomEventFileUrlDocument = gql`
    mutation generateUploadCustomEventFileUrl($contentType: String!, $filename: String!) {
  generateUploadCustomEventFileUrl(contentType: $contentType, filename: $filename) {
    contentDisposition
    contentType
    method
    path
    url
  }
}
    `;
export type GenerateUploadCustomEventFileUrlMutationFn = Apollo.MutationFunction<GenerateUploadCustomEventFileUrlMutation, GenerateUploadCustomEventFileUrlMutationVariables>;

/**
 * __useGenerateUploadCustomEventFileUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadCustomEventFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadCustomEventFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadCustomEventFileUrlMutation, { data, loading, error }] = useGenerateUploadCustomEventFileUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadCustomEventFileUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadCustomEventFileUrlMutation, GenerateUploadCustomEventFileUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadCustomEventFileUrlMutation, GenerateUploadCustomEventFileUrlMutationVariables>(GenerateUploadCustomEventFileUrlDocument, options);
      }
export type GenerateUploadCustomEventFileUrlMutationHookResult = ReturnType<typeof useGenerateUploadCustomEventFileUrlMutation>;
export type GenerateUploadCustomEventFileUrlMutationResult = Apollo.MutationResult<GenerateUploadCustomEventFileUrlMutation>;
export type GenerateUploadCustomEventFileUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadCustomEventFileUrlMutation, GenerateUploadCustomEventFileUrlMutationVariables>;
export const GenerateUploadDailyFormWorkOrderFileUrlDocument = gql`
    mutation generateUploadDailyFormWorkOrderFileUrl($contentType: String!, $filename: String!) {
  generateUploadDailyFormWorkOrderFileUrl(
    contentType: $contentType
    filename: $filename
  ) {
    contentDisposition
    contentType
    method
    path
    url
  }
}
    `;
export type GenerateUploadDailyFormWorkOrderFileUrlMutationFn = Apollo.MutationFunction<GenerateUploadDailyFormWorkOrderFileUrlMutation, GenerateUploadDailyFormWorkOrderFileUrlMutationVariables>;

/**
 * __useGenerateUploadDailyFormWorkOrderFileUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadDailyFormWorkOrderFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadDailyFormWorkOrderFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadDailyFormWorkOrderFileUrlMutation, { data, loading, error }] = useGenerateUploadDailyFormWorkOrderFileUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadDailyFormWorkOrderFileUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadDailyFormWorkOrderFileUrlMutation, GenerateUploadDailyFormWorkOrderFileUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadDailyFormWorkOrderFileUrlMutation, GenerateUploadDailyFormWorkOrderFileUrlMutationVariables>(GenerateUploadDailyFormWorkOrderFileUrlDocument, options);
      }
export type GenerateUploadDailyFormWorkOrderFileUrlMutationHookResult = ReturnType<typeof useGenerateUploadDailyFormWorkOrderFileUrlMutation>;
export type GenerateUploadDailyFormWorkOrderFileUrlMutationResult = Apollo.MutationResult<GenerateUploadDailyFormWorkOrderFileUrlMutation>;
export type GenerateUploadDailyFormWorkOrderFileUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadDailyFormWorkOrderFileUrlMutation, GenerateUploadDailyFormWorkOrderFileUrlMutationVariables>;
export const GenerateUploadJobPhaseCostItemFileUrlDocument = gql`
    mutation generateUploadJobPhaseCostItemFileUrl($contentType: String!, $filename: String!, $jobPhaseId: ID!) {
  generateUploadJobPhaseCostItemFileUrl(
    contentType: $contentType
    filename: $filename
    jobPhaseId: $jobPhaseId
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadJobPhaseCostItemFileUrlMutationFn = Apollo.MutationFunction<GenerateUploadJobPhaseCostItemFileUrlMutation, GenerateUploadJobPhaseCostItemFileUrlMutationVariables>;

/**
 * __useGenerateUploadJobPhaseCostItemFileUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadJobPhaseCostItemFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadJobPhaseCostItemFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadJobPhaseCostItemFileUrlMutation, { data, loading, error }] = useGenerateUploadJobPhaseCostItemFileUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useGenerateUploadJobPhaseCostItemFileUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadJobPhaseCostItemFileUrlMutation, GenerateUploadJobPhaseCostItemFileUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadJobPhaseCostItemFileUrlMutation, GenerateUploadJobPhaseCostItemFileUrlMutationVariables>(GenerateUploadJobPhaseCostItemFileUrlDocument, options);
      }
export type GenerateUploadJobPhaseCostItemFileUrlMutationHookResult = ReturnType<typeof useGenerateUploadJobPhaseCostItemFileUrlMutation>;
export type GenerateUploadJobPhaseCostItemFileUrlMutationResult = Apollo.MutationResult<GenerateUploadJobPhaseCostItemFileUrlMutation>;
export type GenerateUploadJobPhaseCostItemFileUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadJobPhaseCostItemFileUrlMutation, GenerateUploadJobPhaseCostItemFileUrlMutationVariables>;
export const GenerateUploadOrganizationDocumentUrlDocument = gql`
    mutation generateUploadOrganizationDocumentUrl($contentType: String!, $filename: String!) {
  generateUploadOrganizationDocumentUrl(
    contentType: $contentType
    filename: $filename
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadOrganizationDocumentUrlMutationFn = Apollo.MutationFunction<GenerateUploadOrganizationDocumentUrlMutation, GenerateUploadOrganizationDocumentUrlMutationVariables>;

/**
 * __useGenerateUploadOrganizationDocumentUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadOrganizationDocumentUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadOrganizationDocumentUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadOrganizationDocumentUrlMutation, { data, loading, error }] = useGenerateUploadOrganizationDocumentUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadOrganizationDocumentUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadOrganizationDocumentUrlMutation, GenerateUploadOrganizationDocumentUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadOrganizationDocumentUrlMutation, GenerateUploadOrganizationDocumentUrlMutationVariables>(GenerateUploadOrganizationDocumentUrlDocument, options);
      }
export type GenerateUploadOrganizationDocumentUrlMutationHookResult = ReturnType<typeof useGenerateUploadOrganizationDocumentUrlMutation>;
export type GenerateUploadOrganizationDocumentUrlMutationResult = Apollo.MutationResult<GenerateUploadOrganizationDocumentUrlMutation>;
export type GenerateUploadOrganizationDocumentUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadOrganizationDocumentUrlMutation, GenerateUploadOrganizationDocumentUrlMutationVariables>;
export const GenerateUploadOrganizationLogoUrlDocument = gql`
    mutation generateUploadOrganizationLogoUrl($contentType: String!, $filename: String!) {
  generateUploadOrganizationLogoUrl(
    contentType: $contentType
    filename: $filename
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadOrganizationLogoUrlMutationFn = Apollo.MutationFunction<GenerateUploadOrganizationLogoUrlMutation, GenerateUploadOrganizationLogoUrlMutationVariables>;

/**
 * __useGenerateUploadOrganizationLogoUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadOrganizationLogoUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadOrganizationLogoUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadOrganizationLogoUrlMutation, { data, loading, error }] = useGenerateUploadOrganizationLogoUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadOrganizationLogoUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadOrganizationLogoUrlMutation, GenerateUploadOrganizationLogoUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadOrganizationLogoUrlMutation, GenerateUploadOrganizationLogoUrlMutationVariables>(GenerateUploadOrganizationLogoUrlDocument, options);
      }
export type GenerateUploadOrganizationLogoUrlMutationHookResult = ReturnType<typeof useGenerateUploadOrganizationLogoUrlMutation>;
export type GenerateUploadOrganizationLogoUrlMutationResult = Apollo.MutationResult<GenerateUploadOrganizationLogoUrlMutation>;
export type GenerateUploadOrganizationLogoUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadOrganizationLogoUrlMutation, GenerateUploadOrganizationLogoUrlMutationVariables>;
export const GenerateUploadProjectFileUrlDocument = gql`
    mutation generateUploadProjectFileUrl($contentType: String, $filename: String!) {
  generateUploadProjectFileUrl(contentType: $contentType, filename: $filename) {
    contentDisposition
    contentType
    method
    path
    url
  }
}
    `;
export type GenerateUploadProjectFileUrlMutationFn = Apollo.MutationFunction<GenerateUploadProjectFileUrlMutation, GenerateUploadProjectFileUrlMutationVariables>;

/**
 * __useGenerateUploadProjectFileUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadProjectFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadProjectFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadProjectFileUrlMutation, { data, loading, error }] = useGenerateUploadProjectFileUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadProjectFileUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadProjectFileUrlMutation, GenerateUploadProjectFileUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadProjectFileUrlMutation, GenerateUploadProjectFileUrlMutationVariables>(GenerateUploadProjectFileUrlDocument, options);
      }
export type GenerateUploadProjectFileUrlMutationHookResult = ReturnType<typeof useGenerateUploadProjectFileUrlMutation>;
export type GenerateUploadProjectFileUrlMutationResult = Apollo.MutationResult<GenerateUploadProjectFileUrlMutation>;
export type GenerateUploadProjectFileUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadProjectFileUrlMutation, GenerateUploadProjectFileUrlMutationVariables>;
export const GenerateUploadProjectMapImageUrlDocument = gql`
    mutation generateUploadProjectMapImageUrl($contentType: String!, $filename: String!, $projectMapId: ID!) {
  generateUploadProjectMapImageUrl(
    contentType: $contentType
    filename: $filename
    projectMapId: $projectMapId
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadProjectMapImageUrlMutationFn = Apollo.MutationFunction<GenerateUploadProjectMapImageUrlMutation, GenerateUploadProjectMapImageUrlMutationVariables>;

/**
 * __useGenerateUploadProjectMapImageUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadProjectMapImageUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadProjectMapImageUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadProjectMapImageUrlMutation, { data, loading, error }] = useGenerateUploadProjectMapImageUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *      projectMapId: // value for 'projectMapId'
 *   },
 * });
 */
export function useGenerateUploadProjectMapImageUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadProjectMapImageUrlMutation, GenerateUploadProjectMapImageUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadProjectMapImageUrlMutation, GenerateUploadProjectMapImageUrlMutationVariables>(GenerateUploadProjectMapImageUrlDocument, options);
      }
export type GenerateUploadProjectMapImageUrlMutationHookResult = ReturnType<typeof useGenerateUploadProjectMapImageUrlMutation>;
export type GenerateUploadProjectMapImageUrlMutationResult = Apollo.MutationResult<GenerateUploadProjectMapImageUrlMutation>;
export type GenerateUploadProjectMapImageUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadProjectMapImageUrlMutation, GenerateUploadProjectMapImageUrlMutationVariables>;
export const GenerateUploadProposalFileUrlDocument = gql`
    mutation generateUploadProposalFileUrl($contentType: String!, $filename: String!, $proposalProductId: ID!) {
  generateUploadProposalFileUrl(
    contentType: $contentType
    filename: $filename
    proposalProductId: $proposalProductId
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadProposalFileUrlMutationFn = Apollo.MutationFunction<GenerateUploadProposalFileUrlMutation, GenerateUploadProposalFileUrlMutationVariables>;

/**
 * __useGenerateUploadProposalFileUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadProposalFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadProposalFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadProposalFileUrlMutation, { data, loading, error }] = useGenerateUploadProposalFileUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useGenerateUploadProposalFileUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadProposalFileUrlMutation, GenerateUploadProposalFileUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadProposalFileUrlMutation, GenerateUploadProposalFileUrlMutationVariables>(GenerateUploadProposalFileUrlDocument, options);
      }
export type GenerateUploadProposalFileUrlMutationHookResult = ReturnType<typeof useGenerateUploadProposalFileUrlMutation>;
export type GenerateUploadProposalFileUrlMutationResult = Apollo.MutationResult<GenerateUploadProposalFileUrlMutation>;
export type GenerateUploadProposalFileUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadProposalFileUrlMutation, GenerateUploadProposalFileUrlMutationVariables>;
export const GetLinkedServiceAuthUrlDocument = gql`
    mutation getLinkedServiceAuthUrl($service: OrganizationLinkedServiceName!) {
  getLinkedServiceAuthUrl(service: $service)
}
    `;
export type GetLinkedServiceAuthUrlMutationFn = Apollo.MutationFunction<GetLinkedServiceAuthUrlMutation, GetLinkedServiceAuthUrlMutationVariables>;

/**
 * __useGetLinkedServiceAuthUrlMutation__
 *
 * To run a mutation, you first call `useGetLinkedServiceAuthUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedServiceAuthUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getLinkedServiceAuthUrlMutation, { data, loading, error }] = useGetLinkedServiceAuthUrlMutation({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useGetLinkedServiceAuthUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetLinkedServiceAuthUrlMutation, GetLinkedServiceAuthUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetLinkedServiceAuthUrlMutation, GetLinkedServiceAuthUrlMutationVariables>(GetLinkedServiceAuthUrlDocument, options);
      }
export type GetLinkedServiceAuthUrlMutationHookResult = ReturnType<typeof useGetLinkedServiceAuthUrlMutation>;
export type GetLinkedServiceAuthUrlMutationResult = Apollo.MutationResult<GetLinkedServiceAuthUrlMutation>;
export type GetLinkedServiceAuthUrlMutationOptions = Apollo.BaseMutationOptions<GetLinkedServiceAuthUrlMutation, GetLinkedServiceAuthUrlMutationVariables>;
export const GetReportAdditionalCostDocument = gql`
    mutation getReportAdditionalCost($endDate: DateTime!, $first: Int, $page: Int, $startDate: DateTime!) {
  getReportAdditionalCost(
    endDate: $endDate
    first: $first
    page: $page
    startDate: $startDate
  ) {
    data {
      additional_cost_amount
      additional_cost_id
      additional_cost_name
      additional_cost_quantity
      job_id
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportAdditionalCostMutationFn = Apollo.MutationFunction<GetReportAdditionalCostMutation, GetReportAdditionalCostMutationVariables>;

/**
 * __useGetReportAdditionalCostMutation__
 *
 * To run a mutation, you first call `useGetReportAdditionalCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportAdditionalCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportAdditionalCostMutation, { data, loading, error }] = useGetReportAdditionalCostMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportAdditionalCostMutation(baseOptions?: Apollo.MutationHookOptions<GetReportAdditionalCostMutation, GetReportAdditionalCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportAdditionalCostMutation, GetReportAdditionalCostMutationVariables>(GetReportAdditionalCostDocument, options);
      }
export type GetReportAdditionalCostMutationHookResult = ReturnType<typeof useGetReportAdditionalCostMutation>;
export type GetReportAdditionalCostMutationResult = Apollo.MutationResult<GetReportAdditionalCostMutation>;
export type GetReportAdditionalCostMutationOptions = Apollo.BaseMutationOptions<GetReportAdditionalCostMutation, GetReportAdditionalCostMutationVariables>;
export const GetReportCompanyOrClientDetailsDocument = gql`
    mutation getReportCompanyOrClientDetails($companyId: String, $endDate: DateTime!, $first: Int, $page: Int, $startDate: DateTime!) {
  getReportCompanyOrClientDetails(
    companyId: $companyId
    endDate: $endDate
    first: $first
    page: $page
    startDate: $startDate
  ) {
    data {
      companyId
      companyName
      companyStatus
      orgRevenuePercentage
      proposalsCount
      proposalsWonAmountTotal
      proposalsWonCount
      winRate
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportCompanyOrClientDetailsMutationFn = Apollo.MutationFunction<GetReportCompanyOrClientDetailsMutation, GetReportCompanyOrClientDetailsMutationVariables>;

/**
 * __useGetReportCompanyOrClientDetailsMutation__
 *
 * To run a mutation, you first call `useGetReportCompanyOrClientDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportCompanyOrClientDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportCompanyOrClientDetailsMutation, { data, loading, error }] = useGetReportCompanyOrClientDetailsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportCompanyOrClientDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetReportCompanyOrClientDetailsMutation, GetReportCompanyOrClientDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportCompanyOrClientDetailsMutation, GetReportCompanyOrClientDetailsMutationVariables>(GetReportCompanyOrClientDetailsDocument, options);
      }
export type GetReportCompanyOrClientDetailsMutationHookResult = ReturnType<typeof useGetReportCompanyOrClientDetailsMutation>;
export type GetReportCompanyOrClientDetailsMutationResult = Apollo.MutationResult<GetReportCompanyOrClientDetailsMutation>;
export type GetReportCompanyOrClientDetailsMutationOptions = Apollo.BaseMutationOptions<GetReportCompanyOrClientDetailsMutation, GetReportCompanyOrClientDetailsMutationVariables>;
export const GetReportContactDetailsDocument = gql`
    mutation getReportContactDetails($companyId: String, $first: Int, $page: Int) {
  getReportContactDetails(companyId: $companyId, first: $first, page: $page) {
    data {
      address_city
      address_country
      address_line_1
      address_line_2
      address_state
      address_zip
      company_id
      contact_email
      contact_phone
      email
      first_name
      id
      last_name
      name
      notes
      phone
      role
      status
      title
      website
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportContactDetailsMutationFn = Apollo.MutationFunction<GetReportContactDetailsMutation, GetReportContactDetailsMutationVariables>;

/**
 * __useGetReportContactDetailsMutation__
 *
 * To run a mutation, you first call `useGetReportContactDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportContactDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportContactDetailsMutation, { data, loading, error }] = useGetReportContactDetailsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetReportContactDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetReportContactDetailsMutation, GetReportContactDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportContactDetailsMutation, GetReportContactDetailsMutationVariables>(GetReportContactDetailsDocument, options);
      }
export type GetReportContactDetailsMutationHookResult = ReturnType<typeof useGetReportContactDetailsMutation>;
export type GetReportContactDetailsMutationResult = Apollo.MutationResult<GetReportContactDetailsMutation>;
export type GetReportContactDetailsMutationOptions = Apollo.BaseMutationOptions<GetReportContactDetailsMutation, GetReportContactDetailsMutationVariables>;
export const GetReportCrewDetailsDocument = gql`
    mutation getReportCrewDetails($endDate: DateTime!, $first: Int, $page: Int, $startDate: DateTime!) {
  getReportCrewDetails(
    endDate: $endDate
    first: $first
    page: $page
    startDate: $startDate
  ) {
    data {
      actual_labour_hours
      crew_name
      estimated_labour_hours
      job_id
      job_size
      material_cost_type
      proposal_total_amount
      total_material_used
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportCrewDetailsMutationFn = Apollo.MutationFunction<GetReportCrewDetailsMutation, GetReportCrewDetailsMutationVariables>;

/**
 * __useGetReportCrewDetailsMutation__
 *
 * To run a mutation, you first call `useGetReportCrewDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportCrewDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportCrewDetailsMutation, { data, loading, error }] = useGetReportCrewDetailsMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportCrewDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetReportCrewDetailsMutation, GetReportCrewDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportCrewDetailsMutation, GetReportCrewDetailsMutationVariables>(GetReportCrewDetailsDocument, options);
      }
export type GetReportCrewDetailsMutationHookResult = ReturnType<typeof useGetReportCrewDetailsMutation>;
export type GetReportCrewDetailsMutationResult = Apollo.MutationResult<GetReportCrewDetailsMutation>;
export type GetReportCrewDetailsMutationOptions = Apollo.BaseMutationOptions<GetReportCrewDetailsMutation, GetReportCrewDetailsMutationVariables>;
export const GetReportEquipmentCostDetailsDocument = gql`
    mutation getReportEquipmentCostDetails($endDate: DateTime!, $first: Int, $page: Int, $startDate: DateTime!) {
  getReportEquipmentCostDetails(
    endDate: $endDate
    first: $first
    page: $page
    startDate: $startDate
  ) {
    data {
      equipmentCost
      equipmentHours
      equipmentId
      equipmentName
      jobId
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportEquipmentCostDetailsMutationFn = Apollo.MutationFunction<GetReportEquipmentCostDetailsMutation, GetReportEquipmentCostDetailsMutationVariables>;

/**
 * __useGetReportEquipmentCostDetailsMutation__
 *
 * To run a mutation, you first call `useGetReportEquipmentCostDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportEquipmentCostDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportEquipmentCostDetailsMutation, { data, loading, error }] = useGetReportEquipmentCostDetailsMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportEquipmentCostDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetReportEquipmentCostDetailsMutation, GetReportEquipmentCostDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportEquipmentCostDetailsMutation, GetReportEquipmentCostDetailsMutationVariables>(GetReportEquipmentCostDetailsDocument, options);
      }
export type GetReportEquipmentCostDetailsMutationHookResult = ReturnType<typeof useGetReportEquipmentCostDetailsMutation>;
export type GetReportEquipmentCostDetailsMutationResult = Apollo.MutationResult<GetReportEquipmentCostDetailsMutation>;
export type GetReportEquipmentCostDetailsMutationOptions = Apollo.BaseMutationOptions<GetReportEquipmentCostDetailsMutation, GetReportEquipmentCostDetailsMutationVariables>;
export const GetReportJobCostByProductTypeDocument = gql`
    mutation getReportJobCostByProductType($endDate: DateTime!, $first: Int, $jobId: String, $page: Int, $startDate: DateTime!) {
  getReportJobCostByProductType(
    endDate: $endDate
    first: $first
    jobId: $jobId
    page: $page
    startDate: $startDate
  ) {
    data {
      actual_cost_equipment
      actual_cost_labour
      actual_cost_material
      actual_cost_transfer_truck
      actual_employee_hours
      job_id
      job_size
      organization_product_type_name
      proposed_cost_equipment
      proposed_cost_labour
      proposed_cost_material
      proposed_cost_transfer_truck
      proposed_employee_hours
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportJobCostByProductTypeMutationFn = Apollo.MutationFunction<GetReportJobCostByProductTypeMutation, GetReportJobCostByProductTypeMutationVariables>;

/**
 * __useGetReportJobCostByProductTypeMutation__
 *
 * To run a mutation, you first call `useGetReportJobCostByProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportJobCostByProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportJobCostByProductTypeMutation, { data, loading, error }] = useGetReportJobCostByProductTypeMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      jobId: // value for 'jobId'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportJobCostByProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<GetReportJobCostByProductTypeMutation, GetReportJobCostByProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportJobCostByProductTypeMutation, GetReportJobCostByProductTypeMutationVariables>(GetReportJobCostByProductTypeDocument, options);
      }
export type GetReportJobCostByProductTypeMutationHookResult = ReturnType<typeof useGetReportJobCostByProductTypeMutation>;
export type GetReportJobCostByProductTypeMutationResult = Apollo.MutationResult<GetReportJobCostByProductTypeMutation>;
export type GetReportJobCostByProductTypeMutationOptions = Apollo.BaseMutationOptions<GetReportJobCostByProductTypeMutation, GetReportJobCostByProductTypeMutationVariables>;
export const GetReportJobCostDetailDocument = gql`
    mutation getReportJobCostDetail($jobId: String!) {
  getReportJobCostDetail(jobId: $jobId) {
    additional_costs {
      cost
      date
      expense
      qty
      rate
    }
    employees {
      cost
      date
      employee
      hours
      rate
    }
    equipment {
      cost
      date
      equipment
      hours
      rate
    }
    header {
      company_name
      job_external_id
      job_id
      job_name
      status
      total_proposed_amount
    }
    materials {
      cost
      date
      material
      qty
      rate
    }
    summary {
      actual_profit
      additional_costs_difference_percent
      additional_costs_total
      employees_difference_percent
      employees_total
      equipment_difference_percent
      equipment_total
      material_difference_percent
      material_total
      profit_difference_percent
      proposed_additional_costs_total
      proposed_employees_total
      proposed_equipment_total
      proposed_material_total
      proposed_profit
      proposed_total_job_cost
      proposed_trucking_total
      total_job_cost
      total_job_cost_difference_percent
      trucking_difference_percent
      trucking_total
    }
    trucking {
      cost
      date
      qty
      rate
      truck
    }
  }
}
    `;
export type GetReportJobCostDetailMutationFn = Apollo.MutationFunction<GetReportJobCostDetailMutation, GetReportJobCostDetailMutationVariables>;

/**
 * __useGetReportJobCostDetailMutation__
 *
 * To run a mutation, you first call `useGetReportJobCostDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportJobCostDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportJobCostDetailMutation, { data, loading, error }] = useGetReportJobCostDetailMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetReportJobCostDetailMutation(baseOptions?: Apollo.MutationHookOptions<GetReportJobCostDetailMutation, GetReportJobCostDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportJobCostDetailMutation, GetReportJobCostDetailMutationVariables>(GetReportJobCostDetailDocument, options);
      }
export type GetReportJobCostDetailMutationHookResult = ReturnType<typeof useGetReportJobCostDetailMutation>;
export type GetReportJobCostDetailMutationResult = Apollo.MutationResult<GetReportJobCostDetailMutation>;
export type GetReportJobCostDetailMutationOptions = Apollo.BaseMutationOptions<GetReportJobCostDetailMutation, GetReportJobCostDetailMutationVariables>;
export const GetReportJobDetailsDocument = gql`
    mutation getReportJobDetails($companyId: String, $endDate: DateTime!, $first: Int, $jobId: String, $page: Int, $startDate: DateTime!) {
  getReportJobDetails(
    companyId: $companyId
    endDate: $endDate
    first: $first
    jobId: $jobId
    page: $page
    startDate: $startDate
  ) {
    data {
      actual_cost_additional
      actual_cost_direct
      actual_cost_equipment
      actual_cost_indirect
      actual_cost_labour
      actual_cost_material
      actual_cost_overhead
      actual_cost_total
      actual_gross_margin
      actual_gross_margin_percentage
      actual_net_margin
      actual_net_margin_percentage
      actual_operating_margin
      actual_operating_margin_percentage
      actual_overall_total
      actual_profit
      actual_profit_percentage
      company_name
      crew_display_name
      crew_name
      ends_at
      job_address_city
      job_address_line_1
      job_address_state
      job_address_zip
      job_external_id
      job_id
      notes
      organization_product_type_name
      proposal_external_id
      proposal_product_job_duration
      proposal_product_job_size
      proposal_product_material_type
      proposal_product_material_used
      proposal_product_name
      proposal_stage_id
      proposal_stage_name
      proposed_cost_additional
      proposed_cost_direct
      proposed_cost_equipment
      proposed_cost_indirect
      proposed_cost_labour
      proposed_cost_material
      proposed_cost_overhead
      proposed_cost_total
      proposed_gross_margin
      proposed_gross_margin_percentage
      proposed_net_margin
      proposed_net_margin_percentage
      proposed_operating_margin
      proposed_operating_margin_percentage
      proposed_overall_total
      proposed_profit
      proposed_profit_percentage
      starts_at
      status
    }
    metadata {
      totals {
        actual_cost_additional
        actual_cost_direct
        actual_cost_equipment
        actual_cost_indirect
        actual_cost_labour
        actual_cost_material
        actual_cost_overhead
        actual_cost_total
        actual_gross_margin
        actual_net_margin
        actual_operating_margin
        actual_overall_total
        actual_profit
        proposed_cost_additional
        proposed_cost_direct
        proposed_cost_equipment
        proposed_cost_indirect
        proposed_cost_labour
        proposed_cost_material
        proposed_cost_overhead
        proposed_cost_total
        proposed_gross_margin
        proposed_net_margin
        proposed_operating_margin
        proposed_overall_total
        proposed_profit
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportJobDetailsMutationFn = Apollo.MutationFunction<GetReportJobDetailsMutation, GetReportJobDetailsMutationVariables>;

/**
 * __useGetReportJobDetailsMutation__
 *
 * To run a mutation, you first call `useGetReportJobDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportJobDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportJobDetailsMutation, { data, loading, error }] = useGetReportJobDetailsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      jobId: // value for 'jobId'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportJobDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetReportJobDetailsMutation, GetReportJobDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportJobDetailsMutation, GetReportJobDetailsMutationVariables>(GetReportJobDetailsDocument, options);
      }
export type GetReportJobDetailsMutationHookResult = ReturnType<typeof useGetReportJobDetailsMutation>;
export type GetReportJobDetailsMutationResult = Apollo.MutationResult<GetReportJobDetailsMutation>;
export type GetReportJobDetailsMutationOptions = Apollo.BaseMutationOptions<GetReportJobDetailsMutation, GetReportJobDetailsMutationVariables>;
export const GetReportJobsByContactDocument = gql`
    mutation getReportJobsByContact($companyId: String, $endDate: DateTime!, $first: Int, $page: Int, $startDate: DateTime!) {
  getReportJobsByContact(
    companyId: $companyId
    endDate: $endDate
    first: $first
    page: $page
    startDate: $startDate
  ) {
    data {
      customerName
      job
      jobSize
      total
    }
    metadata {
      totals {
        grand_total
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportJobsByContactMutationFn = Apollo.MutationFunction<GetReportJobsByContactMutation, GetReportJobsByContactMutationVariables>;

/**
 * __useGetReportJobsByContactMutation__
 *
 * To run a mutation, you first call `useGetReportJobsByContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportJobsByContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportJobsByContactMutation, { data, loading, error }] = useGetReportJobsByContactMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportJobsByContactMutation(baseOptions?: Apollo.MutationHookOptions<GetReportJobsByContactMutation, GetReportJobsByContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportJobsByContactMutation, GetReportJobsByContactMutationVariables>(GetReportJobsByContactDocument, options);
      }
export type GetReportJobsByContactMutationHookResult = ReturnType<typeof useGetReportJobsByContactMutation>;
export type GetReportJobsByContactMutationResult = Apollo.MutationResult<GetReportJobsByContactMutation>;
export type GetReportJobsByContactMutationOptions = Apollo.BaseMutationOptions<GetReportJobsByContactMutation, GetReportJobsByContactMutationVariables>;
export const GetReportOrganizationProfitabilityDocument = gql`
    mutation getReportOrganizationProfitability($endDate: DateTime!, $first: Int, $page: Int, $productTypeId: String, $startDate: DateTime!) {
  getReportOrganizationProfitability(
    endDate: $endDate
    first: $first
    page: $page
    productTypeId: $productTypeId
    startDate: $startDate
  ) {
    data {
      actual_cost_additional
      actual_cost_equipment
      actual_cost_labour
      actual_cost_material
      actual_cost_transfer_truck
      actual_profit
      additional_variance_percentage
      cost_basis
      equipment_variance_percentage
      items_without_costs
      labour_variance_percentage
      material_variance_percentage
      organization_product_type_name
      profit_variance_dollars
      profit_variance_percentage
      proposed_cost_additional
      proposed_cost_equipment
      proposed_cost_labour
      proposed_cost_material
      proposed_cost_transfer_truck
      proposed_profit
      trucking_variance_percentage
    }
    metadata {
      totals {
        actual_cost_additional
        actual_cost_equipment
        actual_cost_labour
        actual_cost_material
        actual_cost_transfer_truck
        actual_profit
        additional_variance_percentage
        cost_basis
        equipment_variance_percentage
        items_without_costs
        labour_variance_percentage
        material_variance_percentage
        organization_product_type_name
        profit_variance_dollars
        profit_variance_percentage
        proposed_cost_additional
        proposed_cost_equipment
        proposed_cost_labour
        proposed_cost_material
        proposed_cost_transfer_truck
        proposed_profit
        trucking_variance_percentage
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportOrganizationProfitabilityMutationFn = Apollo.MutationFunction<GetReportOrganizationProfitabilityMutation, GetReportOrganizationProfitabilityMutationVariables>;

/**
 * __useGetReportOrganizationProfitabilityMutation__
 *
 * To run a mutation, you first call `useGetReportOrganizationProfitabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportOrganizationProfitabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportOrganizationProfitabilityMutation, { data, loading, error }] = useGetReportOrganizationProfitabilityMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      productTypeId: // value for 'productTypeId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportOrganizationProfitabilityMutation(baseOptions?: Apollo.MutationHookOptions<GetReportOrganizationProfitabilityMutation, GetReportOrganizationProfitabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportOrganizationProfitabilityMutation, GetReportOrganizationProfitabilityMutationVariables>(GetReportOrganizationProfitabilityDocument, options);
      }
export type GetReportOrganizationProfitabilityMutationHookResult = ReturnType<typeof useGetReportOrganizationProfitabilityMutation>;
export type GetReportOrganizationProfitabilityMutationResult = Apollo.MutationResult<GetReportOrganizationProfitabilityMutation>;
export type GetReportOrganizationProfitabilityMutationOptions = Apollo.BaseMutationOptions<GetReportOrganizationProfitabilityMutation, GetReportOrganizationProfitabilityMutationVariables>;
export const GetReportProductDetailsDocument = gql`
    mutation getReportProductDetails($endDate: DateTime!, $first: Int, $page: Int, $startDate: DateTime!) {
  getReportProductDetails(
    endDate: $endDate
    first: $first
    page: $page
    startDate: $startDate
  ) {
    data {
      costBasis
      itemsWithoutCosts
      materialCostType
      materialNeededSum
      measurementMaterial
      productId
      productName
      productType
      proposalsCount
      sumCostTotal
      sumOverallTotal
      sumProfit
    }
    metadata {
      totals {
        cost_total_sum
        items_without_costs
        overall_total_sum
        profit_sum
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportProductDetailsMutationFn = Apollo.MutationFunction<GetReportProductDetailsMutation, GetReportProductDetailsMutationVariables>;

/**
 * __useGetReportProductDetailsMutation__
 *
 * To run a mutation, you first call `useGetReportProductDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportProductDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportProductDetailsMutation, { data, loading, error }] = useGetReportProductDetailsMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportProductDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetReportProductDetailsMutation, GetReportProductDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportProductDetailsMutation, GetReportProductDetailsMutationVariables>(GetReportProductDetailsDocument, options);
      }
export type GetReportProductDetailsMutationHookResult = ReturnType<typeof useGetReportProductDetailsMutation>;
export type GetReportProductDetailsMutationResult = Apollo.MutationResult<GetReportProductDetailsMutation>;
export type GetReportProductDetailsMutationOptions = Apollo.BaseMutationOptions<GetReportProductDetailsMutation, GetReportProductDetailsMutationVariables>;
export const GetReportProposalDetailsDocument = gql`
    mutation getReportProposalDetails($companyId: String, $endDate: DateTime!, $estimatorId: String, $first: Int, $jobId: String, $page: Int, $productTypeId: String, $startDate: DateTime!, $status: String, $wonAt: Boolean) {
  getReportProposalDetails(
    companyId: $companyId
    endDate: $endDate
    estimatorId: $estimatorId
    first: $first
    jobId: $jobId
    page: $page
    productTypeId: $productTypeId
    startDate: $startDate
    status: $status
    wonAt: $wonAt
  ) {
    data {
      address_line_1
      city
      company_id
      company_name
      cost_additional
      cost_basis
      cost_direct
      cost_equipment
      cost_indirect
      cost_labour
      cost_material
      cost_overhead
      cost_total
      created_at
      created_by
      estimator_name
      external_id_with_prefix
      gross_margin
      gross_margin_percentage
      job_name
      job_size
      material_material_needed_override
      material_measurement_material
      material_name
      material_type
      net_margin
      net_margin_percentage
      operating_margin
      operating_margin_percentage
      overall_total
      profit
      profit_percentage_override
      proposal_notes
      sent_at
      signed_at
      signee_initials
      signee_name
      source
      stage_id
      stage_name
      state
      status
      user_id
      viewed_at
      won_at
      zip
    }
    metadata {
      totals {
        cost_additional
        cost_direct
        cost_equipment
        cost_indirect
        cost_labour
        cost_material
        cost_overhead
        cost_total
        gross_margin
        items_without_costs
        net_margin
        operating_margin
        overall_total
        profit
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportProposalDetailsMutationFn = Apollo.MutationFunction<GetReportProposalDetailsMutation, GetReportProposalDetailsMutationVariables>;

/**
 * __useGetReportProposalDetailsMutation__
 *
 * To run a mutation, you first call `useGetReportProposalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportProposalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportProposalDetailsMutation, { data, loading, error }] = useGetReportProposalDetailsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      endDate: // value for 'endDate'
 *      estimatorId: // value for 'estimatorId'
 *      first: // value for 'first'
 *      jobId: // value for 'jobId'
 *      page: // value for 'page'
 *      productTypeId: // value for 'productTypeId'
 *      startDate: // value for 'startDate'
 *      status: // value for 'status'
 *      wonAt: // value for 'wonAt'
 *   },
 * });
 */
export function useGetReportProposalDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetReportProposalDetailsMutation, GetReportProposalDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportProposalDetailsMutation, GetReportProposalDetailsMutationVariables>(GetReportProposalDetailsDocument, options);
      }
export type GetReportProposalDetailsMutationHookResult = ReturnType<typeof useGetReportProposalDetailsMutation>;
export type GetReportProposalDetailsMutationResult = Apollo.MutationResult<GetReportProposalDetailsMutation>;
export type GetReportProposalDetailsMutationOptions = Apollo.BaseMutationOptions<GetReportProposalDetailsMutation, GetReportProposalDetailsMutationVariables>;
export const GetReportSalesByContactDocument = gql`
    mutation getReportSalesByContact($companyId: String, $endDate: DateTime!, $first: Int, $page: Int, $startDate: DateTime!) {
  getReportSalesByContact(
    companyId: $companyId
    endDate: $endDate
    first: $first
    page: $page
    startDate: $startDate
  ) {
    data {
      customerName
      jobSize
      product
      total
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportSalesByContactMutationFn = Apollo.MutationFunction<GetReportSalesByContactMutation, GetReportSalesByContactMutationVariables>;

/**
 * __useGetReportSalesByContactMutation__
 *
 * To run a mutation, you first call `useGetReportSalesByContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportSalesByContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportSalesByContactMutation, { data, loading, error }] = useGetReportSalesByContactMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportSalesByContactMutation(baseOptions?: Apollo.MutationHookOptions<GetReportSalesByContactMutation, GetReportSalesByContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportSalesByContactMutation, GetReportSalesByContactMutationVariables>(GetReportSalesByContactDocument, options);
      }
export type GetReportSalesByContactMutationHookResult = ReturnType<typeof useGetReportSalesByContactMutation>;
export type GetReportSalesByContactMutationResult = Apollo.MutationResult<GetReportSalesByContactMutation>;
export type GetReportSalesByContactMutationOptions = Apollo.BaseMutationOptions<GetReportSalesByContactMutation, GetReportSalesByContactMutationVariables>;
export const GetReportSalesByProductSummaryDocument = gql`
    mutation getReportSalesByProductSummary($endDate: DateTime!, $first: Int, $page: Int, $productId: String, $startDate: DateTime!) {
  getReportSalesByProductSummary(
    endDate: $endDate
    first: $first
    page: $page
    productId: $productId
    startDate: $startDate
  ) {
    data {
      amount
      avgUnitPrice
      perOfSales
      product
      totalJobSize
      totalMaterialQuantity
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportSalesByProductSummaryMutationFn = Apollo.MutationFunction<GetReportSalesByProductSummaryMutation, GetReportSalesByProductSummaryMutationVariables>;

/**
 * __useGetReportSalesByProductSummaryMutation__
 *
 * To run a mutation, you first call `useGetReportSalesByProductSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportSalesByProductSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportSalesByProductSummaryMutation, { data, loading, error }] = useGetReportSalesByProductSummaryMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      productId: // value for 'productId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportSalesByProductSummaryMutation(baseOptions?: Apollo.MutationHookOptions<GetReportSalesByProductSummaryMutation, GetReportSalesByProductSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportSalesByProductSummaryMutation, GetReportSalesByProductSummaryMutationVariables>(GetReportSalesByProductSummaryDocument, options);
      }
export type GetReportSalesByProductSummaryMutationHookResult = ReturnType<typeof useGetReportSalesByProductSummaryMutation>;
export type GetReportSalesByProductSummaryMutationResult = Apollo.MutationResult<GetReportSalesByProductSummaryMutation>;
export type GetReportSalesByProductSummaryMutationOptions = Apollo.BaseMutationOptions<GetReportSalesByProductSummaryMutation, GetReportSalesByProductSummaryMutationVariables>;
export const GetReportSalesByProposalSourceDocument = gql`
    mutation getReportSalesByProposalSource($endDate: DateTime!, $first: Int, $page: Int, $startDate: DateTime!) {
  getReportSalesByProposalSource(
    endDate: $endDate
    first: $first
    page: $page
    startDate: $startDate
  ) {
    data {
      orgRevenuePercentage
      pTotal
      proposalsWonAmountTotal
      proposalsWonCount
      s1
      winRate
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportSalesByProposalSourceMutationFn = Apollo.MutationFunction<GetReportSalesByProposalSourceMutation, GetReportSalesByProposalSourceMutationVariables>;

/**
 * __useGetReportSalesByProposalSourceMutation__
 *
 * To run a mutation, you first call `useGetReportSalesByProposalSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportSalesByProposalSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportSalesByProposalSourceMutation, { data, loading, error }] = useGetReportSalesByProposalSourceMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportSalesByProposalSourceMutation(baseOptions?: Apollo.MutationHookOptions<GetReportSalesByProposalSourceMutation, GetReportSalesByProposalSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportSalesByProposalSourceMutation, GetReportSalesByProposalSourceMutationVariables>(GetReportSalesByProposalSourceDocument, options);
      }
export type GetReportSalesByProposalSourceMutationHookResult = ReturnType<typeof useGetReportSalesByProposalSourceMutation>;
export type GetReportSalesByProposalSourceMutationResult = Apollo.MutationResult<GetReportSalesByProposalSourceMutation>;
export type GetReportSalesByProposalSourceMutationOptions = Apollo.BaseMutationOptions<GetReportSalesByProposalSourceMutation, GetReportSalesByProposalSourceMutationVariables>;
export const GetReportTimeEntriesDocument = gql`
    mutation getReportTimeEntries($endDate: DateTime!, $startDate: DateTime!) {
  getReportTimeEntries(endDate: $endDate, startDate: $startDate) {
    data {
      endTime
      forDate
      jobPhaseAddress
      jobPhaseExternalId
      proposalStageName
      startTime
      timeTrackedHours
      timeTrackedHuman
      userName
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;
export type GetReportTimeEntriesMutationFn = Apollo.MutationFunction<GetReportTimeEntriesMutation, GetReportTimeEntriesMutationVariables>;

/**
 * __useGetReportTimeEntriesMutation__
 *
 * To run a mutation, you first call `useGetReportTimeEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportTimeEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportTimeEntriesMutation, { data, loading, error }] = useGetReportTimeEntriesMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetReportTimeEntriesMutation(baseOptions?: Apollo.MutationHookOptions<GetReportTimeEntriesMutation, GetReportTimeEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportTimeEntriesMutation, GetReportTimeEntriesMutationVariables>(GetReportTimeEntriesDocument, options);
      }
export type GetReportTimeEntriesMutationHookResult = ReturnType<typeof useGetReportTimeEntriesMutation>;
export type GetReportTimeEntriesMutationResult = Apollo.MutationResult<GetReportTimeEntriesMutation>;
export type GetReportTimeEntriesMutationOptions = Apollo.BaseMutationOptions<GetReportTimeEntriesMutation, GetReportTimeEntriesMutationVariables>;
export const GetYearOverYearRevenueReportExportDocument = gql`
    mutation getYearOverYearRevenueReportExport {
  getYearOverYearRevenueReportExport
}
    `;
export type GetYearOverYearRevenueReportExportMutationFn = Apollo.MutationFunction<GetYearOverYearRevenueReportExportMutation, GetYearOverYearRevenueReportExportMutationVariables>;

/**
 * __useGetYearOverYearRevenueReportExportMutation__
 *
 * To run a mutation, you first call `useGetYearOverYearRevenueReportExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetYearOverYearRevenueReportExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getYearOverYearRevenueReportExportMutation, { data, loading, error }] = useGetYearOverYearRevenueReportExportMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetYearOverYearRevenueReportExportMutation(baseOptions?: Apollo.MutationHookOptions<GetYearOverYearRevenueReportExportMutation, GetYearOverYearRevenueReportExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetYearOverYearRevenueReportExportMutation, GetYearOverYearRevenueReportExportMutationVariables>(GetYearOverYearRevenueReportExportDocument, options);
      }
export type GetYearOverYearRevenueReportExportMutationHookResult = ReturnType<typeof useGetYearOverYearRevenueReportExportMutation>;
export type GetYearOverYearRevenueReportExportMutationResult = Apollo.MutationResult<GetYearOverYearRevenueReportExportMutation>;
export type GetYearOverYearRevenueReportExportMutationOptions = Apollo.BaseMutationOptions<GetYearOverYearRevenueReportExportMutation, GetYearOverYearRevenueReportExportMutationVariables>;
export const HasScheduledJobPhasesDocument = gql`
    mutation hasScheduledJobPhases($jobId: ID!) {
  hasScheduledJobPhases(jobId: $jobId)
}
    `;
export type HasScheduledJobPhasesMutationFn = Apollo.MutationFunction<HasScheduledJobPhasesMutation, HasScheduledJobPhasesMutationVariables>;

/**
 * __useHasScheduledJobPhasesMutation__
 *
 * To run a mutation, you first call `useHasScheduledJobPhasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHasScheduledJobPhasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hasScheduledJobPhasesMutation, { data, loading, error }] = useHasScheduledJobPhasesMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useHasScheduledJobPhasesMutation(baseOptions?: Apollo.MutationHookOptions<HasScheduledJobPhasesMutation, HasScheduledJobPhasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HasScheduledJobPhasesMutation, HasScheduledJobPhasesMutationVariables>(HasScheduledJobPhasesDocument, options);
      }
export type HasScheduledJobPhasesMutationHookResult = ReturnType<typeof useHasScheduledJobPhasesMutation>;
export type HasScheduledJobPhasesMutationResult = Apollo.MutationResult<HasScheduledJobPhasesMutation>;
export type HasScheduledJobPhasesMutationOptions = Apollo.BaseMutationOptions<HasScheduledJobPhasesMutation, HasScheduledJobPhasesMutationVariables>;
export const HoldProposalDocument = gql`
    mutation holdProposal($id: ID!) {
  holdProposal(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type HoldProposalMutationFn = Apollo.MutationFunction<HoldProposalMutation, HoldProposalMutationVariables>;

/**
 * __useHoldProposalMutation__
 *
 * To run a mutation, you first call `useHoldProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdProposalMutation, { data, loading, error }] = useHoldProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHoldProposalMutation(baseOptions?: Apollo.MutationHookOptions<HoldProposalMutation, HoldProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HoldProposalMutation, HoldProposalMutationVariables>(HoldProposalDocument, options);
      }
export type HoldProposalMutationHookResult = ReturnType<typeof useHoldProposalMutation>;
export type HoldProposalMutationResult = Apollo.MutationResult<HoldProposalMutation>;
export type HoldProposalMutationOptions = Apollo.BaseMutationOptions<HoldProposalMutation, HoldProposalMutationVariables>;
export const InviteUserDocument = gql`
    mutation inviteUser($input: InviteUserInput!) {
  inviteUser(input: $input)
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const LogActivityDocument = gql`
    mutation logActivity($input: LogActivityInput!) {
  logActivity(input: $input) {
    body
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    createdAt
    createdByUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      billingStatus
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        email
        id
        jobsCount
        logo
        name
        notes
        phone
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      invoiceId
      jobPhases {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          billingStatus
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          id
          invoiceId
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    occurredAt
    opportunity {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        email
        id
        jobsCount
        logo
        name
        notes
        phone
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      companyId
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      createdAt
      dueAt
      estimatedOpportunityValue
      externalId
      id
      name
      notes
      products {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      projectFilesFolderId
      source
      status
      statusId
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
    }
    opportunityId
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    summary
    type
    updatedAt
  }
}
    `;
export type LogActivityMutationFn = Apollo.MutationFunction<LogActivityMutation, LogActivityMutationVariables>;

/**
 * __useLogActivityMutation__
 *
 * To run a mutation, you first call `useLogActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logActivityMutation, { data, loading, error }] = useLogActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogActivityMutation(baseOptions?: Apollo.MutationHookOptions<LogActivityMutation, LogActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogActivityMutation, LogActivityMutationVariables>(LogActivityDocument, options);
      }
export type LogActivityMutationHookResult = ReturnType<typeof useLogActivityMutation>;
export type LogActivityMutationResult = Apollo.MutationResult<LogActivityMutation>;
export type LogActivityMutationOptions = Apollo.BaseMutationOptions<LogActivityMutation, LogActivityMutationVariables>;
export const LoginDocument = gql`
    mutation login($force: Boolean, $input: LoginInput!) {
  login(force: $force, input: $input) {
    __typename
    ... on ActiveSessionConflict {
      message
    }
    ... on User {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            invitedBy {
              addressCity
              addressCountry
              addressLine1
              addressLine2
              addressState
              addressZip
              archivedAt
              autoAssign
              avatar
              crewsCount
              email
              firstName
              hasEmployee
              id
              inviteToken
              invitedAt
              invitedBy {
                addressCity
                addressCountry
                addressLine1
                addressLine2
                addressState
                addressZip
                archivedAt
                autoAssign
                avatar
                crewsCount
                email
                firstName
                hasEmployee
                id
                inviteToken
                invitedAt
                jobPhasesCount
                jobsCount
                lastName
                name
                permissions
                phone
                proposalCount
                roles
                salesGoal
                status
              }
              jobPhasesCount
              jobsCount
              lastName
              name
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
              permissions
              phone
              proposalCount
              roles
              salesGoal
              status
            }
            jobPhasesCount
            jobsCount
            lastName
            name
            organization {
              canMapWithAi
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              invoiceEmailText
              invoicingPaymentTermsNet
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              organizationSalesGoal
              phone
              proposalDefaults {
                autoSave
                color
                defaultLoadingTimeMins
                defaultTransferTruckId
                defaultUnloadTimeMins
                estimateTruckingByFullDay
                id
                idPrefix
                layout
                maxTripNumberPerTruck
                minimumProfitPerDay
                multiplyTravelTimeByDay
                multiplyTravelTimeForEquipmentLabour
                optionalCheckboxDefaultChecked
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
                roundUpToNearestDollarAmount
                startingNumber
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            conversionFactorOverride {
              asphaltTonConversionFactorOverride
              excavateOutTonConversionFactorOverride
              id
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
            }
            documents {
              id
              name
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
              path
              thumbnailPath
            }
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            linkedServices {
              active
              expired
              id
              service
              type
            }
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalDefaults {
              autoSave
              color
              defaultLoadingTimeMins
              defaultTransferTruckId
              defaultUnloadTimeMins
              estimateTruckingByFullDay
              id
              idPrefix
              layout
              maxTripNumberPerTruck
              minimumProfitPerDay
              multiplyTravelTimeByDay
              multiplyTravelTimeForEquipmentLabour
              optionalCheckboxDefaultChecked
              removeIndividualLineItemPricing
              removeUnitPriceAndQuantity
              roundUpToNearestDollarAmount
              startingNumber
            }
            proposalSentEmailText
            salesTaxes {
              id
              isDefault
              name
              percentage
              quickbooksDesktopTaxCodeId
              quickbooksTaxCodeId
            }
            subscribed
            subscription {
              endsAt
              id
              name
              quantity
              renewsAt
              stripeId
              stripePrice
              stripeStatus
              trialEndsAt
            }
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
            organization {
              canMapWithAi
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              invoiceEmailText
              invoicingPaymentTermsNet
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              organizationSalesGoal
              phone
              proposalDefaults {
                autoSave
                color
                defaultLoadingTimeMins
                defaultTransferTruckId
                defaultUnloadTimeMins
                estimateTruckingByFullDay
                id
                idPrefix
                layout
                maxTripNumberPerTruck
                minimumProfitPerDay
                multiplyTravelTimeByDay
                multiplyTravelTimeForEquipmentLabour
                optionalCheckboxDefaultChecked
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
                roundUpToNearestDollarAmount
                startingNumber
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
          }
          documents {
            id
            name
            organization {
              canMapWithAi
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              invoiceEmailText
              invoicingPaymentTermsNet
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              organizationSalesGoal
              phone
              proposalDefaults {
                autoSave
                color
                defaultLoadingTimeMins
                defaultTransferTruckId
                defaultUnloadTimeMins
                estimateTruckingByFullDay
                id
                idPrefix
                layout
                maxTripNumberPerTruck
                minimumProfitPerDay
                multiplyTravelTimeByDay
                multiplyTravelTimeForEquipmentLabour
                optionalCheckboxDefaultChecked
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
                roundUpToNearestDollarAmount
                startingNumber
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            conversionFactorOverride {
              asphaltTonConversionFactorOverride
              excavateOutTonConversionFactorOverride
              id
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
            }
            documents {
              id
              name
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
              path
              thumbnailPath
            }
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            linkedServices {
              active
              expired
              id
              service
              type
            }
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalDefaults {
              autoSave
              color
              defaultLoadingTimeMins
              defaultTransferTruckId
              defaultUnloadTimeMins
              estimateTruckingByFullDay
              id
              idPrefix
              layout
              maxTripNumberPerTruck
              minimumProfitPerDay
              multiplyTravelTimeByDay
              multiplyTravelTimeForEquipmentLabour
              optionalCheckboxDefaultChecked
              removeIndividualLineItemPricing
              removeUnitPriceAndQuantity
              roundUpToNearestDollarAmount
              startingNumber
            }
            proposalSentEmailText
            salesTaxes {
              id
              isDefault
              name
              percentage
              quickbooksDesktopTaxCodeId
              quickbooksTaxCodeId
            }
            subscribed
            subscription {
              endsAt
              id
              name
              quantity
              renewsAt
              stripeId
              stripePrice
              stripeStatus
              trialEndsAt
            }
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            conversionFactorOverride {
              asphaltTonConversionFactorOverride
              excavateOutTonConversionFactorOverride
              id
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
            }
            documents {
              id
              name
              organization {
                canMapWithAi
                email
                emailTemplate
                failingPayment
                id
                invoiceEmailText
                invoicingPaymentTermsNet
                logo
                name
                onTrial
                organizationSalesGoal
                phone
                proposalSentEmailText
                subscribed
                timezone
                trialEndsAt
              }
              path
              thumbnailPath
            }
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            linkedServices {
              active
              expired
              id
              service
              type
            }
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalDefaults {
              autoSave
              color
              defaultLoadingTimeMins
              defaultTransferTruckId
              defaultUnloadTimeMins
              estimateTruckingByFullDay
              id
              idPrefix
              layout
              maxTripNumberPerTruck
              minimumProfitPerDay
              multiplyTravelTimeByDay
              multiplyTravelTimeForEquipmentLabour
              optionalCheckboxDefaultChecked
              removeIndividualLineItemPricing
              removeUnitPriceAndQuantity
              roundUpToNearestDollarAmount
              startingNumber
            }
            proposalSentEmailText
            salesTaxes {
              id
              isDefault
              name
              percentage
              quickbooksDesktopTaxCodeId
              quickbooksTaxCodeId
            }
            subscribed
            subscription {
              endsAt
              id
              name
              quantity
              renewsAt
              stripeId
              stripePrice
              stripeStatus
              trialEndsAt
            }
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      force: // value for 'force'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MergeCompanyDocument = gql`
    mutation mergeCompany($sourceCompany: ID!, $targetCompany: ID!) {
  mergeCompany(sourceCompany: $sourceCompany, targetCompany: $targetCompany) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type MergeCompanyMutationFn = Apollo.MutationFunction<MergeCompanyMutation, MergeCompanyMutationVariables>;

/**
 * __useMergeCompanyMutation__
 *
 * To run a mutation, you first call `useMergeCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCompanyMutation, { data, loading, error }] = useMergeCompanyMutation({
 *   variables: {
 *      sourceCompany: // value for 'sourceCompany'
 *      targetCompany: // value for 'targetCompany'
 *   },
 * });
 */
export function useMergeCompanyMutation(baseOptions?: Apollo.MutationHookOptions<MergeCompanyMutation, MergeCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeCompanyMutation, MergeCompanyMutationVariables>(MergeCompanyDocument, options);
      }
export type MergeCompanyMutationHookResult = ReturnType<typeof useMergeCompanyMutation>;
export type MergeCompanyMutationResult = Apollo.MutationResult<MergeCompanyMutation>;
export type MergeCompanyMutationOptions = Apollo.BaseMutationOptions<MergeCompanyMutation, MergeCompanyMutationVariables>;
export const PreviewInvoiceDocument = gql`
    mutation previewInvoice($data: String, $hideLineItemPricing: Boolean, $id: ID!) {
  previewInvoice(data: $data, hideLineItemPricing: $hideLineItemPricing, id: $id)
}
    `;
export type PreviewInvoiceMutationFn = Apollo.MutationFunction<PreviewInvoiceMutation, PreviewInvoiceMutationVariables>;

/**
 * __usePreviewInvoiceMutation__
 *
 * To run a mutation, you first call `usePreviewInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewInvoiceMutation, { data, loading, error }] = usePreviewInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      hideLineItemPricing: // value for 'hideLineItemPricing'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreviewInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<PreviewInvoiceMutation, PreviewInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewInvoiceMutation, PreviewInvoiceMutationVariables>(PreviewInvoiceDocument, options);
      }
export type PreviewInvoiceMutationHookResult = ReturnType<typeof usePreviewInvoiceMutation>;
export type PreviewInvoiceMutationResult = Apollo.MutationResult<PreviewInvoiceMutation>;
export type PreviewInvoiceMutationOptions = Apollo.BaseMutationOptions<PreviewInvoiceMutation, PreviewInvoiceMutationVariables>;
export const PreviewProposalDocument = gql`
    mutation previewProposal($acceptanceOverride: String, $attachments: [ID!], $clientEmailOverride: String, $contentSettings: UpdateProposalContentSettingsHasManyInput, $emailBodyOverride: String, $emailSubjectOverride: String, $forceSend: Boolean, $layout: ProposalLayout!, $proposalId: ID!, $removeIndividualLineItemPricing: Boolean, $removeUnitPriceAndQuantity: Boolean) {
  previewProposal(
    acceptanceOverride: $acceptanceOverride
    attachments: $attachments
    clientEmailOverride: $clientEmailOverride
    contentSettings: $contentSettings
    emailBodyOverride: $emailBodyOverride
    emailSubjectOverride: $emailSubjectOverride
    forceSend: $forceSend
    layout: $layout
    proposalId: $proposalId
    removeIndividualLineItemPricing: $removeIndividualLineItemPricing
    removeUnitPriceAndQuantity: $removeUnitPriceAndQuantity
  )
}
    `;
export type PreviewProposalMutationFn = Apollo.MutationFunction<PreviewProposalMutation, PreviewProposalMutationVariables>;

/**
 * __usePreviewProposalMutation__
 *
 * To run a mutation, you first call `usePreviewProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewProposalMutation, { data, loading, error }] = usePreviewProposalMutation({
 *   variables: {
 *      acceptanceOverride: // value for 'acceptanceOverride'
 *      attachments: // value for 'attachments'
 *      clientEmailOverride: // value for 'clientEmailOverride'
 *      contentSettings: // value for 'contentSettings'
 *      emailBodyOverride: // value for 'emailBodyOverride'
 *      emailSubjectOverride: // value for 'emailSubjectOverride'
 *      forceSend: // value for 'forceSend'
 *      layout: // value for 'layout'
 *      proposalId: // value for 'proposalId'
 *      removeIndividualLineItemPricing: // value for 'removeIndividualLineItemPricing'
 *      removeUnitPriceAndQuantity: // value for 'removeUnitPriceAndQuantity'
 *   },
 * });
 */
export function usePreviewProposalMutation(baseOptions?: Apollo.MutationHookOptions<PreviewProposalMutation, PreviewProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewProposalMutation, PreviewProposalMutationVariables>(PreviewProposalDocument, options);
      }
export type PreviewProposalMutationHookResult = ReturnType<typeof usePreviewProposalMutation>;
export type PreviewProposalMutationResult = Apollo.MutationResult<PreviewProposalMutation>;
export type PreviewProposalMutationOptions = Apollo.BaseMutationOptions<PreviewProposalMutation, PreviewProposalMutationVariables>;
export const ReassignTaskDocument = gql`
    mutation reassignTask($input: ReassignTaskInput!) {
  reassignTask(input: $input) {
    assignedUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    completedAt
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    content
    createdAt
    dueAt
    id
    notifiableExternalId
    notifiableId
    notifiableType
    notificationTrigger {
      active
      additionalRecipientTypes
      additionalRecipients {
        email
        firstName
        id
        isTask
        lastName
        taskContent
      }
      apiHeaders
      apiMethod
      apiPayload
      apiSecret
      apiUrl
      content
      delay
      emailSubject
      event
      id
      isApi
      isEmail
      isSMS
      isTask
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      sendToAllRecipients
      sendToContact
      sendToUser
      smsContent
      taskContent
      type
    }
    status
    triggerEvent
    triggerType
    updatedAt
  }
}
    `;
export type ReassignTaskMutationFn = Apollo.MutationFunction<ReassignTaskMutation, ReassignTaskMutationVariables>;

/**
 * __useReassignTaskMutation__
 *
 * To run a mutation, you first call `useReassignTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignTaskMutation, { data, loading, error }] = useReassignTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignTaskMutation(baseOptions?: Apollo.MutationHookOptions<ReassignTaskMutation, ReassignTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignTaskMutation, ReassignTaskMutationVariables>(ReassignTaskDocument, options);
      }
export type ReassignTaskMutationHookResult = ReturnType<typeof useReassignTaskMutation>;
export type ReassignTaskMutationResult = Apollo.MutationResult<ReassignTaskMutation>;
export type ReassignTaskMutationOptions = Apollo.BaseMutationOptions<ReassignTaskMutation, ReassignTaskMutationVariables>;
export const RedoAiMappingRunAreaDocument = gql`
    mutation redoAiMappingRunArea($id: ID!) {
  redoAiMappingRunArea(id: $id) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    detections {
      bbox
      category
      color
      confidence
      id
      isDeleted
      source
      version
    }
    segmentations {
      areaSqft
      category
      color
      id
      isDeleted
      polygon
      version
    }
  }
}
    `;
export type RedoAiMappingRunAreaMutationFn = Apollo.MutationFunction<RedoAiMappingRunAreaMutation, RedoAiMappingRunAreaMutationVariables>;

/**
 * __useRedoAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useRedoAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedoAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redoAiMappingRunAreaMutation, { data, loading, error }] = useRedoAiMappingRunAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRedoAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<RedoAiMappingRunAreaMutation, RedoAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedoAiMappingRunAreaMutation, RedoAiMappingRunAreaMutationVariables>(RedoAiMappingRunAreaDocument, options);
      }
export type RedoAiMappingRunAreaMutationHookResult = ReturnType<typeof useRedoAiMappingRunAreaMutation>;
export type RedoAiMappingRunAreaMutationResult = Apollo.MutationResult<RedoAiMappingRunAreaMutation>;
export type RedoAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<RedoAiMappingRunAreaMutation, RedoAiMappingRunAreaMutationVariables>;
export const RefreshOrganizationEmailIdentityStatusDocument = gql`
    mutation refreshOrganizationEmailIdentityStatus {
  refreshOrganizationEmailIdentityStatus {
    dkimTokens {
      host
      type
      value
    }
    dmarcRecord {
      host
      type
      value
    }
    enabled
    fromName
    id
    invoiceFromAddress
    invoiceLocalPart
    notificationsFromAddress
    notificationsLocalPart
    organizationId
    proposalFromAddress
    proposalLocalPart
    replyToCustomEmail
    replyToType
    sendingDomain
    spfRecord {
      host
      type
      value
    }
    verificationStatus
    verifiedAt
  }
}
    `;
export type RefreshOrganizationEmailIdentityStatusMutationFn = Apollo.MutationFunction<RefreshOrganizationEmailIdentityStatusMutation, RefreshOrganizationEmailIdentityStatusMutationVariables>;

/**
 * __useRefreshOrganizationEmailIdentityStatusMutation__
 *
 * To run a mutation, you first call `useRefreshOrganizationEmailIdentityStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshOrganizationEmailIdentityStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshOrganizationEmailIdentityStatusMutation, { data, loading, error }] = useRefreshOrganizationEmailIdentityStatusMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshOrganizationEmailIdentityStatusMutation(baseOptions?: Apollo.MutationHookOptions<RefreshOrganizationEmailIdentityStatusMutation, RefreshOrganizationEmailIdentityStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshOrganizationEmailIdentityStatusMutation, RefreshOrganizationEmailIdentityStatusMutationVariables>(RefreshOrganizationEmailIdentityStatusDocument, options);
      }
export type RefreshOrganizationEmailIdentityStatusMutationHookResult = ReturnType<typeof useRefreshOrganizationEmailIdentityStatusMutation>;
export type RefreshOrganizationEmailIdentityStatusMutationResult = Apollo.MutationResult<RefreshOrganizationEmailIdentityStatusMutation>;
export type RefreshOrganizationEmailIdentityStatusMutationOptions = Apollo.BaseMutationOptions<RefreshOrganizationEmailIdentityStatusMutation, RefreshOrganizationEmailIdentityStatusMutationVariables>;
export const RegisterDocument = gql`
    mutation register($input: RegisterInput!) {
  register(input: $input)
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RemoveTruckFromProposalProductDocument = gql`
    mutation removeTruckFromProposalProduct($id: ID!) {
  removeTruckFromProposalProduct(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type RemoveTruckFromProposalProductMutationFn = Apollo.MutationFunction<RemoveTruckFromProposalProductMutation, RemoveTruckFromProposalProductMutationVariables>;

/**
 * __useRemoveTruckFromProposalProductMutation__
 *
 * To run a mutation, you first call `useRemoveTruckFromProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTruckFromProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTruckFromProposalProductMutation, { data, loading, error }] = useRemoveTruckFromProposalProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTruckFromProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTruckFromProposalProductMutation, RemoveTruckFromProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTruckFromProposalProductMutation, RemoveTruckFromProposalProductMutationVariables>(RemoveTruckFromProposalProductDocument, options);
      }
export type RemoveTruckFromProposalProductMutationHookResult = ReturnType<typeof useRemoveTruckFromProposalProductMutation>;
export type RemoveTruckFromProposalProductMutationResult = Apollo.MutationResult<RemoveTruckFromProposalProductMutation>;
export type RemoveTruckFromProposalProductMutationOptions = Apollo.BaseMutationOptions<RemoveTruckFromProposalProductMutation, RemoveTruckFromProposalProductMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation requestPasswordReset($input: RequestPasswordResetInput!) {
  requestPasswordReset(input: $input)
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResendUserInviteDocument = gql`
    mutation resendUserInvite($id: ID!) {
  resendUserInvite(id: $id)
}
    `;
export type ResendUserInviteMutationFn = Apollo.MutationFunction<ResendUserInviteMutation, ResendUserInviteMutationVariables>;

/**
 * __useResendUserInviteMutation__
 *
 * To run a mutation, you first call `useResendUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInviteMutation, { data, loading, error }] = useResendUserInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserInviteMutation, ResendUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserInviteMutation, ResendUserInviteMutationVariables>(ResendUserInviteDocument, options);
      }
export type ResendUserInviteMutationHookResult = ReturnType<typeof useResendUserInviteMutation>;
export type ResendUserInviteMutationResult = Apollo.MutationResult<ResendUserInviteMutation>;
export type ResendUserInviteMutationOptions = Apollo.BaseMutationOptions<ResendUserInviteMutation, ResendUserInviteMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation resendVerificationEmail($input: ResendVerificationEmailInput!) {
  resendVerificationEmail(input: $input)
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RestoreEmployeeDocument = gql`
    mutation restoreEmployee($id: ID!) {
  restoreEmployee(id: $id) {
    archivedAt
    firstName
    id
    lastName
    name
    organizationId
    rate
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;
export type RestoreEmployeeMutationFn = Apollo.MutationFunction<RestoreEmployeeMutation, RestoreEmployeeMutationVariables>;

/**
 * __useRestoreEmployeeMutation__
 *
 * To run a mutation, you first call `useRestoreEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEmployeeMutation, { data, loading, error }] = useRestoreEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEmployeeMutation, RestoreEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEmployeeMutation, RestoreEmployeeMutationVariables>(RestoreEmployeeDocument, options);
      }
export type RestoreEmployeeMutationHookResult = ReturnType<typeof useRestoreEmployeeMutation>;
export type RestoreEmployeeMutationResult = Apollo.MutationResult<RestoreEmployeeMutation>;
export type RestoreEmployeeMutationOptions = Apollo.BaseMutationOptions<RestoreEmployeeMutation, RestoreEmployeeMutationVariables>;
export const RestoreOrganizationUserDocument = gql`
    mutation restoreOrganizationUser($id: ID!) {
  restoreOrganizationUser(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    archivedAt
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    salesGoal
    status
  }
}
    `;
export type RestoreOrganizationUserMutationFn = Apollo.MutationFunction<RestoreOrganizationUserMutation, RestoreOrganizationUserMutationVariables>;

/**
 * __useRestoreOrganizationUserMutation__
 *
 * To run a mutation, you first call `useRestoreOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreOrganizationUserMutation, { data, loading, error }] = useRestoreOrganizationUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<RestoreOrganizationUserMutation, RestoreOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreOrganizationUserMutation, RestoreOrganizationUserMutationVariables>(RestoreOrganizationUserDocument, options);
      }
export type RestoreOrganizationUserMutationHookResult = ReturnType<typeof useRestoreOrganizationUserMutation>;
export type RestoreOrganizationUserMutationResult = Apollo.MutationResult<RestoreOrganizationUserMutation>;
export type RestoreOrganizationUserMutationOptions = Apollo.BaseMutationOptions<RestoreOrganizationUserMutation, RestoreOrganizationUserMutationVariables>;
export const RetryProposalPackageSendRecipientsDocument = gql`
    mutation retryProposalPackageSendRecipients($runId: ID!) {
  retryProposalPackageSendRecipients(runId: $runId) {
    failedRecipients
    id
    processedRecipients
    proposalId
    recipients {
      attemptCount
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      companyId
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      errorMessage
      id
      proposal {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      proposalId
      sentAt
      startedAt
      status
    }
    status
    succeededRecipients
    totalRecipients
  }
}
    `;
export type RetryProposalPackageSendRecipientsMutationFn = Apollo.MutationFunction<RetryProposalPackageSendRecipientsMutation, RetryProposalPackageSendRecipientsMutationVariables>;

/**
 * __useRetryProposalPackageSendRecipientsMutation__
 *
 * To run a mutation, you first call `useRetryProposalPackageSendRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryProposalPackageSendRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryProposalPackageSendRecipientsMutation, { data, loading, error }] = useRetryProposalPackageSendRecipientsMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useRetryProposalPackageSendRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<RetryProposalPackageSendRecipientsMutation, RetryProposalPackageSendRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryProposalPackageSendRecipientsMutation, RetryProposalPackageSendRecipientsMutationVariables>(RetryProposalPackageSendRecipientsDocument, options);
      }
export type RetryProposalPackageSendRecipientsMutationHookResult = ReturnType<typeof useRetryProposalPackageSendRecipientsMutation>;
export type RetryProposalPackageSendRecipientsMutationResult = Apollo.MutationResult<RetryProposalPackageSendRecipientsMutation>;
export type RetryProposalPackageSendRecipientsMutationOptions = Apollo.BaseMutationOptions<RetryProposalPackageSendRecipientsMutation, RetryProposalPackageSendRecipientsMutationVariables>;
export const RetryQuickbooksTimeExportRunFailedItemsDocument = gql`
    mutation retryQuickbooksTimeExportRunFailedItems($runId: ID!) {
  retryQuickbooksTimeExportRunFailedItems(runId: $runId) {
    createdByUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    createdByUserId
    dateEnd
    dateStart
    failedItems
    finishedAt
    id
    itemsCount
    lastErrorCode
    lastErrorMessage
    organizationId
    organizationLinkedServiceId
    processedItems
    skippedItems
    startedAt
    status
    succeededItems
    totalItems
  }
}
    `;
export type RetryQuickbooksTimeExportRunFailedItemsMutationFn = Apollo.MutationFunction<RetryQuickbooksTimeExportRunFailedItemsMutation, RetryQuickbooksTimeExportRunFailedItemsMutationVariables>;

/**
 * __useRetryQuickbooksTimeExportRunFailedItemsMutation__
 *
 * To run a mutation, you first call `useRetryQuickbooksTimeExportRunFailedItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryQuickbooksTimeExportRunFailedItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryQuickbooksTimeExportRunFailedItemsMutation, { data, loading, error }] = useRetryQuickbooksTimeExportRunFailedItemsMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useRetryQuickbooksTimeExportRunFailedItemsMutation(baseOptions?: Apollo.MutationHookOptions<RetryQuickbooksTimeExportRunFailedItemsMutation, RetryQuickbooksTimeExportRunFailedItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryQuickbooksTimeExportRunFailedItemsMutation, RetryQuickbooksTimeExportRunFailedItemsMutationVariables>(RetryQuickbooksTimeExportRunFailedItemsDocument, options);
      }
export type RetryQuickbooksTimeExportRunFailedItemsMutationHookResult = ReturnType<typeof useRetryQuickbooksTimeExportRunFailedItemsMutation>;
export type RetryQuickbooksTimeExportRunFailedItemsMutationResult = Apollo.MutationResult<RetryQuickbooksTimeExportRunFailedItemsMutation>;
export type RetryQuickbooksTimeExportRunFailedItemsMutationOptions = Apollo.BaseMutationOptions<RetryQuickbooksTimeExportRunFailedItemsMutation, RetryQuickbooksTimeExportRunFailedItemsMutationVariables>;
export const SaveCustomItemDocument = gql`
    mutation saveCustomItem($discount: String, $id: ID, $input: CustomInput!, $stageId: ID!) {
  saveCustomItem(discount: $discount, id: $id, input: $input, stageId: $stageId) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type SaveCustomItemMutationFn = Apollo.MutationFunction<SaveCustomItemMutation, SaveCustomItemMutationVariables>;

/**
 * __useSaveCustomItemMutation__
 *
 * To run a mutation, you first call `useSaveCustomItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomItemMutation, { data, loading, error }] = useSaveCustomItemMutation({
 *   variables: {
 *      discount: // value for 'discount'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useSaveCustomItemMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomItemMutation, SaveCustomItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomItemMutation, SaveCustomItemMutationVariables>(SaveCustomItemDocument, options);
      }
export type SaveCustomItemMutationHookResult = ReturnType<typeof useSaveCustomItemMutation>;
export type SaveCustomItemMutationResult = Apollo.MutationResult<SaveCustomItemMutation>;
export type SaveCustomItemMutationOptions = Apollo.BaseMutationOptions<SaveCustomItemMutation, SaveCustomItemMutationVariables>;
export const SaveCustomProductDocument = gql`
    mutation saveCustomProduct($id: ID, $input: CustomInput!, $productTypeId: ID!) {
  saveCustomProduct(id: $id, input: $input, productTypeId: $productTypeId) {
    definition {
      area
      areaSource
      areaUnit
      calculationVersion
      costTotal
      fixedPrice
      helpers {
        hoursPerDay
        production {
          enabled
          materialRowId
          period
          quantity
          rate
          source
          unit
        }
        travel {
          enabled
          roundTripHours
          visits
        }
      }
      indirectPercentage
      internalName
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricing {
        discount
        mode
        value
        version
      }
      pricingBaseline {
        fixedPrice
        markup
        pricing {
          discount
          mode
          value
          version
        }
        pricingMethod
        profitAmount
      }
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      rows {
        calculatedQuantity
        calculation
        category
        factor
        factorAreaUnit
        factorLabel
        formula
        hauling {
          allocationPercent
          capacity
          capacityUnit
          fullLoads
          haulQuantity
          haulUnit
          loadHours
          materialRowId
          maxTripsPerDay
          planningEnabled
          planningHours
          quantityMode
          roundTripHours
          unloadHours
        }
        hoursPerTruck
        jobSize
        jobSizeUnit
        name
        quantity
        quantityOverride
        quantitySource
        rate
        rowId
        sourceId
        sourceName
        sourcePlantId
        sourcePlantName
        sourceType
        thickness
        total
        truckCapacity
        truckRateHours
        truckRateLoads
        truckRateTons
        truckRateYards
        truckingUnit
        trucksNeeded
        unit
      }
      scope
      scopeFormat
      sellingTotal
      sourceProductId
      sourceProductRevision
      unit
    }
    id
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    revision
  }
}
    `;
export type SaveCustomProductMutationFn = Apollo.MutationFunction<SaveCustomProductMutation, SaveCustomProductMutationVariables>;

/**
 * __useSaveCustomProductMutation__
 *
 * To run a mutation, you first call `useSaveCustomProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomProductMutation, { data, loading, error }] = useSaveCustomProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      productTypeId: // value for 'productTypeId'
 *   },
 * });
 */
export function useSaveCustomProductMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomProductMutation, SaveCustomProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomProductMutation, SaveCustomProductMutationVariables>(SaveCustomProductDocument, options);
      }
export type SaveCustomProductMutationHookResult = ReturnType<typeof useSaveCustomProductMutation>;
export type SaveCustomProductMutationResult = Apollo.MutationResult<SaveCustomProductMutation>;
export type SaveCustomProductMutationOptions = Apollo.BaseMutationOptions<SaveCustomProductMutation, SaveCustomProductMutationVariables>;
export const SaveOrganizationEmailIdentityDocument = gql`
    mutation saveOrganizationEmailIdentity($input: SaveOrganizationEmailIdentityInput!) {
  saveOrganizationEmailIdentity(input: $input) {
    dkimTokens {
      host
      type
      value
    }
    dmarcRecord {
      host
      type
      value
    }
    enabled
    fromName
    id
    invoiceFromAddress
    invoiceLocalPart
    notificationsFromAddress
    notificationsLocalPart
    organizationId
    proposalFromAddress
    proposalLocalPart
    replyToCustomEmail
    replyToType
    sendingDomain
    spfRecord {
      host
      type
      value
    }
    verificationStatus
    verifiedAt
  }
}
    `;
export type SaveOrganizationEmailIdentityMutationFn = Apollo.MutationFunction<SaveOrganizationEmailIdentityMutation, SaveOrganizationEmailIdentityMutationVariables>;

/**
 * __useSaveOrganizationEmailIdentityMutation__
 *
 * To run a mutation, you first call `useSaveOrganizationEmailIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrganizationEmailIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrganizationEmailIdentityMutation, { data, loading, error }] = useSaveOrganizationEmailIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveOrganizationEmailIdentityMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrganizationEmailIdentityMutation, SaveOrganizationEmailIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrganizationEmailIdentityMutation, SaveOrganizationEmailIdentityMutationVariables>(SaveOrganizationEmailIdentityDocument, options);
      }
export type SaveOrganizationEmailIdentityMutationHookResult = ReturnType<typeof useSaveOrganizationEmailIdentityMutation>;
export type SaveOrganizationEmailIdentityMutationResult = Apollo.MutationResult<SaveOrganizationEmailIdentityMutation>;
export type SaveOrganizationEmailIdentityMutationOptions = Apollo.BaseMutationOptions<SaveOrganizationEmailIdentityMutation, SaveOrganizationEmailIdentityMutationVariables>;
export const SaveProjectMapImageDocument = gql`
    mutation saveProjectMapImage($path: String!, $projectMapId: ID!) {
  saveProjectMapImage(path: $path, projectMapId: $projectMapId) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    createdAt
    createdBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    description
    id
    latitude
    longitude
    mapData
    mapImage
    mapImageDirty
    measurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
    name
    updatedAt
  }
}
    `;
export type SaveProjectMapImageMutationFn = Apollo.MutationFunction<SaveProjectMapImageMutation, SaveProjectMapImageMutationVariables>;

/**
 * __useSaveProjectMapImageMutation__
 *
 * To run a mutation, you first call `useSaveProjectMapImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectMapImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectMapImageMutation, { data, loading, error }] = useSaveProjectMapImageMutation({
 *   variables: {
 *      path: // value for 'path'
 *      projectMapId: // value for 'projectMapId'
 *   },
 * });
 */
export function useSaveProjectMapImageMutation(baseOptions?: Apollo.MutationHookOptions<SaveProjectMapImageMutation, SaveProjectMapImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProjectMapImageMutation, SaveProjectMapImageMutationVariables>(SaveProjectMapImageDocument, options);
      }
export type SaveProjectMapImageMutationHookResult = ReturnType<typeof useSaveProjectMapImageMutation>;
export type SaveProjectMapImageMutationResult = Apollo.MutationResult<SaveProjectMapImageMutation>;
export type SaveProjectMapImageMutationOptions = Apollo.BaseMutationOptions<SaveProjectMapImageMutation, SaveProjectMapImageMutationVariables>;
export const SaveQuickbooksIncomeAccountDocument = gql`
    mutation saveQuickbooksIncomeAccount($id: ID!) {
  saveQuickbooksIncomeAccount(id: $id)
}
    `;
export type SaveQuickbooksIncomeAccountMutationFn = Apollo.MutationFunction<SaveQuickbooksIncomeAccountMutation, SaveQuickbooksIncomeAccountMutationVariables>;

/**
 * __useSaveQuickbooksIncomeAccountMutation__
 *
 * To run a mutation, you first call `useSaveQuickbooksIncomeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuickbooksIncomeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuickbooksIncomeAccountMutation, { data, loading, error }] = useSaveQuickbooksIncomeAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveQuickbooksIncomeAccountMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuickbooksIncomeAccountMutation, SaveQuickbooksIncomeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuickbooksIncomeAccountMutation, SaveQuickbooksIncomeAccountMutationVariables>(SaveQuickbooksIncomeAccountDocument, options);
      }
export type SaveQuickbooksIncomeAccountMutationHookResult = ReturnType<typeof useSaveQuickbooksIncomeAccountMutation>;
export type SaveQuickbooksIncomeAccountMutationResult = Apollo.MutationResult<SaveQuickbooksIncomeAccountMutation>;
export type SaveQuickbooksIncomeAccountMutationOptions = Apollo.BaseMutationOptions<SaveQuickbooksIncomeAccountMutation, SaveQuickbooksIncomeAccountMutationVariables>;
export const SaveQuickbooksIntegrationDocument = gql`
    mutation saveQuickbooksIntegration($input: QuickbooksIntegrationInput!) {
  saveQuickbooksIntegration(input: $input)
}
    `;
export type SaveQuickbooksIntegrationMutationFn = Apollo.MutationFunction<SaveQuickbooksIntegrationMutation, SaveQuickbooksIntegrationMutationVariables>;

/**
 * __useSaveQuickbooksIntegrationMutation__
 *
 * To run a mutation, you first call `useSaveQuickbooksIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuickbooksIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuickbooksIntegrationMutation, { data, loading, error }] = useSaveQuickbooksIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQuickbooksIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuickbooksIntegrationMutation, SaveQuickbooksIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuickbooksIntegrationMutation, SaveQuickbooksIntegrationMutationVariables>(SaveQuickbooksIntegrationDocument, options);
      }
export type SaveQuickbooksIntegrationMutationHookResult = ReturnType<typeof useSaveQuickbooksIntegrationMutation>;
export type SaveQuickbooksIntegrationMutationResult = Apollo.MutationResult<SaveQuickbooksIntegrationMutation>;
export type SaveQuickbooksIntegrationMutationOptions = Apollo.BaseMutationOptions<SaveQuickbooksIntegrationMutation, SaveQuickbooksIntegrationMutationVariables>;
export const SaveWorksheetItemDocument = gql`
    mutation saveWorksheetItem($discount: String, $id: ID, $input: WorksheetInput!, $stageId: ID!) {
  saveWorksheetItem(
    discount: $discount
    id: $id
    input: $input
    stageId: $stageId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type SaveWorksheetItemMutationFn = Apollo.MutationFunction<SaveWorksheetItemMutation, SaveWorksheetItemMutationVariables>;

/**
 * __useSaveWorksheetItemMutation__
 *
 * To run a mutation, you first call `useSaveWorksheetItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorksheetItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorksheetItemMutation, { data, loading, error }] = useSaveWorksheetItemMutation({
 *   variables: {
 *      discount: // value for 'discount'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useSaveWorksheetItemMutation(baseOptions?: Apollo.MutationHookOptions<SaveWorksheetItemMutation, SaveWorksheetItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWorksheetItemMutation, SaveWorksheetItemMutationVariables>(SaveWorksheetItemDocument, options);
      }
export type SaveWorksheetItemMutationHookResult = ReturnType<typeof useSaveWorksheetItemMutation>;
export type SaveWorksheetItemMutationResult = Apollo.MutationResult<SaveWorksheetItemMutation>;
export type SaveWorksheetItemMutationOptions = Apollo.BaseMutationOptions<SaveWorksheetItemMutation, SaveWorksheetItemMutationVariables>;
export const SaveWorksheetProductDocument = gql`
    mutation saveWorksheetProduct($id: ID, $input: WorksheetInput!, $productTypeId: ID!) {
  saveWorksheetProduct(id: $id, input: $input, productTypeId: $productTypeId) {
    definition {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingBaseline {
        fixedPrice
        markup
        pricingMethod
        profitAmount
      }
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      rows {
        calculatedQuantity
        calculation
        category
        factor
        factorAreaUnit
        factorLabel
        formula
        hoursPerTruck
        jobSize
        jobSizeUnit
        name
        quantity
        quantityOverride
        rate
        sourceId
        sourceName
        sourcePlantId
        sourcePlantName
        sourceType
        thickness
        total
        truckCapacity
        truckRateHours
        truckRateLoads
        truckRateTons
        truckRateYards
        truckingUnit
        trucksNeeded
        unit
      }
      scope
      scopeFormat
      sellingTotal
      unit
    }
    id
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
  }
}
    `;
export type SaveWorksheetProductMutationFn = Apollo.MutationFunction<SaveWorksheetProductMutation, SaveWorksheetProductMutationVariables>;

/**
 * __useSaveWorksheetProductMutation__
 *
 * To run a mutation, you first call `useSaveWorksheetProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorksheetProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorksheetProductMutation, { data, loading, error }] = useSaveWorksheetProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      productTypeId: // value for 'productTypeId'
 *   },
 * });
 */
export function useSaveWorksheetProductMutation(baseOptions?: Apollo.MutationHookOptions<SaveWorksheetProductMutation, SaveWorksheetProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWorksheetProductMutation, SaveWorksheetProductMutationVariables>(SaveWorksheetProductDocument, options);
      }
export type SaveWorksheetProductMutationHookResult = ReturnType<typeof useSaveWorksheetProductMutation>;
export type SaveWorksheetProductMutationResult = Apollo.MutationResult<SaveWorksheetProductMutation>;
export type SaveWorksheetProductMutationOptions = Apollo.BaseMutationOptions<SaveWorksheetProductMutation, SaveWorksheetProductMutationVariables>;
export const ScheduleCustomEventBlockDocument = gql`
    mutation scheduleCustomEventBlock($input: ScheduleCustomEventBlockInput!) {
  scheduleCustomEventBlock(input: $input) {
    color
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        endsAt
        files {
          customEvent {
            color
            endsAt
            id
            name
            notes
            startsAt
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    files {
      id
      name
      path
    }
    id
    name
    notes
    startsAt
  }
}
    `;
export type ScheduleCustomEventBlockMutationFn = Apollo.MutationFunction<ScheduleCustomEventBlockMutation, ScheduleCustomEventBlockMutationVariables>;

/**
 * __useScheduleCustomEventBlockMutation__
 *
 * To run a mutation, you first call `useScheduleCustomEventBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleCustomEventBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleCustomEventBlockMutation, { data, loading, error }] = useScheduleCustomEventBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleCustomEventBlockMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleCustomEventBlockMutation, ScheduleCustomEventBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleCustomEventBlockMutation, ScheduleCustomEventBlockMutationVariables>(ScheduleCustomEventBlockDocument, options);
      }
export type ScheduleCustomEventBlockMutationHookResult = ReturnType<typeof useScheduleCustomEventBlockMutation>;
export type ScheduleCustomEventBlockMutationResult = Apollo.MutationResult<ScheduleCustomEventBlockMutation>;
export type ScheduleCustomEventBlockMutationOptions = Apollo.BaseMutationOptions<ScheduleCustomEventBlockMutation, ScheduleCustomEventBlockMutationVariables>;
export const ScheduleJobDocument = gql`
    mutation scheduleJob($input: ScheduleJobInput!) {
  scheduleJob(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type ScheduleJobMutationFn = Apollo.MutationFunction<ScheduleJobMutation, ScheduleJobMutationVariables>;

/**
 * __useScheduleJobMutation__
 *
 * To run a mutation, you first call `useScheduleJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleJobMutation, { data, loading, error }] = useScheduleJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleJobMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleJobMutation, ScheduleJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleJobMutation, ScheduleJobMutationVariables>(ScheduleJobDocument, options);
      }
export type ScheduleJobMutationHookResult = ReturnType<typeof useScheduleJobMutation>;
export type ScheduleJobMutationResult = Apollo.MutationResult<ScheduleJobMutation>;
export type ScheduleJobMutationOptions = Apollo.BaseMutationOptions<ScheduleJobMutation, ScheduleJobMutationVariables>;
export const ScheduleJobPhaseDocument = gql`
    mutation scheduleJobPhase($blocks: [AddJobPhaseScheduleBlock]!, $crewId: ID, $jobPhaseId: ID!, $travelTimeEstimate: Float, $userIDs: [ID!], $usersColor: String) {
  scheduleJobPhase(
    blocks: $blocks
    crewId: $crewId
    jobPhaseId: $jobPhaseId
    travelTimeEstimate: $travelTimeEstimate
    userIDs: $userIDs
    usersColor: $usersColor
  ) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type ScheduleJobPhaseMutationFn = Apollo.MutationFunction<ScheduleJobPhaseMutation, ScheduleJobPhaseMutationVariables>;

/**
 * __useScheduleJobPhaseMutation__
 *
 * To run a mutation, you first call `useScheduleJobPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleJobPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleJobPhaseMutation, { data, loading, error }] = useScheduleJobPhaseMutation({
 *   variables: {
 *      blocks: // value for 'blocks'
 *      crewId: // value for 'crewId'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      travelTimeEstimate: // value for 'travelTimeEstimate'
 *      userIDs: // value for 'userIDs'
 *      usersColor: // value for 'usersColor'
 *   },
 * });
 */
export function useScheduleJobPhaseMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleJobPhaseMutation, ScheduleJobPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleJobPhaseMutation, ScheduleJobPhaseMutationVariables>(ScheduleJobPhaseDocument, options);
      }
export type ScheduleJobPhaseMutationHookResult = ReturnType<typeof useScheduleJobPhaseMutation>;
export type ScheduleJobPhaseMutationResult = Apollo.MutationResult<ScheduleJobPhaseMutation>;
export type ScheduleJobPhaseMutationOptions = Apollo.BaseMutationOptions<ScheduleJobPhaseMutation, ScheduleJobPhaseMutationVariables>;
export const ScheduleJobPhaseBlockDocument = gql`
    mutation scheduleJobPhaseBlock($input: ScheduleJobPhaseBlockInput!) {
  scheduleJobPhaseBlock(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type ScheduleJobPhaseBlockMutationFn = Apollo.MutationFunction<ScheduleJobPhaseBlockMutation, ScheduleJobPhaseBlockMutationVariables>;

/**
 * __useScheduleJobPhaseBlockMutation__
 *
 * To run a mutation, you first call `useScheduleJobPhaseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleJobPhaseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleJobPhaseBlockMutation, { data, loading, error }] = useScheduleJobPhaseBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleJobPhaseBlockMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleJobPhaseBlockMutation, ScheduleJobPhaseBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleJobPhaseBlockMutation, ScheduleJobPhaseBlockMutationVariables>(ScheduleJobPhaseBlockDocument, options);
      }
export type ScheduleJobPhaseBlockMutationHookResult = ReturnType<typeof useScheduleJobPhaseBlockMutation>;
export type ScheduleJobPhaseBlockMutationResult = Apollo.MutationResult<ScheduleJobPhaseBlockMutation>;
export type ScheduleJobPhaseBlockMutationOptions = Apollo.BaseMutationOptions<ScheduleJobPhaseBlockMutation, ScheduleJobPhaseBlockMutationVariables>;
export const SegmentAiMappingRunAreaDocument = gql`
    mutation segmentAiMappingRunArea($id: ID!, $minSegAreaSqft: Float, $minSegConf: Float) {
  segmentAiMappingRunArea(
    id: $id
    minSegAreaSqft: $minSegAreaSqft
    minSegConf: $minSegConf
  ) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    taskId
  }
}
    `;
export type SegmentAiMappingRunAreaMutationFn = Apollo.MutationFunction<SegmentAiMappingRunAreaMutation, SegmentAiMappingRunAreaMutationVariables>;

/**
 * __useSegmentAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useSegmentAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentAiMappingRunAreaMutation, { data, loading, error }] = useSegmentAiMappingRunAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      minSegAreaSqft: // value for 'minSegAreaSqft'
 *      minSegConf: // value for 'minSegConf'
 *   },
 * });
 */
export function useSegmentAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<SegmentAiMappingRunAreaMutation, SegmentAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentAiMappingRunAreaMutation, SegmentAiMappingRunAreaMutationVariables>(SegmentAiMappingRunAreaDocument, options);
      }
export type SegmentAiMappingRunAreaMutationHookResult = ReturnType<typeof useSegmentAiMappingRunAreaMutation>;
export type SegmentAiMappingRunAreaMutationResult = Apollo.MutationResult<SegmentAiMappingRunAreaMutation>;
export type SegmentAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<SegmentAiMappingRunAreaMutation, SegmentAiMappingRunAreaMutationVariables>;
export const SendInvoiceDocument = gql`
    mutation sendInvoice($data: String, $hideLineItemPricing: Boolean, $id: ID!) {
  sendInvoice(data: $data, hideLineItemPricing: $hideLineItemPricing, id: $id)
}
    `;
export type SendInvoiceMutationFn = Apollo.MutationFunction<SendInvoiceMutation, SendInvoiceMutationVariables>;

/**
 * __useSendInvoiceMutation__
 *
 * To run a mutation, you first call `useSendInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceMutation, { data, loading, error }] = useSendInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      hideLineItemPricing: // value for 'hideLineItemPricing'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<SendInvoiceMutation, SendInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvoiceMutation, SendInvoiceMutationVariables>(SendInvoiceDocument, options);
      }
export type SendInvoiceMutationHookResult = ReturnType<typeof useSendInvoiceMutation>;
export type SendInvoiceMutationResult = Apollo.MutationResult<SendInvoiceMutation>;
export type SendInvoiceMutationOptions = Apollo.BaseMutationOptions<SendInvoiceMutation, SendInvoiceMutationVariables>;
export const SendOrganizationEmailIdentityTestEmailDocument = gql`
    mutation sendOrganizationEmailIdentityTestEmail {
  sendOrganizationEmailIdentityTestEmail
}
    `;
export type SendOrganizationEmailIdentityTestEmailMutationFn = Apollo.MutationFunction<SendOrganizationEmailIdentityTestEmailMutation, SendOrganizationEmailIdentityTestEmailMutationVariables>;

/**
 * __useSendOrganizationEmailIdentityTestEmailMutation__
 *
 * To run a mutation, you first call `useSendOrganizationEmailIdentityTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOrganizationEmailIdentityTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOrganizationEmailIdentityTestEmailMutation, { data, loading, error }] = useSendOrganizationEmailIdentityTestEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendOrganizationEmailIdentityTestEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendOrganizationEmailIdentityTestEmailMutation, SendOrganizationEmailIdentityTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOrganizationEmailIdentityTestEmailMutation, SendOrganizationEmailIdentityTestEmailMutationVariables>(SendOrganizationEmailIdentityTestEmailDocument, options);
      }
export type SendOrganizationEmailIdentityTestEmailMutationHookResult = ReturnType<typeof useSendOrganizationEmailIdentityTestEmailMutation>;
export type SendOrganizationEmailIdentityTestEmailMutationResult = Apollo.MutationResult<SendOrganizationEmailIdentityTestEmailMutation>;
export type SendOrganizationEmailIdentityTestEmailMutationOptions = Apollo.BaseMutationOptions<SendOrganizationEmailIdentityTestEmailMutation, SendOrganizationEmailIdentityTestEmailMutationVariables>;
export const SendOrganizationEmailTemplatePreviewDocument = gql`
    mutation sendOrganizationEmailTemplatePreview($html: String!) {
  sendOrganizationEmailTemplatePreview(html: $html)
}
    `;
export type SendOrganizationEmailTemplatePreviewMutationFn = Apollo.MutationFunction<SendOrganizationEmailTemplatePreviewMutation, SendOrganizationEmailTemplatePreviewMutationVariables>;

/**
 * __useSendOrganizationEmailTemplatePreviewMutation__
 *
 * To run a mutation, you first call `useSendOrganizationEmailTemplatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOrganizationEmailTemplatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOrganizationEmailTemplatePreviewMutation, { data, loading, error }] = useSendOrganizationEmailTemplatePreviewMutation({
 *   variables: {
 *      html: // value for 'html'
 *   },
 * });
 */
export function useSendOrganizationEmailTemplatePreviewMutation(baseOptions?: Apollo.MutationHookOptions<SendOrganizationEmailTemplatePreviewMutation, SendOrganizationEmailTemplatePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOrganizationEmailTemplatePreviewMutation, SendOrganizationEmailTemplatePreviewMutationVariables>(SendOrganizationEmailTemplatePreviewDocument, options);
      }
export type SendOrganizationEmailTemplatePreviewMutationHookResult = ReturnType<typeof useSendOrganizationEmailTemplatePreviewMutation>;
export type SendOrganizationEmailTemplatePreviewMutationResult = Apollo.MutationResult<SendOrganizationEmailTemplatePreviewMutation>;
export type SendOrganizationEmailTemplatePreviewMutationOptions = Apollo.BaseMutationOptions<SendOrganizationEmailTemplatePreviewMutation, SendOrganizationEmailTemplatePreviewMutationVariables>;
export const SendProposalDocument = gql`
    mutation sendProposal($acceptanceOverride: String, $attachments: [ID!], $clientEmailOverride: String, $contentSettings: UpdateProposalContentSettingsHasManyInput, $emailBodyOverride: String, $emailSubjectOverride: String, $emails: [String!], $forceSend: Boolean, $layout: ProposalLayout!, $proposalId: ID!, $proposalNotes: String, $removeIndividualLineItemPricing: Boolean, $removeUnitPriceAndQuantity: Boolean) {
  sendProposal(
    acceptanceOverride: $acceptanceOverride
    attachments: $attachments
    clientEmailOverride: $clientEmailOverride
    contentSettings: $contentSettings
    emailBodyOverride: $emailBodyOverride
    emailSubjectOverride: $emailSubjectOverride
    emails: $emails
    forceSend: $forceSend
    layout: $layout
    proposalId: $proposalId
    proposalNotes: $proposalNotes
    removeIndividualLineItemPricing: $removeIndividualLineItemPricing
    removeUnitPriceAndQuantity: $removeUnitPriceAndQuantity
  )
}
    `;
export type SendProposalMutationFn = Apollo.MutationFunction<SendProposalMutation, SendProposalMutationVariables>;

/**
 * __useSendProposalMutation__
 *
 * To run a mutation, you first call `useSendProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProposalMutation, { data, loading, error }] = useSendProposalMutation({
 *   variables: {
 *      acceptanceOverride: // value for 'acceptanceOverride'
 *      attachments: // value for 'attachments'
 *      clientEmailOverride: // value for 'clientEmailOverride'
 *      contentSettings: // value for 'contentSettings'
 *      emailBodyOverride: // value for 'emailBodyOverride'
 *      emailSubjectOverride: // value for 'emailSubjectOverride'
 *      emails: // value for 'emails'
 *      forceSend: // value for 'forceSend'
 *      layout: // value for 'layout'
 *      proposalId: // value for 'proposalId'
 *      proposalNotes: // value for 'proposalNotes'
 *      removeIndividualLineItemPricing: // value for 'removeIndividualLineItemPricing'
 *      removeUnitPriceAndQuantity: // value for 'removeUnitPriceAndQuantity'
 *   },
 * });
 */
export function useSendProposalMutation(baseOptions?: Apollo.MutationHookOptions<SendProposalMutation, SendProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProposalMutation, SendProposalMutationVariables>(SendProposalDocument, options);
      }
export type SendProposalMutationHookResult = ReturnType<typeof useSendProposalMutation>;
export type SendProposalMutationResult = Apollo.MutationResult<SendProposalMutation>;
export type SendProposalMutationOptions = Apollo.BaseMutationOptions<SendProposalMutation, SendProposalMutationVariables>;
export const SendProposalPackageDocument = gql`
    mutation sendProposalPackage($acceptanceOverride: String, $attachments: [ID!], $clientEmailOverride: String, $contentSettings: UpdateProposalContentSettingsHasManyInput, $emailBodyOverride: String, $emailSubjectOverride: String, $forceSend: Boolean, $layout: ProposalLayout, $proposalId: ID!, $proposalNotes: String, $recipients: [ProposalPackageRecipientInput!]!, $removeIndividualLineItemPricing: Boolean, $removeUnitPriceAndQuantity: Boolean) {
  sendProposalPackage(
    acceptanceOverride: $acceptanceOverride
    attachments: $attachments
    clientEmailOverride: $clientEmailOverride
    contentSettings: $contentSettings
    emailBodyOverride: $emailBodyOverride
    emailSubjectOverride: $emailSubjectOverride
    forceSend: $forceSend
    layout: $layout
    proposalId: $proposalId
    proposalNotes: $proposalNotes
    recipients: $recipients
    removeIndividualLineItemPricing: $removeIndividualLineItemPricing
    removeUnitPriceAndQuantity: $removeUnitPriceAndQuantity
  ) {
    failedRecipients
    id
    processedRecipients
    proposalId
    recipients {
      attemptCount
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      companyId
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      errorMessage
      id
      proposal {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      proposalId
      sentAt
      startedAt
      status
    }
    status
    succeededRecipients
    totalRecipients
  }
}
    `;
export type SendProposalPackageMutationFn = Apollo.MutationFunction<SendProposalPackageMutation, SendProposalPackageMutationVariables>;

/**
 * __useSendProposalPackageMutation__
 *
 * To run a mutation, you first call `useSendProposalPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProposalPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProposalPackageMutation, { data, loading, error }] = useSendProposalPackageMutation({
 *   variables: {
 *      acceptanceOverride: // value for 'acceptanceOverride'
 *      attachments: // value for 'attachments'
 *      clientEmailOverride: // value for 'clientEmailOverride'
 *      contentSettings: // value for 'contentSettings'
 *      emailBodyOverride: // value for 'emailBodyOverride'
 *      emailSubjectOverride: // value for 'emailSubjectOverride'
 *      forceSend: // value for 'forceSend'
 *      layout: // value for 'layout'
 *      proposalId: // value for 'proposalId'
 *      proposalNotes: // value for 'proposalNotes'
 *      recipients: // value for 'recipients'
 *      removeIndividualLineItemPricing: // value for 'removeIndividualLineItemPricing'
 *      removeUnitPriceAndQuantity: // value for 'removeUnitPriceAndQuantity'
 *   },
 * });
 */
export function useSendProposalPackageMutation(baseOptions?: Apollo.MutationHookOptions<SendProposalPackageMutation, SendProposalPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProposalPackageMutation, SendProposalPackageMutationVariables>(SendProposalPackageDocument, options);
      }
export type SendProposalPackageMutationHookResult = ReturnType<typeof useSendProposalPackageMutation>;
export type SendProposalPackageMutationResult = Apollo.MutationResult<SendProposalPackageMutation>;
export type SendProposalPackageMutationOptions = Apollo.BaseMutationOptions<SendProposalPackageMutation, SendProposalPackageMutationVariables>;
export const SendProposalToSpecificRecipientsDocument = gql`
    mutation sendProposalToSpecificRecipients($clientEmailOverride: String, $emailBodyOverride: String, $emailSubjectOverride: String, $emails: [String!]!, $forceSend: Boolean, $proposalId: ID!, $removeIndividualLineItemPricing: Boolean, $removeUnitPriceAndQuantity: Boolean) {
  sendProposalToSpecificRecipients(
    clientEmailOverride: $clientEmailOverride
    emailBodyOverride: $emailBodyOverride
    emailSubjectOverride: $emailSubjectOverride
    emails: $emails
    forceSend: $forceSend
    proposalId: $proposalId
    removeIndividualLineItemPricing: $removeIndividualLineItemPricing
    removeUnitPriceAndQuantity: $removeUnitPriceAndQuantity
  ) {
    contactId
    createdAt
    email
    id
  }
}
    `;
export type SendProposalToSpecificRecipientsMutationFn = Apollo.MutationFunction<SendProposalToSpecificRecipientsMutation, SendProposalToSpecificRecipientsMutationVariables>;

/**
 * __useSendProposalToSpecificRecipientsMutation__
 *
 * To run a mutation, you first call `useSendProposalToSpecificRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProposalToSpecificRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProposalToSpecificRecipientsMutation, { data, loading, error }] = useSendProposalToSpecificRecipientsMutation({
 *   variables: {
 *      clientEmailOverride: // value for 'clientEmailOverride'
 *      emailBodyOverride: // value for 'emailBodyOverride'
 *      emailSubjectOverride: // value for 'emailSubjectOverride'
 *      emails: // value for 'emails'
 *      forceSend: // value for 'forceSend'
 *      proposalId: // value for 'proposalId'
 *      removeIndividualLineItemPricing: // value for 'removeIndividualLineItemPricing'
 *      removeUnitPriceAndQuantity: // value for 'removeUnitPriceAndQuantity'
 *   },
 * });
 */
export function useSendProposalToSpecificRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<SendProposalToSpecificRecipientsMutation, SendProposalToSpecificRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProposalToSpecificRecipientsMutation, SendProposalToSpecificRecipientsMutationVariables>(SendProposalToSpecificRecipientsDocument, options);
      }
export type SendProposalToSpecificRecipientsMutationHookResult = ReturnType<typeof useSendProposalToSpecificRecipientsMutation>;
export type SendProposalToSpecificRecipientsMutationResult = Apollo.MutationResult<SendProposalToSpecificRecipientsMutation>;
export type SendProposalToSpecificRecipientsMutationOptions = Apollo.BaseMutationOptions<SendProposalToSpecificRecipientsMutation, SendProposalToSpecificRecipientsMutationVariables>;
export const SetJobDepositCollectedDocument = gql`
    mutation setJobDepositCollected($collected: Boolean, $id: ID!) {
  setJobDepositCollected(collected: $collected, id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type SetJobDepositCollectedMutationFn = Apollo.MutationFunction<SetJobDepositCollectedMutation, SetJobDepositCollectedMutationVariables>;

/**
 * __useSetJobDepositCollectedMutation__
 *
 * To run a mutation, you first call `useSetJobDepositCollectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetJobDepositCollectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setJobDepositCollectedMutation, { data, loading, error }] = useSetJobDepositCollectedMutation({
 *   variables: {
 *      collected: // value for 'collected'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetJobDepositCollectedMutation(baseOptions?: Apollo.MutationHookOptions<SetJobDepositCollectedMutation, SetJobDepositCollectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetJobDepositCollectedMutation, SetJobDepositCollectedMutationVariables>(SetJobDepositCollectedDocument, options);
      }
export type SetJobDepositCollectedMutationHookResult = ReturnType<typeof useSetJobDepositCollectedMutation>;
export type SetJobDepositCollectedMutationResult = Apollo.MutationResult<SetJobDepositCollectedMutation>;
export type SetJobDepositCollectedMutationOptions = Apollo.BaseMutationOptions<SetJobDepositCollectedMutation, SetJobDepositCollectedMutationVariables>;
export const SetProposalEstimatingMethodDocument = gql`
    mutation setProposalEstimatingMethod($id: ID!, $method: String!) {
  setProposalEstimatingMethod(id: $id, method: $method) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type SetProposalEstimatingMethodMutationFn = Apollo.MutationFunction<SetProposalEstimatingMethodMutation, SetProposalEstimatingMethodMutationVariables>;

/**
 * __useSetProposalEstimatingMethodMutation__
 *
 * To run a mutation, you first call `useSetProposalEstimatingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProposalEstimatingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProposalEstimatingMethodMutation, { data, loading, error }] = useSetProposalEstimatingMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useSetProposalEstimatingMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetProposalEstimatingMethodMutation, SetProposalEstimatingMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProposalEstimatingMethodMutation, SetProposalEstimatingMethodMutationVariables>(SetProposalEstimatingMethodDocument, options);
      }
export type SetProposalEstimatingMethodMutationHookResult = ReturnType<typeof useSetProposalEstimatingMethodMutation>;
export type SetProposalEstimatingMethodMutationResult = Apollo.MutationResult<SetProposalEstimatingMethodMutation>;
export type SetProposalEstimatingMethodMutationOptions = Apollo.BaseMutationOptions<SetProposalEstimatingMethodMutation, SetProposalEstimatingMethodMutationVariables>;
export const SetProposalToDraftDocument = gql`
    mutation setProposalToDraft($id: ID!) {
  setProposalToDraft(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type SetProposalToDraftMutationFn = Apollo.MutationFunction<SetProposalToDraftMutation, SetProposalToDraftMutationVariables>;

/**
 * __useSetProposalToDraftMutation__
 *
 * To run a mutation, you first call `useSetProposalToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProposalToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProposalToDraftMutation, { data, loading, error }] = useSetProposalToDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetProposalToDraftMutation(baseOptions?: Apollo.MutationHookOptions<SetProposalToDraftMutation, SetProposalToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProposalToDraftMutation, SetProposalToDraftMutationVariables>(SetProposalToDraftDocument, options);
      }
export type SetProposalToDraftMutationHookResult = ReturnType<typeof useSetProposalToDraftMutation>;
export type SetProposalToDraftMutationResult = Apollo.MutationResult<SetProposalToDraftMutation>;
export type SetProposalToDraftMutationOptions = Apollo.BaseMutationOptions<SetProposalToDraftMutation, SetProposalToDraftMutationVariables>;
export const SetProposalToWonDocument = gql`
    mutation setProposalToWon($forceSend: Boolean, $id: ID!) {
  setProposalToWon(forceSend: $forceSend, id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type SetProposalToWonMutationFn = Apollo.MutationFunction<SetProposalToWonMutation, SetProposalToWonMutationVariables>;

/**
 * __useSetProposalToWonMutation__
 *
 * To run a mutation, you first call `useSetProposalToWonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProposalToWonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProposalToWonMutation, { data, loading, error }] = useSetProposalToWonMutation({
 *   variables: {
 *      forceSend: // value for 'forceSend'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetProposalToWonMutation(baseOptions?: Apollo.MutationHookOptions<SetProposalToWonMutation, SetProposalToWonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProposalToWonMutation, SetProposalToWonMutationVariables>(SetProposalToWonDocument, options);
      }
export type SetProposalToWonMutationHookResult = ReturnType<typeof useSetProposalToWonMutation>;
export type SetProposalToWonMutationResult = Apollo.MutationResult<SetProposalToWonMutation>;
export type SetProposalToWonMutationOptions = Apollo.BaseMutationOptions<SetProposalToWonMutation, SetProposalToWonMutationVariables>;
export const SignProposalDocument = gql`
    mutation signProposal($email: String!, $removeProducts: [String!], $signature: String!, $signeeInitials: String!, $signeeName: String!, $signeeTitle: String!, $uuid: String!) {
  signProposal(
    email: $email
    removeProducts: $removeProducts
    signature: $signature
    signeeInitials: $signeeInitials
    signeeName: $signeeName
    signeeTitle: $signeeTitle
    uuid: $uuid
  ) {
    acceptanceOverride
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    company {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      name
      phone
      website
    }
    contact {
      email
      firstName
      id
      lastName
      phone
      title
    }
    content {
      content
      contentOverride
      type
    }
    costTaxes
    discount
    externalId
    externalIdWithPrefix
    id
    layout
    organization {
      address {
        city
        country
        id
        isPrimary
        latitude
        line1
        line2
        longitude
        state
        zip
      }
      email
      id
      logo
      name
      phone
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    profitAfterDiscount
    proposalPDF
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signeeInitials
    signeeName
    signeeTitle
    stages {
      address {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        state
        zip
      }
      addressOverride
      content {
        content
        contentOverride
        type
      }
      discount
      id
      name
      ordering
      overallTotal
      overallTotalAfterDiscount
      profitAfterDiscount
      proposalProductGroups {
        id
        isOptional
        name
        ordering
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          discount
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          id
          isOptional
          jobDuration
          jobSize
          mapImage
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          profitAfterDiscount
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalProductGroupId
          statementOfWork
          worksheet {
            name
            quantity
            scope
            unit
          }
        }
        showIndividualProducts
      }
      proposalProducts {
        discount
        id
        isOptional
        jobDuration
        jobSize
        mapImage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        profitAfterDiscount
        proposalProductGroupId
        statementOfWork
      }
    }
    status
    user {
      email
      firstName
      id
      lastName
      phone
    }
  }
}
    `;
export type SignProposalMutationFn = Apollo.MutationFunction<SignProposalMutation, SignProposalMutationVariables>;

/**
 * __useSignProposalMutation__
 *
 * To run a mutation, you first call `useSignProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signProposalMutation, { data, loading, error }] = useSignProposalMutation({
 *   variables: {
 *      email: // value for 'email'
 *      removeProducts: // value for 'removeProducts'
 *      signature: // value for 'signature'
 *      signeeInitials: // value for 'signeeInitials'
 *      signeeName: // value for 'signeeName'
 *      signeeTitle: // value for 'signeeTitle'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSignProposalMutation(baseOptions?: Apollo.MutationHookOptions<SignProposalMutation, SignProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignProposalMutation, SignProposalMutationVariables>(SignProposalDocument, options);
      }
export type SignProposalMutationHookResult = ReturnType<typeof useSignProposalMutation>;
export type SignProposalMutationResult = Apollo.MutationResult<SignProposalMutation>;
export type SignProposalMutationOptions = Apollo.BaseMutationOptions<SignProposalMutation, SignProposalMutationVariables>;
export const StartQuickbooksTimeExportDocument = gql`
    mutation startQuickbooksTimeExport($endDate: Date!, $jobPhaseId: ID, $startDate: Date!, $userId: ID) {
  startQuickbooksTimeExport(
    endDate: $endDate
    jobPhaseId: $jobPhaseId
    startDate: $startDate
    userId: $userId
  ) {
    createdByUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    createdByUserId
    dateEnd
    dateStart
    failedItems
    finishedAt
    id
    itemsCount
    lastErrorCode
    lastErrorMessage
    organizationId
    organizationLinkedServiceId
    processedItems
    skippedItems
    startedAt
    status
    succeededItems
    totalItems
  }
}
    `;
export type StartQuickbooksTimeExportMutationFn = Apollo.MutationFunction<StartQuickbooksTimeExportMutation, StartQuickbooksTimeExportMutationVariables>;

/**
 * __useStartQuickbooksTimeExportMutation__
 *
 * To run a mutation, you first call `useStartQuickbooksTimeExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartQuickbooksTimeExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startQuickbooksTimeExportMutation, { data, loading, error }] = useStartQuickbooksTimeExportMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      startDate: // value for 'startDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useStartQuickbooksTimeExportMutation(baseOptions?: Apollo.MutationHookOptions<StartQuickbooksTimeExportMutation, StartQuickbooksTimeExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartQuickbooksTimeExportMutation, StartQuickbooksTimeExportMutationVariables>(StartQuickbooksTimeExportDocument, options);
      }
export type StartQuickbooksTimeExportMutationHookResult = ReturnType<typeof useStartQuickbooksTimeExportMutation>;
export type StartQuickbooksTimeExportMutationResult = Apollo.MutationResult<StartQuickbooksTimeExportMutation>;
export type StartQuickbooksTimeExportMutationOptions = Apollo.BaseMutationOptions<StartQuickbooksTimeExportMutation, StartQuickbooksTimeExportMutationVariables>;
export const SyncAiMappingCostsToMapDocument = gql`
    mutation syncAiMappingCostsToMap($input: SyncAiMappingCostsToMapInput!) {
  syncAiMappingCostsToMap(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    createdAt
    createdBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    description
    id
    latitude
    longitude
    mapData
    mapImage
    mapImageDirty
    measurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
    name
    updatedAt
  }
}
    `;
export type SyncAiMappingCostsToMapMutationFn = Apollo.MutationFunction<SyncAiMappingCostsToMapMutation, SyncAiMappingCostsToMapMutationVariables>;

/**
 * __useSyncAiMappingCostsToMapMutation__
 *
 * To run a mutation, you first call `useSyncAiMappingCostsToMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncAiMappingCostsToMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncAiMappingCostsToMapMutation, { data, loading, error }] = useSyncAiMappingCostsToMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncAiMappingCostsToMapMutation(baseOptions?: Apollo.MutationHookOptions<SyncAiMappingCostsToMapMutation, SyncAiMappingCostsToMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncAiMappingCostsToMapMutation, SyncAiMappingCostsToMapMutationVariables>(SyncAiMappingCostsToMapDocument, options);
      }
export type SyncAiMappingCostsToMapMutationHookResult = ReturnType<typeof useSyncAiMappingCostsToMapMutation>;
export type SyncAiMappingCostsToMapMutationResult = Apollo.MutationResult<SyncAiMappingCostsToMapMutation>;
export type SyncAiMappingCostsToMapMutationOptions = Apollo.BaseMutationOptions<SyncAiMappingCostsToMapMutation, SyncAiMappingCostsToMapMutationVariables>;
export const SyncProjectMapMeasurementsDocument = gql`
    mutation syncProjectMapMeasurements($input: SyncProjectMapMeasurementsInput!) {
  syncProjectMapMeasurements(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    createdAt
    createdBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    description
    id
    latitude
    longitude
    mapData
    mapImage
    mapImageDirty
    measurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
    name
    updatedAt
  }
}
    `;
export type SyncProjectMapMeasurementsMutationFn = Apollo.MutationFunction<SyncProjectMapMeasurementsMutation, SyncProjectMapMeasurementsMutationVariables>;

/**
 * __useSyncProjectMapMeasurementsMutation__
 *
 * To run a mutation, you first call `useSyncProjectMapMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncProjectMapMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncProjectMapMeasurementsMutation, { data, loading, error }] = useSyncProjectMapMeasurementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncProjectMapMeasurementsMutation(baseOptions?: Apollo.MutationHookOptions<SyncProjectMapMeasurementsMutation, SyncProjectMapMeasurementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncProjectMapMeasurementsMutation, SyncProjectMapMeasurementsMutationVariables>(SyncProjectMapMeasurementsDocument, options);
      }
export type SyncProjectMapMeasurementsMutationHookResult = ReturnType<typeof useSyncProjectMapMeasurementsMutation>;
export type SyncProjectMapMeasurementsMutationResult = Apollo.MutationResult<SyncProjectMapMeasurementsMutation>;
export type SyncProjectMapMeasurementsMutationOptions = Apollo.BaseMutationOptions<SyncProjectMapMeasurementsMutation, SyncProjectMapMeasurementsMutationVariables>;
export const SyncProposalStageMeasurementsDocument = gql`
    mutation syncProposalStageMeasurements($input: SyncProposalStageMeasurementsInput!) {
  syncProposalStageMeasurements(input: $input) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    checklistItems {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    checklistNotes
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    discount
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalAfterDiscount
    profit
    profitAfterDiscount
    profitPercentage
    proposalProductGroups {
      id
      isOptional
      name
      ordering
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          helpers {
            hoursPerDay
          }
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricing {
            discount
            mode
            value
            version
          }
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            quantitySource
            rate
            rowId
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          children {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      showIndividualProducts
    }
    proposalProducts {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    roundTripTravelTimeHours
    stageMeasurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
  }
}
    `;
export type SyncProposalStageMeasurementsMutationFn = Apollo.MutationFunction<SyncProposalStageMeasurementsMutation, SyncProposalStageMeasurementsMutationVariables>;

/**
 * __useSyncProposalStageMeasurementsMutation__
 *
 * To run a mutation, you first call `useSyncProposalStageMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncProposalStageMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncProposalStageMeasurementsMutation, { data, loading, error }] = useSyncProposalStageMeasurementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncProposalStageMeasurementsMutation(baseOptions?: Apollo.MutationHookOptions<SyncProposalStageMeasurementsMutation, SyncProposalStageMeasurementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncProposalStageMeasurementsMutation, SyncProposalStageMeasurementsMutationVariables>(SyncProposalStageMeasurementsDocument, options);
      }
export type SyncProposalStageMeasurementsMutationHookResult = ReturnType<typeof useSyncProposalStageMeasurementsMutation>;
export type SyncProposalStageMeasurementsMutationResult = Apollo.MutationResult<SyncProposalStageMeasurementsMutation>;
export type SyncProposalStageMeasurementsMutationOptions = Apollo.BaseMutationOptions<SyncProposalStageMeasurementsMutation, SyncProposalStageMeasurementsMutationVariables>;
export const SyncQuickbooksBatchDocument = gql`
    mutation syncQuickbooksBatch($input: SyncQuickbooksBatchInput!) {
  syncQuickbooksBatch(input: $input) {
    billedTotalAmount
    billingMode
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    createEstimate
    createInvoice
    createJob
    createdAt
    id
    isDeposit
    jobs {
      billedAmount
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        checklistItems {
          checklistItem {
            id
            name
          }
          checklistItemId
          id
          isCompleted
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        invoiceId
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
      }
      selectedAmount
    }
    lines {
      billedAmount
      groupName
      id
      itemDescription
      itemName
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          billingStatus
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          id
          invoiceId
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposalId
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          addressOverride
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      originalAmount
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      sortOrder
      sourceType
    }
    partialAmountCents
    partialPercentage
    quickbooksDesktopError
    quickbooksDesktopQueuedAt
    quickbooksDesktopStatus
    quickbooksOnlineDocumentId
    quickbooksOnlineDocumentType
    quickbooksOnlineError
    quickbooksOnlineStatus
    selectedTotalAmount
    syncedDesktopAt
    syncedOnlineAt
  }
}
    `;
export type SyncQuickbooksBatchMutationFn = Apollo.MutationFunction<SyncQuickbooksBatchMutation, SyncQuickbooksBatchMutationVariables>;

/**
 * __useSyncQuickbooksBatchMutation__
 *
 * To run a mutation, you first call `useSyncQuickbooksBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncQuickbooksBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncQuickbooksBatchMutation, { data, loading, error }] = useSyncQuickbooksBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncQuickbooksBatchMutation(baseOptions?: Apollo.MutationHookOptions<SyncQuickbooksBatchMutation, SyncQuickbooksBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncQuickbooksBatchMutation, SyncQuickbooksBatchMutationVariables>(SyncQuickbooksBatchDocument, options);
      }
export type SyncQuickbooksBatchMutationHookResult = ReturnType<typeof useSyncQuickbooksBatchMutation>;
export type SyncQuickbooksBatchMutationResult = Apollo.MutationResult<SyncQuickbooksBatchMutation>;
export type SyncQuickbooksBatchMutationOptions = Apollo.BaseMutationOptions<SyncQuickbooksBatchMutation, SyncQuickbooksBatchMutationVariables>;
export const TestNotificationTriggerApiDocument = gql`
    mutation testNotificationTriggerApi($triggerId: ID!) {
  testNotificationTriggerApi(triggerId: $triggerId) {
    errorMessage
    httpStatusCode
    responseTimeMs
    success
  }
}
    `;
export type TestNotificationTriggerApiMutationFn = Apollo.MutationFunction<TestNotificationTriggerApiMutation, TestNotificationTriggerApiMutationVariables>;

/**
 * __useTestNotificationTriggerApiMutation__
 *
 * To run a mutation, you first call `useTestNotificationTriggerApiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestNotificationTriggerApiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testNotificationTriggerApiMutation, { data, loading, error }] = useTestNotificationTriggerApiMutation({
 *   variables: {
 *      triggerId: // value for 'triggerId'
 *   },
 * });
 */
export function useTestNotificationTriggerApiMutation(baseOptions?: Apollo.MutationHookOptions<TestNotificationTriggerApiMutation, TestNotificationTriggerApiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestNotificationTriggerApiMutation, TestNotificationTriggerApiMutationVariables>(TestNotificationTriggerApiDocument, options);
      }
export type TestNotificationTriggerApiMutationHookResult = ReturnType<typeof useTestNotificationTriggerApiMutation>;
export type TestNotificationTriggerApiMutationResult = Apollo.MutationResult<TestNotificationTriggerApiMutation>;
export type TestNotificationTriggerApiMutationOptions = Apollo.BaseMutationOptions<TestNotificationTriggerApiMutation, TestNotificationTriggerApiMutationVariables>;
export const ToggleOrganizationEmailIdentityDocument = gql`
    mutation toggleOrganizationEmailIdentity($enabled: Boolean!) {
  toggleOrganizationEmailIdentity(enabled: $enabled) {
    dkimTokens {
      host
      type
      value
    }
    dmarcRecord {
      host
      type
      value
    }
    enabled
    fromName
    id
    invoiceFromAddress
    invoiceLocalPart
    notificationsFromAddress
    notificationsLocalPart
    organizationId
    proposalFromAddress
    proposalLocalPart
    replyToCustomEmail
    replyToType
    sendingDomain
    spfRecord {
      host
      type
      value
    }
    verificationStatus
    verifiedAt
  }
}
    `;
export type ToggleOrganizationEmailIdentityMutationFn = Apollo.MutationFunction<ToggleOrganizationEmailIdentityMutation, ToggleOrganizationEmailIdentityMutationVariables>;

/**
 * __useToggleOrganizationEmailIdentityMutation__
 *
 * To run a mutation, you first call `useToggleOrganizationEmailIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleOrganizationEmailIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleOrganizationEmailIdentityMutation, { data, loading, error }] = useToggleOrganizationEmailIdentityMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleOrganizationEmailIdentityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleOrganizationEmailIdentityMutation, ToggleOrganizationEmailIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleOrganizationEmailIdentityMutation, ToggleOrganizationEmailIdentityMutationVariables>(ToggleOrganizationEmailIdentityDocument, options);
      }
export type ToggleOrganizationEmailIdentityMutationHookResult = ReturnType<typeof useToggleOrganizationEmailIdentityMutation>;
export type ToggleOrganizationEmailIdentityMutationResult = Apollo.MutationResult<ToggleOrganizationEmailIdentityMutation>;
export type ToggleOrganizationEmailIdentityMutationOptions = Apollo.BaseMutationOptions<ToggleOrganizationEmailIdentityMutation, ToggleOrganizationEmailIdentityMutationVariables>;
export const ToggleProposalProductGroupOptionalityDocument = gql`
    mutation toggleProposalProductGroupOptionality($id: ID!, $isOptional: Boolean!) {
  toggleProposalProductGroupOptionality(id: $id, isOptional: $isOptional) {
    id
    isOptional
    name
    ordering
    proposalProducts {
      additionalCosts {
        additionalCostId
        cost
        costOverride
        costTotal
        feeAmount
        feeAmountOverride
        feeType
        id
        name
        quantity
        quantityOverride
        showOnProposal
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      crews {
        cost
        crewId
        id
        name
        quantity
        quantityOverride
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
      }
      custom {
        area
        areaSource
        areaUnit
        calculationVersion
        costTotal
        fixedPrice
        helpers {
          hoursPerDay
          production {
            enabled
            materialRowId
            period
            quantity
            rate
            source
            unit
          }
          travel {
            enabled
            roundTripHours
            visits
          }
        }
        indirectPercentage
        internalName
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricing {
          discount
          mode
          value
          version
        }
        pricingBaseline {
          fixedPrice
          markup
          pricing {
            discount
            mode
            value
            version
          }
          pricingMethod
          profitAmount
        }
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        rows {
          calculatedQuantity
          calculation
          category
          factor
          factorAreaUnit
          factorLabel
          formula
          hauling {
            allocationPercent
            capacity
            capacityUnit
            fullLoads
            haulQuantity
            haulUnit
            loadHours
            materialRowId
            maxTripsPerDay
            planningEnabled
            planningHours
            quantityMode
            roundTripHours
            unloadHours
          }
          hoursPerTruck
          jobSize
          jobSizeUnit
          name
          quantity
          quantityOverride
          quantitySource
          rate
          rowId
          sourceId
          sourceName
          sourcePlantId
          sourcePlantName
          sourceType
          thickness
          total
          truckCapacity
          truckRateHours
          truckRateLoads
          truckRateTons
          truckRateYards
          truckingUnit
          trucksNeeded
          unit
        }
        scope
        scopeFormat
        sellingTotal
        sourceProductId
        sourceProductRevision
        unit
      }
      discount
      equipmentPieces {
        calculateTravelTime
        chargeType
        cost
        equipmentPieceId
        id
        name
        quantity
        quantityOverride
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
        usePercentage
      }
      externalProductName
      files {
        createdAt
        filename
        id
        thumbnail
        type
      }
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      material {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        attributesOverride {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMaterialOverride
        costMinimumProduct
        costMinimumProposal
        dailyUnitsComplete
        dailyUnitsCompleteOverride
        externalProductName
        id
        indirectPercentage
        indirectPercentageOverride
        labourCostType
        markupPercentage
        markupPercentageOverride
        materialNeeded
        materialNeededOverride
        measurementJob
        measurementMaterial
        name
        organizationProductTypeName
        overheadPercentage
        overheadPercentageOverride
        productId
        productionRateType
        proposalId
        proposalProductId
        proposalStageId
        statementOfWork
        statementOfWorkOverride
        subcontracted
        tonConversionFactor
        tonConversionFactorOverride
        type
        unitPrice
        unitPriceOverride
        unitPriceProduct
      }
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      plantProduct {
        applicationRate
        applicationRateOverride
        areaCoverage
        costMaterial
        costTransferTruck
        id
        materialNeeded
        materialNeededOverride
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          distanceMeters
          distanceSeconds
          id
          name
          phone
          plantId
          rateOnWeight
          roundTripSeconds
        }
        plantProductId
        rate
        rateOnWeight
        rateOverride
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTimeHrs
        transferTruckRoundTripTimeHrsOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        type
      }
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      projectFiles {
        children {
          children {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        createdAt
        fileSizeBytes
        id
        name
        parentFolderId
        path
        pivot {
          id
        }
        type
      }
      proposalMaterialNoPlants {
        cost
        id
        name
        percentage
        proposalProductId
        quantity
        quantityOverride
        rate
      }
      proposalPlantProducts {
        applicationRate
        applicationRateOverride
        areaCoverage
        costMaterial
        costTransferTruck
        id
        materialNeeded
        materialNeededOverride
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          distanceMeters
          distanceSeconds
          id
          name
          phone
          plantId
          rateOnWeight
          roundTripSeconds
        }
        plantProductId
        rate
        rateOnWeight
        rateOverride
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTimeHrs
        transferTruckRoundTripTimeHrsOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        type
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        proposalProducts {
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          discount
          externalProductName
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        showIndividualProducts
      }
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    showIndividualProducts
  }
}
    `;
export type ToggleProposalProductGroupOptionalityMutationFn = Apollo.MutationFunction<ToggleProposalProductGroupOptionalityMutation, ToggleProposalProductGroupOptionalityMutationVariables>;

/**
 * __useToggleProposalProductGroupOptionalityMutation__
 *
 * To run a mutation, you first call `useToggleProposalProductGroupOptionalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProposalProductGroupOptionalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProposalProductGroupOptionalityMutation, { data, loading, error }] = useToggleProposalProductGroupOptionalityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isOptional: // value for 'isOptional'
 *   },
 * });
 */
export function useToggleProposalProductGroupOptionalityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleProposalProductGroupOptionalityMutation, ToggleProposalProductGroupOptionalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleProposalProductGroupOptionalityMutation, ToggleProposalProductGroupOptionalityMutationVariables>(ToggleProposalProductGroupOptionalityDocument, options);
      }
export type ToggleProposalProductGroupOptionalityMutationHookResult = ReturnType<typeof useToggleProposalProductGroupOptionalityMutation>;
export type ToggleProposalProductGroupOptionalityMutationResult = Apollo.MutationResult<ToggleProposalProductGroupOptionalityMutation>;
export type ToggleProposalProductGroupOptionalityMutationOptions = Apollo.BaseMutationOptions<ToggleProposalProductGroupOptionalityMutation, ToggleProposalProductGroupOptionalityMutationVariables>;
export const ToggleProposalProductOptionalityDocument = gql`
    mutation toggleProposalProductOptionality($id: ID!, $isOptional: Boolean!) {
  toggleProposalProductOptionality(id: $id, isOptional: $isOptional) {
    additionalCosts {
      additionalCostId
      cost
      costOverride
      costTotal
      feeAmount
      feeAmountOverride
      feeType
      id
      name
      quantity
      quantityOverride
      showOnProposal
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    costTransferTruck
    crews {
      cost
      crewId
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
    }
    custom {
      area
      areaSource
      areaUnit
      calculationVersion
      costTotal
      fixedPrice
      helpers {
        hoursPerDay
        production {
          enabled
          materialRowId
          period
          quantity
          rate
          source
          unit
        }
        travel {
          enabled
          roundTripHours
          visits
        }
      }
      indirectPercentage
      internalName
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricing {
        discount
        mode
        value
        version
      }
      pricingBaseline {
        fixedPrice
        markup
        pricing {
          discount
          mode
          value
          version
        }
        pricingMethod
        profitAmount
      }
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      rows {
        calculatedQuantity
        calculation
        category
        factor
        factorAreaUnit
        factorLabel
        formula
        hauling {
          allocationPercent
          capacity
          capacityUnit
          fullLoads
          haulQuantity
          haulUnit
          loadHours
          materialRowId
          maxTripsPerDay
          planningEnabled
          planningHours
          quantityMode
          roundTripHours
          unloadHours
        }
        hoursPerTruck
        jobSize
        jobSizeUnit
        name
        quantity
        quantityOverride
        quantitySource
        rate
        rowId
        sourceId
        sourceName
        sourcePlantId
        sourcePlantName
        sourceType
        thickness
        total
        truckCapacity
        truckRateHours
        truckRateLoads
        truckRateTons
        truckRateYards
        truckingUnit
        trucksNeeded
        unit
      }
      scope
      scopeFormat
      sellingTotal
      sourceProductId
      sourceProductRevision
      unit
    }
    discount
    equipmentPieces {
      calculateTravelTime
      chargeType
      cost
      equipmentPieceId
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
      usePercentage
    }
    externalProductName
    files {
      createdAt
      filename
      id
      thumbnail
      type
    }
    grossMargin
    grossMarginPercentage
    id
    isCustom
    isOptional
    jobDuration
    jobDurationDaysOverride
    jobDurationOverride
    jobSize
    mapData
    mapImage
    mapImageDirty
    material {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      attributesOverride {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMaterialOverride
      costMinimumProduct
      costMinimumProposal
      dailyUnitsComplete
      dailyUnitsCompleteOverride
      externalProductName
      id
      indirectPercentage
      indirectPercentageOverride
      labourCostType
      markupPercentage
      markupPercentageOverride
      materialNeeded
      materialNeededOverride
      measurementJob
      measurementMaterial
      name
      organizationProductTypeName
      overheadPercentage
      overheadPercentageOverride
      productId
      productionRateType
      proposalId
      proposalProductId
      proposalStageId
      statementOfWork
      statementOfWorkOverride
      subcontracted
      tonConversionFactor
      tonConversionFactorOverride
      type
      unitPrice
      unitPriceOverride
      unitPriceProduct
    }
    measurementJob
    measurementMaterial
    netMargin
    netMarginPercentage
    notes
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalAfterDiscount
    overallTotalOverride
    plantProduct {
      applicationRate
      applicationRateOverride
      areaCoverage
      costMaterial
      costTransferTruck
      id
      materialNeeded
      materialNeededOverride
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOnWeight
      rateOverride
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTimeHrs
      transferTruckRoundTripTimeHrsOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        proposalPlantProductId
        quantity
        quantityOverride
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
      type
    }
    productName
    profit
    profitAfterDiscount
    profitOverride
    profitPercentage
    profitPercentageOverride
    projectFiles {
      children {
        children {
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        createdAt
        fileSizeBytes
        id
        name
        parentFolderId
        path
        type
      }
      createdAt
      fileSizeBytes
      id
      name
      parentFolderId
      path
      pivot {
        id
      }
      type
    }
    proposalMaterialNoPlants {
      cost
      id
      name
      percentage
      proposalProductId
      quantity
      quantityOverride
      rate
    }
    proposalPlantProducts {
      applicationRate
      applicationRateOverride
      areaCoverage
      costMaterial
      costTransferTruck
      id
      materialNeeded
      materialNeededOverride
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOnWeight
      rateOverride
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTimeHrs
      transferTruckRoundTripTimeHrsOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        proposalPlantProductId
        quantity
        quantityOverride
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
      type
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      showIndividualProducts
    }
    proposalProductGroupId
    roundTripTravelTimeHours
    statementOfWork
    subcontractorCost
    subcontractorName
    subcontractorProposalId
    transferTruckLoadTimeBuffer
    transferTruckRoundTripTime
    transferTruckRoundTripTimeOverride
    transferTruckUnloadTimeBuffer
    transferTrucks {
      cost
      costOverride
      id
      name
      plantTransferTruckId
      proposalPlantProductId
      quantity
      quantityOverride
      rateHourly
      rateHourlyOverride
      rateTon
      rateTonOverride
      tonnage
      totalHaulingHours
      totalHaulingHoursOverride
      transferTruckId
      truckingProductionRate
      trucksNeeded
    }
    unitPriceOverride
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;
export type ToggleProposalProductOptionalityMutationFn = Apollo.MutationFunction<ToggleProposalProductOptionalityMutation, ToggleProposalProductOptionalityMutationVariables>;

/**
 * __useToggleProposalProductOptionalityMutation__
 *
 * To run a mutation, you first call `useToggleProposalProductOptionalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProposalProductOptionalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProposalProductOptionalityMutation, { data, loading, error }] = useToggleProposalProductOptionalityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isOptional: // value for 'isOptional'
 *   },
 * });
 */
export function useToggleProposalProductOptionalityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleProposalProductOptionalityMutation, ToggleProposalProductOptionalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleProposalProductOptionalityMutation, ToggleProposalProductOptionalityMutationVariables>(ToggleProposalProductOptionalityDocument, options);
      }
export type ToggleProposalProductOptionalityMutationHookResult = ReturnType<typeof useToggleProposalProductOptionalityMutation>;
export type ToggleProposalProductOptionalityMutationResult = Apollo.MutationResult<ToggleProposalProductOptionalityMutation>;
export type ToggleProposalProductOptionalityMutationOptions = Apollo.BaseMutationOptions<ToggleProposalProductOptionalityMutation, ToggleProposalProductOptionalityMutationVariables>;
export const UndoAiMappingRunAreaDocument = gql`
    mutation undoAiMappingRunArea($id: ID!) {
  undoAiMappingRunArea(id: $id) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    detections {
      bbox
      category
      color
      confidence
      id
      isDeleted
      source
      version
    }
    segmentations {
      areaSqft
      category
      color
      id
      isDeleted
      polygon
      version
    }
  }
}
    `;
export type UndoAiMappingRunAreaMutationFn = Apollo.MutationFunction<UndoAiMappingRunAreaMutation, UndoAiMappingRunAreaMutationVariables>;

/**
 * __useUndoAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useUndoAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoAiMappingRunAreaMutation, { data, loading, error }] = useUndoAiMappingRunAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUndoAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<UndoAiMappingRunAreaMutation, UndoAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoAiMappingRunAreaMutation, UndoAiMappingRunAreaMutationVariables>(UndoAiMappingRunAreaDocument, options);
      }
export type UndoAiMappingRunAreaMutationHookResult = ReturnType<typeof useUndoAiMappingRunAreaMutation>;
export type UndoAiMappingRunAreaMutationResult = Apollo.MutationResult<UndoAiMappingRunAreaMutation>;
export type UndoAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<UndoAiMappingRunAreaMutation, UndoAiMappingRunAreaMutationVariables>;
export const UnlinkServiceDocument = gql`
    mutation unlinkService($service: OrganizationLinkedServiceName!) {
  unlinkService(service: $service)
}
    `;
export type UnlinkServiceMutationFn = Apollo.MutationFunction<UnlinkServiceMutation, UnlinkServiceMutationVariables>;

/**
 * __useUnlinkServiceMutation__
 *
 * To run a mutation, you first call `useUnlinkServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkServiceMutation, { data, loading, error }] = useUnlinkServiceMutation({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useUnlinkServiceMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkServiceMutation, UnlinkServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkServiceMutation, UnlinkServiceMutationVariables>(UnlinkServiceDocument, options);
      }
export type UnlinkServiceMutationHookResult = ReturnType<typeof useUnlinkServiceMutation>;
export type UnlinkServiceMutationResult = Apollo.MutationResult<UnlinkServiceMutation>;
export type UnlinkServiceMutationOptions = Apollo.BaseMutationOptions<UnlinkServiceMutation, UnlinkServiceMutationVariables>;
export const UnscheduleCustomEventDocument = gql`
    mutation unscheduleCustomEvent($id: ID!) {
  unscheduleCustomEvent(id: $id) {
    color
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        endsAt
        files {
          customEvent {
            color
            endsAt
            id
            name
            notes
            startsAt
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    files {
      id
      name
      path
    }
    id
    name
    notes
    startsAt
  }
}
    `;
export type UnscheduleCustomEventMutationFn = Apollo.MutationFunction<UnscheduleCustomEventMutation, UnscheduleCustomEventMutationVariables>;

/**
 * __useUnscheduleCustomEventMutation__
 *
 * To run a mutation, you first call `useUnscheduleCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleCustomEventMutation, { data, loading, error }] = useUnscheduleCustomEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnscheduleCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<UnscheduleCustomEventMutation, UnscheduleCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnscheduleCustomEventMutation, UnscheduleCustomEventMutationVariables>(UnscheduleCustomEventDocument, options);
      }
export type UnscheduleCustomEventMutationHookResult = ReturnType<typeof useUnscheduleCustomEventMutation>;
export type UnscheduleCustomEventMutationResult = Apollo.MutationResult<UnscheduleCustomEventMutation>;
export type UnscheduleCustomEventMutationOptions = Apollo.BaseMutationOptions<UnscheduleCustomEventMutation, UnscheduleCustomEventMutationVariables>;
export const UnscheduleJobPhaseDocument = gql`
    mutation unscheduleJobPhase($jobPhaseId: ID!) {
  unscheduleJobPhase(jobPhaseId: $jobPhaseId) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type UnscheduleJobPhaseMutationFn = Apollo.MutationFunction<UnscheduleJobPhaseMutation, UnscheduleJobPhaseMutationVariables>;

/**
 * __useUnscheduleJobPhaseMutation__
 *
 * To run a mutation, you first call `useUnscheduleJobPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleJobPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleJobPhaseMutation, { data, loading, error }] = useUnscheduleJobPhaseMutation({
 *   variables: {
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useUnscheduleJobPhaseMutation(baseOptions?: Apollo.MutationHookOptions<UnscheduleJobPhaseMutation, UnscheduleJobPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnscheduleJobPhaseMutation, UnscheduleJobPhaseMutationVariables>(UnscheduleJobPhaseDocument, options);
      }
export type UnscheduleJobPhaseMutationHookResult = ReturnType<typeof useUnscheduleJobPhaseMutation>;
export type UnscheduleJobPhaseMutationResult = Apollo.MutationResult<UnscheduleJobPhaseMutation>;
export type UnscheduleJobPhaseMutationOptions = Apollo.BaseMutationOptions<UnscheduleJobPhaseMutation, UnscheduleJobPhaseMutationVariables>;
export const UpdateAdditionalCostDocument = gql`
    mutation updateAdditionalCost($input: UpdateAdditionalCostInput!) {
  updateAdditionalCost(input: $input) {
    cost
    feeAmount
    feeType
    id
    name
  }
}
    `;
export type UpdateAdditionalCostMutationFn = Apollo.MutationFunction<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>;

/**
 * __useUpdateAdditionalCostMutation__
 *
 * To run a mutation, you first call `useUpdateAdditionalCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditionalCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditionalCostMutation, { data, loading, error }] = useUpdateAdditionalCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdditionalCostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>(UpdateAdditionalCostDocument, options);
      }
export type UpdateAdditionalCostMutationHookResult = ReturnType<typeof useUpdateAdditionalCostMutation>;
export type UpdateAdditionalCostMutationResult = Apollo.MutationResult<UpdateAdditionalCostMutation>;
export type UpdateAdditionalCostMutationOptions = Apollo.BaseMutationOptions<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>;
export const UpdateAiMappingDetectionDocument = gql`
    mutation updateAiMappingDetection($input: UpdateAiMappingDetectionInput!) {
  updateAiMappingDetection(input: $input) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    detections {
      bbox
      category
      color
      confidence
      id
      isDeleted
      source
      version
    }
    segmentations {
      areaSqft
      category
      color
      id
      isDeleted
      polygon
      version
    }
  }
}
    `;
export type UpdateAiMappingDetectionMutationFn = Apollo.MutationFunction<UpdateAiMappingDetectionMutation, UpdateAiMappingDetectionMutationVariables>;

/**
 * __useUpdateAiMappingDetectionMutation__
 *
 * To run a mutation, you first call `useUpdateAiMappingDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiMappingDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiMappingDetectionMutation, { data, loading, error }] = useUpdateAiMappingDetectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAiMappingDetectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiMappingDetectionMutation, UpdateAiMappingDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiMappingDetectionMutation, UpdateAiMappingDetectionMutationVariables>(UpdateAiMappingDetectionDocument, options);
      }
export type UpdateAiMappingDetectionMutationHookResult = ReturnType<typeof useUpdateAiMappingDetectionMutation>;
export type UpdateAiMappingDetectionMutationResult = Apollo.MutationResult<UpdateAiMappingDetectionMutation>;
export type UpdateAiMappingDetectionMutationOptions = Apollo.BaseMutationOptions<UpdateAiMappingDetectionMutation, UpdateAiMappingDetectionMutationVariables>;
export const UpdateAiMappingSegmentationDocument = gql`
    mutation updateAiMappingSegmentation($input: UpdateAiMappingSegmentationInput!) {
  updateAiMappingSegmentation(input: $input) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    detections {
      bbox
      category
      color
      confidence
      id
      isDeleted
      source
      version
    }
    segmentations {
      areaSqft
      category
      color
      id
      isDeleted
      polygon
      version
    }
  }
}
    `;
export type UpdateAiMappingSegmentationMutationFn = Apollo.MutationFunction<UpdateAiMappingSegmentationMutation, UpdateAiMappingSegmentationMutationVariables>;

/**
 * __useUpdateAiMappingSegmentationMutation__
 *
 * To run a mutation, you first call `useUpdateAiMappingSegmentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiMappingSegmentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiMappingSegmentationMutation, { data, loading, error }] = useUpdateAiMappingSegmentationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAiMappingSegmentationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiMappingSegmentationMutation, UpdateAiMappingSegmentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiMappingSegmentationMutation, UpdateAiMappingSegmentationMutationVariables>(UpdateAiMappingSegmentationDocument, options);
      }
export type UpdateAiMappingSegmentationMutationHookResult = ReturnType<typeof useUpdateAiMappingSegmentationMutation>;
export type UpdateAiMappingSegmentationMutationResult = Apollo.MutationResult<UpdateAiMappingSegmentationMutation>;
export type UpdateAiMappingSegmentationMutationOptions = Apollo.BaseMutationOptions<UpdateAiMappingSegmentationMutation, UpdateAiMappingSegmentationMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateCompanyNotesDocument = gql`
    mutation updateCompanyNotes($input: UpdateCompanyNotesInput!) {
  updateCompanyNotes(input: $input) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type UpdateCompanyNotesMutationFn = Apollo.MutationFunction<UpdateCompanyNotesMutation, UpdateCompanyNotesMutationVariables>;

/**
 * __useUpdateCompanyNotesMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyNotesMutation, { data, loading, error }] = useUpdateCompanyNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyNotesMutation, UpdateCompanyNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyNotesMutation, UpdateCompanyNotesMutationVariables>(UpdateCompanyNotesDocument, options);
      }
export type UpdateCompanyNotesMutationHookResult = ReturnType<typeof useUpdateCompanyNotesMutation>;
export type UpdateCompanyNotesMutationResult = Apollo.MutationResult<UpdateCompanyNotesMutation>;
export type UpdateCompanyNotesMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyNotesMutation, UpdateCompanyNotesMutationVariables>;
export const UpdateCompanyProjectFileFolderIdDocument = gql`
    mutation updateCompanyProjectFileFolderId($id: ID!, $projectFilesFolderId: ID) {
  updateCompanyProjectFileFolderId(
    id: $id
    projectFilesFolderId: $projectFilesFolderId
  ) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type UpdateCompanyProjectFileFolderIdMutationFn = Apollo.MutationFunction<UpdateCompanyProjectFileFolderIdMutation, UpdateCompanyProjectFileFolderIdMutationVariables>;

/**
 * __useUpdateCompanyProjectFileFolderIdMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyProjectFileFolderIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyProjectFileFolderIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyProjectFileFolderIdMutation, { data, loading, error }] = useUpdateCompanyProjectFileFolderIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectFilesFolderId: // value for 'projectFilesFolderId'
 *   },
 * });
 */
export function useUpdateCompanyProjectFileFolderIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyProjectFileFolderIdMutation, UpdateCompanyProjectFileFolderIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyProjectFileFolderIdMutation, UpdateCompanyProjectFileFolderIdMutationVariables>(UpdateCompanyProjectFileFolderIdDocument, options);
      }
export type UpdateCompanyProjectFileFolderIdMutationHookResult = ReturnType<typeof useUpdateCompanyProjectFileFolderIdMutation>;
export type UpdateCompanyProjectFileFolderIdMutationResult = Apollo.MutationResult<UpdateCompanyProjectFileFolderIdMutation>;
export type UpdateCompanyProjectFileFolderIdMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyProjectFileFolderIdMutation, UpdateCompanyProjectFileFolderIdMutationVariables>;
export const UpdateCrewDocument = gql`
    mutation updateCrew($input: UpdateCrewInput!) {
  updateCrew(input: $input) {
    color
    displayName
    employees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    rate
  }
}
    `;
export type UpdateCrewMutationFn = Apollo.MutationFunction<UpdateCrewMutation, UpdateCrewMutationVariables>;

/**
 * __useUpdateCrewMutation__
 *
 * To run a mutation, you first call `useUpdateCrewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewMutation, { data, loading, error }] = useUpdateCrewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewMutation, UpdateCrewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCrewMutation, UpdateCrewMutationVariables>(UpdateCrewDocument, options);
      }
export type UpdateCrewMutationHookResult = ReturnType<typeof useUpdateCrewMutation>;
export type UpdateCrewMutationResult = Apollo.MutationResult<UpdateCrewMutation>;
export type UpdateCrewMutationOptions = Apollo.BaseMutationOptions<UpdateCrewMutation, UpdateCrewMutationVariables>;
export const UpdateCustomEventDocument = gql`
    mutation updateCustomEvent($input: UpdateCustomEventInput) {
  updateCustomEvent(input: $input) {
    color
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        endsAt
        files {
          customEvent {
            color
            endsAt
            id
            name
            notes
            startsAt
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    files {
      id
      name
      path
    }
    id
    name
    notes
    startsAt
  }
}
    `;
export type UpdateCustomEventMutationFn = Apollo.MutationFunction<UpdateCustomEventMutation, UpdateCustomEventMutationVariables>;

/**
 * __useUpdateCustomEventMutation__
 *
 * To run a mutation, you first call `useUpdateCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomEventMutation, { data, loading, error }] = useUpdateCustomEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomEventMutation, UpdateCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomEventMutation, UpdateCustomEventMutationVariables>(UpdateCustomEventDocument, options);
      }
export type UpdateCustomEventMutationHookResult = ReturnType<typeof useUpdateCustomEventMutation>;
export type UpdateCustomEventMutationResult = Apollo.MutationResult<UpdateCustomEventMutation>;
export type UpdateCustomEventMutationOptions = Apollo.BaseMutationOptions<UpdateCustomEventMutation, UpdateCustomEventMutationVariables>;
export const UpdateCustomLibraryProductDocument = gql`
    mutation updateCustomLibraryProduct($expectedRevision: String!, $id: ID!, $input: CustomInput!) {
  updateCustomLibraryProduct(
    expectedRevision: $expectedRevision
    id: $id
    input: $input
  ) {
    definition {
      area
      areaSource
      areaUnit
      calculationVersion
      costTotal
      fixedPrice
      helpers {
        hoursPerDay
        production {
          enabled
          materialRowId
          period
          quantity
          rate
          source
          unit
        }
        travel {
          enabled
          roundTripHours
          visits
        }
      }
      indirectPercentage
      internalName
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricing {
        discount
        mode
        value
        version
      }
      pricingBaseline {
        fixedPrice
        markup
        pricing {
          discount
          mode
          value
          version
        }
        pricingMethod
        profitAmount
      }
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      rows {
        calculatedQuantity
        calculation
        category
        factor
        factorAreaUnit
        factorLabel
        formula
        hauling {
          allocationPercent
          capacity
          capacityUnit
          fullLoads
          haulQuantity
          haulUnit
          loadHours
          materialRowId
          maxTripsPerDay
          planningEnabled
          planningHours
          quantityMode
          roundTripHours
          unloadHours
        }
        hoursPerTruck
        jobSize
        jobSizeUnit
        name
        quantity
        quantityOverride
        quantitySource
        rate
        rowId
        sourceId
        sourceName
        sourcePlantId
        sourcePlantName
        sourceType
        thickness
        total
        truckCapacity
        truckRateHours
        truckRateLoads
        truckRateTons
        truckRateYards
        truckingUnit
        trucksNeeded
        unit
      }
      scope
      scopeFormat
      sellingTotal
      sourceProductId
      sourceProductRevision
      unit
    }
    id
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    revision
  }
}
    `;
export type UpdateCustomLibraryProductMutationFn = Apollo.MutationFunction<UpdateCustomLibraryProductMutation, UpdateCustomLibraryProductMutationVariables>;

/**
 * __useUpdateCustomLibraryProductMutation__
 *
 * To run a mutation, you first call `useUpdateCustomLibraryProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomLibraryProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomLibraryProductMutation, { data, loading, error }] = useUpdateCustomLibraryProductMutation({
 *   variables: {
 *      expectedRevision: // value for 'expectedRevision'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomLibraryProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomLibraryProductMutation, UpdateCustomLibraryProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomLibraryProductMutation, UpdateCustomLibraryProductMutationVariables>(UpdateCustomLibraryProductDocument, options);
      }
export type UpdateCustomLibraryProductMutationHookResult = ReturnType<typeof useUpdateCustomLibraryProductMutation>;
export type UpdateCustomLibraryProductMutationResult = Apollo.MutationResult<UpdateCustomLibraryProductMutation>;
export type UpdateCustomLibraryProductMutationOptions = Apollo.BaseMutationOptions<UpdateCustomLibraryProductMutation, UpdateCustomLibraryProductMutationVariables>;
export const UpdateDailyFormInspectionDocument = gql`
    mutation updateDailyFormInspection($input: UpdateDailyFormInspectionInput!) {
  updateDailyFormInspection(input: $input) {
    createdAt
    dailyFormVehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      registrationExpirationDate
      registrationState
      vin
      year
    }
    id
    lightsWork
    loadStrapped
    oilChecked
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    questionAnswers {
      answer
      id
      isTrue
    }
    tiresAiredBrakesWorking
    toolsLoaded
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    vehicleConditionAcceptable
    vehicleFueled
    vehicleMilleage
  }
}
    `;
export type UpdateDailyFormInspectionMutationFn = Apollo.MutationFunction<UpdateDailyFormInspectionMutation, UpdateDailyFormInspectionMutationVariables>;

/**
 * __useUpdateDailyFormInspectionMutation__
 *
 * To run a mutation, you first call `useUpdateDailyFormInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyFormInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyFormInspectionMutation, { data, loading, error }] = useUpdateDailyFormInspectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyFormInspectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyFormInspectionMutation, UpdateDailyFormInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyFormInspectionMutation, UpdateDailyFormInspectionMutationVariables>(UpdateDailyFormInspectionDocument, options);
      }
export type UpdateDailyFormInspectionMutationHookResult = ReturnType<typeof useUpdateDailyFormInspectionMutation>;
export type UpdateDailyFormInspectionMutationResult = Apollo.MutationResult<UpdateDailyFormInspectionMutation>;
export type UpdateDailyFormInspectionMutationOptions = Apollo.BaseMutationOptions<UpdateDailyFormInspectionMutation, UpdateDailyFormInspectionMutationVariables>;
export const UpdateDailyFormInspectionQuestionDocument = gql`
    mutation updateDailyFormInspectionQuestion($input: UpdateDailyFormInspectionQuestionInput!) {
  updateDailyFormInspectionQuestion(input: $input) {
    id
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    question
    type
  }
}
    `;
export type UpdateDailyFormInspectionQuestionMutationFn = Apollo.MutationFunction<UpdateDailyFormInspectionQuestionMutation, UpdateDailyFormInspectionQuestionMutationVariables>;

/**
 * __useUpdateDailyFormInspectionQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateDailyFormInspectionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyFormInspectionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyFormInspectionQuestionMutation, { data, loading, error }] = useUpdateDailyFormInspectionQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyFormInspectionQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyFormInspectionQuestionMutation, UpdateDailyFormInspectionQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyFormInspectionQuestionMutation, UpdateDailyFormInspectionQuestionMutationVariables>(UpdateDailyFormInspectionQuestionDocument, options);
      }
export type UpdateDailyFormInspectionQuestionMutationHookResult = ReturnType<typeof useUpdateDailyFormInspectionQuestionMutation>;
export type UpdateDailyFormInspectionQuestionMutationResult = Apollo.MutationResult<UpdateDailyFormInspectionQuestionMutation>;
export type UpdateDailyFormInspectionQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateDailyFormInspectionQuestionMutation, UpdateDailyFormInspectionQuestionMutationVariables>;
export const UpdateDailyFormVehicleDocument = gql`
    mutation updateDailyFormVehicle($input: UpdateDailyFormVehicleInput!) {
  updateDailyFormVehicle(input: $input) {
    currentMeterReading
    dailyFormVehicleType {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    defaultServiceIntervalUnit
    defaultServiceIntervalValue
    id
    inServiceDate
    inspections {
      createdAt
      dailyFormVehicle {
        currentMeterReading
        dailyFormVehicleType {
          id
          name
        }
        defaultServiceIntervalUnit
        defaultServiceIntervalValue
        id
        inServiceDate
        inspections {
          createdAt
          id
          lightsWork
          loadStrapped
          oilChecked
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          questionAnswers {
            answer
            id
            isTrue
          }
          tiresAiredBrakesWorking
          toolsLoaded
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicleConditionAcceptable
          vehicleFueled
          vehicleMilleage
        }
        isActive
        licensePlate
        make
        meterType
        model
        name
        notes
        parts {
          id
          name
          notes
          partNumber
          quantity
          unitPrice
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          vendorName
        }
        registrationExpirationDate
        registrationState
        servicePlans {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        vin
        workOrders {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        year
      }
      id
      lightsWork
      loadStrapped
      oilChecked
      tiresAiredBrakesWorking
      toolsLoaded
      vehicleConditionAcceptable
      vehicleFueled
      vehicleMilleage
    }
    isActive
    licensePlate
    make
    meterType
    model
    name
    notes
    parts {
      id
      name
      notes
      partNumber
      quantity
      unitPrice
      vendorName
    }
    registrationExpirationDate
    registrationState
    servicePlans {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    vin
    workOrders {
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      status
    }
    year
  }
}
    `;
export type UpdateDailyFormVehicleMutationFn = Apollo.MutationFunction<UpdateDailyFormVehicleMutation, UpdateDailyFormVehicleMutationVariables>;

/**
 * __useUpdateDailyFormVehicleMutation__
 *
 * To run a mutation, you first call `useUpdateDailyFormVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyFormVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyFormVehicleMutation, { data, loading, error }] = useUpdateDailyFormVehicleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyFormVehicleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyFormVehicleMutation, UpdateDailyFormVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyFormVehicleMutation, UpdateDailyFormVehicleMutationVariables>(UpdateDailyFormVehicleDocument, options);
      }
export type UpdateDailyFormVehicleMutationHookResult = ReturnType<typeof useUpdateDailyFormVehicleMutation>;
export type UpdateDailyFormVehicleMutationResult = Apollo.MutationResult<UpdateDailyFormVehicleMutation>;
export type UpdateDailyFormVehicleMutationOptions = Apollo.BaseMutationOptions<UpdateDailyFormVehicleMutation, UpdateDailyFormVehicleMutationVariables>;
export const UpdateDailyFormVehiclePartDocument = gql`
    mutation updateDailyFormVehiclePart($input: UpdateDailyFormVehiclePartInput!) {
  updateDailyFormVehiclePart(input: $input) {
    id
    name
    notes
    partNumber
    quantity
    unitPrice
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    vendorName
  }
}
    `;
export type UpdateDailyFormVehiclePartMutationFn = Apollo.MutationFunction<UpdateDailyFormVehiclePartMutation, UpdateDailyFormVehiclePartMutationVariables>;

/**
 * __useUpdateDailyFormVehiclePartMutation__
 *
 * To run a mutation, you first call `useUpdateDailyFormVehiclePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyFormVehiclePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyFormVehiclePartMutation, { data, loading, error }] = useUpdateDailyFormVehiclePartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyFormVehiclePartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyFormVehiclePartMutation, UpdateDailyFormVehiclePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyFormVehiclePartMutation, UpdateDailyFormVehiclePartMutationVariables>(UpdateDailyFormVehiclePartDocument, options);
      }
export type UpdateDailyFormVehiclePartMutationHookResult = ReturnType<typeof useUpdateDailyFormVehiclePartMutation>;
export type UpdateDailyFormVehiclePartMutationResult = Apollo.MutationResult<UpdateDailyFormVehiclePartMutation>;
export type UpdateDailyFormVehiclePartMutationOptions = Apollo.BaseMutationOptions<UpdateDailyFormVehiclePartMutation, UpdateDailyFormVehiclePartMutationVariables>;
export const UpdateDailyFormVehicleServicePlanDocument = gql`
    mutation updateDailyFormVehicleServicePlan($input: UpdateDailyFormVehicleServicePlanInput!) {
  updateDailyFormVehicleServicePlan(input: $input) {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    autoCreateTask
    id
    intervalUnit
    intervalValue
    isActive
    issueType
    lastCompletedAt
    lastCompletedMeterReading
    leadUnit
    leadValue
    name
    nextDueDate
    nextDueMeterReading
    notes
    priority
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    workOrders {
      assignedTo {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      files {
        dailyFormWorkOrder {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        path
      }
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      servicePlan {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        autoCreateTask
        id
        intervalUnit
        intervalValue
        isActive
        issueType
        lastCompletedAt
        lastCompletedMeterReading
        leadUnit
        leadValue
        name
        nextDueDate
        nextDueMeterReading
        notes
        priority
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          vin
          year
        }
        workOrders {
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
      }
      status
    }
  }
}
    `;
export type UpdateDailyFormVehicleServicePlanMutationFn = Apollo.MutationFunction<UpdateDailyFormVehicleServicePlanMutation, UpdateDailyFormVehicleServicePlanMutationVariables>;

/**
 * __useUpdateDailyFormVehicleServicePlanMutation__
 *
 * To run a mutation, you first call `useUpdateDailyFormVehicleServicePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyFormVehicleServicePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyFormVehicleServicePlanMutation, { data, loading, error }] = useUpdateDailyFormVehicleServicePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyFormVehicleServicePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyFormVehicleServicePlanMutation, UpdateDailyFormVehicleServicePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyFormVehicleServicePlanMutation, UpdateDailyFormVehicleServicePlanMutationVariables>(UpdateDailyFormVehicleServicePlanDocument, options);
      }
export type UpdateDailyFormVehicleServicePlanMutationHookResult = ReturnType<typeof useUpdateDailyFormVehicleServicePlanMutation>;
export type UpdateDailyFormVehicleServicePlanMutationResult = Apollo.MutationResult<UpdateDailyFormVehicleServicePlanMutation>;
export type UpdateDailyFormVehicleServicePlanMutationOptions = Apollo.BaseMutationOptions<UpdateDailyFormVehicleServicePlanMutation, UpdateDailyFormVehicleServicePlanMutationVariables>;
export const UpdateDailyFormVehicleTypeDocument = gql`
    mutation updateDailyFormVehicleType($id: ID!, $name: String!) {
  updateDailyFormVehicleType(id: $id, name: $name) {
    id
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;
export type UpdateDailyFormVehicleTypeMutationFn = Apollo.MutationFunction<UpdateDailyFormVehicleTypeMutation, UpdateDailyFormVehicleTypeMutationVariables>;

/**
 * __useUpdateDailyFormVehicleTypeMutation__
 *
 * To run a mutation, you first call `useUpdateDailyFormVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyFormVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyFormVehicleTypeMutation, { data, loading, error }] = useUpdateDailyFormVehicleTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateDailyFormVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyFormVehicleTypeMutation, UpdateDailyFormVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyFormVehicleTypeMutation, UpdateDailyFormVehicleTypeMutationVariables>(UpdateDailyFormVehicleTypeDocument, options);
      }
export type UpdateDailyFormVehicleTypeMutationHookResult = ReturnType<typeof useUpdateDailyFormVehicleTypeMutation>;
export type UpdateDailyFormVehicleTypeMutationResult = Apollo.MutationResult<UpdateDailyFormVehicleTypeMutation>;
export type UpdateDailyFormVehicleTypeMutationOptions = Apollo.BaseMutationOptions<UpdateDailyFormVehicleTypeMutation, UpdateDailyFormVehicleTypeMutationVariables>;
export const UpdateDailyFormWorkOrderDocument = gql`
    mutation updateDailyFormWorkOrder($input: UpdateDailyFormWorkOrderInput!) {
  updateDailyFormWorkOrder(input: $input) {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    comments
    completedAt
    createdAt
    currentMeterReading
    estimatedTaskTime
    files {
      dailyFormWorkOrder {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        comments
        completedAt
        createdAt
        currentMeterReading
        estimatedTaskTime
        files {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        issueDescription
        issueName
        issueType
        neededCompletionDate
        priority
        servicePlan {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
      }
      id
      name
      path
    }
    id
    issueDescription
    issueName
    issueType
    neededCompletionDate
    priority
    servicePlan {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    vehicle {
      currentMeterReading
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      registrationExpirationDate
      registrationState
      vin
      year
    }
  }
}
    `;
export type UpdateDailyFormWorkOrderMutationFn = Apollo.MutationFunction<UpdateDailyFormWorkOrderMutation, UpdateDailyFormWorkOrderMutationVariables>;

/**
 * __useUpdateDailyFormWorkOrderMutation__
 *
 * To run a mutation, you first call `useUpdateDailyFormWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyFormWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyFormWorkOrderMutation, { data, loading, error }] = useUpdateDailyFormWorkOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyFormWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyFormWorkOrderMutation, UpdateDailyFormWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyFormWorkOrderMutation, UpdateDailyFormWorkOrderMutationVariables>(UpdateDailyFormWorkOrderDocument, options);
      }
export type UpdateDailyFormWorkOrderMutationHookResult = ReturnType<typeof useUpdateDailyFormWorkOrderMutation>;
export type UpdateDailyFormWorkOrderMutationResult = Apollo.MutationResult<UpdateDailyFormWorkOrderMutation>;
export type UpdateDailyFormWorkOrderMutationOptions = Apollo.BaseMutationOptions<UpdateDailyFormWorkOrderMutation, UpdateDailyFormWorkOrderMutationVariables>;
export const UpdateDailyFormWorkOrderStatusDocument = gql`
    mutation updateDailyFormWorkOrderStatus($input: UpdateDailyFormWorkOrderStatusInput!) {
  updateDailyFormWorkOrderStatus(input: $input) {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    comments
    completedAt
    createdAt
    currentMeterReading
    estimatedTaskTime
    files {
      dailyFormWorkOrder {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        comments
        completedAt
        createdAt
        currentMeterReading
        estimatedTaskTime
        files {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        issueDescription
        issueName
        issueType
        neededCompletionDate
        priority
        servicePlan {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
      }
      id
      name
      path
    }
    id
    issueDescription
    issueName
    issueType
    neededCompletionDate
    priority
    servicePlan {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    vehicle {
      currentMeterReading
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      registrationExpirationDate
      registrationState
      vin
      year
    }
  }
}
    `;
export type UpdateDailyFormWorkOrderStatusMutationFn = Apollo.MutationFunction<UpdateDailyFormWorkOrderStatusMutation, UpdateDailyFormWorkOrderStatusMutationVariables>;

/**
 * __useUpdateDailyFormWorkOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDailyFormWorkOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyFormWorkOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyFormWorkOrderStatusMutation, { data, loading, error }] = useUpdateDailyFormWorkOrderStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyFormWorkOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyFormWorkOrderStatusMutation, UpdateDailyFormWorkOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyFormWorkOrderStatusMutation, UpdateDailyFormWorkOrderStatusMutationVariables>(UpdateDailyFormWorkOrderStatusDocument, options);
      }
export type UpdateDailyFormWorkOrderStatusMutationHookResult = ReturnType<typeof useUpdateDailyFormWorkOrderStatusMutation>;
export type UpdateDailyFormWorkOrderStatusMutationResult = Apollo.MutationResult<UpdateDailyFormWorkOrderStatusMutation>;
export type UpdateDailyFormWorkOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDailyFormWorkOrderStatusMutation, UpdateDailyFormWorkOrderStatusMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation updateEmployee($input: UpdateEmployeeInput!) {
  updateEmployee(input: $input) {
    archivedAt
    firstName
    id
    lastName
    name
    organizationId
    rate
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const UpdateEquipmentPieceDocument = gql`
    mutation updateEquipmentPiece($input: UpdateEquipmentPieceInput!) {
  updateEquipmentPiece(input: $input) {
    calculateTravelTime
    chargeType
    fuelSurcharge
    id
    name
    rate
    usePercentage
  }
}
    `;
export type UpdateEquipmentPieceMutationFn = Apollo.MutationFunction<UpdateEquipmentPieceMutation, UpdateEquipmentPieceMutationVariables>;

/**
 * __useUpdateEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentPieceMutation, { data, loading, error }] = useUpdateEquipmentPieceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentPieceMutation, UpdateEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentPieceMutation, UpdateEquipmentPieceMutationVariables>(UpdateEquipmentPieceDocument, options);
      }
export type UpdateEquipmentPieceMutationHookResult = ReturnType<typeof useUpdateEquipmentPieceMutation>;
export type UpdateEquipmentPieceMutationResult = Apollo.MutationResult<UpdateEquipmentPieceMutation>;
export type UpdateEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentPieceMutation, UpdateEquipmentPieceMutationVariables>;
export const UpdateJobBillingStatusDocument = gql`
    mutation updateJobBillingStatus($billingStatus: JobBillingStatus!, $id: ID!) {
  updateJobBillingStatus(billingStatus: $billingStatus, id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type UpdateJobBillingStatusMutationFn = Apollo.MutationFunction<UpdateJobBillingStatusMutation, UpdateJobBillingStatusMutationVariables>;

/**
 * __useUpdateJobBillingStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobBillingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobBillingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobBillingStatusMutation, { data, loading, error }] = useUpdateJobBillingStatusMutation({
 *   variables: {
 *      billingStatus: // value for 'billingStatus'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateJobBillingStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobBillingStatusMutation, UpdateJobBillingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobBillingStatusMutation, UpdateJobBillingStatusMutationVariables>(UpdateJobBillingStatusDocument, options);
      }
export type UpdateJobBillingStatusMutationHookResult = ReturnType<typeof useUpdateJobBillingStatusMutation>;
export type UpdateJobBillingStatusMutationResult = Apollo.MutationResult<UpdateJobBillingStatusMutation>;
export type UpdateJobBillingStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJobBillingStatusMutation, UpdateJobBillingStatusMutationVariables>;
export const UpdateJobChecklistItemsDocument = gql`
    mutation updateJobChecklistItems($input: UpdateJobChecklistItemsInput!) {
  updateJobChecklistItems(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type UpdateJobChecklistItemsMutationFn = Apollo.MutationFunction<UpdateJobChecklistItemsMutation, UpdateJobChecklistItemsMutationVariables>;

/**
 * __useUpdateJobChecklistItemsMutation__
 *
 * To run a mutation, you first call `useUpdateJobChecklistItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobChecklistItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobChecklistItemsMutation, { data, loading, error }] = useUpdateJobChecklistItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobChecklistItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobChecklistItemsMutation, UpdateJobChecklistItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobChecklistItemsMutation, UpdateJobChecklistItemsMutationVariables>(UpdateJobChecklistItemsDocument, options);
      }
export type UpdateJobChecklistItemsMutationHookResult = ReturnType<typeof useUpdateJobChecklistItemsMutation>;
export type UpdateJobChecklistItemsMutationResult = Apollo.MutationResult<UpdateJobChecklistItemsMutation>;
export type UpdateJobChecklistItemsMutationOptions = Apollo.BaseMutationOptions<UpdateJobChecklistItemsMutation, UpdateJobChecklistItemsMutationVariables>;
export const UpdateJobExternalIdDocument = gql`
    mutation updateJobExternalId($externalId: String!, $id: ID!) {
  updateJobExternalId(externalId: $externalId, id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type UpdateJobExternalIdMutationFn = Apollo.MutationFunction<UpdateJobExternalIdMutation, UpdateJobExternalIdMutationVariables>;

/**
 * __useUpdateJobExternalIdMutation__
 *
 * To run a mutation, you first call `useUpdateJobExternalIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobExternalIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobExternalIdMutation, { data, loading, error }] = useUpdateJobExternalIdMutation({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateJobExternalIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobExternalIdMutation, UpdateJobExternalIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobExternalIdMutation, UpdateJobExternalIdMutationVariables>(UpdateJobExternalIdDocument, options);
      }
export type UpdateJobExternalIdMutationHookResult = ReturnType<typeof useUpdateJobExternalIdMutation>;
export type UpdateJobExternalIdMutationResult = Apollo.MutationResult<UpdateJobExternalIdMutation>;
export type UpdateJobExternalIdMutationOptions = Apollo.BaseMutationOptions<UpdateJobExternalIdMutation, UpdateJobExternalIdMutationVariables>;
export const UpdateJobNotesDocument = gql`
    mutation updateJobNotes($id: ID!, $notes: String!) {
  updateJobNotes(id: $id, notes: $notes) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type UpdateJobNotesMutationFn = Apollo.MutationFunction<UpdateJobNotesMutation, UpdateJobNotesMutationVariables>;

/**
 * __useUpdateJobNotesMutation__
 *
 * To run a mutation, you first call `useUpdateJobNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobNotesMutation, { data, loading, error }] = useUpdateJobNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateJobNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobNotesMutation, UpdateJobNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobNotesMutation, UpdateJobNotesMutationVariables>(UpdateJobNotesDocument, options);
      }
export type UpdateJobNotesMutationHookResult = ReturnType<typeof useUpdateJobNotesMutation>;
export type UpdateJobNotesMutationResult = Apollo.MutationResult<UpdateJobNotesMutation>;
export type UpdateJobNotesMutationOptions = Apollo.BaseMutationOptions<UpdateJobNotesMutation, UpdateJobNotesMutationVariables>;
export const UpdateJobPhaseChecklistItemsDocument = gql`
    mutation updateJobPhaseChecklistItems($input: UpdateJobPhaseChecklistItemsInput!) {
  updateJobPhaseChecklistItems(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    actualSubcontractorCost
    actualSubcontractorName
    actualSubcontractorReference
    address
    applicableStatuses
    checklistCompletion {
      allCompleted
      ratio
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    checklistNotes
    costItems {
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      id
      plantId
      plantProductId
    }
    costingMode
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      calculateTravelTime
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    hasJobCostsEntered
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      id
      invoiceId
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    jobCostEntryDaysCount
    jobCostingCompletionStatus
    jobCostingThresholdPercent
    jobCostingVariancePercent
    jobDuration
    jobPhaseMaterialNoPlants {
      cost
      id
      jobPhaseId
      name
      percentage
      quantity
      rate
    }
    jobPhasePlant {
      id
      materialNeeded
      name
      rate
      type
    }
    jobPhasePlants {
      id
      materialNeeded
      name
      rate
      type
    }
    jobSize
    lastJobCostEntryDate
    missingCostCategories
    notes
    ordering
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      showIndividualProducts
    }
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      proposalPlantProductId
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;
export type UpdateJobPhaseChecklistItemsMutationFn = Apollo.MutationFunction<UpdateJobPhaseChecklistItemsMutation, UpdateJobPhaseChecklistItemsMutationVariables>;

/**
 * __useUpdateJobPhaseChecklistItemsMutation__
 *
 * To run a mutation, you first call `useUpdateJobPhaseChecklistItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPhaseChecklistItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPhaseChecklistItemsMutation, { data, loading, error }] = useUpdateJobPhaseChecklistItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobPhaseChecklistItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPhaseChecklistItemsMutation, UpdateJobPhaseChecklistItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPhaseChecklistItemsMutation, UpdateJobPhaseChecklistItemsMutationVariables>(UpdateJobPhaseChecklistItemsDocument, options);
      }
export type UpdateJobPhaseChecklistItemsMutationHookResult = ReturnType<typeof useUpdateJobPhaseChecklistItemsMutation>;
export type UpdateJobPhaseChecklistItemsMutationResult = Apollo.MutationResult<UpdateJobPhaseChecklistItemsMutation>;
export type UpdateJobPhaseChecklistItemsMutationOptions = Apollo.BaseMutationOptions<UpdateJobPhaseChecklistItemsMutation, UpdateJobPhaseChecklistItemsMutationVariables>;
export const UpdateJobPhaseCostingDocument = gql`
    mutation updateJobPhaseCosting($input: UpdateJobPhaseCostingInput!) {
  updateJobPhaseCosting(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    actualSubcontractorCost
    actualSubcontractorName
    actualSubcontractorReference
    address
    applicableStatuses
    checklistCompletion {
      allCompleted
      ratio
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    checklistNotes
    costItems {
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      id
      plantId
      plantProductId
    }
    costingMode
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      calculateTravelTime
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    hasJobCostsEntered
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      id
      invoiceId
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    jobCostEntryDaysCount
    jobCostingCompletionStatus
    jobCostingThresholdPercent
    jobCostingVariancePercent
    jobDuration
    jobPhaseMaterialNoPlants {
      cost
      id
      jobPhaseId
      name
      percentage
      quantity
      rate
    }
    jobPhasePlant {
      id
      materialNeeded
      name
      rate
      type
    }
    jobPhasePlants {
      id
      materialNeeded
      name
      rate
      type
    }
    jobSize
    lastJobCostEntryDate
    missingCostCategories
    notes
    ordering
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      showIndividualProducts
    }
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      proposalPlantProductId
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;
export type UpdateJobPhaseCostingMutationFn = Apollo.MutationFunction<UpdateJobPhaseCostingMutation, UpdateJobPhaseCostingMutationVariables>;

/**
 * __useUpdateJobPhaseCostingMutation__
 *
 * To run a mutation, you first call `useUpdateJobPhaseCostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPhaseCostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPhaseCostingMutation, { data, loading, error }] = useUpdateJobPhaseCostingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobPhaseCostingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPhaseCostingMutation, UpdateJobPhaseCostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPhaseCostingMutation, UpdateJobPhaseCostingMutationVariables>(UpdateJobPhaseCostingDocument, options);
      }
export type UpdateJobPhaseCostingMutationHookResult = ReturnType<typeof useUpdateJobPhaseCostingMutation>;
export type UpdateJobPhaseCostingMutationResult = Apollo.MutationResult<UpdateJobPhaseCostingMutation>;
export type UpdateJobPhaseCostingMutationOptions = Apollo.BaseMutationOptions<UpdateJobPhaseCostingMutation, UpdateJobPhaseCostingMutationVariables>;
export const UpdateJobPhaseNotesDocument = gql`
    mutation updateJobPhaseNotes($input: UpdateJobPhaseNotesInput!) {
  updateJobPhaseNotes(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    actualSubcontractorCost
    actualSubcontractorName
    actualSubcontractorReference
    address
    applicableStatuses
    checklistCompletion {
      allCompleted
      ratio
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    checklistNotes
    costItems {
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      id
      plantId
      plantProductId
    }
    costingMode
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      calculateTravelTime
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    hasJobCostsEntered
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      id
      invoiceId
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    jobCostEntryDaysCount
    jobCostingCompletionStatus
    jobCostingThresholdPercent
    jobCostingVariancePercent
    jobDuration
    jobPhaseMaterialNoPlants {
      cost
      id
      jobPhaseId
      name
      percentage
      quantity
      rate
    }
    jobPhasePlant {
      id
      materialNeeded
      name
      rate
      type
    }
    jobPhasePlants {
      id
      materialNeeded
      name
      rate
      type
    }
    jobSize
    lastJobCostEntryDate
    missingCostCategories
    notes
    ordering
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      showIndividualProducts
    }
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      proposalPlantProductId
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;
export type UpdateJobPhaseNotesMutationFn = Apollo.MutationFunction<UpdateJobPhaseNotesMutation, UpdateJobPhaseNotesMutationVariables>;

/**
 * __useUpdateJobPhaseNotesMutation__
 *
 * To run a mutation, you first call `useUpdateJobPhaseNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPhaseNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPhaseNotesMutation, { data, loading, error }] = useUpdateJobPhaseNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobPhaseNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPhaseNotesMutation, UpdateJobPhaseNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPhaseNotesMutation, UpdateJobPhaseNotesMutationVariables>(UpdateJobPhaseNotesDocument, options);
      }
export type UpdateJobPhaseNotesMutationHookResult = ReturnType<typeof useUpdateJobPhaseNotesMutation>;
export type UpdateJobPhaseNotesMutationResult = Apollo.MutationResult<UpdateJobPhaseNotesMutation>;
export type UpdateJobPhaseNotesMutationOptions = Apollo.BaseMutationOptions<UpdateJobPhaseNotesMutation, UpdateJobPhaseNotesMutationVariables>;
export const UpdateJobPhaseStatusDocument = gql`
    mutation updateJobPhaseStatus($id: ID!, $status: JobPhaseStatus!) {
  updateJobPhaseStatus(id: $id, status: $status) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    actualSubcontractorCost
    actualSubcontractorName
    actualSubcontractorReference
    address
    applicableStatuses
    checklistCompletion {
      allCompleted
      ratio
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    checklistNotes
    costItems {
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      id
      plantId
      plantProductId
    }
    costingMode
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      calculateTravelTime
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    hasJobCostsEntered
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      id
      invoiceId
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    jobCostEntryDaysCount
    jobCostingCompletionStatus
    jobCostingThresholdPercent
    jobCostingVariancePercent
    jobDuration
    jobPhaseMaterialNoPlants {
      cost
      id
      jobPhaseId
      name
      percentage
      quantity
      rate
    }
    jobPhasePlant {
      id
      materialNeeded
      name
      rate
      type
    }
    jobPhasePlants {
      id
      materialNeeded
      name
      rate
      type
    }
    jobSize
    lastJobCostEntryDate
    missingCostCategories
    notes
    ordering
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      showIndividualProducts
    }
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      proposalPlantProductId
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;
export type UpdateJobPhaseStatusMutationFn = Apollo.MutationFunction<UpdateJobPhaseStatusMutation, UpdateJobPhaseStatusMutationVariables>;

/**
 * __useUpdateJobPhaseStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobPhaseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPhaseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPhaseStatusMutation, { data, loading, error }] = useUpdateJobPhaseStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateJobPhaseStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPhaseStatusMutation, UpdateJobPhaseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPhaseStatusMutation, UpdateJobPhaseStatusMutationVariables>(UpdateJobPhaseStatusDocument, options);
      }
export type UpdateJobPhaseStatusMutationHookResult = ReturnType<typeof useUpdateJobPhaseStatusMutation>;
export type UpdateJobPhaseStatusMutationResult = Apollo.MutationResult<UpdateJobPhaseStatusMutation>;
export type UpdateJobPhaseStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJobPhaseStatusMutation, UpdateJobPhaseStatusMutationVariables>;
export const UpdateJobProjectFileFolderIdDocument = gql`
    mutation updateJobProjectFileFolderId($id: ID!, $projectFilesFolderId: ID) {
  updateJobProjectFileFolderId(
    id: $id
    projectFilesFolderId: $projectFilesFolderId
  ) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type UpdateJobProjectFileFolderIdMutationFn = Apollo.MutationFunction<UpdateJobProjectFileFolderIdMutation, UpdateJobProjectFileFolderIdMutationVariables>;

/**
 * __useUpdateJobProjectFileFolderIdMutation__
 *
 * To run a mutation, you first call `useUpdateJobProjectFileFolderIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobProjectFileFolderIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobProjectFileFolderIdMutation, { data, loading, error }] = useUpdateJobProjectFileFolderIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectFilesFolderId: // value for 'projectFilesFolderId'
 *   },
 * });
 */
export function useUpdateJobProjectFileFolderIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobProjectFileFolderIdMutation, UpdateJobProjectFileFolderIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobProjectFileFolderIdMutation, UpdateJobProjectFileFolderIdMutationVariables>(UpdateJobProjectFileFolderIdDocument, options);
      }
export type UpdateJobProjectFileFolderIdMutationHookResult = ReturnType<typeof useUpdateJobProjectFileFolderIdMutation>;
export type UpdateJobProjectFileFolderIdMutationResult = Apollo.MutationResult<UpdateJobProjectFileFolderIdMutation>;
export type UpdateJobProjectFileFolderIdMutationOptions = Apollo.BaseMutationOptions<UpdateJobProjectFileFolderIdMutation, UpdateJobProjectFileFolderIdMutationVariables>;
export const UpdateJobProjectManagerDocument = gql`
    mutation updateJobProjectManager($id: ID!, $userId: ID!) {
  updateJobProjectManager(id: $id, userId: $userId) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type UpdateJobProjectManagerMutationFn = Apollo.MutationFunction<UpdateJobProjectManagerMutation, UpdateJobProjectManagerMutationVariables>;

/**
 * __useUpdateJobProjectManagerMutation__
 *
 * To run a mutation, you first call `useUpdateJobProjectManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobProjectManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobProjectManagerMutation, { data, loading, error }] = useUpdateJobProjectManagerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateJobProjectManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobProjectManagerMutation, UpdateJobProjectManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobProjectManagerMutation, UpdateJobProjectManagerMutationVariables>(UpdateJobProjectManagerDocument, options);
      }
export type UpdateJobProjectManagerMutationHookResult = ReturnType<typeof useUpdateJobProjectManagerMutation>;
export type UpdateJobProjectManagerMutationResult = Apollo.MutationResult<UpdateJobProjectManagerMutation>;
export type UpdateJobProjectManagerMutationOptions = Apollo.BaseMutationOptions<UpdateJobProjectManagerMutation, UpdateJobProjectManagerMutationVariables>;
export const UpdateJobStatusDocument = gql`
    mutation updateJobStatus($id: ID!, $status: JobStatus!) {
  updateJobStatus(id: $id, status: $status) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;
export type UpdateJobStatusMutationFn = Apollo.MutationFunction<UpdateJobStatusMutation, UpdateJobStatusMutationVariables>;

/**
 * __useUpdateJobStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobStatusMutation, { data, loading, error }] = useUpdateJobStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateJobStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobStatusMutation, UpdateJobStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobStatusMutation, UpdateJobStatusMutationVariables>(UpdateJobStatusDocument, options);
      }
export type UpdateJobStatusMutationHookResult = ReturnType<typeof useUpdateJobStatusMutation>;
export type UpdateJobStatusMutationResult = Apollo.MutationResult<UpdateJobStatusMutation>;
export type UpdateJobStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJobStatusMutation, UpdateJobStatusMutationVariables>;
export const UpdateNotificationTriggerDocument = gql`
    mutation updateNotificationTrigger($input: UpdateNotificationTriggerInput!) {
  updateNotificationTrigger(input: $input) {
    active
    additionalRecipientTypes
    additionalRecipients {
      email
      firstName
      id
      isTask
      lastName
      taskContent
    }
    apiHeaders
    apiMethod
    apiPayload
    apiSecret
    apiUrl
    content
    delay
    emailSubject
    event
    id
    isApi
    isEmail
    isSMS
    isTask
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    sendToAllRecipients
    sendToContact
    sendToUser
    smsContent
    taskContent
    type
  }
}
    `;
export type UpdateNotificationTriggerMutationFn = Apollo.MutationFunction<UpdateNotificationTriggerMutation, UpdateNotificationTriggerMutationVariables>;

/**
 * __useUpdateNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationTriggerMutation, { data, loading, error }] = useUpdateNotificationTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationTriggerMutation, UpdateNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationTriggerMutation, UpdateNotificationTriggerMutationVariables>(UpdateNotificationTriggerDocument, options);
      }
export type UpdateNotificationTriggerMutationHookResult = ReturnType<typeof useUpdateNotificationTriggerMutation>;
export type UpdateNotificationTriggerMutationResult = Apollo.MutationResult<UpdateNotificationTriggerMutation>;
export type UpdateNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationTriggerMutation, UpdateNotificationTriggerMutationVariables>;
export const UpdateOpportunityDocument = gql`
    mutation updateOpportunity($input: UpdateOpportunityInput!) {
  updateOpportunity(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;
export type UpdateOpportunityMutationFn = Apollo.MutationFunction<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;

/**
 * __useUpdateOpportunityMutation__
 *
 * To run a mutation, you first call `useUpdateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpportunityMutation, { data, loading, error }] = useUpdateOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>(UpdateOpportunityDocument, options);
      }
export type UpdateOpportunityMutationHookResult = ReturnType<typeof useUpdateOpportunityMutation>;
export type UpdateOpportunityMutationResult = Apollo.MutationResult<UpdateOpportunityMutation>;
export type UpdateOpportunityMutationOptions = Apollo.BaseMutationOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;
export const UpdateOpportunityStatusDocument = gql`
    mutation updateOpportunityStatus($id: ID!, $statusId: ID!) {
  updateOpportunityStatus(id: $id, statusId: $statusId) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;
export type UpdateOpportunityStatusMutationFn = Apollo.MutationFunction<UpdateOpportunityStatusMutation, UpdateOpportunityStatusMutationVariables>;

/**
 * __useUpdateOpportunityStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOpportunityStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpportunityStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpportunityStatusMutation, { data, loading, error }] = useUpdateOpportunityStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useUpdateOpportunityStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpportunityStatusMutation, UpdateOpportunityStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpportunityStatusMutation, UpdateOpportunityStatusMutationVariables>(UpdateOpportunityStatusDocument, options);
      }
export type UpdateOpportunityStatusMutationHookResult = ReturnType<typeof useUpdateOpportunityStatusMutation>;
export type UpdateOpportunityStatusMutationResult = Apollo.MutationResult<UpdateOpportunityStatusMutation>;
export type UpdateOpportunityStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOpportunityStatusMutation, UpdateOpportunityStatusMutationVariables>;
export const UpdateOpportunityStatusesOrderingDocument = gql`
    mutation updateOpportunityStatusesOrdering($statuses: [OpportunityStatusOrderingInput!]!) {
  updateOpportunityStatusesOrdering(statuses: $statuses) {
    id
    name
    ordering
  }
}
    `;
export type UpdateOpportunityStatusesOrderingMutationFn = Apollo.MutationFunction<UpdateOpportunityStatusesOrderingMutation, UpdateOpportunityStatusesOrderingMutationVariables>;

/**
 * __useUpdateOpportunityStatusesOrderingMutation__
 *
 * To run a mutation, you first call `useUpdateOpportunityStatusesOrderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpportunityStatusesOrderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpportunityStatusesOrderingMutation, { data, loading, error }] = useUpdateOpportunityStatusesOrderingMutation({
 *   variables: {
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useUpdateOpportunityStatusesOrderingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpportunityStatusesOrderingMutation, UpdateOpportunityStatusesOrderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpportunityStatusesOrderingMutation, UpdateOpportunityStatusesOrderingMutationVariables>(UpdateOpportunityStatusesOrderingDocument, options);
      }
export type UpdateOpportunityStatusesOrderingMutationHookResult = ReturnType<typeof useUpdateOpportunityStatusesOrderingMutation>;
export type UpdateOpportunityStatusesOrderingMutationResult = Apollo.MutationResult<UpdateOpportunityStatusesOrderingMutation>;
export type UpdateOpportunityStatusesOrderingMutationOptions = Apollo.BaseMutationOptions<UpdateOpportunityStatusesOrderingMutation, UpdateOpportunityStatusesOrderingMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    canMapWithAi
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    invoiceEmailText
    invoicingPaymentTermsNet
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    organizationSalesGoal
    phone
    proposalDefaults {
      autoSave
      color
      defaultLoadingTimeMins
      defaultTransferTruckId
      defaultUnloadTimeMins
      estimateTruckingByFullDay
      id
      idPrefix
      layout
      maxTripNumberPerTruck
      minimumProfitPerDay
      multiplyTravelTimeByDay
      multiplyTravelTimeForEquipmentLabour
      optionalCheckboxDefaultChecked
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      roundUpToNearestDollarAmount
      startingNumber
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationAddressDocument = gql`
    mutation updateOrganizationAddress($input: UpdateOrganizationAddressInput!) {
  updateOrganizationAddress(input: $input) {
    city
    country
    id
    isPrimary
    latitude
    line1
    line2
    longitude
    state
    zip
  }
}
    `;
export type UpdateOrganizationAddressMutationFn = Apollo.MutationFunction<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>;

/**
 * __useUpdateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAddressMutation, { data, loading, error }] = useUpdateOrganizationAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>(UpdateOrganizationAddressDocument, options);
      }
export type UpdateOrganizationAddressMutationHookResult = ReturnType<typeof useUpdateOrganizationAddressMutation>;
export type UpdateOrganizationAddressMutationResult = Apollo.MutationResult<UpdateOrganizationAddressMutation>;
export type UpdateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>;
export const UpdateOrganizationAddressPrimaryDocument = gql`
    mutation updateOrganizationAddressPrimary($id: ID!) {
  updateOrganizationAddressPrimary(id: $id)
}
    `;
export type UpdateOrganizationAddressPrimaryMutationFn = Apollo.MutationFunction<UpdateOrganizationAddressPrimaryMutation, UpdateOrganizationAddressPrimaryMutationVariables>;

/**
 * __useUpdateOrganizationAddressPrimaryMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAddressPrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAddressPrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAddressPrimaryMutation, { data, loading, error }] = useUpdateOrganizationAddressPrimaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOrganizationAddressPrimaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAddressPrimaryMutation, UpdateOrganizationAddressPrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAddressPrimaryMutation, UpdateOrganizationAddressPrimaryMutationVariables>(UpdateOrganizationAddressPrimaryDocument, options);
      }
export type UpdateOrganizationAddressPrimaryMutationHookResult = ReturnType<typeof useUpdateOrganizationAddressPrimaryMutation>;
export type UpdateOrganizationAddressPrimaryMutationResult = Apollo.MutationResult<UpdateOrganizationAddressPrimaryMutation>;
export type UpdateOrganizationAddressPrimaryMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAddressPrimaryMutation, UpdateOrganizationAddressPrimaryMutationVariables>;
export const UpdateOrganizationConversionFactorOverrideDocument = gql`
    mutation updateOrganizationConversionFactorOverride($input: UpdateOrganizationConversionFactorOverrideInput!) {
  updateOrganizationConversionFactorOverride(input: $input) {
    asphaltTonConversionFactorOverride
    excavateOutTonConversionFactorOverride
    id
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;
export type UpdateOrganizationConversionFactorOverrideMutationFn = Apollo.MutationFunction<UpdateOrganizationConversionFactorOverrideMutation, UpdateOrganizationConversionFactorOverrideMutationVariables>;

/**
 * __useUpdateOrganizationConversionFactorOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationConversionFactorOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationConversionFactorOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationConversionFactorOverrideMutation, { data, loading, error }] = useUpdateOrganizationConversionFactorOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationConversionFactorOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationConversionFactorOverrideMutation, UpdateOrganizationConversionFactorOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationConversionFactorOverrideMutation, UpdateOrganizationConversionFactorOverrideMutationVariables>(UpdateOrganizationConversionFactorOverrideDocument, options);
      }
export type UpdateOrganizationConversionFactorOverrideMutationHookResult = ReturnType<typeof useUpdateOrganizationConversionFactorOverrideMutation>;
export type UpdateOrganizationConversionFactorOverrideMutationResult = Apollo.MutationResult<UpdateOrganizationConversionFactorOverrideMutation>;
export type UpdateOrganizationConversionFactorOverrideMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationConversionFactorOverrideMutation, UpdateOrganizationConversionFactorOverrideMutationVariables>;
export const UpdateOrganizationEmailTemplateDocument = gql`
    mutation updateOrganizationEmailTemplate($html: String, $type: OrganizationEmailTemplateType!) {
  updateOrganizationEmailTemplate(html: $html, type: $type)
}
    `;
export type UpdateOrganizationEmailTemplateMutationFn = Apollo.MutationFunction<UpdateOrganizationEmailTemplateMutation, UpdateOrganizationEmailTemplateMutationVariables>;

/**
 * __useUpdateOrganizationEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationEmailTemplateMutation, { data, loading, error }] = useUpdateOrganizationEmailTemplateMutation({
 *   variables: {
 *      html: // value for 'html'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateOrganizationEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationEmailTemplateMutation, UpdateOrganizationEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationEmailTemplateMutation, UpdateOrganizationEmailTemplateMutationVariables>(UpdateOrganizationEmailTemplateDocument, options);
      }
export type UpdateOrganizationEmailTemplateMutationHookResult = ReturnType<typeof useUpdateOrganizationEmailTemplateMutation>;
export type UpdateOrganizationEmailTemplateMutationResult = Apollo.MutationResult<UpdateOrganizationEmailTemplateMutation>;
export type UpdateOrganizationEmailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationEmailTemplateMutation, UpdateOrganizationEmailTemplateMutationVariables>;
export const UpdateOrganizationInvoiceEmailTextDocument = gql`
    mutation updateOrganizationInvoiceEmailText($id: ID!, $text: String!) {
  updateOrganizationInvoiceEmailText(id: $id, text: $text) {
    canMapWithAi
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    invoiceEmailText
    invoicingPaymentTermsNet
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    organizationSalesGoal
    phone
    proposalDefaults {
      autoSave
      color
      defaultLoadingTimeMins
      defaultTransferTruckId
      defaultUnloadTimeMins
      estimateTruckingByFullDay
      id
      idPrefix
      layout
      maxTripNumberPerTruck
      minimumProfitPerDay
      multiplyTravelTimeByDay
      multiplyTravelTimeForEquipmentLabour
      optionalCheckboxDefaultChecked
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      roundUpToNearestDollarAmount
      startingNumber
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type UpdateOrganizationInvoiceEmailTextMutationFn = Apollo.MutationFunction<UpdateOrganizationInvoiceEmailTextMutation, UpdateOrganizationInvoiceEmailTextMutationVariables>;

/**
 * __useUpdateOrganizationInvoiceEmailTextMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationInvoiceEmailTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationInvoiceEmailTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationInvoiceEmailTextMutation, { data, loading, error }] = useUpdateOrganizationInvoiceEmailTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateOrganizationInvoiceEmailTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationInvoiceEmailTextMutation, UpdateOrganizationInvoiceEmailTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationInvoiceEmailTextMutation, UpdateOrganizationInvoiceEmailTextMutationVariables>(UpdateOrganizationInvoiceEmailTextDocument, options);
      }
export type UpdateOrganizationInvoiceEmailTextMutationHookResult = ReturnType<typeof useUpdateOrganizationInvoiceEmailTextMutation>;
export type UpdateOrganizationInvoiceEmailTextMutationResult = Apollo.MutationResult<UpdateOrganizationInvoiceEmailTextMutation>;
export type UpdateOrganizationInvoiceEmailTextMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationInvoiceEmailTextMutation, UpdateOrganizationInvoiceEmailTextMutationVariables>;
export const UpdateOrganizationInvoicingPaymentTermsNetDocument = gql`
    mutation updateOrganizationInvoicingPaymentTermsNet($id: ID!, $invoicingPaymentTermsNet: Int!) {
  updateOrganizationInvoicingPaymentTermsNet(
    id: $id
    invoicingPaymentTermsNet: $invoicingPaymentTermsNet
  ) {
    canMapWithAi
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    invoiceEmailText
    invoicingPaymentTermsNet
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    organizationSalesGoal
    phone
    proposalDefaults {
      autoSave
      color
      defaultLoadingTimeMins
      defaultTransferTruckId
      defaultUnloadTimeMins
      estimateTruckingByFullDay
      id
      idPrefix
      layout
      maxTripNumberPerTruck
      minimumProfitPerDay
      multiplyTravelTimeByDay
      multiplyTravelTimeForEquipmentLabour
      optionalCheckboxDefaultChecked
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      roundUpToNearestDollarAmount
      startingNumber
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type UpdateOrganizationInvoicingPaymentTermsNetMutationFn = Apollo.MutationFunction<UpdateOrganizationInvoicingPaymentTermsNetMutation, UpdateOrganizationInvoicingPaymentTermsNetMutationVariables>;

/**
 * __useUpdateOrganizationInvoicingPaymentTermsNetMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationInvoicingPaymentTermsNetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationInvoicingPaymentTermsNetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationInvoicingPaymentTermsNetMutation, { data, loading, error }] = useUpdateOrganizationInvoicingPaymentTermsNetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      invoicingPaymentTermsNet: // value for 'invoicingPaymentTermsNet'
 *   },
 * });
 */
export function useUpdateOrganizationInvoicingPaymentTermsNetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationInvoicingPaymentTermsNetMutation, UpdateOrganizationInvoicingPaymentTermsNetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationInvoicingPaymentTermsNetMutation, UpdateOrganizationInvoicingPaymentTermsNetMutationVariables>(UpdateOrganizationInvoicingPaymentTermsNetDocument, options);
      }
export type UpdateOrganizationInvoicingPaymentTermsNetMutationHookResult = ReturnType<typeof useUpdateOrganizationInvoicingPaymentTermsNetMutation>;
export type UpdateOrganizationInvoicingPaymentTermsNetMutationResult = Apollo.MutationResult<UpdateOrganizationInvoicingPaymentTermsNetMutation>;
export type UpdateOrganizationInvoicingPaymentTermsNetMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationInvoicingPaymentTermsNetMutation, UpdateOrganizationInvoicingPaymentTermsNetMutationVariables>;
export const UpdateOrganizationProductTypeDocument = gql`
    mutation updateOrganizationProductType($input: UpdateOrganizationProductTypeInput!) {
  updateOrganizationProductType(input: $input) {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
}
    `;
export type UpdateOrganizationProductTypeMutationFn = Apollo.MutationFunction<UpdateOrganizationProductTypeMutation, UpdateOrganizationProductTypeMutationVariables>;

/**
 * __useUpdateOrganizationProductTypeMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProductTypeMutation, { data, loading, error }] = useUpdateOrganizationProductTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProductTypeMutation, UpdateOrganizationProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProductTypeMutation, UpdateOrganizationProductTypeMutationVariables>(UpdateOrganizationProductTypeDocument, options);
      }
export type UpdateOrganizationProductTypeMutationHookResult = ReturnType<typeof useUpdateOrganizationProductTypeMutation>;
export type UpdateOrganizationProductTypeMutationResult = Apollo.MutationResult<UpdateOrganizationProductTypeMutation>;
export type UpdateOrganizationProductTypeMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProductTypeMutation, UpdateOrganizationProductTypeMutationVariables>;
export const UpdateOrganizationProposalChecklistItemDocument = gql`
    mutation updateOrganizationProposalChecklistItem($id: ID!, $name: String!) {
  updateOrganizationProposalChecklistItem(id: $id, name: $name) {
    id
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;
export type UpdateOrganizationProposalChecklistItemMutationFn = Apollo.MutationFunction<UpdateOrganizationProposalChecklistItemMutation, UpdateOrganizationProposalChecklistItemMutationVariables>;

/**
 * __useUpdateOrganizationProposalChecklistItemMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProposalChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProposalChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProposalChecklistItemMutation, { data, loading, error }] = useUpdateOrganizationProposalChecklistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOrganizationProposalChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProposalChecklistItemMutation, UpdateOrganizationProposalChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProposalChecklistItemMutation, UpdateOrganizationProposalChecklistItemMutationVariables>(UpdateOrganizationProposalChecklistItemDocument, options);
      }
export type UpdateOrganizationProposalChecklistItemMutationHookResult = ReturnType<typeof useUpdateOrganizationProposalChecklistItemMutation>;
export type UpdateOrganizationProposalChecklistItemMutationResult = Apollo.MutationResult<UpdateOrganizationProposalChecklistItemMutation>;
export type UpdateOrganizationProposalChecklistItemMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProposalChecklistItemMutation, UpdateOrganizationProposalChecklistItemMutationVariables>;
export const UpdateOrganizationProposalContentDocument = gql`
    mutation updateOrganizationProposalContent($content: String!, $type: String!) {
  updateOrganizationProposalContent(content: $content, type: $type) {
    content
    id
    type
  }
}
    `;
export type UpdateOrganizationProposalContentMutationFn = Apollo.MutationFunction<UpdateOrganizationProposalContentMutation, UpdateOrganizationProposalContentMutationVariables>;

/**
 * __useUpdateOrganizationProposalContentMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProposalContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProposalContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProposalContentMutation, { data, loading, error }] = useUpdateOrganizationProposalContentMutation({
 *   variables: {
 *      content: // value for 'content'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateOrganizationProposalContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProposalContentMutation, UpdateOrganizationProposalContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProposalContentMutation, UpdateOrganizationProposalContentMutationVariables>(UpdateOrganizationProposalContentDocument, options);
      }
export type UpdateOrganizationProposalContentMutationHookResult = ReturnType<typeof useUpdateOrganizationProposalContentMutation>;
export type UpdateOrganizationProposalContentMutationResult = Apollo.MutationResult<UpdateOrganizationProposalContentMutation>;
export type UpdateOrganizationProposalContentMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProposalContentMutation, UpdateOrganizationProposalContentMutationVariables>;
export const UpdateOrganizationProposalDefaultsDocument = gql`
    mutation updateOrganizationProposalDefaults($input: UpdateOrganizationProposalDefaultsInput!) {
  updateOrganizationProposalDefaults(input: $input) {
    autoSave
    color
    defaultLoadingTimeMins
    defaultTransferTruckId
    defaultUnloadTimeMins
    estimateTruckingByFullDay
    id
    idPrefix
    layout
    maxTripNumberPerTruck
    minimumProfitPerDay
    multiplyTravelTimeByDay
    multiplyTravelTimeForEquipmentLabour
    optionalCheckboxDefaultChecked
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    roundUpToNearestDollarAmount
    startingNumber
  }
}
    `;
export type UpdateOrganizationProposalDefaultsMutationFn = Apollo.MutationFunction<UpdateOrganizationProposalDefaultsMutation, UpdateOrganizationProposalDefaultsMutationVariables>;

/**
 * __useUpdateOrganizationProposalDefaultsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProposalDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProposalDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProposalDefaultsMutation, { data, loading, error }] = useUpdateOrganizationProposalDefaultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationProposalDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProposalDefaultsMutation, UpdateOrganizationProposalDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProposalDefaultsMutation, UpdateOrganizationProposalDefaultsMutationVariables>(UpdateOrganizationProposalDefaultsDocument, options);
      }
export type UpdateOrganizationProposalDefaultsMutationHookResult = ReturnType<typeof useUpdateOrganizationProposalDefaultsMutation>;
export type UpdateOrganizationProposalDefaultsMutationResult = Apollo.MutationResult<UpdateOrganizationProposalDefaultsMutation>;
export type UpdateOrganizationProposalDefaultsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProposalDefaultsMutation, UpdateOrganizationProposalDefaultsMutationVariables>;
export const UpdateOrganizationProposalLayoutContentSettingsDocument = gql`
    mutation updateOrganizationProposalLayoutContentSettings($items: [UpdateProposalLayoutContentSettingItemInput!]!) {
  updateOrganizationProposalLayoutContentSettings(items: $items) {
    contentType
    id
    organizationId
    showOnBranded
    showOnFull
    showOnSimple
    showOnTabular
  }
}
    `;
export type UpdateOrganizationProposalLayoutContentSettingsMutationFn = Apollo.MutationFunction<UpdateOrganizationProposalLayoutContentSettingsMutation, UpdateOrganizationProposalLayoutContentSettingsMutationVariables>;

/**
 * __useUpdateOrganizationProposalLayoutContentSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProposalLayoutContentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProposalLayoutContentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProposalLayoutContentSettingsMutation, { data, loading, error }] = useUpdateOrganizationProposalLayoutContentSettingsMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useUpdateOrganizationProposalLayoutContentSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProposalLayoutContentSettingsMutation, UpdateOrganizationProposalLayoutContentSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProposalLayoutContentSettingsMutation, UpdateOrganizationProposalLayoutContentSettingsMutationVariables>(UpdateOrganizationProposalLayoutContentSettingsDocument, options);
      }
export type UpdateOrganizationProposalLayoutContentSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationProposalLayoutContentSettingsMutation>;
export type UpdateOrganizationProposalLayoutContentSettingsMutationResult = Apollo.MutationResult<UpdateOrganizationProposalLayoutContentSettingsMutation>;
export type UpdateOrganizationProposalLayoutContentSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProposalLayoutContentSettingsMutation, UpdateOrganizationProposalLayoutContentSettingsMutationVariables>;
export const UpdateOrganizationProposalSentEmailTextDocument = gql`
    mutation updateOrganizationProposalSentEmailText($id: ID!, $text: String!) {
  updateOrganizationProposalSentEmailText(id: $id, text: $text) {
    canMapWithAi
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    invoiceEmailText
    invoicingPaymentTermsNet
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    organizationSalesGoal
    phone
    proposalDefaults {
      autoSave
      color
      defaultLoadingTimeMins
      defaultTransferTruckId
      defaultUnloadTimeMins
      estimateTruckingByFullDay
      id
      idPrefix
      layout
      maxTripNumberPerTruck
      minimumProfitPerDay
      multiplyTravelTimeByDay
      multiplyTravelTimeForEquipmentLabour
      optionalCheckboxDefaultChecked
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      roundUpToNearestDollarAmount
      startingNumber
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type UpdateOrganizationProposalSentEmailTextMutationFn = Apollo.MutationFunction<UpdateOrganizationProposalSentEmailTextMutation, UpdateOrganizationProposalSentEmailTextMutationVariables>;

/**
 * __useUpdateOrganizationProposalSentEmailTextMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProposalSentEmailTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProposalSentEmailTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProposalSentEmailTextMutation, { data, loading, error }] = useUpdateOrganizationProposalSentEmailTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateOrganizationProposalSentEmailTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProposalSentEmailTextMutation, UpdateOrganizationProposalSentEmailTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProposalSentEmailTextMutation, UpdateOrganizationProposalSentEmailTextMutationVariables>(UpdateOrganizationProposalSentEmailTextDocument, options);
      }
export type UpdateOrganizationProposalSentEmailTextMutationHookResult = ReturnType<typeof useUpdateOrganizationProposalSentEmailTextMutation>;
export type UpdateOrganizationProposalSentEmailTextMutationResult = Apollo.MutationResult<UpdateOrganizationProposalSentEmailTextMutation>;
export type UpdateOrganizationProposalSentEmailTextMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProposalSentEmailTextMutation, UpdateOrganizationProposalSentEmailTextMutationVariables>;
export const UpdateOrganizationSalesTaxesDocument = gql`
    mutation updateOrganizationSalesTaxes($input: UpdateOrganizationSalesTaxesInput!) {
  updateOrganizationSalesTaxes(input: $input) {
    canMapWithAi
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    invoiceEmailText
    invoicingPaymentTermsNet
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    organizationSalesGoal
    phone
    proposalDefaults {
      autoSave
      color
      defaultLoadingTimeMins
      defaultTransferTruckId
      defaultUnloadTimeMins
      estimateTruckingByFullDay
      id
      idPrefix
      layout
      maxTripNumberPerTruck
      minimumProfitPerDay
      multiplyTravelTimeByDay
      multiplyTravelTimeForEquipmentLabour
      optionalCheckboxDefaultChecked
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      roundUpToNearestDollarAmount
      startingNumber
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type UpdateOrganizationSalesTaxesMutationFn = Apollo.MutationFunction<UpdateOrganizationSalesTaxesMutation, UpdateOrganizationSalesTaxesMutationVariables>;

/**
 * __useUpdateOrganizationSalesTaxesMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSalesTaxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSalesTaxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSalesTaxesMutation, { data, loading, error }] = useUpdateOrganizationSalesTaxesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSalesTaxesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationSalesTaxesMutation, UpdateOrganizationSalesTaxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationSalesTaxesMutation, UpdateOrganizationSalesTaxesMutationVariables>(UpdateOrganizationSalesTaxesDocument, options);
      }
export type UpdateOrganizationSalesTaxesMutationHookResult = ReturnType<typeof useUpdateOrganizationSalesTaxesMutation>;
export type UpdateOrganizationSalesTaxesMutationResult = Apollo.MutationResult<UpdateOrganizationSalesTaxesMutation>;
export type UpdateOrganizationSalesTaxesMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationSalesTaxesMutation, UpdateOrganizationSalesTaxesMutationVariables>;
export const UpdateOrganizationSettingsDocument = gql`
    mutation updateOrganizationSettings($settings: [UpdateOrganizationSettingsInput!]!) {
  updateOrganizationSettings(settings: $settings)
}
    `;
export type UpdateOrganizationSettingsMutationFn = Apollo.MutationFunction<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;

/**
 * __useUpdateOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingsMutation, { data, loading, error }] = useUpdateOrganizationSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateOrganizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>(UpdateOrganizationSettingsDocument, options);
      }
export type UpdateOrganizationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationResult = Apollo.MutationResult<UpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;
export const UpdateOrganizationUserDocument = gql`
    mutation updateOrganizationUser($input: UpdateOrganizationUserInput!) {
  updateOrganizationUser(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    archivedAt
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    salesGoal
    status
  }
}
    `;
export type UpdateOrganizationUserMutationFn = Apollo.MutationFunction<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;

/**
 * __useUpdateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserMutation, { data, loading, error }] = useUpdateOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>(UpdateOrganizationUserDocument, options);
      }
export type UpdateOrganizationUserMutationHookResult = ReturnType<typeof useUpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationResult = Apollo.MutationResult<UpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;
export const UpdatePlantDocument = gql`
    mutation updatePlant($input: UpdatePlantInput!) {
  updatePlant(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    id
    name
    phone
    products {
      id
      pivot {
        applicationRate
      }
      plantId
      rate
      type
    }
  }
}
    `;
export type UpdatePlantMutationFn = Apollo.MutationFunction<UpdatePlantMutation, UpdatePlantMutationVariables>;

/**
 * __useUpdatePlantMutation__
 *
 * To run a mutation, you first call `useUpdatePlantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlantMutation, { data, loading, error }] = useUpdatePlantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlantMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlantMutation, UpdatePlantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlantMutation, UpdatePlantMutationVariables>(UpdatePlantDocument, options);
      }
export type UpdatePlantMutationHookResult = ReturnType<typeof useUpdatePlantMutation>;
export type UpdatePlantMutationResult = Apollo.MutationResult<UpdatePlantMutation>;
export type UpdatePlantMutationOptions = Apollo.BaseMutationOptions<UpdatePlantMutation, UpdatePlantMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    areaCoverage
    attributes {
      __typename
      ... on ProductAttributeAsphalt {
        applicationRate
      }
      ... on ProductAttributeAsphaltCurbing {
        curbHeight
        curbWidth
      }
      ... on ProductAttributeConcreteColumn {
        diameter
        height
      }
      ... on ProductAttributeConcreteCurbOrGutter {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeConcreteFlatwork {
        applicationRate
      }
      ... on ProductAttributeConcreteFooting {
        depth
        width
      }
      ... on ProductAttributeConcreteWall {
        height
        width
      }
      ... on ProductAttributeConcreteWaterway {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeCrackSeal {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeCurbWall {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeExcavateOut {
        applicationRate
      }
      ... on ProductAttributeGrading {
        applicationRate
        poundsPerCubicYard
      }
      ... on ProductAttributeMastic {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeMicrosurfacing {
        applicationRate
      }
      ... on ProductAttributeSealCoat {
        applicationRate
      }
      ... on ProductAttributeSlurrySeal {
        applicationRate
      }
      ... on ProductAttributeStriping {
        applicationRate
        lineWidth
      }
    }
    costMaterial
    costMinimumProduct
    costMinimumProposal
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    dailyUnitsComplete
    externalProductName
    id
    indirectPercentage
    labourCostType
    markupPercentage
    materialsNoPlant {
      id
      name
      percentage
      productId
      rate
    }
    measurementJob
    measurementMaterial
    name
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    overheadPercentage
    plant {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        pivot {
          applicationRate
        }
        plantId
        rate
        type
      }
    }
    plantProductId
    plantProducts {
      id
      pivot {
        applicationRate
      }
      plantId
      rate
      type
    }
    plants {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        plantId
        rate
        type
      }
    }
    productAdditionalCosts {
      additionalCost {
        cost
        feeAmount
        feeType
        id
        name
      }
      id
      type
    }
    productCrews {
      crew {
        color
        displayName
        id
        name
        rate
      }
      id
      quantity
    }
    productEquipmentPieces {
      equipmentPiece {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      id
      quantity
    }
    productionRateType
    statementOfWork
    subcontracted
    type
    unitPrice
    unitPriceProduct
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const UpdateProductGroupDocument = gql`
    mutation updateProductGroup($input: UpdateProductGroupInput!) {
  updateProductGroup(input: $input) {
    id
    name
    organizationId
    products {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMinimumProduct
      costMinimumProposal
      crew {
        color
        displayName
        employees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        rate
      }
      dailyUnitsComplete
      externalProductName
      id
      indirectPercentage
      labourCostType
      markupPercentage
      materialsNoPlant {
        id
        name
        percentage
        productId
        rate
      }
      measurementJob
      measurementMaterial
      name
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      overheadPercentage
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        id
        name
        phone
        products {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
      }
      plantProductId
      plantProducts {
        id
        pivot {
          applicationRate
        }
        plantId
        rate
        type
      }
      plants {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        id
        name
        phone
        products {
          id
          plantId
          rate
          type
        }
      }
      productAdditionalCosts {
        additionalCost {
          cost
          feeAmount
          feeType
          id
          name
        }
        id
        type
      }
      productCrews {
        crew {
          color
          displayName
          id
          name
          rate
        }
        id
        quantity
      }
      productEquipmentPieces {
        equipmentPiece {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        id
        quantity
      }
      productionRateType
      statementOfWork
      subcontracted
      type
      unitPrice
      unitPriceProduct
    }
  }
}
    `;
export type UpdateProductGroupMutationFn = Apollo.MutationFunction<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>;

/**
 * __useUpdateProductGroupMutation__
 *
 * To run a mutation, you first call `useUpdateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductGroupMutation, { data, loading, error }] = useUpdateProductGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>(UpdateProductGroupDocument, options);
      }
export type UpdateProductGroupMutationHookResult = ReturnType<typeof useUpdateProductGroupMutation>;
export type UpdateProductGroupMutationResult = Apollo.MutationResult<UpdateProductGroupMutation>;
export type UpdateProductGroupMutationOptions = Apollo.BaseMutationOptions<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>;
export const UpdateProjectMapDocument = gql`
    mutation updateProjectMap($input: UpdateProjectMapInput!) {
  updateProjectMap(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    createdAt
    createdBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    description
    id
    latitude
    longitude
    mapData
    mapImage
    mapImageDirty
    measurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
    name
    updatedAt
  }
}
    `;
export type UpdateProjectMapMutationFn = Apollo.MutationFunction<UpdateProjectMapMutation, UpdateProjectMapMutationVariables>;

/**
 * __useUpdateProjectMapMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMapMutation, { data, loading, error }] = useUpdateProjectMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMapMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMapMutation, UpdateProjectMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMapMutation, UpdateProjectMapMutationVariables>(UpdateProjectMapDocument, options);
      }
export type UpdateProjectMapMutationHookResult = ReturnType<typeof useUpdateProjectMapMutation>;
export type UpdateProjectMapMutationResult = Apollo.MutationResult<UpdateProjectMapMutation>;
export type UpdateProjectMapMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMapMutation, UpdateProjectMapMutationVariables>;
export const UpdateProposalDocument = gql`
    mutation updateProposal($closeConfidence: Int, $companyId: ID!, $contactId: ID!, $id: ID!, $projectedCloseDate: Date, $source: ProposalSource) {
  updateProposal(
    closeConfidence: $closeConfidence
    companyId: $companyId
    contactId: $contactId
    id: $id
    projectedCloseDate: $projectedCloseDate
    source: $source
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalMutationFn = Apollo.MutationFunction<UpdateProposalMutation, UpdateProposalMutationVariables>;

/**
 * __useUpdateProposalMutation__
 *
 * To run a mutation, you first call `useUpdateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalMutation, { data, loading, error }] = useUpdateProposalMutation({
 *   variables: {
 *      closeConfidence: // value for 'closeConfidence'
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      id: // value for 'id'
 *      projectedCloseDate: // value for 'projectedCloseDate'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useUpdateProposalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalMutation, UpdateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalMutation, UpdateProposalMutationVariables>(UpdateProposalDocument, options);
      }
export type UpdateProposalMutationHookResult = ReturnType<typeof useUpdateProposalMutation>;
export type UpdateProposalMutationResult = Apollo.MutationResult<UpdateProposalMutation>;
export type UpdateProposalMutationOptions = Apollo.BaseMutationOptions<UpdateProposalMutation, UpdateProposalMutationVariables>;
export const UpdateProposalAddressDocument = gql`
    mutation updateProposalAddress($input: UpdateProposalAddress!) {
  updateProposalAddress(input: $input) {
    city
    country
    id
    latitude
    line1
    line2
    longitude
    mapImage
    organizationAddressId
    state
    zip
  }
}
    `;
export type UpdateProposalAddressMutationFn = Apollo.MutationFunction<UpdateProposalAddressMutation, UpdateProposalAddressMutationVariables>;

/**
 * __useUpdateProposalAddressMutation__
 *
 * To run a mutation, you first call `useUpdateProposalAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalAddressMutation, { data, loading, error }] = useUpdateProposalAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalAddressMutation, UpdateProposalAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalAddressMutation, UpdateProposalAddressMutationVariables>(UpdateProposalAddressDocument, options);
      }
export type UpdateProposalAddressMutationHookResult = ReturnType<typeof useUpdateProposalAddressMutation>;
export type UpdateProposalAddressMutationResult = Apollo.MutationResult<UpdateProposalAddressMutation>;
export type UpdateProposalAddressMutationOptions = Apollo.BaseMutationOptions<UpdateProposalAddressMutation, UpdateProposalAddressMutationVariables>;
export const UpdateProposalContentSettingsDocument = gql`
    mutation updateProposalContentSettings($contentSettings: UpdateProposalContentSettingsHasManyInput!, $id: ID!) {
  updateProposalContentSettings(contentSettings: $contentSettings, id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalContentSettingsMutationFn = Apollo.MutationFunction<UpdateProposalContentSettingsMutation, UpdateProposalContentSettingsMutationVariables>;

/**
 * __useUpdateProposalContentSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateProposalContentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalContentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalContentSettingsMutation, { data, loading, error }] = useUpdateProposalContentSettingsMutation({
 *   variables: {
 *      contentSettings: // value for 'contentSettings'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProposalContentSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalContentSettingsMutation, UpdateProposalContentSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalContentSettingsMutation, UpdateProposalContentSettingsMutationVariables>(UpdateProposalContentSettingsDocument, options);
      }
export type UpdateProposalContentSettingsMutationHookResult = ReturnType<typeof useUpdateProposalContentSettingsMutation>;
export type UpdateProposalContentSettingsMutationResult = Apollo.MutationResult<UpdateProposalContentSettingsMutation>;
export type UpdateProposalContentSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateProposalContentSettingsMutation, UpdateProposalContentSettingsMutationVariables>;
export const UpdateProposalDiscountDocument = gql`
    mutation updateProposalDiscount($input: UpdateProposalDiscountInput!) {
  updateProposalDiscount(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalDiscountMutationFn = Apollo.MutationFunction<UpdateProposalDiscountMutation, UpdateProposalDiscountMutationVariables>;

/**
 * __useUpdateProposalDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateProposalDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalDiscountMutation, { data, loading, error }] = useUpdateProposalDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalDiscountMutation, UpdateProposalDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalDiscountMutation, UpdateProposalDiscountMutationVariables>(UpdateProposalDiscountDocument, options);
      }
export type UpdateProposalDiscountMutationHookResult = ReturnType<typeof useUpdateProposalDiscountMutation>;
export type UpdateProposalDiscountMutationResult = Apollo.MutationResult<UpdateProposalDiscountMutation>;
export type UpdateProposalDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateProposalDiscountMutation, UpdateProposalDiscountMutationVariables>;
export const UpdateProposalInfoDocument = gql`
    mutation updateProposalInfo($input: UpdateProposalInfoInput) {
  updateProposalInfo(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalInfoMutationFn = Apollo.MutationFunction<UpdateProposalInfoMutation, UpdateProposalInfoMutationVariables>;

/**
 * __useUpdateProposalInfoMutation__
 *
 * To run a mutation, you first call `useUpdateProposalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalInfoMutation, { data, loading, error }] = useUpdateProposalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalInfoMutation, UpdateProposalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalInfoMutation, UpdateProposalInfoMutationVariables>(UpdateProposalInfoDocument, options);
      }
export type UpdateProposalInfoMutationHookResult = ReturnType<typeof useUpdateProposalInfoMutation>;
export type UpdateProposalInfoMutationResult = Apollo.MutationResult<UpdateProposalInfoMutation>;
export type UpdateProposalInfoMutationOptions = Apollo.BaseMutationOptions<UpdateProposalInfoMutation, UpdateProposalInfoMutationVariables>;
export const UpdateProposalPlantProductDocument = gql`
    mutation updateProposalPlantProduct($applicationRateOverride: Float, $materialNeededOverride: Float, $plantProductId: ID!, $proposalPlantProductId: ID!, $proposalProductId: ID!) {
  updateProposalPlantProduct(
    applicationRateOverride: $applicationRateOverride
    materialNeededOverride: $materialNeededOverride
    plantProductId: $plantProductId
    proposalPlantProductId: $proposalPlantProductId
    proposalProductId: $proposalProductId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalPlantProductMutationFn = Apollo.MutationFunction<UpdateProposalPlantProductMutation, UpdateProposalPlantProductMutationVariables>;

/**
 * __useUpdateProposalPlantProductMutation__
 *
 * To run a mutation, you first call `useUpdateProposalPlantProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalPlantProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalPlantProductMutation, { data, loading, error }] = useUpdateProposalPlantProductMutation({
 *   variables: {
 *      applicationRateOverride: // value for 'applicationRateOverride'
 *      materialNeededOverride: // value for 'materialNeededOverride'
 *      plantProductId: // value for 'plantProductId'
 *      proposalPlantProductId: // value for 'proposalPlantProductId'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useUpdateProposalPlantProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalPlantProductMutation, UpdateProposalPlantProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalPlantProductMutation, UpdateProposalPlantProductMutationVariables>(UpdateProposalPlantProductDocument, options);
      }
export type UpdateProposalPlantProductMutationHookResult = ReturnType<typeof useUpdateProposalPlantProductMutation>;
export type UpdateProposalPlantProductMutationResult = Apollo.MutationResult<UpdateProposalPlantProductMutation>;
export type UpdateProposalPlantProductMutationOptions = Apollo.BaseMutationOptions<UpdateProposalPlantProductMutation, UpdateProposalPlantProductMutationVariables>;
export const UpdateProposalProductDocument = gql`
    mutation updateProposalProduct($input: UpdateProposalProductInput!) {
  updateProposalProduct(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalProductMutationFn = Apollo.MutationFunction<UpdateProposalProductMutation, UpdateProposalProductMutationVariables>;

/**
 * __useUpdateProposalProductMutation__
 *
 * To run a mutation, you first call `useUpdateProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalProductMutation, { data, loading, error }] = useUpdateProposalProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalProductMutation, UpdateProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalProductMutation, UpdateProposalProductMutationVariables>(UpdateProposalProductDocument, options);
      }
export type UpdateProposalProductMutationHookResult = ReturnType<typeof useUpdateProposalProductMutation>;
export type UpdateProposalProductMutationResult = Apollo.MutationResult<UpdateProposalProductMutation>;
export type UpdateProposalProductMutationOptions = Apollo.BaseMutationOptions<UpdateProposalProductMutation, UpdateProposalProductMutationVariables>;
export const UpdateProposalProductDiscountDocument = gql`
    mutation updateProposalProductDiscount($input: UpdateProposalProductDiscountInput!) {
  updateProposalProductDiscount(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalProductDiscountMutationFn = Apollo.MutationFunction<UpdateProposalProductDiscountMutation, UpdateProposalProductDiscountMutationVariables>;

/**
 * __useUpdateProposalProductDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateProposalProductDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalProductDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalProductDiscountMutation, { data, loading, error }] = useUpdateProposalProductDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalProductDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalProductDiscountMutation, UpdateProposalProductDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalProductDiscountMutation, UpdateProposalProductDiscountMutationVariables>(UpdateProposalProductDiscountDocument, options);
      }
export type UpdateProposalProductDiscountMutationHookResult = ReturnType<typeof useUpdateProposalProductDiscountMutation>;
export type UpdateProposalProductDiscountMutationResult = Apollo.MutationResult<UpdateProposalProductDiscountMutation>;
export type UpdateProposalProductDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateProposalProductDiscountMutation, UpdateProposalProductDiscountMutationVariables>;
export const UpdateProposalProductOverridesDocument = gql`
    mutation updateProposalProductOverrides($externalProductName: String, $jobSize: Int, $overallTotalOverride: Int, $profitOverride: Int, $profitPercentageOverride: Int, $proposalProductId: ID!, $unitPriceOverride: Int) {
  updateProposalProductOverrides(
    externalProductName: $externalProductName
    jobSize: $jobSize
    overallTotalOverride: $overallTotalOverride
    profitOverride: $profitOverride
    profitPercentageOverride: $profitPercentageOverride
    proposalProductId: $proposalProductId
    unitPriceOverride: $unitPriceOverride
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalProductOverridesMutationFn = Apollo.MutationFunction<UpdateProposalProductOverridesMutation, UpdateProposalProductOverridesMutationVariables>;

/**
 * __useUpdateProposalProductOverridesMutation__
 *
 * To run a mutation, you first call `useUpdateProposalProductOverridesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalProductOverridesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalProductOverridesMutation, { data, loading, error }] = useUpdateProposalProductOverridesMutation({
 *   variables: {
 *      externalProductName: // value for 'externalProductName'
 *      jobSize: // value for 'jobSize'
 *      overallTotalOverride: // value for 'overallTotalOverride'
 *      profitOverride: // value for 'profitOverride'
 *      profitPercentageOverride: // value for 'profitPercentageOverride'
 *      proposalProductId: // value for 'proposalProductId'
 *      unitPriceOverride: // value for 'unitPriceOverride'
 *   },
 * });
 */
export function useUpdateProposalProductOverridesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalProductOverridesMutation, UpdateProposalProductOverridesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalProductOverridesMutation, UpdateProposalProductOverridesMutationVariables>(UpdateProposalProductOverridesDocument, options);
      }
export type UpdateProposalProductOverridesMutationHookResult = ReturnType<typeof useUpdateProposalProductOverridesMutation>;
export type UpdateProposalProductOverridesMutationResult = Apollo.MutationResult<UpdateProposalProductOverridesMutation>;
export type UpdateProposalProductOverridesMutationOptions = Apollo.BaseMutationOptions<UpdateProposalProductOverridesMutation, UpdateProposalProductOverridesMutationVariables>;
export const UpdateProposalProductProjectFilesDocument = gql`
    mutation updateProposalProductProjectFiles($projectFileIds: [ID!]!, $proposalProductId: ID!) {
  updateProposalProductProjectFiles(
    projectFileIds: $projectFileIds
    proposalProductId: $proposalProductId
  ) {
    additionalCosts {
      additionalCostId
      cost
      costOverride
      costTotal
      feeAmount
      feeAmountOverride
      feeType
      id
      name
      quantity
      quantityOverride
      showOnProposal
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    costTransferTruck
    crews {
      cost
      crewId
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
    }
    custom {
      area
      areaSource
      areaUnit
      calculationVersion
      costTotal
      fixedPrice
      helpers {
        hoursPerDay
        production {
          enabled
          materialRowId
          period
          quantity
          rate
          source
          unit
        }
        travel {
          enabled
          roundTripHours
          visits
        }
      }
      indirectPercentage
      internalName
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricing {
        discount
        mode
        value
        version
      }
      pricingBaseline {
        fixedPrice
        markup
        pricing {
          discount
          mode
          value
          version
        }
        pricingMethod
        profitAmount
      }
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      rows {
        calculatedQuantity
        calculation
        category
        factor
        factorAreaUnit
        factorLabel
        formula
        hauling {
          allocationPercent
          capacity
          capacityUnit
          fullLoads
          haulQuantity
          haulUnit
          loadHours
          materialRowId
          maxTripsPerDay
          planningEnabled
          planningHours
          quantityMode
          roundTripHours
          unloadHours
        }
        hoursPerTruck
        jobSize
        jobSizeUnit
        name
        quantity
        quantityOverride
        quantitySource
        rate
        rowId
        sourceId
        sourceName
        sourcePlantId
        sourcePlantName
        sourceType
        thickness
        total
        truckCapacity
        truckRateHours
        truckRateLoads
        truckRateTons
        truckRateYards
        truckingUnit
        trucksNeeded
        unit
      }
      scope
      scopeFormat
      sellingTotal
      sourceProductId
      sourceProductRevision
      unit
    }
    discount
    equipmentPieces {
      calculateTravelTime
      chargeType
      cost
      equipmentPieceId
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
      usePercentage
    }
    externalProductName
    files {
      createdAt
      filename
      id
      thumbnail
      type
    }
    grossMargin
    grossMarginPercentage
    id
    isCustom
    isOptional
    jobDuration
    jobDurationDaysOverride
    jobDurationOverride
    jobSize
    mapData
    mapImage
    mapImageDirty
    material {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      attributesOverride {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMaterialOverride
      costMinimumProduct
      costMinimumProposal
      dailyUnitsComplete
      dailyUnitsCompleteOverride
      externalProductName
      id
      indirectPercentage
      indirectPercentageOverride
      labourCostType
      markupPercentage
      markupPercentageOverride
      materialNeeded
      materialNeededOverride
      measurementJob
      measurementMaterial
      name
      organizationProductTypeName
      overheadPercentage
      overheadPercentageOverride
      productId
      productionRateType
      proposalId
      proposalProductId
      proposalStageId
      statementOfWork
      statementOfWorkOverride
      subcontracted
      tonConversionFactor
      tonConversionFactorOverride
      type
      unitPrice
      unitPriceOverride
      unitPriceProduct
    }
    measurementJob
    measurementMaterial
    netMargin
    netMarginPercentage
    notes
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalAfterDiscount
    overallTotalOverride
    plantProduct {
      applicationRate
      applicationRateOverride
      areaCoverage
      costMaterial
      costTransferTruck
      id
      materialNeeded
      materialNeededOverride
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOnWeight
      rateOverride
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTimeHrs
      transferTruckRoundTripTimeHrsOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        proposalPlantProductId
        quantity
        quantityOverride
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
      type
    }
    productName
    profit
    profitAfterDiscount
    profitOverride
    profitPercentage
    profitPercentageOverride
    projectFiles {
      children {
        children {
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        createdAt
        fileSizeBytes
        id
        name
        parentFolderId
        path
        type
      }
      createdAt
      fileSizeBytes
      id
      name
      parentFolderId
      path
      pivot {
        id
      }
      type
    }
    proposalMaterialNoPlants {
      cost
      id
      name
      percentage
      proposalProductId
      quantity
      quantityOverride
      rate
    }
    proposalPlantProducts {
      applicationRate
      applicationRateOverride
      areaCoverage
      costMaterial
      costTransferTruck
      id
      materialNeeded
      materialNeededOverride
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOnWeight
      rateOverride
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTimeHrs
      transferTruckRoundTripTimeHrsOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        proposalPlantProductId
        quantity
        quantityOverride
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
      type
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      showIndividualProducts
    }
    proposalProductGroupId
    roundTripTravelTimeHours
    statementOfWork
    subcontractorCost
    subcontractorName
    subcontractorProposalId
    transferTruckLoadTimeBuffer
    transferTruckRoundTripTime
    transferTruckRoundTripTimeOverride
    transferTruckUnloadTimeBuffer
    transferTrucks {
      cost
      costOverride
      id
      name
      plantTransferTruckId
      proposalPlantProductId
      quantity
      quantityOverride
      rateHourly
      rateHourlyOverride
      rateTon
      rateTonOverride
      tonnage
      totalHaulingHours
      totalHaulingHoursOverride
      transferTruckId
      truckingProductionRate
      trucksNeeded
    }
    unitPriceOverride
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;
export type UpdateProposalProductProjectFilesMutationFn = Apollo.MutationFunction<UpdateProposalProductProjectFilesMutation, UpdateProposalProductProjectFilesMutationVariables>;

/**
 * __useUpdateProposalProductProjectFilesMutation__
 *
 * To run a mutation, you first call `useUpdateProposalProductProjectFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalProductProjectFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalProductProjectFilesMutation, { data, loading, error }] = useUpdateProposalProductProjectFilesMutation({
 *   variables: {
 *      projectFileIds: // value for 'projectFileIds'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useUpdateProposalProductProjectFilesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalProductProjectFilesMutation, UpdateProposalProductProjectFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalProductProjectFilesMutation, UpdateProposalProductProjectFilesMutationVariables>(UpdateProposalProductProjectFilesDocument, options);
      }
export type UpdateProposalProductProjectFilesMutationHookResult = ReturnType<typeof useUpdateProposalProductProjectFilesMutation>;
export type UpdateProposalProductProjectFilesMutationResult = Apollo.MutationResult<UpdateProposalProductProjectFilesMutation>;
export type UpdateProposalProductProjectFilesMutationOptions = Apollo.BaseMutationOptions<UpdateProposalProductProjectFilesMutation, UpdateProposalProductProjectFilesMutationVariables>;
export const UpdateProposalSalesTaxesDocument = gql`
    mutation updateProposalSalesTaxes($input: UpdateProposalSalesTaxesInput) {
  updateProposalSalesTaxes(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalSalesTaxesMutationFn = Apollo.MutationFunction<UpdateProposalSalesTaxesMutation, UpdateProposalSalesTaxesMutationVariables>;

/**
 * __useUpdateProposalSalesTaxesMutation__
 *
 * To run a mutation, you first call `useUpdateProposalSalesTaxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalSalesTaxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalSalesTaxesMutation, { data, loading, error }] = useUpdateProposalSalesTaxesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalSalesTaxesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalSalesTaxesMutation, UpdateProposalSalesTaxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalSalesTaxesMutation, UpdateProposalSalesTaxesMutationVariables>(UpdateProposalSalesTaxesDocument, options);
      }
export type UpdateProposalSalesTaxesMutationHookResult = ReturnType<typeof useUpdateProposalSalesTaxesMutation>;
export type UpdateProposalSalesTaxesMutationResult = Apollo.MutationResult<UpdateProposalSalesTaxesMutation>;
export type UpdateProposalSalesTaxesMutationOptions = Apollo.BaseMutationOptions<UpdateProposalSalesTaxesMutation, UpdateProposalSalesTaxesMutationVariables>;
export const UpdateProposalStageDocument = gql`
    mutation updateProposalStage($addressOverride: String, $id: ID!, $mapData: String, $name: String) {
  updateProposalStage(
    addressOverride: $addressOverride
    id: $id
    mapData: $mapData
    name: $name
  ) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    checklistItems {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    checklistNotes
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    discount
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalAfterDiscount
    profit
    profitAfterDiscount
    profitPercentage
    proposalProductGroups {
      id
      isOptional
      name
      ordering
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          helpers {
            hoursPerDay
          }
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricing {
            discount
            mode
            value
            version
          }
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            quantitySource
            rate
            rowId
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          children {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      showIndividualProducts
    }
    proposalProducts {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    roundTripTravelTimeHours
    stageMeasurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
  }
}
    `;
export type UpdateProposalStageMutationFn = Apollo.MutationFunction<UpdateProposalStageMutation, UpdateProposalStageMutationVariables>;

/**
 * __useUpdateProposalStageMutation__
 *
 * To run a mutation, you first call `useUpdateProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalStageMutation, { data, loading, error }] = useUpdateProposalStageMutation({
 *   variables: {
 *      addressOverride: // value for 'addressOverride'
 *      id: // value for 'id'
 *      mapData: // value for 'mapData'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalStageMutation, UpdateProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalStageMutation, UpdateProposalStageMutationVariables>(UpdateProposalStageDocument, options);
      }
export type UpdateProposalStageMutationHookResult = ReturnType<typeof useUpdateProposalStageMutation>;
export type UpdateProposalStageMutationResult = Apollo.MutationResult<UpdateProposalStageMutation>;
export type UpdateProposalStageMutationOptions = Apollo.BaseMutationOptions<UpdateProposalStageMutation, UpdateProposalStageMutationVariables>;
export const UpdateProposalStageAddressAndClearProductsDocument = gql`
    mutation updateProposalStageAddressAndClearProducts($input: UpdateProposalStageAddressAndClearProductsInput!) {
  updateProposalStageAddressAndClearProducts(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalStageAddressAndClearProductsMutationFn = Apollo.MutationFunction<UpdateProposalStageAddressAndClearProductsMutation, UpdateProposalStageAddressAndClearProductsMutationVariables>;

/**
 * __useUpdateProposalStageAddressAndClearProductsMutation__
 *
 * To run a mutation, you first call `useUpdateProposalStageAddressAndClearProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalStageAddressAndClearProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalStageAddressAndClearProductsMutation, { data, loading, error }] = useUpdateProposalStageAddressAndClearProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalStageAddressAndClearProductsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalStageAddressAndClearProductsMutation, UpdateProposalStageAddressAndClearProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalStageAddressAndClearProductsMutation, UpdateProposalStageAddressAndClearProductsMutationVariables>(UpdateProposalStageAddressAndClearProductsDocument, options);
      }
export type UpdateProposalStageAddressAndClearProductsMutationHookResult = ReturnType<typeof useUpdateProposalStageAddressAndClearProductsMutation>;
export type UpdateProposalStageAddressAndClearProductsMutationResult = Apollo.MutationResult<UpdateProposalStageAddressAndClearProductsMutation>;
export type UpdateProposalStageAddressAndClearProductsMutationOptions = Apollo.BaseMutationOptions<UpdateProposalStageAddressAndClearProductsMutation, UpdateProposalStageAddressAndClearProductsMutationVariables>;
export const UpdateProposalStagesOrderingDocument = gql`
    mutation updateProposalStagesOrdering($input: UpdateProposalStagesOrdering!) {
  updateProposalStagesOrdering(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalStagesOrderingMutationFn = Apollo.MutationFunction<UpdateProposalStagesOrderingMutation, UpdateProposalStagesOrderingMutationVariables>;

/**
 * __useUpdateProposalStagesOrderingMutation__
 *
 * To run a mutation, you first call `useUpdateProposalStagesOrderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalStagesOrderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalStagesOrderingMutation, { data, loading, error }] = useUpdateProposalStagesOrderingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalStagesOrderingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalStagesOrderingMutation, UpdateProposalStagesOrderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalStagesOrderingMutation, UpdateProposalStagesOrderingMutationVariables>(UpdateProposalStagesOrderingDocument, options);
      }
export type UpdateProposalStagesOrderingMutationHookResult = ReturnType<typeof useUpdateProposalStagesOrderingMutation>;
export type UpdateProposalStagesOrderingMutationResult = Apollo.MutationResult<UpdateProposalStagesOrderingMutation>;
export type UpdateProposalStagesOrderingMutationOptions = Apollo.BaseMutationOptions<UpdateProposalStagesOrderingMutation, UpdateProposalStagesOrderingMutationVariables>;
export const UpdateRolesWithPermissionsDocument = gql`
    mutation updateRolesWithPermissions($input: UpdateRolesWithPermissionsInput) {
  updateRolesWithPermissions(input: $input) {
    admin
    employee
    foreman
    officeManager
    salesperson
    subcontractor
  }
}
    `;
export type UpdateRolesWithPermissionsMutationFn = Apollo.MutationFunction<UpdateRolesWithPermissionsMutation, UpdateRolesWithPermissionsMutationVariables>;

/**
 * __useUpdateRolesWithPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateRolesWithPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRolesWithPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRolesWithPermissionsMutation, { data, loading, error }] = useUpdateRolesWithPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRolesWithPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRolesWithPermissionsMutation, UpdateRolesWithPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRolesWithPermissionsMutation, UpdateRolesWithPermissionsMutationVariables>(UpdateRolesWithPermissionsDocument, options);
      }
export type UpdateRolesWithPermissionsMutationHookResult = ReturnType<typeof useUpdateRolesWithPermissionsMutation>;
export type UpdateRolesWithPermissionsMutationResult = Apollo.MutationResult<UpdateRolesWithPermissionsMutation>;
export type UpdateRolesWithPermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateRolesWithPermissionsMutation, UpdateRolesWithPermissionsMutationVariables>;
export const UpdateStageProductsOrderingDocument = gql`
    mutation updateStageProductsOrdering($input: UpdateProposalProductsOrderingInput!) {
  updateStageProductsOrdering(input: $input) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    checklistItems {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    checklistNotes
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    discount
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalAfterDiscount
    profit
    profitAfterDiscount
    profitPercentage
    proposalProductGroups {
      id
      isOptional
      name
      ordering
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          helpers {
            hoursPerDay
          }
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricing {
            discount
            mode
            value
            version
          }
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            quantitySource
            rate
            rowId
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          children {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      showIndividualProducts
    }
    proposalProducts {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    roundTripTravelTimeHours
    stageMeasurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
  }
}
    `;
export type UpdateStageProductsOrderingMutationFn = Apollo.MutationFunction<UpdateStageProductsOrderingMutation, UpdateStageProductsOrderingMutationVariables>;

/**
 * __useUpdateStageProductsOrderingMutation__
 *
 * To run a mutation, you first call `useUpdateStageProductsOrderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStageProductsOrderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStageProductsOrderingMutation, { data, loading, error }] = useUpdateStageProductsOrderingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStageProductsOrderingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStageProductsOrderingMutation, UpdateStageProductsOrderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStageProductsOrderingMutation, UpdateStageProductsOrderingMutationVariables>(UpdateStageProductsOrderingDocument, options);
      }
export type UpdateStageProductsOrderingMutationHookResult = ReturnType<typeof useUpdateStageProductsOrderingMutation>;
export type UpdateStageProductsOrderingMutationResult = Apollo.MutationResult<UpdateStageProductsOrderingMutation>;
export type UpdateStageProductsOrderingMutationOptions = Apollo.BaseMutationOptions<UpdateStageProductsOrderingMutation, UpdateStageProductsOrderingMutationVariables>;
export const UpdateTimeBucketDocument = gql`
    mutation updateTimeBucket($input: UpdateTimeBucketInput!) {
  updateTimeBucket(input: $input) {
    id
    name
    organizationId
  }
}
    `;
export type UpdateTimeBucketMutationFn = Apollo.MutationFunction<UpdateTimeBucketMutation, UpdateTimeBucketMutationVariables>;

/**
 * __useUpdateTimeBucketMutation__
 *
 * To run a mutation, you first call `useUpdateTimeBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeBucketMutation, { data, loading, error }] = useUpdateTimeBucketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeBucketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeBucketMutation, UpdateTimeBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeBucketMutation, UpdateTimeBucketMutationVariables>(UpdateTimeBucketDocument, options);
      }
export type UpdateTimeBucketMutationHookResult = ReturnType<typeof useUpdateTimeBucketMutation>;
export type UpdateTimeBucketMutationResult = Apollo.MutationResult<UpdateTimeBucketMutation>;
export type UpdateTimeBucketMutationOptions = Apollo.BaseMutationOptions<UpdateTimeBucketMutation, UpdateTimeBucketMutationVariables>;
export const UpdateTimeEntryDocument = gql`
    mutation updateTimeEntry($input: UpdateTimeEntryInput!) {
  updateTimeEntry(input: $input) {
    clockInLatitude
    clockInLongitude
    clockOutLatitude
    clockOutLongitude
    endTime
    forDate
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      checklistNotes
      costingMode
      crewId
      endsAt
      externalId
      hasJobCostsEntered
      id
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    notes
    organizationId
    startTime
    timeBucket {
      id
      name
      organizationId
    }
    timeTrackedSeconds
    timeTrackedSecondsOverride
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    uuid
  }
}
    `;
export type UpdateTimeEntryMutationFn = Apollo.MutationFunction<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>;

/**
 * __useUpdateTimeEntryMutation__
 *
 * To run a mutation, you first call `useUpdateTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeEntryMutation, { data, loading, error }] = useUpdateTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>(UpdateTimeEntryDocument, options);
      }
export type UpdateTimeEntryMutationHookResult = ReturnType<typeof useUpdateTimeEntryMutation>;
export type UpdateTimeEntryMutationResult = Apollo.MutationResult<UpdateTimeEntryMutation>;
export type UpdateTimeEntryMutationOptions = Apollo.BaseMutationOptions<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>;
export const UpdateTransferTruckDocument = gql`
    mutation updateTransferTruck($input: UpdateTransferTruckInput!) {
  updateTransferTruck(input: $input) {
    defaultRateHourly
    defaultRateTon
    defaultTonnage
    id
    name
  }
}
    `;
export type UpdateTransferTruckMutationFn = Apollo.MutationFunction<UpdateTransferTruckMutation, UpdateTransferTruckMutationVariables>;

/**
 * __useUpdateTransferTruckMutation__
 *
 * To run a mutation, you first call `useUpdateTransferTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransferTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransferTruckMutation, { data, loading, error }] = useUpdateTransferTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransferTruckMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransferTruckMutation, UpdateTransferTruckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransferTruckMutation, UpdateTransferTruckMutationVariables>(UpdateTransferTruckDocument, options);
      }
export type UpdateTransferTruckMutationHookResult = ReturnType<typeof useUpdateTransferTruckMutation>;
export type UpdateTransferTruckMutationResult = Apollo.MutationResult<UpdateTransferTruckMutation>;
export type UpdateTransferTruckMutationOptions = Apollo.BaseMutationOptions<UpdateTransferTruckMutation, UpdateTransferTruckMutationVariables>;
export const UpdateWorkOrderItemsDocument = gql`
    mutation updateWorkOrderItems($input: UpdateWorkOrderItemsInput!) {
  updateWorkOrderItems(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    actualSubcontractorCost
    actualSubcontractorName
    actualSubcontractorReference
    address
    applicableStatuses
    checklistCompletion {
      allCompleted
      ratio
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    checklistNotes
    costItems {
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      id
      plantId
      plantProductId
    }
    costingMode
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      calculateTravelTime
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    hasJobCostsEntered
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      id
      invoiceId
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    jobCostEntryDaysCount
    jobCostingCompletionStatus
    jobCostingThresholdPercent
    jobCostingVariancePercent
    jobDuration
    jobPhaseMaterialNoPlants {
      cost
      id
      jobPhaseId
      name
      percentage
      quantity
      rate
    }
    jobPhasePlant {
      id
      materialNeeded
      name
      rate
      type
    }
    jobPhasePlants {
      id
      materialNeeded
      name
      rate
      type
    }
    jobSize
    lastJobCostEntryDate
    missingCostCategories
    notes
    ordering
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      showIndividualProducts
    }
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      proposalPlantProductId
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;
export type UpdateWorkOrderItemsMutationFn = Apollo.MutationFunction<UpdateWorkOrderItemsMutation, UpdateWorkOrderItemsMutationVariables>;

/**
 * __useUpdateWorkOrderItemsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderItemsMutation, { data, loading, error }] = useUpdateWorkOrderItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkOrderItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOrderItemsMutation, UpdateWorkOrderItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOrderItemsMutation, UpdateWorkOrderItemsMutationVariables>(UpdateWorkOrderItemsDocument, options);
      }
export type UpdateWorkOrderItemsMutationHookResult = ReturnType<typeof useUpdateWorkOrderItemsMutation>;
export type UpdateWorkOrderItemsMutationResult = Apollo.MutationResult<UpdateWorkOrderItemsMutation>;
export type UpdateWorkOrderItemsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderItemsMutation, UpdateWorkOrderItemsMutationVariables>;
export const UpdateWorksheetSettingsDocument = gql`
    mutation updateWorksheetSettings($markup: String!, $method: String!) {
  updateWorksheetSettings(markup: $markup, method: $method) {
    canManageProducts
    canManageSettings
    enabled
    factors {
      label
      value
    }
    markup
    method
  }
}
    `;
export type UpdateWorksheetSettingsMutationFn = Apollo.MutationFunction<UpdateWorksheetSettingsMutation, UpdateWorksheetSettingsMutationVariables>;

/**
 * __useUpdateWorksheetSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorksheetSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorksheetSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorksheetSettingsMutation, { data, loading, error }] = useUpdateWorksheetSettingsMutation({
 *   variables: {
 *      markup: // value for 'markup'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useUpdateWorksheetSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorksheetSettingsMutation, UpdateWorksheetSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorksheetSettingsMutation, UpdateWorksheetSettingsMutationVariables>(UpdateWorksheetSettingsDocument, options);
      }
export type UpdateWorksheetSettingsMutationHookResult = ReturnType<typeof useUpdateWorksheetSettingsMutation>;
export type UpdateWorksheetSettingsMutationResult = Apollo.MutationResult<UpdateWorksheetSettingsMutation>;
export type UpdateWorksheetSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateWorksheetSettingsMutation, UpdateWorksheetSettingsMutationVariables>;
export const ValidateRegistrationTokenDocument = gql`
    mutation validateRegistrationToken($input: ValidateRegistrationTokenInput!) {
  validateRegistrationToken(input: $input)
}
    `;
export type ValidateRegistrationTokenMutationFn = Apollo.MutationFunction<ValidateRegistrationTokenMutation, ValidateRegistrationTokenMutationVariables>;

/**
 * __useValidateRegistrationTokenMutation__
 *
 * To run a mutation, you first call `useValidateRegistrationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateRegistrationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateRegistrationTokenMutation, { data, loading, error }] = useValidateRegistrationTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateRegistrationTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateRegistrationTokenMutation, ValidateRegistrationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateRegistrationTokenMutation, ValidateRegistrationTokenMutationVariables>(ValidateRegistrationTokenDocument, options);
      }
export type ValidateRegistrationTokenMutationHookResult = ReturnType<typeof useValidateRegistrationTokenMutation>;
export type ValidateRegistrationTokenMutationResult = Apollo.MutationResult<ValidateRegistrationTokenMutation>;
export type ValidateRegistrationTokenMutationOptions = Apollo.BaseMutationOptions<ValidateRegistrationTokenMutation, ValidateRegistrationTokenMutationVariables>;
export const GetOrganizationApiKeysDocument = gql`
    query GetOrganizationApiKeys {
  GetOrganizationApiKeys {
    api_key
    description
    id
    is_active
    organizationId
  }
}
    `;

/**
 * __useGetOrganizationApiKeysQuery__
 *
 * To run a query within a React component, call `useGetOrganizationApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>(GetOrganizationApiKeysDocument, options);
      }
export function useGetOrganizationApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>(GetOrganizationApiKeysDocument, options);
        }
export type GetOrganizationApiKeysQueryHookResult = ReturnType<typeof useGetOrganizationApiKeysQuery>;
export type GetOrganizationApiKeysLazyQueryHookResult = ReturnType<typeof useGetOrganizationApiKeysLazyQuery>;
export type GetOrganizationApiKeysQueryResult = Apollo.QueryResult<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>;
export const CustomProductsDocument = gql`
    query customProducts {
  customProducts {
    definition {
      area
      areaSource
      areaUnit
      calculationVersion
      costTotal
      fixedPrice
      helpers {
        hoursPerDay
        production {
          enabled
          materialRowId
          period
          quantity
          rate
          source
          unit
        }
        travel {
          enabled
          roundTripHours
          visits
        }
      }
      indirectPercentage
      internalName
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricing {
        discount
        mode
        value
        version
      }
      pricingBaseline {
        fixedPrice
        markup
        pricing {
          discount
          mode
          value
          version
        }
        pricingMethod
        profitAmount
      }
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      rows {
        calculatedQuantity
        calculation
        category
        factor
        factorAreaUnit
        factorLabel
        formula
        hauling {
          allocationPercent
          capacity
          capacityUnit
          fullLoads
          haulQuantity
          haulUnit
          loadHours
          materialRowId
          maxTripsPerDay
          planningEnabled
          planningHours
          quantityMode
          roundTripHours
          unloadHours
        }
        hoursPerTruck
        jobSize
        jobSizeUnit
        name
        quantity
        quantityOverride
        quantitySource
        rate
        rowId
        sourceId
        sourceName
        sourcePlantId
        sourcePlantName
        sourceType
        thickness
        total
        truckCapacity
        truckRateHours
        truckRateLoads
        truckRateTons
        truckRateYards
        truckingUnit
        trucksNeeded
        unit
      }
      scope
      scopeFormat
      sellingTotal
      sourceProductId
      sourceProductRevision
      unit
    }
    id
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    revision
  }
}
    `;

/**
 * __useCustomProductsQuery__
 *
 * To run a query within a React component, call `useCustomProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomProductsQuery(baseOptions?: Apollo.QueryHookOptions<CustomProductsQuery, CustomProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomProductsQuery, CustomProductsQueryVariables>(CustomProductsDocument, options);
      }
export function useCustomProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomProductsQuery, CustomProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomProductsQuery, CustomProductsQueryVariables>(CustomProductsDocument, options);
        }
export type CustomProductsQueryHookResult = ReturnType<typeof useCustomProductsQuery>;
export type CustomProductsLazyQueryHookResult = ReturnType<typeof useCustomProductsLazyQuery>;
export type CustomProductsQueryResult = Apollo.QueryResult<CustomProductsQuery, CustomProductsQueryVariables>;
export const CustomProposalDocument = gql`
    query customProposal($id: ID!) {
  customProposal(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;

/**
 * __useCustomProposalQuery__
 *
 * To run a query within a React component, call `useCustomProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomProposalQuery(baseOptions: Apollo.QueryHookOptions<CustomProposalQuery, CustomProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomProposalQuery, CustomProposalQueryVariables>(CustomProposalDocument, options);
      }
export function useCustomProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomProposalQuery, CustomProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomProposalQuery, CustomProposalQueryVariables>(CustomProposalDocument, options);
        }
export type CustomProposalQueryHookResult = ReturnType<typeof useCustomProposalQuery>;
export type CustomProposalLazyQueryHookResult = ReturnType<typeof useCustomProposalLazyQuery>;
export type CustomProposalQueryResult = Apollo.QueryResult<CustomProposalQuery, CustomProposalQueryVariables>;
export const CustomSettingsDocument = gql`
    query customSettings {
  customSettings {
    canManageProducts
    canManageSettings
    enabled
    factors {
      label
      value
    }
    markup
    workingHoursPerDay
  }
}
    `;

/**
 * __useCustomSettingsQuery__
 *
 * To run a query within a React component, call `useCustomSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomSettingsQuery(baseOptions?: Apollo.QueryHookOptions<CustomSettingsQuery, CustomSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomSettingsQuery, CustomSettingsQueryVariables>(CustomSettingsDocument, options);
      }
export function useCustomSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomSettingsQuery, CustomSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomSettingsQuery, CustomSettingsQueryVariables>(CustomSettingsDocument, options);
        }
export type CustomSettingsQueryHookResult = ReturnType<typeof useCustomSettingsQuery>;
export type CustomSettingsLazyQueryHookResult = ReturnType<typeof useCustomSettingsLazyQuery>;
export type CustomSettingsQueryResult = Apollo.QueryResult<CustomSettingsQuery, CustomSettingsQueryVariables>;
export const GetAdditionalCostDocument = gql`
    query getAdditionalCost($id: ID!) {
  getAdditionalCost(id: $id) {
    cost
    feeAmount
    feeType
    id
    name
  }
}
    `;

/**
 * __useGetAdditionalCostQuery__
 *
 * To run a query within a React component, call `useGetAdditionalCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalCostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdditionalCostQuery(baseOptions: Apollo.QueryHookOptions<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>(GetAdditionalCostDocument, options);
      }
export function useGetAdditionalCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>(GetAdditionalCostDocument, options);
        }
export type GetAdditionalCostQueryHookResult = ReturnType<typeof useGetAdditionalCostQuery>;
export type GetAdditionalCostLazyQueryHookResult = ReturnType<typeof useGetAdditionalCostLazyQuery>;
export type GetAdditionalCostQueryResult = Apollo.QueryResult<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>;
export const GetAdditionalCostsDocument = gql`
    query getAdditionalCosts($feeType: AdditionalCostFeeType, $first: Int!, $page: Int, $search: String, $sort: SortDirection) {
  getAdditionalCosts(
    feeType: $feeType
    first: $first
    page: $page
    search: $search
    sort: $sort
  ) {
    data {
      cost
      feeAmount
      feeType
      id
      name
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetAdditionalCostsQuery__
 *
 * To run a query within a React component, call `useGetAdditionalCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalCostsQuery({
 *   variables: {
 *      feeType: // value for 'feeType'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAdditionalCostsQuery(baseOptions: Apollo.QueryHookOptions<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>(GetAdditionalCostsDocument, options);
      }
export function useGetAdditionalCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>(GetAdditionalCostsDocument, options);
        }
export type GetAdditionalCostsQueryHookResult = ReturnType<typeof useGetAdditionalCostsQuery>;
export type GetAdditionalCostsLazyQueryHookResult = ReturnType<typeof useGetAdditionalCostsLazyQuery>;
export type GetAdditionalCostsQueryResult = Apollo.QueryResult<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>;
export const GetAiMappingRunDocument = gql`
    query getAiMappingRun($projectMapId: ID!) {
  getAiMappingRun(projectMapId: $projectMapId) {
    areas {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    createdAt
    description
    id
    name
    projectMap {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      createdAt
      createdBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      description
      id
      latitude
      longitude
      mapData
      mapImage
      mapImageDirty
      measurements {
        featureGeojson
        geojsonFeatureId
        id
        isScreenshotTarget
        label
        measurementJob
        measurementType
        measurementValue
        product {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMinimumProduct
          costMinimumProposal
          crew {
            color
            displayName
            id
            name
            rate
          }
          dailyUnitsComplete
          externalProductName
          id
          indirectPercentage
          labourCostType
          markupPercentage
          materialsNoPlant {
            id
            name
            percentage
            productId
            rate
          }
          measurementJob
          measurementMaterial
          name
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          overheadPercentage
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProductId
          plantProducts {
            id
            plantId
            rate
            type
          }
          plants {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          productAdditionalCosts {
            id
            type
          }
          productCrews {
            id
            quantity
          }
          productEquipmentPieces {
            id
            quantity
          }
          productionRateType
          statementOfWork
          subcontracted
          type
          unitPrice
          unitPriceProduct
        }
        productId
        sortOrder
      }
      name
      updatedAt
    }
    updatedAt
  }
}
    `;

/**
 * __useGetAiMappingRunQuery__
 *
 * To run a query within a React component, call `useGetAiMappingRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiMappingRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiMappingRunQuery({
 *   variables: {
 *      projectMapId: // value for 'projectMapId'
 *   },
 * });
 */
export function useGetAiMappingRunQuery(baseOptions: Apollo.QueryHookOptions<GetAiMappingRunQuery, GetAiMappingRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiMappingRunQuery, GetAiMappingRunQueryVariables>(GetAiMappingRunDocument, options);
      }
export function useGetAiMappingRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiMappingRunQuery, GetAiMappingRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiMappingRunQuery, GetAiMappingRunQueryVariables>(GetAiMappingRunDocument, options);
        }
export type GetAiMappingRunQueryHookResult = ReturnType<typeof useGetAiMappingRunQuery>;
export type GetAiMappingRunLazyQueryHookResult = ReturnType<typeof useGetAiMappingRunLazyQuery>;
export type GetAiMappingRunQueryResult = Apollo.QueryResult<GetAiMappingRunQuery, GetAiMappingRunQueryVariables>;
export const GetAiMappingRunAreaDocument = gql`
    query getAiMappingRunArea($id: ID!) {
  getAiMappingRunArea(id: $id) {
    coordinates
    createdAt
    currentVersion
    id
    imageHeight
    imageWidth
    inputType
    minSegAreaSqft
    minSegConf
    name
    segmentationModel
    status
    taskId
    updatedAt
  }
}
    `;

/**
 * __useGetAiMappingRunAreaQuery__
 *
 * To run a query within a React component, call `useGetAiMappingRunAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiMappingRunAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiMappingRunAreaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAiMappingRunAreaQuery(baseOptions: Apollo.QueryHookOptions<GetAiMappingRunAreaQuery, GetAiMappingRunAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiMappingRunAreaQuery, GetAiMappingRunAreaQueryVariables>(GetAiMappingRunAreaDocument, options);
      }
export function useGetAiMappingRunAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiMappingRunAreaQuery, GetAiMappingRunAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiMappingRunAreaQuery, GetAiMappingRunAreaQueryVariables>(GetAiMappingRunAreaDocument, options);
        }
export type GetAiMappingRunAreaQueryHookResult = ReturnType<typeof useGetAiMappingRunAreaQuery>;
export type GetAiMappingRunAreaLazyQueryHookResult = ReturnType<typeof useGetAiMappingRunAreaLazyQuery>;
export type GetAiMappingRunAreaQueryResult = Apollo.QueryResult<GetAiMappingRunAreaQuery, GetAiMappingRunAreaQueryVariables>;
export const GetAiMappingRunAreaResultsDocument = gql`
    query getAiMappingRunAreaResults($id: ID!) {
  getAiMappingRunAreaResults(id: $id) {
    area {
      coordinates
      createdAt
      currentVersion
      id
      imageHeight
      imageWidth
      inputType
      minSegAreaSqft
      minSegConf
      name
      segmentationModel
      status
      taskId
      updatedAt
    }
    detections {
      bbox
      category
      color
      confidence
      id
      isDeleted
      source
      version
    }
    segmentations {
      areaSqft
      category
      color
      id
      isDeleted
      polygon
      version
    }
  }
}
    `;

/**
 * __useGetAiMappingRunAreaResultsQuery__
 *
 * To run a query within a React component, call `useGetAiMappingRunAreaResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiMappingRunAreaResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiMappingRunAreaResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAiMappingRunAreaResultsQuery(baseOptions: Apollo.QueryHookOptions<GetAiMappingRunAreaResultsQuery, GetAiMappingRunAreaResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiMappingRunAreaResultsQuery, GetAiMappingRunAreaResultsQueryVariables>(GetAiMappingRunAreaResultsDocument, options);
      }
export function useGetAiMappingRunAreaResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiMappingRunAreaResultsQuery, GetAiMappingRunAreaResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiMappingRunAreaResultsQuery, GetAiMappingRunAreaResultsQueryVariables>(GetAiMappingRunAreaResultsDocument, options);
        }
export type GetAiMappingRunAreaResultsQueryHookResult = ReturnType<typeof useGetAiMappingRunAreaResultsQuery>;
export type GetAiMappingRunAreaResultsLazyQueryHookResult = ReturnType<typeof useGetAiMappingRunAreaResultsLazyQuery>;
export type GetAiMappingRunAreaResultsQueryResult = Apollo.QueryResult<GetAiMappingRunAreaResultsQuery, GetAiMappingRunAreaResultsQueryVariables>;
export const GetAiMappingTaskStatusDocument = gql`
    query getAiMappingTaskStatus($taskId: String!) {
  getAiMappingTaskStatus(taskId: $taskId) {
    counts {
      category
      count
    }
    error
    pdfUrl
    progress
    progressMessage
    status
  }
}
    `;

/**
 * __useGetAiMappingTaskStatusQuery__
 *
 * To run a query within a React component, call `useGetAiMappingTaskStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiMappingTaskStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiMappingTaskStatusQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetAiMappingTaskStatusQuery(baseOptions: Apollo.QueryHookOptions<GetAiMappingTaskStatusQuery, GetAiMappingTaskStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiMappingTaskStatusQuery, GetAiMappingTaskStatusQueryVariables>(GetAiMappingTaskStatusDocument, options);
      }
export function useGetAiMappingTaskStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiMappingTaskStatusQuery, GetAiMappingTaskStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiMappingTaskStatusQuery, GetAiMappingTaskStatusQueryVariables>(GetAiMappingTaskStatusDocument, options);
        }
export type GetAiMappingTaskStatusQueryHookResult = ReturnType<typeof useGetAiMappingTaskStatusQuery>;
export type GetAiMappingTaskStatusLazyQueryHookResult = ReturnType<typeof useGetAiMappingTaskStatusLazyQuery>;
export type GetAiMappingTaskStatusQueryResult = Apollo.QueryResult<GetAiMappingTaskStatusQuery, GetAiMappingTaskStatusQueryVariables>;
export const GetAllCrewsDocument = gql`
    query getAllCrews {
  getAllCrews {
    color
    displayName
    employees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    rate
  }
}
    `;

/**
 * __useGetAllCrewsQuery__
 *
 * To run a query within a React component, call `useGetAllCrewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCrewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCrewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCrewsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCrewsQuery, GetAllCrewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCrewsQuery, GetAllCrewsQueryVariables>(GetAllCrewsDocument, options);
      }
export function useGetAllCrewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCrewsQuery, GetAllCrewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCrewsQuery, GetAllCrewsQueryVariables>(GetAllCrewsDocument, options);
        }
export type GetAllCrewsQueryHookResult = ReturnType<typeof useGetAllCrewsQuery>;
export type GetAllCrewsLazyQueryHookResult = ReturnType<typeof useGetAllCrewsLazyQuery>;
export type GetAllCrewsQueryResult = Apollo.QueryResult<GetAllCrewsQuery, GetAllCrewsQueryVariables>;
export const GetAllDailyFormVehiclesDocument = gql`
    query getAllDailyFormVehicles {
  getAllDailyFormVehicles {
    currentMeterReading
    dailyFormVehicleType {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    defaultServiceIntervalUnit
    defaultServiceIntervalValue
    id
    inServiceDate
    inspections {
      createdAt
      dailyFormVehicle {
        currentMeterReading
        dailyFormVehicleType {
          id
          name
        }
        defaultServiceIntervalUnit
        defaultServiceIntervalValue
        id
        inServiceDate
        inspections {
          createdAt
          id
          lightsWork
          loadStrapped
          oilChecked
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          questionAnswers {
            answer
            id
            isTrue
          }
          tiresAiredBrakesWorking
          toolsLoaded
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicleConditionAcceptable
          vehicleFueled
          vehicleMilleage
        }
        isActive
        licensePlate
        make
        meterType
        model
        name
        notes
        parts {
          id
          name
          notes
          partNumber
          quantity
          unitPrice
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          vendorName
        }
        registrationExpirationDate
        registrationState
        servicePlans {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        vin
        workOrders {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        year
      }
      id
      lightsWork
      loadStrapped
      oilChecked
      tiresAiredBrakesWorking
      toolsLoaded
      vehicleConditionAcceptable
      vehicleFueled
      vehicleMilleage
    }
    isActive
    licensePlate
    make
    meterType
    model
    name
    notes
    parts {
      id
      name
      notes
      partNumber
      quantity
      unitPrice
      vendorName
    }
    registrationExpirationDate
    registrationState
    servicePlans {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    vin
    workOrders {
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      status
    }
    year
  }
}
    `;

/**
 * __useGetAllDailyFormVehiclesQuery__
 *
 * To run a query within a React component, call `useGetAllDailyFormVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDailyFormVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDailyFormVehiclesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDailyFormVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDailyFormVehiclesQuery, GetAllDailyFormVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDailyFormVehiclesQuery, GetAllDailyFormVehiclesQueryVariables>(GetAllDailyFormVehiclesDocument, options);
      }
export function useGetAllDailyFormVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDailyFormVehiclesQuery, GetAllDailyFormVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDailyFormVehiclesQuery, GetAllDailyFormVehiclesQueryVariables>(GetAllDailyFormVehiclesDocument, options);
        }
export type GetAllDailyFormVehiclesQueryHookResult = ReturnType<typeof useGetAllDailyFormVehiclesQuery>;
export type GetAllDailyFormVehiclesLazyQueryHookResult = ReturnType<typeof useGetAllDailyFormVehiclesLazyQuery>;
export type GetAllDailyFormVehiclesQueryResult = Apollo.QueryResult<GetAllDailyFormVehiclesQuery, GetAllDailyFormVehiclesQueryVariables>;
export const GetArchivedCompaniesDocument = gql`
    query getArchivedCompanies($first: Int!, $page: Int) {
  getArchivedCompanies(first: $first, page: $page) {
    data {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetArchivedCompaniesQuery__
 *
 * To run a query within a React component, call `useGetArchivedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetArchivedCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>(GetArchivedCompaniesDocument, options);
      }
export function useGetArchivedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>(GetArchivedCompaniesDocument, options);
        }
export type GetArchivedCompaniesQueryHookResult = ReturnType<typeof useGetArchivedCompaniesQuery>;
export type GetArchivedCompaniesLazyQueryHookResult = ReturnType<typeof useGetArchivedCompaniesLazyQuery>;
export type GetArchivedCompaniesQueryResult = Apollo.QueryResult<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>;
export const GetCheckoutUrlDocument = gql`
    query getCheckoutUrl {
  getCheckoutUrl
}
    `;

/**
 * __useGetCheckoutUrlQuery__
 *
 * To run a query within a React component, call `useGetCheckoutUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCheckoutUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>(GetCheckoutUrlDocument, options);
      }
export function useGetCheckoutUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>(GetCheckoutUrlDocument, options);
        }
export type GetCheckoutUrlQueryHookResult = ReturnType<typeof useGetCheckoutUrlQuery>;
export type GetCheckoutUrlLazyQueryHookResult = ReturnType<typeof useGetCheckoutUrlLazyQuery>;
export type GetCheckoutUrlQueryResult = Apollo.QueryResult<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>;
export const GetCompaniesDocument = gql`
    query getCompanies($first: Int!, $page: Int, $search: String, $searchByName: Boolean, $sort: SortDirection, $sortKey: GetCompaniesSortKey) {
  getCompanies(
    first: $first
    page: $page
    search: $search
    searchByName: $searchByName
    sort: $sort
    sortKey: $sortKey
  ) {
    data {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      searchByName: // value for 'searchByName'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($id: ID!) {
  getCompany(id: $id) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyContactsDocument = gql`
    query getCompanyContacts($id: ID!) {
  getCompanyContacts(id: $id) {
    SMSNotifications
    SMSNotificationsReadOnly
    email
    firstName
    id
    lastName
    phone
    primary
    role
    title
  }
}
    `;

/**
 * __useGetCompanyContactsQuery__
 *
 * To run a query within a React component, call `useGetCompanyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyContactsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>(GetCompanyContactsDocument, options);
      }
export function useGetCompanyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>(GetCompanyContactsDocument, options);
        }
export type GetCompanyContactsQueryHookResult = ReturnType<typeof useGetCompanyContactsQuery>;
export type GetCompanyContactsLazyQueryHookResult = ReturnType<typeof useGetCompanyContactsLazyQuery>;
export type GetCompanyContactsQueryResult = Apollo.QueryResult<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>;
export const GetCompanyProposalActivityDocument = gql`
    query getCompanyProposalActivity($companyId: ID!, $contactId: ID, $first: Int!, $page: Int) {
  getCompanyProposalActivity(
    companyId: $companyId
    contactId: $contactId
    first: $first
    page: $page
  ) {
    data {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      clientEmailOverride
      closeConfidence
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      contentSettings {
        contentType
        id
        isEnabled
        proposalId
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      customFinancials {
        incomplete
        netMargin
        productsWithoutCosts
        profit
        sendErrors
      }
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      events {
        action
        createdAt
        id
      }
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      lastEvent {
        action
        createdAt
        id
      }
      lastStatusChange {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      latestPackageSendRun {
        failedRecipients
        id
        processedRecipients
        proposalId
        recipients {
          attemptCount
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          companyId
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          errorMessage
          id
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          sentAt
          startedAt
          status
        }
        status
        succeededRecipients
        totalRecipients
      }
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      packageChildren {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageParent {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageWinnerProposal {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        addressOverride
        checklistItems {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        proposalProductGroups {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        roundTripTravelTimeHours
        stageMeasurements {
          featureGeojson
          geojsonFeatureId
          id
          isScreenshotTarget
          label
          measurementJob
          measurementType
          measurementValue
          product {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            externalProductName
            id
            indirectPercentage
            labourCostType
            markupPercentage
            measurementJob
            measurementMaterial
            name
            overheadPercentage
            plantProductId
            productionRateType
            statementOfWork
            subcontracted
            type
            unitPrice
            unitPriceProduct
          }
          productId
          sortOrder
        }
      }
      status
      statusChanges {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
      uuid
      version
      versionWithPrefix
      versions {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          addressOverride
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        wonAt
      }
      wonAt
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetCompanyProposalActivityQuery__
 *
 * To run a query within a React component, call `useGetCompanyProposalActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyProposalActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyProposalActivityQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetCompanyProposalActivityQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyProposalActivityQuery, GetCompanyProposalActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyProposalActivityQuery, GetCompanyProposalActivityQueryVariables>(GetCompanyProposalActivityDocument, options);
      }
export function useGetCompanyProposalActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyProposalActivityQuery, GetCompanyProposalActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyProposalActivityQuery, GetCompanyProposalActivityQueryVariables>(GetCompanyProposalActivityDocument, options);
        }
export type GetCompanyProposalActivityQueryHookResult = ReturnType<typeof useGetCompanyProposalActivityQuery>;
export type GetCompanyProposalActivityLazyQueryHookResult = ReturnType<typeof useGetCompanyProposalActivityLazyQuery>;
export type GetCompanyProposalActivityQueryResult = Apollo.QueryResult<GetCompanyProposalActivityQuery, GetCompanyProposalActivityQueryVariables>;
export const GetContactActivitiesDocument = gql`
    query getContactActivities($contactId: ID!, $first: Int!, $opportunityId: ID, $page: Int) {
  getContactActivities(
    contactId: $contactId
    first: $first
    opportunityId: $opportunityId
    page: $page
  ) {
    data {
      body
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      createdAt
      createdByUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        checklistItems {
          checklistItem {
            id
            name
          }
          checklistItemId
          id
          isCompleted
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        invoiceId
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
      }
      occurredAt
      opportunity {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        companyId
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        createdAt
        dueAt
        estimatedOpportunityValue
        externalId
        id
        name
        notes
        products {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        projectFilesFolderId
        source
        status
        statusId
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      opportunityId
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      summary
      type
      updatedAt
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetContactActivitiesQuery__
 *
 * To run a query within a React component, call `useGetContactActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactActivitiesQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      first: // value for 'first'
 *      opportunityId: // value for 'opportunityId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetContactActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetContactActivitiesQuery, GetContactActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactActivitiesQuery, GetContactActivitiesQueryVariables>(GetContactActivitiesDocument, options);
      }
export function useGetContactActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactActivitiesQuery, GetContactActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactActivitiesQuery, GetContactActivitiesQueryVariables>(GetContactActivitiesDocument, options);
        }
export type GetContactActivitiesQueryHookResult = ReturnType<typeof useGetContactActivitiesQuery>;
export type GetContactActivitiesLazyQueryHookResult = ReturnType<typeof useGetContactActivitiesLazyQuery>;
export type GetContactActivitiesQueryResult = Apollo.QueryResult<GetContactActivitiesQuery, GetContactActivitiesQueryVariables>;
export const GetCrewDocument = gql`
    query getCrew($id: ID!) {
  getCrew(id: $id) {
    color
    displayName
    employees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    rate
  }
}
    `;

/**
 * __useGetCrewQuery__
 *
 * To run a query within a React component, call `useGetCrewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCrewQuery(baseOptions: Apollo.QueryHookOptions<GetCrewQuery, GetCrewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrewQuery, GetCrewQueryVariables>(GetCrewDocument, options);
      }
export function useGetCrewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrewQuery, GetCrewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrewQuery, GetCrewQueryVariables>(GetCrewDocument, options);
        }
export type GetCrewQueryHookResult = ReturnType<typeof useGetCrewQuery>;
export type GetCrewLazyQueryHookResult = ReturnType<typeof useGetCrewLazyQuery>;
export type GetCrewQueryResult = Apollo.QueryResult<GetCrewQuery, GetCrewQueryVariables>;
export const GetCrewsDocument = gql`
    query getCrews($first: Int!, $page: Int, $search: String, $sort: SortDirection) {
  getCrews(first: $first, page: $page, search: $search, sort: $sort) {
    data {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetCrewsQuery__
 *
 * To run a query within a React component, call `useGetCrewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrewsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCrewsQuery(baseOptions: Apollo.QueryHookOptions<GetCrewsQuery, GetCrewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrewsQuery, GetCrewsQueryVariables>(GetCrewsDocument, options);
      }
export function useGetCrewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrewsQuery, GetCrewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrewsQuery, GetCrewsQueryVariables>(GetCrewsDocument, options);
        }
export type GetCrewsQueryHookResult = ReturnType<typeof useGetCrewsQuery>;
export type GetCrewsLazyQueryHookResult = ReturnType<typeof useGetCrewsLazyQuery>;
export type GetCrewsQueryResult = Apollo.QueryResult<GetCrewsQuery, GetCrewsQueryVariables>;
export const GetCurrentMonthStatsDocument = gql`
    query getCurrentMonthStats {
  getCurrentMonthStats {
    closedBids
    closedRate
    closedRevenue
    sentBids
  }
}
    `;

/**
 * __useGetCurrentMonthStatsQuery__
 *
 * To run a query within a React component, call `useGetCurrentMonthStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentMonthStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentMonthStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentMonthStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>(GetCurrentMonthStatsDocument, options);
      }
export function useGetCurrentMonthStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>(GetCurrentMonthStatsDocument, options);
        }
export type GetCurrentMonthStatsQueryHookResult = ReturnType<typeof useGetCurrentMonthStatsQuery>;
export type GetCurrentMonthStatsLazyQueryHookResult = ReturnType<typeof useGetCurrentMonthStatsLazyQuery>;
export type GetCurrentMonthStatsQueryResult = Apollo.QueryResult<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>;
export const GetCustomEventDocument = gql`
    query getCustomEvent($id: ID!) {
  getCustomEvent(id: $id) {
    color
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        endsAt
        files {
          customEvent {
            color
            endsAt
            id
            name
            notes
            startsAt
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    files {
      id
      name
      path
    }
    id
    name
    notes
    startsAt
  }
}
    `;

/**
 * __useGetCustomEventQuery__
 *
 * To run a query within a React component, call `useGetCustomEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomEventQuery(baseOptions: Apollo.QueryHookOptions<GetCustomEventQuery, GetCustomEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomEventQuery, GetCustomEventQueryVariables>(GetCustomEventDocument, options);
      }
export function useGetCustomEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomEventQuery, GetCustomEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomEventQuery, GetCustomEventQueryVariables>(GetCustomEventDocument, options);
        }
export type GetCustomEventQueryHookResult = ReturnType<typeof useGetCustomEventQuery>;
export type GetCustomEventLazyQueryHookResult = ReturnType<typeof useGetCustomEventLazyQuery>;
export type GetCustomEventQueryResult = Apollo.QueryResult<GetCustomEventQuery, GetCustomEventQueryVariables>;
export const GetCustomEventBlocksDocument = gql`
    query getCustomEventBlocks($crewId: ID, $customEventIds: [ID], $dateFrom: DateTime, $dateUntil: DateTime) {
  getCustomEventBlocks(
    crewId: $crewId
    customEventIds: $customEventIds
    dateFrom: $dateFrom
    dateUntil: $dateUntil
  ) {
    blockLength
    customEvent {
      color
      crew {
        color
        displayName
        employees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        rate
      }
      customEventBlocks {
        blockLength
        customEvent {
          color
          endsAt
          files {
            id
            name
            path
          }
          id
          name
          notes
          startsAt
        }
        endsAt
        id
        scheduledAt
      }
      endsAt
      id
      name
      notes
      startsAt
    }
    endsAt
    id
    scheduledAt
  }
}
    `;

/**
 * __useGetCustomEventBlocksQuery__
 *
 * To run a query within a React component, call `useGetCustomEventBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomEventBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomEventBlocksQuery({
 *   variables: {
 *      crewId: // value for 'crewId'
 *      customEventIds: // value for 'customEventIds'
 *      dateFrom: // value for 'dateFrom'
 *      dateUntil: // value for 'dateUntil'
 *   },
 * });
 */
export function useGetCustomEventBlocksQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>(GetCustomEventBlocksDocument, options);
      }
export function useGetCustomEventBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>(GetCustomEventBlocksDocument, options);
        }
export type GetCustomEventBlocksQueryHookResult = ReturnType<typeof useGetCustomEventBlocksQuery>;
export type GetCustomEventBlocksLazyQueryHookResult = ReturnType<typeof useGetCustomEventBlocksLazyQuery>;
export type GetCustomEventBlocksQueryResult = Apollo.QueryResult<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>;
export const GetDailyFormInspectionDocument = gql`
    query getDailyFormInspection($id: ID!) {
  getDailyFormInspection(id: $id) {
    createdAt
    dailyFormVehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      registrationExpirationDate
      registrationState
      vin
      year
    }
    id
    lightsWork
    loadStrapped
    oilChecked
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    questionAnswers {
      answer
      id
      isTrue
    }
    tiresAiredBrakesWorking
    toolsLoaded
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    vehicleConditionAcceptable
    vehicleFueled
    vehicleMilleage
  }
}
    `;

/**
 * __useGetDailyFormInspectionQuery__
 *
 * To run a query within a React component, call `useGetDailyFormInspectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormInspectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormInspectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyFormInspectionQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormInspectionQuery, GetDailyFormInspectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormInspectionQuery, GetDailyFormInspectionQueryVariables>(GetDailyFormInspectionDocument, options);
      }
export function useGetDailyFormInspectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormInspectionQuery, GetDailyFormInspectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormInspectionQuery, GetDailyFormInspectionQueryVariables>(GetDailyFormInspectionDocument, options);
        }
export type GetDailyFormInspectionQueryHookResult = ReturnType<typeof useGetDailyFormInspectionQuery>;
export type GetDailyFormInspectionLazyQueryHookResult = ReturnType<typeof useGetDailyFormInspectionLazyQuery>;
export type GetDailyFormInspectionQueryResult = Apollo.QueryResult<GetDailyFormInspectionQuery, GetDailyFormInspectionQueryVariables>;
export const GetDailyFormInspectionQuestionDocument = gql`
    query getDailyFormInspectionQuestion($id: ID!) {
  getDailyFormInspectionQuestion(id: $id) {
    id
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    question
    type
  }
}
    `;

/**
 * __useGetDailyFormInspectionQuestionQuery__
 *
 * To run a query within a React component, call `useGetDailyFormInspectionQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormInspectionQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormInspectionQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyFormInspectionQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormInspectionQuestionQuery, GetDailyFormInspectionQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormInspectionQuestionQuery, GetDailyFormInspectionQuestionQueryVariables>(GetDailyFormInspectionQuestionDocument, options);
      }
export function useGetDailyFormInspectionQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormInspectionQuestionQuery, GetDailyFormInspectionQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormInspectionQuestionQuery, GetDailyFormInspectionQuestionQueryVariables>(GetDailyFormInspectionQuestionDocument, options);
        }
export type GetDailyFormInspectionQuestionQueryHookResult = ReturnType<typeof useGetDailyFormInspectionQuestionQuery>;
export type GetDailyFormInspectionQuestionLazyQueryHookResult = ReturnType<typeof useGetDailyFormInspectionQuestionLazyQuery>;
export type GetDailyFormInspectionQuestionQueryResult = Apollo.QueryResult<GetDailyFormInspectionQuestionQuery, GetDailyFormInspectionQuestionQueryVariables>;
export const GetDailyFormInspectionQuestionsDocument = gql`
    query getDailyFormInspectionQuestions {
  getDailyFormInspectionQuestions {
    id
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    question
    type
  }
}
    `;

/**
 * __useGetDailyFormInspectionQuestionsQuery__
 *
 * To run a query within a React component, call `useGetDailyFormInspectionQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormInspectionQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormInspectionQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDailyFormInspectionQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDailyFormInspectionQuestionsQuery, GetDailyFormInspectionQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormInspectionQuestionsQuery, GetDailyFormInspectionQuestionsQueryVariables>(GetDailyFormInspectionQuestionsDocument, options);
      }
export function useGetDailyFormInspectionQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormInspectionQuestionsQuery, GetDailyFormInspectionQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormInspectionQuestionsQuery, GetDailyFormInspectionQuestionsQueryVariables>(GetDailyFormInspectionQuestionsDocument, options);
        }
export type GetDailyFormInspectionQuestionsQueryHookResult = ReturnType<typeof useGetDailyFormInspectionQuestionsQuery>;
export type GetDailyFormInspectionQuestionsLazyQueryHookResult = ReturnType<typeof useGetDailyFormInspectionQuestionsLazyQuery>;
export type GetDailyFormInspectionQuestionsQueryResult = Apollo.QueryResult<GetDailyFormInspectionQuestionsQuery, GetDailyFormInspectionQuestionsQueryVariables>;
export const GetDailyFormInspectionsDocument = gql`
    query getDailyFormInspections($dailyFormVehicleId: ID, $dateSubmitted: DateTime, $first: Int!, $page: Int, $sortDirection: SortDirection, $sortKey: QueryDailyFormInspectionsSortKey) {
  getDailyFormInspections(
    dailyFormVehicleId: $dailyFormVehicleId
    dateSubmitted: $dateSubmitted
    first: $first
    page: $page
    sortDirection: $sortDirection
    sortKey: $sortKey
  ) {
    data {
      createdAt
      dailyFormVehicle {
        currentMeterReading
        dailyFormVehicleType {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        defaultServiceIntervalUnit
        defaultServiceIntervalValue
        id
        inServiceDate
        inspections {
          createdAt
          dailyFormVehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          id
          lightsWork
          loadStrapped
          oilChecked
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          questionAnswers {
            answer
            id
            isTrue
          }
          tiresAiredBrakesWorking
          toolsLoaded
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicleConditionAcceptable
          vehicleFueled
          vehicleMilleage
        }
        isActive
        licensePlate
        make
        meterType
        model
        name
        notes
        parts {
          id
          name
          notes
          partNumber
          quantity
          unitPrice
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          vendorName
        }
        registrationExpirationDate
        registrationState
        servicePlans {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        vin
        workOrders {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        year
      }
      id
      lightsWork
      loadStrapped
      oilChecked
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      questionAnswers {
        answer
        id
        inspection {
          createdAt
          dailyFormVehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          id
          lightsWork
          loadStrapped
          oilChecked
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          questionAnswers {
            answer
            id
            isTrue
          }
          tiresAiredBrakesWorking
          toolsLoaded
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicleConditionAcceptable
          vehicleFueled
          vehicleMilleage
        }
        isTrue
        question {
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          question
          type
        }
      }
      tiresAiredBrakesWorking
      toolsLoaded
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      vehicleConditionAcceptable
      vehicleFueled
      vehicleMilleage
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetDailyFormInspectionsQuery__
 *
 * To run a query within a React component, call `useGetDailyFormInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormInspectionsQuery({
 *   variables: {
 *      dailyFormVehicleId: // value for 'dailyFormVehicleId'
 *      dateSubmitted: // value for 'dateSubmitted'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useGetDailyFormInspectionsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormInspectionsQuery, GetDailyFormInspectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormInspectionsQuery, GetDailyFormInspectionsQueryVariables>(GetDailyFormInspectionsDocument, options);
      }
export function useGetDailyFormInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormInspectionsQuery, GetDailyFormInspectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormInspectionsQuery, GetDailyFormInspectionsQueryVariables>(GetDailyFormInspectionsDocument, options);
        }
export type GetDailyFormInspectionsQueryHookResult = ReturnType<typeof useGetDailyFormInspectionsQuery>;
export type GetDailyFormInspectionsLazyQueryHookResult = ReturnType<typeof useGetDailyFormInspectionsLazyQuery>;
export type GetDailyFormInspectionsQueryResult = Apollo.QueryResult<GetDailyFormInspectionsQuery, GetDailyFormInspectionsQueryVariables>;
export const GetDailyFormVehicleDocument = gql`
    query getDailyFormVehicle($id: ID!) {
  getDailyFormVehicle(id: $id) {
    currentMeterReading
    dailyFormVehicleType {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    defaultServiceIntervalUnit
    defaultServiceIntervalValue
    id
    inServiceDate
    inspections {
      createdAt
      dailyFormVehicle {
        currentMeterReading
        dailyFormVehicleType {
          id
          name
        }
        defaultServiceIntervalUnit
        defaultServiceIntervalValue
        id
        inServiceDate
        inspections {
          createdAt
          id
          lightsWork
          loadStrapped
          oilChecked
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          questionAnswers {
            answer
            id
            isTrue
          }
          tiresAiredBrakesWorking
          toolsLoaded
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicleConditionAcceptable
          vehicleFueled
          vehicleMilleage
        }
        isActive
        licensePlate
        make
        meterType
        model
        name
        notes
        parts {
          id
          name
          notes
          partNumber
          quantity
          unitPrice
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          vendorName
        }
        registrationExpirationDate
        registrationState
        servicePlans {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        vin
        workOrders {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        year
      }
      id
      lightsWork
      loadStrapped
      oilChecked
      tiresAiredBrakesWorking
      toolsLoaded
      vehicleConditionAcceptable
      vehicleFueled
      vehicleMilleage
    }
    isActive
    licensePlate
    make
    meterType
    model
    name
    notes
    parts {
      id
      name
      notes
      partNumber
      quantity
      unitPrice
      vendorName
    }
    registrationExpirationDate
    registrationState
    servicePlans {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    vin
    workOrders {
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      status
    }
    year
  }
}
    `;

/**
 * __useGetDailyFormVehicleQuery__
 *
 * To run a query within a React component, call `useGetDailyFormVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormVehicleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyFormVehicleQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormVehicleQuery, GetDailyFormVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormVehicleQuery, GetDailyFormVehicleQueryVariables>(GetDailyFormVehicleDocument, options);
      }
export function useGetDailyFormVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormVehicleQuery, GetDailyFormVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormVehicleQuery, GetDailyFormVehicleQueryVariables>(GetDailyFormVehicleDocument, options);
        }
export type GetDailyFormVehicleQueryHookResult = ReturnType<typeof useGetDailyFormVehicleQuery>;
export type GetDailyFormVehicleLazyQueryHookResult = ReturnType<typeof useGetDailyFormVehicleLazyQuery>;
export type GetDailyFormVehicleQueryResult = Apollo.QueryResult<GetDailyFormVehicleQuery, GetDailyFormVehicleQueryVariables>;
export const GetDailyFormVehiclePartDocument = gql`
    query getDailyFormVehiclePart($id: ID!) {
  getDailyFormVehiclePart(id: $id) {
    id
    name
    notes
    partNumber
    quantity
    unitPrice
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    vendorName
  }
}
    `;

/**
 * __useGetDailyFormVehiclePartQuery__
 *
 * To run a query within a React component, call `useGetDailyFormVehiclePartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormVehiclePartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormVehiclePartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyFormVehiclePartQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormVehiclePartQuery, GetDailyFormVehiclePartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormVehiclePartQuery, GetDailyFormVehiclePartQueryVariables>(GetDailyFormVehiclePartDocument, options);
      }
export function useGetDailyFormVehiclePartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormVehiclePartQuery, GetDailyFormVehiclePartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormVehiclePartQuery, GetDailyFormVehiclePartQueryVariables>(GetDailyFormVehiclePartDocument, options);
        }
export type GetDailyFormVehiclePartQueryHookResult = ReturnType<typeof useGetDailyFormVehiclePartQuery>;
export type GetDailyFormVehiclePartLazyQueryHookResult = ReturnType<typeof useGetDailyFormVehiclePartLazyQuery>;
export type GetDailyFormVehiclePartQueryResult = Apollo.QueryResult<GetDailyFormVehiclePartQuery, GetDailyFormVehiclePartQueryVariables>;
export const GetDailyFormVehiclePartsDocument = gql`
    query getDailyFormVehicleParts {
  getDailyFormVehicleParts {
    id
    name
    notes
    partNumber
    quantity
    unitPrice
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    vendorName
  }
}
    `;

/**
 * __useGetDailyFormVehiclePartsQuery__
 *
 * To run a query within a React component, call `useGetDailyFormVehiclePartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormVehiclePartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormVehiclePartsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDailyFormVehiclePartsQuery(baseOptions?: Apollo.QueryHookOptions<GetDailyFormVehiclePartsQuery, GetDailyFormVehiclePartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormVehiclePartsQuery, GetDailyFormVehiclePartsQueryVariables>(GetDailyFormVehiclePartsDocument, options);
      }
export function useGetDailyFormVehiclePartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormVehiclePartsQuery, GetDailyFormVehiclePartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormVehiclePartsQuery, GetDailyFormVehiclePartsQueryVariables>(GetDailyFormVehiclePartsDocument, options);
        }
export type GetDailyFormVehiclePartsQueryHookResult = ReturnType<typeof useGetDailyFormVehiclePartsQuery>;
export type GetDailyFormVehiclePartsLazyQueryHookResult = ReturnType<typeof useGetDailyFormVehiclePartsLazyQuery>;
export type GetDailyFormVehiclePartsQueryResult = Apollo.QueryResult<GetDailyFormVehiclePartsQuery, GetDailyFormVehiclePartsQueryVariables>;
export const GetDailyFormVehicleServicePlanDocument = gql`
    query getDailyFormVehicleServicePlan($id: ID!) {
  getDailyFormVehicleServicePlan(id: $id) {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    autoCreateTask
    id
    intervalUnit
    intervalValue
    isActive
    issueType
    lastCompletedAt
    lastCompletedMeterReading
    leadUnit
    leadValue
    name
    nextDueDate
    nextDueMeterReading
    notes
    priority
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    workOrders {
      assignedTo {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      files {
        dailyFormWorkOrder {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        path
      }
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      servicePlan {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        autoCreateTask
        id
        intervalUnit
        intervalValue
        isActive
        issueType
        lastCompletedAt
        lastCompletedMeterReading
        leadUnit
        leadValue
        name
        nextDueDate
        nextDueMeterReading
        notes
        priority
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          vin
          year
        }
        workOrders {
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
      }
      status
    }
  }
}
    `;

/**
 * __useGetDailyFormVehicleServicePlanQuery__
 *
 * To run a query within a React component, call `useGetDailyFormVehicleServicePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormVehicleServicePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormVehicleServicePlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyFormVehicleServicePlanQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormVehicleServicePlanQuery, GetDailyFormVehicleServicePlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormVehicleServicePlanQuery, GetDailyFormVehicleServicePlanQueryVariables>(GetDailyFormVehicleServicePlanDocument, options);
      }
export function useGetDailyFormVehicleServicePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormVehicleServicePlanQuery, GetDailyFormVehicleServicePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormVehicleServicePlanQuery, GetDailyFormVehicleServicePlanQueryVariables>(GetDailyFormVehicleServicePlanDocument, options);
        }
export type GetDailyFormVehicleServicePlanQueryHookResult = ReturnType<typeof useGetDailyFormVehicleServicePlanQuery>;
export type GetDailyFormVehicleServicePlanLazyQueryHookResult = ReturnType<typeof useGetDailyFormVehicleServicePlanLazyQuery>;
export type GetDailyFormVehicleServicePlanQueryResult = Apollo.QueryResult<GetDailyFormVehicleServicePlanQuery, GetDailyFormVehicleServicePlanQueryVariables>;
export const GetDailyFormVehicleServicePlansDocument = gql`
    query getDailyFormVehicleServicePlans {
  getDailyFormVehicleServicePlans {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    autoCreateTask
    id
    intervalUnit
    intervalValue
    isActive
    issueType
    lastCompletedAt
    lastCompletedMeterReading
    leadUnit
    leadValue
    name
    nextDueDate
    nextDueMeterReading
    notes
    priority
    vehicle {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      vin
      year
    }
    workOrders {
      assignedTo {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      files {
        dailyFormWorkOrder {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        path
      }
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      servicePlan {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        autoCreateTask
        id
        intervalUnit
        intervalValue
        isActive
        issueType
        lastCompletedAt
        lastCompletedMeterReading
        leadUnit
        leadValue
        name
        nextDueDate
        nextDueMeterReading
        notes
        priority
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          vin
          year
        }
        workOrders {
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
      }
      status
    }
  }
}
    `;

/**
 * __useGetDailyFormVehicleServicePlansQuery__
 *
 * To run a query within a React component, call `useGetDailyFormVehicleServicePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormVehicleServicePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormVehicleServicePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDailyFormVehicleServicePlansQuery(baseOptions?: Apollo.QueryHookOptions<GetDailyFormVehicleServicePlansQuery, GetDailyFormVehicleServicePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormVehicleServicePlansQuery, GetDailyFormVehicleServicePlansQueryVariables>(GetDailyFormVehicleServicePlansDocument, options);
      }
export function useGetDailyFormVehicleServicePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormVehicleServicePlansQuery, GetDailyFormVehicleServicePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormVehicleServicePlansQuery, GetDailyFormVehicleServicePlansQueryVariables>(GetDailyFormVehicleServicePlansDocument, options);
        }
export type GetDailyFormVehicleServicePlansQueryHookResult = ReturnType<typeof useGetDailyFormVehicleServicePlansQuery>;
export type GetDailyFormVehicleServicePlansLazyQueryHookResult = ReturnType<typeof useGetDailyFormVehicleServicePlansLazyQuery>;
export type GetDailyFormVehicleServicePlansQueryResult = Apollo.QueryResult<GetDailyFormVehicleServicePlansQuery, GetDailyFormVehicleServicePlansQueryVariables>;
export const GetDailyFormVehicleTypeDocument = gql`
    query getDailyFormVehicleType($id: ID!) {
  getDailyFormVehicleType(id: $id) {
    id
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;

/**
 * __useGetDailyFormVehicleTypeQuery__
 *
 * To run a query within a React component, call `useGetDailyFormVehicleTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormVehicleTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormVehicleTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyFormVehicleTypeQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormVehicleTypeQuery, GetDailyFormVehicleTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormVehicleTypeQuery, GetDailyFormVehicleTypeQueryVariables>(GetDailyFormVehicleTypeDocument, options);
      }
export function useGetDailyFormVehicleTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormVehicleTypeQuery, GetDailyFormVehicleTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormVehicleTypeQuery, GetDailyFormVehicleTypeQueryVariables>(GetDailyFormVehicleTypeDocument, options);
        }
export type GetDailyFormVehicleTypeQueryHookResult = ReturnType<typeof useGetDailyFormVehicleTypeQuery>;
export type GetDailyFormVehicleTypeLazyQueryHookResult = ReturnType<typeof useGetDailyFormVehicleTypeLazyQuery>;
export type GetDailyFormVehicleTypeQueryResult = Apollo.QueryResult<GetDailyFormVehicleTypeQuery, GetDailyFormVehicleTypeQueryVariables>;
export const GetDailyFormVehicleTypesDocument = gql`
    query getDailyFormVehicleTypes {
  getDailyFormVehicleTypes {
    id
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;

/**
 * __useGetDailyFormVehicleTypesQuery__
 *
 * To run a query within a React component, call `useGetDailyFormVehicleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormVehicleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormVehicleTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDailyFormVehicleTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetDailyFormVehicleTypesQuery, GetDailyFormVehicleTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormVehicleTypesQuery, GetDailyFormVehicleTypesQueryVariables>(GetDailyFormVehicleTypesDocument, options);
      }
export function useGetDailyFormVehicleTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormVehicleTypesQuery, GetDailyFormVehicleTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormVehicleTypesQuery, GetDailyFormVehicleTypesQueryVariables>(GetDailyFormVehicleTypesDocument, options);
        }
export type GetDailyFormVehicleTypesQueryHookResult = ReturnType<typeof useGetDailyFormVehicleTypesQuery>;
export type GetDailyFormVehicleTypesLazyQueryHookResult = ReturnType<typeof useGetDailyFormVehicleTypesLazyQuery>;
export type GetDailyFormVehicleTypesQueryResult = Apollo.QueryResult<GetDailyFormVehicleTypesQuery, GetDailyFormVehicleTypesQueryVariables>;
export const GetDailyFormVehiclesDocument = gql`
    query getDailyFormVehicles($first: Int!, $page: Int) {
  getDailyFormVehicles(first: $first, page: $page) {
    data {
      currentMeterReading
      dailyFormVehicleType {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      inspections {
        createdAt
        dailyFormVehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        id
        lightsWork
        loadStrapped
        oilChecked
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        questionAnswers {
          answer
          id
          inspection {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isTrue
          question {
            id
            question
            type
          }
        }
        tiresAiredBrakesWorking
        toolsLoaded
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicleConditionAcceptable
        vehicleFueled
        vehicleMilleage
      }
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      parts {
        id
        name
        notes
        partNumber
        quantity
        unitPrice
        vehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        vendorName
      }
      registrationExpirationDate
      registrationState
      servicePlans {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        autoCreateTask
        id
        intervalUnit
        intervalValue
        isActive
        issueType
        lastCompletedAt
        lastCompletedMeterReading
        leadUnit
        leadValue
        name
        nextDueDate
        nextDueMeterReading
        notes
        priority
        vehicle {
          currentMeterReading
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          registrationExpirationDate
          registrationState
          vin
          year
        }
        workOrders {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
      }
      vin
      workOrders {
        comments
        completedAt
        createdAt
        currentMeterReading
        estimatedTaskTime
        id
        issueDescription
        issueName
        issueType
        neededCompletionDate
        priority
        status
      }
      year
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetDailyFormVehiclesQuery__
 *
 * To run a query within a React component, call `useGetDailyFormVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormVehiclesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetDailyFormVehiclesQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormVehiclesQuery, GetDailyFormVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormVehiclesQuery, GetDailyFormVehiclesQueryVariables>(GetDailyFormVehiclesDocument, options);
      }
export function useGetDailyFormVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormVehiclesQuery, GetDailyFormVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormVehiclesQuery, GetDailyFormVehiclesQueryVariables>(GetDailyFormVehiclesDocument, options);
        }
export type GetDailyFormVehiclesQueryHookResult = ReturnType<typeof useGetDailyFormVehiclesQuery>;
export type GetDailyFormVehiclesLazyQueryHookResult = ReturnType<typeof useGetDailyFormVehiclesLazyQuery>;
export type GetDailyFormVehiclesQueryResult = Apollo.QueryResult<GetDailyFormVehiclesQuery, GetDailyFormVehiclesQueryVariables>;
export const GetDailyFormWorkOrderDocument = gql`
    query getDailyFormWorkOrder($id: ID!) {
  getDailyFormWorkOrder(id: $id) {
    assignedTo {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    comments
    completedAt
    createdAt
    currentMeterReading
    estimatedTaskTime
    files {
      dailyFormWorkOrder {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        comments
        completedAt
        createdAt
        currentMeterReading
        estimatedTaskTime
        files {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
        }
        id
        issueDescription
        issueName
        issueType
        neededCompletionDate
        priority
        servicePlan {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          autoCreateTask
          id
          intervalUnit
          intervalValue
          isActive
          issueType
          lastCompletedAt
          lastCompletedMeterReading
          leadUnit
          leadValue
          name
          nextDueDate
          nextDueMeterReading
          notes
          priority
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
        }
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        vehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
      }
      id
      name
      path
    }
    id
    issueDescription
    issueName
    issueType
    neededCompletionDate
    priority
    servicePlan {
      autoCreateTask
      id
      intervalUnit
      intervalValue
      isActive
      issueType
      lastCompletedAt
      lastCompletedMeterReading
      leadUnit
      leadValue
      name
      nextDueDate
      nextDueMeterReading
      notes
      priority
    }
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    vehicle {
      currentMeterReading
      defaultServiceIntervalUnit
      defaultServiceIntervalValue
      id
      inServiceDate
      isActive
      licensePlate
      make
      meterType
      model
      name
      notes
      registrationExpirationDate
      registrationState
      vin
      year
    }
  }
}
    `;

/**
 * __useGetDailyFormWorkOrderQuery__
 *
 * To run a query within a React component, call `useGetDailyFormWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormWorkOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormWorkOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyFormWorkOrderQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormWorkOrderQuery, GetDailyFormWorkOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormWorkOrderQuery, GetDailyFormWorkOrderQueryVariables>(GetDailyFormWorkOrderDocument, options);
      }
export function useGetDailyFormWorkOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormWorkOrderQuery, GetDailyFormWorkOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormWorkOrderQuery, GetDailyFormWorkOrderQueryVariables>(GetDailyFormWorkOrderDocument, options);
        }
export type GetDailyFormWorkOrderQueryHookResult = ReturnType<typeof useGetDailyFormWorkOrderQuery>;
export type GetDailyFormWorkOrderLazyQueryHookResult = ReturnType<typeof useGetDailyFormWorkOrderLazyQuery>;
export type GetDailyFormWorkOrderQueryResult = Apollo.QueryResult<GetDailyFormWorkOrderQuery, GetDailyFormWorkOrderQueryVariables>;
export const GetDailyFormWorkOrdersDocument = gql`
    query getDailyFormWorkOrders($assignedTo: ID, $completedDate: Date, $first: Int!, $multipleAssignedTo: [ID!], $multiplePriorities: [DailyFormIssuePriority!], $multipleStatuses: [DailyFormIssueStatus!], $neededCompletionDate: Date, $page: Int, $priority: DailyFormIssuePriority, $search: String, $sortDirection: SortDirection, $sortKey: QueryDailyFormWorkOrdersSortKey, $status: DailyFormIssueStatus, $vehicleId: ID) {
  getDailyFormWorkOrders(
    assignedTo: $assignedTo
    completedDate: $completedDate
    first: $first
    multipleAssignedTo: $multipleAssignedTo
    multiplePriorities: $multiplePriorities
    multipleStatuses: $multipleStatuses
    neededCompletionDate: $neededCompletionDate
    page: $page
    priority: $priority
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    status: $status
    vehicleId: $vehicleId
  ) {
    data {
      assignedTo {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      comments
      completedAt
      createdAt
      currentMeterReading
      estimatedTaskTime
      files {
        dailyFormWorkOrder {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        path
      }
      id
      issueDescription
      issueName
      issueType
      neededCompletionDate
      priority
      servicePlan {
        assignedTo {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        autoCreateTask
        id
        intervalUnit
        intervalValue
        isActive
        issueType
        lastCompletedAt
        lastCompletedMeterReading
        leadUnit
        leadValue
        name
        nextDueDate
        nextDueMeterReading
        notes
        priority
        vehicle {
          currentMeterReading
          dailyFormVehicleType {
            id
            name
          }
          defaultServiceIntervalUnit
          defaultServiceIntervalValue
          id
          inServiceDate
          inspections {
            createdAt
            id
            lightsWork
            loadStrapped
            oilChecked
            tiresAiredBrakesWorking
            toolsLoaded
            vehicleConditionAcceptable
            vehicleFueled
            vehicleMilleage
          }
          isActive
          licensePlate
          make
          meterType
          model
          name
          notes
          parts {
            id
            name
            notes
            partNumber
            quantity
            unitPrice
            vendorName
          }
          registrationExpirationDate
          registrationState
          servicePlans {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          vin
          workOrders {
            comments
            completedAt
            createdAt
            currentMeterReading
            estimatedTaskTime
            id
            issueDescription
            issueName
            issueType
            neededCompletionDate
            priority
            status
          }
          year
        }
        workOrders {
          assignedTo {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          comments
          completedAt
          createdAt
          currentMeterReading
          estimatedTaskTime
          files {
            id
            name
            path
          }
          id
          issueDescription
          issueName
          issueType
          neededCompletionDate
          priority
          servicePlan {
            autoCreateTask
            id
            intervalUnit
            intervalValue
            isActive
            issueType
            lastCompletedAt
            lastCompletedMeterReading
            leadUnit
            leadValue
            name
            nextDueDate
            nextDueMeterReading
            notes
            priority
          }
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          vehicle {
            currentMeterReading
            defaultServiceIntervalUnit
            defaultServiceIntervalValue
            id
            inServiceDate
            isActive
            licensePlate
            make
            meterType
            model
            name
            notes
            registrationExpirationDate
            registrationState
            vin
            year
          }
        }
      }
      status
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      vehicle {
        currentMeterReading
        defaultServiceIntervalUnit
        defaultServiceIntervalValue
        id
        inServiceDate
        isActive
        licensePlate
        make
        meterType
        model
        name
        notes
        registrationExpirationDate
        registrationState
        vin
        year
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetDailyFormWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetDailyFormWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyFormWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyFormWorkOrdersQuery({
 *   variables: {
 *      assignedTo: // value for 'assignedTo'
 *      completedDate: // value for 'completedDate'
 *      first: // value for 'first'
 *      multipleAssignedTo: // value for 'multipleAssignedTo'
 *      multiplePriorities: // value for 'multiplePriorities'
 *      multipleStatuses: // value for 'multipleStatuses'
 *      neededCompletionDate: // value for 'neededCompletionDate'
 *      page: // value for 'page'
 *      priority: // value for 'priority'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      status: // value for 'status'
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useGetDailyFormWorkOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetDailyFormWorkOrdersQuery, GetDailyFormWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyFormWorkOrdersQuery, GetDailyFormWorkOrdersQueryVariables>(GetDailyFormWorkOrdersDocument, options);
      }
export function useGetDailyFormWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyFormWorkOrdersQuery, GetDailyFormWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyFormWorkOrdersQuery, GetDailyFormWorkOrdersQueryVariables>(GetDailyFormWorkOrdersDocument, options);
        }
export type GetDailyFormWorkOrdersQueryHookResult = ReturnType<typeof useGetDailyFormWorkOrdersQuery>;
export type GetDailyFormWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetDailyFormWorkOrdersLazyQuery>;
export type GetDailyFormWorkOrdersQueryResult = Apollo.QueryResult<GetDailyFormWorkOrdersQuery, GetDailyFormWorkOrdersQueryVariables>;
export const GetDashboardExtraKpisYtdDocument = gql`
    query getDashboardExtraKpisYtd {
  getDashboardExtraKpisYtd {
    averageProposalAmount
    jobsWonCount
    organizationSalesGoal
    pace
    percentToGoal
    totalPipeline
    weightedForecast30Days
    weightedForecast60Days
    weightedPipeline
  }
}
    `;

/**
 * __useGetDashboardExtraKpisYtdQuery__
 *
 * To run a query within a React component, call `useGetDashboardExtraKpisYtdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardExtraKpisYtdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardExtraKpisYtdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardExtraKpisYtdQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardExtraKpisYtdQuery, GetDashboardExtraKpisYtdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardExtraKpisYtdQuery, GetDashboardExtraKpisYtdQueryVariables>(GetDashboardExtraKpisYtdDocument, options);
      }
export function useGetDashboardExtraKpisYtdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardExtraKpisYtdQuery, GetDashboardExtraKpisYtdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardExtraKpisYtdQuery, GetDashboardExtraKpisYtdQueryVariables>(GetDashboardExtraKpisYtdDocument, options);
        }
export type GetDashboardExtraKpisYtdQueryHookResult = ReturnType<typeof useGetDashboardExtraKpisYtdQuery>;
export type GetDashboardExtraKpisYtdLazyQueryHookResult = ReturnType<typeof useGetDashboardExtraKpisYtdLazyQuery>;
export type GetDashboardExtraKpisYtdQueryResult = Apollo.QueryResult<GetDashboardExtraKpisYtdQuery, GetDashboardExtraKpisYtdQueryVariables>;
export const GetDashboardMapDataDocument = gql`
    query getDashboardMapData {
  getDashboardMapData {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;

/**
 * __useGetDashboardMapDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardMapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardMapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardMapDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardMapDataQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>(GetDashboardMapDataDocument, options);
      }
export function useGetDashboardMapDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>(GetDashboardMapDataDocument, options);
        }
export type GetDashboardMapDataQueryHookResult = ReturnType<typeof useGetDashboardMapDataQuery>;
export type GetDashboardMapDataLazyQueryHookResult = ReturnType<typeof useGetDashboardMapDataLazyQuery>;
export type GetDashboardMapDataQueryResult = Apollo.QueryResult<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>;
export const GetEmployeeDocument = gql`
    query getEmployee($id: ID!) {
  getEmployee(id: $id) {
    archivedAt
    firstName
    id
    lastName
    name
    organizationId
    rate
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetEmployeesDocument = gql`
    query getEmployees($archived: Boolean, $first: Int!, $page: Int, $search: String, $sort: SortDirection) {
  getEmployees(
    archived: $archived
    first: $first
    page: $page
    search: $search
    sort: $sort
  ) {
    data {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetEnabledContentTypesForLayoutDocument = gql`
    query getEnabledContentTypesForLayout($layout: ProposalLayout!) {
  getEnabledContentTypesForLayout(layout: $layout) {
    contentType
    id
    organizationId
    showOnBranded
    showOnFull
    showOnSimple
    showOnTabular
  }
}
    `;

/**
 * __useGetEnabledContentTypesForLayoutQuery__
 *
 * To run a query within a React component, call `useGetEnabledContentTypesForLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledContentTypesForLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledContentTypesForLayoutQuery({
 *   variables: {
 *      layout: // value for 'layout'
 *   },
 * });
 */
export function useGetEnabledContentTypesForLayoutQuery(baseOptions: Apollo.QueryHookOptions<GetEnabledContentTypesForLayoutQuery, GetEnabledContentTypesForLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnabledContentTypesForLayoutQuery, GetEnabledContentTypesForLayoutQueryVariables>(GetEnabledContentTypesForLayoutDocument, options);
      }
export function useGetEnabledContentTypesForLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnabledContentTypesForLayoutQuery, GetEnabledContentTypesForLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnabledContentTypesForLayoutQuery, GetEnabledContentTypesForLayoutQueryVariables>(GetEnabledContentTypesForLayoutDocument, options);
        }
export type GetEnabledContentTypesForLayoutQueryHookResult = ReturnType<typeof useGetEnabledContentTypesForLayoutQuery>;
export type GetEnabledContentTypesForLayoutLazyQueryHookResult = ReturnType<typeof useGetEnabledContentTypesForLayoutLazyQuery>;
export type GetEnabledContentTypesForLayoutQueryResult = Apollo.QueryResult<GetEnabledContentTypesForLayoutQuery, GetEnabledContentTypesForLayoutQueryVariables>;
export const GetEquipmentPieceDocument = gql`
    query getEquipmentPiece($id: ID!) {
  getEquipmentPiece(id: $id) {
    calculateTravelTime
    chargeType
    fuelSurcharge
    id
    name
    rate
    usePercentage
  }
}
    `;

/**
 * __useGetEquipmentPieceQuery__
 *
 * To run a query within a React component, call `useGetEquipmentPieceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentPieceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentPieceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEquipmentPieceQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>(GetEquipmentPieceDocument, options);
      }
export function useGetEquipmentPieceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>(GetEquipmentPieceDocument, options);
        }
export type GetEquipmentPieceQueryHookResult = ReturnType<typeof useGetEquipmentPieceQuery>;
export type GetEquipmentPieceLazyQueryHookResult = ReturnType<typeof useGetEquipmentPieceLazyQuery>;
export type GetEquipmentPieceQueryResult = Apollo.QueryResult<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>;
export const GetEquipmentPiecesDocument = gql`
    query getEquipmentPieces($first: Int!, $page: Int, $search: String, $sort: SortDirection) {
  getEquipmentPieces(first: $first, page: $page, search: $search, sort: $sort) {
    data {
      calculateTravelTime
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetEquipmentPiecesQuery__
 *
 * To run a query within a React component, call `useGetEquipmentPiecesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentPiecesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentPiecesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEquipmentPiecesQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>(GetEquipmentPiecesDocument, options);
      }
export function useGetEquipmentPiecesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>(GetEquipmentPiecesDocument, options);
        }
export type GetEquipmentPiecesQueryHookResult = ReturnType<typeof useGetEquipmentPiecesQuery>;
export type GetEquipmentPiecesLazyQueryHookResult = ReturnType<typeof useGetEquipmentPiecesLazyQuery>;
export type GetEquipmentPiecesQueryResult = Apollo.QueryResult<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>;
export const GetInvoiceDocument = gql`
    query getInvoice($id: ID!) {
  getInvoice(id: $id) {
    data
    hideLineItemPricing
    id
    isOverdue
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      billingStatus
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      invoiceId
      jobPhases {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          billingStatus
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          id
          invoiceId
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    link
    paidAt
    sentAt
    status
    uuid
  }
}
    `;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
      }
export function useGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export type GetInvoiceQueryResult = Apollo.QueryResult<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const GetInvoicesDocument = gql`
    query getInvoices($billingStatuses: [JobBillingStatus!], $companyId: ID, $first: Int!, $isOverdue: Boolean, $jobStatuses: [JobStatus!], $multipleCompanyIDs: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetInvoicesSortKey, $status: InvoiceStatus) {
  getInvoices(
    billingStatuses: $billingStatuses
    companyId: $companyId
    first: $first
    isOverdue: $isOverdue
    jobStatuses: $jobStatuses
    multipleCompanyIDs: $multipleCompanyIDs
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    status: $status
  ) {
    data {
      data
      hideLineItemPricing
      id
      isOverdue
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        checklistItems {
          checklistItem {
            id
            name
          }
          checklistItemId
          id
          isCompleted
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        invoiceId
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
      }
      link
      paidAt
      sentAt
      status
      uuid
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      billingStatuses: // value for 'billingStatuses'
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      isOverdue: // value for 'isOverdue'
 *      jobStatuses: // value for 'jobStatuses'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetJobDocument = gql`
    query getJob($id: ID!) {
  getJob(id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    depositCollectedAt
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    id
    invoiceId
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItemId
        id
        isCompleted
        jobPhaseId
      }
      checklistNotes
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      costingMode
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        id
        invoiceId
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        rate
        type
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        rate
        type
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        discount
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        unitPriceOverride
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
  }
}
    `;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const GetJobBillingStatusesDocument = gql`
    query getJobBillingStatuses {
  getJobBillingStatuses {
    statuses
  }
}
    `;

/**
 * __useGetJobBillingStatusesQuery__
 *
 * To run a query within a React component, call `useGetJobBillingStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobBillingStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobBillingStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobBillingStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>(GetJobBillingStatusesDocument, options);
      }
export function useGetJobBillingStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>(GetJobBillingStatusesDocument, options);
        }
export type GetJobBillingStatusesQueryHookResult = ReturnType<typeof useGetJobBillingStatusesQuery>;
export type GetJobBillingStatusesLazyQueryHookResult = ReturnType<typeof useGetJobBillingStatusesLazyQuery>;
export type GetJobBillingStatusesQueryResult = Apollo.QueryResult<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>;
export const GetJobCitiesDocument = gql`
    query getJobCities {
  getJobCities
}
    `;

/**
 * __useGetJobCitiesQuery__
 *
 * To run a query within a React component, call `useGetJobCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobCitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetJobCitiesQuery, GetJobCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobCitiesQuery, GetJobCitiesQueryVariables>(GetJobCitiesDocument, options);
      }
export function useGetJobCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobCitiesQuery, GetJobCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobCitiesQuery, GetJobCitiesQueryVariables>(GetJobCitiesDocument, options);
        }
export type GetJobCitiesQueryHookResult = ReturnType<typeof useGetJobCitiesQuery>;
export type GetJobCitiesLazyQueryHookResult = ReturnType<typeof useGetJobCitiesLazyQuery>;
export type GetJobCitiesQueryResult = Apollo.QueryResult<GetJobCitiesQuery, GetJobCitiesQueryVariables>;
export const GetJobCostingLapsedReportDocument = gql`
    query getJobCostingLapsedReport($first: Int!, $jobsInPast: Boolean, $jobsWithoutCosts: Boolean, $page: Int, $sortDirection: SortDirection, $sortKey: GetJobCostingLapsedReportSortKey, $statuses: [JobStatus!]) {
  getJobCostingLapsedReport(
    first: $first
    jobsInPast: $jobsInPast
    jobsWithoutCosts: $jobsWithoutCosts
    page: $page
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
  ) {
    data {
      actualOverallTotal
      allPhasesMissingCost
      clientName
      endsAt
      externalId
      id
      jobName
      phaseMissingCost
      phases {
        actualOverallTotal
        endsAt
        externalId
        id
        jobId
        missingCost
        productType
        proposedOverallTotal
        status
        varianceAmount
        variancePercent
      }
      proposedOverallTotal
      status
      varianceAmount
      variancePercent
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetJobCostingLapsedReportQuery__
 *
 * To run a query within a React component, call `useGetJobCostingLapsedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCostingLapsedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCostingLapsedReportQuery({
 *   variables: {
 *      first: // value for 'first'
 *      jobsInPast: // value for 'jobsInPast'
 *      jobsWithoutCosts: // value for 'jobsWithoutCosts'
 *      page: // value for 'page'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetJobCostingLapsedReportQuery(baseOptions: Apollo.QueryHookOptions<GetJobCostingLapsedReportQuery, GetJobCostingLapsedReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobCostingLapsedReportQuery, GetJobCostingLapsedReportQueryVariables>(GetJobCostingLapsedReportDocument, options);
      }
export function useGetJobCostingLapsedReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobCostingLapsedReportQuery, GetJobCostingLapsedReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobCostingLapsedReportQuery, GetJobCostingLapsedReportQueryVariables>(GetJobCostingLapsedReportDocument, options);
        }
export type GetJobCostingLapsedReportQueryHookResult = ReturnType<typeof useGetJobCostingLapsedReportQuery>;
export type GetJobCostingLapsedReportLazyQueryHookResult = ReturnType<typeof useGetJobCostingLapsedReportLazyQuery>;
export type GetJobCostingLapsedReportQueryResult = Apollo.QueryResult<GetJobCostingLapsedReportQuery, GetJobCostingLapsedReportQueryVariables>;
export const GetJobInvoiceStatsDocument = gql`
    query getJobInvoiceStats {
  getJobInvoiceStats {
    invoiceStatus
    last30DaysAmount
    yearToDateAmount
  }
}
    `;

/**
 * __useGetJobInvoiceStatsQuery__
 *
 * To run a query within a React component, call `useGetJobInvoiceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobInvoiceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobInvoiceStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobInvoiceStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobInvoiceStatsQuery, GetJobInvoiceStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobInvoiceStatsQuery, GetJobInvoiceStatsQueryVariables>(GetJobInvoiceStatsDocument, options);
      }
export function useGetJobInvoiceStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobInvoiceStatsQuery, GetJobInvoiceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobInvoiceStatsQuery, GetJobInvoiceStatsQueryVariables>(GetJobInvoiceStatsDocument, options);
        }
export type GetJobInvoiceStatsQueryHookResult = ReturnType<typeof useGetJobInvoiceStatsQuery>;
export type GetJobInvoiceStatsLazyQueryHookResult = ReturnType<typeof useGetJobInvoiceStatsLazyQuery>;
export type GetJobInvoiceStatsQueryResult = Apollo.QueryResult<GetJobInvoiceStatsQuery, GetJobInvoiceStatsQueryVariables>;
export const GetJobPhaseDocument = gql`
    query getJobPhase($id: ID!) {
  getJobPhase(id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    actualSubcontractorCost
    actualSubcontractorName
    actualSubcontractorReference
    address
    applicableStatuses
    checklistCompletion {
      allCompleted
      ratio
    }
    checklistItems {
      checklistItem {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      checklistItemId
      id
      isCompleted
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      jobPhaseId
    }
    checklistNotes
    costItems {
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      id
      plantId
      plantProductId
    }
    costingMode
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      archivedAt
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      calculateTravelTime
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    hasJobCostsEntered
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      id
      invoiceId
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    jobCostEntryDaysCount
    jobCostingCompletionStatus
    jobCostingThresholdPercent
    jobCostingVariancePercent
    jobDuration
    jobPhaseMaterialNoPlants {
      cost
      id
      jobPhaseId
      name
      percentage
      quantity
      rate
    }
    jobPhasePlant {
      id
      materialNeeded
      name
      rate
      type
    }
    jobPhasePlants {
      id
      materialNeeded
      name
      rate
      type
    }
    jobSize
    lastJobCostEntryDate
    missingCostCategories
    notes
    ordering
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      discount
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isCustom
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      overallTotalOverride
      productName
      profit
      profitAfterDiscount
      profitOverride
      profitPercentage
      profitPercentageOverride
      proposalProductGroupId
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      unitPriceOverride
    }
    proposalProductGroup {
      id
      isOptional
      name
      ordering
      showIndividualProducts
    }
    proposalStage {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      proposalPlantProductId
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    worksheet {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      scope
      scopeFormat
      sellingTotal
      unit
    }
  }
}
    `;

/**
 * __useGetJobPhaseQuery__
 *
 * To run a query within a React component, call `useGetJobPhaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPhaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPhaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPhaseQuery(baseOptions: Apollo.QueryHookOptions<GetJobPhaseQuery, GetJobPhaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPhaseQuery, GetJobPhaseQueryVariables>(GetJobPhaseDocument, options);
      }
export function useGetJobPhaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPhaseQuery, GetJobPhaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPhaseQuery, GetJobPhaseQueryVariables>(GetJobPhaseDocument, options);
        }
export type GetJobPhaseQueryHookResult = ReturnType<typeof useGetJobPhaseQuery>;
export type GetJobPhaseLazyQueryHookResult = ReturnType<typeof useGetJobPhaseLazyQuery>;
export type GetJobPhaseQueryResult = Apollo.QueryResult<GetJobPhaseQuery, GetJobPhaseQueryVariables>;
export const GetJobPhaseCostItemDocument = gql`
    query getJobPhaseCostItem($date: Date!, $jobPhaseId: ID!) {
  getJobPhaseCostItem(date: $date, jobPhaseId: $jobPhaseId) {
    additionalCosts {
      additionalCostId
      cost
      costTotal
      feeAmount
      feeType
      id
      isSubcontractorCost
      jobPhaseCostItem {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          isSubcontractorCost
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        materialsNoPlants {
          costTotal
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          jobPhaseCostItemId
          name
          quantity
          rate
        }
        plantId
        plantProductId
        plants {
          costTotal
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantId
          plantProduct {
            id
            plantId
            rate
            type
          }
          plantProductId
          quantity
          rate
        }
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
      }
      name
    }
    costAdditional
    costEquipment
    costLabour
    costMaterial
    costTransferTruck
    date
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistNotes
      costingMode
      crewId
      endsAt
      externalId
      hasJobCostsEntered
      id
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    material {
      costMaterial
      id
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    materialsNoPlants {
      costTotal
      id
      jobPhaseCostItemId
      name
      quantity
      rate
    }
    plantId
    plantProductId
    plants {
      costTotal
      id
      plantId
      plantProductId
      quantity
      rate
    }
    transferTrucks {
      hours
      id
      name
      plantTransferTruckId
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
  }
}
    `;

/**
 * __useGetJobPhaseCostItemQuery__
 *
 * To run a query within a React component, call `useGetJobPhaseCostItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPhaseCostItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPhaseCostItemQuery({
 *   variables: {
 *      date: // value for 'date'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useGetJobPhaseCostItemQuery(baseOptions: Apollo.QueryHookOptions<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>(GetJobPhaseCostItemDocument, options);
      }
export function useGetJobPhaseCostItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>(GetJobPhaseCostItemDocument, options);
        }
export type GetJobPhaseCostItemQueryHookResult = ReturnType<typeof useGetJobPhaseCostItemQuery>;
export type GetJobPhaseCostItemLazyQueryHookResult = ReturnType<typeof useGetJobPhaseCostItemLazyQuery>;
export type GetJobPhaseCostItemQueryResult = Apollo.QueryResult<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>;
export const GetJobPhaseCostsDocument = gql`
    query getJobPhaseCosts($id: ID!) {
  getJobPhaseCosts(id: $id) {
    additionalCosts {
      additionalCostId
      cost
      costTotal
      feeAmount
      feeType
      id
      isSubcontractorCost
      jobPhaseCostItem {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          isSubcontractorCost
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        materialsNoPlants {
          costTotal
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          jobPhaseCostItemId
          name
          quantity
          rate
        }
        plantId
        plantProductId
        plants {
          costTotal
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantId
          plantProduct {
            id
            plantId
            rate
            type
          }
          plantProductId
          quantity
          rate
        }
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
      }
      name
    }
    costAdditional
    costEquipment
    costLabour
    costMaterial
    costTransferTruck
    date
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistNotes
      costingMode
      crewId
      endsAt
      externalId
      hasJobCostsEntered
      id
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    material {
      costMaterial
      id
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    materialsNoPlants {
      costTotal
      id
      jobPhaseCostItemId
      name
      quantity
      rate
    }
    plantId
    plantProductId
    plants {
      costTotal
      id
      plantId
      plantProductId
      quantity
      rate
    }
    transferTrucks {
      hours
      id
      name
      plantTransferTruckId
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
  }
}
    `;

/**
 * __useGetJobPhaseCostsQuery__
 *
 * To run a query within a React component, call `useGetJobPhaseCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPhaseCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPhaseCostsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPhaseCostsQuery(baseOptions: Apollo.QueryHookOptions<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>(GetJobPhaseCostsDocument, options);
      }
export function useGetJobPhaseCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>(GetJobPhaseCostsDocument, options);
        }
export type GetJobPhaseCostsQueryHookResult = ReturnType<typeof useGetJobPhaseCostsQuery>;
export type GetJobPhaseCostsLazyQueryHookResult = ReturnType<typeof useGetJobPhaseCostsLazyQuery>;
export type GetJobPhaseCostsQueryResult = Apollo.QueryResult<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>;
export const GetJobPhasesDocument = gql`
    query getJobPhases($billingStatuses: [JobBillingStatus!], $companyId: ID, $crewId: ID, $date: DateTime, $endDate: DateTime, $first: Int!, $foremanUserId: ID, $organizationProductTypeId: ID, $page: Int, $search: String, $searchByName: Boolean, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $startDate: DateTime, $userId: ID) {
  getJobPhases(
    billingStatuses: $billingStatuses
    companyId: $companyId
    crewId: $crewId
    date: $date
    endDate: $endDate
    first: $first
    foremanUserId: $foremanUserId
    organizationProductTypeId: $organizationProductTypeId
    page: $page
    search: $search
    searchByName: $searchByName
    sortDirection: $sortDirection
    sortKey: $sortKey
    startDate: $startDate
    userId: $userId
  ) {
    data {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      checklistNotes
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          isSubcontractorCost
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistNotes
          costingMode
          crewId
          endsAt
          externalId
          hasJobCostsEntered
          id
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organizationProductTypeName
          productName
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          startsAt
          status
          travelTimeEstimate
          usersColor
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        materialsNoPlants {
          costTotal
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          jobPhaseCostItemId
          name
          quantity
          rate
        }
        plantId
        plantProductId
        plants {
          costTotal
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantId
          plantProduct {
            id
            plantId
            rate
            type
          }
          plantProductId
          quantity
          rate
        }
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
      }
      costingMode
      crew {
        color
        displayName
        employees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      defaultEquipmentPieces {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      hasJobCostsEntered
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        depositCollectedAt
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        invoiceId
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
      }
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobPhaseMaterialNoPlants {
        cost
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistNotes
          costingMode
          crewId
          endsAt
          externalId
          hasJobCostsEntered
          id
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organizationProductTypeName
          productName
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          startsAt
          status
          travelTimeEstimate
          usersColor
        }
        jobPhaseId
        name
        percentage
        quantity
        rate
      }
      jobPhasePlant {
        id
        materialNeeded
        name
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProduct {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        rate
        type
        worksheetMaterial {
          quantity
          rate
          unit
        }
      }
      jobPhasePlants {
        id
        materialNeeded
        name
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
        }
        plantProduct {
          id
          plantId
          rate
          type
        }
        rate
        type
        worksheetMaterial {
          quantity
          rate
          unit
        }
      }
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalProduct {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        custom {
          area
          areaSource
          areaUnit
          calculationVersion
          costTotal
          fixedPrice
          helpers {
            hoursPerDay
          }
          indirectPercentage
          internalName
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricing {
            discount
            mode
            value
            version
          }
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            quantitySource
            rate
            rowId
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          sourceProductId
          sourceProductRevision
          unit
        }
        discount
        equipmentPieces {
          calculateTravelTime
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isCustom
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        overallTotalOverride
        plantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        productName
        profit
        profitAfterDiscount
        profitOverride
        profitPercentage
        profitPercentageOverride
        projectFiles {
          children {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          createdAt
          fileSizeBytes
          id
          name
          parentFolderId
          path
          pivot {
            id
          }
          type
        }
        proposalMaterialNoPlants {
          cost
          id
          name
          percentage
          proposalProductId
          quantity
          quantityOverride
          rate
        }
        proposalPlantProducts {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProductGroupId
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          proposalPlantProductId
          quantity
          quantityOverride
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
        unitPriceOverride
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      proposalProductGroup {
        id
        isOptional
        name
        ordering
        showIndividualProducts
      }
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        crew {
          color
          displayName
          id
          name
          rate
        }
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          billingStatus
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          id
          invoiceId
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposalId
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          userId
          uuid
        }
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistNotes
          costingMode
          crewId
          endsAt
          externalId
          hasJobCostsEntered
          id
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organizationProductTypeName
          productName
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          startsAt
          status
          travelTimeEstimate
          usersColor
        }
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        crew {
          color
          displayName
          id
          name
          rate
        }
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          billingStatus
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          id
          invoiceId
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposalId
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          userId
          uuid
        }
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistNotes
          costingMode
          crewId
          endsAt
          externalId
          hasJobCostsEntered
          id
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organizationProductTypeName
          productName
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          startsAt
          status
          travelTimeEstimate
          usersColor
        }
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        proposalPlantProduct {
          applicationRate
          applicationRateOverride
          areaCoverage
          costMaterial
          costTransferTruck
          id
          materialNeeded
          materialNeededOverride
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOnWeight
          rateOverride
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTimeHrs
          transferTruckRoundTripTimeHrsOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          type
        }
        proposalPlantProductId
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruck {
          defaultRateHourly
          defaultRateTon
          defaultTonnage
          id
          name
        }
        transferTruckId
        worksheetBilling {
          quantity
          rate
          unit
        }
      }
      worksheet {
        area
        areaSource
        areaUnit
        costTotal
        fixedPrice
        indirectPercentage
        margin
        marginPercentage
        markup
        name
        overheadPercentage
        pricingMethod
        pricingOverrideField
        profitAmount
        quantity
        rate
        scope
        scopeFormat
        sellingTotal
        unit
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetJobPhasesQuery__
 *
 * To run a query within a React component, call `useGetJobPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPhasesQuery({
 *   variables: {
 *      billingStatuses: // value for 'billingStatuses'
 *      companyId: // value for 'companyId'
 *      crewId: // value for 'crewId'
 *      date: // value for 'date'
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      foremanUserId: // value for 'foremanUserId'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      searchByName: // value for 'searchByName'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      startDate: // value for 'startDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetJobPhasesQuery(baseOptions: Apollo.QueryHookOptions<GetJobPhasesQuery, GetJobPhasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPhasesQuery, GetJobPhasesQueryVariables>(GetJobPhasesDocument, options);
      }
export function useGetJobPhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPhasesQuery, GetJobPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPhasesQuery, GetJobPhasesQueryVariables>(GetJobPhasesDocument, options);
        }
export type GetJobPhasesQueryHookResult = ReturnType<typeof useGetJobPhasesQuery>;
export type GetJobPhasesLazyQueryHookResult = ReturnType<typeof useGetJobPhasesLazyQuery>;
export type GetJobPhasesQueryResult = Apollo.QueryResult<GetJobPhasesQuery, GetJobPhasesQueryVariables>;
export const GetJobReadinessDashboardDocument = gql`
    query getJobReadinessDashboard($crewId: ID, $endDate: Date!, $jobIds: [ID!], $jobPhaseId: ID, $startDate: Date!) {
  getJobReadinessDashboard(
    crewId: $crewId
    endDate: $endDate
    jobIds: $jobIds
    jobPhaseId: $jobPhaseId
    startDate: $startDate
  ) {
    dailyTotals {
      materialRows {
        hasPlant
        materialName
        quantity
        sourceName
        trucks
        unitAbbr
      }
      scheduledDate
      totalQuantity
      totalTrucks
    }
    exceptions {
      jobsMissingMaterialQuantity
      jobsMissingPlantAssignment
      jobsNotConfirmedWithClient
      materialLinesWithoutTrucks
    }
    jobs {
      checklistOutstanding
      checklistTotal
      confirmedWithClient
      jobExternalId
      jobId
      jobName
      jobPhaseId
      key
      materialLines {
        hasPlant
        materialName
        quantity
        sourceName
        trucks
        unitAbbr
      }
      profitScheduled
      revenueScheduled
      scheduledDate
    }
    summary {
      jobsConfirmedWithClient
      jobsScheduled
      jobsWithOutstandingChecklistItems
      profitScheduled
      revenueScheduled
      totalQuantity
      totalTrucks
    }
  }
}
    `;

/**
 * __useGetJobReadinessDashboardQuery__
 *
 * To run a query within a React component, call `useGetJobReadinessDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobReadinessDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobReadinessDashboardQuery({
 *   variables: {
 *      crewId: // value for 'crewId'
 *      endDate: // value for 'endDate'
 *      jobIds: // value for 'jobIds'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetJobReadinessDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetJobReadinessDashboardQuery, GetJobReadinessDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobReadinessDashboardQuery, GetJobReadinessDashboardQueryVariables>(GetJobReadinessDashboardDocument, options);
      }
export function useGetJobReadinessDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobReadinessDashboardQuery, GetJobReadinessDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobReadinessDashboardQuery, GetJobReadinessDashboardQueryVariables>(GetJobReadinessDashboardDocument, options);
        }
export type GetJobReadinessDashboardQueryHookResult = ReturnType<typeof useGetJobReadinessDashboardQuery>;
export type GetJobReadinessDashboardLazyQueryHookResult = ReturnType<typeof useGetJobReadinessDashboardLazyQuery>;
export type GetJobReadinessDashboardQueryResult = Apollo.QueryResult<GetJobReadinessDashboardQuery, GetJobReadinessDashboardQueryVariables>;
export const GetJobScheduleByAmountStatsDocument = gql`
    query getJobScheduleByAmountStats {
  getJobScheduleByAmountStats {
    date
    overallTotal
  }
}
    `;

/**
 * __useGetJobScheduleByAmountStatsQuery__
 *
 * To run a query within a React component, call `useGetJobScheduleByAmountStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobScheduleByAmountStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobScheduleByAmountStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobScheduleByAmountStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>(GetJobScheduleByAmountStatsDocument, options);
      }
export function useGetJobScheduleByAmountStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>(GetJobScheduleByAmountStatsDocument, options);
        }
export type GetJobScheduleByAmountStatsQueryHookResult = ReturnType<typeof useGetJobScheduleByAmountStatsQuery>;
export type GetJobScheduleByAmountStatsLazyQueryHookResult = ReturnType<typeof useGetJobScheduleByAmountStatsLazyQuery>;
export type GetJobScheduleByAmountStatsQueryResult = Apollo.QueryResult<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>;
export const GetJobScheduleStatsDocument = gql`
    query getJobScheduleStats($endDate: Date!, $startDate: Date!) {
  getJobScheduleStats(endDate: $endDate, startDate: $startDate) {
    amountScheduled
    profitScheduled
  }
}
    `;

/**
 * __useGetJobScheduleStatsQuery__
 *
 * To run a query within a React component, call `useGetJobScheduleStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobScheduleStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobScheduleStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetJobScheduleStatsQuery(baseOptions: Apollo.QueryHookOptions<GetJobScheduleStatsQuery, GetJobScheduleStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobScheduleStatsQuery, GetJobScheduleStatsQueryVariables>(GetJobScheduleStatsDocument, options);
      }
export function useGetJobScheduleStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobScheduleStatsQuery, GetJobScheduleStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobScheduleStatsQuery, GetJobScheduleStatsQueryVariables>(GetJobScheduleStatsDocument, options);
        }
export type GetJobScheduleStatsQueryHookResult = ReturnType<typeof useGetJobScheduleStatsQuery>;
export type GetJobScheduleStatsLazyQueryHookResult = ReturnType<typeof useGetJobScheduleStatsLazyQuery>;
export type GetJobScheduleStatsQueryResult = Apollo.QueryResult<GetJobScheduleStatsQuery, GetJobScheduleStatsQueryVariables>;
export const GetJobSchedulesDocument = gql`
    query getJobSchedules($crewId: ID, $dateFrom: DateTime, $dateUntil: DateTime, $jobIds: [ID!], $jobPhaseId: ID) {
  getJobSchedules(
    crewId: $crewId
    dateFrom: $dateFrom
    dateUntil: $dateUntil
    jobIds: $jobIds
    jobPhaseId: $jobPhaseId
  ) {
    blockLength
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    endsAt
    estimatedMaterial
    estimatedMaterialOverride
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      billingStatus
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      invoiceId
      jobPhases {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          id
          name
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          billingStatus
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          id
          invoiceId
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
      uuid
    }
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistNotes
      costingMode
      crewId
      endsAt
      externalId
      hasJobCostsEntered
      id
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    scheduledAt
    showTravelFrom
    showTravelTo
    travelTime
  }
}
    `;

/**
 * __useGetJobSchedulesQuery__
 *
 * To run a query within a React component, call `useGetJobSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSchedulesQuery({
 *   variables: {
 *      crewId: // value for 'crewId'
 *      dateFrom: // value for 'dateFrom'
 *      dateUntil: // value for 'dateUntil'
 *      jobIds: // value for 'jobIds'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useGetJobSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>(GetJobSchedulesDocument, options);
      }
export function useGetJobSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>(GetJobSchedulesDocument, options);
        }
export type GetJobSchedulesQueryHookResult = ReturnType<typeof useGetJobSchedulesQuery>;
export type GetJobSchedulesLazyQueryHookResult = ReturnType<typeof useGetJobSchedulesLazyQuery>;
export type GetJobSchedulesQueryResult = Apollo.QueryResult<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>;
export const GetJobsDocument = gql`
    query getJobs($billingStatuses: [JobBillingStatus!], $cities: [String!], $companyId: ID, $first: Int!, $jobIds: [ID!], $multipleCompanyIDs: [ID!], $multipleUserIDs: [ID!], $organizationProductTypeIds: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $statuses: [JobStatus!], $userId: ID) {
  getJobs(
    billingStatuses: $billingStatuses
    cities: $cities
    companyId: $companyId
    first: $first
    jobIds: $jobIds
    multipleCompanyIDs: $multipleCompanyIDs
    multipleUserIDs: $multipleUserIDs
    organizationProductTypeIds: $organizationProductTypeIds
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
  ) {
    data {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      billingStatus
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      invoiceId
      jobPhases {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalId
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
      uuid
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      billingStatuses: // value for 'billingStatuses'
 *      cities: // value for 'cities'
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      jobIds: // value for 'jobIds'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      multipleUserIDs: // value for 'multipleUserIDs'
 *      organizationProductTypeIds: // value for 'organizationProductTypeIds'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetJobsSimpleDocument = gql`
    query getJobsSimple($billingStatuses: [JobBillingStatus!], $companyId: ID, $companyName: String, $first: Int!, $jobIds: [ID!], $jobName: String, $multipleCompanyIDs: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $statuses: [JobStatus!], $userId: ID) {
  getJobsSimple(
    billingStatuses: $billingStatuses
    companyId: $companyId
    companyName: $companyName
    first: $first
    jobIds: $jobIds
    jobName: $jobName
    multipleCompanyIDs: $multipleCompanyIDs
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
  ) {
    data {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      billingStatus
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      datePushedToQuickbooks
      depositCollectedAt
      endsAt
      externalId
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      invoiceId
      jobPhases {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItemId
          id
          isCompleted
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      proposalId
      proposalStage {
        addressOverride
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
      uuid
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetJobsSimpleQuery__
 *
 * To run a query within a React component, call `useGetJobsSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsSimpleQuery({
 *   variables: {
 *      billingStatuses: // value for 'billingStatuses'
 *      companyId: // value for 'companyId'
 *      companyName: // value for 'companyName'
 *      first: // value for 'first'
 *      jobIds: // value for 'jobIds'
 *      jobName: // value for 'jobName'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetJobsSimpleQuery(baseOptions: Apollo.QueryHookOptions<GetJobsSimpleQuery, GetJobsSimpleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsSimpleQuery, GetJobsSimpleQueryVariables>(GetJobsSimpleDocument, options);
      }
export function useGetJobsSimpleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsSimpleQuery, GetJobsSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsSimpleQuery, GetJobsSimpleQueryVariables>(GetJobsSimpleDocument, options);
        }
export type GetJobsSimpleQueryHookResult = ReturnType<typeof useGetJobsSimpleQuery>;
export type GetJobsSimpleLazyQueryHookResult = ReturnType<typeof useGetJobsSimpleLazyQuery>;
export type GetJobsSimpleQueryResult = Apollo.QueryResult<GetJobsSimpleQuery, GetJobsSimpleQueryVariables>;
export const GetLastYearStatsDocument = gql`
    query getLastYearStats {
  getLastYearStats {
    closedBids {
      month
      total
      year
    }
    closedRate {
      month
      total
      year
    }
    closedRevenue {
      month
      total
      year
    }
    sentBids {
      month
      total
      year
    }
  }
}
    `;

/**
 * __useGetLastYearStatsQuery__
 *
 * To run a query within a React component, call `useGetLastYearStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastYearStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastYearStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastYearStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>(GetLastYearStatsDocument, options);
      }
export function useGetLastYearStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>(GetLastYearStatsDocument, options);
        }
export type GetLastYearStatsQueryHookResult = ReturnType<typeof useGetLastYearStatsQuery>;
export type GetLastYearStatsLazyQueryHookResult = ReturnType<typeof useGetLastYearStatsLazyQuery>;
export type GetLastYearStatsQueryResult = Apollo.QueryResult<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>;
export const GetManageSubscriptionUrlDocument = gql`
    query getManageSubscriptionUrl {
  getManageSubscriptionUrl
}
    `;

/**
 * __useGetManageSubscriptionUrlQuery__
 *
 * To run a query within a React component, call `useGetManageSubscriptionUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageSubscriptionUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageSubscriptionUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManageSubscriptionUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>(GetManageSubscriptionUrlDocument, options);
      }
export function useGetManageSubscriptionUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>(GetManageSubscriptionUrlDocument, options);
        }
export type GetManageSubscriptionUrlQueryHookResult = ReturnType<typeof useGetManageSubscriptionUrlQuery>;
export type GetManageSubscriptionUrlLazyQueryHookResult = ReturnType<typeof useGetManageSubscriptionUrlLazyQuery>;
export type GetManageSubscriptionUrlQueryResult = Apollo.QueryResult<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>;
export const GetMaterialNeededByDayStatsDocument = gql`
    query getMaterialNeededByDayStats {
  getMaterialNeededByDayStats {
    JobPhaseAmountScheduledInDay
    date
    jobPhaseMaterialNeededInDay
    material
  }
}
    `;

/**
 * __useGetMaterialNeededByDayStatsQuery__
 *
 * To run a query within a React component, call `useGetMaterialNeededByDayStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialNeededByDayStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialNeededByDayStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMaterialNeededByDayStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>(GetMaterialNeededByDayStatsDocument, options);
      }
export function useGetMaterialNeededByDayStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>(GetMaterialNeededByDayStatsDocument, options);
        }
export type GetMaterialNeededByDayStatsQueryHookResult = ReturnType<typeof useGetMaterialNeededByDayStatsQuery>;
export type GetMaterialNeededByDayStatsLazyQueryHookResult = ReturnType<typeof useGetMaterialNeededByDayStatsLazyQuery>;
export type GetMaterialNeededByDayStatsQueryResult = Apollo.QueryResult<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>;
export const GetMyTasksDocument = gql`
    query getMyTasks($all: Boolean, $first: Int!, $page: Int, $status: String, $userId: ID) {
  getMyTasks(
    all: $all
    first: $first
    page: $page
    status: $status
    userId: $userId
  ) {
    data {
      assignedUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      completedAt
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      content
      createdAt
      dueAt
      id
      notifiableExternalId
      notifiableId
      notifiableType
      notificationTrigger {
        active
        additionalRecipientTypes
        additionalRecipients {
          email
          firstName
          id
          isTask
          lastName
          taskContent
        }
        apiHeaders
        apiMethod
        apiPayload
        apiSecret
        apiUrl
        content
        delay
        emailSubject
        event
        id
        isApi
        isEmail
        isSMS
        isTask
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        sendToAllRecipients
        sendToContact
        sendToUser
        smsContent
        taskContent
        type
      }
      status
      triggerEvent
      triggerType
      updatedAt
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetMyTasksQuery__
 *
 * To run a query within a React component, call `useGetMyTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTasksQuery({
 *   variables: {
 *      all: // value for 'all'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      status: // value for 'status'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyTasksQuery(baseOptions: Apollo.QueryHookOptions<GetMyTasksQuery, GetMyTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTasksQuery, GetMyTasksQueryVariables>(GetMyTasksDocument, options);
      }
export function useGetMyTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTasksQuery, GetMyTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTasksQuery, GetMyTasksQueryVariables>(GetMyTasksDocument, options);
        }
export type GetMyTasksQueryHookResult = ReturnType<typeof useGetMyTasksQuery>;
export type GetMyTasksLazyQueryHookResult = ReturnType<typeof useGetMyTasksLazyQuery>;
export type GetMyTasksQueryResult = Apollo.QueryResult<GetMyTasksQuery, GetMyTasksQueryVariables>;
export const GetNotificationTriggerDocument = gql`
    query getNotificationTrigger($id: ID!) {
  getNotificationTrigger(id: $id) {
    active
    additionalRecipientTypes
    additionalRecipients {
      email
      firstName
      id
      isTask
      lastName
      taskContent
    }
    apiHeaders
    apiMethod
    apiPayload
    apiSecret
    apiUrl
    content
    delay
    emailSubject
    event
    id
    isApi
    isEmail
    isSMS
    isTask
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    sendToAllRecipients
    sendToContact
    sendToUser
    smsContent
    taskContent
    type
  }
}
    `;

/**
 * __useGetNotificationTriggerQuery__
 *
 * To run a query within a React component, call `useGetNotificationTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTriggerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationTriggerQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>(GetNotificationTriggerDocument, options);
      }
export function useGetNotificationTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>(GetNotificationTriggerDocument, options);
        }
export type GetNotificationTriggerQueryHookResult = ReturnType<typeof useGetNotificationTriggerQuery>;
export type GetNotificationTriggerLazyQueryHookResult = ReturnType<typeof useGetNotificationTriggerLazyQuery>;
export type GetNotificationTriggerQueryResult = Apollo.QueryResult<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>;
export const GetNotificationTriggersDocument = gql`
    query getNotificationTriggers {
  getNotificationTriggers {
    active
    additionalRecipientTypes
    additionalRecipients {
      email
      firstName
      id
      isTask
      lastName
      taskContent
    }
    apiHeaders
    apiMethod
    apiPayload
    apiSecret
    apiUrl
    content
    delay
    emailSubject
    event
    id
    isApi
    isEmail
    isSMS
    isTask
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    sendToAllRecipients
    sendToContact
    sendToUser
    smsContent
    taskContent
    type
  }
}
    `;

/**
 * __useGetNotificationTriggersQuery__
 *
 * To run a query within a React component, call `useGetNotificationTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationTriggersQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>(GetNotificationTriggersDocument, options);
      }
export function useGetNotificationTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>(GetNotificationTriggersDocument, options);
        }
export type GetNotificationTriggersQueryHookResult = ReturnType<typeof useGetNotificationTriggersQuery>;
export type GetNotificationTriggersLazyQueryHookResult = ReturnType<typeof useGetNotificationTriggersLazyQuery>;
export type GetNotificationTriggersQueryResult = Apollo.QueryResult<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>;
export const GetOpportunitiesDocument = gql`
    query getOpportunities($companyId: ID, $contactName: String, $dueAt: Date, $first: Int!, $multipleCompanyIDs: [ID!], $multipleUserIDs: [ID!], $page: Int, $search: String, $sort: SortDirection, $sortKey: GetOpportunitiesSortKey, $statuses: [String!], $userId: ID) {
  getOpportunities(
    companyId: $companyId
    contactName: $contactName
    dueAt: $dueAt
    first: $first
    multipleCompanyIDs: $multipleCompanyIDs
    multipleUserIDs: $multipleUserIDs
    page: $page
    search: $search
    sort: $sort
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
  ) {
    data {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      companyId
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      createdAt
      dueAt
      estimatedOpportunityValue
      externalId
      id
      name
      notes
      products {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      projectFilesFolderId
      source
      status
      statusId
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetOpportunitiesQuery__
 *
 * To run a query within a React component, call `useGetOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunitiesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      contactName: // value for 'contactName'
 *      dueAt: // value for 'dueAt'
 *      first: // value for 'first'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      multipleUserIDs: // value for 'multipleUserIDs'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>(GetOpportunitiesDocument, options);
      }
export function useGetOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>(GetOpportunitiesDocument, options);
        }
export type GetOpportunitiesQueryHookResult = ReturnType<typeof useGetOpportunitiesQuery>;
export type GetOpportunitiesLazyQueryHookResult = ReturnType<typeof useGetOpportunitiesLazyQuery>;
export type GetOpportunitiesQueryResult = Apollo.QueryResult<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>;
export const GetOpportunityDocument = gql`
    query getOpportunity($id: ID!) {
  getOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
  }
}
    `;

/**
 * __useGetOpportunityQuery__
 *
 * To run a query within a React component, call `useGetOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOpportunityQuery(baseOptions: Apollo.QueryHookOptions<GetOpportunityQuery, GetOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunityQuery, GetOpportunityQueryVariables>(GetOpportunityDocument, options);
      }
export function useGetOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunityQuery, GetOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunityQuery, GetOpportunityQueryVariables>(GetOpportunityDocument, options);
        }
export type GetOpportunityQueryHookResult = ReturnType<typeof useGetOpportunityQuery>;
export type GetOpportunityLazyQueryHookResult = ReturnType<typeof useGetOpportunityLazyQuery>;
export type GetOpportunityQueryResult = Apollo.QueryResult<GetOpportunityQuery, GetOpportunityQueryVariables>;
export const GetOpportunityStatusesDocument = gql`
    query getOpportunityStatuses {
  getOpportunityStatuses {
    id
    name
    ordering
  }
}
    `;

/**
 * __useGetOpportunityStatusesQuery__
 *
 * To run a query within a React component, call `useGetOpportunityStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpportunityStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>(GetOpportunityStatusesDocument, options);
      }
export function useGetOpportunityStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>(GetOpportunityStatusesDocument, options);
        }
export type GetOpportunityStatusesQueryHookResult = ReturnType<typeof useGetOpportunityStatusesQuery>;
export type GetOpportunityStatusesLazyQueryHookResult = ReturnType<typeof useGetOpportunityStatusesLazyQuery>;
export type GetOpportunityStatusesQueryResult = Apollo.QueryResult<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>;
export const GetOrganizationAddressDocument = gql`
    query getOrganizationAddress($id: ID!) {
  getOrganizationAddress(id: $id) {
    city
    country
    id
    isPrimary
    latitude
    line1
    line2
    longitude
    state
    zip
  }
}
    `;

/**
 * __useGetOrganizationAddressQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationAddressQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>(GetOrganizationAddressDocument, options);
      }
export function useGetOrganizationAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>(GetOrganizationAddressDocument, options);
        }
export type GetOrganizationAddressQueryHookResult = ReturnType<typeof useGetOrganizationAddressQuery>;
export type GetOrganizationAddressLazyQueryHookResult = ReturnType<typeof useGetOrganizationAddressLazyQuery>;
export type GetOrganizationAddressQueryResult = Apollo.QueryResult<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>;
export const GetOrganizationAddressesDocument = gql`
    query getOrganizationAddresses($first: Int!, $page: Int) {
  getOrganizationAddresses(first: $first, page: $page) {
    data {
      city
      country
      id
      isPrimary
      latitude
      line1
      line2
      longitude
      state
      zip
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetOrganizationAddressesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAddressesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetOrganizationAddressesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>(GetOrganizationAddressesDocument, options);
      }
export function useGetOrganizationAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>(GetOrganizationAddressesDocument, options);
        }
export type GetOrganizationAddressesQueryHookResult = ReturnType<typeof useGetOrganizationAddressesQuery>;
export type GetOrganizationAddressesLazyQueryHookResult = ReturnType<typeof useGetOrganizationAddressesLazyQuery>;
export type GetOrganizationAddressesQueryResult = Apollo.QueryResult<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>;
export const GetOrganizationDataUploadsDocument = gql`
    query getOrganizationDataUploads($first: Int!, $page: Int) {
  getOrganizationDataUploads(first: $first, page: $page) {
    data {
      createdAt
      error
      id
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      startedAt
      status
      type
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetOrganizationDataUploadsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDataUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDataUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDataUploadsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetOrganizationDataUploadsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>(GetOrganizationDataUploadsDocument, options);
      }
export function useGetOrganizationDataUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>(GetOrganizationDataUploadsDocument, options);
        }
export type GetOrganizationDataUploadsQueryHookResult = ReturnType<typeof useGetOrganizationDataUploadsQuery>;
export type GetOrganizationDataUploadsLazyQueryHookResult = ReturnType<typeof useGetOrganizationDataUploadsLazyQuery>;
export type GetOrganizationDataUploadsQueryResult = Apollo.QueryResult<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>;
export const GetOrganizationEmailIdentityDocument = gql`
    query getOrganizationEmailIdentity {
  getOrganizationEmailIdentity {
    dkimTokens {
      host
      type
      value
    }
    dmarcRecord {
      host
      type
      value
    }
    enabled
    fromName
    id
    invoiceFromAddress
    invoiceLocalPart
    notificationsFromAddress
    notificationsLocalPart
    organizationId
    proposalFromAddress
    proposalLocalPart
    replyToCustomEmail
    replyToType
    sendingDomain
    spfRecord {
      host
      type
      value
    }
    verificationStatus
    verifiedAt
  }
}
    `;

/**
 * __useGetOrganizationEmailIdentityQuery__
 *
 * To run a query within a React component, call `useGetOrganizationEmailIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationEmailIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationEmailIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationEmailIdentityQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationEmailIdentityQuery, GetOrganizationEmailIdentityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationEmailIdentityQuery, GetOrganizationEmailIdentityQueryVariables>(GetOrganizationEmailIdentityDocument, options);
      }
export function useGetOrganizationEmailIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationEmailIdentityQuery, GetOrganizationEmailIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationEmailIdentityQuery, GetOrganizationEmailIdentityQueryVariables>(GetOrganizationEmailIdentityDocument, options);
        }
export type GetOrganizationEmailIdentityQueryHookResult = ReturnType<typeof useGetOrganizationEmailIdentityQuery>;
export type GetOrganizationEmailIdentityLazyQueryHookResult = ReturnType<typeof useGetOrganizationEmailIdentityLazyQuery>;
export type GetOrganizationEmailIdentityQueryResult = Apollo.QueryResult<GetOrganizationEmailIdentityQuery, GetOrganizationEmailIdentityQueryVariables>;
export const GetOrganizationEmailTemplateDocument = gql`
    query getOrganizationEmailTemplate($type: OrganizationEmailTemplateType!) {
  getOrganizationEmailTemplate(type: $type) {
    html
    id
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    type
  }
}
    `;

/**
 * __useGetOrganizationEmailTemplateQuery__
 *
 * To run a query within a React component, call `useGetOrganizationEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationEmailTemplateQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetOrganizationEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>(GetOrganizationEmailTemplateDocument, options);
      }
export function useGetOrganizationEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>(GetOrganizationEmailTemplateDocument, options);
        }
export type GetOrganizationEmailTemplateQueryHookResult = ReturnType<typeof useGetOrganizationEmailTemplateQuery>;
export type GetOrganizationEmailTemplateLazyQueryHookResult = ReturnType<typeof useGetOrganizationEmailTemplateLazyQuery>;
export type GetOrganizationEmailTemplateQueryResult = Apollo.QueryResult<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>;
export const GetOrganizationEmailTemplatesDocument = gql`
    query getOrganizationEmailTemplates {
  getOrganizationEmailTemplates {
    html
    id
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    type
  }
}
    `;

/**
 * __useGetOrganizationEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationEmailTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationEmailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>(GetOrganizationEmailTemplatesDocument, options);
      }
export function useGetOrganizationEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>(GetOrganizationEmailTemplatesDocument, options);
        }
export type GetOrganizationEmailTemplatesQueryHookResult = ReturnType<typeof useGetOrganizationEmailTemplatesQuery>;
export type GetOrganizationEmailTemplatesLazyQueryHookResult = ReturnType<typeof useGetOrganizationEmailTemplatesLazyQuery>;
export type GetOrganizationEmailTemplatesQueryResult = Apollo.QueryResult<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>;
export const GetOrganizationProductTypeDocument = gql`
    query getOrganizationProductType($id: ID!) {
  getOrganizationProductType(id: $id) {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
}
    `;

/**
 * __useGetOrganizationProductTypeQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProductTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProductTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProductTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationProductTypeQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>(GetOrganizationProductTypeDocument, options);
      }
export function useGetOrganizationProductTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>(GetOrganizationProductTypeDocument, options);
        }
export type GetOrganizationProductTypeQueryHookResult = ReturnType<typeof useGetOrganizationProductTypeQuery>;
export type GetOrganizationProductTypeLazyQueryHookResult = ReturnType<typeof useGetOrganizationProductTypeLazyQuery>;
export type GetOrganizationProductTypeQueryResult = Apollo.QueryResult<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>;
export const GetOrganizationProductTypesDocument = gql`
    query getOrganizationProductTypes {
  getOrganizationProductTypes {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
}
    `;

/**
 * __useGetOrganizationProductTypesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProductTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationProductTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>(GetOrganizationProductTypesDocument, options);
      }
export function useGetOrganizationProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>(GetOrganizationProductTypesDocument, options);
        }
export type GetOrganizationProductTypesQueryHookResult = ReturnType<typeof useGetOrganizationProductTypesQuery>;
export type GetOrganizationProductTypesLazyQueryHookResult = ReturnType<typeof useGetOrganizationProductTypesLazyQuery>;
export type GetOrganizationProductTypesQueryResult = Apollo.QueryResult<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>;
export const GetOrganizationProposalContentDocument = gql`
    query getOrganizationProposalContent {
  getOrganizationProposalContent {
    content
    id
    type
  }
}
    `;

/**
 * __useGetOrganizationProposalContentQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProposalContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProposalContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProposalContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationProposalContentQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>(GetOrganizationProposalContentDocument, options);
      }
export function useGetOrganizationProposalContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>(GetOrganizationProposalContentDocument, options);
        }
export type GetOrganizationProposalContentQueryHookResult = ReturnType<typeof useGetOrganizationProposalContentQuery>;
export type GetOrganizationProposalContentLazyQueryHookResult = ReturnType<typeof useGetOrganizationProposalContentLazyQuery>;
export type GetOrganizationProposalContentQueryResult = Apollo.QueryResult<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>;
export const GetOrganizationProposalLayoutContentSettingsDocument = gql`
    query getOrganizationProposalLayoutContentSettings {
  getOrganizationProposalLayoutContentSettings {
    contentType
    id
    organizationId
    showOnBranded
    showOnFull
    showOnSimple
    showOnTabular
  }
}
    `;

/**
 * __useGetOrganizationProposalLayoutContentSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProposalLayoutContentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProposalLayoutContentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProposalLayoutContentSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationProposalLayoutContentSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationProposalLayoutContentSettingsQuery, GetOrganizationProposalLayoutContentSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProposalLayoutContentSettingsQuery, GetOrganizationProposalLayoutContentSettingsQueryVariables>(GetOrganizationProposalLayoutContentSettingsDocument, options);
      }
export function useGetOrganizationProposalLayoutContentSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProposalLayoutContentSettingsQuery, GetOrganizationProposalLayoutContentSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProposalLayoutContentSettingsQuery, GetOrganizationProposalLayoutContentSettingsQueryVariables>(GetOrganizationProposalLayoutContentSettingsDocument, options);
        }
export type GetOrganizationProposalLayoutContentSettingsQueryHookResult = ReturnType<typeof useGetOrganizationProposalLayoutContentSettingsQuery>;
export type GetOrganizationProposalLayoutContentSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganizationProposalLayoutContentSettingsLazyQuery>;
export type GetOrganizationProposalLayoutContentSettingsQueryResult = Apollo.QueryResult<GetOrganizationProposalLayoutContentSettingsQuery, GetOrganizationProposalLayoutContentSettingsQueryVariables>;
export const GetOrganizationSettingsDocument = gql`
    query getOrganizationSettings {
  getOrganizationSettings {
    key
    value
  }
}
    `;

/**
 * __useGetOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
      }
export function useGetOrganizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
        }
export type GetOrganizationSettingsQueryHookResult = ReturnType<typeof useGetOrganizationSettingsQuery>;
export type GetOrganizationSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganizationSettingsLazyQuery>;
export type GetOrganizationSettingsQueryResult = Apollo.QueryResult<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>;
export const GetOrganizationUserDocument = gql`
    query getOrganizationUser($id: ID!) {
  getOrganizationUser(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    archivedAt
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    salesGoal
    status
  }
}
    `;

/**
 * __useGetOrganizationUserQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationUserQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(GetOrganizationUserDocument, options);
      }
export function useGetOrganizationUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(GetOrganizationUserDocument, options);
        }
export type GetOrganizationUserQueryHookResult = ReturnType<typeof useGetOrganizationUserQuery>;
export type GetOrganizationUserLazyQueryHookResult = ReturnType<typeof useGetOrganizationUserLazyQuery>;
export type GetOrganizationUserQueryResult = Apollo.QueryResult<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>;
export const GetOrganizationUsersDocument = gql`
    query getOrganizationUsers($archived: Boolean, $first: Int!, $page: Int, $roles: [UserRole], $search: String, $status: UserStatus) {
  getOrganizationUsers(
    archived: $archived
    first: $first
    page: $page
    roles: $roles
    search: $search
    status: $status
  ) {
    data {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      roles: // value for 'roles'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
      }
export function useGetOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
export type GetOrganizationUsersQueryHookResult = ReturnType<typeof useGetOrganizationUsersQuery>;
export type GetOrganizationUsersLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersLazyQuery>;
export type GetOrganizationUsersQueryResult = Apollo.QueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export const GetOutstandingWorkReportDocument = gql`
    query getOutstandingWorkReport($endDate: DateTime!, $mode: OutstandingWorkReportMode, $startDate: DateTime!) {
  getOutstandingWorkReport(endDate: $endDate, mode: $mode, startDate: $startDate) {
    countJobsOutstanding
    countJobsWon
    jobs {
      customerName
      externalId
      id
      jobName
      jobRevenue
    }
    mode
    totalOutstandingRevenue
    totalWonRevenue
  }
}
    `;

/**
 * __useGetOutstandingWorkReportQuery__
 *
 * To run a query within a React component, call `useGetOutstandingWorkReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutstandingWorkReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutstandingWorkReportQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      mode: // value for 'mode'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetOutstandingWorkReportQuery(baseOptions: Apollo.QueryHookOptions<GetOutstandingWorkReportQuery, GetOutstandingWorkReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutstandingWorkReportQuery, GetOutstandingWorkReportQueryVariables>(GetOutstandingWorkReportDocument, options);
      }
export function useGetOutstandingWorkReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutstandingWorkReportQuery, GetOutstandingWorkReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutstandingWorkReportQuery, GetOutstandingWorkReportQueryVariables>(GetOutstandingWorkReportDocument, options);
        }
export type GetOutstandingWorkReportQueryHookResult = ReturnType<typeof useGetOutstandingWorkReportQuery>;
export type GetOutstandingWorkReportLazyQueryHookResult = ReturnType<typeof useGetOutstandingWorkReportLazyQuery>;
export type GetOutstandingWorkReportQueryResult = Apollo.QueryResult<GetOutstandingWorkReportQuery, GetOutstandingWorkReportQueryVariables>;
export const GetPersonPerformanceYtdDocument = gql`
    query getPersonPerformanceYtd {
  getPersonPerformanceYtd {
    averageProposedNetMargin
    forecastedSalesThisYear
    name
    percentToGoal
    personId
    proposalsSent
    proposalsWon
    proposalsWonAmount
    salesGoal
    winRate
  }
}
    `;

/**
 * __useGetPersonPerformanceYtdQuery__
 *
 * To run a query within a React component, call `useGetPersonPerformanceYtdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonPerformanceYtdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonPerformanceYtdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonPerformanceYtdQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonPerformanceYtdQuery, GetPersonPerformanceYtdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonPerformanceYtdQuery, GetPersonPerformanceYtdQueryVariables>(GetPersonPerformanceYtdDocument, options);
      }
export function useGetPersonPerformanceYtdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonPerformanceYtdQuery, GetPersonPerformanceYtdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonPerformanceYtdQuery, GetPersonPerformanceYtdQueryVariables>(GetPersonPerformanceYtdDocument, options);
        }
export type GetPersonPerformanceYtdQueryHookResult = ReturnType<typeof useGetPersonPerformanceYtdQuery>;
export type GetPersonPerformanceYtdLazyQueryHookResult = ReturnType<typeof useGetPersonPerformanceYtdLazyQuery>;
export type GetPersonPerformanceYtdQueryResult = Apollo.QueryResult<GetPersonPerformanceYtdQuery, GetPersonPerformanceYtdQueryVariables>;
export const GetPlantDocument = gql`
    query getPlant($id: ID!) {
  getPlant(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    id
    name
    phone
    products {
      id
      pivot {
        applicationRate
      }
      plantId
      rate
      type
    }
  }
}
    `;

/**
 * __useGetPlantQuery__
 *
 * To run a query within a React component, call `useGetPlantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlantQuery(baseOptions: Apollo.QueryHookOptions<GetPlantQuery, GetPlantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantQuery, GetPlantQueryVariables>(GetPlantDocument, options);
      }
export function useGetPlantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantQuery, GetPlantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantQuery, GetPlantQueryVariables>(GetPlantDocument, options);
        }
export type GetPlantQueryHookResult = ReturnType<typeof useGetPlantQuery>;
export type GetPlantLazyQueryHookResult = ReturnType<typeof useGetPlantLazyQuery>;
export type GetPlantQueryResult = Apollo.QueryResult<GetPlantQuery, GetPlantQueryVariables>;
export const GetPlantProductTypesDocument = gql`
    query getPlantProductTypes {
  getPlantProductTypes {
    id
    name
  }
}
    `;

/**
 * __useGetPlantProductTypesQuery__
 *
 * To run a query within a React component, call `useGetPlantProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantProductTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlantProductTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>(GetPlantProductTypesDocument, options);
      }
export function useGetPlantProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>(GetPlantProductTypesDocument, options);
        }
export type GetPlantProductTypesQueryHookResult = ReturnType<typeof useGetPlantProductTypesQuery>;
export type GetPlantProductTypesLazyQueryHookResult = ReturnType<typeof useGetPlantProductTypesLazyQuery>;
export type GetPlantProductTypesQueryResult = Apollo.QueryResult<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>;
export const GetPlantTransferTrucksDocument = gql`
    query getPlantTransferTrucks($plantId: ID!) {
  getPlantTransferTrucks(plantId: $plantId) {
    id
    rateHourly
    rateTon
    tonnage
    transferTruck {
      defaultRateHourly
      defaultRateTon
      defaultTonnage
      id
      name
    }
  }
}
    `;

/**
 * __useGetPlantTransferTrucksQuery__
 *
 * To run a query within a React component, call `useGetPlantTransferTrucksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantTransferTrucksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantTransferTrucksQuery({
 *   variables: {
 *      plantId: // value for 'plantId'
 *   },
 * });
 */
export function useGetPlantTransferTrucksQuery(baseOptions: Apollo.QueryHookOptions<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>(GetPlantTransferTrucksDocument, options);
      }
export function useGetPlantTransferTrucksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>(GetPlantTransferTrucksDocument, options);
        }
export type GetPlantTransferTrucksQueryHookResult = ReturnType<typeof useGetPlantTransferTrucksQuery>;
export type GetPlantTransferTrucksLazyQueryHookResult = ReturnType<typeof useGetPlantTransferTrucksLazyQuery>;
export type GetPlantTransferTrucksQueryResult = Apollo.QueryResult<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>;
export const GetPlantsDocument = gql`
    query getPlants($first: Int!, $page: Int, $search: String) {
  getPlants(first: $first, page: $page, search: $search) {
    data {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        pivot {
          applicationRate
        }
        plantId
        rate
        type
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetPlantsQuery__
 *
 * To run a query within a React component, call `useGetPlantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPlantsQuery(baseOptions: Apollo.QueryHookOptions<GetPlantsQuery, GetPlantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantsQuery, GetPlantsQueryVariables>(GetPlantsDocument, options);
      }
export function useGetPlantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantsQuery, GetPlantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantsQuery, GetPlantsQueryVariables>(GetPlantsDocument, options);
        }
export type GetPlantsQueryHookResult = ReturnType<typeof useGetPlantsQuery>;
export type GetPlantsLazyQueryHookResult = ReturnType<typeof useGetPlantsLazyQuery>;
export type GetPlantsQueryResult = Apollo.QueryResult<GetPlantsQuery, GetPlantsQueryVariables>;
export const GetPreviousMonthStatsDocument = gql`
    query getPreviousMonthStats {
  getPreviousMonthStats {
    closedBids
    closedRate
    closedRevenue
    sentBids
  }
}
    `;

/**
 * __useGetPreviousMonthStatsQuery__
 *
 * To run a query within a React component, call `useGetPreviousMonthStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousMonthStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousMonthStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreviousMonthStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>(GetPreviousMonthStatsDocument, options);
      }
export function useGetPreviousMonthStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>(GetPreviousMonthStatsDocument, options);
        }
export type GetPreviousMonthStatsQueryHookResult = ReturnType<typeof useGetPreviousMonthStatsQuery>;
export type GetPreviousMonthStatsLazyQueryHookResult = ReturnType<typeof useGetPreviousMonthStatsLazyQuery>;
export type GetPreviousMonthStatsQueryResult = Apollo.QueryResult<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>;
export const GetProductDocument = gql`
    query getProduct($id: ID!) {
  getProduct(id: $id) {
    areaCoverage
    attributes {
      __typename
      ... on ProductAttributeAsphalt {
        applicationRate
      }
      ... on ProductAttributeAsphaltCurbing {
        curbHeight
        curbWidth
      }
      ... on ProductAttributeConcreteColumn {
        diameter
        height
      }
      ... on ProductAttributeConcreteCurbOrGutter {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeConcreteFlatwork {
        applicationRate
      }
      ... on ProductAttributeConcreteFooting {
        depth
        width
      }
      ... on ProductAttributeConcreteWall {
        height
        width
      }
      ... on ProductAttributeConcreteWaterway {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeCrackSeal {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeCurbWall {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeExcavateOut {
        applicationRate
      }
      ... on ProductAttributeGrading {
        applicationRate
        poundsPerCubicYard
      }
      ... on ProductAttributeMastic {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeMicrosurfacing {
        applicationRate
      }
      ... on ProductAttributeSealCoat {
        applicationRate
      }
      ... on ProductAttributeSlurrySeal {
        applicationRate
      }
      ... on ProductAttributeStriping {
        applicationRate
        lineWidth
      }
    }
    costMaterial
    costMinimumProduct
    costMinimumProposal
    crew {
      color
      displayName
      employees {
        archivedAt
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      id
      name
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    dailyUnitsComplete
    externalProductName
    id
    indirectPercentage
    labourCostType
    markupPercentage
    materialsNoPlant {
      id
      name
      percentage
      productId
      rate
    }
    measurementJob
    measurementMaterial
    name
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    overheadPercentage
    plant {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        pivot {
          applicationRate
        }
        plantId
        rate
        type
      }
    }
    plantProductId
    plantProducts {
      id
      pivot {
        applicationRate
      }
      plantId
      rate
      type
    }
    plants {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        plantId
        rate
        type
      }
    }
    productAdditionalCosts {
      additionalCost {
        cost
        feeAmount
        feeType
        id
        name
      }
      id
      type
    }
    productCrews {
      crew {
        color
        displayName
        id
        name
        rate
      }
      id
      quantity
    }
    productEquipmentPieces {
      equipmentPiece {
        calculateTravelTime
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      id
      quantity
    }
    productionRateType
    statementOfWork
    subcontracted
    type
    unitPrice
    unitPriceProduct
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductGroupDocument = gql`
    query getProductGroup($id: ID!) {
  getProductGroup(id: $id) {
    id
    name
    organizationId
    products {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMinimumProduct
      costMinimumProposal
      crew {
        color
        displayName
        employees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        rate
      }
      dailyUnitsComplete
      externalProductName
      id
      indirectPercentage
      labourCostType
      markupPercentage
      materialsNoPlant {
        id
        name
        percentage
        productId
        rate
      }
      measurementJob
      measurementMaterial
      name
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      overheadPercentage
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        id
        name
        phone
        products {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
      }
      plantProductId
      plantProducts {
        id
        pivot {
          applicationRate
        }
        plantId
        rate
        type
      }
      plants {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        id
        name
        phone
        products {
          id
          plantId
          rate
          type
        }
      }
      productAdditionalCosts {
        additionalCost {
          cost
          feeAmount
          feeType
          id
          name
        }
        id
        type
      }
      productCrews {
        crew {
          color
          displayName
          id
          name
          rate
        }
        id
        quantity
      }
      productEquipmentPieces {
        equipmentPiece {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        id
        quantity
      }
      productionRateType
      statementOfWork
      subcontracted
      type
      unitPrice
      unitPriceProduct
    }
  }
}
    `;

/**
 * __useGetProductGroupQuery__
 *
 * To run a query within a React component, call `useGetProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductGroupQuery(baseOptions: Apollo.QueryHookOptions<GetProductGroupQuery, GetProductGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductGroupQuery, GetProductGroupQueryVariables>(GetProductGroupDocument, options);
      }
export function useGetProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductGroupQuery, GetProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductGroupQuery, GetProductGroupQueryVariables>(GetProductGroupDocument, options);
        }
export type GetProductGroupQueryHookResult = ReturnType<typeof useGetProductGroupQuery>;
export type GetProductGroupLazyQueryHookResult = ReturnType<typeof useGetProductGroupLazyQuery>;
export type GetProductGroupQueryResult = Apollo.QueryResult<GetProductGroupQuery, GetProductGroupQueryVariables>;
export const GetProductGroupsDocument = gql`
    query getProductGroups($first: Int!, $page: Int, $search: String) {
  getProductGroups(first: $first, page: $page, search: $search) {
    data {
      id
      name
      organizationId
      products {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetProductGroupsQuery__
 *
 * To run a query within a React component, call `useGetProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetProductGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetProductGroupsQuery, GetProductGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductGroupsQuery, GetProductGroupsQueryVariables>(GetProductGroupsDocument, options);
      }
export function useGetProductGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductGroupsQuery, GetProductGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductGroupsQuery, GetProductGroupsQueryVariables>(GetProductGroupsDocument, options);
        }
export type GetProductGroupsQueryHookResult = ReturnType<typeof useGetProductGroupsQuery>;
export type GetProductGroupsLazyQueryHookResult = ReturnType<typeof useGetProductGroupsLazyQuery>;
export type GetProductGroupsQueryResult = Apollo.QueryResult<GetProductGroupsQuery, GetProductGroupsQueryVariables>;
export const GetProductStatsDocument = gql`
    query getProductStats {
  getProductStats {
    materialUsed {
      jobSizeComplete
      productMaterialUsed
      productType
      proposalJobSize
      proposalMaterialNeeded
    }
    productTypeUsedPercentages {
      equipmentUsedPercentage
      labourUsedPercentage
      materialUsedPercentage
      productType
    }
    products {
      actualProfitPercentage
      name
      proposedProfitPercentage
      sumOverallTotal
    }
  }
}
    `;

/**
 * __useGetProductStatsQuery__
 *
 * To run a query within a React component, call `useGetProductStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductStatsQuery, GetProductStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductStatsQuery, GetProductStatsQueryVariables>(GetProductStatsDocument, options);
      }
export function useGetProductStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductStatsQuery, GetProductStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductStatsQuery, GetProductStatsQueryVariables>(GetProductStatsDocument, options);
        }
export type GetProductStatsQueryHookResult = ReturnType<typeof useGetProductStatsQuery>;
export type GetProductStatsLazyQueryHookResult = ReturnType<typeof useGetProductStatsLazyQuery>;
export type GetProductStatsQueryResult = Apollo.QueryResult<GetProductStatsQuery, GetProductStatsQueryVariables>;
export const GetProductsDocument = gql`
    query getProducts($first: Int!, $orderBy: [QueryGetProductsOrderByOrderByClause!], $organizationProductTypeId: ID, $page: Int, $search: String, $type: ProductType) {
  getProducts(
    first: $first
    orderBy: $orderBy
    organizationProductTypeId: $organizationProductTypeId
    page: $page
    search: $search
    type: $type
  ) {
    data {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeAsphaltCurbing {
          curbHeight
          curbWidth
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMinimumProduct
      costMinimumProposal
      crew {
        color
        displayName
        employees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        rate
      }
      dailyUnitsComplete
      externalProductName
      id
      indirectPercentage
      labourCostType
      markupPercentage
      materialsNoPlant {
        id
        name
        percentage
        productId
        rate
      }
      measurementJob
      measurementMaterial
      name
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      overheadPercentage
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        id
        name
        phone
        products {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
      }
      plantProductId
      plantProducts {
        id
        pivot {
          applicationRate
        }
        plantId
        rate
        type
      }
      plants {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        id
        name
        phone
        products {
          id
          plantId
          rate
          type
        }
      }
      productAdditionalCosts {
        additionalCost {
          cost
          feeAmount
          feeType
          id
          name
        }
        id
        type
      }
      productCrews {
        crew {
          color
          displayName
          id
          name
          rate
        }
        id
        quantity
      }
      productEquipmentPieces {
        equipmentPiece {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        id
        quantity
      }
      productionRateType
      statementOfWork
      subcontracted
      type
      unitPrice
      unitPriceProduct
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProjectFileDocument = gql`
    query getProjectFile($id: ID!) {
  getProjectFile(id: $id) {
    children {
      children {
        createdAt
        fileSizeBytes
        id
        name
        parentFolderId
        path
        pivot {
          id
        }
        type
      }
      createdAt
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    createdAt
    fileSizeBytes
    id
    name
    parentFolderId
    path
    pivot {
      id
    }
    type
  }
}
    `;

/**
 * __useGetProjectFileQuery__
 *
 * To run a query within a React component, call `useGetProjectFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectFileQuery(baseOptions: Apollo.QueryHookOptions<GetProjectFileQuery, GetProjectFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectFileQuery, GetProjectFileQueryVariables>(GetProjectFileDocument, options);
      }
export function useGetProjectFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectFileQuery, GetProjectFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectFileQuery, GetProjectFileQueryVariables>(GetProjectFileDocument, options);
        }
export type GetProjectFileQueryHookResult = ReturnType<typeof useGetProjectFileQuery>;
export type GetProjectFileLazyQueryHookResult = ReturnType<typeof useGetProjectFileLazyQuery>;
export type GetProjectFileQueryResult = Apollo.QueryResult<GetProjectFileQuery, GetProjectFileQueryVariables>;
export const GetProjectFilesDocument = gql`
    query getProjectFiles {
  getProjectFiles {
    children {
      children {
        createdAt
        fileSizeBytes
        id
        name
        parentFolderId
        path
        pivot {
          id
        }
        type
      }
      createdAt
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    createdAt
    fileSizeBytes
    id
    name
    parentFolderId
    path
    pivot {
      id
    }
    type
  }
}
    `;

/**
 * __useGetProjectFilesQuery__
 *
 * To run a query within a React component, call `useGetProjectFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectFilesQuery, GetProjectFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectFilesQuery, GetProjectFilesQueryVariables>(GetProjectFilesDocument, options);
      }
export function useGetProjectFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectFilesQuery, GetProjectFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectFilesQuery, GetProjectFilesQueryVariables>(GetProjectFilesDocument, options);
        }
export type GetProjectFilesQueryHookResult = ReturnType<typeof useGetProjectFilesQuery>;
export type GetProjectFilesLazyQueryHookResult = ReturnType<typeof useGetProjectFilesLazyQuery>;
export type GetProjectFilesQueryResult = Apollo.QueryResult<GetProjectFilesQuery, GetProjectFilesQueryVariables>;
export const GetProjectMapDocument = gql`
    query getProjectMap($id: ID!) {
  getProjectMap(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    createdAt
    createdBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    description
    id
    latitude
    longitude
    mapData
    mapImage
    mapImageDirty
    measurements {
      featureGeojson
      geojsonFeatureId
      id
      isScreenshotTarget
      label
      measurementJob
      measurementType
      measurementValue
      product {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeAsphaltCurbing {
            curbHeight
            curbWidth
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMinimumProduct
        costMinimumProposal
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        dailyUnitsComplete
        externalProductName
        id
        indirectPercentage
        labourCostType
        markupPercentage
        materialsNoPlant {
          id
          name
          percentage
          productId
          rate
        }
        measurementJob
        measurementMaterial
        name
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        overheadPercentage
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        plantProductId
        plantProducts {
          id
          pivot {
            applicationRate
          }
          plantId
          rate
          type
        }
        plants {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            plantId
            rate
            type
          }
        }
        productAdditionalCosts {
          additionalCost {
            cost
            feeAmount
            feeType
            id
            name
          }
          id
          type
        }
        productCrews {
          crew {
            color
            displayName
            id
            name
            rate
          }
          id
          quantity
        }
        productEquipmentPieces {
          equipmentPiece {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          id
          quantity
        }
        productionRateType
        statementOfWork
        subcontracted
        type
        unitPrice
        unitPriceProduct
      }
      productId
      sortOrder
    }
    name
    updatedAt
  }
}
    `;

/**
 * __useGetProjectMapQuery__
 *
 * To run a query within a React component, call `useGetProjectMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectMapQuery(baseOptions: Apollo.QueryHookOptions<GetProjectMapQuery, GetProjectMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectMapQuery, GetProjectMapQueryVariables>(GetProjectMapDocument, options);
      }
export function useGetProjectMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectMapQuery, GetProjectMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectMapQuery, GetProjectMapQueryVariables>(GetProjectMapDocument, options);
        }
export type GetProjectMapQueryHookResult = ReturnType<typeof useGetProjectMapQuery>;
export type GetProjectMapLazyQueryHookResult = ReturnType<typeof useGetProjectMapLazyQuery>;
export type GetProjectMapQueryResult = Apollo.QueryResult<GetProjectMapQuery, GetProjectMapQueryVariables>;
export const GetProjectMapsDocument = gql`
    query getProjectMaps($first: Int!, $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetProjectMapsSortKey) {
  getProjectMaps(
    first: $first
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
  ) {
    data {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      createdAt
      createdBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      description
      id
      latitude
      longitude
      mapData
      mapImage
      mapImageDirty
      measurements {
        featureGeojson
        geojsonFeatureId
        id
        isScreenshotTarget
        label
        measurementJob
        measurementType
        measurementValue
        product {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeAsphaltCurbing {
              curbHeight
              curbWidth
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMinimumProduct
          costMinimumProposal
          crew {
            color
            displayName
            id
            name
            rate
          }
          dailyUnitsComplete
          externalProductName
          id
          indirectPercentage
          labourCostType
          markupPercentage
          materialsNoPlant {
            id
            name
            percentage
            productId
            rate
          }
          measurementJob
          measurementMaterial
          name
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          overheadPercentage
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProductId
          plantProducts {
            id
            plantId
            rate
            type
          }
          plants {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          productAdditionalCosts {
            id
            type
          }
          productCrews {
            id
            quantity
          }
          productEquipmentPieces {
            id
            quantity
          }
          productionRateType
          statementOfWork
          subcontracted
          type
          unitPrice
          unitPriceProduct
        }
        productId
        sortOrder
      }
      name
      updatedAt
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetProjectMapsQuery__
 *
 * To run a query within a React component, call `useGetProjectMapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMapsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useGetProjectMapsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectMapsQuery, GetProjectMapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectMapsQuery, GetProjectMapsQueryVariables>(GetProjectMapsDocument, options);
      }
export function useGetProjectMapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectMapsQuery, GetProjectMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectMapsQuery, GetProjectMapsQueryVariables>(GetProjectMapsDocument, options);
        }
export type GetProjectMapsQueryHookResult = ReturnType<typeof useGetProjectMapsQuery>;
export type GetProjectMapsLazyQueryHookResult = ReturnType<typeof useGetProjectMapsLazyQuery>;
export type GetProjectMapsQueryResult = Apollo.QueryResult<GetProjectMapsQuery, GetProjectMapsQueryVariables>;
export const GetProposalDocument = gql`
    query getProposal($id: ID!) {
  getProposal(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;

/**
 * __useGetProposalQuery__
 *
 * To run a query within a React component, call `useGetProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProposalQuery(baseOptions: Apollo.QueryHookOptions<GetProposalQuery, GetProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalQuery, GetProposalQueryVariables>(GetProposalDocument, options);
      }
export function useGetProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalQuery, GetProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalQuery, GetProposalQueryVariables>(GetProposalDocument, options);
        }
export type GetProposalQueryHookResult = ReturnType<typeof useGetProposalQuery>;
export type GetProposalLazyQueryHookResult = ReturnType<typeof useGetProposalLazyQuery>;
export type GetProposalQueryResult = Apollo.QueryResult<GetProposalQuery, GetProposalQueryVariables>;
export const GetProposalProductMapDataDocument = gql`
    query getProposalProductMapData($proposalProductId: ID!, $token: String!) {
  getProposalProductMapData(proposalProductId: $proposalProductId, token: $token)
}
    `;

/**
 * __useGetProposalProductMapDataQuery__
 *
 * To run a query within a React component, call `useGetProposalProductMapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalProductMapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalProductMapDataQuery({
 *   variables: {
 *      proposalProductId: // value for 'proposalProductId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetProposalProductMapDataQuery(baseOptions: Apollo.QueryHookOptions<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>(GetProposalProductMapDataDocument, options);
      }
export function useGetProposalProductMapDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>(GetProposalProductMapDataDocument, options);
        }
export type GetProposalProductMapDataQueryHookResult = ReturnType<typeof useGetProposalProductMapDataQuery>;
export type GetProposalProductMapDataLazyQueryHookResult = ReturnType<typeof useGetProposalProductMapDataLazyQuery>;
export type GetProposalProductMapDataQueryResult = Apollo.QueryResult<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>;
export const GetProposalUserMetricsDocument = gql`
    query getProposalUserMetrics($userId: ID) {
  getProposalUserMetrics(userId: $userId) {
    avgNetMargin
    closeRate
    salesGoal
    sentCount
    totalProposed
    totalWon
    userId
    wonCount
  }
}
    `;

/**
 * __useGetProposalUserMetricsQuery__
 *
 * To run a query within a React component, call `useGetProposalUserMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalUserMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalUserMetricsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetProposalUserMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetProposalUserMetricsQuery, GetProposalUserMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalUserMetricsQuery, GetProposalUserMetricsQueryVariables>(GetProposalUserMetricsDocument, options);
      }
export function useGetProposalUserMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalUserMetricsQuery, GetProposalUserMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalUserMetricsQuery, GetProposalUserMetricsQueryVariables>(GetProposalUserMetricsDocument, options);
        }
export type GetProposalUserMetricsQueryHookResult = ReturnType<typeof useGetProposalUserMetricsQuery>;
export type GetProposalUserMetricsLazyQueryHookResult = ReturnType<typeof useGetProposalUserMetricsLazyQuery>;
export type GetProposalUserMetricsQueryResult = Apollo.QueryResult<GetProposalUserMetricsQuery, GetProposalUserMetricsQueryVariables>;
export const GetProposalsDocument = gql`
    query getProposals($companyId: ID, $first: Int!, $multipleCompanyIDs: [ID!], $multipleUserIDs: [ID!], $organizationProductTypeIds: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetProposalsSortKey, $statuses: [ProposalStatus!], $userId: ID) {
  getProposals(
    companyId: $companyId
    first: $first
    multipleCompanyIDs: $multipleCompanyIDs
    multipleUserIDs: $multipleUserIDs
    organizationProductTypeIds: $organizationProductTypeIds
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
  ) {
    data {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        closeConfidence
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      clientEmailOverride
      closeConfidence
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      contentSettings {
        contentType
        id
        isEnabled
        proposalId
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      customFinancials {
        incomplete
        netMargin
        productsWithoutCosts
        profit
        sendErrors
      }
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      events {
        action
        createdAt
        id
      }
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      lastEvent {
        action
        createdAt
        id
      }
      lastStatusChange {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      latestPackageSendRun {
        failedRecipients
        id
        processedRecipients
        proposalId
        recipients {
          attemptCount
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          companyId
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          errorMessage
          id
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          sentAt
          startedAt
          status
        }
        status
        succeededRecipients
        totalRecipients
      }
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      organization {
        canMapWithAi
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      packageChildren {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageParent {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      packageWinnerProposal {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        updatedAt
        userId
        uuid
        version
        versionWithPrefix
        wonAt
      }
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        addressOverride
        checklistItems {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistNotes
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        discount
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalAfterDiscount
        profit
        profitAfterDiscount
        profitPercentage
        proposalProductGroups {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        roundTripTravelTimeHours
        stageMeasurements {
          featureGeojson
          geojsonFeatureId
          id
          isScreenshotTarget
          label
          measurementJob
          measurementType
          measurementValue
          product {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            externalProductName
            id
            indirectPercentage
            labourCostType
            markupPercentage
            measurementJob
            measurementMaterial
            name
            overheadPercentage
            plantProductId
            productionRateType
            statementOfWork
            subcontracted
            type
            unitPrice
            unitPriceProduct
          }
          productId
          sortOrder
        }
      }
      status
      statusChanges {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        status
      }
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      userId
      uuid
      version
      versionWithPrefix
      versions {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          addressOverride
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          closeConfidence
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          updatedAt
          userId
          uuid
          version
          versionWithPrefix
          wonAt
        }
        wonAt
      }
      wonAt
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetProposalsQuery__
 *
 * To run a query within a React component, call `useGetProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      multipleUserIDs: // value for 'multipleUserIDs'
 *      organizationProductTypeIds: // value for 'organizationProductTypeIds'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetProposalsQuery(baseOptions: Apollo.QueryHookOptions<GetProposalsQuery, GetProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalsQuery, GetProposalsQueryVariables>(GetProposalsDocument, options);
      }
export function useGetProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalsQuery, GetProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalsQuery, GetProposalsQueryVariables>(GetProposalsDocument, options);
        }
export type GetProposalsQueryHookResult = ReturnType<typeof useGetProposalsQuery>;
export type GetProposalsLazyQueryHookResult = ReturnType<typeof useGetProposalsLazyQuery>;
export type GetProposalsQueryResult = Apollo.QueryResult<GetProposalsQuery, GetProposalsQueryVariables>;
export const GetPublicInvoiceDocument = gql`
    query getPublicInvoice($email: String, $token: String, $uuid: String!) {
  getPublicInvoice(email: $email, token: $token, uuid: $uuid) {
    __typename
    ... on PublicInvoice {
      company {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        email
        logo
        name
        phone
      }
      data
      hideLineItemPricing
      job {
        address {
          city
          country
          line1
          line2
          state
          zip
        }
        externalId
        id
        proposalStage {
          id
          name
        }
      }
      organization {
        address {
          city
          country
          line1
          line2
          state
          zip
        }
        email
        logo
        name
        phone
      }
      pageTextParsed
      uuid
    }
    ... on PublicInvoiceOrganization {
      address {
        city
        country
        line1
        line2
        state
        zip
      }
      email
      logo
      name
      phone
    }
  }
}
    `;

/**
 * __useGetPublicInvoiceQuery__
 *
 * To run a query within a React component, call `useGetPublicInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicInvoiceQuery({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetPublicInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetPublicInvoiceQuery, GetPublicInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicInvoiceQuery, GetPublicInvoiceQueryVariables>(GetPublicInvoiceDocument, options);
      }
export function useGetPublicInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicInvoiceQuery, GetPublicInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicInvoiceQuery, GetPublicInvoiceQueryVariables>(GetPublicInvoiceDocument, options);
        }
export type GetPublicInvoiceQueryHookResult = ReturnType<typeof useGetPublicInvoiceQuery>;
export type GetPublicInvoiceLazyQueryHookResult = ReturnType<typeof useGetPublicInvoiceLazyQuery>;
export type GetPublicInvoiceQueryResult = Apollo.QueryResult<GetPublicInvoiceQuery, GetPublicInvoiceQueryVariables>;
export const GetPublicProposalDocument = gql`
    query getPublicProposal($email: String, $token: String, $uuid: String!) {
  getPublicProposal(email: $email, token: $token, uuid: $uuid) {
    __typename
    ... on PublicProposal {
      acceptanceOverride
      attachments {
        id
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
            organization {
              canMapWithAi
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              invoiceEmailText
              invoicingPaymentTermsNet
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              organizationSalesGoal
              phone
              proposalDefaults {
                autoSave
                color
                defaultLoadingTimeMins
                defaultTransferTruckId
                defaultUnloadTimeMins
                estimateTruckingByFullDay
                id
                idPrefix
                layout
                maxTripNumberPerTruck
                minimumProfitPerDay
                multiplyTravelTimeByDay
                multiplyTravelTimeForEquipmentLabour
                optionalCheckboxDefaultChecked
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
                roundUpToNearestDollarAmount
                startingNumber
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
          }
          documents {
            id
            name
            organization {
              canMapWithAi
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              invoiceEmailText
              invoicingPaymentTermsNet
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              organizationSalesGoal
              phone
              proposalDefaults {
                autoSave
                color
                defaultLoadingTimeMins
                defaultTransferTruckId
                defaultUnloadTimeMins
                estimateTruckingByFullDay
                id
                idPrefix
                layout
                maxTripNumberPerTruck
                minimumProfitPerDay
                multiplyTravelTimeByDay
                multiplyTravelTimeForEquipmentLabour
                optionalCheckboxDefaultChecked
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
                roundUpToNearestDollarAmount
                startingNumber
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      company {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        email
        id
        name
        phone
        website
      }
      contact {
        email
        firstName
        id
        lastName
        phone
        title
      }
      content {
        content
        contentOverride
        type
      }
      costTaxes
      discount
      externalId
      externalIdWithPrefix
      id
      layout
      organization {
        address {
          city
          country
          id
          isPrimary
          latitude
          line1
          line2
          longitude
          state
          zip
        }
        email
        id
        logo
        name
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
      }
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      profitAfterDiscount
      proposalPDF
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signeeInitials
      signeeName
      signeeTitle
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          state
          zip
        }
        addressOverride
        content {
          content
          contentOverride
          type
        }
        discount
        id
        name
        ordering
        overallTotal
        overallTotalAfterDiscount
        profitAfterDiscount
        proposalProductGroups {
          id
          isOptional
          name
          ordering
          proposalProducts {
            additionalCosts {
              additionalCostId
              cost
              costOverride
              costTotal
              feeAmount
              feeAmountOverride
              feeType
              id
              name
              quantity
              quantityOverride
              showOnProposal
            }
            discount
            files {
              createdAt
              filename
              id
              thumbnail
              type
            }
            id
            isOptional
            jobDuration
            jobSize
            mapImage
            material {
              areaCoverage
              attributes {
                __typename
                ... on ProductAttributeAsphalt {
                  applicationRate
                }
                ... on ProductAttributeAsphaltCurbing {
                  curbHeight
                  curbWidth
                }
                ... on ProductAttributeConcreteColumn {
                  diameter
                  height
                }
                ... on ProductAttributeConcreteCurbOrGutter {
                  curbHeight
                  curbWidth
                  gutterHeight
                  gutterWidth
                }
                ... on ProductAttributeConcreteFlatwork {
                  applicationRate
                }
                ... on ProductAttributeConcreteFooting {
                  depth
                  width
                }
                ... on ProductAttributeConcreteWall {
                  height
                  width
                }
                ... on ProductAttributeConcreteWaterway {
                  curbHeight
                  curbWidth
                  gutterHeight
                  gutterWidth
                }
                ... on ProductAttributeCrackSeal {
                  crackDepth
                  crackWidth
                  overbandThickness
                  overbandWidth
                  poundsPerBlock
                  poundsPerGallon
                }
                ... on ProductAttributeCurbWall {
                  curbHeight
                  curbWidth
                  gutterHeight
                  gutterWidth
                }
                ... on ProductAttributeExcavateOut {
                  applicationRate
                }
                ... on ProductAttributeGrading {
                  applicationRate
                  poundsPerCubicYard
                }
                ... on ProductAttributeMastic {
                  crackDepth
                  crackWidth
                  overbandThickness
                  overbandWidth
                  poundsPerBlock
                  poundsPerGallon
                }
                ... on ProductAttributeMicrosurfacing {
                  applicationRate
                }
                ... on ProductAttributeSealCoat {
                  applicationRate
                }
                ... on ProductAttributeSlurrySeal {
                  applicationRate
                }
                ... on ProductAttributeStriping {
                  applicationRate
                  lineWidth
                }
              }
              attributesOverride {
                __typename
                ... on ProductAttributeAsphalt {
                  applicationRate
                }
                ... on ProductAttributeAsphaltCurbing {
                  curbHeight
                  curbWidth
                }
                ... on ProductAttributeConcreteColumn {
                  diameter
                  height
                }
                ... on ProductAttributeConcreteCurbOrGutter {
                  curbHeight
                  curbWidth
                  gutterHeight
                  gutterWidth
                }
                ... on ProductAttributeConcreteFlatwork {
                  applicationRate
                }
                ... on ProductAttributeConcreteFooting {
                  depth
                  width
                }
                ... on ProductAttributeConcreteWall {
                  height
                  width
                }
                ... on ProductAttributeConcreteWaterway {
                  curbHeight
                  curbWidth
                  gutterHeight
                  gutterWidth
                }
                ... on ProductAttributeCrackSeal {
                  crackDepth
                  crackWidth
                  overbandThickness
                  overbandWidth
                  poundsPerBlock
                  poundsPerGallon
                }
                ... on ProductAttributeCurbWall {
                  curbHeight
                  curbWidth
                  gutterHeight
                  gutterWidth
                }
                ... on ProductAttributeExcavateOut {
                  applicationRate
                }
                ... on ProductAttributeGrading {
                  applicationRate
                  poundsPerCubicYard
                }
                ... on ProductAttributeMastic {
                  crackDepth
                  crackWidth
                  overbandThickness
                  overbandWidth
                  poundsPerBlock
                  poundsPerGallon
                }
                ... on ProductAttributeMicrosurfacing {
                  applicationRate
                }
                ... on ProductAttributeSealCoat {
                  applicationRate
                }
                ... on ProductAttributeSlurrySeal {
                  applicationRate
                }
                ... on ProductAttributeStriping {
                  applicationRate
                  lineWidth
                }
              }
              costMaterial
              costMaterialOverride
              costMinimumProduct
              costMinimumProposal
              dailyUnitsComplete
              dailyUnitsCompleteOverride
              externalProductName
              id
              indirectPercentage
              indirectPercentageOverride
              labourCostType
              markupPercentage
              markupPercentageOverride
              materialNeeded
              materialNeededOverride
              measurementJob
              measurementMaterial
              name
              organizationProductTypeName
              overheadPercentage
              overheadPercentageOverride
              productId
              productionRateType
              proposalId
              proposalProductId
              proposalStageId
              statementOfWork
              statementOfWorkOverride
              subcontracted
              tonConversionFactor
              tonConversionFactorOverride
              type
              unitPrice
              unitPriceOverride
              unitPriceProduct
            }
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            profitAfterDiscount
            projectFiles {
              children {
                createdAt
                fileSizeBytes
                id
                name
                parentFolderId
                path
                type
              }
              createdAt
              fileSizeBytes
              id
              name
              parentFolderId
              path
              pivot {
                id
              }
              type
            }
            proposalProductGroupId
            statementOfWork
            worksheet {
              name
              quantity
              scope
              unit
            }
          }
          showIndividualProducts
        }
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          discount
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          id
          isOptional
          jobDuration
          jobSize
          mapImage
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          profitAfterDiscount
          projectFiles {
            children {
              children {
                createdAt
                fileSizeBytes
                id
                name
                parentFolderId
                path
                type
              }
              createdAt
              fileSizeBytes
              id
              name
              parentFolderId
              path
              pivot {
                id
              }
              type
            }
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            pivot {
              id
            }
            type
          }
          proposalProductGroupId
          statementOfWork
          worksheet {
            name
            quantity
            scope
            unit
          }
        }
      }
      status
      user {
        email
        firstName
        id
        lastName
        phone
      }
    }
    ... on PublicProposalOrganization {
      estimatorEmail
      id
      logo
    }
  }
}
    `;

/**
 * __useGetPublicProposalQuery__
 *
 * To run a query within a React component, call `useGetPublicProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicProposalQuery({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetPublicProposalQuery(baseOptions: Apollo.QueryHookOptions<GetPublicProposalQuery, GetPublicProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicProposalQuery, GetPublicProposalQueryVariables>(GetPublicProposalDocument, options);
      }
export function useGetPublicProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicProposalQuery, GetPublicProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicProposalQuery, GetPublicProposalQueryVariables>(GetPublicProposalDocument, options);
        }
export type GetPublicProposalQueryHookResult = ReturnType<typeof useGetPublicProposalQuery>;
export type GetPublicProposalLazyQueryHookResult = ReturnType<typeof useGetPublicProposalLazyQuery>;
export type GetPublicProposalQueryResult = Apollo.QueryResult<GetPublicProposalQuery, GetPublicProposalQueryVariables>;
export const GetPublicProposalCompanyOrgDocument = gql`
    query getPublicProposalCompanyOrg($uuid: String!) {
  getPublicProposalCompanyOrg(uuid: $uuid) {
    company {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      name
      phone
      website
    }
    organization {
      address {
        city
        country
        id
        isPrimary
        latitude
        line1
        line2
        longitude
        state
        zip
      }
      email
      id
      logo
      name
      phone
      proposalDefaults {
        autoSave
        color
        defaultLoadingTimeMins
        defaultTransferTruckId
        defaultUnloadTimeMins
        estimateTruckingByFullDay
        id
        idPrefix
        layout
        maxTripNumberPerTruck
        minimumProfitPerDay
        multiplyTravelTimeByDay
        multiplyTravelTimeForEquipmentLabour
        optionalCheckboxDefaultChecked
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        roundUpToNearestDollarAmount
        startingNumber
      }
    }
  }
}
    `;

/**
 * __useGetPublicProposalCompanyOrgQuery__
 *
 * To run a query within a React component, call `useGetPublicProposalCompanyOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicProposalCompanyOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicProposalCompanyOrgQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetPublicProposalCompanyOrgQuery(baseOptions: Apollo.QueryHookOptions<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>(GetPublicProposalCompanyOrgDocument, options);
      }
export function useGetPublicProposalCompanyOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>(GetPublicProposalCompanyOrgDocument, options);
        }
export type GetPublicProposalCompanyOrgQueryHookResult = ReturnType<typeof useGetPublicProposalCompanyOrgQuery>;
export type GetPublicProposalCompanyOrgLazyQueryHookResult = ReturnType<typeof useGetPublicProposalCompanyOrgLazyQuery>;
export type GetPublicProposalCompanyOrgQueryResult = Apollo.QueryResult<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>;
export const GetQuickbooksIncomeAccountsDocument = gql`
    query getQuickbooksIncomeAccounts {
  getQuickbooksIncomeAccounts {
    id
    name
  }
}
    `;

/**
 * __useGetQuickbooksIncomeAccountsQuery__
 *
 * To run a query within a React component, call `useGetQuickbooksIncomeAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickbooksIncomeAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickbooksIncomeAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickbooksIncomeAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>(GetQuickbooksIncomeAccountsDocument, options);
      }
export function useGetQuickbooksIncomeAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>(GetQuickbooksIncomeAccountsDocument, options);
        }
export type GetQuickbooksIncomeAccountsQueryHookResult = ReturnType<typeof useGetQuickbooksIncomeAccountsQuery>;
export type GetQuickbooksIncomeAccountsLazyQueryHookResult = ReturnType<typeof useGetQuickbooksIncomeAccountsLazyQuery>;
export type GetQuickbooksIncomeAccountsQueryResult = Apollo.QueryResult<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>;
export const GetQuickbooksTaxCodesDocument = gql`
    query getQuickbooksTaxCodes {
  getQuickbooksTaxCodes {
    description
    id
    name
  }
}
    `;

/**
 * __useGetQuickbooksTaxCodesQuery__
 *
 * To run a query within a React component, call `useGetQuickbooksTaxCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickbooksTaxCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickbooksTaxCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickbooksTaxCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>(GetQuickbooksTaxCodesDocument, options);
      }
export function useGetQuickbooksTaxCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>(GetQuickbooksTaxCodesDocument, options);
        }
export type GetQuickbooksTaxCodesQueryHookResult = ReturnType<typeof useGetQuickbooksTaxCodesQuery>;
export type GetQuickbooksTaxCodesLazyQueryHookResult = ReturnType<typeof useGetQuickbooksTaxCodesLazyQuery>;
export type GetQuickbooksTaxCodesQueryResult = Apollo.QueryResult<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>;
export const GetQuickbooksTaxRatesDocument = gql`
    query getQuickbooksTaxRates {
  getQuickbooksTaxRates {
    description
    id
    name
    rateValue
  }
}
    `;

/**
 * __useGetQuickbooksTaxRatesQuery__
 *
 * To run a query within a React component, call `useGetQuickbooksTaxRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickbooksTaxRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickbooksTaxRatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickbooksTaxRatesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>(GetQuickbooksTaxRatesDocument, options);
      }
export function useGetQuickbooksTaxRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>(GetQuickbooksTaxRatesDocument, options);
        }
export type GetQuickbooksTaxRatesQueryHookResult = ReturnType<typeof useGetQuickbooksTaxRatesQuery>;
export type GetQuickbooksTaxRatesLazyQueryHookResult = ReturnType<typeof useGetQuickbooksTaxRatesLazyQuery>;
export type GetQuickbooksTaxRatesQueryResult = Apollo.QueryResult<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>;
export const GetQuickbooksTimeExportRunDocument = gql`
    query getQuickbooksTimeExportRun($id: ID!) {
  getQuickbooksTimeExportRun(id: $id) {
    createdByUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    createdByUserId
    dateEnd
    dateStart
    failedItems
    finishedAt
    id
    itemsCount
    lastErrorCode
    lastErrorMessage
    organizationId
    organizationLinkedServiceId
    processedItems
    skippedItems
    startedAt
    status
    succeededItems
    totalItems
  }
}
    `;

/**
 * __useGetQuickbooksTimeExportRunQuery__
 *
 * To run a query within a React component, call `useGetQuickbooksTimeExportRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickbooksTimeExportRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickbooksTimeExportRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuickbooksTimeExportRunQuery(baseOptions: Apollo.QueryHookOptions<GetQuickbooksTimeExportRunQuery, GetQuickbooksTimeExportRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickbooksTimeExportRunQuery, GetQuickbooksTimeExportRunQueryVariables>(GetQuickbooksTimeExportRunDocument, options);
      }
export function useGetQuickbooksTimeExportRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickbooksTimeExportRunQuery, GetQuickbooksTimeExportRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickbooksTimeExportRunQuery, GetQuickbooksTimeExportRunQueryVariables>(GetQuickbooksTimeExportRunDocument, options);
        }
export type GetQuickbooksTimeExportRunQueryHookResult = ReturnType<typeof useGetQuickbooksTimeExportRunQuery>;
export type GetQuickbooksTimeExportRunLazyQueryHookResult = ReturnType<typeof useGetQuickbooksTimeExportRunLazyQuery>;
export type GetQuickbooksTimeExportRunQueryResult = Apollo.QueryResult<GetQuickbooksTimeExportRunQuery, GetQuickbooksTimeExportRunQueryVariables>;
export const GetQuickbooksTimeExportRunItemsDocument = gql`
    query getQuickbooksTimeExportRunItems($first: Int!, $page: Int, $runId: ID!, $status: QuickbooksTimeExportItemStatus) {
  getQuickbooksTimeExportRunItems(
    first: $first
    page: $page
    runId: $runId
    status: $status
  ) {
    data {
      attemptCount
      errorCode
      errorMessage
      errorPayload
      exportedAt
      id
      lastAttemptAt
      organizationId
      qboCustomerId
      qboEmployeeId
      qboJobId
      qboTimeActivityId
      recommendedAction
      retryable
      runId
      status
      timeEntry {
        clockInLatitude
        clockInLongitude
        clockOutLatitude
        clockOutLongitude
        endTime
        forDate
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistCompletion {
            allCompleted
            ratio
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        notes
        organizationId
        startTime
        timeBucket {
          id
          name
          organizationId
        }
        timeTrackedSeconds
        timeTrackedSecondsOverride
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        uuid
      }
      timeEntryId
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetQuickbooksTimeExportRunItemsQuery__
 *
 * To run a query within a React component, call `useGetQuickbooksTimeExportRunItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickbooksTimeExportRunItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickbooksTimeExportRunItemsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      runId: // value for 'runId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetQuickbooksTimeExportRunItemsQuery(baseOptions: Apollo.QueryHookOptions<GetQuickbooksTimeExportRunItemsQuery, GetQuickbooksTimeExportRunItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickbooksTimeExportRunItemsQuery, GetQuickbooksTimeExportRunItemsQueryVariables>(GetQuickbooksTimeExportRunItemsDocument, options);
      }
export function useGetQuickbooksTimeExportRunItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickbooksTimeExportRunItemsQuery, GetQuickbooksTimeExportRunItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickbooksTimeExportRunItemsQuery, GetQuickbooksTimeExportRunItemsQueryVariables>(GetQuickbooksTimeExportRunItemsDocument, options);
        }
export type GetQuickbooksTimeExportRunItemsQueryHookResult = ReturnType<typeof useGetQuickbooksTimeExportRunItemsQuery>;
export type GetQuickbooksTimeExportRunItemsLazyQueryHookResult = ReturnType<typeof useGetQuickbooksTimeExportRunItemsLazyQuery>;
export type GetQuickbooksTimeExportRunItemsQueryResult = Apollo.QueryResult<GetQuickbooksTimeExportRunItemsQuery, GetQuickbooksTimeExportRunItemsQueryVariables>;
export const GetQuickbooksTimeExportRunsDocument = gql`
    query getQuickbooksTimeExportRuns($first: Int!, $page: Int, $status: QuickbooksTimeExportRunStatus) {
  getQuickbooksTimeExportRuns(first: $first, page: $page, status: $status) {
    data {
      createdByUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      createdByUserId
      dateEnd
      dateStart
      failedItems
      finishedAt
      id
      itemsCount
      lastErrorCode
      lastErrorMessage
      organizationId
      organizationLinkedServiceId
      processedItems
      skippedItems
      startedAt
      status
      succeededItems
      totalItems
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetQuickbooksTimeExportRunsQuery__
 *
 * To run a query within a React component, call `useGetQuickbooksTimeExportRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickbooksTimeExportRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickbooksTimeExportRunsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetQuickbooksTimeExportRunsQuery(baseOptions: Apollo.QueryHookOptions<GetQuickbooksTimeExportRunsQuery, GetQuickbooksTimeExportRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickbooksTimeExportRunsQuery, GetQuickbooksTimeExportRunsQueryVariables>(GetQuickbooksTimeExportRunsDocument, options);
      }
export function useGetQuickbooksTimeExportRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickbooksTimeExportRunsQuery, GetQuickbooksTimeExportRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickbooksTimeExportRunsQuery, GetQuickbooksTimeExportRunsQueryVariables>(GetQuickbooksTimeExportRunsDocument, options);
        }
export type GetQuickbooksTimeExportRunsQueryHookResult = ReturnType<typeof useGetQuickbooksTimeExportRunsQuery>;
export type GetQuickbooksTimeExportRunsLazyQueryHookResult = ReturnType<typeof useGetQuickbooksTimeExportRunsLazyQuery>;
export type GetQuickbooksTimeExportRunsQueryResult = Apollo.QueryResult<GetQuickbooksTimeExportRunsQuery, GetQuickbooksTimeExportRunsQueryVariables>;
export const GetRolesWithPermissionsDocument = gql`
    query getRolesWithPermissions {
  getRolesWithPermissions {
    admin
    employee
    foreman
    officeManager
    salesperson
    subcontractor
  }
}
    `;

/**
 * __useGetRolesWithPermissionsQuery__
 *
 * To run a query within a React component, call `useGetRolesWithPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesWithPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesWithPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesWithPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>(GetRolesWithPermissionsDocument, options);
      }
export function useGetRolesWithPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>(GetRolesWithPermissionsDocument, options);
        }
export type GetRolesWithPermissionsQueryHookResult = ReturnType<typeof useGetRolesWithPermissionsQuery>;
export type GetRolesWithPermissionsLazyQueryHookResult = ReturnType<typeof useGetRolesWithPermissionsLazyQuery>;
export type GetRolesWithPermissionsQueryResult = Apollo.QueryResult<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>;
export const GetTimeBucketDocument = gql`
    query getTimeBucket($id: ID!) {
  getTimeBucket(id: $id) {
    id
    name
    organizationId
  }
}
    `;

/**
 * __useGetTimeBucketQuery__
 *
 * To run a query within a React component, call `useGetTimeBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeBucketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTimeBucketQuery(baseOptions: Apollo.QueryHookOptions<GetTimeBucketQuery, GetTimeBucketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeBucketQuery, GetTimeBucketQueryVariables>(GetTimeBucketDocument, options);
      }
export function useGetTimeBucketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeBucketQuery, GetTimeBucketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeBucketQuery, GetTimeBucketQueryVariables>(GetTimeBucketDocument, options);
        }
export type GetTimeBucketQueryHookResult = ReturnType<typeof useGetTimeBucketQuery>;
export type GetTimeBucketLazyQueryHookResult = ReturnType<typeof useGetTimeBucketLazyQuery>;
export type GetTimeBucketQueryResult = Apollo.QueryResult<GetTimeBucketQuery, GetTimeBucketQueryVariables>;
export const GetTimeBucketsDocument = gql`
    query getTimeBuckets {
  getTimeBuckets {
    id
    name
    organizationId
  }
}
    `;

/**
 * __useGetTimeBucketsQuery__
 *
 * To run a query within a React component, call `useGetTimeBucketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeBucketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeBucketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimeBucketsQuery(baseOptions?: Apollo.QueryHookOptions<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>(GetTimeBucketsDocument, options);
      }
export function useGetTimeBucketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>(GetTimeBucketsDocument, options);
        }
export type GetTimeBucketsQueryHookResult = ReturnType<typeof useGetTimeBucketsQuery>;
export type GetTimeBucketsLazyQueryHookResult = ReturnType<typeof useGetTimeBucketsLazyQuery>;
export type GetTimeBucketsQueryResult = Apollo.QueryResult<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>;
export const GetTimeEntriesDocument = gql`
    query getTimeEntries($first: Int!, $forDate: Date, $forDateEnd: Date, $forDateStart: Date, $jobPhaseId: ID, $page: Int, $sortDirection: SortDirection, $sortKey: GetTimeEntriesSortKey, $userId: ID) {
  getTimeEntries(
    first: $first
    forDate: $forDate
    forDateEnd: $forDateEnd
    forDateStart: $forDateStart
    jobPhaseId: $jobPhaseId
    page: $page
    sortDirection: $sortDirection
    sortKey: $sortKey
    userId: $userId
  ) {
    data {
      clockInLatitude
      clockInLongitude
      clockOutLatitude
      clockOutLongitude
      endTime
      forDate
      id
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        actualSubcontractorCost
        actualSubcontractorName
        actualSubcontractorReference
        address
        applicableStatuses
        checklistCompletion {
          allCompleted
          ratio
        }
        checklistItems {
          checklistItem {
            id
            name
          }
          checklistItemId
          id
          isCompleted
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
        }
        checklistNotes
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            isSubcontractorCost
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          materialsNoPlants {
            costTotal
            id
            jobPhaseCostItemId
            name
            quantity
            rate
          }
          plantId
          plantProductId
          plants {
            costTotal
            id
            plantId
            plantProductId
            quantity
            rate
          }
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
        }
        costingMode
        crew {
          color
          displayName
          employees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          archivedAt
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
        }
        defaultEquipmentPieces {
          calculateTravelTime
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        hasJobCostsEntered
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          checklistItems {
            checklistItemId
            id
            isCompleted
            jobPhaseId
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          depositCollectedAt
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          id
          invoiceId
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
        }
        jobCostEntryDaysCount
        jobCostingCompletionStatus
        jobCostingThresholdPercent
        jobCostingVariancePercent
        jobDuration
        jobPhaseMaterialNoPlants {
          cost
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          jobPhaseId
          name
          percentage
          quantity
          rate
        }
        jobPhasePlant {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobPhasePlants {
          id
          materialNeeded
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            plantId
            rate
            type
          }
          rate
          type
          worksheetMaterial {
            quantity
            rate
            unit
          }
        }
        jobSize
        lastJobCostEntryDate
        missingCostCategories
        notes
        ordering
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          custom {
            area
            areaSource
            areaUnit
            calculationVersion
            costTotal
            fixedPrice
            indirectPercentage
            internalName
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            sourceProductId
            sourceProductRevision
            unit
          }
          discount
          equipmentPieces {
            calculateTravelTime
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isCustom
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeAsphaltCurbing {
                curbHeight
                curbWidth
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          overallTotalOverride
          plantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          productName
          profit
          profitAfterDiscount
          profitOverride
          profitPercentage
          profitPercentageOverride
          projectFiles {
            createdAt
            fileSizeBytes
            id
            name
            parentFolderId
            path
            type
          }
          proposalMaterialNoPlants {
            cost
            id
            name
            percentage
            proposalProductId
            quantity
            quantityOverride
            rate
          }
          proposalPlantProducts {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProductGroupId
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            proposalPlantProductId
            quantity
            quantityOverride
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
          unitPriceOverride
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        proposalProductGroup {
          id
          isOptional
          name
          ordering
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          showIndividualProducts
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          proposalPlantProduct {
            applicationRate
            applicationRateOverride
            areaCoverage
            costMaterial
            costTransferTruck
            id
            materialNeeded
            materialNeededOverride
            plantProductId
            rate
            rateOnWeight
            rateOverride
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTimeHrs
            transferTruckRoundTripTimeHrsOverride
            transferTruckUnloadTimeBuffer
            type
          }
          proposalPlantProductId
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruck {
            defaultRateHourly
            defaultRateTon
            defaultTonnage
            id
            name
          }
          transferTruckId
          worksheetBilling {
            quantity
            rate
            unit
          }
        }
        worksheet {
          area
          areaSource
          areaUnit
          costTotal
          fixedPrice
          indirectPercentage
          margin
          marginPercentage
          markup
          name
          overheadPercentage
          pricingBaseline {
            fixedPrice
            markup
            pricingMethod
            profitAmount
          }
          pricingMethod
          pricingOverrideField
          profitAmount
          quantity
          rate
          rows {
            calculatedQuantity
            calculation
            category
            factor
            factorAreaUnit
            factorLabel
            formula
            hoursPerTruck
            jobSize
            jobSizeUnit
            name
            quantity
            quantityOverride
            rate
            sourceId
            sourceName
            sourcePlantId
            sourcePlantName
            sourceType
            thickness
            total
            truckCapacity
            truckRateHours
            truckRateLoads
            truckRateTons
            truckRateYards
            truckingUnit
            trucksNeeded
            unit
          }
          scope
          scopeFormat
          sellingTotal
          unit
        }
      }
      notes
      organizationId
      startTime
      timeBucket {
        id
        name
        organizationId
      }
      timeTrackedSeconds
      timeTrackedSecondsOverride
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      uuid
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetTimeEntriesQuery__
 *
 * To run a query within a React component, call `useGetTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeEntriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      forDate: // value for 'forDate'
 *      forDateEnd: // value for 'forDateEnd'
 *      forDateStart: // value for 'forDateStart'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      page: // value for 'page'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>(GetTimeEntriesDocument, options);
      }
export function useGetTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>(GetTimeEntriesDocument, options);
        }
export type GetTimeEntriesQueryHookResult = ReturnType<typeof useGetTimeEntriesQuery>;
export type GetTimeEntriesLazyQueryHookResult = ReturnType<typeof useGetTimeEntriesLazyQuery>;
export type GetTimeEntriesQueryResult = Apollo.QueryResult<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>;
export const GetTimeEntriesGroupedByUserDocument = gql`
    query getTimeEntriesGroupedByUser($first: Int!, $forDate: Date, $forDateEnd: Date, $forDateStart: Date, $jobPhaseId: ID, $page: Int, $sortDirection: SortDirection, $userId: ID) {
  getTimeEntriesGroupedByUser(
    first: $first
    forDate: $forDate
    forDateEnd: $forDateEnd
    forDateStart: $forDateStart
    jobPhaseId: $jobPhaseId
    page: $page
    sortDirection: $sortDirection
    userId: $userId
  ) {
    data {
      dates {
        entries {
          clockInLatitude
          clockInLongitude
          clockOutLatitude
          clockOutLongitude
          endTime
          forDate
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            actualSubcontractorCost
            actualSubcontractorName
            actualSubcontractorReference
            address
            applicableStatuses
            checklistNotes
            costingMode
            crewId
            endsAt
            externalId
            hasJobCostsEntered
            id
            jobCostEntryDaysCount
            jobCostingCompletionStatus
            jobCostingThresholdPercent
            jobCostingVariancePercent
            jobDuration
            jobSize
            lastJobCostEntryDate
            missingCostCategories
            notes
            ordering
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          notes
          organizationId
          startTime
          timeBucket {
            id
            name
            organizationId
          }
          timeTrackedSeconds
          timeTrackedSecondsOverride
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          uuid
        }
        forDate
        totalEntries
        totalTimeTrackedSeconds
      }
      totalEntries
      totalTimeTrackedSeconds
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetTimeEntriesGroupedByUserQuery__
 *
 * To run a query within a React component, call `useGetTimeEntriesGroupedByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeEntriesGroupedByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeEntriesGroupedByUserQuery({
 *   variables: {
 *      first: // value for 'first'
 *      forDate: // value for 'forDate'
 *      forDateEnd: // value for 'forDateEnd'
 *      forDateStart: // value for 'forDateStart'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      page: // value for 'page'
 *      sortDirection: // value for 'sortDirection'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetTimeEntriesGroupedByUserQuery(baseOptions: Apollo.QueryHookOptions<GetTimeEntriesGroupedByUserQuery, GetTimeEntriesGroupedByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeEntriesGroupedByUserQuery, GetTimeEntriesGroupedByUserQueryVariables>(GetTimeEntriesGroupedByUserDocument, options);
      }
export function useGetTimeEntriesGroupedByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeEntriesGroupedByUserQuery, GetTimeEntriesGroupedByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeEntriesGroupedByUserQuery, GetTimeEntriesGroupedByUserQueryVariables>(GetTimeEntriesGroupedByUserDocument, options);
        }
export type GetTimeEntriesGroupedByUserQueryHookResult = ReturnType<typeof useGetTimeEntriesGroupedByUserQuery>;
export type GetTimeEntriesGroupedByUserLazyQueryHookResult = ReturnType<typeof useGetTimeEntriesGroupedByUserLazyQuery>;
export type GetTimeEntriesGroupedByUserQueryResult = Apollo.QueryResult<GetTimeEntriesGroupedByUserQuery, GetTimeEntriesGroupedByUserQueryVariables>;
export const GetTransferTruckDocument = gql`
    query getTransferTruck($id: ID!) {
  getTransferTruck(id: $id) {
    defaultRateHourly
    defaultRateTon
    defaultTonnage
    id
    name
  }
}
    `;

/**
 * __useGetTransferTruckQuery__
 *
 * To run a query within a React component, call `useGetTransferTruckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferTruckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferTruckQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransferTruckQuery(baseOptions: Apollo.QueryHookOptions<GetTransferTruckQuery, GetTransferTruckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferTruckQuery, GetTransferTruckQueryVariables>(GetTransferTruckDocument, options);
      }
export function useGetTransferTruckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferTruckQuery, GetTransferTruckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferTruckQuery, GetTransferTruckQueryVariables>(GetTransferTruckDocument, options);
        }
export type GetTransferTruckQueryHookResult = ReturnType<typeof useGetTransferTruckQuery>;
export type GetTransferTruckLazyQueryHookResult = ReturnType<typeof useGetTransferTruckLazyQuery>;
export type GetTransferTruckQueryResult = Apollo.QueryResult<GetTransferTruckQuery, GetTransferTruckQueryVariables>;
export const GetTransferTrucksDocument = gql`
    query getTransferTrucks {
  getTransferTrucks {
    defaultRateHourly
    defaultRateTon
    defaultTonnage
    id
    name
  }
}
    `;

/**
 * __useGetTransferTrucksQuery__
 *
 * To run a query within a React component, call `useGetTransferTrucksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferTrucksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferTrucksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransferTrucksQuery(baseOptions?: Apollo.QueryHookOptions<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>(GetTransferTrucksDocument, options);
      }
export function useGetTransferTrucksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>(GetTransferTrucksDocument, options);
        }
export type GetTransferTrucksQueryHookResult = ReturnType<typeof useGetTransferTrucksQuery>;
export type GetTransferTrucksLazyQueryHookResult = ReturnType<typeof useGetTransferTrucksLazyQuery>;
export type GetTransferTrucksQueryResult = Apollo.QueryResult<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>;
export const GetUserOrganizationDocument = gql`
    query getUserOrganization {
  getUserOrganization {
    canMapWithAi
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    invoiceEmailText
    invoicingPaymentTermsNet
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    organizationSalesGoal
    phone
    proposalDefaults {
      autoSave
      color
      defaultLoadingTimeMins
      defaultTransferTruckId
      defaultUnloadTimeMins
      estimateTruckingByFullDay
      id
      idPrefix
      layout
      maxTripNumberPerTruck
      minimumProfitPerDay
      multiplyTravelTimeByDay
      multiplyTravelTimeForEquipmentLabour
      optionalCheckboxDefaultChecked
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      roundUpToNearestDollarAmount
      startingNumber
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;

/**
 * __useGetUserOrganizationQuery__
 *
 * To run a query within a React component, call `useGetUserOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>(GetUserOrganizationDocument, options);
      }
export function useGetUserOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>(GetUserOrganizationDocument, options);
        }
export type GetUserOrganizationQueryHookResult = ReturnType<typeof useGetUserOrganizationQuery>;
export type GetUserOrganizationLazyQueryHookResult = ReturnType<typeof useGetUserOrganizationLazyQuery>;
export type GetUserOrganizationQueryResult = Apollo.QueryResult<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>;
export const GetYearOverYearRevenueReportDocument = gql`
    query getYearOverYearRevenueReport {
  getYearOverYearRevenueReport {
    data {
      lastYearRevenue
      month
      percentDifference
      thisYearRevenue
    }
  }
}
    `;

/**
 * __useGetYearOverYearRevenueReportQuery__
 *
 * To run a query within a React component, call `useGetYearOverYearRevenueReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYearOverYearRevenueReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYearOverYearRevenueReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetYearOverYearRevenueReportQuery(baseOptions?: Apollo.QueryHookOptions<GetYearOverYearRevenueReportQuery, GetYearOverYearRevenueReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYearOverYearRevenueReportQuery, GetYearOverYearRevenueReportQueryVariables>(GetYearOverYearRevenueReportDocument, options);
      }
export function useGetYearOverYearRevenueReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYearOverYearRevenueReportQuery, GetYearOverYearRevenueReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYearOverYearRevenueReportQuery, GetYearOverYearRevenueReportQueryVariables>(GetYearOverYearRevenueReportDocument, options);
        }
export type GetYearOverYearRevenueReportQueryHookResult = ReturnType<typeof useGetYearOverYearRevenueReportQuery>;
export type GetYearOverYearRevenueReportLazyQueryHookResult = ReturnType<typeof useGetYearOverYearRevenueReportLazyQuery>;
export type GetYearOverYearRevenueReportQueryResult = Apollo.QueryResult<GetYearOverYearRevenueReportQuery, GetYearOverYearRevenueReportQueryVariables>;
export const GetYearToDateStatsDocument = gql`
    query getYearToDateStats {
  getYearToDateStats {
    yearToDateCloseRate
    yearToDateJobAmountCompleted
    yearToDateNetMarginCalculated
    yearToDateTotalAmountProposed
    yearToDateTotalSalesWon
  }
}
    `;

/**
 * __useGetYearToDateStatsQuery__
 *
 * To run a query within a React component, call `useGetYearToDateStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYearToDateStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYearToDateStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetYearToDateStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>(GetYearToDateStatsDocument, options);
      }
export function useGetYearToDateStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>(GetYearToDateStatsDocument, options);
        }
export type GetYearToDateStatsQueryHookResult = ReturnType<typeof useGetYearToDateStatsQuery>;
export type GetYearToDateStatsLazyQueryHookResult = ReturnType<typeof useGetYearToDateStatsLazyQuery>;
export type GetYearToDateStatsQueryResult = Apollo.QueryResult<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>;
export const IsCompanySearchableDocument = gql`
    query isCompanySearchable($id: ID!) {
  isCompanySearchable(id: $id)
}
    `;

/**
 * __useIsCompanySearchableQuery__
 *
 * To run a query within a React component, call `useIsCompanySearchableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCompanySearchableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCompanySearchableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsCompanySearchableQuery(baseOptions: Apollo.QueryHookOptions<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>(IsCompanySearchableDocument, options);
      }
export function useIsCompanySearchableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>(IsCompanySearchableDocument, options);
        }
export type IsCompanySearchableQueryHookResult = ReturnType<typeof useIsCompanySearchableQuery>;
export type IsCompanySearchableLazyQueryHookResult = ReturnType<typeof useIsCompanySearchableLazyQuery>;
export type IsCompanySearchableQueryResult = Apollo.QueryResult<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>;
export const IsJobSearchableDocument = gql`
    query isJobSearchable($id: ID!) {
  isJobSearchable(id: $id)
}
    `;

/**
 * __useIsJobSearchableQuery__
 *
 * To run a query within a React component, call `useIsJobSearchableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsJobSearchableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsJobSearchableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsJobSearchableQuery(baseOptions: Apollo.QueryHookOptions<IsJobSearchableQuery, IsJobSearchableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsJobSearchableQuery, IsJobSearchableQueryVariables>(IsJobSearchableDocument, options);
      }
export function useIsJobSearchableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsJobSearchableQuery, IsJobSearchableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsJobSearchableQuery, IsJobSearchableQueryVariables>(IsJobSearchableDocument, options);
        }
export type IsJobSearchableQueryHookResult = ReturnType<typeof useIsJobSearchableQuery>;
export type IsJobSearchableLazyQueryHookResult = ReturnType<typeof useIsJobSearchableLazyQuery>;
export type IsJobSearchableQueryResult = Apollo.QueryResult<IsJobSearchableQuery, IsJobSearchableQueryVariables>;
export const IsOpportunitySearchableDocument = gql`
    query isOpportunitySearchable($id: ID!) {
  isOpportunitySearchable(id: $id)
}
    `;

/**
 * __useIsOpportunitySearchableQuery__
 *
 * To run a query within a React component, call `useIsOpportunitySearchableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOpportunitySearchableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOpportunitySearchableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsOpportunitySearchableQuery(baseOptions: Apollo.QueryHookOptions<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>(IsOpportunitySearchableDocument, options);
      }
export function useIsOpportunitySearchableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>(IsOpportunitySearchableDocument, options);
        }
export type IsOpportunitySearchableQueryHookResult = ReturnType<typeof useIsOpportunitySearchableQuery>;
export type IsOpportunitySearchableLazyQueryHookResult = ReturnType<typeof useIsOpportunitySearchableLazyQuery>;
export type IsOpportunitySearchableQueryResult = Apollo.QueryResult<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>;
export const IsProposalSearchableDocument = gql`
    query isProposalSearchable($id: ID!) {
  isProposalSearchable(id: $id)
}
    `;

/**
 * __useIsProposalSearchableQuery__
 *
 * To run a query within a React component, call `useIsProposalSearchableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsProposalSearchableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsProposalSearchableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsProposalSearchableQuery(baseOptions: Apollo.QueryHookOptions<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>(IsProposalSearchableDocument, options);
      }
export function useIsProposalSearchableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>(IsProposalSearchableDocument, options);
        }
export type IsProposalSearchableQueryHookResult = ReturnType<typeof useIsProposalSearchableQuery>;
export type IsProposalSearchableLazyQueryHookResult = ReturnType<typeof useIsProposalSearchableLazyQuery>;
export type IsProposalSearchableQueryResult = Apollo.QueryResult<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    archivedAt
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          canMapWithAi
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    salesGoal
    status
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const NotificationTriggerDeliveriesDocument = gql`
    query notificationTriggerDeliveries($first: Int, $triggerId: ID!) {
  notificationTriggerDeliveries(first: $first, triggerId: $triggerId) {
    attempts
    createdAt
    deliveredAt
    errorMessage
    eventType
    httpStatusCode
    id
    nextRetryAt
    notificationTriggerId
    responseBody
    status
    url
    uuid
  }
}
    `;

/**
 * __useNotificationTriggerDeliveriesQuery__
 *
 * To run a query within a React component, call `useNotificationTriggerDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTriggerDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTriggerDeliveriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      triggerId: // value for 'triggerId'
 *   },
 * });
 */
export function useNotificationTriggerDeliveriesQuery(baseOptions: Apollo.QueryHookOptions<NotificationTriggerDeliveriesQuery, NotificationTriggerDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationTriggerDeliveriesQuery, NotificationTriggerDeliveriesQueryVariables>(NotificationTriggerDeliveriesDocument, options);
      }
export function useNotificationTriggerDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationTriggerDeliveriesQuery, NotificationTriggerDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationTriggerDeliveriesQuery, NotificationTriggerDeliveriesQueryVariables>(NotificationTriggerDeliveriesDocument, options);
        }
export type NotificationTriggerDeliveriesQueryHookResult = ReturnType<typeof useNotificationTriggerDeliveriesQuery>;
export type NotificationTriggerDeliveriesLazyQueryHookResult = ReturnType<typeof useNotificationTriggerDeliveriesLazyQuery>;
export type NotificationTriggerDeliveriesQueryResult = Apollo.QueryResult<NotificationTriggerDeliveriesQuery, NotificationTriggerDeliveriesQueryVariables>;
export const OrganizationProposalChecklistItemsDocument = gql`
    query organizationProposalChecklistItems {
  organizationProposalChecklistItems {
    id
    name
    organization {
      canMapWithAi
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          canMapWithAi
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalDefaults {
            autoSave
            color
            defaultLoadingTimeMins
            defaultTransferTruckId
            defaultUnloadTimeMins
            estimateTruckingByFullDay
            id
            idPrefix
            layout
            maxTripNumberPerTruck
            minimumProfitPerDay
            multiplyTravelTimeByDay
            multiplyTravelTimeForEquipmentLabour
            optionalCheckboxDefaultChecked
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            roundUpToNearestDollarAmount
            startingNumber
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;

/**
 * __useOrganizationProposalChecklistItemsQuery__
 *
 * To run a query within a React component, call `useOrganizationProposalChecklistItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationProposalChecklistItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationProposalChecklistItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationProposalChecklistItemsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationProposalChecklistItemsQuery, OrganizationProposalChecklistItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationProposalChecklistItemsQuery, OrganizationProposalChecklistItemsQueryVariables>(OrganizationProposalChecklistItemsDocument, options);
      }
export function useOrganizationProposalChecklistItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationProposalChecklistItemsQuery, OrganizationProposalChecklistItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationProposalChecklistItemsQuery, OrganizationProposalChecklistItemsQueryVariables>(OrganizationProposalChecklistItemsDocument, options);
        }
export type OrganizationProposalChecklistItemsQueryHookResult = ReturnType<typeof useOrganizationProposalChecklistItemsQuery>;
export type OrganizationProposalChecklistItemsLazyQueryHookResult = ReturnType<typeof useOrganizationProposalChecklistItemsLazyQuery>;
export type OrganizationProposalChecklistItemsQueryResult = Apollo.QueryResult<OrganizationProposalChecklistItemsQuery, OrganizationProposalChecklistItemsQueryVariables>;
export const PreviewSubscriptionChangeDocument = gql`
    query previewSubscriptionChange($email: String, $quantityChange: Int!) {
  previewSubscriptionChange(email: $email, quantityChange: $quantityChange) {
    totalOnRenewal
    totalToday
  }
}
    `;

/**
 * __usePreviewSubscriptionChangeQuery__
 *
 * To run a query within a React component, call `usePreviewSubscriptionChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewSubscriptionChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewSubscriptionChangeQuery({
 *   variables: {
 *      email: // value for 'email'
 *      quantityChange: // value for 'quantityChange'
 *   },
 * });
 */
export function usePreviewSubscriptionChangeQuery(baseOptions: Apollo.QueryHookOptions<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>(PreviewSubscriptionChangeDocument, options);
      }
export function usePreviewSubscriptionChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>(PreviewSubscriptionChangeDocument, options);
        }
export type PreviewSubscriptionChangeQueryHookResult = ReturnType<typeof usePreviewSubscriptionChangeQuery>;
export type PreviewSubscriptionChangeLazyQueryHookResult = ReturnType<typeof usePreviewSubscriptionChangeLazyQuery>;
export type PreviewSubscriptionChangeQueryResult = Apollo.QueryResult<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>;
export const TaskRelatedSearchDocument = gql`
    query taskRelatedSearch($first: Int, $search: String!, $type: String!) {
  taskRelatedSearch(first: $first, search: $search, type: $type) {
    companyId
    contactId
    id
    label
    secondary
  }
}
    `;

/**
 * __useTaskRelatedSearchQuery__
 *
 * To run a query within a React component, call `useTaskRelatedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskRelatedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskRelatedSearchQuery({
 *   variables: {
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTaskRelatedSearchQuery(baseOptions: Apollo.QueryHookOptions<TaskRelatedSearchQuery, TaskRelatedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskRelatedSearchQuery, TaskRelatedSearchQueryVariables>(TaskRelatedSearchDocument, options);
      }
export function useTaskRelatedSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskRelatedSearchQuery, TaskRelatedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskRelatedSearchQuery, TaskRelatedSearchQueryVariables>(TaskRelatedSearchDocument, options);
        }
export type TaskRelatedSearchQueryHookResult = ReturnType<typeof useTaskRelatedSearchQuery>;
export type TaskRelatedSearchLazyQueryHookResult = ReturnType<typeof useTaskRelatedSearchLazyQuery>;
export type TaskRelatedSearchQueryResult = Apollo.QueryResult<TaskRelatedSearchQuery, TaskRelatedSearchQueryVariables>;
export const TimeEntryDocument = gql`
    query timeEntry($id: ID!) {
  timeEntry(id: $id) {
    clockInLatitude
    clockInLongitude
    clockOutLatitude
    clockOutLongitude
    endTime
    forDate
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      actualSubcontractorCost
      actualSubcontractorName
      actualSubcontractorReference
      address
      applicableStatuses
      checklistCompletion {
        allCompleted
        ratio
      }
      checklistItems {
        checklistItem {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        checklistItemId
        id
        isCompleted
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          actualSubcontractorCost
          actualSubcontractorName
          actualSubcontractorReference
          address
          applicableStatuses
          checklistNotes
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          costingMode
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            archivedAt
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            calculateTravelTime
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          hasJobCostsEntered
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            depositCollectedAt
            endsAt
            externalId
            id
            invoiceId
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
            uuid
          }
          jobCostEntryDaysCount
          jobCostingCompletionStatus
          jobCostingThresholdPercent
          jobCostingVariancePercent
          jobDuration
          jobPhaseMaterialNoPlants {
            cost
            id
            jobPhaseId
            name
            percentage
            quantity
            rate
          }
          jobPhasePlant {
            id
            materialNeeded
            name
            rate
            type
          }
          jobPhasePlants {
            id
            materialNeeded
            name
            rate
            type
          }
          jobSize
          lastJobCostEntryDate
          missingCostCategories
          notes
          ordering
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          proposalProductGroup {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalStage {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            proposalPlantProductId
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          worksheet {
            area
            areaSource
            areaUnit
            costTotal
            fixedPrice
            indirectPercentage
            margin
            marginPercentage
            markup
            name
            overheadPercentage
            pricingMethod
            pricingOverrideField
            profitAmount
            quantity
            rate
            scope
            scopeFormat
            sellingTotal
            unit
          }
        }
        jobPhaseId
      }
      checklistNotes
      costingMode
      crewId
      endsAt
      externalId
      hasJobCostsEntered
      id
      jobCostEntryDaysCount
      jobCostingCompletionStatus
      jobCostingThresholdPercent
      jobCostingVariancePercent
      jobDuration
      jobSize
      lastJobCostEntryDate
      missingCostCategories
      notes
      ordering
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    notes
    organizationId
    startTime
    timeBucket {
      id
      name
      organizationId
    }
    timeTrackedSeconds
    timeTrackedSecondsOverride
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        archivedAt
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        salesGoal
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    uuid
  }
}
    `;

/**
 * __useTimeEntryQuery__
 *
 * To run a query within a React component, call `useTimeEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeEntryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeEntryQuery(baseOptions: Apollo.QueryHookOptions<TimeEntryQuery, TimeEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeEntryQuery, TimeEntryQueryVariables>(TimeEntryDocument, options);
      }
export function useTimeEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeEntryQuery, TimeEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeEntryQuery, TimeEntryQueryVariables>(TimeEntryDocument, options);
        }
export type TimeEntryQueryHookResult = ReturnType<typeof useTimeEntryQuery>;
export type TimeEntryLazyQueryHookResult = ReturnType<typeof useTimeEntryLazyQuery>;
export type TimeEntryQueryResult = Apollo.QueryResult<TimeEntryQuery, TimeEntryQueryVariables>;
export const ValidateLoginDocument = gql`
    query validateLogin($input: ValidateLoginInput!) {
  validateLogin(input: $input)
}
    `;

/**
 * __useValidateLoginQuery__
 *
 * To run a query within a React component, call `useValidateLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateLoginQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateLoginQuery(baseOptions: Apollo.QueryHookOptions<ValidateLoginQuery, ValidateLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateLoginQuery, ValidateLoginQueryVariables>(ValidateLoginDocument, options);
      }
export function useValidateLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateLoginQuery, ValidateLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateLoginQuery, ValidateLoginQueryVariables>(ValidateLoginDocument, options);
        }
export type ValidateLoginQueryHookResult = ReturnType<typeof useValidateLoginQuery>;
export type ValidateLoginLazyQueryHookResult = ReturnType<typeof useValidateLoginLazyQuery>;
export type ValidateLoginQueryResult = Apollo.QueryResult<ValidateLoginQuery, ValidateLoginQueryVariables>;
export const ValidateUserInviteTokenDocument = gql`
    query validateUserInviteToken($email: String!, $inviteToken: String!) {
  validateUserInviteToken(email: $email, inviteToken: $inviteToken)
}
    `;

/**
 * __useValidateUserInviteTokenQuery__
 *
 * To run a query within a React component, call `useValidateUserInviteTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateUserInviteTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateUserInviteTokenQuery({
 *   variables: {
 *      email: // value for 'email'
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useValidateUserInviteTokenQuery(baseOptions: Apollo.QueryHookOptions<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>(ValidateUserInviteTokenDocument, options);
      }
export function useValidateUserInviteTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>(ValidateUserInviteTokenDocument, options);
        }
export type ValidateUserInviteTokenQueryHookResult = ReturnType<typeof useValidateUserInviteTokenQuery>;
export type ValidateUserInviteTokenLazyQueryHookResult = ReturnType<typeof useValidateUserInviteTokenLazyQuery>;
export type ValidateUserInviteTokenQueryResult = Apollo.QueryResult<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>;
export const WorksheetProductsDocument = gql`
    query worksheetProducts {
  worksheetProducts {
    definition {
      area
      areaSource
      areaUnit
      costTotal
      fixedPrice
      indirectPercentage
      margin
      marginPercentage
      markup
      name
      overheadPercentage
      pricingBaseline {
        fixedPrice
        markup
        pricingMethod
        profitAmount
      }
      pricingMethod
      pricingOverrideField
      profitAmount
      quantity
      rate
      rows {
        calculatedQuantity
        calculation
        category
        factor
        factorAreaUnit
        factorLabel
        formula
        hoursPerTruck
        jobSize
        jobSizeUnit
        name
        quantity
        quantityOverride
        rate
        sourceId
        sourceName
        sourcePlantId
        sourcePlantName
        sourceType
        thickness
        total
        truckCapacity
        truckRateHours
        truckRateLoads
        truckRateTons
        truckRateYards
        truckingUnit
        trucksNeeded
        unit
      }
      scope
      scopeFormat
      sellingTotal
      unit
    }
    id
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
  }
}
    `;

/**
 * __useWorksheetProductsQuery__
 *
 * To run a query within a React component, call `useWorksheetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorksheetProductsQuery(baseOptions?: Apollo.QueryHookOptions<WorksheetProductsQuery, WorksheetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorksheetProductsQuery, WorksheetProductsQueryVariables>(WorksheetProductsDocument, options);
      }
export function useWorksheetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorksheetProductsQuery, WorksheetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorksheetProductsQuery, WorksheetProductsQueryVariables>(WorksheetProductsDocument, options);
        }
export type WorksheetProductsQueryHookResult = ReturnType<typeof useWorksheetProductsQuery>;
export type WorksheetProductsLazyQueryHookResult = ReturnType<typeof useWorksheetProductsLazyQuery>;
export type WorksheetProductsQueryResult = Apollo.QueryResult<WorksheetProductsQuery, WorksheetProductsQueryVariables>;
export const WorksheetProposalDocument = gql`
    query worksheetProposal($id: ID!) {
  worksheetProposal(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        canMapWithAi
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        invoiceEmailText
        invoicingPaymentTermsNet
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        organizationSalesGoal
        phone
        proposalDefaults {
          autoSave
          color
          defaultLoadingTimeMins
          defaultTransferTruckId
          defaultUnloadTimeMins
          estimateTruckingByFullDay
          id
          idPrefix
          layout
          maxTripNumberPerTruck
          minimumProfitPerDay
          multiplyTravelTimeByDay
          multiplyTravelTimeForEquipmentLabour
          optionalCheckboxDefaultChecked
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          roundUpToNearestDollarAmount
          startingNumber
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        closeConfidence
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        contentSettings {
          contentType
          id
          isEnabled
          proposalId
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        customFinancials {
          incomplete
          netMargin
          productsWithoutCosts
          profit
          sendErrors
        }
        discount
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        estimatingMethod
        events {
          action
          createdAt
          id
        }
        externalId
        externalIdWithPrefix
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isPackageChild
        isPackageParent
        isSendable
        lastEvent {
          action
          createdAt
          id
        }
        lastStatusChange {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        latestPackageSendRun {
          failedRecipients
          id
          processedRecipients
          proposalId
          recipients {
            attemptCount
            companyId
            contactId
            errorMessage
            id
            proposalId
            sentAt
            startedAt
            status
          }
          status
          succeededRecipients
          totalRecipients
        }
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        organization {
          canMapWithAi
          email
          emailTemplate
          failingPayment
          id
          invoiceEmailText
          invoicingPaymentTermsNet
          logo
          name
          onTrial
          organizationSalesGoal
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        overallTotal
        overallTotalAfterDiscount
        overallTotalAfterTaxes
        packageChildren {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageParent {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        packageWinnerProposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        pdfGeneratedAt
        profit
        profitAfterDiscount
        profitPercentage
        projectFilesFolderId
        projectedCloseDate
        proposalNotes
        proposalPackageParentId
        proposalPackageWinnerProposalId
        proposalPdf
        proposalRole
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          checklistItems {
            id
            name
          }
          checklistNotes
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          discount
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalAfterDiscount
          profit
          profitAfterDiscount
          profitPercentage
          proposalProductGroups {
            id
            isOptional
            name
            ordering
            showIndividualProducts
          }
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            discount
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isCustom
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            overallTotalOverride
            productName
            profit
            profitAfterDiscount
            profitOverride
            profitPercentage
            profitPercentageOverride
            proposalProductGroupId
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            unitPriceOverride
          }
          roundTripTravelTimeHours
          stageMeasurements {
            featureGeojson
            geojsonFeatureId
            id
            isScreenshotTarget
            label
            measurementJob
            measurementType
            measurementValue
            productId
            sortOrder
          }
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          status
        }
        updatedAt
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          archivedAt
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          salesGoal
          status
        }
        userId
        uuid
        version
        versionWithPrefix
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          clientEmailOverride
          closeConfidence
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          contentSettings {
            contentType
            id
            isEnabled
            proposalId
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          customFinancials {
            incomplete
            netMargin
            productsWithoutCosts
            profit
            sendErrors
          }
          discount
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          estimatingMethod
          events {
            action
            createdAt
            id
          }
          externalId
          externalIdWithPrefix
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isPackageChild
          isPackageParent
          isSendable
          lastEvent {
            action
            createdAt
            id
          }
          lastStatusChange {
            changeAt
            status
          }
          latestPackageSendRun {
            failedRecipients
            id
            processedRecipients
            proposalId
            status
            succeededRecipients
            totalRecipients
          }
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          organization {
            canMapWithAi
            email
            emailTemplate
            failingPayment
            id
            invoiceEmailText
            invoicingPaymentTermsNet
            logo
            name
            onTrial
            organizationSalesGoal
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          overallTotal
          overallTotalAfterDiscount
          overallTotalAfterTaxes
          packageChildren {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageParent {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          packageWinnerProposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          pdfGeneratedAt
          profit
          profitAfterDiscount
          profitPercentage
          projectFilesFolderId
          projectedCloseDate
          proposalNotes
          proposalPackageParentId
          proposalPackageWinnerProposalId
          proposalPdf
          proposalRole
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            checklistNotes
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            discount
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalAfterDiscount
            profit
            profitAfterDiscount
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          updatedAt
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            archivedAt
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            salesGoal
            status
          }
          userId
          uuid
          version
          versionWithPrefix
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            closeConfidence
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            discount
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            estimatingMethod
            externalId
            externalIdWithPrefix
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isPackageChild
            isPackageParent
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterDiscount
            overallTotalAfterTaxes
            pdfGeneratedAt
            profit
            profitAfterDiscount
            profitPercentage
            projectFilesFolderId
            projectedCloseDate
            proposalNotes
            proposalPackageParentId
            proposalPackageWinnerProposalId
            proposalPdf
            proposalRole
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            updatedAt
            userId
            uuid
            version
            versionWithPrefix
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    clientEmailOverride
    closeConfidence
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    contentSettings {
      contentType
      id
      isEnabled
      proposalId
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    customFinancials {
      incomplete
      netMargin
      productsWithoutCosts
      profit
      sendErrors
    }
    discount
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    estimatingMethod
    events {
      action
      createdAt
      id
    }
    externalId
    externalIdWithPrefix
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isPackageChild
    isPackageParent
    isSendable
    lastEvent {
      action
      createdAt
      id
    }
    lastStatusChange {
      changeAt
      status
    }
    latestPackageSendRun {
      failedRecipients
      id
      processedRecipients
      proposalId
      status
      succeededRecipients
      totalRecipients
    }
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    organization {
      canMapWithAi
      email
      emailTemplate
      failingPayment
      id
      invoiceEmailText
      invoicingPaymentTermsNet
      logo
      name
      onTrial
      organizationSalesGoal
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    overallTotal
    overallTotalAfterDiscount
    overallTotalAfterTaxes
    packageChildren {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageParent {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    packageWinnerProposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    pdfGeneratedAt
    profit
    profitAfterDiscount
    profitPercentage
    projectFilesFolderId
    projectedCloseDate
    proposalNotes
    proposalPackageParentId
    proposalPackageWinnerProposalId
    proposalPdf
    proposalRole
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      checklistNotes
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      discount
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalAfterDiscount
      profit
      profitAfterDiscount
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      archivedAt
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      salesGoal
      status
    }
    userId
    uuid
    version
    versionWithPrefix
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      closeConfidence
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      discount
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      estimatingMethod
      externalId
      externalIdWithPrefix
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isPackageChild
      isPackageParent
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterDiscount
      overallTotalAfterTaxes
      pdfGeneratedAt
      profit
      profitAfterDiscount
      profitPercentage
      projectFilesFolderId
      projectedCloseDate
      proposalNotes
      proposalPackageParentId
      proposalPackageWinnerProposalId
      proposalPdf
      proposalRole
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      updatedAt
      userId
      uuid
      version
      versionWithPrefix
      wonAt
    }
    wonAt
  }
}
    `;

/**
 * __useWorksheetProposalQuery__
 *
 * To run a query within a React component, call `useWorksheetProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorksheetProposalQuery(baseOptions: Apollo.QueryHookOptions<WorksheetProposalQuery, WorksheetProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorksheetProposalQuery, WorksheetProposalQueryVariables>(WorksheetProposalDocument, options);
      }
export function useWorksheetProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorksheetProposalQuery, WorksheetProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorksheetProposalQuery, WorksheetProposalQueryVariables>(WorksheetProposalDocument, options);
        }
export type WorksheetProposalQueryHookResult = ReturnType<typeof useWorksheetProposalQuery>;
export type WorksheetProposalLazyQueryHookResult = ReturnType<typeof useWorksheetProposalLazyQuery>;
export type WorksheetProposalQueryResult = Apollo.QueryResult<WorksheetProposalQuery, WorksheetProposalQueryVariables>;
export const WorksheetSettingsDocument = gql`
    query worksheetSettings {
  worksheetSettings {
    canManageProducts
    canManageSettings
    enabled
    factors {
      label
      value
    }
    markup
    method
  }
}
    `;

/**
 * __useWorksheetSettingsQuery__
 *
 * To run a query within a React component, call `useWorksheetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorksheetSettingsQuery(baseOptions?: Apollo.QueryHookOptions<WorksheetSettingsQuery, WorksheetSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorksheetSettingsQuery, WorksheetSettingsQueryVariables>(WorksheetSettingsDocument, options);
      }
export function useWorksheetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorksheetSettingsQuery, WorksheetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorksheetSettingsQuery, WorksheetSettingsQueryVariables>(WorksheetSettingsDocument, options);
        }
export type WorksheetSettingsQueryHookResult = ReturnType<typeof useWorksheetSettingsQuery>;
export type WorksheetSettingsLazyQueryHookResult = ReturnType<typeof useWorksheetSettingsLazyQuery>;
export type WorksheetSettingsQueryResult = Apollo.QueryResult<WorksheetSettingsQuery, WorksheetSettingsQueryVariables>;
export const CustomAddPlantProductToProposalProductDocument = gql`
    mutation customAddPlantProductToProposalProduct($input: AddPlantProductToProposalProductInput!) {
  addPlantProductToProposalProduct(input: $input) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomAddPlantProductToProposalProductMutationFn = Apollo.MutationFunction<CustomAddPlantProductToProposalProductMutation, CustomAddPlantProductToProposalProductMutationVariables>;

/**
 * __useCustomAddPlantProductToProposalProductMutation__
 *
 * To run a mutation, you first call `useCustomAddPlantProductToProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomAddPlantProductToProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customAddPlantProductToProposalProductMutation, { data, loading, error }] = useCustomAddPlantProductToProposalProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomAddPlantProductToProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomAddPlantProductToProposalProductMutation, CustomAddPlantProductToProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomAddPlantProductToProposalProductMutation, CustomAddPlantProductToProposalProductMutationVariables>(CustomAddPlantProductToProposalProductDocument, options);
      }
export type CustomAddPlantProductToProposalProductMutationHookResult = ReturnType<typeof useCustomAddPlantProductToProposalProductMutation>;
export type CustomAddPlantProductToProposalProductMutationResult = Apollo.MutationResult<CustomAddPlantProductToProposalProductMutation>;
export type CustomAddPlantProductToProposalProductMutationOptions = Apollo.BaseMutationOptions<CustomAddPlantProductToProposalProductMutation, CustomAddPlantProductToProposalProductMutationVariables>;
export const CustomAddProductsToProposalStageDocument = gql`
    mutation customAddProductsToProposalStage($input: AddProductsToProposalStageInput!) {
  addProductsToProposalStage(input: $input) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomAddProductsToProposalStageMutationFn = Apollo.MutationFunction<CustomAddProductsToProposalStageMutation, CustomAddProductsToProposalStageMutationVariables>;

/**
 * __useCustomAddProductsToProposalStageMutation__
 *
 * To run a mutation, you first call `useCustomAddProductsToProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomAddProductsToProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customAddProductsToProposalStageMutation, { data, loading, error }] = useCustomAddProductsToProposalStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomAddProductsToProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomAddProductsToProposalStageMutation, CustomAddProductsToProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomAddProductsToProposalStageMutation, CustomAddProductsToProposalStageMutationVariables>(CustomAddProductsToProposalStageDocument, options);
      }
export type CustomAddProductsToProposalStageMutationHookResult = ReturnType<typeof useCustomAddProductsToProposalStageMutation>;
export type CustomAddProductsToProposalStageMutationResult = Apollo.MutationResult<CustomAddProductsToProposalStageMutation>;
export type CustomAddProductsToProposalStageMutationOptions = Apollo.BaseMutationOptions<CustomAddProductsToProposalStageMutation, CustomAddProductsToProposalStageMutationVariables>;
export const CustomAddProposalAddressDocument = gql`
    mutation customAddProposalAddress($input: AddProposalAddressInput!) {
  addProposalAddress(input: $input) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomAddProposalAddressMutationFn = Apollo.MutationFunction<CustomAddProposalAddressMutation, CustomAddProposalAddressMutationVariables>;

/**
 * __useCustomAddProposalAddressMutation__
 *
 * To run a mutation, you first call `useCustomAddProposalAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomAddProposalAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customAddProposalAddressMutation, { data, loading, error }] = useCustomAddProposalAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomAddProposalAddressMutation(baseOptions?: Apollo.MutationHookOptions<CustomAddProposalAddressMutation, CustomAddProposalAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomAddProposalAddressMutation, CustomAddProposalAddressMutationVariables>(CustomAddProposalAddressDocument, options);
      }
export type CustomAddProposalAddressMutationHookResult = ReturnType<typeof useCustomAddProposalAddressMutation>;
export type CustomAddProposalAddressMutationResult = Apollo.MutationResult<CustomAddProposalAddressMutation>;
export type CustomAddProposalAddressMutationOptions = Apollo.BaseMutationOptions<CustomAddProposalAddressMutation, CustomAddProposalAddressMutationVariables>;
export const CustomAddProposalEquipmentPieceDocument = gql`
    mutation customAddProposalEquipmentPiece($equipmentPieceId: ID!, $proposalProductId: ID!, $quantity: Float!) {
  addProposalEquipmentPiece(
    equipmentPieceId: $equipmentPieceId
    proposalProductId: $proposalProductId
    quantity: $quantity
  ) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomAddProposalEquipmentPieceMutationFn = Apollo.MutationFunction<CustomAddProposalEquipmentPieceMutation, CustomAddProposalEquipmentPieceMutationVariables>;

/**
 * __useCustomAddProposalEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useCustomAddProposalEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomAddProposalEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customAddProposalEquipmentPieceMutation, { data, loading, error }] = useCustomAddProposalEquipmentPieceMutation({
 *   variables: {
 *      equipmentPieceId: // value for 'equipmentPieceId'
 *      proposalProductId: // value for 'proposalProductId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useCustomAddProposalEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<CustomAddProposalEquipmentPieceMutation, CustomAddProposalEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomAddProposalEquipmentPieceMutation, CustomAddProposalEquipmentPieceMutationVariables>(CustomAddProposalEquipmentPieceDocument, options);
      }
export type CustomAddProposalEquipmentPieceMutationHookResult = ReturnType<typeof useCustomAddProposalEquipmentPieceMutation>;
export type CustomAddProposalEquipmentPieceMutationResult = Apollo.MutationResult<CustomAddProposalEquipmentPieceMutation>;
export type CustomAddProposalEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<CustomAddProposalEquipmentPieceMutation, CustomAddProposalEquipmentPieceMutationVariables>;
export const CustomAddProposalStageDocument = gql`
    mutation customAddProposalStage($proposalId: ID!) {
  addProposalStage(proposalId: $proposalId) {
    ...BitumioProposalStage
  }
}
    ${BitumioProposalStageFragmentDoc}`;
export type CustomAddProposalStageMutationFn = Apollo.MutationFunction<CustomAddProposalStageMutation, CustomAddProposalStageMutationVariables>;

/**
 * __useCustomAddProposalStageMutation__
 *
 * To run a mutation, you first call `useCustomAddProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomAddProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customAddProposalStageMutation, { data, loading, error }] = useCustomAddProposalStageMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCustomAddProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomAddProposalStageMutation, CustomAddProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomAddProposalStageMutation, CustomAddProposalStageMutationVariables>(CustomAddProposalStageDocument, options);
      }
export type CustomAddProposalStageMutationHookResult = ReturnType<typeof useCustomAddProposalStageMutation>;
export type CustomAddProposalStageMutationResult = Apollo.MutationResult<CustomAddProposalStageMutation>;
export type CustomAddProposalStageMutationOptions = Apollo.BaseMutationOptions<CustomAddProposalStageMutation, CustomAddProposalStageMutationVariables>;
export const CustomApplyAiMappingAdditionalCostsDocument = gql`
    mutation customApplyAiMappingAdditionalCosts($input: ApplyAiMappingAdditionalCostsInput!) {
  applyAiMappingAdditionalCosts(input: $input) {
    id
  }
}
    `;
export type CustomApplyAiMappingAdditionalCostsMutationFn = Apollo.MutationFunction<CustomApplyAiMappingAdditionalCostsMutation, CustomApplyAiMappingAdditionalCostsMutationVariables>;

/**
 * __useCustomApplyAiMappingAdditionalCostsMutation__
 *
 * To run a mutation, you first call `useCustomApplyAiMappingAdditionalCostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomApplyAiMappingAdditionalCostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customApplyAiMappingAdditionalCostsMutation, { data, loading, error }] = useCustomApplyAiMappingAdditionalCostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomApplyAiMappingAdditionalCostsMutation(baseOptions?: Apollo.MutationHookOptions<CustomApplyAiMappingAdditionalCostsMutation, CustomApplyAiMappingAdditionalCostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomApplyAiMappingAdditionalCostsMutation, CustomApplyAiMappingAdditionalCostsMutationVariables>(CustomApplyAiMappingAdditionalCostsDocument, options);
      }
export type CustomApplyAiMappingAdditionalCostsMutationHookResult = ReturnType<typeof useCustomApplyAiMappingAdditionalCostsMutation>;
export type CustomApplyAiMappingAdditionalCostsMutationResult = Apollo.MutationResult<CustomApplyAiMappingAdditionalCostsMutation>;
export type CustomApplyAiMappingAdditionalCostsMutationOptions = Apollo.BaseMutationOptions<CustomApplyAiMappingAdditionalCostsMutation, CustomApplyAiMappingAdditionalCostsMutationVariables>;
export const CustomApplyProposalStageMeasurementsDocument = gql`
    mutation customApplyProposalStageMeasurements($input: ApplyProposalStageMeasurementsInput!) {
  applyProposalStageMeasurements(input: $input) {
    warnings
    proposal {
      ...BitumioProposal
    }
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomApplyProposalStageMeasurementsMutationFn = Apollo.MutationFunction<CustomApplyProposalStageMeasurementsMutation, CustomApplyProposalStageMeasurementsMutationVariables>;

/**
 * __useCustomApplyProposalStageMeasurementsMutation__
 *
 * To run a mutation, you first call `useCustomApplyProposalStageMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomApplyProposalStageMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customApplyProposalStageMeasurementsMutation, { data, loading, error }] = useCustomApplyProposalStageMeasurementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomApplyProposalStageMeasurementsMutation(baseOptions?: Apollo.MutationHookOptions<CustomApplyProposalStageMeasurementsMutation, CustomApplyProposalStageMeasurementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomApplyProposalStageMeasurementsMutation, CustomApplyProposalStageMeasurementsMutationVariables>(CustomApplyProposalStageMeasurementsDocument, options);
      }
export type CustomApplyProposalStageMeasurementsMutationHookResult = ReturnType<typeof useCustomApplyProposalStageMeasurementsMutation>;
export type CustomApplyProposalStageMeasurementsMutationResult = Apollo.MutationResult<CustomApplyProposalStageMeasurementsMutation>;
export type CustomApplyProposalStageMeasurementsMutationOptions = Apollo.BaseMutationOptions<CustomApplyProposalStageMeasurementsMutation, CustomApplyProposalStageMeasurementsMutationVariables>;
export const CustomCancelAiMappingTaskDocument = gql`
    mutation customCancelAiMappingTask($taskId: String!) {
  cancelAiMappingTask(taskId: $taskId) {
    ...AiMappingRunAreaFragment
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;
export type CustomCancelAiMappingTaskMutationFn = Apollo.MutationFunction<CustomCancelAiMappingTaskMutation, CustomCancelAiMappingTaskMutationVariables>;

/**
 * __useCustomCancelAiMappingTaskMutation__
 *
 * To run a mutation, you first call `useCustomCancelAiMappingTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCancelAiMappingTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCancelAiMappingTaskMutation, { data, loading, error }] = useCustomCancelAiMappingTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCustomCancelAiMappingTaskMutation(baseOptions?: Apollo.MutationHookOptions<CustomCancelAiMappingTaskMutation, CustomCancelAiMappingTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCancelAiMappingTaskMutation, CustomCancelAiMappingTaskMutationVariables>(CustomCancelAiMappingTaskDocument, options);
      }
export type CustomCancelAiMappingTaskMutationHookResult = ReturnType<typeof useCustomCancelAiMappingTaskMutation>;
export type CustomCancelAiMappingTaskMutationResult = Apollo.MutationResult<CustomCancelAiMappingTaskMutation>;
export type CustomCancelAiMappingTaskMutationOptions = Apollo.BaseMutationOptions<CustomCancelAiMappingTaskMutation, CustomCancelAiMappingTaskMutationVariables>;
export const CustomCancelOpportunityDocument = gql`
    mutation customCancelOpportunity($id: ID!) {
  cancelOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      name
    }
    companyId
    contact {
      email
      firstName
      id
      lastName
    }
    contactId
    createdAt
    dueAt
    id
    name
    notes
    products {
      id
      name
    }
    source
    status
    updatedAt
    user {
      firstName
      id
      lastName
    }
    userId
  }
}
    `;
export type CustomCancelOpportunityMutationFn = Apollo.MutationFunction<CustomCancelOpportunityMutation, CustomCancelOpportunityMutationVariables>;

/**
 * __useCustomCancelOpportunityMutation__
 *
 * To run a mutation, you first call `useCustomCancelOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCancelOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCancelOpportunityMutation, { data, loading, error }] = useCustomCancelOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomCancelOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CustomCancelOpportunityMutation, CustomCancelOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCancelOpportunityMutation, CustomCancelOpportunityMutationVariables>(CustomCancelOpportunityDocument, options);
      }
export type CustomCancelOpportunityMutationHookResult = ReturnType<typeof useCustomCancelOpportunityMutation>;
export type CustomCancelOpportunityMutationResult = Apollo.MutationResult<CustomCancelOpportunityMutation>;
export type CustomCancelOpportunityMutationOptions = Apollo.BaseMutationOptions<CustomCancelOpportunityMutation, CustomCancelOpportunityMutationVariables>;
export const CustomCancelProposalDocument = gql`
    mutation customCancelProposal($duplicate: Boolean!, $id: ID!, $maintainCurrentId: Boolean) {
  cancelProposal(
    duplicate: $duplicate
    id: $id
    maintainCurrentId: $maintainCurrentId
  ) {
    newProposal {
      ...BitumioProposal
    }
    proposal {
      ...BitumioProposal
    }
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomCancelProposalMutationFn = Apollo.MutationFunction<CustomCancelProposalMutation, CustomCancelProposalMutationVariables>;

/**
 * __useCustomCancelProposalMutation__
 *
 * To run a mutation, you first call `useCustomCancelProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCancelProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCancelProposalMutation, { data, loading, error }] = useCustomCancelProposalMutation({
 *   variables: {
 *      duplicate: // value for 'duplicate'
 *      id: // value for 'id'
 *      maintainCurrentId: // value for 'maintainCurrentId'
 *   },
 * });
 */
export function useCustomCancelProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomCancelProposalMutation, CustomCancelProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCancelProposalMutation, CustomCancelProposalMutationVariables>(CustomCancelProposalDocument, options);
      }
export type CustomCancelProposalMutationHookResult = ReturnType<typeof useCustomCancelProposalMutation>;
export type CustomCancelProposalMutationResult = Apollo.MutationResult<CustomCancelProposalMutation>;
export type CustomCancelProposalMutationOptions = Apollo.BaseMutationOptions<CustomCancelProposalMutation, CustomCancelProposalMutationVariables>;
export const CustomCloseProposalDocument = gql`
    mutation customCloseProposal($id: ID!) {
  closeProposal(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomCloseProposalMutationFn = Apollo.MutationFunction<CustomCloseProposalMutation, CustomCloseProposalMutationVariables>;

/**
 * __useCustomCloseProposalMutation__
 *
 * To run a mutation, you first call `useCustomCloseProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCloseProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCloseProposalMutation, { data, loading, error }] = useCustomCloseProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomCloseProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomCloseProposalMutation, CustomCloseProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCloseProposalMutation, CustomCloseProposalMutationVariables>(CustomCloseProposalDocument, options);
      }
export type CustomCloseProposalMutationHookResult = ReturnType<typeof useCustomCloseProposalMutation>;
export type CustomCloseProposalMutationResult = Apollo.MutationResult<CustomCloseProposalMutation>;
export type CustomCloseProposalMutationOptions = Apollo.BaseMutationOptions<CustomCloseProposalMutation, CustomCloseProposalMutationVariables>;
export const CustomCopyProposalProductToStageDocument = gql`
    mutation customCopyProposalProductToStage($proposalProductId: ID!, $targetStageId: ID!) {
  copyProposalProductToStage(
    proposalProductId: $proposalProductId
    targetStageId: $targetStageId
  ) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomCopyProposalProductToStageMutationFn = Apollo.MutationFunction<CustomCopyProposalProductToStageMutation, CustomCopyProposalProductToStageMutationVariables>;

/**
 * __useCustomCopyProposalProductToStageMutation__
 *
 * To run a mutation, you first call `useCustomCopyProposalProductToStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCopyProposalProductToStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCopyProposalProductToStageMutation, { data, loading, error }] = useCustomCopyProposalProductToStageMutation({
 *   variables: {
 *      proposalProductId: // value for 'proposalProductId'
 *      targetStageId: // value for 'targetStageId'
 *   },
 * });
 */
export function useCustomCopyProposalProductToStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomCopyProposalProductToStageMutation, CustomCopyProposalProductToStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCopyProposalProductToStageMutation, CustomCopyProposalProductToStageMutationVariables>(CustomCopyProposalProductToStageDocument, options);
      }
export type CustomCopyProposalProductToStageMutationHookResult = ReturnType<typeof useCustomCopyProposalProductToStageMutation>;
export type CustomCopyProposalProductToStageMutationResult = Apollo.MutationResult<CustomCopyProposalProductToStageMutation>;
export type CustomCopyProposalProductToStageMutationOptions = Apollo.BaseMutationOptions<CustomCopyProposalProductToStageMutation, CustomCopyProposalProductToStageMutationVariables>;
export const CustomCreateAiMappingDetectionDocument = gql`
    mutation customCreateAiMappingDetection($input: CreateAiMappingDetectionInput!) {
  createAiMappingDetection(input: $input) {
    ...AiMappingResultsBundleFragment
  }
}
    ${AiMappingResultsBundleFragmentFragmentDoc}`;
export type CustomCreateAiMappingDetectionMutationFn = Apollo.MutationFunction<CustomCreateAiMappingDetectionMutation, CustomCreateAiMappingDetectionMutationVariables>;

/**
 * __useCustomCreateAiMappingDetectionMutation__
 *
 * To run a mutation, you first call `useCustomCreateAiMappingDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateAiMappingDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateAiMappingDetectionMutation, { data, loading, error }] = useCustomCreateAiMappingDetectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateAiMappingDetectionMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateAiMappingDetectionMutation, CustomCreateAiMappingDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateAiMappingDetectionMutation, CustomCreateAiMappingDetectionMutationVariables>(CustomCreateAiMappingDetectionDocument, options);
      }
export type CustomCreateAiMappingDetectionMutationHookResult = ReturnType<typeof useCustomCreateAiMappingDetectionMutation>;
export type CustomCreateAiMappingDetectionMutationResult = Apollo.MutationResult<CustomCreateAiMappingDetectionMutation>;
export type CustomCreateAiMappingDetectionMutationOptions = Apollo.BaseMutationOptions<CustomCreateAiMappingDetectionMutation, CustomCreateAiMappingDetectionMutationVariables>;
export const CustomCreateAiMappingRunDocument = gql`
    mutation customCreateAiMappingRun($projectMapId: ID!) {
  createAiMappingRun(projectMapId: $projectMapId) {
    id
    name
    description
    createdAt
    updatedAt
    projectMap {
      id
    }
    areas {
      ...AiMappingRunAreaFragment
    }
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;
export type CustomCreateAiMappingRunMutationFn = Apollo.MutationFunction<CustomCreateAiMappingRunMutation, CustomCreateAiMappingRunMutationVariables>;

/**
 * __useCustomCreateAiMappingRunMutation__
 *
 * To run a mutation, you first call `useCustomCreateAiMappingRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateAiMappingRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateAiMappingRunMutation, { data, loading, error }] = useCustomCreateAiMappingRunMutation({
 *   variables: {
 *      projectMapId: // value for 'projectMapId'
 *   },
 * });
 */
export function useCustomCreateAiMappingRunMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateAiMappingRunMutation, CustomCreateAiMappingRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateAiMappingRunMutation, CustomCreateAiMappingRunMutationVariables>(CustomCreateAiMappingRunDocument, options);
      }
export type CustomCreateAiMappingRunMutationHookResult = ReturnType<typeof useCustomCreateAiMappingRunMutation>;
export type CustomCreateAiMappingRunMutationResult = Apollo.MutationResult<CustomCreateAiMappingRunMutation>;
export type CustomCreateAiMappingRunMutationOptions = Apollo.BaseMutationOptions<CustomCreateAiMappingRunMutation, CustomCreateAiMappingRunMutationVariables>;
export const CustomCreateAiMappingRunAreaDocument = gql`
    mutation customCreateAiMappingRunArea($input: CreateAiMappingRunAreaInput!) {
  createAiMappingRunArea(input: $input) {
    ...AiMappingRunAreaFragment
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;
export type CustomCreateAiMappingRunAreaMutationFn = Apollo.MutationFunction<CustomCreateAiMappingRunAreaMutation, CustomCreateAiMappingRunAreaMutationVariables>;

/**
 * __useCustomCreateAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useCustomCreateAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateAiMappingRunAreaMutation, { data, loading, error }] = useCustomCreateAiMappingRunAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateAiMappingRunAreaMutation, CustomCreateAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateAiMappingRunAreaMutation, CustomCreateAiMappingRunAreaMutationVariables>(CustomCreateAiMappingRunAreaDocument, options);
      }
export type CustomCreateAiMappingRunAreaMutationHookResult = ReturnType<typeof useCustomCreateAiMappingRunAreaMutation>;
export type CustomCreateAiMappingRunAreaMutationResult = Apollo.MutationResult<CustomCreateAiMappingRunAreaMutation>;
export type CustomCreateAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<CustomCreateAiMappingRunAreaMutation, CustomCreateAiMappingRunAreaMutationVariables>;
export const CustomCreateAiMappingSegmentationDocument = gql`
    mutation customCreateAiMappingSegmentation($input: CreateAiMappingSegmentationInput!) {
  createAiMappingSegmentation(input: $input) {
    ...AiMappingResultsBundleFragment
  }
}
    ${AiMappingResultsBundleFragmentFragmentDoc}`;
export type CustomCreateAiMappingSegmentationMutationFn = Apollo.MutationFunction<CustomCreateAiMappingSegmentationMutation, CustomCreateAiMappingSegmentationMutationVariables>;

/**
 * __useCustomCreateAiMappingSegmentationMutation__
 *
 * To run a mutation, you first call `useCustomCreateAiMappingSegmentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateAiMappingSegmentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateAiMappingSegmentationMutation, { data, loading, error }] = useCustomCreateAiMappingSegmentationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateAiMappingSegmentationMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateAiMappingSegmentationMutation, CustomCreateAiMappingSegmentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateAiMappingSegmentationMutation, CustomCreateAiMappingSegmentationMutationVariables>(CustomCreateAiMappingSegmentationDocument, options);
      }
export type CustomCreateAiMappingSegmentationMutationHookResult = ReturnType<typeof useCustomCreateAiMappingSegmentationMutation>;
export type CustomCreateAiMappingSegmentationMutationResult = Apollo.MutationResult<CustomCreateAiMappingSegmentationMutation>;
export type CustomCreateAiMappingSegmentationMutationOptions = Apollo.BaseMutationOptions<CustomCreateAiMappingSegmentationMutation, CustomCreateAiMappingSegmentationMutationVariables>;
export const CustomCreateCustomEventDocument = gql`
    mutation customCreateCustomEvent($input: CreateCustomEventInput) {
  createCustomEvent(input: $input) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomCreateCustomEventMutationFn = Apollo.MutationFunction<CustomCreateCustomEventMutation, CustomCreateCustomEventMutationVariables>;

/**
 * __useCustomCreateCustomEventMutation__
 *
 * To run a mutation, you first call `useCustomCreateCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateCustomEventMutation, { data, loading, error }] = useCustomCreateCustomEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateCustomEventMutation, CustomCreateCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateCustomEventMutation, CustomCreateCustomEventMutationVariables>(CustomCreateCustomEventDocument, options);
      }
export type CustomCreateCustomEventMutationHookResult = ReturnType<typeof useCustomCreateCustomEventMutation>;
export type CustomCreateCustomEventMutationResult = Apollo.MutationResult<CustomCreateCustomEventMutation>;
export type CustomCreateCustomEventMutationOptions = Apollo.BaseMutationOptions<CustomCreateCustomEventMutation, CustomCreateCustomEventMutationVariables>;
export const CustomCreateDailyFormVehiclePartDocument = gql`
    mutation customCreateDailyFormVehiclePart($input: CreateDailyFormVehiclePartInput!) {
  createDailyFormVehiclePart(input: $input) {
    id
  }
}
    `;
export type CustomCreateDailyFormVehiclePartMutationFn = Apollo.MutationFunction<CustomCreateDailyFormVehiclePartMutation, CustomCreateDailyFormVehiclePartMutationVariables>;

/**
 * __useCustomCreateDailyFormVehiclePartMutation__
 *
 * To run a mutation, you first call `useCustomCreateDailyFormVehiclePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateDailyFormVehiclePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateDailyFormVehiclePartMutation, { data, loading, error }] = useCustomCreateDailyFormVehiclePartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateDailyFormVehiclePartMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateDailyFormVehiclePartMutation, CustomCreateDailyFormVehiclePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateDailyFormVehiclePartMutation, CustomCreateDailyFormVehiclePartMutationVariables>(CustomCreateDailyFormVehiclePartDocument, options);
      }
export type CustomCreateDailyFormVehiclePartMutationHookResult = ReturnType<typeof useCustomCreateDailyFormVehiclePartMutation>;
export type CustomCreateDailyFormVehiclePartMutationResult = Apollo.MutationResult<CustomCreateDailyFormVehiclePartMutation>;
export type CustomCreateDailyFormVehiclePartMutationOptions = Apollo.BaseMutationOptions<CustomCreateDailyFormVehiclePartMutation, CustomCreateDailyFormVehiclePartMutationVariables>;
export const CustomCreateDailyFormVehicleServicePlanDocument = gql`
    mutation customCreateDailyFormVehicleServicePlan($input: CreateDailyFormVehicleServicePlanInput!) {
  createDailyFormVehicleServicePlan(input: $input) {
    id
  }
}
    `;
export type CustomCreateDailyFormVehicleServicePlanMutationFn = Apollo.MutationFunction<CustomCreateDailyFormVehicleServicePlanMutation, CustomCreateDailyFormVehicleServicePlanMutationVariables>;

/**
 * __useCustomCreateDailyFormVehicleServicePlanMutation__
 *
 * To run a mutation, you first call `useCustomCreateDailyFormVehicleServicePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateDailyFormVehicleServicePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateDailyFormVehicleServicePlanMutation, { data, loading, error }] = useCustomCreateDailyFormVehicleServicePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateDailyFormVehicleServicePlanMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateDailyFormVehicleServicePlanMutation, CustomCreateDailyFormVehicleServicePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateDailyFormVehicleServicePlanMutation, CustomCreateDailyFormVehicleServicePlanMutationVariables>(CustomCreateDailyFormVehicleServicePlanDocument, options);
      }
export type CustomCreateDailyFormVehicleServicePlanMutationHookResult = ReturnType<typeof useCustomCreateDailyFormVehicleServicePlanMutation>;
export type CustomCreateDailyFormVehicleServicePlanMutationResult = Apollo.MutationResult<CustomCreateDailyFormVehicleServicePlanMutation>;
export type CustomCreateDailyFormVehicleServicePlanMutationOptions = Apollo.BaseMutationOptions<CustomCreateDailyFormVehicleServicePlanMutation, CustomCreateDailyFormVehicleServicePlanMutationVariables>;
export const CustomCreateNotificationTriggerDocument = gql`
    mutation CustomCreateNotificationTrigger($input: CreateNotificationTriggerInput!) {
  createNotificationTrigger(input: $input) {
    ...NotificationTriggerFragment
  }
}
    ${NotificationTriggerFragmentFragmentDoc}`;
export type CustomCreateNotificationTriggerMutationFn = Apollo.MutationFunction<CustomCreateNotificationTriggerMutation, CustomCreateNotificationTriggerMutationVariables>;

/**
 * __useCustomCreateNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useCustomCreateNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateNotificationTriggerMutation, { data, loading, error }] = useCustomCreateNotificationTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateNotificationTriggerMutation, CustomCreateNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateNotificationTriggerMutation, CustomCreateNotificationTriggerMutationVariables>(CustomCreateNotificationTriggerDocument, options);
      }
export type CustomCreateNotificationTriggerMutationHookResult = ReturnType<typeof useCustomCreateNotificationTriggerMutation>;
export type CustomCreateNotificationTriggerMutationResult = Apollo.MutationResult<CustomCreateNotificationTriggerMutation>;
export type CustomCreateNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<CustomCreateNotificationTriggerMutation, CustomCreateNotificationTriggerMutationVariables>;
export const CustomCreateProductDocument = gql`
    mutation customCreateProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    ...UpdatedProduct
  }
}
    ${UpdatedProductFragmentDoc}`;
export type CustomCreateProductMutationFn = Apollo.MutationFunction<CustomCreateProductMutation, CustomCreateProductMutationVariables>;

/**
 * __useCustomCreateProductMutation__
 *
 * To run a mutation, you first call `useCustomCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateProductMutation, { data, loading, error }] = useCustomCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateProductMutation, CustomCreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateProductMutation, CustomCreateProductMutationVariables>(CustomCreateProductDocument, options);
      }
export type CustomCreateProductMutationHookResult = ReturnType<typeof useCustomCreateProductMutation>;
export type CustomCreateProductMutationResult = Apollo.MutationResult<CustomCreateProductMutation>;
export type CustomCreateProductMutationOptions = Apollo.BaseMutationOptions<CustomCreateProductMutation, CustomCreateProductMutationVariables>;
export const CustomCreateProposalDocument = gql`
    mutation customCreateProposal($companyId: ID!, $contactId: ID!, $source: ProposalSource, $projectedCloseDate: Date, $closeConfidence: Int) {
  createProposal(
    companyId: $companyId
    contactId: $contactId
    source: $source
    projectedCloseDate: $projectedCloseDate
    closeConfidence: $closeConfidence
  ) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomCreateProposalMutationFn = Apollo.MutationFunction<CustomCreateProposalMutation, CustomCreateProposalMutationVariables>;

/**
 * __useCustomCreateProposalMutation__
 *
 * To run a mutation, you first call `useCustomCreateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateProposalMutation, { data, loading, error }] = useCustomCreateProposalMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      source: // value for 'source'
 *      projectedCloseDate: // value for 'projectedCloseDate'
 *      closeConfidence: // value for 'closeConfidence'
 *   },
 * });
 */
export function useCustomCreateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateProposalMutation, CustomCreateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateProposalMutation, CustomCreateProposalMutationVariables>(CustomCreateProposalDocument, options);
      }
export type CustomCreateProposalMutationHookResult = ReturnType<typeof useCustomCreateProposalMutation>;
export type CustomCreateProposalMutationResult = Apollo.MutationResult<CustomCreateProposalMutation>;
export type CustomCreateProposalMutationOptions = Apollo.BaseMutationOptions<CustomCreateProposalMutation, CustomCreateProposalMutationVariables>;
export const CustomCreateProposalFromOpportunityDocument = gql`
    mutation customCreateProposalFromOpportunity($id: ID!) {
  createProposalFromOpportunity(id: $id) {
    id
  }
}
    `;
export type CustomCreateProposalFromOpportunityMutationFn = Apollo.MutationFunction<CustomCreateProposalFromOpportunityMutation, CustomCreateProposalFromOpportunityMutationVariables>;

/**
 * __useCustomCreateProposalFromOpportunityMutation__
 *
 * To run a mutation, you first call `useCustomCreateProposalFromOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateProposalFromOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateProposalFromOpportunityMutation, { data, loading, error }] = useCustomCreateProposalFromOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomCreateProposalFromOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateProposalFromOpportunityMutation, CustomCreateProposalFromOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateProposalFromOpportunityMutation, CustomCreateProposalFromOpportunityMutationVariables>(CustomCreateProposalFromOpportunityDocument, options);
      }
export type CustomCreateProposalFromOpportunityMutationHookResult = ReturnType<typeof useCustomCreateProposalFromOpportunityMutation>;
export type CustomCreateProposalFromOpportunityMutationResult = Apollo.MutationResult<CustomCreateProposalFromOpportunityMutation>;
export type CustomCreateProposalFromOpportunityMutationOptions = Apollo.BaseMutationOptions<CustomCreateProposalFromOpportunityMutation, CustomCreateProposalFromOpportunityMutationVariables>;
export const CustomDeleteAiMappingDetectionDocument = gql`
    mutation customDeleteAiMappingDetection($runAreaId: ID!, $detectionId: ID!) {
  deleteAiMappingDetection(runAreaId: $runAreaId, detectionId: $detectionId) {
    ...AiMappingResultsBundleFragment
  }
}
    ${AiMappingResultsBundleFragmentFragmentDoc}`;
export type CustomDeleteAiMappingDetectionMutationFn = Apollo.MutationFunction<CustomDeleteAiMappingDetectionMutation, CustomDeleteAiMappingDetectionMutationVariables>;

/**
 * __useCustomDeleteAiMappingDetectionMutation__
 *
 * To run a mutation, you first call `useCustomDeleteAiMappingDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteAiMappingDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteAiMappingDetectionMutation, { data, loading, error }] = useCustomDeleteAiMappingDetectionMutation({
 *   variables: {
 *      runAreaId: // value for 'runAreaId'
 *      detectionId: // value for 'detectionId'
 *   },
 * });
 */
export function useCustomDeleteAiMappingDetectionMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteAiMappingDetectionMutation, CustomDeleteAiMappingDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteAiMappingDetectionMutation, CustomDeleteAiMappingDetectionMutationVariables>(CustomDeleteAiMappingDetectionDocument, options);
      }
export type CustomDeleteAiMappingDetectionMutationHookResult = ReturnType<typeof useCustomDeleteAiMappingDetectionMutation>;
export type CustomDeleteAiMappingDetectionMutationResult = Apollo.MutationResult<CustomDeleteAiMappingDetectionMutation>;
export type CustomDeleteAiMappingDetectionMutationOptions = Apollo.BaseMutationOptions<CustomDeleteAiMappingDetectionMutation, CustomDeleteAiMappingDetectionMutationVariables>;
export const CustomDeleteAiMappingSegmentationDocument = gql`
    mutation customDeleteAiMappingSegmentation($runAreaId: ID!, $segmentationId: ID!) {
  deleteAiMappingSegmentation(
    runAreaId: $runAreaId
    segmentationId: $segmentationId
  ) {
    ...AiMappingResultsBundleFragment
  }
}
    ${AiMappingResultsBundleFragmentFragmentDoc}`;
export type CustomDeleteAiMappingSegmentationMutationFn = Apollo.MutationFunction<CustomDeleteAiMappingSegmentationMutation, CustomDeleteAiMappingSegmentationMutationVariables>;

/**
 * __useCustomDeleteAiMappingSegmentationMutation__
 *
 * To run a mutation, you first call `useCustomDeleteAiMappingSegmentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteAiMappingSegmentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteAiMappingSegmentationMutation, { data, loading, error }] = useCustomDeleteAiMappingSegmentationMutation({
 *   variables: {
 *      runAreaId: // value for 'runAreaId'
 *      segmentationId: // value for 'segmentationId'
 *   },
 * });
 */
export function useCustomDeleteAiMappingSegmentationMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteAiMappingSegmentationMutation, CustomDeleteAiMappingSegmentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteAiMappingSegmentationMutation, CustomDeleteAiMappingSegmentationMutationVariables>(CustomDeleteAiMappingSegmentationDocument, options);
      }
export type CustomDeleteAiMappingSegmentationMutationHookResult = ReturnType<typeof useCustomDeleteAiMappingSegmentationMutation>;
export type CustomDeleteAiMappingSegmentationMutationResult = Apollo.MutationResult<CustomDeleteAiMappingSegmentationMutation>;
export type CustomDeleteAiMappingSegmentationMutationOptions = Apollo.BaseMutationOptions<CustomDeleteAiMappingSegmentationMutation, CustomDeleteAiMappingSegmentationMutationVariables>;
export const CustomDeleteCustomEventDocument = gql`
    mutation customDeleteCustomEvent($id: ID!) {
  deleteCustomEvent(id: $id) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomDeleteCustomEventMutationFn = Apollo.MutationFunction<CustomDeleteCustomEventMutation, CustomDeleteCustomEventMutationVariables>;

/**
 * __useCustomDeleteCustomEventMutation__
 *
 * To run a mutation, you first call `useCustomDeleteCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteCustomEventMutation, { data, loading, error }] = useCustomDeleteCustomEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteCustomEventMutation, CustomDeleteCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteCustomEventMutation, CustomDeleteCustomEventMutationVariables>(CustomDeleteCustomEventDocument, options);
      }
export type CustomDeleteCustomEventMutationHookResult = ReturnType<typeof useCustomDeleteCustomEventMutation>;
export type CustomDeleteCustomEventMutationResult = Apollo.MutationResult<CustomDeleteCustomEventMutation>;
export type CustomDeleteCustomEventMutationOptions = Apollo.BaseMutationOptions<CustomDeleteCustomEventMutation, CustomDeleteCustomEventMutationVariables>;
export const CustomDeleteDailyFormVehiclePartDocument = gql`
    mutation customDeleteDailyFormVehiclePart($id: ID!) {
  deleteDailyFormVehiclePart(id: $id) {
    id
  }
}
    `;
export type CustomDeleteDailyFormVehiclePartMutationFn = Apollo.MutationFunction<CustomDeleteDailyFormVehiclePartMutation, CustomDeleteDailyFormVehiclePartMutationVariables>;

/**
 * __useCustomDeleteDailyFormVehiclePartMutation__
 *
 * To run a mutation, you first call `useCustomDeleteDailyFormVehiclePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteDailyFormVehiclePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteDailyFormVehiclePartMutation, { data, loading, error }] = useCustomDeleteDailyFormVehiclePartMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteDailyFormVehiclePartMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteDailyFormVehiclePartMutation, CustomDeleteDailyFormVehiclePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteDailyFormVehiclePartMutation, CustomDeleteDailyFormVehiclePartMutationVariables>(CustomDeleteDailyFormVehiclePartDocument, options);
      }
export type CustomDeleteDailyFormVehiclePartMutationHookResult = ReturnType<typeof useCustomDeleteDailyFormVehiclePartMutation>;
export type CustomDeleteDailyFormVehiclePartMutationResult = Apollo.MutationResult<CustomDeleteDailyFormVehiclePartMutation>;
export type CustomDeleteDailyFormVehiclePartMutationOptions = Apollo.BaseMutationOptions<CustomDeleteDailyFormVehiclePartMutation, CustomDeleteDailyFormVehiclePartMutationVariables>;
export const CustomDeleteDailyFormVehicleServicePlanDocument = gql`
    mutation customDeleteDailyFormVehicleServicePlan($id: ID!) {
  deleteDailyFormVehicleServicePlan(id: $id) {
    id
  }
}
    `;
export type CustomDeleteDailyFormVehicleServicePlanMutationFn = Apollo.MutationFunction<CustomDeleteDailyFormVehicleServicePlanMutation, CustomDeleteDailyFormVehicleServicePlanMutationVariables>;

/**
 * __useCustomDeleteDailyFormVehicleServicePlanMutation__
 *
 * To run a mutation, you first call `useCustomDeleteDailyFormVehicleServicePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteDailyFormVehicleServicePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteDailyFormVehicleServicePlanMutation, { data, loading, error }] = useCustomDeleteDailyFormVehicleServicePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteDailyFormVehicleServicePlanMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteDailyFormVehicleServicePlanMutation, CustomDeleteDailyFormVehicleServicePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteDailyFormVehicleServicePlanMutation, CustomDeleteDailyFormVehicleServicePlanMutationVariables>(CustomDeleteDailyFormVehicleServicePlanDocument, options);
      }
export type CustomDeleteDailyFormVehicleServicePlanMutationHookResult = ReturnType<typeof useCustomDeleteDailyFormVehicleServicePlanMutation>;
export type CustomDeleteDailyFormVehicleServicePlanMutationResult = Apollo.MutationResult<CustomDeleteDailyFormVehicleServicePlanMutation>;
export type CustomDeleteDailyFormVehicleServicePlanMutationOptions = Apollo.BaseMutationOptions<CustomDeleteDailyFormVehicleServicePlanMutation, CustomDeleteDailyFormVehicleServicePlanMutationVariables>;
export const CustomDeleteProposalDocument = gql`
    mutation customDeleteProposal($id: ID!) {
  deleteProposal(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomDeleteProposalMutationFn = Apollo.MutationFunction<CustomDeleteProposalMutation, CustomDeleteProposalMutationVariables>;

/**
 * __useCustomDeleteProposalMutation__
 *
 * To run a mutation, you first call `useCustomDeleteProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteProposalMutation, { data, loading, error }] = useCustomDeleteProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteProposalMutation, CustomDeleteProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteProposalMutation, CustomDeleteProposalMutationVariables>(CustomDeleteProposalDocument, options);
      }
export type CustomDeleteProposalMutationHookResult = ReturnType<typeof useCustomDeleteProposalMutation>;
export type CustomDeleteProposalMutationResult = Apollo.MutationResult<CustomDeleteProposalMutation>;
export type CustomDeleteProposalMutationOptions = Apollo.BaseMutationOptions<CustomDeleteProposalMutation, CustomDeleteProposalMutationVariables>;
export const CustomDeleteProposalProductDocument = gql`
    mutation customDeleteProposalProduct($id: ID!) {
  deleteProposalProduct(id: $id) {
    ...BitumioProposalStage
  }
}
    ${BitumioProposalStageFragmentDoc}`;
export type CustomDeleteProposalProductMutationFn = Apollo.MutationFunction<CustomDeleteProposalProductMutation, CustomDeleteProposalProductMutationVariables>;

/**
 * __useCustomDeleteProposalProductMutation__
 *
 * To run a mutation, you first call `useCustomDeleteProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteProposalProductMutation, { data, loading, error }] = useCustomDeleteProposalProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteProposalProductMutation, CustomDeleteProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteProposalProductMutation, CustomDeleteProposalProductMutationVariables>(CustomDeleteProposalProductDocument, options);
      }
export type CustomDeleteProposalProductMutationHookResult = ReturnType<typeof useCustomDeleteProposalProductMutation>;
export type CustomDeleteProposalProductMutationResult = Apollo.MutationResult<CustomDeleteProposalProductMutation>;
export type CustomDeleteProposalProductMutationOptions = Apollo.BaseMutationOptions<CustomDeleteProposalProductMutation, CustomDeleteProposalProductMutationVariables>;
export const CustomDeleteProposalStageDocument = gql`
    mutation customDeleteProposalStage($id: ID!) {
  deleteProposalStage(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomDeleteProposalStageMutationFn = Apollo.MutationFunction<CustomDeleteProposalStageMutation, CustomDeleteProposalStageMutationVariables>;

/**
 * __useCustomDeleteProposalStageMutation__
 *
 * To run a mutation, you first call `useCustomDeleteProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteProposalStageMutation, { data, loading, error }] = useCustomDeleteProposalStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteProposalStageMutation, CustomDeleteProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteProposalStageMutation, CustomDeleteProposalStageMutationVariables>(CustomDeleteProposalStageDocument, options);
      }
export type CustomDeleteProposalStageMutationHookResult = ReturnType<typeof useCustomDeleteProposalStageMutation>;
export type CustomDeleteProposalStageMutationResult = Apollo.MutationResult<CustomDeleteProposalStageMutation>;
export type CustomDeleteProposalStageMutationOptions = Apollo.BaseMutationOptions<CustomDeleteProposalStageMutation, CustomDeleteProposalStageMutationVariables>;
export const CustomDetectAiMappingRunAreaDocument = gql`
    mutation customDetectAiMappingRunArea($id: ID!) {
  detectAiMappingRunArea(id: $id) {
    taskId
    area {
      ...AiMappingRunAreaFragment
    }
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;
export type CustomDetectAiMappingRunAreaMutationFn = Apollo.MutationFunction<CustomDetectAiMappingRunAreaMutation, CustomDetectAiMappingRunAreaMutationVariables>;

/**
 * __useCustomDetectAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useCustomDetectAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDetectAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDetectAiMappingRunAreaMutation, { data, loading, error }] = useCustomDetectAiMappingRunAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDetectAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<CustomDetectAiMappingRunAreaMutation, CustomDetectAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDetectAiMappingRunAreaMutation, CustomDetectAiMappingRunAreaMutationVariables>(CustomDetectAiMappingRunAreaDocument, options);
      }
export type CustomDetectAiMappingRunAreaMutationHookResult = ReturnType<typeof useCustomDetectAiMappingRunAreaMutation>;
export type CustomDetectAiMappingRunAreaMutationResult = Apollo.MutationResult<CustomDetectAiMappingRunAreaMutation>;
export type CustomDetectAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<CustomDetectAiMappingRunAreaMutation, CustomDetectAiMappingRunAreaMutationVariables>;
export const CustomDuplicateProductDocument = gql`
    mutation customDuplicateProduct($id: ID!) {
  duplicateProduct(id: $id) {
    id
  }
}
    `;
export type CustomDuplicateProductMutationFn = Apollo.MutationFunction<CustomDuplicateProductMutation, CustomDuplicateProductMutationVariables>;

/**
 * __useCustomDuplicateProductMutation__
 *
 * To run a mutation, you first call `useCustomDuplicateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDuplicateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDuplicateProductMutation, { data, loading, error }] = useCustomDuplicateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDuplicateProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomDuplicateProductMutation, CustomDuplicateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDuplicateProductMutation, CustomDuplicateProductMutationVariables>(CustomDuplicateProductDocument, options);
      }
export type CustomDuplicateProductMutationHookResult = ReturnType<typeof useCustomDuplicateProductMutation>;
export type CustomDuplicateProductMutationResult = Apollo.MutationResult<CustomDuplicateProductMutation>;
export type CustomDuplicateProductMutationOptions = Apollo.BaseMutationOptions<CustomDuplicateProductMutation, CustomDuplicateProductMutationVariables>;
export const CustomDuplicateProposalDocument = gql`
    mutation customDuplicateProposal($id: ID!, $isChangeOrder: Boolean, $startNewProposal: Boolean, $createNewVersion: Boolean, $changeOrderJobId: ID, $changeOrderProposalType: ChangeOrderProposalType, $changeOrderScheduledJobsAction: ChangeOrderScheduledJobsAction) {
  duplicateProposal(
    id: $id
    isChangeOrder: $isChangeOrder
    startNewProposal: $startNewProposal
    createNewVersion: $createNewVersion
    changeOrderJobId: $changeOrderJobId
    changeOrderProposalType: $changeOrderProposalType
    changeOrderScheduledJobsAction: $changeOrderScheduledJobsAction
  ) {
    newProposal {
      ...BitumioProposal
    }
    proposal {
      ...BitumioProposal
    }
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomDuplicateProposalMutationFn = Apollo.MutationFunction<CustomDuplicateProposalMutation, CustomDuplicateProposalMutationVariables>;

/**
 * __useCustomDuplicateProposalMutation__
 *
 * To run a mutation, you first call `useCustomDuplicateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDuplicateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDuplicateProposalMutation, { data, loading, error }] = useCustomDuplicateProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isChangeOrder: // value for 'isChangeOrder'
 *      startNewProposal: // value for 'startNewProposal'
 *      createNewVersion: // value for 'createNewVersion'
 *      changeOrderJobId: // value for 'changeOrderJobId'
 *      changeOrderProposalType: // value for 'changeOrderProposalType'
 *      changeOrderScheduledJobsAction: // value for 'changeOrderScheduledJobsAction'
 *   },
 * });
 */
export function useCustomDuplicateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomDuplicateProposalMutation, CustomDuplicateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDuplicateProposalMutation, CustomDuplicateProposalMutationVariables>(CustomDuplicateProposalDocument, options);
      }
export type CustomDuplicateProposalMutationHookResult = ReturnType<typeof useCustomDuplicateProposalMutation>;
export type CustomDuplicateProposalMutationResult = Apollo.MutationResult<CustomDuplicateProposalMutation>;
export type CustomDuplicateProposalMutationOptions = Apollo.BaseMutationOptions<CustomDuplicateProposalMutation, CustomDuplicateProposalMutationVariables>;
export const CustomDuplicateProposalStageDocument = gql`
    mutation customDuplicateProposalStage($id: ID!) {
  duplicateProposalStage(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomDuplicateProposalStageMutationFn = Apollo.MutationFunction<CustomDuplicateProposalStageMutation, CustomDuplicateProposalStageMutationVariables>;

/**
 * __useCustomDuplicateProposalStageMutation__
 *
 * To run a mutation, you first call `useCustomDuplicateProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDuplicateProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDuplicateProposalStageMutation, { data, loading, error }] = useCustomDuplicateProposalStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDuplicateProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomDuplicateProposalStageMutation, CustomDuplicateProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDuplicateProposalStageMutation, CustomDuplicateProposalStageMutationVariables>(CustomDuplicateProposalStageDocument, options);
      }
export type CustomDuplicateProposalStageMutationHookResult = ReturnType<typeof useCustomDuplicateProposalStageMutation>;
export type CustomDuplicateProposalStageMutationResult = Apollo.MutationResult<CustomDuplicateProposalStageMutation>;
export type CustomDuplicateProposalStageMutationOptions = Apollo.BaseMutationOptions<CustomDuplicateProposalStageMutation, CustomDuplicateProposalStageMutationVariables>;
export const CustomExportAiMappingRunAreaPdfDocument = gql`
    mutation customExportAiMappingRunAreaPdf($id: ID!) {
  exportAiMappingRunAreaPdf(id: $id) {
    taskId
    area {
      ...AiMappingRunAreaFragment
    }
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;
export type CustomExportAiMappingRunAreaPdfMutationFn = Apollo.MutationFunction<CustomExportAiMappingRunAreaPdfMutation, CustomExportAiMappingRunAreaPdfMutationVariables>;

/**
 * __useCustomExportAiMappingRunAreaPdfMutation__
 *
 * To run a mutation, you first call `useCustomExportAiMappingRunAreaPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomExportAiMappingRunAreaPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customExportAiMappingRunAreaPdfMutation, { data, loading, error }] = useCustomExportAiMappingRunAreaPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomExportAiMappingRunAreaPdfMutation(baseOptions?: Apollo.MutationHookOptions<CustomExportAiMappingRunAreaPdfMutation, CustomExportAiMappingRunAreaPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomExportAiMappingRunAreaPdfMutation, CustomExportAiMappingRunAreaPdfMutationVariables>(CustomExportAiMappingRunAreaPdfDocument, options);
      }
export type CustomExportAiMappingRunAreaPdfMutationHookResult = ReturnType<typeof useCustomExportAiMappingRunAreaPdfMutation>;
export type CustomExportAiMappingRunAreaPdfMutationResult = Apollo.MutationResult<CustomExportAiMappingRunAreaPdfMutation>;
export type CustomExportAiMappingRunAreaPdfMutationOptions = Apollo.BaseMutationOptions<CustomExportAiMappingRunAreaPdfMutation, CustomExportAiMappingRunAreaPdfMutationVariables>;
export const CustomRedoAiMappingRunAreaDocument = gql`
    mutation customRedoAiMappingRunArea($id: ID!) {
  redoAiMappingRunArea(id: $id) {
    ...AiMappingResultsBundleFragment
  }
}
    ${AiMappingResultsBundleFragmentFragmentDoc}`;
export type CustomRedoAiMappingRunAreaMutationFn = Apollo.MutationFunction<CustomRedoAiMappingRunAreaMutation, CustomRedoAiMappingRunAreaMutationVariables>;

/**
 * __useCustomRedoAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useCustomRedoAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomRedoAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customRedoAiMappingRunAreaMutation, { data, loading, error }] = useCustomRedoAiMappingRunAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomRedoAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<CustomRedoAiMappingRunAreaMutation, CustomRedoAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomRedoAiMappingRunAreaMutation, CustomRedoAiMappingRunAreaMutationVariables>(CustomRedoAiMappingRunAreaDocument, options);
      }
export type CustomRedoAiMappingRunAreaMutationHookResult = ReturnType<typeof useCustomRedoAiMappingRunAreaMutation>;
export type CustomRedoAiMappingRunAreaMutationResult = Apollo.MutationResult<CustomRedoAiMappingRunAreaMutation>;
export type CustomRedoAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<CustomRedoAiMappingRunAreaMutation, CustomRedoAiMappingRunAreaMutationVariables>;
export const CustomRetryProposalPackageSendRecipientsDocument = gql`
    mutation customRetryProposalPackageSendRecipients($runId: ID!) {
  retryProposalPackageSendRecipients(runId: $runId) {
    id
    status
    totalRecipients
    processedRecipients
    succeededRecipients
    failedRecipients
  }
}
    `;
export type CustomRetryProposalPackageSendRecipientsMutationFn = Apollo.MutationFunction<CustomRetryProposalPackageSendRecipientsMutation, CustomRetryProposalPackageSendRecipientsMutationVariables>;

/**
 * __useCustomRetryProposalPackageSendRecipientsMutation__
 *
 * To run a mutation, you first call `useCustomRetryProposalPackageSendRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomRetryProposalPackageSendRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customRetryProposalPackageSendRecipientsMutation, { data, loading, error }] = useCustomRetryProposalPackageSendRecipientsMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useCustomRetryProposalPackageSendRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<CustomRetryProposalPackageSendRecipientsMutation, CustomRetryProposalPackageSendRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomRetryProposalPackageSendRecipientsMutation, CustomRetryProposalPackageSendRecipientsMutationVariables>(CustomRetryProposalPackageSendRecipientsDocument, options);
      }
export type CustomRetryProposalPackageSendRecipientsMutationHookResult = ReturnType<typeof useCustomRetryProposalPackageSendRecipientsMutation>;
export type CustomRetryProposalPackageSendRecipientsMutationResult = Apollo.MutationResult<CustomRetryProposalPackageSendRecipientsMutation>;
export type CustomRetryProposalPackageSendRecipientsMutationOptions = Apollo.BaseMutationOptions<CustomRetryProposalPackageSendRecipientsMutation, CustomRetryProposalPackageSendRecipientsMutationVariables>;
export const CustomScheduleCustomEventBlockDocument = gql`
    mutation customScheduleCustomEventBlock($input: ScheduleCustomEventBlockInput!) {
  scheduleCustomEventBlock(input: $input) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomScheduleCustomEventBlockMutationFn = Apollo.MutationFunction<CustomScheduleCustomEventBlockMutation, CustomScheduleCustomEventBlockMutationVariables>;

/**
 * __useCustomScheduleCustomEventBlockMutation__
 *
 * To run a mutation, you first call `useCustomScheduleCustomEventBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomScheduleCustomEventBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customScheduleCustomEventBlockMutation, { data, loading, error }] = useCustomScheduleCustomEventBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomScheduleCustomEventBlockMutation(baseOptions?: Apollo.MutationHookOptions<CustomScheduleCustomEventBlockMutation, CustomScheduleCustomEventBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomScheduleCustomEventBlockMutation, CustomScheduleCustomEventBlockMutationVariables>(CustomScheduleCustomEventBlockDocument, options);
      }
export type CustomScheduleCustomEventBlockMutationHookResult = ReturnType<typeof useCustomScheduleCustomEventBlockMutation>;
export type CustomScheduleCustomEventBlockMutationResult = Apollo.MutationResult<CustomScheduleCustomEventBlockMutation>;
export type CustomScheduleCustomEventBlockMutationOptions = Apollo.BaseMutationOptions<CustomScheduleCustomEventBlockMutation, CustomScheduleCustomEventBlockMutationVariables>;
export const CustomScheduleJobPhaseDocument = gql`
    mutation customScheduleJobPhase($blocks: [AddJobPhaseScheduleBlock]!, $crewId: ID, $jobPhaseId: ID!, $travelTimeEstimate: Float, $userIDs: [ID!], $usersColor: String) {
  scheduleJobPhase(
    blocks: $blocks
    crewId: $crewId
    jobPhaseId: $jobPhaseId
    travelTimeEstimate: $travelTimeEstimate
    userIDs: $userIDs
    usersColor: $usersColor
  ) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    endsAt
    foremanUser {
      id
      organization {
        id
      }
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
    }
    notes
    proposalId
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    startsAt
    status
    userId
  }
}
    `;
export type CustomScheduleJobPhaseMutationFn = Apollo.MutationFunction<CustomScheduleJobPhaseMutation, CustomScheduleJobPhaseMutationVariables>;

/**
 * __useCustomScheduleJobPhaseMutation__
 *
 * To run a mutation, you first call `useCustomScheduleJobPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomScheduleJobPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customScheduleJobPhaseMutation, { data, loading, error }] = useCustomScheduleJobPhaseMutation({
 *   variables: {
 *      blocks: // value for 'blocks'
 *      crewId: // value for 'crewId'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      travelTimeEstimate: // value for 'travelTimeEstimate'
 *      userIDs: // value for 'userIDs'
 *      usersColor: // value for 'usersColor'
 *   },
 * });
 */
export function useCustomScheduleJobPhaseMutation(baseOptions?: Apollo.MutationHookOptions<CustomScheduleJobPhaseMutation, CustomScheduleJobPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomScheduleJobPhaseMutation, CustomScheduleJobPhaseMutationVariables>(CustomScheduleJobPhaseDocument, options);
      }
export type CustomScheduleJobPhaseMutationHookResult = ReturnType<typeof useCustomScheduleJobPhaseMutation>;
export type CustomScheduleJobPhaseMutationResult = Apollo.MutationResult<CustomScheduleJobPhaseMutation>;
export type CustomScheduleJobPhaseMutationOptions = Apollo.BaseMutationOptions<CustomScheduleJobPhaseMutation, CustomScheduleJobPhaseMutationVariables>;
export const CustomScheduleJobPhaseBlockDocument = gql`
    mutation customScheduleJobPhaseBlock($input: ScheduleJobPhaseBlockInput!) {
  scheduleJobPhaseBlock(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    endsAt
    foremanUser {
      id
      organization {
        id
      }
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
    }
    notes
    proposalId
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    startsAt
    status
    userId
  }
}
    `;
export type CustomScheduleJobPhaseBlockMutationFn = Apollo.MutationFunction<CustomScheduleJobPhaseBlockMutation, CustomScheduleJobPhaseBlockMutationVariables>;

/**
 * __useCustomScheduleJobPhaseBlockMutation__
 *
 * To run a mutation, you first call `useCustomScheduleJobPhaseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomScheduleJobPhaseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customScheduleJobPhaseBlockMutation, { data, loading, error }] = useCustomScheduleJobPhaseBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomScheduleJobPhaseBlockMutation(baseOptions?: Apollo.MutationHookOptions<CustomScheduleJobPhaseBlockMutation, CustomScheduleJobPhaseBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomScheduleJobPhaseBlockMutation, CustomScheduleJobPhaseBlockMutationVariables>(CustomScheduleJobPhaseBlockDocument, options);
      }
export type CustomScheduleJobPhaseBlockMutationHookResult = ReturnType<typeof useCustomScheduleJobPhaseBlockMutation>;
export type CustomScheduleJobPhaseBlockMutationResult = Apollo.MutationResult<CustomScheduleJobPhaseBlockMutation>;
export type CustomScheduleJobPhaseBlockMutationOptions = Apollo.BaseMutationOptions<CustomScheduleJobPhaseBlockMutation, CustomScheduleJobPhaseBlockMutationVariables>;
export const CustomSegmentAiMappingRunAreaDocument = gql`
    mutation customSegmentAiMappingRunArea($id: ID!, $minSegAreaSqft: Float, $minSegConf: Float) {
  segmentAiMappingRunArea(
    id: $id
    minSegAreaSqft: $minSegAreaSqft
    minSegConf: $minSegConf
  ) {
    taskId
    area {
      ...AiMappingRunAreaFragment
    }
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;
export type CustomSegmentAiMappingRunAreaMutationFn = Apollo.MutationFunction<CustomSegmentAiMappingRunAreaMutation, CustomSegmentAiMappingRunAreaMutationVariables>;

/**
 * __useCustomSegmentAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useCustomSegmentAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSegmentAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSegmentAiMappingRunAreaMutation, { data, loading, error }] = useCustomSegmentAiMappingRunAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      minSegAreaSqft: // value for 'minSegAreaSqft'
 *      minSegConf: // value for 'minSegConf'
 *   },
 * });
 */
export function useCustomSegmentAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<CustomSegmentAiMappingRunAreaMutation, CustomSegmentAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSegmentAiMappingRunAreaMutation, CustomSegmentAiMappingRunAreaMutationVariables>(CustomSegmentAiMappingRunAreaDocument, options);
      }
export type CustomSegmentAiMappingRunAreaMutationHookResult = ReturnType<typeof useCustomSegmentAiMappingRunAreaMutation>;
export type CustomSegmentAiMappingRunAreaMutationResult = Apollo.MutationResult<CustomSegmentAiMappingRunAreaMutation>;
export type CustomSegmentAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<CustomSegmentAiMappingRunAreaMutation, CustomSegmentAiMappingRunAreaMutationVariables>;
export const CustomSendProposalPackageDocument = gql`
    mutation customSendProposalPackage($proposalId: ID!, $recipients: [ProposalPackageRecipientInput!]!, $layout: ProposalLayout, $removeUnitPriceAndQuantity: Boolean, $removeIndividualLineItemPricing: Boolean, $proposalNotes: String, $acceptanceOverride: String, $attachments: [ID!], $emailSubjectOverride: String, $emailBodyOverride: String, $contentSettings: UpdateProposalContentSettingsHasManyInput) {
  sendProposalPackage(
    proposalId: $proposalId
    recipients: $recipients
    layout: $layout
    removeUnitPriceAndQuantity: $removeUnitPriceAndQuantity
    removeIndividualLineItemPricing: $removeIndividualLineItemPricing
    proposalNotes: $proposalNotes
    acceptanceOverride: $acceptanceOverride
    attachments: $attachments
    emailSubjectOverride: $emailSubjectOverride
    emailBodyOverride: $emailBodyOverride
    contentSettings: $contentSettings
  ) {
    id
    status
    totalRecipients
    processedRecipients
    succeededRecipients
    failedRecipients
  }
}
    `;
export type CustomSendProposalPackageMutationFn = Apollo.MutationFunction<CustomSendProposalPackageMutation, CustomSendProposalPackageMutationVariables>;

/**
 * __useCustomSendProposalPackageMutation__
 *
 * To run a mutation, you first call `useCustomSendProposalPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSendProposalPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSendProposalPackageMutation, { data, loading, error }] = useCustomSendProposalPackageMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      recipients: // value for 'recipients'
 *      layout: // value for 'layout'
 *      removeUnitPriceAndQuantity: // value for 'removeUnitPriceAndQuantity'
 *      removeIndividualLineItemPricing: // value for 'removeIndividualLineItemPricing'
 *      proposalNotes: // value for 'proposalNotes'
 *      acceptanceOverride: // value for 'acceptanceOverride'
 *      attachments: // value for 'attachments'
 *      emailSubjectOverride: // value for 'emailSubjectOverride'
 *      emailBodyOverride: // value for 'emailBodyOverride'
 *      contentSettings: // value for 'contentSettings'
 *   },
 * });
 */
export function useCustomSendProposalPackageMutation(baseOptions?: Apollo.MutationHookOptions<CustomSendProposalPackageMutation, CustomSendProposalPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSendProposalPackageMutation, CustomSendProposalPackageMutationVariables>(CustomSendProposalPackageDocument, options);
      }
export type CustomSendProposalPackageMutationHookResult = ReturnType<typeof useCustomSendProposalPackageMutation>;
export type CustomSendProposalPackageMutationResult = Apollo.MutationResult<CustomSendProposalPackageMutation>;
export type CustomSendProposalPackageMutationOptions = Apollo.BaseMutationOptions<CustomSendProposalPackageMutation, CustomSendProposalPackageMutationVariables>;
export const CustomSendProposalToSpecificRecipientsDocument = gql`
    mutation customSendProposalToSpecificRecipients($emails: [String!]!, $proposalId: ID!, $forceSend: Boolean) {
  sendProposalToSpecificRecipients(
    emails: $emails
    proposalId: $proposalId
    forceSend: $forceSend
  ) {
    contactId
    email
    id
  }
}
    `;
export type CustomSendProposalToSpecificRecipientsMutationFn = Apollo.MutationFunction<CustomSendProposalToSpecificRecipientsMutation, CustomSendProposalToSpecificRecipientsMutationVariables>;

/**
 * __useCustomSendProposalToSpecificRecipientsMutation__
 *
 * To run a mutation, you first call `useCustomSendProposalToSpecificRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSendProposalToSpecificRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSendProposalToSpecificRecipientsMutation, { data, loading, error }] = useCustomSendProposalToSpecificRecipientsMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *      proposalId: // value for 'proposalId'
 *      forceSend: // value for 'forceSend'
 *   },
 * });
 */
export function useCustomSendProposalToSpecificRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<CustomSendProposalToSpecificRecipientsMutation, CustomSendProposalToSpecificRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSendProposalToSpecificRecipientsMutation, CustomSendProposalToSpecificRecipientsMutationVariables>(CustomSendProposalToSpecificRecipientsDocument, options);
      }
export type CustomSendProposalToSpecificRecipientsMutationHookResult = ReturnType<typeof useCustomSendProposalToSpecificRecipientsMutation>;
export type CustomSendProposalToSpecificRecipientsMutationResult = Apollo.MutationResult<CustomSendProposalToSpecificRecipientsMutation>;
export type CustomSendProposalToSpecificRecipientsMutationOptions = Apollo.BaseMutationOptions<CustomSendProposalToSpecificRecipientsMutation, CustomSendProposalToSpecificRecipientsMutationVariables>;
export const CustomSetJobDepositCollectedDocument = gql`
    mutation customSetJobDepositCollected($collected: Boolean!, $id: ID!) {
  setJobDepositCollected(collected: $collected, id: $id) {
    id
    billingStatus
    depositCollectedAt
  }
}
    `;
export type CustomSetJobDepositCollectedMutationFn = Apollo.MutationFunction<CustomSetJobDepositCollectedMutation, CustomSetJobDepositCollectedMutationVariables>;

/**
 * __useCustomSetJobDepositCollectedMutation__
 *
 * To run a mutation, you first call `useCustomSetJobDepositCollectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSetJobDepositCollectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSetJobDepositCollectedMutation, { data, loading, error }] = useCustomSetJobDepositCollectedMutation({
 *   variables: {
 *      collected: // value for 'collected'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomSetJobDepositCollectedMutation(baseOptions?: Apollo.MutationHookOptions<CustomSetJobDepositCollectedMutation, CustomSetJobDepositCollectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSetJobDepositCollectedMutation, CustomSetJobDepositCollectedMutationVariables>(CustomSetJobDepositCollectedDocument, options);
      }
export type CustomSetJobDepositCollectedMutationHookResult = ReturnType<typeof useCustomSetJobDepositCollectedMutation>;
export type CustomSetJobDepositCollectedMutationResult = Apollo.MutationResult<CustomSetJobDepositCollectedMutation>;
export type CustomSetJobDepositCollectedMutationOptions = Apollo.BaseMutationOptions<CustomSetJobDepositCollectedMutation, CustomSetJobDepositCollectedMutationVariables>;
export const CustomSetProposalToDraftDocument = gql`
    mutation customSetProposalToDraft($id: ID!) {
  setProposalToDraft(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomSetProposalToDraftMutationFn = Apollo.MutationFunction<CustomSetProposalToDraftMutation, CustomSetProposalToDraftMutationVariables>;

/**
 * __useCustomSetProposalToDraftMutation__
 *
 * To run a mutation, you first call `useCustomSetProposalToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSetProposalToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSetProposalToDraftMutation, { data, loading, error }] = useCustomSetProposalToDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomSetProposalToDraftMutation(baseOptions?: Apollo.MutationHookOptions<CustomSetProposalToDraftMutation, CustomSetProposalToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSetProposalToDraftMutation, CustomSetProposalToDraftMutationVariables>(CustomSetProposalToDraftDocument, options);
      }
export type CustomSetProposalToDraftMutationHookResult = ReturnType<typeof useCustomSetProposalToDraftMutation>;
export type CustomSetProposalToDraftMutationResult = Apollo.MutationResult<CustomSetProposalToDraftMutation>;
export type CustomSetProposalToDraftMutationOptions = Apollo.BaseMutationOptions<CustomSetProposalToDraftMutation, CustomSetProposalToDraftMutationVariables>;
export const CustomSetProposalToWonDocument = gql`
    mutation customSetProposalToWon($id: ID!, $forceSend: Boolean) {
  setProposalToWon(id: $id, forceSend: $forceSend) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomSetProposalToWonMutationFn = Apollo.MutationFunction<CustomSetProposalToWonMutation, CustomSetProposalToWonMutationVariables>;

/**
 * __useCustomSetProposalToWonMutation__
 *
 * To run a mutation, you first call `useCustomSetProposalToWonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSetProposalToWonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSetProposalToWonMutation, { data, loading, error }] = useCustomSetProposalToWonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      forceSend: // value for 'forceSend'
 *   },
 * });
 */
export function useCustomSetProposalToWonMutation(baseOptions?: Apollo.MutationHookOptions<CustomSetProposalToWonMutation, CustomSetProposalToWonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSetProposalToWonMutation, CustomSetProposalToWonMutationVariables>(CustomSetProposalToWonDocument, options);
      }
export type CustomSetProposalToWonMutationHookResult = ReturnType<typeof useCustomSetProposalToWonMutation>;
export type CustomSetProposalToWonMutationResult = Apollo.MutationResult<CustomSetProposalToWonMutation>;
export type CustomSetProposalToWonMutationOptions = Apollo.BaseMutationOptions<CustomSetProposalToWonMutation, CustomSetProposalToWonMutationVariables>;
export const CustomSyncAiMappingCostsToMapDocument = gql`
    mutation customSyncAiMappingCostsToMap($input: SyncAiMappingCostsToMapInput!) {
  syncAiMappingCostsToMap(input: $input) {
    id
    measurements {
      id
      geojsonFeatureId
    }
  }
}
    `;
export type CustomSyncAiMappingCostsToMapMutationFn = Apollo.MutationFunction<CustomSyncAiMappingCostsToMapMutation, CustomSyncAiMappingCostsToMapMutationVariables>;

/**
 * __useCustomSyncAiMappingCostsToMapMutation__
 *
 * To run a mutation, you first call `useCustomSyncAiMappingCostsToMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSyncAiMappingCostsToMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSyncAiMappingCostsToMapMutation, { data, loading, error }] = useCustomSyncAiMappingCostsToMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomSyncAiMappingCostsToMapMutation(baseOptions?: Apollo.MutationHookOptions<CustomSyncAiMappingCostsToMapMutation, CustomSyncAiMappingCostsToMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSyncAiMappingCostsToMapMutation, CustomSyncAiMappingCostsToMapMutationVariables>(CustomSyncAiMappingCostsToMapDocument, options);
      }
export type CustomSyncAiMappingCostsToMapMutationHookResult = ReturnType<typeof useCustomSyncAiMappingCostsToMapMutation>;
export type CustomSyncAiMappingCostsToMapMutationResult = Apollo.MutationResult<CustomSyncAiMappingCostsToMapMutation>;
export type CustomSyncAiMappingCostsToMapMutationOptions = Apollo.BaseMutationOptions<CustomSyncAiMappingCostsToMapMutation, CustomSyncAiMappingCostsToMapMutationVariables>;
export const CustomSyncProposalStageMeasurementsDocument = gql`
    mutation customSyncProposalStageMeasurements($input: SyncProposalStageMeasurementsInput!) {
  syncProposalStageMeasurements(input: $input) {
    ...BitumioProposalStage
  }
}
    ${BitumioProposalStageFragmentDoc}`;
export type CustomSyncProposalStageMeasurementsMutationFn = Apollo.MutationFunction<CustomSyncProposalStageMeasurementsMutation, CustomSyncProposalStageMeasurementsMutationVariables>;

/**
 * __useCustomSyncProposalStageMeasurementsMutation__
 *
 * To run a mutation, you first call `useCustomSyncProposalStageMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSyncProposalStageMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSyncProposalStageMeasurementsMutation, { data, loading, error }] = useCustomSyncProposalStageMeasurementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomSyncProposalStageMeasurementsMutation(baseOptions?: Apollo.MutationHookOptions<CustomSyncProposalStageMeasurementsMutation, CustomSyncProposalStageMeasurementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSyncProposalStageMeasurementsMutation, CustomSyncProposalStageMeasurementsMutationVariables>(CustomSyncProposalStageMeasurementsDocument, options);
      }
export type CustomSyncProposalStageMeasurementsMutationHookResult = ReturnType<typeof useCustomSyncProposalStageMeasurementsMutation>;
export type CustomSyncProposalStageMeasurementsMutationResult = Apollo.MutationResult<CustomSyncProposalStageMeasurementsMutation>;
export type CustomSyncProposalStageMeasurementsMutationOptions = Apollo.BaseMutationOptions<CustomSyncProposalStageMeasurementsMutation, CustomSyncProposalStageMeasurementsMutationVariables>;
export const CustomSyncQuickbooksBatchDocument = gql`
    mutation customSyncQuickbooksBatch($input: SyncQuickbooksBatchInput!) {
  syncQuickbooksBatch(input: $input) {
    id
    billedTotalAmount
    selectedTotalAmount
    quickbooksOnlineStatus
    quickbooksDesktopStatus
    quickbooksOnlineError
    quickbooksDesktopError
  }
}
    `;
export type CustomSyncQuickbooksBatchMutationFn = Apollo.MutationFunction<CustomSyncQuickbooksBatchMutation, CustomSyncQuickbooksBatchMutationVariables>;

/**
 * __useCustomSyncQuickbooksBatchMutation__
 *
 * To run a mutation, you first call `useCustomSyncQuickbooksBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSyncQuickbooksBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSyncQuickbooksBatchMutation, { data, loading, error }] = useCustomSyncQuickbooksBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomSyncQuickbooksBatchMutation(baseOptions?: Apollo.MutationHookOptions<CustomSyncQuickbooksBatchMutation, CustomSyncQuickbooksBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSyncQuickbooksBatchMutation, CustomSyncQuickbooksBatchMutationVariables>(CustomSyncQuickbooksBatchDocument, options);
      }
export type CustomSyncQuickbooksBatchMutationHookResult = ReturnType<typeof useCustomSyncQuickbooksBatchMutation>;
export type CustomSyncQuickbooksBatchMutationResult = Apollo.MutationResult<CustomSyncQuickbooksBatchMutation>;
export type CustomSyncQuickbooksBatchMutationOptions = Apollo.BaseMutationOptions<CustomSyncQuickbooksBatchMutation, CustomSyncQuickbooksBatchMutationVariables>;
export const CustomUndoAiMappingRunAreaDocument = gql`
    mutation customUndoAiMappingRunArea($id: ID!) {
  undoAiMappingRunArea(id: $id) {
    ...AiMappingResultsBundleFragment
  }
}
    ${AiMappingResultsBundleFragmentFragmentDoc}`;
export type CustomUndoAiMappingRunAreaMutationFn = Apollo.MutationFunction<CustomUndoAiMappingRunAreaMutation, CustomUndoAiMappingRunAreaMutationVariables>;

/**
 * __useCustomUndoAiMappingRunAreaMutation__
 *
 * To run a mutation, you first call `useCustomUndoAiMappingRunAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUndoAiMappingRunAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUndoAiMappingRunAreaMutation, { data, loading, error }] = useCustomUndoAiMappingRunAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomUndoAiMappingRunAreaMutation(baseOptions?: Apollo.MutationHookOptions<CustomUndoAiMappingRunAreaMutation, CustomUndoAiMappingRunAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUndoAiMappingRunAreaMutation, CustomUndoAiMappingRunAreaMutationVariables>(CustomUndoAiMappingRunAreaDocument, options);
      }
export type CustomUndoAiMappingRunAreaMutationHookResult = ReturnType<typeof useCustomUndoAiMappingRunAreaMutation>;
export type CustomUndoAiMappingRunAreaMutationResult = Apollo.MutationResult<CustomUndoAiMappingRunAreaMutation>;
export type CustomUndoAiMappingRunAreaMutationOptions = Apollo.BaseMutationOptions<CustomUndoAiMappingRunAreaMutation, CustomUndoAiMappingRunAreaMutationVariables>;
export const CustomUnscheduleCustomEventDocument = gql`
    mutation customUnscheduleCustomEvent($id: ID!) {
  unscheduleCustomEvent(id: $id) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomUnscheduleCustomEventMutationFn = Apollo.MutationFunction<CustomUnscheduleCustomEventMutation, CustomUnscheduleCustomEventMutationVariables>;

/**
 * __useCustomUnscheduleCustomEventMutation__
 *
 * To run a mutation, you first call `useCustomUnscheduleCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUnscheduleCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUnscheduleCustomEventMutation, { data, loading, error }] = useCustomUnscheduleCustomEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomUnscheduleCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CustomUnscheduleCustomEventMutation, CustomUnscheduleCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUnscheduleCustomEventMutation, CustomUnscheduleCustomEventMutationVariables>(CustomUnscheduleCustomEventDocument, options);
      }
export type CustomUnscheduleCustomEventMutationHookResult = ReturnType<typeof useCustomUnscheduleCustomEventMutation>;
export type CustomUnscheduleCustomEventMutationResult = Apollo.MutationResult<CustomUnscheduleCustomEventMutation>;
export type CustomUnscheduleCustomEventMutationOptions = Apollo.BaseMutationOptions<CustomUnscheduleCustomEventMutation, CustomUnscheduleCustomEventMutationVariables>;
export const CustomUnscheduleJobPhaseDocument = gql`
    mutation customUnscheduleJobPhase($jobPhaseId: ID!) {
  unscheduleJobPhase(jobPhaseId: $jobPhaseId) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    endsAt
    foremanUser {
      id
      organization {
        id
      }
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
    }
    notes
    proposalId
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    startsAt
    status
    userId
  }
}
    `;
export type CustomUnscheduleJobPhaseMutationFn = Apollo.MutationFunction<CustomUnscheduleJobPhaseMutation, CustomUnscheduleJobPhaseMutationVariables>;

/**
 * __useCustomUnscheduleJobPhaseMutation__
 *
 * To run a mutation, you first call `useCustomUnscheduleJobPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUnscheduleJobPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUnscheduleJobPhaseMutation, { data, loading, error }] = useCustomUnscheduleJobPhaseMutation({
 *   variables: {
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useCustomUnscheduleJobPhaseMutation(baseOptions?: Apollo.MutationHookOptions<CustomUnscheduleJobPhaseMutation, CustomUnscheduleJobPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUnscheduleJobPhaseMutation, CustomUnscheduleJobPhaseMutationVariables>(CustomUnscheduleJobPhaseDocument, options);
      }
export type CustomUnscheduleJobPhaseMutationHookResult = ReturnType<typeof useCustomUnscheduleJobPhaseMutation>;
export type CustomUnscheduleJobPhaseMutationResult = Apollo.MutationResult<CustomUnscheduleJobPhaseMutation>;
export type CustomUnscheduleJobPhaseMutationOptions = Apollo.BaseMutationOptions<CustomUnscheduleJobPhaseMutation, CustomUnscheduleJobPhaseMutationVariables>;
export const CustomUpdateAiMappingDetectionDocument = gql`
    mutation customUpdateAiMappingDetection($input: UpdateAiMappingDetectionInput!) {
  updateAiMappingDetection(input: $input) {
    ...AiMappingResultsBundleFragment
  }
}
    ${AiMappingResultsBundleFragmentFragmentDoc}`;
export type CustomUpdateAiMappingDetectionMutationFn = Apollo.MutationFunction<CustomUpdateAiMappingDetectionMutation, CustomUpdateAiMappingDetectionMutationVariables>;

/**
 * __useCustomUpdateAiMappingDetectionMutation__
 *
 * To run a mutation, you first call `useCustomUpdateAiMappingDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateAiMappingDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateAiMappingDetectionMutation, { data, loading, error }] = useCustomUpdateAiMappingDetectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateAiMappingDetectionMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateAiMappingDetectionMutation, CustomUpdateAiMappingDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateAiMappingDetectionMutation, CustomUpdateAiMappingDetectionMutationVariables>(CustomUpdateAiMappingDetectionDocument, options);
      }
export type CustomUpdateAiMappingDetectionMutationHookResult = ReturnType<typeof useCustomUpdateAiMappingDetectionMutation>;
export type CustomUpdateAiMappingDetectionMutationResult = Apollo.MutationResult<CustomUpdateAiMappingDetectionMutation>;
export type CustomUpdateAiMappingDetectionMutationOptions = Apollo.BaseMutationOptions<CustomUpdateAiMappingDetectionMutation, CustomUpdateAiMappingDetectionMutationVariables>;
export const CustomUpdateAiMappingSegmentationDocument = gql`
    mutation customUpdateAiMappingSegmentation($input: UpdateAiMappingSegmentationInput!) {
  updateAiMappingSegmentation(input: $input) {
    ...AiMappingResultsBundleFragment
  }
}
    ${AiMappingResultsBundleFragmentFragmentDoc}`;
export type CustomUpdateAiMappingSegmentationMutationFn = Apollo.MutationFunction<CustomUpdateAiMappingSegmentationMutation, CustomUpdateAiMappingSegmentationMutationVariables>;

/**
 * __useCustomUpdateAiMappingSegmentationMutation__
 *
 * To run a mutation, you first call `useCustomUpdateAiMappingSegmentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateAiMappingSegmentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateAiMappingSegmentationMutation, { data, loading, error }] = useCustomUpdateAiMappingSegmentationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateAiMappingSegmentationMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateAiMappingSegmentationMutation, CustomUpdateAiMappingSegmentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateAiMappingSegmentationMutation, CustomUpdateAiMappingSegmentationMutationVariables>(CustomUpdateAiMappingSegmentationDocument, options);
      }
export type CustomUpdateAiMappingSegmentationMutationHookResult = ReturnType<typeof useCustomUpdateAiMappingSegmentationMutation>;
export type CustomUpdateAiMappingSegmentationMutationResult = Apollo.MutationResult<CustomUpdateAiMappingSegmentationMutation>;
export type CustomUpdateAiMappingSegmentationMutationOptions = Apollo.BaseMutationOptions<CustomUpdateAiMappingSegmentationMutation, CustomUpdateAiMappingSegmentationMutationVariables>;
export const CustomUpdateCustomEventDocument = gql`
    mutation customUpdateCustomEvent($input: UpdateCustomEventInput) {
  updateCustomEvent(input: $input) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomUpdateCustomEventMutationFn = Apollo.MutationFunction<CustomUpdateCustomEventMutation, CustomUpdateCustomEventMutationVariables>;

/**
 * __useCustomUpdateCustomEventMutation__
 *
 * To run a mutation, you first call `useCustomUpdateCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateCustomEventMutation, { data, loading, error }] = useCustomUpdateCustomEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateCustomEventMutation, CustomUpdateCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateCustomEventMutation, CustomUpdateCustomEventMutationVariables>(CustomUpdateCustomEventDocument, options);
      }
export type CustomUpdateCustomEventMutationHookResult = ReturnType<typeof useCustomUpdateCustomEventMutation>;
export type CustomUpdateCustomEventMutationResult = Apollo.MutationResult<CustomUpdateCustomEventMutation>;
export type CustomUpdateCustomEventMutationOptions = Apollo.BaseMutationOptions<CustomUpdateCustomEventMutation, CustomUpdateCustomEventMutationVariables>;
export const CustomUpdateDailyFormVehiclePartDocument = gql`
    mutation customUpdateDailyFormVehiclePart($input: UpdateDailyFormVehiclePartInput!) {
  updateDailyFormVehiclePart(input: $input) {
    id
  }
}
    `;
export type CustomUpdateDailyFormVehiclePartMutationFn = Apollo.MutationFunction<CustomUpdateDailyFormVehiclePartMutation, CustomUpdateDailyFormVehiclePartMutationVariables>;

/**
 * __useCustomUpdateDailyFormVehiclePartMutation__
 *
 * To run a mutation, you first call `useCustomUpdateDailyFormVehiclePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateDailyFormVehiclePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateDailyFormVehiclePartMutation, { data, loading, error }] = useCustomUpdateDailyFormVehiclePartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateDailyFormVehiclePartMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateDailyFormVehiclePartMutation, CustomUpdateDailyFormVehiclePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateDailyFormVehiclePartMutation, CustomUpdateDailyFormVehiclePartMutationVariables>(CustomUpdateDailyFormVehiclePartDocument, options);
      }
export type CustomUpdateDailyFormVehiclePartMutationHookResult = ReturnType<typeof useCustomUpdateDailyFormVehiclePartMutation>;
export type CustomUpdateDailyFormVehiclePartMutationResult = Apollo.MutationResult<CustomUpdateDailyFormVehiclePartMutation>;
export type CustomUpdateDailyFormVehiclePartMutationOptions = Apollo.BaseMutationOptions<CustomUpdateDailyFormVehiclePartMutation, CustomUpdateDailyFormVehiclePartMutationVariables>;
export const CustomUpdateDailyFormVehicleServicePlanDocument = gql`
    mutation customUpdateDailyFormVehicleServicePlan($input: UpdateDailyFormVehicleServicePlanInput!) {
  updateDailyFormVehicleServicePlan(input: $input) {
    id
  }
}
    `;
export type CustomUpdateDailyFormVehicleServicePlanMutationFn = Apollo.MutationFunction<CustomUpdateDailyFormVehicleServicePlanMutation, CustomUpdateDailyFormVehicleServicePlanMutationVariables>;

/**
 * __useCustomUpdateDailyFormVehicleServicePlanMutation__
 *
 * To run a mutation, you first call `useCustomUpdateDailyFormVehicleServicePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateDailyFormVehicleServicePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateDailyFormVehicleServicePlanMutation, { data, loading, error }] = useCustomUpdateDailyFormVehicleServicePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateDailyFormVehicleServicePlanMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateDailyFormVehicleServicePlanMutation, CustomUpdateDailyFormVehicleServicePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateDailyFormVehicleServicePlanMutation, CustomUpdateDailyFormVehicleServicePlanMutationVariables>(CustomUpdateDailyFormVehicleServicePlanDocument, options);
      }
export type CustomUpdateDailyFormVehicleServicePlanMutationHookResult = ReturnType<typeof useCustomUpdateDailyFormVehicleServicePlanMutation>;
export type CustomUpdateDailyFormVehicleServicePlanMutationResult = Apollo.MutationResult<CustomUpdateDailyFormVehicleServicePlanMutation>;
export type CustomUpdateDailyFormVehicleServicePlanMutationOptions = Apollo.BaseMutationOptions<CustomUpdateDailyFormVehicleServicePlanMutation, CustomUpdateDailyFormVehicleServicePlanMutationVariables>;
export const CustomUpdateJobNotesDocument = gql`
    mutation customUpdateJobNotes($id: ID!, $notes: String!) {
  updateJobNotes(id: $id, notes: $notes) {
    id
    notes
  }
}
    `;
export type CustomUpdateJobNotesMutationFn = Apollo.MutationFunction<CustomUpdateJobNotesMutation, CustomUpdateJobNotesMutationVariables>;

/**
 * __useCustomUpdateJobNotesMutation__
 *
 * To run a mutation, you first call `useCustomUpdateJobNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateJobNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateJobNotesMutation, { data, loading, error }] = useCustomUpdateJobNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCustomUpdateJobNotesMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateJobNotesMutation, CustomUpdateJobNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateJobNotesMutation, CustomUpdateJobNotesMutationVariables>(CustomUpdateJobNotesDocument, options);
      }
export type CustomUpdateJobNotesMutationHookResult = ReturnType<typeof useCustomUpdateJobNotesMutation>;
export type CustomUpdateJobNotesMutationResult = Apollo.MutationResult<CustomUpdateJobNotesMutation>;
export type CustomUpdateJobNotesMutationOptions = Apollo.BaseMutationOptions<CustomUpdateJobNotesMutation, CustomUpdateJobNotesMutationVariables>;
export const CustomUpdateJobPhaseCostingDocument = gql`
    mutation customUpdateJobPhaseCosting($input: UpdateJobPhaseCostingInput!) {
  updateJobPhaseCosting(input: $input) {
    ...JobPhaseFragment
  }
}
    ${JobPhaseFragmentFragmentDoc}`;
export type CustomUpdateJobPhaseCostingMutationFn = Apollo.MutationFunction<CustomUpdateJobPhaseCostingMutation, CustomUpdateJobPhaseCostingMutationVariables>;

/**
 * __useCustomUpdateJobPhaseCostingMutation__
 *
 * To run a mutation, you first call `useCustomUpdateJobPhaseCostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateJobPhaseCostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateJobPhaseCostingMutation, { data, loading, error }] = useCustomUpdateJobPhaseCostingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateJobPhaseCostingMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateJobPhaseCostingMutation, CustomUpdateJobPhaseCostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateJobPhaseCostingMutation, CustomUpdateJobPhaseCostingMutationVariables>(CustomUpdateJobPhaseCostingDocument, options);
      }
export type CustomUpdateJobPhaseCostingMutationHookResult = ReturnType<typeof useCustomUpdateJobPhaseCostingMutation>;
export type CustomUpdateJobPhaseCostingMutationResult = Apollo.MutationResult<CustomUpdateJobPhaseCostingMutation>;
export type CustomUpdateJobPhaseCostingMutationOptions = Apollo.BaseMutationOptions<CustomUpdateJobPhaseCostingMutation, CustomUpdateJobPhaseCostingMutationVariables>;
export const CustomUpdateJobPhaseNotesDocument = gql`
    mutation customUpdateJobPhaseNotes($input: UpdateJobPhaseNotesInput!) {
  updateJobPhaseNotes(input: $input) {
    ...JobPhaseFragment
  }
}
    ${JobPhaseFragmentFragmentDoc}`;
export type CustomUpdateJobPhaseNotesMutationFn = Apollo.MutationFunction<CustomUpdateJobPhaseNotesMutation, CustomUpdateJobPhaseNotesMutationVariables>;

/**
 * __useCustomUpdateJobPhaseNotesMutation__
 *
 * To run a mutation, you first call `useCustomUpdateJobPhaseNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateJobPhaseNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateJobPhaseNotesMutation, { data, loading, error }] = useCustomUpdateJobPhaseNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateJobPhaseNotesMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateJobPhaseNotesMutation, CustomUpdateJobPhaseNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateJobPhaseNotesMutation, CustomUpdateJobPhaseNotesMutationVariables>(CustomUpdateJobPhaseNotesDocument, options);
      }
export type CustomUpdateJobPhaseNotesMutationHookResult = ReturnType<typeof useCustomUpdateJobPhaseNotesMutation>;
export type CustomUpdateJobPhaseNotesMutationResult = Apollo.MutationResult<CustomUpdateJobPhaseNotesMutation>;
export type CustomUpdateJobPhaseNotesMutationOptions = Apollo.BaseMutationOptions<CustomUpdateJobPhaseNotesMutation, CustomUpdateJobPhaseNotesMutationVariables>;
export const CustomUpdateJobProjectManagerDocument = gql`
    mutation customUpdateJobProjectManager($id: ID!, $userId: ID!) {
  updateJobProjectManager(id: $id, userId: $userId) {
    id
    userId
  }
}
    `;
export type CustomUpdateJobProjectManagerMutationFn = Apollo.MutationFunction<CustomUpdateJobProjectManagerMutation, CustomUpdateJobProjectManagerMutationVariables>;

/**
 * __useCustomUpdateJobProjectManagerMutation__
 *
 * To run a mutation, you first call `useCustomUpdateJobProjectManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateJobProjectManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateJobProjectManagerMutation, { data, loading, error }] = useCustomUpdateJobProjectManagerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCustomUpdateJobProjectManagerMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateJobProjectManagerMutation, CustomUpdateJobProjectManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateJobProjectManagerMutation, CustomUpdateJobProjectManagerMutationVariables>(CustomUpdateJobProjectManagerDocument, options);
      }
export type CustomUpdateJobProjectManagerMutationHookResult = ReturnType<typeof useCustomUpdateJobProjectManagerMutation>;
export type CustomUpdateJobProjectManagerMutationResult = Apollo.MutationResult<CustomUpdateJobProjectManagerMutation>;
export type CustomUpdateJobProjectManagerMutationOptions = Apollo.BaseMutationOptions<CustomUpdateJobProjectManagerMutation, CustomUpdateJobProjectManagerMutationVariables>;
export const CustomUpdateNotificationTriggerDocument = gql`
    mutation CustomUpdateNotificationTrigger($input: UpdateNotificationTriggerInput!) {
  updateNotificationTrigger(input: $input) {
    ...NotificationTriggerFragment
  }
}
    ${NotificationTriggerFragmentFragmentDoc}`;
export type CustomUpdateNotificationTriggerMutationFn = Apollo.MutationFunction<CustomUpdateNotificationTriggerMutation, CustomUpdateNotificationTriggerMutationVariables>;

/**
 * __useCustomUpdateNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useCustomUpdateNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateNotificationTriggerMutation, { data, loading, error }] = useCustomUpdateNotificationTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateNotificationTriggerMutation, CustomUpdateNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateNotificationTriggerMutation, CustomUpdateNotificationTriggerMutationVariables>(CustomUpdateNotificationTriggerDocument, options);
      }
export type CustomUpdateNotificationTriggerMutationHookResult = ReturnType<typeof useCustomUpdateNotificationTriggerMutation>;
export type CustomUpdateNotificationTriggerMutationResult = Apollo.MutationResult<CustomUpdateNotificationTriggerMutation>;
export type CustomUpdateNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<CustomUpdateNotificationTriggerMutation, CustomUpdateNotificationTriggerMutationVariables>;
export const CustomUpdateProjectMapDocument = gql`
    mutation customUpdateProjectMap($input: UpdateProjectMapInput!) {
  updateProjectMap(input: $input) {
    id
    addressLine1
    addressLine2
    addressCity
    addressState
    addressZip
    addressCountry
    latitude
    longitude
  }
}
    `;
export type CustomUpdateProjectMapMutationFn = Apollo.MutationFunction<CustomUpdateProjectMapMutation, CustomUpdateProjectMapMutationVariables>;

/**
 * __useCustomUpdateProjectMapMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProjectMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProjectMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProjectMapMutation, { data, loading, error }] = useCustomUpdateProjectMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateProjectMapMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProjectMapMutation, CustomUpdateProjectMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProjectMapMutation, CustomUpdateProjectMapMutationVariables>(CustomUpdateProjectMapDocument, options);
      }
export type CustomUpdateProjectMapMutationHookResult = ReturnType<typeof useCustomUpdateProjectMapMutation>;
export type CustomUpdateProjectMapMutationResult = Apollo.MutationResult<CustomUpdateProjectMapMutation>;
export type CustomUpdateProjectMapMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProjectMapMutation, CustomUpdateProjectMapMutationVariables>;
export const CustomUpdateProposalDocument = gql`
    mutation customUpdateProposal($id: ID!, $companyId: ID!, $contactId: ID!, $source: ProposalSource, $projectedCloseDate: Date, $closeConfidence: Int) {
  updateProposal(
    id: $id
    companyId: $companyId
    contactId: $contactId
    source: $source
    projectedCloseDate: $projectedCloseDate
    closeConfidence: $closeConfidence
  ) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomUpdateProposalMutationFn = Apollo.MutationFunction<CustomUpdateProposalMutation, CustomUpdateProposalMutationVariables>;

/**
 * __useCustomUpdateProposalMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalMutation, { data, loading, error }] = useCustomUpdateProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      source: // value for 'source'
 *      projectedCloseDate: // value for 'projectedCloseDate'
 *      closeConfidence: // value for 'closeConfidence'
 *   },
 * });
 */
export function useCustomUpdateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalMutation, CustomUpdateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalMutation, CustomUpdateProposalMutationVariables>(CustomUpdateProposalDocument, options);
      }
export type CustomUpdateProposalMutationHookResult = ReturnType<typeof useCustomUpdateProposalMutation>;
export type CustomUpdateProposalMutationResult = Apollo.MutationResult<CustomUpdateProposalMutation>;
export type CustomUpdateProposalMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalMutation, CustomUpdateProposalMutationVariables>;
export const CustomUpdateProposalInfoDocument = gql`
    mutation customUpdateProposalInfo($input: UpdateProposalInfoInput) {
  updateProposalInfo(input: $input) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomUpdateProposalInfoMutationFn = Apollo.MutationFunction<CustomUpdateProposalInfoMutation, CustomUpdateProposalInfoMutationVariables>;

/**
 * __useCustomUpdateProposalInfoMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalInfoMutation, { data, loading, error }] = useCustomUpdateProposalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateProposalInfoMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalInfoMutation, CustomUpdateProposalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalInfoMutation, CustomUpdateProposalInfoMutationVariables>(CustomUpdateProposalInfoDocument, options);
      }
export type CustomUpdateProposalInfoMutationHookResult = ReturnType<typeof useCustomUpdateProposalInfoMutation>;
export type CustomUpdateProposalInfoMutationResult = Apollo.MutationResult<CustomUpdateProposalInfoMutation>;
export type CustomUpdateProposalInfoMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalInfoMutation, CustomUpdateProposalInfoMutationVariables>;
export const CustomUpdateProposalPlantProductDocument = gql`
    mutation customUpdateProposalPlantProduct($plantProductId: ID!, $proposalProductId: ID!, $proposalPlantProductId: ID!) {
  updateProposalPlantProduct(
    plantProductId: $plantProductId
    proposalProductId: $proposalProductId
    proposalPlantProductId: $proposalPlantProductId
  ) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomUpdateProposalPlantProductMutationFn = Apollo.MutationFunction<CustomUpdateProposalPlantProductMutation, CustomUpdateProposalPlantProductMutationVariables>;

/**
 * __useCustomUpdateProposalPlantProductMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalPlantProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalPlantProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalPlantProductMutation, { data, loading, error }] = useCustomUpdateProposalPlantProductMutation({
 *   variables: {
 *      plantProductId: // value for 'plantProductId'
 *      proposalProductId: // value for 'proposalProductId'
 *      proposalPlantProductId: // value for 'proposalPlantProductId'
 *   },
 * });
 */
export function useCustomUpdateProposalPlantProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalPlantProductMutation, CustomUpdateProposalPlantProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalPlantProductMutation, CustomUpdateProposalPlantProductMutationVariables>(CustomUpdateProposalPlantProductDocument, options);
      }
export type CustomUpdateProposalPlantProductMutationHookResult = ReturnType<typeof useCustomUpdateProposalPlantProductMutation>;
export type CustomUpdateProposalPlantProductMutationResult = Apollo.MutationResult<CustomUpdateProposalPlantProductMutation>;
export type CustomUpdateProposalPlantProductMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalPlantProductMutation, CustomUpdateProposalPlantProductMutationVariables>;
export const CustomUpdateProposalProductDocument = gql`
    mutation customUpdateProposalProduct($input: UpdateProposalProductInput!) {
  updateProposalProduct(input: $input) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomUpdateProposalProductMutationFn = Apollo.MutationFunction<CustomUpdateProposalProductMutation, CustomUpdateProposalProductMutationVariables>;

/**
 * __useCustomUpdateProposalProductMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalProductMutation, { data, loading, error }] = useCustomUpdateProposalProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalProductMutation, CustomUpdateProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalProductMutation, CustomUpdateProposalProductMutationVariables>(CustomUpdateProposalProductDocument, options);
      }
export type CustomUpdateProposalProductMutationHookResult = ReturnType<typeof useCustomUpdateProposalProductMutation>;
export type CustomUpdateProposalProductMutationResult = Apollo.MutationResult<CustomUpdateProposalProductMutation>;
export type CustomUpdateProposalProductMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalProductMutation, CustomUpdateProposalProductMutationVariables>;
export const CustomUpdateProposalStageDocument = gql`
    mutation customUpdateProposalStage($id: ID!, $name: String, $mapData: String, $addressOverride: String) {
  updateProposalStage(
    id: $id
    name: $name
    mapData: $mapData
    addressOverride: $addressOverride
  ) {
    ...BitumioProposalStage
  }
}
    ${BitumioProposalStageFragmentDoc}`;
export type CustomUpdateProposalStageMutationFn = Apollo.MutationFunction<CustomUpdateProposalStageMutation, CustomUpdateProposalStageMutationVariables>;

/**
 * __useCustomUpdateProposalStageMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalStageMutation, { data, loading, error }] = useCustomUpdateProposalStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      mapData: // value for 'mapData'
 *      addressOverride: // value for 'addressOverride'
 *   },
 * });
 */
export function useCustomUpdateProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalStageMutation, CustomUpdateProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalStageMutation, CustomUpdateProposalStageMutationVariables>(CustomUpdateProposalStageDocument, options);
      }
export type CustomUpdateProposalStageMutationHookResult = ReturnType<typeof useCustomUpdateProposalStageMutation>;
export type CustomUpdateProposalStageMutationResult = Apollo.MutationResult<CustomUpdateProposalStageMutation>;
export type CustomUpdateProposalStageMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalStageMutation, CustomUpdateProposalStageMutationVariables>;
export const CustomUpdateProposalStageAddressAndClearProductsDocument = gql`
    mutation customUpdateProposalStageAddressAndClearProducts($input: UpdateProposalStageAddressAndClearProductsInput!) {
  updateProposalStageAddressAndClearProducts(input: $input) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomUpdateProposalStageAddressAndClearProductsMutationFn = Apollo.MutationFunction<CustomUpdateProposalStageAddressAndClearProductsMutation, CustomUpdateProposalStageAddressAndClearProductsMutationVariables>;

/**
 * __useCustomUpdateProposalStageAddressAndClearProductsMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalStageAddressAndClearProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalStageAddressAndClearProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalStageAddressAndClearProductsMutation, { data, loading, error }] = useCustomUpdateProposalStageAddressAndClearProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateProposalStageAddressAndClearProductsMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalStageAddressAndClearProductsMutation, CustomUpdateProposalStageAddressAndClearProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalStageAddressAndClearProductsMutation, CustomUpdateProposalStageAddressAndClearProductsMutationVariables>(CustomUpdateProposalStageAddressAndClearProductsDocument, options);
      }
export type CustomUpdateProposalStageAddressAndClearProductsMutationHookResult = ReturnType<typeof useCustomUpdateProposalStageAddressAndClearProductsMutation>;
export type CustomUpdateProposalStageAddressAndClearProductsMutationResult = Apollo.MutationResult<CustomUpdateProposalStageAddressAndClearProductsMutation>;
export type CustomUpdateProposalStageAddressAndClearProductsMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalStageAddressAndClearProductsMutation, CustomUpdateProposalStageAddressAndClearProductsMutationVariables>;
export const CustomGetAiMappingProposalDocument = gql`
    query customGetAiMappingProposal($id: ID!) {
  getProposal(id: $id) {
    id
    stages {
      id
      name
      proposalProducts {
        id
        productName
        measurementJob
        material {
          id
          name
          unitPrice
          measurementJob
          productId
        }
      }
    }
  }
}
    `;

/**
 * __useCustomGetAiMappingProposalQuery__
 *
 * To run a query within a React component, call `useCustomGetAiMappingProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetAiMappingProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetAiMappingProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetAiMappingProposalQuery(baseOptions: Apollo.QueryHookOptions<CustomGetAiMappingProposalQuery, CustomGetAiMappingProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetAiMappingProposalQuery, CustomGetAiMappingProposalQueryVariables>(CustomGetAiMappingProposalDocument, options);
      }
export function useCustomGetAiMappingProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetAiMappingProposalQuery, CustomGetAiMappingProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetAiMappingProposalQuery, CustomGetAiMappingProposalQueryVariables>(CustomGetAiMappingProposalDocument, options);
        }
export type CustomGetAiMappingProposalQueryHookResult = ReturnType<typeof useCustomGetAiMappingProposalQuery>;
export type CustomGetAiMappingProposalLazyQueryHookResult = ReturnType<typeof useCustomGetAiMappingProposalLazyQuery>;
export type CustomGetAiMappingProposalQueryResult = Apollo.QueryResult<CustomGetAiMappingProposalQuery, CustomGetAiMappingProposalQueryVariables>;
export const CustomGetAiMappingRunDocument = gql`
    query customGetAiMappingRun($projectMapId: ID!) {
  getAiMappingRun(projectMapId: $projectMapId) {
    id
    name
    description
    createdAt
    updatedAt
    projectMap {
      id
    }
    areas {
      ...AiMappingRunAreaFragment
    }
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;

/**
 * __useCustomGetAiMappingRunQuery__
 *
 * To run a query within a React component, call `useCustomGetAiMappingRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetAiMappingRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetAiMappingRunQuery({
 *   variables: {
 *      projectMapId: // value for 'projectMapId'
 *   },
 * });
 */
export function useCustomGetAiMappingRunQuery(baseOptions: Apollo.QueryHookOptions<CustomGetAiMappingRunQuery, CustomGetAiMappingRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetAiMappingRunQuery, CustomGetAiMappingRunQueryVariables>(CustomGetAiMappingRunDocument, options);
      }
export function useCustomGetAiMappingRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetAiMappingRunQuery, CustomGetAiMappingRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetAiMappingRunQuery, CustomGetAiMappingRunQueryVariables>(CustomGetAiMappingRunDocument, options);
        }
export type CustomGetAiMappingRunQueryHookResult = ReturnType<typeof useCustomGetAiMappingRunQuery>;
export type CustomGetAiMappingRunLazyQueryHookResult = ReturnType<typeof useCustomGetAiMappingRunLazyQuery>;
export type CustomGetAiMappingRunQueryResult = Apollo.QueryResult<CustomGetAiMappingRunQuery, CustomGetAiMappingRunQueryVariables>;
export const CustomGetAiMappingRunAreaDocument = gql`
    query customGetAiMappingRunArea($id: ID!) {
  getAiMappingRunArea(id: $id) {
    ...AiMappingRunAreaFragment
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;

/**
 * __useCustomGetAiMappingRunAreaQuery__
 *
 * To run a query within a React component, call `useCustomGetAiMappingRunAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetAiMappingRunAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetAiMappingRunAreaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetAiMappingRunAreaQuery(baseOptions: Apollo.QueryHookOptions<CustomGetAiMappingRunAreaQuery, CustomGetAiMappingRunAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetAiMappingRunAreaQuery, CustomGetAiMappingRunAreaQueryVariables>(CustomGetAiMappingRunAreaDocument, options);
      }
export function useCustomGetAiMappingRunAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetAiMappingRunAreaQuery, CustomGetAiMappingRunAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetAiMappingRunAreaQuery, CustomGetAiMappingRunAreaQueryVariables>(CustomGetAiMappingRunAreaDocument, options);
        }
export type CustomGetAiMappingRunAreaQueryHookResult = ReturnType<typeof useCustomGetAiMappingRunAreaQuery>;
export type CustomGetAiMappingRunAreaLazyQueryHookResult = ReturnType<typeof useCustomGetAiMappingRunAreaLazyQuery>;
export type CustomGetAiMappingRunAreaQueryResult = Apollo.QueryResult<CustomGetAiMappingRunAreaQuery, CustomGetAiMappingRunAreaQueryVariables>;
export const CustomGetAiMappingRunAreaResultsDocument = gql`
    query customGetAiMappingRunAreaResults($id: ID!) {
  getAiMappingRunAreaResults(id: $id) {
    area {
      ...AiMappingRunAreaFragment
    }
    detections {
      id
      version
      category
      bbox
      confidence
      color
      source
      isDeleted
    }
    segmentations {
      id
      version
      category
      polygon
      areaSqft
      color
      isDeleted
    }
  }
}
    ${AiMappingRunAreaFragmentFragmentDoc}`;

/**
 * __useCustomGetAiMappingRunAreaResultsQuery__
 *
 * To run a query within a React component, call `useCustomGetAiMappingRunAreaResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetAiMappingRunAreaResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetAiMappingRunAreaResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetAiMappingRunAreaResultsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetAiMappingRunAreaResultsQuery, CustomGetAiMappingRunAreaResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetAiMappingRunAreaResultsQuery, CustomGetAiMappingRunAreaResultsQueryVariables>(CustomGetAiMappingRunAreaResultsDocument, options);
      }
export function useCustomGetAiMappingRunAreaResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetAiMappingRunAreaResultsQuery, CustomGetAiMappingRunAreaResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetAiMappingRunAreaResultsQuery, CustomGetAiMappingRunAreaResultsQueryVariables>(CustomGetAiMappingRunAreaResultsDocument, options);
        }
export type CustomGetAiMappingRunAreaResultsQueryHookResult = ReturnType<typeof useCustomGetAiMappingRunAreaResultsQuery>;
export type CustomGetAiMappingRunAreaResultsLazyQueryHookResult = ReturnType<typeof useCustomGetAiMappingRunAreaResultsLazyQuery>;
export type CustomGetAiMappingRunAreaResultsQueryResult = Apollo.QueryResult<CustomGetAiMappingRunAreaResultsQuery, CustomGetAiMappingRunAreaResultsQueryVariables>;
export const CustomGetAiMappingTaskStatusDocument = gql`
    query customGetAiMappingTaskStatus($taskId: String!) {
  getAiMappingTaskStatus(taskId: $taskId) {
    status
    progress
    progressMessage
    error
    pdfUrl
    counts {
      category
      count
    }
  }
}
    `;

/**
 * __useCustomGetAiMappingTaskStatusQuery__
 *
 * To run a query within a React component, call `useCustomGetAiMappingTaskStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetAiMappingTaskStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetAiMappingTaskStatusQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCustomGetAiMappingTaskStatusQuery(baseOptions: Apollo.QueryHookOptions<CustomGetAiMappingTaskStatusQuery, CustomGetAiMappingTaskStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetAiMappingTaskStatusQuery, CustomGetAiMappingTaskStatusQueryVariables>(CustomGetAiMappingTaskStatusDocument, options);
      }
export function useCustomGetAiMappingTaskStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetAiMappingTaskStatusQuery, CustomGetAiMappingTaskStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetAiMappingTaskStatusQuery, CustomGetAiMappingTaskStatusQueryVariables>(CustomGetAiMappingTaskStatusDocument, options);
        }
export type CustomGetAiMappingTaskStatusQueryHookResult = ReturnType<typeof useCustomGetAiMappingTaskStatusQuery>;
export type CustomGetAiMappingTaskStatusLazyQueryHookResult = ReturnType<typeof useCustomGetAiMappingTaskStatusLazyQuery>;
export type CustomGetAiMappingTaskStatusQueryResult = Apollo.QueryResult<CustomGetAiMappingTaskStatusQuery, CustomGetAiMappingTaskStatusQueryVariables>;
export const CustomGetAllCrewsDocument = gql`
    query customGetAllCrews {
  getAllCrews {
    color
    displayName
    employees {
      id
    }
    foremanUser {
      id
      name
    }
    id
    name
    organization {
      id
    }
    rate
  }
}
    `;

/**
 * __useCustomGetAllCrewsQuery__
 *
 * To run a query within a React component, call `useCustomGetAllCrewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetAllCrewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetAllCrewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomGetAllCrewsQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>(CustomGetAllCrewsDocument, options);
      }
export function useCustomGetAllCrewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>(CustomGetAllCrewsDocument, options);
        }
export type CustomGetAllCrewsQueryHookResult = ReturnType<typeof useCustomGetAllCrewsQuery>;
export type CustomGetAllCrewsLazyQueryHookResult = ReturnType<typeof useCustomGetAllCrewsLazyQuery>;
export type CustomGetAllCrewsQueryResult = Apollo.QueryResult<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>;
export const CustomGetCompaniesDocument = gql`
    query customGetCompanies($first: Int!, $page: Int, $search: String, $sort: SortDirection, $sortKey: GetCompaniesSortKey) {
  getCompanies(
    first: $first
    page: $page
    search: $search
    sort: $sort
    sortKey: $sortKey
  ) {
    data {
      ...CompanyFragment
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${CompanyFragmentFragmentDoc}`;

/**
 * __useCustomGetCompaniesQuery__
 *
 * To run a query within a React component, call `useCustomGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useCustomGetCompaniesQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>(CustomGetCompaniesDocument, options);
      }
export function useCustomGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>(CustomGetCompaniesDocument, options);
        }
export type CustomGetCompaniesQueryHookResult = ReturnType<typeof useCustomGetCompaniesQuery>;
export type CustomGetCompaniesLazyQueryHookResult = ReturnType<typeof useCustomGetCompaniesLazyQuery>;
export type CustomGetCompaniesQueryResult = Apollo.QueryResult<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>;
export const CustomGetCompaniesForDropdownDocument = gql`
    query customGetCompaniesForDropdown($first: Int!, $page: Int, $search: String, $sort: SortDirection, $sortKey: GetCompaniesSortKey) {
  getCompanies(
    first: $first
    page: $page
    search: $search
    sort: $sort
    sortKey: $sortKey
  ) {
    data {
      id
      name
      contacts {
        email
        id
        firstName
        lastName
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetCompaniesForDropdownQuery__
 *
 * To run a query within a React component, call `useCustomGetCompaniesForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCompaniesForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCompaniesForDropdownQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useCustomGetCompaniesForDropdownQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCompaniesForDropdownQuery, CustomGetCompaniesForDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCompaniesForDropdownQuery, CustomGetCompaniesForDropdownQueryVariables>(CustomGetCompaniesForDropdownDocument, options);
      }
export function useCustomGetCompaniesForDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCompaniesForDropdownQuery, CustomGetCompaniesForDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCompaniesForDropdownQuery, CustomGetCompaniesForDropdownQueryVariables>(CustomGetCompaniesForDropdownDocument, options);
        }
export type CustomGetCompaniesForDropdownQueryHookResult = ReturnType<typeof useCustomGetCompaniesForDropdownQuery>;
export type CustomGetCompaniesForDropdownLazyQueryHookResult = ReturnType<typeof useCustomGetCompaniesForDropdownLazyQuery>;
export type CustomGetCompaniesForDropdownQueryResult = Apollo.QueryResult<CustomGetCompaniesForDropdownQuery, CustomGetCompaniesForDropdownQueryVariables>;
export const CustomGetCompaniesForFilterDocument = gql`
    query customGetCompaniesForFilter($first: Int!, $page: Int, $search: String, $sort: SortDirection, $sortKey: GetCompaniesSortKey) {
  getCompanies(
    first: $first
    page: $page
    search: $search
    sort: $sort
    sortKey: $sortKey
  ) {
    data {
      id
      name
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetCompaniesForFilterQuery__
 *
 * To run a query within a React component, call `useCustomGetCompaniesForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCompaniesForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCompaniesForFilterQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useCustomGetCompaniesForFilterQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>(CustomGetCompaniesForFilterDocument, options);
      }
export function useCustomGetCompaniesForFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>(CustomGetCompaniesForFilterDocument, options);
        }
export type CustomGetCompaniesForFilterQueryHookResult = ReturnType<typeof useCustomGetCompaniesForFilterQuery>;
export type CustomGetCompaniesForFilterLazyQueryHookResult = ReturnType<typeof useCustomGetCompaniesForFilterLazyQuery>;
export type CustomGetCompaniesForFilterQueryResult = Apollo.QueryResult<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>;
export const CustomGetCompaniesForMergeDocument = gql`
    query customGetCompaniesForMerge($first: Int!, $page: Int, $search: String, $sort: SortDirection, $sortKey: GetCompaniesSortKey) {
  getCompanies(
    first: $first
    page: $page
    search: $search
    sort: $sort
    sortKey: $sortKey
  ) {
    data {
      id
      name
      proposalsCount
      jobsCount
    }
    paginatorInfo {
      currentPage
      hasMorePages
    }
  }
}
    `;

/**
 * __useCustomGetCompaniesForMergeQuery__
 *
 * To run a query within a React component, call `useCustomGetCompaniesForMergeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCompaniesForMergeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCompaniesForMergeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useCustomGetCompaniesForMergeQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCompaniesForMergeQuery, CustomGetCompaniesForMergeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCompaniesForMergeQuery, CustomGetCompaniesForMergeQueryVariables>(CustomGetCompaniesForMergeDocument, options);
      }
export function useCustomGetCompaniesForMergeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCompaniesForMergeQuery, CustomGetCompaniesForMergeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCompaniesForMergeQuery, CustomGetCompaniesForMergeQueryVariables>(CustomGetCompaniesForMergeDocument, options);
        }
export type CustomGetCompaniesForMergeQueryHookResult = ReturnType<typeof useCustomGetCompaniesForMergeQuery>;
export type CustomGetCompaniesForMergeLazyQueryHookResult = ReturnType<typeof useCustomGetCompaniesForMergeLazyQuery>;
export type CustomGetCompaniesForMergeQueryResult = Apollo.QueryResult<CustomGetCompaniesForMergeQuery, CustomGetCompaniesForMergeQueryVariables>;
export const CustomGetCompanyDocument = gql`
    query customGetCompany($id: ID!) {
  getCompany(id: $id) {
    ...CompanyFragment
  }
}
    ${CompanyFragmentFragmentDoc}`;

/**
 * __useCustomGetCompanyQuery__
 *
 * To run a query within a React component, call `useCustomGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>(CustomGetCompanyDocument, options);
      }
export function useCustomGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>(CustomGetCompanyDocument, options);
        }
export type CustomGetCompanyQueryHookResult = ReturnType<typeof useCustomGetCompanyQuery>;
export type CustomGetCompanyLazyQueryHookResult = ReturnType<typeof useCustomGetCompanyLazyQuery>;
export type CustomGetCompanyQueryResult = Apollo.QueryResult<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>;
export const CustomGetCrewsDocument = gql`
    query customGetCrews($first: Int!, $page: Int, $search: String, $sort: SortDirection) {
  getCrews(first: $first, page: $page, search: $search, sort: $sort) {
    data {
      id
      name
      displayName
      rate
      color
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetCrewsQuery__
 *
 * To run a query within a React component, call `useCustomGetCrewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCrewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCrewsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCustomGetCrewsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCrewsQuery, CustomGetCrewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCrewsQuery, CustomGetCrewsQueryVariables>(CustomGetCrewsDocument, options);
      }
export function useCustomGetCrewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCrewsQuery, CustomGetCrewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCrewsQuery, CustomGetCrewsQueryVariables>(CustomGetCrewsDocument, options);
        }
export type CustomGetCrewsQueryHookResult = ReturnType<typeof useCustomGetCrewsQuery>;
export type CustomGetCrewsLazyQueryHookResult = ReturnType<typeof useCustomGetCrewsLazyQuery>;
export type CustomGetCrewsQueryResult = Apollo.QueryResult<CustomGetCrewsQuery, CustomGetCrewsQueryVariables>;
export const CustomGetCustomEventDocument = gql`
    query customGetCustomEvent($id: ID!) {
  getCustomEvent(id: $id) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;

/**
 * __useCustomGetCustomEventQuery__
 *
 * To run a query within a React component, call `useCustomGetCustomEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCustomEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCustomEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetCustomEventQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>(CustomGetCustomEventDocument, options);
      }
export function useCustomGetCustomEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>(CustomGetCustomEventDocument, options);
        }
export type CustomGetCustomEventQueryHookResult = ReturnType<typeof useCustomGetCustomEventQuery>;
export type CustomGetCustomEventLazyQueryHookResult = ReturnType<typeof useCustomGetCustomEventLazyQuery>;
export type CustomGetCustomEventQueryResult = Apollo.QueryResult<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>;
export const CustomGetCustomEventBlocksDocument = gql`
    query customGetCustomEventBlocks($dateFrom: DateTime, $dateUntil: DateTime, $crewId: ID, $customEventIds: [ID]) {
  getCustomEventBlocks(
    dateFrom: $dateFrom
    dateUntil: $dateUntil
    crewId: $crewId
    customEventIds: $customEventIds
  ) {
    blockLength
    customEvent {
      color
      crew {
        color
        id
        name
      }
      endsAt
      id
      name
      notes
      startsAt
      customEventsToUsers {
        user {
          id
          firstName
          lastName
        }
      }
    }
    endsAt
    id
    scheduledAt
  }
}
    `;

/**
 * __useCustomGetCustomEventBlocksQuery__
 *
 * To run a query within a React component, call `useCustomGetCustomEventBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCustomEventBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCustomEventBlocksQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateUntil: // value for 'dateUntil'
 *      crewId: // value for 'crewId'
 *      customEventIds: // value for 'customEventIds'
 *   },
 * });
 */
export function useCustomGetCustomEventBlocksQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>(CustomGetCustomEventBlocksDocument, options);
      }
export function useCustomGetCustomEventBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>(CustomGetCustomEventBlocksDocument, options);
        }
export type CustomGetCustomEventBlocksQueryHookResult = ReturnType<typeof useCustomGetCustomEventBlocksQuery>;
export type CustomGetCustomEventBlocksLazyQueryHookResult = ReturnType<typeof useCustomGetCustomEventBlocksLazyQuery>;
export type CustomGetCustomEventBlocksQueryResult = Apollo.QueryResult<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>;
export const CustomGetDailyFormVehicleDocument = gql`
    query customGetDailyFormVehicle($id: ID!) {
  getDailyFormVehicle(id: $id) {
    id
    name
    year
    make
    model
    vin
    licensePlate
    registrationState
    registrationExpirationDate
    inServiceDate
    meterType
    currentMeterReading
    defaultServiceIntervalValue
    defaultServiceIntervalUnit
    notes
    isActive
    dailyFormVehicleType {
      id
      name
    }
    parts {
      id
      name
      vendorName
      partNumber
      unitPrice
      quantity
      notes
    }
    servicePlans {
      id
      name
      intervalValue
      intervalUnit
      leadValue
      leadUnit
      lastCompletedAt
      lastCompletedMeterReading
      nextDueDate
      nextDueMeterReading
      autoCreateTask
      issueType
      priority
      notes
      isActive
      assignedTo {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCustomGetDailyFormVehicleQuery__
 *
 * To run a query within a React component, call `useCustomGetDailyFormVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetDailyFormVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetDailyFormVehicleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetDailyFormVehicleQuery(baseOptions: Apollo.QueryHookOptions<CustomGetDailyFormVehicleQuery, CustomGetDailyFormVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetDailyFormVehicleQuery, CustomGetDailyFormVehicleQueryVariables>(CustomGetDailyFormVehicleDocument, options);
      }
export function useCustomGetDailyFormVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetDailyFormVehicleQuery, CustomGetDailyFormVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetDailyFormVehicleQuery, CustomGetDailyFormVehicleQueryVariables>(CustomGetDailyFormVehicleDocument, options);
        }
export type CustomGetDailyFormVehicleQueryHookResult = ReturnType<typeof useCustomGetDailyFormVehicleQuery>;
export type CustomGetDailyFormVehicleLazyQueryHookResult = ReturnType<typeof useCustomGetDailyFormVehicleLazyQuery>;
export type CustomGetDailyFormVehicleQueryResult = Apollo.QueryResult<CustomGetDailyFormVehicleQuery, CustomGetDailyFormVehicleQueryVariables>;
export const CustomGetDailyFormVehiclesDocument = gql`
    query customGetDailyFormVehicles($first: Int!, $page: Int) {
  getDailyFormVehicles(first: $first, page: $page) {
    data {
      id
      name
      year
      make
      model
      licensePlate
      registrationExpirationDate
      currentMeterReading
      meterType
      isActive
      dailyFormVehicleType {
        id
        name
      }
      servicePlans {
        id
        name
        intervalUnit
        nextDueDate
        nextDueMeterReading
        isActive
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetDailyFormVehiclesQuery__
 *
 * To run a query within a React component, call `useCustomGetDailyFormVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetDailyFormVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetDailyFormVehiclesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCustomGetDailyFormVehiclesQuery(baseOptions: Apollo.QueryHookOptions<CustomGetDailyFormVehiclesQuery, CustomGetDailyFormVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetDailyFormVehiclesQuery, CustomGetDailyFormVehiclesQueryVariables>(CustomGetDailyFormVehiclesDocument, options);
      }
export function useCustomGetDailyFormVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetDailyFormVehiclesQuery, CustomGetDailyFormVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetDailyFormVehiclesQuery, CustomGetDailyFormVehiclesQueryVariables>(CustomGetDailyFormVehiclesDocument, options);
        }
export type CustomGetDailyFormVehiclesQueryHookResult = ReturnType<typeof useCustomGetDailyFormVehiclesQuery>;
export type CustomGetDailyFormVehiclesLazyQueryHookResult = ReturnType<typeof useCustomGetDailyFormVehiclesLazyQuery>;
export type CustomGetDailyFormVehiclesQueryResult = Apollo.QueryResult<CustomGetDailyFormVehiclesQuery, CustomGetDailyFormVehiclesQueryVariables>;
export const CustomGetDailyFormWorkOrderDocument = gql`
    query customGetDailyFormWorkOrder($id: ID!) {
  getDailyFormWorkOrder(id: $id) {
    id
    issueName
    issueDescription
    issueType
    priority
    status
    comments
    neededCompletionDate
    completedAt
    currentMeterReading
    estimatedTaskTime
    vehicle {
      id
      name
    }
    assignedTo {
      id
      name
    }
    servicePlan {
      id
      name
    }
    files {
      id
      name
      path
    }
  }
}
    `;

/**
 * __useCustomGetDailyFormWorkOrderQuery__
 *
 * To run a query within a React component, call `useCustomGetDailyFormWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetDailyFormWorkOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetDailyFormWorkOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetDailyFormWorkOrderQuery(baseOptions: Apollo.QueryHookOptions<CustomGetDailyFormWorkOrderQuery, CustomGetDailyFormWorkOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetDailyFormWorkOrderQuery, CustomGetDailyFormWorkOrderQueryVariables>(CustomGetDailyFormWorkOrderDocument, options);
      }
export function useCustomGetDailyFormWorkOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetDailyFormWorkOrderQuery, CustomGetDailyFormWorkOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetDailyFormWorkOrderQuery, CustomGetDailyFormWorkOrderQueryVariables>(CustomGetDailyFormWorkOrderDocument, options);
        }
export type CustomGetDailyFormWorkOrderQueryHookResult = ReturnType<typeof useCustomGetDailyFormWorkOrderQuery>;
export type CustomGetDailyFormWorkOrderLazyQueryHookResult = ReturnType<typeof useCustomGetDailyFormWorkOrderLazyQuery>;
export type CustomGetDailyFormWorkOrderQueryResult = Apollo.QueryResult<CustomGetDailyFormWorkOrderQuery, CustomGetDailyFormWorkOrderQueryVariables>;
export const CustomGetDailyFormWorkOrdersDocument = gql`
    query customGetDailyFormWorkOrders($assignedTo: ID, $first: Int!, $multipleAssignedTo: [ID!], $multiplePriorities: [DailyFormIssuePriority!], $multipleStatuses: [DailyFormIssueStatus!], $completedDate: Date, $neededCompletionDate: Date, $page: Int, $priority: DailyFormIssuePriority, $search: String, $sortDirection: SortDirection, $sortKey: QueryDailyFormWorkOrdersSortKey, $status: DailyFormIssueStatus, $vehicleId: ID) {
  getDailyFormWorkOrders(
    assignedTo: $assignedTo
    first: $first
    multipleAssignedTo: $multipleAssignedTo
    multiplePriorities: $multiplePriorities
    multipleStatuses: $multipleStatuses
    completedDate: $completedDate
    neededCompletionDate: $neededCompletionDate
    page: $page
    priority: $priority
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    status: $status
    vehicleId: $vehicleId
  ) {
    data {
      id
      issueName
      priority
      status
      neededCompletionDate
      completedAt
      currentMeterReading
      createdAt
      vehicle {
        id
        name
      }
      user {
        id
        name
      }
      assignedTo {
        id
        name
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetDailyFormWorkOrdersQuery__
 *
 * To run a query within a React component, call `useCustomGetDailyFormWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetDailyFormWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetDailyFormWorkOrdersQuery({
 *   variables: {
 *      assignedTo: // value for 'assignedTo'
 *      first: // value for 'first'
 *      multipleAssignedTo: // value for 'multipleAssignedTo'
 *      multiplePriorities: // value for 'multiplePriorities'
 *      multipleStatuses: // value for 'multipleStatuses'
 *      completedDate: // value for 'completedDate'
 *      neededCompletionDate: // value for 'neededCompletionDate'
 *      page: // value for 'page'
 *      priority: // value for 'priority'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      status: // value for 'status'
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useCustomGetDailyFormWorkOrdersQuery(baseOptions: Apollo.QueryHookOptions<CustomGetDailyFormWorkOrdersQuery, CustomGetDailyFormWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetDailyFormWorkOrdersQuery, CustomGetDailyFormWorkOrdersQueryVariables>(CustomGetDailyFormWorkOrdersDocument, options);
      }
export function useCustomGetDailyFormWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetDailyFormWorkOrdersQuery, CustomGetDailyFormWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetDailyFormWorkOrdersQuery, CustomGetDailyFormWorkOrdersQueryVariables>(CustomGetDailyFormWorkOrdersDocument, options);
        }
export type CustomGetDailyFormWorkOrdersQueryHookResult = ReturnType<typeof useCustomGetDailyFormWorkOrdersQuery>;
export type CustomGetDailyFormWorkOrdersLazyQueryHookResult = ReturnType<typeof useCustomGetDailyFormWorkOrdersLazyQuery>;
export type CustomGetDailyFormWorkOrdersQueryResult = Apollo.QueryResult<CustomGetDailyFormWorkOrdersQuery, CustomGetDailyFormWorkOrdersQueryVariables>;
export const CustomGetDailyFormInspectionDocument = gql`
    query customGetDailyFormInspection($id: ID!) {
  getDailyFormInspection(id: $id) {
    createdAt
    dailyFormVehicle {
      dailyFormVehicleType {
        id
        name
      }
      id
      name
    }
    id
    lightsWork
    loadStrapped
    oilChecked
    questionAnswers {
      question {
        id
        question
        type
      }
      isTrue
      answer
    }
    tiresAiredBrakesWorking
    toolsLoaded
    vehicleConditionAcceptable
    vehicleFueled
    vehicleMilleage
  }
}
    `;

/**
 * __useCustomGetDailyFormInspectionQuery__
 *
 * To run a query within a React component, call `useCustomGetDailyFormInspectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetDailyFormInspectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetDailyFormInspectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetDailyFormInspectionQuery(baseOptions: Apollo.QueryHookOptions<CustomGetDailyFormInspectionQuery, CustomGetDailyFormInspectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetDailyFormInspectionQuery, CustomGetDailyFormInspectionQueryVariables>(CustomGetDailyFormInspectionDocument, options);
      }
export function useCustomGetDailyFormInspectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetDailyFormInspectionQuery, CustomGetDailyFormInspectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetDailyFormInspectionQuery, CustomGetDailyFormInspectionQueryVariables>(CustomGetDailyFormInspectionDocument, options);
        }
export type CustomGetDailyFormInspectionQueryHookResult = ReturnType<typeof useCustomGetDailyFormInspectionQuery>;
export type CustomGetDailyFormInspectionLazyQueryHookResult = ReturnType<typeof useCustomGetDailyFormInspectionLazyQuery>;
export type CustomGetDailyFormInspectionQueryResult = Apollo.QueryResult<CustomGetDailyFormInspectionQuery, CustomGetDailyFormInspectionQueryVariables>;
export const CustomGetDailyFormInspectionsDocument = gql`
    query customGetDailyFormInspections($dailyFormVehicleId: ID, $dateSubmitted: DateTime, $first: Int!, $page: Int, $sortDirection: SortDirection, $sortKey: QueryDailyFormInspectionsSortKey) {
  getDailyFormInspections(
    dailyFormVehicleId: $dailyFormVehicleId
    dateSubmitted: $dateSubmitted
    first: $first
    page: $page
    sortDirection: $sortDirection
    sortKey: $sortKey
  ) {
    data {
      createdAt
      dailyFormVehicle {
        dailyFormVehicleType {
          id
          name
        }
        id
        name
      }
      user {
        id
        name
      }
      id
      lightsWork
      loadStrapped
      oilChecked
      tiresAiredBrakesWorking
      toolsLoaded
      vehicleConditionAcceptable
      vehicleFueled
      vehicleMilleage
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetDailyFormInspectionsQuery__
 *
 * To run a query within a React component, call `useCustomGetDailyFormInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetDailyFormInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetDailyFormInspectionsQuery({
 *   variables: {
 *      dailyFormVehicleId: // value for 'dailyFormVehicleId'
 *      dateSubmitted: // value for 'dateSubmitted'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useCustomGetDailyFormInspectionsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetDailyFormInspectionsQuery, CustomGetDailyFormInspectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetDailyFormInspectionsQuery, CustomGetDailyFormInspectionsQueryVariables>(CustomGetDailyFormInspectionsDocument, options);
      }
export function useCustomGetDailyFormInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetDailyFormInspectionsQuery, CustomGetDailyFormInspectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetDailyFormInspectionsQuery, CustomGetDailyFormInspectionsQueryVariables>(CustomGetDailyFormInspectionsDocument, options);
        }
export type CustomGetDailyFormInspectionsQueryHookResult = ReturnType<typeof useCustomGetDailyFormInspectionsQuery>;
export type CustomGetDailyFormInspectionsLazyQueryHookResult = ReturnType<typeof useCustomGetDailyFormInspectionsLazyQuery>;
export type CustomGetDailyFormInspectionsQueryResult = Apollo.QueryResult<CustomGetDailyFormInspectionsQuery, CustomGetDailyFormInspectionsQueryVariables>;
export const CustomGetDashboardMapDataDocument = gql`
    query customGetDashboardMapData {
  getDashboardMapData {
    id
    status
    jobPhases {
      id
      status
      startsAt
      productName
    }
    proposalStage {
      id
      name
    }
    address {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useCustomGetDashboardMapDataQuery__
 *
 * To run a query within a React component, call `useCustomGetDashboardMapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetDashboardMapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetDashboardMapDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomGetDashboardMapDataQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>(CustomGetDashboardMapDataDocument, options);
      }
export function useCustomGetDashboardMapDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>(CustomGetDashboardMapDataDocument, options);
        }
export type CustomGetDashboardMapDataQueryHookResult = ReturnType<typeof useCustomGetDashboardMapDataQuery>;
export type CustomGetDashboardMapDataLazyQueryHookResult = ReturnType<typeof useCustomGetDashboardMapDataLazyQuery>;
export type CustomGetDashboardMapDataQueryResult = Apollo.QueryResult<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>;
export const CustomGetInvoicesDocument = gql`
    query customGetInvoices($first: Int!, $page: Int, $search: String, $companyId: ID, $multipleCompanyIDs: [ID!], $status: InvoiceStatus, $jobStatuses: [JobStatus!], $isOverdue: Boolean, $sortDirection: SortDirection, $sortKey: GetInvoicesSortKey, $billingStatuses: [JobBillingStatus!]) {
  getInvoices(
    first: $first
    page: $page
    search: $search
    companyId: $companyId
    multipleCompanyIDs: $multipleCompanyIDs
    status: $status
    jobStatuses: $jobStatuses
    isOverdue: $isOverdue
    sortDirection: $sortDirection
    sortKey: $sortKey
    billingStatuses: $billingStatuses
  ) {
    data {
      id
      status
      isOverdue
      sentAt
      job {
        id
        status
        billingStatus
        proposalStage {
          id
          name
        }
        company {
          id
          name
        }
      }
    }
    paginatorInfo {
      count
      currentPage
      lastPage
      perPage
      total
      hasMorePages
    }
  }
}
    `;

/**
 * __useCustomGetInvoicesQuery__
 *
 * To run a query within a React component, call `useCustomGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetInvoicesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      companyId: // value for 'companyId'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      status: // value for 'status'
 *      jobStatuses: // value for 'jobStatuses'
 *      isOverdue: // value for 'isOverdue'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      billingStatuses: // value for 'billingStatuses'
 *   },
 * });
 */
export function useCustomGetInvoicesQuery(baseOptions: Apollo.QueryHookOptions<CustomGetInvoicesQuery, CustomGetInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetInvoicesQuery, CustomGetInvoicesQueryVariables>(CustomGetInvoicesDocument, options);
      }
export function useCustomGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetInvoicesQuery, CustomGetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetInvoicesQuery, CustomGetInvoicesQueryVariables>(CustomGetInvoicesDocument, options);
        }
export type CustomGetInvoicesQueryHookResult = ReturnType<typeof useCustomGetInvoicesQuery>;
export type CustomGetInvoicesLazyQueryHookResult = ReturnType<typeof useCustomGetInvoicesLazyQuery>;
export type CustomGetInvoicesQueryResult = Apollo.QueryResult<CustomGetInvoicesQuery, CustomGetInvoicesQueryVariables>;
export const CustomGetJobDocument = gql`
    query customGetJob($id: ID!) {
  getJob(id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualCostTransferTruck
    actualProfitPercentage
    datePushedToQuickbooks
    billingStatus
    projectFilesFolderId
    proposalId
    userId
    invoiceId
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      organizationAddressId
      state
      zip
      mapImage
    }
    company {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      name
      notes
      phone
      website
    }
    contact {
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    endsAt
    id
    externalId
    jobPhases {
      ...JobPhaseFragment
    }
    checklistItems {
      id
      jobPhaseId
      isCompleted
      checklistItemId
    }
    proposalStage {
      id
      name
    }
    proposal {
      id
      isChangeOrder
      status
      costTaxes
      overallTotalAfterTaxes
      salesTaxes {
        id
        percentage
      }
    }
    changeOrders {
      id
      changeOrderJobId
      externalId
      status
      overallTotalAfterTaxes
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedCostTransferTruck
    proposedProfitPercentage
    startsAt
    shouldPushTaxesToQuickbooks
    mayShowTaxNotification
    status
    notes
  }
}
    ${JobPhaseFragmentFragmentDoc}`;

/**
 * __useCustomGetJobQuery__
 *
 * To run a query within a React component, call `useCustomGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetJobQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobQuery, CustomGetJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobQuery, CustomGetJobQueryVariables>(CustomGetJobDocument, options);
      }
export function useCustomGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobQuery, CustomGetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobQuery, CustomGetJobQueryVariables>(CustomGetJobDocument, options);
        }
export type CustomGetJobQueryHookResult = ReturnType<typeof useCustomGetJobQuery>;
export type CustomGetJobLazyQueryHookResult = ReturnType<typeof useCustomGetJobLazyQuery>;
export type CustomGetJobQueryResult = Apollo.QueryResult<CustomGetJobQuery, CustomGetJobQueryVariables>;
export const CustomGetJobCostingLapsedReportDocument = gql`
    query customGetJobCostingLapsedReport($first: Int!, $page: Int, $statuses: [JobStatus!], $jobsWithoutCosts: Boolean, $jobsInPast: Boolean, $sortDirection: SortDirection, $sortKey: GetJobCostingLapsedReportSortKey) {
  getJobCostingLapsedReport(
    first: $first
    page: $page
    statuses: $statuses
    jobsWithoutCosts: $jobsWithoutCosts
    jobsInPast: $jobsInPast
    sortDirection: $sortDirection
    sortKey: $sortKey
  ) {
    data {
      id
      externalId
      jobName
      clientName
      status
      endsAt
      phaseMissingCost
      allPhasesMissingCost
      proposedOverallTotal
      actualOverallTotal
      varianceAmount
      variancePercent
      phases {
        id
        externalId
        jobId
        productType
        status
        endsAt
        missingCost
        proposedOverallTotal
        actualOverallTotal
        varianceAmount
        variancePercent
      }
    }
    paginatorInfo {
      currentPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobCostingLapsedReportQuery__
 *
 * To run a query within a React component, call `useCustomGetJobCostingLapsedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobCostingLapsedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobCostingLapsedReportQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      statuses: // value for 'statuses'
 *      jobsWithoutCosts: // value for 'jobsWithoutCosts'
 *      jobsInPast: // value for 'jobsInPast'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useCustomGetJobCostingLapsedReportQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobCostingLapsedReportQuery, CustomGetJobCostingLapsedReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobCostingLapsedReportQuery, CustomGetJobCostingLapsedReportQueryVariables>(CustomGetJobCostingLapsedReportDocument, options);
      }
export function useCustomGetJobCostingLapsedReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobCostingLapsedReportQuery, CustomGetJobCostingLapsedReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobCostingLapsedReportQuery, CustomGetJobCostingLapsedReportQueryVariables>(CustomGetJobCostingLapsedReportDocument, options);
        }
export type CustomGetJobCostingLapsedReportQueryHookResult = ReturnType<typeof useCustomGetJobCostingLapsedReportQuery>;
export type CustomGetJobCostingLapsedReportLazyQueryHookResult = ReturnType<typeof useCustomGetJobCostingLapsedReportLazyQuery>;
export type CustomGetJobCostingLapsedReportQueryResult = Apollo.QueryResult<CustomGetJobCostingLapsedReportQuery, CustomGetJobCostingLapsedReportQueryVariables>;
export const CustomGetJobDepositStatusDocument = gql`
    query customGetJobDepositStatus($id: ID!) {
  getJob(id: $id) {
    id
    billingStatus
    depositCollectedAt
  }
}
    `;

/**
 * __useCustomGetJobDepositStatusQuery__
 *
 * To run a query within a React component, call `useCustomGetJobDepositStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobDepositStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobDepositStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetJobDepositStatusQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobDepositStatusQuery, CustomGetJobDepositStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobDepositStatusQuery, CustomGetJobDepositStatusQueryVariables>(CustomGetJobDepositStatusDocument, options);
      }
export function useCustomGetJobDepositStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobDepositStatusQuery, CustomGetJobDepositStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobDepositStatusQuery, CustomGetJobDepositStatusQueryVariables>(CustomGetJobDepositStatusDocument, options);
        }
export type CustomGetJobDepositStatusQueryHookResult = ReturnType<typeof useCustomGetJobDepositStatusQuery>;
export type CustomGetJobDepositStatusLazyQueryHookResult = ReturnType<typeof useCustomGetJobDepositStatusLazyQuery>;
export type CustomGetJobDepositStatusQueryResult = Apollo.QueryResult<CustomGetJobDepositStatusQuery, CustomGetJobDepositStatusQueryVariables>;
export const CustomGetJobPhaseDocument = gql`
    query customGetJobPhase($id: ID!) {
  getJobPhase(id: $id) {
    ...JobPhaseFragment
  }
}
    ${JobPhaseFragmentFragmentDoc}`;

/**
 * __useCustomGetJobPhaseQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetJobPhaseQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>(CustomGetJobPhaseDocument, options);
      }
export function useCustomGetJobPhaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>(CustomGetJobPhaseDocument, options);
        }
export type CustomGetJobPhaseQueryHookResult = ReturnType<typeof useCustomGetJobPhaseQuery>;
export type CustomGetJobPhaseLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhaseLazyQuery>;
export type CustomGetJobPhaseQueryResult = Apollo.QueryResult<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>;
export const CustomGetJobPhaseCostItemDocument = gql`
    query customGetJobPhaseCostItem($date: Date!, $jobPhaseId: ID!) {
  getJobPhaseCostItem(date: $date, jobPhaseId: $jobPhaseId) {
    additionalCosts {
      additionalCostId
      costTotal
      cost
      feeAmount
      feeType
      id
      jobPhaseCostItem {
        user {
          name
        }
        date
        costMaterial
        costEquipment
        costLabour
        costAdditional
        costTransferTruck
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          isSubcontractorCost
          name
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultEmployees {
            firstName
            id
            lastName
            name
            rate
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            id
            inviteToken
            invitedAt
            lastName
            name
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            endsAt
            id
            notes
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            userId
          }
          jobDuration
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            subscribed
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            grossMargin
            grossMarginPercentage
            id
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            profit
            profitPercentage
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            grossMargin
            grossMarginPercentage
            id
            jobDuration
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            overallTotal
            productName
            profit
            profitPercentage
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            crews {
              cost
            }
          }
          proposalStage {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            profit
            profitPercentage
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
        }
        date
      }
      name
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      crewId
      endsAt
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      proposalProduct {
        costEquipment
        costMaterial
        costTransferTruck
        costLabour
        costAdditional
        costTotal
        crews {
          cost
        }
      }
    }
    material {
      costMaterial
      id
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    plants {
      id
      quantity
      rate
      costTotal
      plantId
      plantProductId
    }
    materialsNoPlants {
      id
      name
      quantity
      rate
      costTotal
      jobPhaseCostItemId
    }
    transferTrucks {
      hours
      id
      name
      transferTruckId
      plantTransferTruckId
      rateHourly
      rateTon
      tonnage
    }
  }
}
    `;

/**
 * __useCustomGetJobPhaseCostItemQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhaseCostItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhaseCostItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhaseCostItemQuery({
 *   variables: {
 *      date: // value for 'date'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useCustomGetJobPhaseCostItemQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>(CustomGetJobPhaseCostItemDocument, options);
      }
export function useCustomGetJobPhaseCostItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>(CustomGetJobPhaseCostItemDocument, options);
        }
export type CustomGetJobPhaseCostItemQueryHookResult = ReturnType<typeof useCustomGetJobPhaseCostItemQuery>;
export type CustomGetJobPhaseCostItemLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhaseCostItemLazyQuery>;
export type CustomGetJobPhaseCostItemQueryResult = Apollo.QueryResult<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>;
export const CustomGetJobPhaseForDropdownLazyDocument = gql`
    query CustomGetJobPhaseForDropdownLazy($id: ID!) {
  getJobPhase(id: $id) {
    id
    organizationProductTypeName
    address
    startsAt
    endsAt
    proposalStage {
      id
      name
    }
  }
}
    `;

/**
 * __useCustomGetJobPhaseForDropdownLazyQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhaseForDropdownLazyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhaseForDropdownLazyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhaseForDropdownLazyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetJobPhaseForDropdownLazyQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>(CustomGetJobPhaseForDropdownLazyDocument, options);
      }
export function useCustomGetJobPhaseForDropdownLazyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>(CustomGetJobPhaseForDropdownLazyDocument, options);
        }
export type CustomGetJobPhaseForDropdownLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhaseForDropdownLazyQuery>;
export type CustomGetJobPhaseForDropdownLazyLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhaseForDropdownLazyLazyQuery>;
export type CustomGetJobPhaseForDropdownLazyQueryResult = Apollo.QueryResult<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>;
export const CustomGetJobPhasesDocument = gql`
    query customGetJobPhases($search: String, $searchByName: Boolean, $companyId: ID, $userId: ID, $foremanUserId: ID, $organizationProductTypeId: ID, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $first: Int!, $page: Int, $crewId: ID, $date: DateTime, $billingStatuses: [JobBillingStatus!]) {
  getJobPhases(
    search: $search
    searchByName: $searchByName
    companyId: $companyId
    userId: $userId
    foremanUserId: $foremanUserId
    organizationProductTypeId: $organizationProductTypeId
    sortDirection: $sortDirection
    sortKey: $sortKey
    first: $first
    page: $page
    crewId: $crewId
    date: $date
    billingStatuses: $billingStatuses
  ) {
    data {
      id
      externalId
      address
      hasJobCostsEntered
      jobCostingCompletionStatus
      jobCostingVariancePercent
      jobCostingThresholdPercent
      jobCostEntryDaysCount
      lastJobCostEntryDate
      missingCostCategories
      proposedCostTotal
      actualCostTotal
      proposalStage {
        name
        distanceSeconds
      }
      productName
      foremanUser {
        name
      }
      organization {
        name
      }
      jobSize
      travelTimeEstimate
      proposedMaterialNeeded
      organizationProductTypeName
      defaultAdditionalCosts {
        name
        id
      }
      defaultEquipmentPieces {
        name
        id
      }
      crew {
        name
        displayName
      }
      startsAt
      jobDuration
      job {
        id
        externalId
        company {
          name
        }
        contact {
          firstName
          lastName
          phone
        }
        address {
          line1
        }
        billingStatus
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobPhasesQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhasesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      searchByName: // value for 'searchByName'
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      foremanUserId: // value for 'foremanUserId'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      crewId: // value for 'crewId'
 *      date: // value for 'date'
 *      billingStatuses: // value for 'billingStatuses'
 *   },
 * });
 */
export function useCustomGetJobPhasesQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>(CustomGetJobPhasesDocument, options);
      }
export function useCustomGetJobPhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>(CustomGetJobPhasesDocument, options);
        }
export type CustomGetJobPhasesQueryHookResult = ReturnType<typeof useCustomGetJobPhasesQuery>;
export type CustomGetJobPhasesLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhasesLazyQuery>;
export type CustomGetJobPhasesQueryResult = Apollo.QueryResult<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>;
export const CustomGetJobPhasesForDropdownDocument = gql`
    query customGetJobPhasesForDropdown($search: String, $searchByName: Boolean, $companyId: ID, $userId: ID, $foremanUserId: ID, $organizationProductTypeId: ID, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $first: Int!, $page: Int, $crewId: ID, $date: DateTime, $billingStatuses: [JobBillingStatus!]) {
  getJobPhases(
    search: $search
    searchByName: $searchByName
    companyId: $companyId
    userId: $userId
    foremanUserId: $foremanUserId
    organizationProductTypeId: $organizationProductTypeId
    sortDirection: $sortDirection
    sortKey: $sortKey
    first: $first
    page: $page
    crewId: $crewId
    date: $date
    billingStatuses: $billingStatuses
  ) {
    data {
      id
      externalId
      address
      proposalStage {
        id
        name
        distanceSeconds
      }
      job {
        id
        company {
          id
          name
        }
      }
      productName
      organizationProductTypeName
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobPhasesForDropdownQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhasesForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhasesForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhasesForDropdownQuery({
 *   variables: {
 *      search: // value for 'search'
 *      searchByName: // value for 'searchByName'
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      foremanUserId: // value for 'foremanUserId'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      crewId: // value for 'crewId'
 *      date: // value for 'date'
 *      billingStatuses: // value for 'billingStatuses'
 *   },
 * });
 */
export function useCustomGetJobPhasesForDropdownQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>(CustomGetJobPhasesForDropdownDocument, options);
      }
export function useCustomGetJobPhasesForDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>(CustomGetJobPhasesForDropdownDocument, options);
        }
export type CustomGetJobPhasesForDropdownQueryHookResult = ReturnType<typeof useCustomGetJobPhasesForDropdownQuery>;
export type CustomGetJobPhasesForDropdownLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhasesForDropdownLazyQuery>;
export type CustomGetJobPhasesForDropdownQueryResult = Apollo.QueryResult<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>;
export const CustomGetJobPhasesScheduleBlocksDocument = gql`
    query customGetJobPhasesScheduleBlocks($search: String, $companyId: ID, $userId: ID, $foremanUserId: ID, $organizationProductTypeId: ID, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $first: Int!, $page: Int, $crewId: ID, $date: DateTime!) {
  getJobPhases(
    search: $search
    companyId: $companyId
    userId: $userId
    foremanUserId: $foremanUserId
    organizationProductTypeId: $organizationProductTypeId
    sortDirection: $sortDirection
    sortKey: $sortKey
    first: $first
    page: $page
    crewId: $crewId
    date: $date
  ) {
    data {
      id
      externalId
      hasJobCostsEntered
      jobCostingCompletionStatus
      jobCostingVariancePercent
      jobCostingThresholdPercent
      jobCostEntryDaysCount
      lastJobCostEntryDate
      missingCostCategories
      proposedCostTotal
      actualCostTotal
      proposalStage {
        name
        distanceSeconds
      }
      productName
      foremanUser {
        name
      }
      organization {
        name
      }
      jobSize
      travelTimeEstimate
      proposedMaterialNeeded
      organizationProductTypeName
      defaultEquipmentPieces {
        name
        id
      }
      crew {
        name
        displayName
      }
      startsAt
      jobDuration
      job {
        id
        externalId
        billingStatus
        company {
          name
        }
        contact {
          firstName
          lastName
          phone
        }
        address {
          line1
        }
      }
      scheduledBlockForDate {
        scheduledAt
        blockLength
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobPhasesScheduleBlocksQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhasesScheduleBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhasesScheduleBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhasesScheduleBlocksQuery({
 *   variables: {
 *      search: // value for 'search'
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      foremanUserId: // value for 'foremanUserId'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      crewId: // value for 'crewId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCustomGetJobPhasesScheduleBlocksQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>(CustomGetJobPhasesScheduleBlocksDocument, options);
      }
export function useCustomGetJobPhasesScheduleBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>(CustomGetJobPhasesScheduleBlocksDocument, options);
        }
export type CustomGetJobPhasesScheduleBlocksQueryHookResult = ReturnType<typeof useCustomGetJobPhasesScheduleBlocksQuery>;
export type CustomGetJobPhasesScheduleBlocksLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhasesScheduleBlocksLazyQuery>;
export type CustomGetJobPhasesScheduleBlocksQueryResult = Apollo.QueryResult<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>;
export const CustomGetJobSchedulesDocument = gql`
    query customGetJobSchedules($crewId: ID, $dateFrom: DateTime, $dateUntil: DateTime, $jobIds: [ID!], $jobPhaseId: ID) {
  getJobSchedules(
    crewId: $crewId
    dateFrom: $dateFrom
    dateUntil: $dateUntil
    jobIds: $jobIds
    jobPhaseId: $jobPhaseId
  ) {
    blockLength
    crew {
      color
      displayName
      id
      name
      rate
    }
    endsAt
    id
    job {
      id
      datePushedToQuickbooks
      status
      userId
      company {
        name
      }
    }
    jobPhase {
      id
      productName
      status
      checklistCompletion {
        ratio
        allCompleted
      }
      proposalProduct {
        material {
          id
          name
          productId
        }
      }
      organizationProductType {
        name
      }
      proposalStage {
        name
      }
      foremanUser {
        name
      }
      usersColor
    }
    scheduledAt
    showTravelFrom
    showTravelTo
    travelTime
  }
}
    `;

/**
 * __useCustomGetJobSchedulesQuery__
 *
 * To run a query within a React component, call `useCustomGetJobSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobSchedulesQuery({
 *   variables: {
 *      crewId: // value for 'crewId'
 *      dateFrom: // value for 'dateFrom'
 *      dateUntil: // value for 'dateUntil'
 *      jobIds: // value for 'jobIds'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useCustomGetJobSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>(CustomGetJobSchedulesDocument, options);
      }
export function useCustomGetJobSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>(CustomGetJobSchedulesDocument, options);
        }
export type CustomGetJobSchedulesQueryHookResult = ReturnType<typeof useCustomGetJobSchedulesQuery>;
export type CustomGetJobSchedulesLazyQueryHookResult = ReturnType<typeof useCustomGetJobSchedulesLazyQuery>;
export type CustomGetJobSchedulesQueryResult = Apollo.QueryResult<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>;
export const CustomGetJobsDocument = gql`
    query customGetJobs($companyId: ID, $multipleCompanyIDs: [ID!], $first: Int!, $jobIds: [ID!], $organizationProductTypeIds: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $statuses: [JobStatus!], $userId: ID, $billingStatuses: [JobBillingStatus!], $cities: [String!]) {
  getJobs(
    companyId: $companyId
    multipleCompanyIDs: $multipleCompanyIDs
    first: $first
    jobIds: $jobIds
    organizationProductTypeIds: $organizationProductTypeIds
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
    billingStatuses: $billingStatuses
    cities: $cities
  ) {
    data {
      jobPhases {
        id
        externalId
        applicableStatuses
        endsAt
        ordering
        productName
        startsAt
        status
        organizationProductTypeName
        proposalProductGroup {
          id
          name
          ordering
        }
        organizationProductType {
          id
          name
        }
        jobDuration
        foremanUser {
          id
          name
          firstName
          lastName
        }
        proposedOverallTotal
        actualOverallTotal
        scheduleBlocks {
          id
          scheduledAt
          endsAt
          blockLength
          showTravelTo
          showTravelFrom
          travelTime
        }
      }
      user {
        id
        firstName
        lastName
        name
      }
      actualOverallTotal
      foremanUser {
        id
        name
        firstName
        lastName
      }
      address {
        id
        line1
        city
        state
        latitude
        longitude
      }
      company {
        id
        name
      }
      contact {
        firstName
        id
        lastName
        phone
      }
      endsAt
      foremanUser {
        firstName
        id
        lastName
      }
      id
      externalId
      proposedOverallTotal
      startsAt
      endsAt
      status
      billingStatus
      proposal {
        wonAt
      }
      proposalStage {
        id
        name
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobsQuery__
 *
 * To run a query within a React component, call `useCustomGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      first: // value for 'first'
 *      jobIds: // value for 'jobIds'
 *      organizationProductTypeIds: // value for 'organizationProductTypeIds'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *      billingStatuses: // value for 'billingStatuses'
 *      cities: // value for 'cities'
 *   },
 * });
 */
export function useCustomGetJobsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobsQuery, CustomGetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobsQuery, CustomGetJobsQueryVariables>(CustomGetJobsDocument, options);
      }
export function useCustomGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobsQuery, CustomGetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobsQuery, CustomGetJobsQueryVariables>(CustomGetJobsDocument, options);
        }
export type CustomGetJobsQueryHookResult = ReturnType<typeof useCustomGetJobsQuery>;
export type CustomGetJobsLazyQueryHookResult = ReturnType<typeof useCustomGetJobsLazyQuery>;
export type CustomGetJobsQueryResult = Apollo.QueryResult<CustomGetJobsQuery, CustomGetJobsQueryVariables>;
export const CustomGetJobsForDropdownDocument = gql`
    query customGetJobsForDropdown($billingStatuses: [JobBillingStatus!], $companyId: ID, $companyName: String, $first: Int!, $jobIds: [ID!], $jobName: String, $multipleCompanyIDs: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $statuses: [JobStatus!], $userId: ID) {
  getJobsSimple(
    billingStatuses: $billingStatuses
    companyId: $companyId
    companyName: $companyName
    first: $first
    jobIds: $jobIds
    jobName: $jobName
    multipleCompanyIDs: $multipleCompanyIDs
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
  ) {
    data {
      id
      externalId
      company {
        id
        name
      }
      proposalStage {
        id
        name
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobsForDropdownQuery__
 *
 * To run a query within a React component, call `useCustomGetJobsForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobsForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobsForDropdownQuery({
 *   variables: {
 *      billingStatuses: // value for 'billingStatuses'
 *      companyId: // value for 'companyId'
 *      companyName: // value for 'companyName'
 *      first: // value for 'first'
 *      jobIds: // value for 'jobIds'
 *      jobName: // value for 'jobName'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCustomGetJobsForDropdownQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobsForDropdownQuery, CustomGetJobsForDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobsForDropdownQuery, CustomGetJobsForDropdownQueryVariables>(CustomGetJobsForDropdownDocument, options);
      }
export function useCustomGetJobsForDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobsForDropdownQuery, CustomGetJobsForDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobsForDropdownQuery, CustomGetJobsForDropdownQueryVariables>(CustomGetJobsForDropdownDocument, options);
        }
export type CustomGetJobsForDropdownQueryHookResult = ReturnType<typeof useCustomGetJobsForDropdownQuery>;
export type CustomGetJobsForDropdownLazyQueryHookResult = ReturnType<typeof useCustomGetJobsForDropdownLazyQuery>;
export type CustomGetJobsForDropdownQueryResult = Apollo.QueryResult<CustomGetJobsForDropdownQuery, CustomGetJobsForDropdownQueryVariables>;
export const CustomGetMyTasksDocument = gql`
    query CustomGetMyTasks($first: Int!, $page: Int, $status: String, $userId: ID, $all: Boolean) {
  getMyTasks(
    first: $first
    page: $page
    status: $status
    userId: $userId
    all: $all
  ) {
    data {
      id
      content
      status
      dueAt
      createdAt
      updatedAt
      completedAt
      triggerType
      triggerEvent
      notifiableType
      notifiableId
      notifiableExternalId
      assignedUser {
        id
        name
        firstName
        lastName
        email
        permissions
      }
      company {
        id
        name
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetMyTasksQuery__
 *
 * To run a query within a React component, call `useCustomGetMyTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetMyTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetMyTasksQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      status: // value for 'status'
 *      userId: // value for 'userId'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useCustomGetMyTasksQuery(baseOptions: Apollo.QueryHookOptions<CustomGetMyTasksQuery, CustomGetMyTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetMyTasksQuery, CustomGetMyTasksQueryVariables>(CustomGetMyTasksDocument, options);
      }
export function useCustomGetMyTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetMyTasksQuery, CustomGetMyTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetMyTasksQuery, CustomGetMyTasksQueryVariables>(CustomGetMyTasksDocument, options);
        }
export type CustomGetMyTasksQueryHookResult = ReturnType<typeof useCustomGetMyTasksQuery>;
export type CustomGetMyTasksLazyQueryHookResult = ReturnType<typeof useCustomGetMyTasksLazyQuery>;
export type CustomGetMyTasksQueryResult = Apollo.QueryResult<CustomGetMyTasksQuery, CustomGetMyTasksQueryVariables>;
export const CustomGetNotificationTriggerDocument = gql`
    query CustomGetNotificationTrigger($id: ID!) {
  getNotificationTrigger(id: $id) {
    ...NotificationTriggerFragment
  }
}
    ${NotificationTriggerFragmentFragmentDoc}`;

/**
 * __useCustomGetNotificationTriggerQuery__
 *
 * To run a query within a React component, call `useCustomGetNotificationTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetNotificationTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetNotificationTriggerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetNotificationTriggerQuery(baseOptions: Apollo.QueryHookOptions<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>(CustomGetNotificationTriggerDocument, options);
      }
export function useCustomGetNotificationTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>(CustomGetNotificationTriggerDocument, options);
        }
export type CustomGetNotificationTriggerQueryHookResult = ReturnType<typeof useCustomGetNotificationTriggerQuery>;
export type CustomGetNotificationTriggerLazyQueryHookResult = ReturnType<typeof useCustomGetNotificationTriggerLazyQuery>;
export type CustomGetNotificationTriggerQueryResult = Apollo.QueryResult<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>;
export const CustomGetNotificationTriggersDocument = gql`
    query CustomGetNotificationTriggers {
  getNotificationTriggers {
    ...NotificationTriggerFragment
  }
}
    ${NotificationTriggerFragmentFragmentDoc}`;

/**
 * __useCustomGetNotificationTriggersQuery__
 *
 * To run a query within a React component, call `useCustomGetNotificationTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetNotificationTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetNotificationTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomGetNotificationTriggersQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>(CustomGetNotificationTriggersDocument, options);
      }
export function useCustomGetNotificationTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>(CustomGetNotificationTriggersDocument, options);
        }
export type CustomGetNotificationTriggersQueryHookResult = ReturnType<typeof useCustomGetNotificationTriggersQuery>;
export type CustomGetNotificationTriggersLazyQueryHookResult = ReturnType<typeof useCustomGetNotificationTriggersLazyQuery>;
export type CustomGetNotificationTriggersQueryResult = Apollo.QueryResult<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>;
export const CustomGetOpportunitiesDocument = gql`
    query customGetOpportunities($companyId: ID, $contactName: String, $dueAt: Date, $first: Int!, $multipleCompanyIDs: [ID!], $multipleUserIDs: [ID!], $page: Int, $search: String, $sort: SortDirection, $sortKey: GetOpportunitiesSortKey, $statuses: [String!], $userId: ID) {
  getOpportunities(
    companyId: $companyId
    contactName: $contactName
    dueAt: $dueAt
    first: $first
    multipleCompanyIDs: $multipleCompanyIDs
    multipleUserIDs: $multipleUserIDs
    page: $page
    search: $search
    sort: $sort
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
  ) {
    data {
      addressCity
      addressZip
      company {
        id
        name
      }
      companyId
      contact {
        firstName
        id
        lastName
        phone
      }
      contactId
      createdAt
      dueAt
      estimatedOpportunityValue
      externalId
      id
      name
      notes
      source
      status
      statusId
      updatedAt
      user {
        firstName
        id
        lastName
        name
      }
      userId
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetOpportunitiesQuery__
 *
 * To run a query within a React component, call `useCustomGetOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetOpportunitiesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      contactName: // value for 'contactName'
 *      dueAt: // value for 'dueAt'
 *      first: // value for 'first'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      multipleUserIDs: // value for 'multipleUserIDs'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCustomGetOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<CustomGetOpportunitiesQuery, CustomGetOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetOpportunitiesQuery, CustomGetOpportunitiesQueryVariables>(CustomGetOpportunitiesDocument, options);
      }
export function useCustomGetOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetOpportunitiesQuery, CustomGetOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetOpportunitiesQuery, CustomGetOpportunitiesQueryVariables>(CustomGetOpportunitiesDocument, options);
        }
export type CustomGetOpportunitiesQueryHookResult = ReturnType<typeof useCustomGetOpportunitiesQuery>;
export type CustomGetOpportunitiesLazyQueryHookResult = ReturnType<typeof useCustomGetOpportunitiesLazyQuery>;
export type CustomGetOpportunitiesQueryResult = Apollo.QueryResult<CustomGetOpportunitiesQuery, CustomGetOpportunitiesQueryVariables>;
export const CustomGetOpportunityDocument = gql`
    query customGetOpportunity($id: ID!) {
  getOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    companyId
    estimatedOpportunityValue
    projectFilesFolderId
    company {
      id
      name
      contacts {
        firstName
        id
        lastName
      }
    }
    contactId
    dueAt
    id
    externalId
    name
    notes
    products {
      id
    }
    source
    status
    statusId
    userId
  }
}
    `;

/**
 * __useCustomGetOpportunityQuery__
 *
 * To run a query within a React component, call `useCustomGetOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetOpportunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetOpportunityQuery(baseOptions: Apollo.QueryHookOptions<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>(CustomGetOpportunityDocument, options);
      }
export function useCustomGetOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>(CustomGetOpportunityDocument, options);
        }
export type CustomGetOpportunityQueryHookResult = ReturnType<typeof useCustomGetOpportunityQuery>;
export type CustomGetOpportunityLazyQueryHookResult = ReturnType<typeof useCustomGetOpportunityLazyQuery>;
export type CustomGetOpportunityQueryResult = Apollo.QueryResult<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>;
export const CustomGetOrganizationEmailTemplateDocument = gql`
    query customGetOrganizationEmailTemplate($type: OrganizationEmailTemplateType!) {
  getOrganizationEmailTemplate(type: $type) {
    ...BitumioOrganizationEmailTemplate
  }
}
    ${BitumioOrganizationEmailTemplateFragmentDoc}`;

/**
 * __useCustomGetOrganizationEmailTemplateQuery__
 *
 * To run a query within a React component, call `useCustomGetOrganizationEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetOrganizationEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetOrganizationEmailTemplateQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCustomGetOrganizationEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>(CustomGetOrganizationEmailTemplateDocument, options);
      }
export function useCustomGetOrganizationEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>(CustomGetOrganizationEmailTemplateDocument, options);
        }
export type CustomGetOrganizationEmailTemplateQueryHookResult = ReturnType<typeof useCustomGetOrganizationEmailTemplateQuery>;
export type CustomGetOrganizationEmailTemplateLazyQueryHookResult = ReturnType<typeof useCustomGetOrganizationEmailTemplateLazyQuery>;
export type CustomGetOrganizationEmailTemplateQueryResult = Apollo.QueryResult<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>;
export const CustomGetOrganizationEmailTemplatesDocument = gql`
    query customGetOrganizationEmailTemplates {
  getOrganizationEmailTemplates {
    ...BitumioOrganizationEmailTemplate
  }
}
    ${BitumioOrganizationEmailTemplateFragmentDoc}`;

/**
 * __useCustomGetOrganizationEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useCustomGetOrganizationEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetOrganizationEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetOrganizationEmailTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomGetOrganizationEmailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>(CustomGetOrganizationEmailTemplatesDocument, options);
      }
export function useCustomGetOrganizationEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>(CustomGetOrganizationEmailTemplatesDocument, options);
        }
export type CustomGetOrganizationEmailTemplatesQueryHookResult = ReturnType<typeof useCustomGetOrganizationEmailTemplatesQuery>;
export type CustomGetOrganizationEmailTemplatesLazyQueryHookResult = ReturnType<typeof useCustomGetOrganizationEmailTemplatesLazyQuery>;
export type CustomGetOrganizationEmailTemplatesQueryResult = Apollo.QueryResult<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>;
export const CustomGetOrganizationUsersDocument = gql`
    query customGetOrganizationUsers($archived: Boolean, $first: Int!, $page: Int, $roles: [UserRole], $search: String, $status: UserStatus) {
  getOrganizationUsers(
    archived: $archived
    first: $first
    page: $page
    roles: $roles
    search: $search
    status: $status
  ) {
    data {
      id
      firstName
      lastName
      name
      email
      roles
      status
      hasEmployee
      archivedAt
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useCustomGetOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetOrganizationUsersQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      roles: // value for 'roles'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCustomGetOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<CustomGetOrganizationUsersQuery, CustomGetOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetOrganizationUsersQuery, CustomGetOrganizationUsersQueryVariables>(CustomGetOrganizationUsersDocument, options);
      }
export function useCustomGetOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetOrganizationUsersQuery, CustomGetOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetOrganizationUsersQuery, CustomGetOrganizationUsersQueryVariables>(CustomGetOrganizationUsersDocument, options);
        }
export type CustomGetOrganizationUsersQueryHookResult = ReturnType<typeof useCustomGetOrganizationUsersQuery>;
export type CustomGetOrganizationUsersLazyQueryHookResult = ReturnType<typeof useCustomGetOrganizationUsersLazyQuery>;
export type CustomGetOrganizationUsersQueryResult = Apollo.QueryResult<CustomGetOrganizationUsersQuery, CustomGetOrganizationUsersQueryVariables>;
export const CustomGetProductsDocument = gql`
    query customGetProducts($first: Int!, $orderBy: [QueryGetProductsOrderByOrderByClause!], $organizationProductTypeId: ID, $page: Int, $search: String, $type: ProductType) {
  getProducts(
    first: $first
    orderBy: $orderBy
    organizationProductTypeId: $organizationProductTypeId
    page: $page
    search: $search
    type: $type
  ) {
    data {
      dailyUnitsComplete
      id
      indirectPercentage
      labourCostType
      markupPercentage
      measurementJob
      measurementMaterial
      organizationProductType {
        name
      }
      name
      overheadPercentage
      statementOfWork
      type
      subcontracted
      unitPriceProduct
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetProductsQuery__
 *
 * To run a query within a React component, call `useCustomGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCustomGetProductsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetProductsQuery, CustomGetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetProductsQuery, CustomGetProductsQueryVariables>(CustomGetProductsDocument, options);
      }
export function useCustomGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetProductsQuery, CustomGetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetProductsQuery, CustomGetProductsQueryVariables>(CustomGetProductsDocument, options);
        }
export type CustomGetProductsQueryHookResult = ReturnType<typeof useCustomGetProductsQuery>;
export type CustomGetProductsLazyQueryHookResult = ReturnType<typeof useCustomGetProductsLazyQuery>;
export type CustomGetProductsQueryResult = Apollo.QueryResult<CustomGetProductsQuery, CustomGetProductsQueryVariables>;
export const CustomGetProjectMapDocument = gql`
    query customGetProjectMap($id: ID!) {
  getProjectMap(id: $id) {
    id
    name
    mapData
    addressLine1
    addressLine2
    addressCity
    addressState
    addressZip
    addressCountry
    latitude
    longitude
    measurements {
      id
      geojsonFeatureId
      featureGeojson
      label
      sortOrder
      measurementType
      measurementJob
      measurementValue
      productId
      isScreenshotTarget
      product {
        id
        name
        measurementJob
        dailyUnitsComplete
      }
    }
  }
}
    `;

/**
 * __useCustomGetProjectMapQuery__
 *
 * To run a query within a React component, call `useCustomGetProjectMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetProjectMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetProjectMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetProjectMapQuery(baseOptions: Apollo.QueryHookOptions<CustomGetProjectMapQuery, CustomGetProjectMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetProjectMapQuery, CustomGetProjectMapQueryVariables>(CustomGetProjectMapDocument, options);
      }
export function useCustomGetProjectMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetProjectMapQuery, CustomGetProjectMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetProjectMapQuery, CustomGetProjectMapQueryVariables>(CustomGetProjectMapDocument, options);
        }
export type CustomGetProjectMapQueryHookResult = ReturnType<typeof useCustomGetProjectMapQuery>;
export type CustomGetProjectMapLazyQueryHookResult = ReturnType<typeof useCustomGetProjectMapLazyQuery>;
export type CustomGetProjectMapQueryResult = Apollo.QueryResult<CustomGetProjectMapQuery, CustomGetProjectMapQueryVariables>;
export const CustomGetProjectMapsDocument = gql`
    query customGetProjectMaps($first: Int!, $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetProjectMapsSortKey) {
  getProjectMaps(
    first: $first
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
  ) {
    data {
      id
      name
      createdAt
      updatedAt
      createdBy {
        id
        firstName
        lastName
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetProjectMapsQuery__
 *
 * To run a query within a React component, call `useCustomGetProjectMapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetProjectMapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetProjectMapsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useCustomGetProjectMapsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetProjectMapsQuery, CustomGetProjectMapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetProjectMapsQuery, CustomGetProjectMapsQueryVariables>(CustomGetProjectMapsDocument, options);
      }
export function useCustomGetProjectMapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetProjectMapsQuery, CustomGetProjectMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetProjectMapsQuery, CustomGetProjectMapsQueryVariables>(CustomGetProjectMapsDocument, options);
        }
export type CustomGetProjectMapsQueryHookResult = ReturnType<typeof useCustomGetProjectMapsQuery>;
export type CustomGetProjectMapsLazyQueryHookResult = ReturnType<typeof useCustomGetProjectMapsLazyQuery>;
export type CustomGetProjectMapsQueryResult = Apollo.QueryResult<CustomGetProjectMapsQuery, CustomGetProjectMapsQueryVariables>;
export const CustomGetProposalDocument = gql`
    query customGetProposal($id: ID!) {
  getProposal(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;

/**
 * __useCustomGetProposalQuery__
 *
 * To run a query within a React component, call `useCustomGetProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetProposalQuery(baseOptions: Apollo.QueryHookOptions<CustomGetProposalQuery, CustomGetProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetProposalQuery, CustomGetProposalQueryVariables>(CustomGetProposalDocument, options);
      }
export function useCustomGetProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetProposalQuery, CustomGetProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetProposalQuery, CustomGetProposalQueryVariables>(CustomGetProposalDocument, options);
        }
export type CustomGetProposalQueryHookResult = ReturnType<typeof useCustomGetProposalQuery>;
export type CustomGetProposalLazyQueryHookResult = ReturnType<typeof useCustomGetProposalLazyQuery>;
export type CustomGetProposalQueryResult = Apollo.QueryResult<CustomGetProposalQuery, CustomGetProposalQueryVariables>;
export const CustomGetProposalPackageSummaryDocument = gql`
    query customGetProposalPackageSummary($id: ID!) {
  getProposal(id: $id) {
    id
    isPackageParent
    latestPackageSendRun {
      id
      status
      totalRecipients
      processedRecipients
      succeededRecipients
      failedRecipients
      recipients {
        id
        status
        proposalId
        errorMessage
        proposal {
          id
          externalIdWithPrefix
          status
        }
        company {
          id
          name
        }
        contact {
          id
          firstName
          lastName
        }
      }
    }
    packageChildren {
      id
      externalIdWithPrefix
      status
      sentAt
      signedAt
      company {
        id
        name
      }
      contact {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useCustomGetProposalPackageSummaryQuery__
 *
 * To run a query within a React component, call `useCustomGetProposalPackageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetProposalPackageSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetProposalPackageSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetProposalPackageSummaryQuery(baseOptions: Apollo.QueryHookOptions<CustomGetProposalPackageSummaryQuery, CustomGetProposalPackageSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetProposalPackageSummaryQuery, CustomGetProposalPackageSummaryQueryVariables>(CustomGetProposalPackageSummaryDocument, options);
      }
export function useCustomGetProposalPackageSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetProposalPackageSummaryQuery, CustomGetProposalPackageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetProposalPackageSummaryQuery, CustomGetProposalPackageSummaryQueryVariables>(CustomGetProposalPackageSummaryDocument, options);
        }
export type CustomGetProposalPackageSummaryQueryHookResult = ReturnType<typeof useCustomGetProposalPackageSummaryQuery>;
export type CustomGetProposalPackageSummaryLazyQueryHookResult = ReturnType<typeof useCustomGetProposalPackageSummaryLazyQuery>;
export type CustomGetProposalPackageSummaryQueryResult = Apollo.QueryResult<CustomGetProposalPackageSummaryQuery, CustomGetProposalPackageSummaryQueryVariables>;
export const CustomGetProposalsDocument = gql`
    query customGetProposals($companyId: ID, $multipleCompanyIDs: [ID!], $first: Int!, $organizationProductTypeIds: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetProposalsSortKey, $statuses: [ProposalStatus!], $userId: ID, $multipleUserIDs: [ID!]) {
  getProposals(
    companyId: $companyId
    multipleCompanyIDs: $multipleCompanyIDs
    first: $first
    organizationProductTypeIds: $organizationProductTypeIds
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
    multipleUserIDs: $multipleUserIDs
  ) {
    data {
      proposalRole
      latestPackageSendRun {
        status
        totalRecipients
        processedRecipients
      }
      company {
        email
        id
        name
      }
      contact {
        firstName
        id
        lastName
        phone
      }
      user {
        firstName
        id
        lastName
        name
      }
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        id
        name
        overallTotal
        proposalProducts {
          id
          productName
        }
      }
      id
      externalId
      externalIdWithPrefix
      status
      overallTotal
      userId
      uuid
      createdAt
      sentAt
      lastEvent {
        action
        createdAt
        id
      }
      lastStatusChange {
        changeAt
        status
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetProposalsQuery__
 *
 * To run a query within a React component, call `useCustomGetProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetProposalsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      first: // value for 'first'
 *      organizationProductTypeIds: // value for 'organizationProductTypeIds'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *      multipleUserIDs: // value for 'multipleUserIDs'
 *   },
 * });
 */
export function useCustomGetProposalsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>(CustomGetProposalsDocument, options);
      }
export function useCustomGetProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>(CustomGetProposalsDocument, options);
        }
export type CustomGetProposalsQueryHookResult = ReturnType<typeof useCustomGetProposalsQuery>;
export type CustomGetProposalsLazyQueryHookResult = ReturnType<typeof useCustomGetProposalsLazyQuery>;
export type CustomGetProposalsQueryResult = Apollo.QueryResult<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>;
export const CustomGetQuickbooksSyncJobsDocument = gql`
    query customGetQuickbooksSyncJobs($companyId: ID, $first: Int!, $jobIds: [ID!], $page: Int, $search: String) {
  getJobs(
    companyId: $companyId
    first: $first
    jobIds: $jobIds
    page: $page
    search: $search
  ) {
    data {
      id
      externalId
      proposedOverallTotal
      proposalStage {
        name
      }
      jobPhases {
        id
        productName
        proposedOverallTotal
        proposalProductGroup {
          id
          name
        }
        proposalProduct {
          productName
          statementOfWork
          material {
            name
            externalProductName
            statementOfWork
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCustomGetQuickbooksSyncJobsQuery__
 *
 * To run a query within a React component, call `useCustomGetQuickbooksSyncJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetQuickbooksSyncJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetQuickbooksSyncJobsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      jobIds: // value for 'jobIds'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCustomGetQuickbooksSyncJobsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetQuickbooksSyncJobsQuery, CustomGetQuickbooksSyncJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetQuickbooksSyncJobsQuery, CustomGetQuickbooksSyncJobsQueryVariables>(CustomGetQuickbooksSyncJobsDocument, options);
      }
export function useCustomGetQuickbooksSyncJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetQuickbooksSyncJobsQuery, CustomGetQuickbooksSyncJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetQuickbooksSyncJobsQuery, CustomGetQuickbooksSyncJobsQueryVariables>(CustomGetQuickbooksSyncJobsDocument, options);
        }
export type CustomGetQuickbooksSyncJobsQueryHookResult = ReturnType<typeof useCustomGetQuickbooksSyncJobsQuery>;
export type CustomGetQuickbooksSyncJobsLazyQueryHookResult = ReturnType<typeof useCustomGetQuickbooksSyncJobsLazyQuery>;
export type CustomGetQuickbooksSyncJobsQueryResult = Apollo.QueryResult<CustomGetQuickbooksSyncJobsQuery, CustomGetQuickbooksSyncJobsQueryVariables>;
export const CustomGetTimeEntriesDocument = gql`
    query customGetTimeEntries($first: Int!, $forDate: Date, $jobPhaseId: ID, $page: Int, $sortDirection: SortDirection, $sortKey: GetTimeEntriesSortKey, $userId: ID, $forDateStart: Date, $forDateEnd: Date) {
  getTimeEntries(
    first: $first
    forDate: $forDate
    jobPhaseId: $jobPhaseId
    page: $page
    sortDirection: $sortDirection
    sortKey: $sortKey
    userId: $userId
    forDateStart: $forDateStart
    forDateEnd: $forDateEnd
  ) {
    data {
      endTime
      forDate
      id
      jobPhase {
        id
        externalId
        address
        proposalStage {
          id
          name
        }
        job {
          id
          externalId
        }
      }
      clockInLatitude
      clockInLongitude
      clockOutLatitude
      clockOutLongitude
      notes
      organizationId
      startTime
      timeBucket {
        id
        name
        organizationId
      }
      timeTrackedSeconds
      timeTrackedSecondsOverride
      user {
        firstName
        id
        lastName
        name
      }
      uuid
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetTimeEntriesQuery__
 *
 * To run a query within a React component, call `useCustomGetTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetTimeEntriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      forDate: // value for 'forDate'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      page: // value for 'page'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      userId: // value for 'userId'
 *      forDateStart: // value for 'forDateStart'
 *      forDateEnd: // value for 'forDateEnd'
 *   },
 * });
 */
export function useCustomGetTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>(CustomGetTimeEntriesDocument, options);
      }
export function useCustomGetTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>(CustomGetTimeEntriesDocument, options);
        }
export type CustomGetTimeEntriesQueryHookResult = ReturnType<typeof useCustomGetTimeEntriesQuery>;
export type CustomGetTimeEntriesLazyQueryHookResult = ReturnType<typeof useCustomGetTimeEntriesLazyQuery>;
export type CustomGetTimeEntriesQueryResult = Apollo.QueryResult<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>;
export const CustomGetVehicleDailyFormWorkOrdersDocument = gql`
    query customGetVehicleDailyFormWorkOrders($first: Int!, $page: Int, $vehicleId: ID) {
  getDailyFormWorkOrders(
    first: $first
    page: $page
    vehicleId: $vehicleId
    sortKey: CREATED_AT
    sortDirection: DESC
  ) {
    data {
      id
      issueName
      status
      neededCompletionDate
      completedAt
      currentMeterReading
      createdAt
      assignedTo {
        id
        name
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetVehicleDailyFormWorkOrdersQuery__
 *
 * To run a query within a React component, call `useCustomGetVehicleDailyFormWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetVehicleDailyFormWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetVehicleDailyFormWorkOrdersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useCustomGetVehicleDailyFormWorkOrdersQuery(baseOptions: Apollo.QueryHookOptions<CustomGetVehicleDailyFormWorkOrdersQuery, CustomGetVehicleDailyFormWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetVehicleDailyFormWorkOrdersQuery, CustomGetVehicleDailyFormWorkOrdersQueryVariables>(CustomGetVehicleDailyFormWorkOrdersDocument, options);
      }
export function useCustomGetVehicleDailyFormWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetVehicleDailyFormWorkOrdersQuery, CustomGetVehicleDailyFormWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetVehicleDailyFormWorkOrdersQuery, CustomGetVehicleDailyFormWorkOrdersQueryVariables>(CustomGetVehicleDailyFormWorkOrdersDocument, options);
        }
export type CustomGetVehicleDailyFormWorkOrdersQueryHookResult = ReturnType<typeof useCustomGetVehicleDailyFormWorkOrdersQuery>;
export type CustomGetVehicleDailyFormWorkOrdersLazyQueryHookResult = ReturnType<typeof useCustomGetVehicleDailyFormWorkOrdersLazyQuery>;
export type CustomGetVehicleDailyFormWorkOrdersQueryResult = Apollo.QueryResult<CustomGetVehicleDailyFormWorkOrdersQuery, CustomGetVehicleDailyFormWorkOrdersQueryVariables>;
export const CustomMeDocument = gql`
    query CustomMe {
  me {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    autoAssign
    avatar
    crewsCount
    email
    firstName
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        id
        inviteToken
        invitedAt
        lastName
        name
        organization {
          documents {
            id
            name
            path
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          trialEndsAt
        }
        phone
        proposalCount
        roles
        status
      }
      lastName
      name
      phone
      proposalCount
      roles
      status
    }
    lastName
    name
    organization {
      email
      emailTemplate
      invoiceEmailText
      failingPayment
      id
      logo
      name
      onTrial
      phone
      subscribed
      trialEndsAt
      subscription {
        id
      }
      timezone
    }
    phone
    proposalCount
    roles
    permissions
    status
  }
}
    `;

/**
 * __useCustomMeQuery__
 *
 * To run a query within a React component, call `useCustomMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomMeQuery(baseOptions?: Apollo.QueryHookOptions<CustomMeQuery, CustomMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomMeQuery, CustomMeQueryVariables>(CustomMeDocument, options);
      }
export function useCustomMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomMeQuery, CustomMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomMeQuery, CustomMeQueryVariables>(CustomMeDocument, options);
        }
export type CustomMeQueryHookResult = ReturnType<typeof useCustomMeQuery>;
export type CustomMeLazyQueryHookResult = ReturnType<typeof useCustomMeLazyQuery>;
export type CustomMeQueryResult = Apollo.QueryResult<CustomMeQuery, CustomMeQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AppLoginResult": [
      "ActiveSessionConflict",
      "LoginAppUser"
    ],
    "LoginResult": [
      "ActiveSessionConflict",
      "User"
    ],
    "ProductAttributes": [
      "ProductAttributeAsphalt",
      "ProductAttributeAsphaltCurbing",
      "ProductAttributeConcreteColumn",
      "ProductAttributeConcreteCurbOrGutter",
      "ProductAttributeConcreteFlatwork",
      "ProductAttributeConcreteFooting",
      "ProductAttributeConcreteWall",
      "ProductAttributeConcreteWaterway",
      "ProductAttributeCrackSeal",
      "ProductAttributeCurbWall",
      "ProductAttributeExcavateOut",
      "ProductAttributeGrading",
      "ProductAttributeMastic",
      "ProductAttributeMicrosurfacing",
      "ProductAttributeSealCoat",
      "ProductAttributeSlurrySeal",
      "ProductAttributeStriping"
    ],
    "PublicInvoiceResponse": [
      "PublicInvoice",
      "PublicInvoiceOrganization"
    ],
    "PublicProposalResponse": [
      "PublicProposal",
      "PublicProposalOrganization"
    ]
  }
};
      export default result;
    